(() => {

      var $parcel$global = globalThis;
    /*
 * Application Insights JavaScript SDK - Web, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */ /*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */ // These constants are currently NOT exported directly, we may export them later associated with a frozen namespace (maybe)
// For now do NOT expect that we will export these values.
var $b347daff6f5f8dc1$export$375c5ccc31575c19 = undefined;
var $b347daff6f5f8dc1$export$38c7ba05d207d137 = null;
var $b347daff6f5f8dc1$export$ccb33e29d92c9a58 = "";
var $b347daff6f5f8dc1$export$428cfe48a69a3b4f = "boolean";
var $b347daff6f5f8dc1$export$601fe16600f10158 = "function";
var $b347daff6f5f8dc1$export$4e8bcd47a31d751c = "number";
var $b347daff6f5f8dc1$export$8b8a958a7f6f130c = "object";
var $b347daff6f5f8dc1$export$4ddd10988dd20ff4 = "prototype";
var $b347daff6f5f8dc1$export$bac6e64dee11e7fb = "__proto__";
var $b347daff6f5f8dc1$export$a0e01ba2ebef17f2 = "string";
var $b347daff6f5f8dc1$export$6db089fe7b26f5b6 = "undefined";
var $b347daff6f5f8dc1$export$943e078395581e44 = "constructor";
var $b347daff6f5f8dc1$export$27c95a7104c1f7aa = "Symbol";
var $b347daff6f5f8dc1$export$e674ec9e2c0d330e = "_polyfill";
var $b347daff6f5f8dc1$export$b2c0731cca6bbbd0 = "indexOf";
var $b347daff6f5f8dc1$export$ecb956a5faeb2d4a = "lastIndexOf";
var $b347daff6f5f8dc1$export$5f32d5745d700b0e = "length";
var $b347daff6f5f8dc1$export$71efb3495f6084f2 = "done";
var $b347daff6f5f8dc1$export$764bd63f4c2043a2 = "value";
var $b347daff6f5f8dc1$export$3c5e605ca7ade9f2 = "name";
var $b347daff6f5f8dc1$export$ddd00fe728e19670 = "slice";
var $b347daff6f5f8dc1$export$9ec954dd81c90a5d = Object;
var $b347daff6f5f8dc1$export$e77bb59b5e655b3d = $b347daff6f5f8dc1$export$9ec954dd81c90a5d[$b347daff6f5f8dc1$export$4ddd10988dd20ff4];
var $b347daff6f5f8dc1$export$7ce2e0314415f079 = String;
var $b347daff6f5f8dc1$export$a31bd47275edb702 = $b347daff6f5f8dc1$export$7ce2e0314415f079[$b347daff6f5f8dc1$export$4ddd10988dd20ff4];
var $b347daff6f5f8dc1$export$dbb682be7aa6edc2 = Math;
var $b347daff6f5f8dc1$export$b42fc7fc171852c3 = Array;
var $b347daff6f5f8dc1$export$f3f471c81a14426 = $b347daff6f5f8dc1$export$b42fc7fc171852c3[$b347daff6f5f8dc1$export$4ddd10988dd20ff4];


/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */ 
var $6b9be1171d21f18a$var$GLOBAL_CONFIG_KEY = "__tsUtils$gblCfg";
var $6b9be1171d21f18a$var$_globalCfg;
function $6b9be1171d21f18a$export$141de058bfcfe74() {
    var result;
    if (typeof globalThis !== (0, $b347daff6f5f8dc1$export$6db089fe7b26f5b6)) result = globalThis;
    if (!result && typeof self !== (0, $b347daff6f5f8dc1$export$6db089fe7b26f5b6)) result = self;
    if (!result && typeof window !== (0, $b347daff6f5f8dc1$export$6db089fe7b26f5b6)) result = window;
    if (!result && typeof $parcel$global !== (0, $b347daff6f5f8dc1$export$6db089fe7b26f5b6)) result = $parcel$global;
    return result;
}
function $6b9be1171d21f18a$export$8a1a74f726f2b336() {
    if (!$6b9be1171d21f18a$var$_globalCfg) {
        var gbl = $6b9be1171d21f18a$export$141de058bfcfe74() || {};
        $6b9be1171d21f18a$var$_globalCfg = gbl[$6b9be1171d21f18a$var$GLOBAL_CONFIG_KEY] = gbl[$6b9be1171d21f18a$var$GLOBAL_CONFIG_KEY] || {};
    }
    return $6b9be1171d21f18a$var$_globalCfg;
}


/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */ /*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */ 

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */ 
/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */ 
/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */ /**
 * Function to safely execute a callback function, if the function throws the provided default
 * value will be returned.
 * @since 0.9.5
 * @group Safe
 * @param cb - Callback function be wrapped with an exception
 * @param defValue - The default value to return when an exception is thrown
 * @returns The result of the callback function or the default if an exception occurred calling the callback
 * function.
 * @example
 * ```ts
 * let theExpression = "{ invalid: json value";
 *
 * let result = safeGet(() => {
 *     return JSON.parse(theExpression);
 * }, {});
 *
 * // result === {};
 * ```
 */ function $ab7fdd65453f0d9e$export$e51ae4db7b428f67(cb, defValue) {
    var result = defValue;
    try {
        result = cb();
    } catch (e) {
    // Do nothing
    }
    return result;
}


var $533f826bbc418791$var$PRIMITIVE_TYPES = [
    (0, $b347daff6f5f8dc1$export$a0e01ba2ebef17f2),
    (0, $b347daff6f5f8dc1$export$4e8bcd47a31d751c),
    (0, $b347daff6f5f8dc1$export$428cfe48a69a3b4f),
    (0, $b347daff6f5f8dc1$export$6db089fe7b26f5b6),
    "symbol",
    "bigint"
];
function $533f826bbc418791$export$baab46d9fe4a4eef(theType) {
    return function(value) {
        return typeof value === theType;
    };
}
function $533f826bbc418791$export$76383c610bda195a(theName) {
    var theType = "[object " + theName + "]";
    return function(value) {
        return !!(value && $533f826bbc418791$export$3cbb80dec8953997(value) === theType);
    };
}
function $533f826bbc418791$export$3cbb80dec8953997(value) {
    return (0, $b347daff6f5f8dc1$export$e77bb59b5e655b3d).toString.call(value);
}
function $533f826bbc418791$export$aa336f94d74d9e02(value, theType) {
    return typeof value === theType;
}
function $533f826bbc418791$export$fce6876652108ab(value) {
    return typeof value === (0, $b347daff6f5f8dc1$export$6db089fe7b26f5b6) || value === (0, $b347daff6f5f8dc1$export$6db089fe7b26f5b6);
}
function $533f826bbc418791$export$565ef2e4233b16ad(arg) {
    return !$533f826bbc418791$export$4e62c701997796c1(arg);
}
function $533f826bbc418791$export$bedb7023a7733221(value) {
    return value === (0, $b347daff6f5f8dc1$export$38c7ba05d207d137) || $533f826bbc418791$export$fce6876652108ab(value);
}
function $533f826bbc418791$export$3388cdee8977b866(value) {
    return value === (0, $b347daff6f5f8dc1$export$38c7ba05d207d137) || !$533f826bbc418791$export$4e62c701997796c1(value);
}
function $533f826bbc418791$export$4e62c701997796c1(arg) {
    return !!arg || arg !== (0, $b347daff6f5f8dc1$export$375c5ccc31575c19);
}
var $533f826bbc418791$export$c3825b437cbdea5c = function(value) {
    return value === (0, $b347daff6f5f8dc1$export$38c7ba05d207d137) || $533f826bbc418791$export$1f3b27a0956fac0e(typeof value);
};
var $533f826bbc418791$export$1f3b27a0956fac0e = function(theType) {
    return theType !== (0, $b347daff6f5f8dc1$export$8b8a958a7f6f130c) && $533f826bbc418791$var$PRIMITIVE_TYPES.indexOf(theType) !== -1;
};
var $533f826bbc418791$export$844ec244b1367d54 = $533f826bbc418791$export$baab46d9fe4a4eef((0, $b347daff6f5f8dc1$export$a0e01ba2ebef17f2));
var $533f826bbc418791$export$f6e2535fb5126e54 = $533f826bbc418791$export$baab46d9fe4a4eef((0, $b347daff6f5f8dc1$export$601fe16600f10158));
function $533f826bbc418791$export$a6cdc56e425d0d0a(value) {
    if (!value && $533f826bbc418791$export$bedb7023a7733221(value)) return false;
    return !!value && typeof value === (0, $b347daff6f5f8dc1$export$8b8a958a7f6f130c);
}
var $533f826bbc418791$export$43bee75e5e14138e = (0, $b347daff6f5f8dc1$export$b42fc7fc171852c3).isArray;
var $533f826bbc418791$export$871608497c498473 = $533f826bbc418791$export$76383c610bda195a("Date");
var $533f826bbc418791$export$7e4aa119212bc614 = $533f826bbc418791$export$baab46d9fe4a4eef((0, $b347daff6f5f8dc1$export$4e8bcd47a31d751c));
var $533f826bbc418791$export$f9ce7b637dfbe238 = $533f826bbc418791$export$baab46d9fe4a4eef((0, $b347daff6f5f8dc1$export$428cfe48a69a3b4f));
var $533f826bbc418791$export$49841c62b9eff15 = $533f826bbc418791$export$76383c610bda195a("RegExp");
var $533f826bbc418791$export$be78b3111c50efdd = $533f826bbc418791$export$76383c610bda195a("File");
var $533f826bbc418791$export$67a42df2b7ab73bc = $533f826bbc418791$export$76383c610bda195a("FormData");
var $533f826bbc418791$export$5bcd6e94ed871c88 = $533f826bbc418791$export$76383c610bda195a("Blob");
var $533f826bbc418791$export$9dd3754ae86f0017 = $533f826bbc418791$export$76383c610bda195a("ArrayBuffer");
var $533f826bbc418791$export$e6127cc7fe7395c3 = $533f826bbc418791$export$76383c610bda195a("Error");
function $533f826bbc418791$export$ae936b9d47e5870e(value) {
    return !!value && $533f826bbc418791$export$f6e2535fb5126e54(value.then);
}
var $533f826bbc418791$export$f5b060c2914b97c8 = $533f826bbc418791$export$ae936b9d47e5870e;
function $533f826bbc418791$export$4369c812aac99591(value) {
    return $533f826bbc418791$export$ae936b9d47e5870e(value) && $533f826bbc418791$export$f6e2535fb5126e54(value.catch);
}
function $533f826bbc418791$export$5f2b986706b25721(value) {
    return !value || !(0, $ab7fdd65453f0d9e$export$e51ae4db7b428f67)(function() {
        return value && 0 + value;
    }, value);
}
function $533f826bbc418791$export$8f9cae6546f97a9f(value) {
    // Objects created with no prototype (Object.create(null)) cannot be converted to primitives
    // Which causes this code to throw, additionally just using !! also fails for Boolean objects
    // !!(new Boolean(false)) evaluates to true
    return !(!value || (0, $ab7fdd65453f0d9e$export$e51ae4db7b428f67)(function() {
        return !(value && 0 + value);
    }, !value));
//return !(!value || !(value && (0 + value)));
}


/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */ 
/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */ 
/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */ 
var $a1ed021ceb472abb$export$1bd5e8b059facbe9 = (0, $b347daff6f5f8dc1$export$9ec954dd81c90a5d).getOwnPropertyDescriptor;


/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */ 
function $78c14fe71626d827$export$d76937f5d45b7158(obj, prop) {
    return obj && (0, $b347daff6f5f8dc1$export$e77bb59b5e655b3d).hasOwnProperty.call(obj, prop);
}


var $08325aa6d8565cc0$export$34e6b98f73578a9c = (0, $b347daff6f5f8dc1$export$9ec954dd81c90a5d)["hasOwn"] || $08325aa6d8565cc0$export$9a4df78208de965f;
function $08325aa6d8565cc0$export$9a4df78208de965f(obj, prop) {
    return (0, $78c14fe71626d827$export$d76937f5d45b7158)(obj, prop) || !!(0, $a1ed021ceb472abb$export$1bd5e8b059facbe9)(obj, prop);
}


function $45e528077703ac0c$export$aa0705d5774c95d1(theObject, callbackfn, thisArg) {
    if (theObject && (0, $533f826bbc418791$export$a6cdc56e425d0d0a)(theObject)) {
        for(var prop in theObject)if ((0, $08325aa6d8565cc0$export$34e6b98f73578a9c)(theObject, prop)) {
            if (callbackfn.call(thisArg || theObject, prop, theObject[prop]) === -1) break;
        }
    }
}



/**
 * @internal
 * @ignore
 * Mapping from ObjDefinePropDescriptor key to PropertyDescriptor key
 */ var $d212d948d25f959a$var$propMap = {
    e: "enumerable",
    c: "configurable",
    v: (0, $b347daff6f5f8dc1$export$764bd63f4c2043a2),
    w: "writable",
    g: "get",
    s: "set"
};
/**
 * @internal
 * @ignore
 * Helper to convert ObjDefinePropDescriptor into PropertyDescriptor
 * @param value - The prop descriptor to convert
 * @returns
 */ function $d212d948d25f959a$var$_createProp(value) {
    var prop = {};
    prop[$d212d948d25f959a$var$propMap["c"]] = true;
    prop[$d212d948d25f959a$var$propMap["e"]] = true;
    if (value.l) {
        // Asign a getter function to return the value when requested
        prop.get = function() {
            return value.l.v;
        };
        // If it has a setter then expose it as well
        var desc = (0, $a1ed021ceb472abb$export$1bd5e8b059facbe9)(value.l, "v");
        if (desc && desc.set) prop.set = function(newValue) {
            value.l.v = newValue;
        };
    }
    (0, $45e528077703ac0c$export$aa0705d5774c95d1)(value, function(key, value) {
        prop[$d212d948d25f959a$var$propMap[key]] = (0, $533f826bbc418791$export$fce6876652108ab)(value) ? prop[$d212d948d25f959a$var$propMap[key]] : value;
    });
    return prop;
}
var $d212d948d25f959a$export$8b8fd4dfd45f6b81 = (0, $b347daff6f5f8dc1$export$9ec954dd81c90a5d)["defineProperty"];
var $d212d948d25f959a$export$aa4c975d12edd698 = (0, $b347daff6f5f8dc1$export$9ec954dd81c90a5d)["defineProperties"];
function $d212d948d25f959a$export$4f97e7dc4bb3c3bb(target, key, value, configurable, enumerable) {
    var _a;
    return $d212d948d25f959a$export$8b8fd4dfd45f6b81(target, key, $d212d948d25f959a$var$_createProp((_a = {
        e: enumerable,
        c: configurable
    }, _a[(0, $533f826bbc418791$export$f6e2535fb5126e54)(value) ? "g" : "v"] = value, _a)));
}
function $d212d948d25f959a$export$5525b807dcec3e1b(target, prop, getProp, setProp, configurable, enumerable) {
    var desc = {
        e: enumerable,
        c: configurable
    };
    if (getProp) desc.g = getProp;
    if (setProp) desc.s = setProp;
    return $d212d948d25f959a$export$8b8fd4dfd45f6b81(target, prop, $d212d948d25f959a$var$_createProp(desc));
}
function $d212d948d25f959a$export$d0d2ebf910ad6e2(target, key, propDesc) {
    return $d212d948d25f959a$export$8b8fd4dfd45f6b81(target, key, $d212d948d25f959a$var$_createProp(propDesc));
}
function $d212d948d25f959a$export$343685e498f18ed2(target, propDescMap) {
    var props = {};
    (0, $45e528077703ac0c$export$aa0705d5774c95d1)(propDescMap, function(key, value) {
        props[key] = $d212d948d25f959a$var$_createProp(value);
    });
    return $d212d948d25f959a$export$aa4c975d12edd698(target, props);
}


var $d8ec17546a34ef88$export$2d4a6284764f647f;
var $d8ec17546a34ef88$var$_fetchLazyTestHooks = function() {
    $d8ec17546a34ef88$export$2d4a6284764f647f = (0, $6b9be1171d21f18a$export$8a1a74f726f2b336)();
    $d8ec17546a34ef88$var$_fetchLazyTestHooks = (0, $b347daff6f5f8dc1$export$38c7ba05d207d137);
};
function $d8ec17546a34ef88$export$db98eae15987454c(cb) {
    var lazyValue = {};
    $d8ec17546a34ef88$var$_fetchLazyTestHooks && $d8ec17546a34ef88$var$_fetchLazyTestHooks();
    lazyValue.b = $d8ec17546a34ef88$export$2d4a6284764f647f.lzy;
    (0, $d212d948d25f959a$export$8b8fd4dfd45f6b81)(lazyValue, "v", {
        configurable: true,
        get: function() {
            var result = cb();
            if (!$d8ec17546a34ef88$export$2d4a6284764f647f.lzy) {
                // Just replace the value
                (0, $d212d948d25f959a$export$8b8fd4dfd45f6b81)(lazyValue, "v", {
                    value: result
                });
                if (lazyValue.b) delete lazyValue.b;
            }
            if ($d8ec17546a34ef88$export$2d4a6284764f647f.lzy && lazyValue.b !== $d8ec17546a34ef88$export$2d4a6284764f647f.lzy) lazyValue.b = $d8ec17546a34ef88$export$2d4a6284764f647f.lzy;
            return result;
        }
    });
    return lazyValue;
}
function $d8ec17546a34ef88$export$31f2f77e19969b63(newValue) {
    $d8ec17546a34ef88$var$_fetchLazyTestHooks && $d8ec17546a34ef88$var$_fetchLazyTestHooks();
    $d8ec17546a34ef88$export$2d4a6284764f647f.lzy = newValue;
}
function $d8ec17546a34ef88$export$5405f984434b2087(cb) {
    var lazyValue = {};
    $d8ec17546a34ef88$var$_fetchLazyTestHooks && $d8ec17546a34ef88$var$_fetchLazyTestHooks();
    lazyValue.b = $d8ec17546a34ef88$export$2d4a6284764f647f.lzy;
    var _setValue = function(newValue) {
        // Just replace the value
        (0, $d212d948d25f959a$export$8b8fd4dfd45f6b81)(lazyValue, "v", {
            value: newValue,
            writable: true
        });
        if (lazyValue.b) delete lazyValue.b;
    };
    (0, $d212d948d25f959a$export$8b8fd4dfd45f6b81)(lazyValue, "v", {
        configurable: true,
        get: function() {
            var result = cb();
            if (!$d8ec17546a34ef88$export$2d4a6284764f647f.lzy) // Just replace the value
            _setValue(result);
            if ($d8ec17546a34ef88$export$2d4a6284764f647f.lzy && lazyValue.b !== $d8ec17546a34ef88$export$2d4a6284764f647f.lzy) lazyValue.b = $d8ec17546a34ef88$export$2d4a6284764f647f.lzy;
            return result;
        },
        set: _setValue
    });
    return lazyValue;
}



function $f07ca4f3c96b6502$export$c6675fd9042172d2(cb, defValue) {
    return (0, $d8ec17546a34ef88$export$db98eae15987454c)(function() {
        return (0, $ab7fdd65453f0d9e$export$e51ae4db7b428f67)(cb, defValue);
    });
}



var $b364f2cd2faf3e98$exports = {};
"use strict";


var $3d5fcb60a9467a45$var$WINDOW = "window";
var $3d5fcb60a9467a45$var$_cachedGlobal;
var $3d5fcb60a9467a45$var$_cachedWindow;
var $3d5fcb60a9467a45$var$_cachedDocument;
var $3d5fcb60a9467a45$var$_cachedNavigator;
var $3d5fcb60a9467a45$var$_cachedHistory;
var $3d5fcb60a9467a45$var$_isWebWorker;
var $3d5fcb60a9467a45$var$_isNode;
var $3d5fcb60a9467a45$export$45fd08e1bc14fe1c = function(name) {
    return (0, $f07ca4f3c96b6502$export$c6675fd9042172d2)(function() {
        return $3d5fcb60a9467a45$export$3df6e51375017edd(name) || (0, $b347daff6f5f8dc1$export$375c5ccc31575c19);
    }, (0, $b347daff6f5f8dc1$export$375c5ccc31575c19));
};
var $3d5fcb60a9467a45$export$a4e55266d2135a7f = function(useCached) {
    (!$3d5fcb60a9467a45$var$_cachedGlobal || useCached === false || (0, $d8ec17546a34ef88$export$2d4a6284764f647f) && (0, $d8ec17546a34ef88$export$2d4a6284764f647f).lzy && !$3d5fcb60a9467a45$var$_cachedGlobal.b) && ($3d5fcb60a9467a45$var$_cachedGlobal = (0, $f07ca4f3c96b6502$export$c6675fd9042172d2)((0, $6b9be1171d21f18a$export$141de058bfcfe74), (0, $b347daff6f5f8dc1$export$38c7ba05d207d137)));
    return $3d5fcb60a9467a45$var$_cachedGlobal.v;
};
var $3d5fcb60a9467a45$export$3df6e51375017edd = function(name, useCached) {
    var gbl = !$3d5fcb60a9467a45$var$_cachedGlobal || useCached === false ? $3d5fcb60a9467a45$export$a4e55266d2135a7f(useCached) : $3d5fcb60a9467a45$var$_cachedGlobal.v;
    if (gbl && gbl[name]) return gbl[name];
    // Test workaround, for environments where <global>.window (when global == window) doesn't return the base window
    if (name === $3d5fcb60a9467a45$var$WINDOW && $3d5fcb60a9467a45$var$_cachedWindow) // tslint:disable-next-line: no-angle-bracket-type-assertion
    return $3d5fcb60a9467a45$var$_cachedWindow.v;
    return 0, $b347daff6f5f8dc1$export$38c7ba05d207d137;
};
var $3d5fcb60a9467a45$export$c4372eca9c56fe99 = function() {
    return !!$3d5fcb60a9467a45$export$f65ca476c09acec0();
};
var $3d5fcb60a9467a45$export$f65ca476c09acec0 = function() {
    (!$3d5fcb60a9467a45$var$_cachedDocument || (0, $d8ec17546a34ef88$export$2d4a6284764f647f) && (0, $d8ec17546a34ef88$export$2d4a6284764f647f).lzy && !$3d5fcb60a9467a45$var$_cachedDocument.b) && ($3d5fcb60a9467a45$var$_cachedDocument = $3d5fcb60a9467a45$export$45fd08e1bc14fe1c("document"));
    return $3d5fcb60a9467a45$var$_cachedDocument.v;
};
var $3d5fcb60a9467a45$export$fef62134eea24008 = function() {
    return !!$3d5fcb60a9467a45$export$38b2d434cce3ea22();
};
var $3d5fcb60a9467a45$export$38b2d434cce3ea22 = function() {
    (!$3d5fcb60a9467a45$var$_cachedWindow || (0, $d8ec17546a34ef88$export$2d4a6284764f647f) && (0, $d8ec17546a34ef88$export$2d4a6284764f647f).lzy && !$3d5fcb60a9467a45$var$_cachedWindow.b) && ($3d5fcb60a9467a45$var$_cachedWindow = $3d5fcb60a9467a45$export$45fd08e1bc14fe1c($3d5fcb60a9467a45$var$WINDOW));
    return $3d5fcb60a9467a45$var$_cachedWindow.v;
};
var $3d5fcb60a9467a45$export$bd82d106260417bf = function() {
    return !!$3d5fcb60a9467a45$export$a56241c767c1d89f();
};
var $3d5fcb60a9467a45$export$a56241c767c1d89f = function() {
    (!$3d5fcb60a9467a45$var$_cachedNavigator || (0, $d8ec17546a34ef88$export$2d4a6284764f647f) && (0, $d8ec17546a34ef88$export$2d4a6284764f647f).lzy && !$3d5fcb60a9467a45$var$_cachedNavigator.b) && ($3d5fcb60a9467a45$var$_cachedNavigator = $3d5fcb60a9467a45$export$45fd08e1bc14fe1c("navigator"));
    return $3d5fcb60a9467a45$var$_cachedNavigator.v;
};
var $3d5fcb60a9467a45$export$b79afd6d47f11781 = function() {
    return !!$3d5fcb60a9467a45$export$f9582a3c130d9538();
};
var $3d5fcb60a9467a45$export$f9582a3c130d9538 = function() {
    (!$3d5fcb60a9467a45$var$_cachedHistory || (0, $d8ec17546a34ef88$export$2d4a6284764f647f) && (0, $d8ec17546a34ef88$export$2d4a6284764f647f).lzy && !$3d5fcb60a9467a45$var$_cachedHistory.b) && ($3d5fcb60a9467a45$var$_cachedHistory = $3d5fcb60a9467a45$export$45fd08e1bc14fe1c("history"));
    return $3d5fcb60a9467a45$var$_cachedHistory.v;
};
var $3d5fcb60a9467a45$export$8ee0fc9ee280b4ee = function() {
    !$3d5fcb60a9467a45$var$_isNode && ($3d5fcb60a9467a45$var$_isNode = (0, $f07ca4f3c96b6502$export$c6675fd9042172d2)(function() {
        return !!($b364f2cd2faf3e98$exports && ($b364f2cd2faf3e98$exports.versions || {}).node);
    }, false));
    return $3d5fcb60a9467a45$var$_isNode.v;
};
var $3d5fcb60a9467a45$export$97b87b8868ff7a3c = function() {
    !$3d5fcb60a9467a45$var$_isWebWorker && ($3d5fcb60a9467a45$var$_isWebWorker = (0, $f07ca4f3c96b6502$export$c6675fd9042172d2)(function() {
        return !!(self && self instanceof WorkerGlobalScope);
    }, false));
    return $3d5fcb60a9467a45$var$_isWebWorker.v;
};

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */ /**
 * Throw an error exception with the specified optional message
 * @group Error
 * @param message
 */ function $44a1c24c0e411039$export$8bf7aba4a9e09055(message) {
    throw new Error(message);
}
function $44a1c24c0e411039$export$3f7738bd7dcba681(message) {
    throw new TypeError(message);
}
function $44a1c24c0e411039$export$462e4d432290318e(message) {
    throw new RangeError(message);
}


var $c9b63384299a3252$var$_a;
var $c9b63384299a3252$var$UNDEFINED = "undefined";
/**
 * Constant string defined to support minimization
 * @ignore
 */ var $c9b63384299a3252$var$Constructor = "constructor";
/**
 * Constant string defined to support minimization
 * @ignore
 */ var $c9b63384299a3252$var$Prototype = "prototype";
/**
 * Constant string defined to support minimization
 * @ignore
 */ var $c9b63384299a3252$var$strFunction = "function";
/**
 * Used to define the name of the instance function lookup table
 * @ignore
 */ var $c9b63384299a3252$var$DynInstFuncTable = "_dynInstFuncs";
/**
 * Name used to tag the dynamic prototype function
 * @ignore
 */ var $c9b63384299a3252$var$DynProxyTag = "_isDynProxy";
/**
 * Name added to a prototype to define the dynamic prototype "class" name used to lookup the function table
 * @ignore
 */ var $c9b63384299a3252$var$DynClassName = "_dynClass";
/**
 * Prefix added to the classname to avoid any name clashes with other instance level properties
 * @ignore
 */ var $c9b63384299a3252$var$DynClassNamePrefix = "_dynCls$";
/**
 * A tag which is used to check if we have already to attempted to set the instance function if one is not present
 * @ignore
 */ var $c9b63384299a3252$var$DynInstChkTag = "_dynInstChk";
/**
 * A tag which is used to check if we are allows to try and set an instance function is one is not present. Using the same
 * tag name as the function level but a different const name for readability only.
 */ var $c9b63384299a3252$var$DynAllowInstChkTag = $c9b63384299a3252$var$DynInstChkTag;
/**
 * The global (imported) instances where the global performance options are stored
 */ var $c9b63384299a3252$var$DynProtoDefaultOptions = "_dfOpts";
/**
 * Value used as the name of a class when it cannot be determined
 * @ignore
 */ var $c9b63384299a3252$var$UnknownValue = "_unknown_";
/**
 * Constant string defined to support minimization
 * @ignore
 */ var $c9b63384299a3252$var$str__Proto = "__proto__";
/**
 * The polyfill version of __proto__ so that it doesn't cause issues for anyone not expecting it to exist
 */ var $c9b63384299a3252$var$DynProtoBaseProto = "_dyn" + $c9b63384299a3252$var$str__Proto;
/**
 * Runtime Global holder for dynamicProto settings
 */ var $c9b63384299a3252$var$DynProtoGlobalSettings = "__dynProto$Gbl";
/**
 * Track the current prototype for IE8 as you can't look back to get the prototype
 */ var $c9b63384299a3252$var$DynProtoCurrent = "_dynInstProto";
/**
 * Constant string defined to support minimization
 * @ignore
 */ var $c9b63384299a3252$var$strUseBaseInst = "useBaseInst";
/**
 * Constant string defined to support minimization
 * @ignore
 */ var $c9b63384299a3252$var$strSetInstFuncs = "setInstFuncs";
var $c9b63384299a3252$var$Obj = Object;
/**
 * Pre-lookup to check if we are running on a modern browser (i.e. not IE8)
 * @ignore
 */ var $c9b63384299a3252$var$_objGetPrototypeOf = $c9b63384299a3252$var$Obj["getPrototypeOf"];
/**
 * Pre-lookup to check for the existence of this function
 */ var $c9b63384299a3252$var$_objGetOwnProps = $c9b63384299a3252$var$Obj["getOwnPropertyNames"];
// Since 1.1.7 moving these to the runtime global to work around mixed version and module issues
// See Issue https://github.com/microsoft/DynamicProto-JS/issues/57 for details
var $c9b63384299a3252$var$_gbl = (0, $3d5fcb60a9467a45$export$a4e55266d2135a7f)();
var $c9b63384299a3252$var$_gblInst = $c9b63384299a3252$var$_gbl[$c9b63384299a3252$var$DynProtoGlobalSettings] || ($c9b63384299a3252$var$_gbl[$c9b63384299a3252$var$DynProtoGlobalSettings] = {
    o: ($c9b63384299a3252$var$_a = {}, $c9b63384299a3252$var$_a[$c9b63384299a3252$var$strSetInstFuncs] = true, $c9b63384299a3252$var$_a[$c9b63384299a3252$var$strUseBaseInst] = true, $c9b63384299a3252$var$_a),
    n: 1000 // Start new global index @ 1000 so we "fix" some cases when mixed with 1.1.6 or earlier
});
/**
 * Helper used to check whether the target is an Object prototype or Array prototype
 * @ignore
 */ function $c9b63384299a3252$var$_isObjectOrArrayPrototype(target) {
    return target && (target === $c9b63384299a3252$var$Obj[$c9b63384299a3252$var$Prototype] || target === Array[$c9b63384299a3252$var$Prototype]);
}
/**
 * Helper used to check whether the target is an Object prototype, Array prototype or Function prototype
 * @ignore
 */ function $c9b63384299a3252$var$_isObjectArrayOrFunctionPrototype(target) {
    return $c9b63384299a3252$var$_isObjectOrArrayPrototype(target) || target === Function[$c9b63384299a3252$var$Prototype];
}
/**
 * Helper used to get the prototype of the target object as getPrototypeOf is not available in an ES3 environment.
 * @ignore
 */ function $c9b63384299a3252$var$_getObjProto(target) {
    var newProto;
    if (target) {
        // This method doesn't exist in older browsers (e.g. IE8)
        if ($c9b63384299a3252$var$_objGetPrototypeOf) return $c9b63384299a3252$var$_objGetPrototypeOf(target);
        var curProto = target[$c9b63384299a3252$var$str__Proto] || target[$c9b63384299a3252$var$Prototype] || (target[$c9b63384299a3252$var$Constructor] ? target[$c9b63384299a3252$var$Constructor][$c9b63384299a3252$var$Prototype] : null);
        // Using the pre-calculated value as IE8 doesn't support looking up the prototype of a prototype and thus fails for more than 1 base class
        newProto = target[$c9b63384299a3252$var$DynProtoBaseProto] || curProto;
        if (!(0, $78c14fe71626d827$export$d76937f5d45b7158)(target, $c9b63384299a3252$var$DynProtoBaseProto)) {
            // As this prototype doesn't have this property then this is from an inherited class so newProto is the base to return so save it
            // so we can look it up value (which for a multiple hierarchy dynamicProto will be the base class)
            delete target[$c9b63384299a3252$var$DynProtoCurrent]; // Delete any current value allocated to this instance so we pick up the value from prototype hierarchy
            newProto = target[$c9b63384299a3252$var$DynProtoBaseProto] = target[$c9b63384299a3252$var$DynProtoCurrent] || target[$c9b63384299a3252$var$DynProtoBaseProto];
            target[$c9b63384299a3252$var$DynProtoCurrent] = curProto;
        }
    }
    return newProto;
}
/**
 * Helper to get the properties of an object, including none enumerable ones as functions on a prototype in ES6
 * are not enumerable.
 * @param target
 */ function $c9b63384299a3252$var$_forEachProp(target, func) {
    var props = [];
    if ($c9b63384299a3252$var$_objGetOwnProps) props = $c9b63384299a3252$var$_objGetOwnProps(target);
    else {
        for(var name_1 in target)if (typeof name_1 === "string" && (0, $78c14fe71626d827$export$d76937f5d45b7158)(target, name_1)) props.push(name_1);
    }
    if (props && props.length > 0) for(var lp = 0; lp < props.length; lp++)func(props[lp]);
}
/**
 * Helper function to check whether the provided function name is a potential candidate for dynamic
 * callback and prototype generation.
 * @param target The target object, may be a prototype or class object
 * @param funcName The function name
 * @param skipOwn Skips the check for own property
 * @ignore
 */ function $c9b63384299a3252$var$_isDynamicCandidate(target, funcName, skipOwn) {
    return funcName !== $c9b63384299a3252$var$Constructor && typeof target[funcName] === $c9b63384299a3252$var$strFunction && (skipOwn || (0, $78c14fe71626d827$export$d76937f5d45b7158)(target, funcName));
}
/**
 * Helper to throw a TypeError exception
 * @param message the message
 * @ignore
 */ function $c9b63384299a3252$var$_throwTypeError(message) {
    (0, $44a1c24c0e411039$export$3f7738bd7dcba681)("DynamicProto: " + message);
}
/**
 * Returns a collection of the instance functions that are defined directly on the thisTarget object, it does
 * not return any inherited functions
 * @param thisTarget The object to get the instance functions from
 * @ignore
 */ function $c9b63384299a3252$var$_getInstanceFuncs(thisTarget) {
    // Get the base proto
    var instFuncs = {};
    // Save any existing instance functions
    $c9b63384299a3252$var$_forEachProp(thisTarget, function(name) {
        // Don't include any dynamic prototype instances - as we only want the real functions
        if (!instFuncs[name] && $c9b63384299a3252$var$_isDynamicCandidate(thisTarget, name, false)) // Create an instance callback for passing the base function to the caller
        instFuncs[name] = thisTarget[name];
    });
    return instFuncs;
}
/**
 * Returns whether the value is included in the array
 * @param values The array of values
 * @param value  The value
 */ function $c9b63384299a3252$var$_hasVisited(values, value) {
    for(var lp = values.length - 1; lp >= 0; lp--){
        if (values[lp] === value) return true;
    }
    return false;
}
/**
 * Returns an object that contains callback functions for all "base/super" functions, this is used to "save"
 * enabling calling super.xxx() functions without requiring that the base "class" has defined a prototype references
 * @param target The current instance
 * @ignore
 */ function $c9b63384299a3252$var$_getBaseFuncs(classProto, thisTarget, instFuncs, useBaseInst) {
    function _instFuncProxy(target, funcHost, funcName) {
        var theFunc = funcHost[funcName];
        if (theFunc[$c9b63384299a3252$var$DynProxyTag] && useBaseInst) {
            // grab and reuse the hosted looking function (if available) otherwise the original passed function
            var instFuncTable = target[$c9b63384299a3252$var$DynInstFuncTable] || {};
            if (instFuncTable[$c9b63384299a3252$var$DynAllowInstChkTag] !== false) theFunc = (instFuncTable[funcHost[$c9b63384299a3252$var$DynClassName]] || {})[funcName] || theFunc;
        }
        return function() {
            // eslint-disable-next-line prefer-rest-params
            return theFunc.apply(target, arguments);
        };
    }
    // Start creating a new baseFuncs by creating proxies for the instance functions (as they may get replaced)
    var baseFuncs = {};
    $c9b63384299a3252$var$_forEachProp(instFuncs, function(name) {
        // Create an instance callback for passing the base function to the caller
        baseFuncs[name] = _instFuncProxy(thisTarget, instFuncs, name);
    });
    // Get the base prototype functions
    var baseProto = $c9b63384299a3252$var$_getObjProto(classProto);
    var visited = [];
    // Don't include base object functions for Object, Array or Function
    while(baseProto && !$c9b63384299a3252$var$_isObjectArrayOrFunctionPrototype(baseProto) && !$c9b63384299a3252$var$_hasVisited(visited, baseProto)){
        // look for prototype functions
        $c9b63384299a3252$var$_forEachProp(baseProto, function(name) {
            // Don't include any dynamic prototype instances - as we only want the real functions
            // For IE 7/8 the prototype lookup doesn't provide the full chain so we need to bypass the 
            // hasOwnProperty check we get all of the methods, main difference is that IE7/8 doesn't return
            // the Object prototype methods while bypassing the check
            if (!baseFuncs[name] && $c9b63384299a3252$var$_isDynamicCandidate(baseProto, name, !$c9b63384299a3252$var$_objGetPrototypeOf)) // Create an instance callback for passing the base function to the caller
            baseFuncs[name] = _instFuncProxy(thisTarget, baseProto, name);
        });
        // We need to find all possible functions that might be overloaded by walking the entire prototype chain
        // This avoids the caller from needing to check whether it's direct base class implements the function or not
        // by walking the entire chain it simplifies the usage and issues from upgrading any of the base classes.
        visited.push(baseProto);
        baseProto = $c9b63384299a3252$var$_getObjProto(baseProto);
    }
    return baseFuncs;
}
function $c9b63384299a3252$var$_getInstFunc(target, funcName, proto, currentDynProtoProxy) {
    var instFunc = null;
    // We need to check whether the class name is defined directly on this prototype otherwise
    // it will walk the proto chain and return any parent proto classname.
    if (target && (0, $78c14fe71626d827$export$d76937f5d45b7158)(proto, $c9b63384299a3252$var$DynClassName)) {
        var instFuncTable = target[$c9b63384299a3252$var$DynInstFuncTable] || {};
        instFunc = (instFuncTable[proto[$c9b63384299a3252$var$DynClassName]] || {})[funcName];
        if (!instFunc) // Avoid stack overflow from recursive calling the same function
        $c9b63384299a3252$var$_throwTypeError("Missing [" + funcName + "] " + $c9b63384299a3252$var$strFunction);
        // We have the instance function, lets check it we can speed up further calls
        // by adding the instance function back directly on the instance (avoiding the dynamic func lookup)
        if (!instFunc[$c9b63384299a3252$var$DynInstChkTag] && instFuncTable[$c9b63384299a3252$var$DynAllowInstChkTag] !== false) {
            // If the instance already has an instance function we can't replace it
            var canAddInst = !(0, $78c14fe71626d827$export$d76937f5d45b7158)(target, funcName);
            // Get current prototype
            var objProto = $c9b63384299a3252$var$_getObjProto(target);
            var visited = [];
            // Lookup the function starting at the top (instance level prototype) and traverse down, if the first matching function
            // if nothing is found or if the first hit is a dynamic proto instance then we can safely add an instance shortcut
            while(canAddInst && objProto && !$c9b63384299a3252$var$_isObjectArrayOrFunctionPrototype(objProto) && !$c9b63384299a3252$var$_hasVisited(visited, objProto)){
                var protoFunc = objProto[funcName];
                if (protoFunc) {
                    canAddInst = protoFunc === currentDynProtoProxy;
                    break;
                }
                // We need to find all possible initial functions to ensure that we don't bypass a valid override function
                visited.push(objProto);
                objProto = $c9b63384299a3252$var$_getObjProto(objProto);
            }
            try {
                if (canAddInst) // This instance doesn't have an instance func and the class hierarchy does have a higher level prototype version
                // so it's safe to directly assign for any subsequent calls (for better performance)
                target[funcName] = instFunc;
                // Block further attempts to set the instance function for any
                instFunc[$c9b63384299a3252$var$DynInstChkTag] = 1;
            } catch (e) {
                // Don't crash if the object is readonly or the runtime doesn't allow changing this
                // And set a flag so we don't try again for any function
                instFuncTable[$c9b63384299a3252$var$DynAllowInstChkTag] = false;
            }
        }
    }
    return instFunc;
}
function $c9b63384299a3252$var$_getProtoFunc(funcName, proto, currentDynProtoProxy) {
    var protoFunc = proto[funcName];
    // Check that the prototype function is not a self reference -- try to avoid stack overflow!
    if (protoFunc === currentDynProtoProxy) // It is so lookup the base prototype
    protoFunc = $c9b63384299a3252$var$_getObjProto(proto)[funcName];
    if (typeof protoFunc !== $c9b63384299a3252$var$strFunction) $c9b63384299a3252$var$_throwTypeError("[" + funcName + "] is not a " + $c9b63384299a3252$var$strFunction);
    return protoFunc;
}
/**
 * Add the required dynamic prototype methods to the the class prototype
 * @param proto - The class prototype
 * @param className - The instance classname
 * @param target - The target instance
 * @param baseInstFuncs - The base instance functions
 * @param setInstanceFunc - Flag to allow prototype function to reset the instance function if one does not exist
 * @ignore
 */ function $c9b63384299a3252$var$_populatePrototype(proto, className, target, baseInstFuncs, setInstanceFunc) {
    function _createDynamicPrototype(proto, funcName) {
        var dynProtoProxy = function() {
            // Use the instance or prototype function
            var instFunc = $c9b63384299a3252$var$_getInstFunc(this, funcName, proto, dynProtoProxy) || $c9b63384299a3252$var$_getProtoFunc(funcName, proto, dynProtoProxy);
            // eslint-disable-next-line prefer-rest-params
            return instFunc.apply(this, arguments);
        };
        // Tag this function as a proxy to support replacing dynamic proxy elements (primary use case is for unit testing
        // via which can dynamically replace the prototype function reference)
        dynProtoProxy[$c9b63384299a3252$var$DynProxyTag] = 1;
        return dynProtoProxy;
    }
    if (!$c9b63384299a3252$var$_isObjectOrArrayPrototype(proto)) {
        var instFuncTable = target[$c9b63384299a3252$var$DynInstFuncTable] = target[$c9b63384299a3252$var$DynInstFuncTable] || {};
        var instFuncs_1 = instFuncTable[className] = instFuncTable[className] || {}; // fetch and assign if as it may not exist yet
        // Set whether we are allow to lookup instances, if someone has set to false then do not re-enable
        if (instFuncTable[$c9b63384299a3252$var$DynAllowInstChkTag] !== false) instFuncTable[$c9b63384299a3252$var$DynAllowInstChkTag] = !!setInstanceFunc;
        $c9b63384299a3252$var$_forEachProp(target, function(name) {
            // Only add overridden functions
            if ($c9b63384299a3252$var$_isDynamicCandidate(target, name, false) && target[name] !== baseInstFuncs[name]) {
                // Save the instance Function to the lookup table and remove it from the instance as it's not a dynamic proto function
                instFuncs_1[name] = target[name];
                delete target[name];
                // Add a dynamic proto if one doesn't exist or if a prototype function exists and it's not a dynamic one
                if (!(0, $78c14fe71626d827$export$d76937f5d45b7158)(proto, name) || proto[name] && !proto[name][$c9b63384299a3252$var$DynProxyTag]) proto[name] = _createDynamicPrototype(proto, name);
            }
        });
    }
}
/**
 * Checks whether the passed prototype object appears to be correct by walking the prototype hierarchy of the instance
 * @param classProto The class prototype instance
 * @param thisTarget The current instance that will be checked whether the passed prototype instance is in the hierarchy
 * @ignore
 */ function $c9b63384299a3252$var$_checkPrototype(classProto, thisTarget) {
    // This method doesn't existing in older browsers (e.g. IE8)
    if ($c9b63384299a3252$var$_objGetPrototypeOf) {
        // As this is primarily a coding time check, don't bother checking if running in IE8 or lower
        var visited = [];
        var thisProto = $c9b63384299a3252$var$_getObjProto(thisTarget);
        while(thisProto && !$c9b63384299a3252$var$_isObjectArrayOrFunctionPrototype(thisProto) && !$c9b63384299a3252$var$_hasVisited(visited, thisProto)){
            if (thisProto === classProto) return true;
            // This avoids the caller from needing to check whether it's direct base class implements the function or not
            // by walking the entire chain it simplifies the usage and issues from upgrading any of the base classes.
            visited.push(thisProto);
            thisProto = $c9b63384299a3252$var$_getObjProto(thisProto);
        }
        return false;
    }
    // If objGetPrototypeOf doesn't exist then just assume everything is ok.
    return true;
}
/**
 * Gets the current prototype name using the ES6 name if available otherwise falling back to a use unknown as the name.
 * It's not critical for this to return a name, it's used to decorate the generated unique name for easier debugging only.
 * @param target
 * @param unknownValue
 * @ignore
 */ function $c9b63384299a3252$var$_getObjName(target, unknownValue) {
    if ((0, $78c14fe71626d827$export$d76937f5d45b7158)(target, $c9b63384299a3252$var$Prototype)) // Look like a prototype
    return target.name || unknownValue || $c9b63384299a3252$var$UnknownValue;
    return ((target || {})[$c9b63384299a3252$var$Constructor] || {}).name || unknownValue || $c9b63384299a3252$var$UnknownValue;
}
function $c9b63384299a3252$export$2e2bcd8739ae039(theClass, target, delegateFunc, options) {
    // Make sure that the passed theClass argument looks correct
    if (!(0, $78c14fe71626d827$export$d76937f5d45b7158)(theClass, $c9b63384299a3252$var$Prototype)) $c9b63384299a3252$var$_throwTypeError("theClass is an invalid class definition.");
    // Quick check to make sure that the passed theClass argument looks correct (this is a common copy/paste error)
    var classProto = theClass[$c9b63384299a3252$var$Prototype];
    if (!$c9b63384299a3252$var$_checkPrototype(classProto, target)) $c9b63384299a3252$var$_throwTypeError("[" + $c9b63384299a3252$var$_getObjName(theClass) + "] not in hierarchy of [" + $c9b63384299a3252$var$_getObjName(target) + "]");
    var className = null;
    if ((0, $78c14fe71626d827$export$d76937f5d45b7158)(classProto, $c9b63384299a3252$var$DynClassName)) // Only grab the class name if it's defined on this prototype (i.e. don't walk the prototype chain)
    className = classProto[$c9b63384299a3252$var$DynClassName];
    else {
        // As not all browser support name on the prototype creating a unique dynamic one if we have not already
        // assigned one, so we can use a simple string as the lookup rather than an object for the dynamic instance
        // function table lookup.
        className = $c9b63384299a3252$var$DynClassNamePrefix + $c9b63384299a3252$var$_getObjName(theClass, "_") + "$" + $c9b63384299a3252$var$_gblInst.n;
        $c9b63384299a3252$var$_gblInst.n++;
        classProto[$c9b63384299a3252$var$DynClassName] = className;
    }
    var perfOptions = $c9b63384299a3252$export$2e2bcd8739ae039[$c9b63384299a3252$var$DynProtoDefaultOptions];
    var useBaseInst = !!perfOptions[$c9b63384299a3252$var$strUseBaseInst];
    if (useBaseInst && options && options[$c9b63384299a3252$var$strUseBaseInst] !== undefined) useBaseInst = !!options[$c9b63384299a3252$var$strUseBaseInst];
    // Get the current instance functions
    var instFuncs = $c9b63384299a3252$var$_getInstanceFuncs(target);
    // Get all of the functions for any base instance (before they are potentially overridden)
    var baseFuncs = $c9b63384299a3252$var$_getBaseFuncs(classProto, target, instFuncs, useBaseInst);
    // Execute the delegate passing in both the current target "this" and "base" function references
    // Note casting the same type as we don't actually have the base class here and this will provide some intellisense support
    delegateFunc(target, baseFuncs);
    // Don't allow setting instance functions for older IE instances
    var setInstanceFunc = !!$c9b63384299a3252$var$_objGetPrototypeOf && !!perfOptions[$c9b63384299a3252$var$strSetInstFuncs];
    if (setInstanceFunc && options) setInstanceFunc = !!options[$c9b63384299a3252$var$strSetInstFuncs];
    // Populate the Prototype for any overridden instance functions
    $c9b63384299a3252$var$_populatePrototype(classProto, className, target, instFuncs, setInstanceFunc !== false);
}
/**
 * Exposes the default global options to allow global configuration, if the global values are disabled these will override
 * any passed values. This is primarily exposed to support unit-testing without the need for individual classes to expose
 * their internal usage of dynamic proto.
 */ $c9b63384299a3252$export$2e2bcd8739ae039[$c9b63384299a3252$var$DynProtoDefaultOptions] = $c9b63384299a3252$var$_gblInst.o;


/*
 * Application Insights JavaScript SDK - Web Analytics, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ /**
* ApplicationInsights.ts
* @copyright Microsoft 2018
*/ // Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */ 



/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */ 



function $f432995056d11d0e$export$43fe3a9b30d28d1e(obj) {
    if (!(0, $533f826bbc418791$export$a6cdc56e425d0d0a)(obj) || obj === (0, $b347daff6f5f8dc1$export$38c7ba05d207d137)) throw new TypeError("polyObjKeys called on non-object");
    var result = [];
    for(var prop in obj)if ((0, $08325aa6d8565cc0$export$34e6b98f73578a9c)(obj, prop)) result.push(prop);
    return result;
}
function $f432995056d11d0e$export$aba5bd6a473725e4(value) {
    var result = [];
    (0, $45e528077703ac0c$export$aa0705d5774c95d1)(value, function(key, value) {
        result.push([
            key,
            value
        ]);
    });
    return result;
}
function $f432995056d11d0e$export$f478e11a4f5d56d5(value) {
    var result = [];
    (0, $45e528077703ac0c$export$aa0705d5774c95d1)(value, function(key, value) {
        result.push(value);
    });
    return result;
}


var $36a077d9f4439b69$var$_objFreeze = (0, $b347daff6f5f8dc1$export$9ec954dd81c90a5d)["freeze"];
var $36a077d9f4439b69$var$_doNothing = function(value) {
    return value;
};
var $36a077d9f4439b69$var$_getProto = function(value) {
    return value[0, $b347daff6f5f8dc1$export$bac6e64dee11e7fb] || (0, $b347daff6f5f8dc1$export$38c7ba05d207d137);
};
var $36a077d9f4439b69$export$afe328edc487dcfe = (0, $b347daff6f5f8dc1$export$9ec954dd81c90a5d)["assign"];
function $36a077d9f4439b69$export$f7628dc18f4211e5(value) {
    if (!(0, $533f826bbc418791$export$a6cdc56e425d0d0a)(value) || value === (0, $b347daff6f5f8dc1$export$38c7ba05d207d137)) (0, $44a1c24c0e411039$export$3f7738bd7dcba681)("objKeys called on non-object");
    return (0, $b347daff6f5f8dc1$export$9ec954dd81c90a5d).keys(value);
}
function $36a077d9f4439b69$export$a15782d21797da4c(value) {
    if ($36a077d9f4439b69$var$_objFreeze) (0, $45e528077703ac0c$export$aa0705d5774c95d1)(value, function(key, value) {
        if ((0, $533f826bbc418791$export$43bee75e5e14138e)(value) || (0, $533f826bbc418791$export$a6cdc56e425d0d0a)(value)) $36a077d9f4439b69$var$_objFreeze(value);
    });
    return $36a077d9f4439b69$export$5da24d7703175bc5(value);
}
var $36a077d9f4439b69$export$5da24d7703175bc5 = $36a077d9f4439b69$var$_objFreeze || $36a077d9f4439b69$var$_doNothing;
var $36a077d9f4439b69$export$8bbd42c2bec875c8 = (0, $b347daff6f5f8dc1$export$9ec954dd81c90a5d)["seal"] || $36a077d9f4439b69$var$_doNothing;
var $36a077d9f4439b69$export$743454acee35f1d4 = (0, $b347daff6f5f8dc1$export$9ec954dd81c90a5d)["getPrototypeOf"] || $36a077d9f4439b69$var$_getProto;
var $36a077d9f4439b69$export$5359e3134992ffd2 = (0, $b347daff6f5f8dc1$export$9ec954dd81c90a5d).entries || (0, $f432995056d11d0e$export$aba5bd6a473725e4);
var $36a077d9f4439b69$export$91c2df05d37a1ffb = (0, $b347daff6f5f8dc1$export$9ec954dd81c90a5d).values || (0, $f432995056d11d0e$export$f478e11a4f5d56d5);

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */ 
/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */ 

function $386f00e3a193a7da$export$21fce7cbd4dc679f(object, format) {
    var propertyValueDump = (0, $b347daff6f5f8dc1$export$ccb33e29d92c9a58);
    if ((0, $533f826bbc418791$export$e6127cc7fe7395c3)(object)) propertyValueDump = "{ stack: '" + object.stack + "', message: '" + object.message + "', name: '" + object.name + "'";
    else try {
        propertyValueDump = JSON.stringify(object, (0, $b347daff6f5f8dc1$export$38c7ba05d207d137), format ? (0, $533f826bbc418791$export$7e4aa119212bc614)(format) ? format : 4 : (0, $b347daff6f5f8dc1$export$375c5ccc31575c19));
    } catch (e) {
        // Unable to convert object (probably circular)
        propertyValueDump = " - " + $386f00e3a193a7da$export$21fce7cbd4dc679f(e, format);
    }
    return (0, $533f826bbc418791$export$3cbb80dec8953997)(object) + ": " + propertyValueDump;
}


var $f80c2443c3b8028d$var$_objCreate = (0, $b347daff6f5f8dc1$export$9ec954dd81c90a5d)["create"];
var $f80c2443c3b8028d$export$c09f2411a4ae511b = $f80c2443c3b8028d$var$_objCreate || $f80c2443c3b8028d$export$8a0865d167ee9eb4;
function $f80c2443c3b8028d$export$8a0865d167ee9eb4(obj) {
    if (!obj) return {};
    var type = typeof obj;
    if (type !== (0, $b347daff6f5f8dc1$export$8b8a958a7f6f130c) && type !== (0, $b347daff6f5f8dc1$export$601fe16600f10158)) throw new TypeError("Prototype must be an Object or function: " + (0, $386f00e3a193a7da$export$21fce7cbd4dc679f)(obj));
    function tempFunc() {}
    tempFunc[0, $b347daff6f5f8dc1$export$4ddd10988dd20ff4] = obj;
    return new tempFunc();
}


// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
var $67b827af57eed1eb$export$327014e6dfd5ba11 = "function";
var $67b827af57eed1eb$export$127e9c2439c2ee16 = "object";
var $67b827af57eed1eb$export$9b7d2d86cf58b987 = "undefined";
var $67b827af57eed1eb$export$ecddaaeb55ecf049 = "prototype";
var $67b827af57eed1eb$export$b39d4edf23d6f14c = "default";
var $67b827af57eed1eb$export$9ec954dd81c90a5d = Object;
var $67b827af57eed1eb$export$e77bb59b5e655b3d = $67b827af57eed1eb$export$9ec954dd81c90a5d[$67b827af57eed1eb$export$ecddaaeb55ecf049];


var $2a74b38b87b38cda$export$3a8d60327f425095 = ((0, $3d5fcb60a9467a45$export$a4e55266d2135a7f)() || {})["Symbol"];
var $2a74b38b87b38cda$export$904e7a8ad467688a = ((0, $3d5fcb60a9467a45$export$a4e55266d2135a7f)() || {})["Reflect"];
var $2a74b38b87b38cda$export$9f6bdf37c7d86dfe = !!$2a74b38b87b38cda$export$904e7a8ad467688a;
var $2a74b38b87b38cda$var$strDecorate = "decorate";
var $2a74b38b87b38cda$var$strMetadata = "metadata";
var $2a74b38b87b38cda$var$strGetOwnPropertySymbols = "getOwnPropertySymbols";
var $2a74b38b87b38cda$var$strIterator = "iterator";
var $2a74b38b87b38cda$var$strHasOwnProperty = "hasOwnProperty";
var $2a74b38b87b38cda$export$64ecba31e1fc6f1e = function(t) {
    // tslint:disable-next-line: ban-comma-operator
    for(var s, i = 1, n = arguments.length; i < n; i++){
        s = arguments[i];
        for(var p in s)if ((0, $67b827af57eed1eb$export$e77bb59b5e655b3d)[$2a74b38b87b38cda$var$strHasOwnProperty].call(s, p)) t[p] = s[p];
    }
    return t;
};
var $2a74b38b87b38cda$export$b3cf7a802e578501 = (0, $36a077d9f4439b69$export$afe328edc487dcfe) || $2a74b38b87b38cda$export$64ecba31e1fc6f1e;
// tslint:disable-next-line: only-arrow-functions
var $2a74b38b87b38cda$var$extendStaticsFn = function(d, b) {
    $2a74b38b87b38cda$var$extendStaticsFn = (0, $67b827af57eed1eb$export$9ec954dd81c90a5d)["setPrototypeOf"] || // tslint:disable-next-line: only-arrow-functions
    ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || // tslint:disable-next-line: only-arrow-functions
    function(d, b) {
        for(var p in b)if (b[$2a74b38b87b38cda$var$strHasOwnProperty](p)) d[p] = b[p];
    };
    return $2a74b38b87b38cda$var$extendStaticsFn(d, b);
};
function $2a74b38b87b38cda$export$1f9c32e3fbfb8e62(d, b) {
    if (typeof b !== (0, $67b827af57eed1eb$export$327014e6dfd5ba11) && b !== null) (0, $44a1c24c0e411039$export$3f7738bd7dcba681)("Class extends value " + String(b) + " is not a constructor or null");
    $2a74b38b87b38cda$var$extendStaticsFn(d, b);
    function __() {
        this.constructor = d;
    }
    // tslint:disable-next-line: ban-comma-operator
    d[0, $67b827af57eed1eb$export$ecddaaeb55ecf049] = b === null ? (0, $f80c2443c3b8028d$export$c09f2411a4ae511b)(b) : (__[0, $67b827af57eed1eb$export$ecddaaeb55ecf049] = b[0, $67b827af57eed1eb$export$ecddaaeb55ecf049], new __());
}
function $2a74b38b87b38cda$export$b0e1e04064f2edd0(s, e) {
    var t = {};
    for(var k in s)if ((0, $78c14fe71626d827$export$d76937f5d45b7158)(s, k) && e.indexOf(k) < 0) t[k] = s[k];
    if (s != null && typeof (0, $67b827af57eed1eb$export$9ec954dd81c90a5d)[$2a74b38b87b38cda$var$strGetOwnPropertySymbols] === (0, $67b827af57eed1eb$export$327014e6dfd5ba11)) {
        for(var i = 0, p = (0, $67b827af57eed1eb$export$9ec954dd81c90a5d)[$2a74b38b87b38cda$var$strGetOwnPropertySymbols](s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && (0, $67b827af57eed1eb$export$e77bb59b5e655b3d)["propertyIsEnumerable"].call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $2a74b38b87b38cda$export$1f334cb233663b35(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = (0, $67b827af57eed1eb$export$9ec954dd81c90a5d)["getOwnPropertyDescriptor"](target, key) : desc, d;
    if ($2a74b38b87b38cda$export$9f6bdf37c7d86dfe && typeof $2a74b38b87b38cda$export$904e7a8ad467688a[$2a74b38b87b38cda$var$strDecorate] === (0, $67b827af57eed1eb$export$327014e6dfd5ba11)) r = $2a74b38b87b38cda$export$904e7a8ad467688a[$2a74b38b87b38cda$var$strDecorate](decorators, target, key, desc);
    else {
        for(var i = decorators.length - 1; i >= 0; i--)// eslint-disable-next-line no-cond-assign
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }
    // tslint:disable-next-line:ban-comma-operator
    return c > 3 && r && (0, $d212d948d25f959a$export$8b8fd4dfd45f6b81)(target, key, r), r;
}
function $2a74b38b87b38cda$export$a862c09c17c00454(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $2a74b38b87b38cda$export$652131891efe9c32(metadataKey, metadataValue) {
    if ($2a74b38b87b38cda$export$9f6bdf37c7d86dfe && $2a74b38b87b38cda$export$904e7a8ad467688a[$2a74b38b87b38cda$var$strMetadata] === (0, $67b827af57eed1eb$export$327014e6dfd5ba11)) return $2a74b38b87b38cda$export$904e7a8ad467688a[$2a74b38b87b38cda$var$strMetadata](metadataKey, metadataValue);
}
function $2a74b38b87b38cda$export$11150685fa6930db(m, o) {
    for(var p in m)if (p !== (0, $67b827af57eed1eb$export$b39d4edf23d6f14c) && !(0, $78c14fe71626d827$export$d76937f5d45b7158)(o, p)) $2a74b38b87b38cda$export$1ea27411cf67499d(o, m, p);
}
function $2a74b38b87b38cda$export$1ea27411cf67499d(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    if (!!(0, $d212d948d25f959a$export$8b8fd4dfd45f6b81)) (0, $d212d948d25f959a$export$8b8fd4dfd45f6b81)(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
    else o[k2] = m[k];
}
function $2a74b38b87b38cda$export$19cc45bf4f6ae179(o) {
    var s = typeof $2a74b38b87b38cda$export$3a8d60327f425095 === (0, $67b827af57eed1eb$export$327014e6dfd5ba11) && $2a74b38b87b38cda$export$3a8d60327f425095[$2a74b38b87b38cda$var$strIterator], m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    (0, $44a1c24c0e411039$export$3f7738bd7dcba681)(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $2a74b38b87b38cda$export$18637e2f1e451a15(o, n) {
    var m = typeof $2a74b38b87b38cda$export$3a8d60327f425095 === (0, $67b827af57eed1eb$export$327014e6dfd5ba11) && o[$2a74b38b87b38cda$export$3a8d60327f425095[$2a74b38b87b38cda$var$strIterator]];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            // tslint:disable-next-line:no-conditional-assignment
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) // eslint-disable-next-line no-unsafe-finally
            throw e.error;
        }
    }
    return ar;
}
function $2a74b38b87b38cda$export$e4572e1e87bd3458() {
    var theArgs = arguments;
    // Calculate new total size
    for(var s = 0, i = 0, il = theArgs.length; i < il; i++)s += theArgs[i].length;
    // Create new full array
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = theArgs[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $2a74b38b87b38cda$export$643fbb7023bc1942(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
}
function $2a74b38b87b38cda$export$b4774f2d9ed4def4(cooked, raw) {
    if (0, $d212d948d25f959a$export$8b8fd4dfd45f6b81) (0, $d212d948d25f959a$export$8b8fd4dfd45f6b81)(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $2a74b38b87b38cda$export$8f42f3b1d1cb5f6d(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== (0, $67b827af57eed1eb$export$b39d4edf23d6f14c) && Object.prototype.hasOwnProperty.call(mod, k)) $2a74b38b87b38cda$export$1ea27411cf67499d(result, mod, k);
    }
    // Set default module
    if (!!(0, $d212d948d25f959a$export$8b8fd4dfd45f6b81)) (0, $d212d948d25f959a$export$8b8fd4dfd45f6b81)(result, (0, $67b827af57eed1eb$export$b39d4edf23d6f14c), {
        enumerable: true,
        value: mod
    });
    else result[0, $67b827af57eed1eb$export$b39d4edf23d6f14c] = mod;
    return result;
}
function $2a74b38b87b38cda$export$b2781524d4888cea(mod) {
    return mod && mod.__esModule ? mod : {
        strDefault: mod
    };
}



/*
 * Application Insights JavaScript SDK - Common, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // Licensed under the
/*
 * Application Insights JavaScript SDK - Common, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ /*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */ 
function $f6bb085f8cf12216$export$e2e5bcdbdc49c586(theArray, callbackfn, thisArg) {
    if (theArray) {
        var len = theArray[0, $b347daff6f5f8dc1$export$5f32d5745d700b0e] >>> 0;
        for(var idx = 0; idx < len; idx++)if (idx in theArray) {
            if (callbackfn.call(thisArg || theArray, theArray[idx], idx, theArray) === -1) break;
        }
    }
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */ 
/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */ 

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */ 
var $d813f4522b40a37e$export$590567be997858b6 = (0, $b347daff6f5f8dc1$export$7ce2e0314415f079);



var $d491d25af4ac425c$var$_arrSlice = (0, $b347daff6f5f8dc1$export$f3f471c81a14426)[0, $b347daff6f5f8dc1$export$ddd00fe728e19670];
var $d491d25af4ac425c$var$_throwMissingFunction = function(funcName, thisArg) {
    (0, $44a1c24c0e411039$export$3f7738bd7dcba681)("'" + (0, $d813f4522b40a37e$export$590567be997858b6)(funcName) + "' not defined for " + (0, $386f00e3a193a7da$export$21fce7cbd4dc679f)(thisArg));
};
var $d491d25af4ac425c$export$fe708dcfc359f940 = function(funcName) {
    return function(thisArg) {
        return thisArg[funcName].apply(thisArg, $d491d25af4ac425c$var$_arrSlice.call(arguments, 1));
    };
};
var $d491d25af4ac425c$export$34d1cd0b62238dad = function(funcName, clsProto) {
    var clsFn = clsProto && clsProto[funcName];
    return function(thisArg) {
        var theFunc = thisArg && thisArg[funcName] || clsFn;
        if (theFunc) return theFunc.apply(thisArg, $d491d25af4ac425c$var$_arrSlice.call(arguments, 1));
        $d491d25af4ac425c$var$_throwMissingFunction(funcName, thisArg);
    };
};
var $d491d25af4ac425c$export$e4412260893e0ee4 = function(funcName, clsProto, polyFunc) {
    var clsFn = clsProto && clsProto[funcName];
    return function(thisArg) {
        var theFunc = thisArg && thisArg[funcName] || clsFn;
        if (theFunc || polyFunc) {
            var theArgs = arguments;
            return (theFunc || polyFunc).apply(thisArg, theFunc ? $d491d25af4ac425c$var$_arrSlice.call(theArgs, 1) : theArgs);
        }
        $d491d25af4ac425c$var$_throwMissingFunction(funcName, thisArg);
    };
};
function $d491d25af4ac425c$export$b9deaf03e58c2bf5(propName) {
    return function(thisArg) {
        return thisArg[propName];
    };
}


var $a96d4958027d6f85$export$9f3b3ffa84393d30 = (0, $d491d25af4ac425c$export$34d1cd0b62238dad)((0, $b347daff6f5f8dc1$export$b2c0731cca6bbbd0), (0, $b347daff6f5f8dc1$export$f3f471c81a14426));
var $a96d4958027d6f85$export$ef8741fcdb4b04c8 = (0, $d491d25af4ac425c$export$34d1cd0b62238dad)((0, $b347daff6f5f8dc1$export$ecb956a5faeb2d4a), (0, $b347daff6f5f8dc1$export$f3f471c81a14426));

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */ /**
 * Return the number of milliseconds that have elapsed since January 1, 1970 00:00:00 UTC.
 *
 * To offer protection against timing attacks and fingerprinting, the precision of dateNow()
 * might get rounded depending on browser settings. In Firefox, the privacy.reduceTimerPrecision
 * preference is enabled by default and defaults to 20µs in Firefox 59; in 60 it will be 2ms.
 *
 * @since 0.4.4
 * @group Timer
 *
 * @returns A Number representing the milliseconds elapsed since the UNIX epoch.
 * @example
 * ```ts
 * let now = utcNow();
 * ```
 */ function $628cad25a0769458$export$a56f095995763cca() {
    return (Date.now || $628cad25a0769458$export$dc8a201911902710)();
}
function $628cad25a0769458$export$dc8a201911902710() {
    return new Date().getTime();
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */ 


var $824d7bc9d9e48f68$var$_perf;
function $824d7bc9d9e48f68$export$581add2462e763c2() {
    return !!$824d7bc9d9e48f68$export$28a0276e10aa78d7();
}
function $824d7bc9d9e48f68$export$28a0276e10aa78d7() {
    (!$824d7bc9d9e48f68$var$_perf || !$824d7bc9d9e48f68$var$_perf.b && (0, $d8ec17546a34ef88$export$2d4a6284764f647f) && (0, $d8ec17546a34ef88$export$2d4a6284764f647f).lzy) && ($824d7bc9d9e48f68$var$_perf = (0, $3d5fcb60a9467a45$export$45fd08e1bc14fe1c)("performance"));
    return $824d7bc9d9e48f68$var$_perf.v;
}
function $824d7bc9d9e48f68$export$ba2b1ec760f018ed() {
    var perf = $824d7bc9d9e48f68$export$28a0276e10aa78d7();
    if (perf && perf.now) return perf.now();
    return (0, $628cad25a0769458$export$a56f095995763cca)();
}
function $824d7bc9d9e48f68$export$1ea91570c695dfb2(startTime) {
    return $824d7bc9d9e48f68$export$ba2b1ec760f018ed() - startTime;
}

/*
 * Application Insights JavaScript SDK - Core, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ /*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */ 




/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */ 
var $317394647a739f1b$export$e411eeaf23dccbe8 = (0, $b347daff6f5f8dc1$export$dbb682be7aa6edc2).min;
var $317394647a739f1b$export$2ca8010d037f830f = (0, $b347daff6f5f8dc1$export$dbb682be7aa6edc2).max;


/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */ 

var $f0b39daabf48e63b$export$aaf2ac896f62f2c3 = (0, $d491d25af4ac425c$export$34d1cd0b62238dad)((0, $b347daff6f5f8dc1$export$ddd00fe728e19670), (0, $b347daff6f5f8dc1$export$a31bd47275edb702));


var $c3f3bf8012a4b2d4$export$9d1aa7361d7a6e87 = (0, $d491d25af4ac425c$export$34d1cd0b62238dad)("substring", (0, $b347daff6f5f8dc1$export$a31bd47275edb702));
var $c3f3bf8012a4b2d4$export$25b2a9bb66b0078d = (0, $d491d25af4ac425c$export$e4412260893e0ee4)("substr", (0, $b347daff6f5f8dc1$export$a31bd47275edb702), $c3f3bf8012a4b2d4$export$5e0a36ccb324041a);
function $c3f3bf8012a4b2d4$export$5e0a36ccb324041a(value, start, length) {
    if ((0, $533f826bbc418791$export$bedb7023a7733221)(value)) (0, $44a1c24c0e411039$export$3f7738bd7dcba681)("'polyStrSubstr called with invalid " + (0, $386f00e3a193a7da$export$21fce7cbd4dc679f)(value));
    if (length < 0) return 0, $b347daff6f5f8dc1$export$ccb33e29d92c9a58;
    // If start is omitted or undefined, its treated as zero
    start = start || 0;
    if (start < 0) start = (0, $317394647a739f1b$export$2ca8010d037f830f)(start + value[0, $b347daff6f5f8dc1$export$5f32d5745d700b0e], 0);
    if ((0, $533f826bbc418791$export$fce6876652108ab)(length)) return (0, $f0b39daabf48e63b$export$aaf2ac896f62f2c3)(value, start);
    return (0, $f0b39daabf48e63b$export$aaf2ac896f62f2c3)(value, start, start + length);
}
function $c3f3bf8012a4b2d4$export$a1120f14ec6f7ada(value, count) {
    return $c3f3bf8012a4b2d4$export$9d1aa7361d7a6e87(value, 0, count);
}
function $c3f3bf8012a4b2d4$export$9fa3d612c59f0874(value, count) {
    var len = value[0, $b347daff6f5f8dc1$export$5f32d5745d700b0e];
    if (count <= 0) return 0, $b347daff6f5f8dc1$export$ccb33e29d92c9a58;
    return len > count ? $c3f3bf8012a4b2d4$export$9d1aa7361d7a6e87(value, len - count) : value;
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */ 

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */ 



function $5df3266279dc0b26$var$_createTrimFn(exp) {
    return function _doTrim(value) {
        if ((0, $533f826bbc418791$export$bedb7023a7733221)(value)) (0, $44a1c24c0e411039$export$3f7738bd7dcba681)("strTrim called [" + (0, $386f00e3a193a7da$export$21fce7cbd4dc679f)(value) + "]");
        if (value && value.replace) value = value.replace(exp, (0, $b347daff6f5f8dc1$export$ccb33e29d92c9a58));
        return value;
    };
}
var $5df3266279dc0b26$export$f662cd8e6ce31dc2 = $5df3266279dc0b26$var$_createTrimFn(/^\s+|(?=\s)\s+$/g);
var $5df3266279dc0b26$export$bb2565d3c45fa8e8 = $5df3266279dc0b26$var$_createTrimFn(/^\s+/g);
var $5df3266279dc0b26$export$78c6fe435b4cfdc5 = $5df3266279dc0b26$var$_createTrimFn(/(?=\s)\s+$/g);


var $f67365b40c49b6c1$export$ef0e11c5f5f351f7 = (0, $d491d25af4ac425c$export$e4412260893e0ee4)("trim", (0, $b347daff6f5f8dc1$export$a31bd47275edb702), (0, $5df3266279dc0b26$export$f662cd8e6ce31dc2));
var $f67365b40c49b6c1$export$cc516ea7d6f0e796 = (0, $d491d25af4ac425c$export$e4412260893e0ee4)("trimStart", (0, $b347daff6f5f8dc1$export$a31bd47275edb702), (0, $5df3266279dc0b26$export$bb2565d3c45fa8e8));
var $f67365b40c49b6c1$export$54a8ea2dce045d2d = $f67365b40c49b6c1$export$cc516ea7d6f0e796;
var $f67365b40c49b6c1$export$2f86eefb8e93fce1 = (0, $d491d25af4ac425c$export$e4412260893e0ee4)("trimEnd", (0, $b347daff6f5f8dc1$export$a31bd47275edb702), (0, $5df3266279dc0b26$export$78c6fe435b4cfdc5));
var $f67365b40c49b6c1$export$9c947579c164a1bf = $f67365b40c49b6c1$export$2f86eefb8e93fce1;


/*
 * Application Insights JavaScript SDK - Core, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var $1ae5573ce493bccc$export$e4eaee9e01d9baaa = "toLowerCase"; // Count: 9
var $1ae5573ce493bccc$export$9d71a37f0770d87f = "blkVal"; // Count: 5
var $1ae5573ce493bccc$export$6eae51590aaea43 = "length"; // Count: 42
var $1ae5573ce493bccc$export$9e4bb115c58de388 = "rdOnly"; // Count: 4
var $1ae5573ce493bccc$export$6c2b24c6eee14c46 = "notify"; // Count: 4
var $1ae5573ce493bccc$export$667d3cd09d258d38 = "warnToConsole"; // Count: 4
var $1ae5573ce493bccc$export$6c078c21a0c6c1ce = "throwInternal"; // Count: 5
var $1ae5573ce493bccc$export$24caac6d68ff1537 = "setDf"; // Count: 6
var $1ae5573ce493bccc$export$fc59eec8d77f3766 = "watch"; // Count: 9
var $1ae5573ce493bccc$export$e6a243fe757439f9 = "logger"; // Count: 21
var $1ae5573ce493bccc$export$2f85ca6962b15ff8 = "apply"; // Count: 7
var $1ae5573ce493bccc$export$a0a330e7fa1e278c = "push"; // Count: 31
var $1ae5573ce493bccc$export$84020a2e4fe863b0 = "splice"; // Count: 8
var $1ae5573ce493bccc$export$d17a699c20d379ac = "hdlr"; // Count: 6
var $1ae5573ce493bccc$export$bd01c5e3f12db01c = "cancel"; // Count: 5
var $1ae5573ce493bccc$export$65cd33bb52d04675 = "initialize"; // Count: 4
var $1ae5573ce493bccc$export$f001befbf8417151 = "identifier"; // Count: 8
var $1ae5573ce493bccc$export$2e2716e9c35a66a8 = "isInitialized"; // Count: 10
var $1ae5573ce493bccc$export$37717a508eca6e2d = "getPlugin"; // Count: 6
var $1ae5573ce493bccc$export$538c138266a38409 = "pollInternalLogs"; // Count: 2
var $1ae5573ce493bccc$export$9734b0a24bf02e93 = "name"; // Count: 11
var $1ae5573ce493bccc$export$7b5ba5854159c1f0 = "time"; // Count: 6
var $1ae5573ce493bccc$export$5c220169317cd6de = "processNext"; // Count: 15
var $1ae5573ce493bccc$export$a08d24db8e8aa3f3 = "getProcessTelContext"; // Count: 2
var $1ae5573ce493bccc$export$3a09068de032bb32 = "getNotifyMgr"; // Count: 5
var $1ae5573ce493bccc$export$5c8bcfab4f42ca62 = "addNotificationListener"; // Count: 4
var $1ae5573ce493bccc$export$861144ba9c13be60 = "removeNotificationListener"; // Count: 4
var $1ae5573ce493bccc$export$c9b1609f2b84393a = "enabled"; // Count: 6
var $1ae5573ce493bccc$export$8d1c48dba7ad83a = "stopPollingInternalLogs"; // Count: 2
var $1ae5573ce493bccc$export$7eb85b5cba77a43d = "unload"; // Count: 9
var $1ae5573ce493bccc$export$8693bdba21bfca93 = "onComplete"; // Count: 5
var $1ae5573ce493bccc$export$568c4302d11f2b22 = "version"; // Count: 6
var $1ae5573ce493bccc$export$e53d8cae4d527530 = "loggingLevelConsole"; // Count: 2
var $1ae5573ce493bccc$export$1e6514b499ba4d34 = "createNew"; // Count: 7
var $1ae5573ce493bccc$export$7176fb2a7d11927e = "teardown"; // Count: 9
var $1ae5573ce493bccc$export$2cc5b49df2eed261 = "messageId"; // Count: 4
var $1ae5573ce493bccc$export$923606b70907833e = "message"; // Count: 6
var $1ae5573ce493bccc$export$d8114c9e990204cb = "isAsync"; // Count: 6
var $1ae5573ce493bccc$export$c7ff2c36e5c78421 = "diagLog"; // Count: 10
var $1ae5573ce493bccc$export$458d234b616d0745 = "_doTeardown"; // Count: 4
var $1ae5573ce493bccc$export$c9f4bebf02f459de = "update"; // Count: 6
var $1ae5573ce493bccc$export$36754a48de7fd714 = "getNext"; // Count: 12
var $1ae5573ce493bccc$export$55d672a1dc4d50c1 = "setNextPlugin"; // Count: 5
var $1ae5573ce493bccc$export$2e850152cb3355e2 = "userAgent"; // Count: 5
var $1ae5573ce493bccc$export$b889f1d4cb07c706 = "split"; // Count: 5
var $1ae5573ce493bccc$export$aa192ee35fac3196 = "nodeType"; // Count: 3
var $1ae5573ce493bccc$export$ef9ef3ed86c4485 = "replace"; // Count: 8
var $1ae5573ce493bccc$export$6a3333b2109fff2a = "logInternalMessage"; // Count: 2
var $1ae5573ce493bccc$export$8fdcd26070ec159 = "type"; // Count: 14
var $1ae5573ce493bccc$export$b353fcbe1ae31450 = "handler"; // Count: 5
var $1ae5573ce493bccc$export$3a89026537e5dfec = "isChildEvt"; // Count: 3
var $1ae5573ce493bccc$export$c405fd80acb80a5b = "getCtx"; // Count: 6
var $1ae5573ce493bccc$export$2ec27a3df8fa4130 = "setCtx"; // Count: 10
var $1ae5573ce493bccc$export$b6736e780b133181 = "complete"; // Count: 3
var $1ae5573ce493bccc$export$a5eb52c53bba8560 = "traceId"; // Count: 5
var $1ae5573ce493bccc$export$c105b94efa183847 = "spanId"; // Count: 5
var $1ae5573ce493bccc$export$4e92e4b92b41ba2d = "traceFlags"; // Count: 6


/*
 * Application Insights JavaScript SDK - Core, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 


/*
 * Application Insights JavaScript SDK - Core, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // ###################################################################################################################################################
// Note: DON'T Export these const from the package as we are still targeting IE/ES5 this will export a mutable variables that someone could change ###
// ###################################################################################################################################################
var $9fe4a5d5204a4cff$export$a43287864529b8fd = undefined;
var $9fe4a5d5204a4cff$export$5e8607ab26634759 = "";
var $9fe4a5d5204a4cff$export$829012af4b2055a2 = "channels";
var $9fe4a5d5204a4cff$export$3094ace9cd82ff99 = "core";
var $9fe4a5d5204a4cff$export$1cf3476332da55b3 = "createPerfMgr";
var $9fe4a5d5204a4cff$export$49e9417944569ae8 = "disabled";
var $9fe4a5d5204a4cff$export$ffb2356587263734 = "extensionConfig";
var $9fe4a5d5204a4cff$export$a077ce616a1ab4ee = "extensions";
var $9fe4a5d5204a4cff$export$820a3bce4a265606 = "processTelemetry";
var $9fe4a5d5204a4cff$export$58efcc07763b37be = "priority";
var $9fe4a5d5204a4cff$export$bb3c4bc1b1175d3d = "eventsSent";
var $9fe4a5d5204a4cff$export$bacb5b2f4c1081b9 = "eventsDiscarded";
var $9fe4a5d5204a4cff$export$d75e063cb88a1c25 = "eventsSendRequest";
var $9fe4a5d5204a4cff$export$5d265841733c97c3 = "perfEvent";
var $9fe4a5d5204a4cff$export$f8b08c7de64edfbf = "getPerfMgr";
var $9fe4a5d5204a4cff$export$8f3e5386cefa231e = "domain";
var $9fe4a5d5204a4cff$export$bdba10701e0ccff3 = "path";
var $9fe4a5d5204a4cff$export$80c7dcdabc53a7db = "Not dynamic - ";


/*
 * Application Insights JavaScript SDK - Core, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 

/*
 * Application Insights JavaScript SDK - Core, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */ 

var $0194d45a55d79548$export$7c0888b0c4641088 = (0, $d491d25af4ac425c$export$34d1cd0b62238dad)((0, $b347daff6f5f8dc1$export$b2c0731cca6bbbd0), (0, $b347daff6f5f8dc1$export$a31bd47275edb702));
var $0194d45a55d79548$export$107c6a87f2040ede = (0, $d491d25af4ac425c$export$34d1cd0b62238dad)((0, $b347daff6f5f8dc1$export$ecb956a5faeb2d4a), (0, $b347daff6f5f8dc1$export$a31bd47275edb702));



/*
 * Application Insights JavaScript SDK - Core, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */ /*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2023 Nevware21
 * Licensed under the MIT license.
 */ 
var $e9133230f0eaf267$export$4b40e215736a9426 = (0, $d491d25af4ac425c$export$fe708dcfc359f940)("call");






// Use to cache the result of Object.cont
var $a339b44c6e62d324$var$_fnToString;
var $a339b44c6e62d324$var$_objCtrFnString;
var $a339b44c6e62d324$var$_gblWindow;
function $a339b44c6e62d324$export$53b83ca8eaab0383(value) {
    if (!value || typeof value !== (0, $b347daff6f5f8dc1$export$8b8a958a7f6f130c)) return false;
    if (!$a339b44c6e62d324$var$_gblWindow) // Lazily cache the current global window value and default it to "true" (so we bypass this check in the future)
    $a339b44c6e62d324$var$_gblWindow = (0, $3d5fcb60a9467a45$export$fef62134eea24008)() ? (0, $3d5fcb60a9467a45$export$38b2d434cce3ea22)() : true;
    var result = false;
    if (value !== $a339b44c6e62d324$var$_gblWindow) {
        if (!$a339b44c6e62d324$var$_objCtrFnString) {
            // Lazily caching what the runtime reports as the object function constructor (as a string)
            // Using an current function lookup to find what this runtime calls a "native" function
            $a339b44c6e62d324$var$_fnToString = Function[0, $b347daff6f5f8dc1$export$4ddd10988dd20ff4].toString;
            $a339b44c6e62d324$var$_objCtrFnString = (0, $e9133230f0eaf267$export$4b40e215736a9426)($a339b44c6e62d324$var$_fnToString, (0, $b347daff6f5f8dc1$export$9ec954dd81c90a5d));
        }
        try {
            var proto = (0, $36a077d9f4439b69$export$743454acee35f1d4)(value);
            // No prototype so looks like an object created with Object.create(null)
            result = !proto;
            if (!result) {
                if ((0, $78c14fe71626d827$export$d76937f5d45b7158)(proto, (0, $b347daff6f5f8dc1$export$943e078395581e44))) proto = proto[0, $b347daff6f5f8dc1$export$943e078395581e44];
                result = proto && typeof proto === (0, $b347daff6f5f8dc1$export$601fe16600f10158) && $a339b44c6e62d324$var$_fnToString.call(proto) === $a339b44c6e62d324$var$_objCtrFnString;
            }
        } catch (ex) {
        // Something went wrong, so it's not an object we are playing with
        }
    }
    return result;
}




// RESTRICT and AVOID circular dependencies you should not import other contained modules or export the contents of this file directly
// Added to help with minification
var $0b747974b0bb3563$var$strGetPrototypeOf = "getPrototypeOf";
var $0b747974b0bb3563$var$rCamelCase = /-([a-z])/g;
var $0b747974b0bb3563$var$rNormalizeInvalid = /([^\w\d_$])/g;
var $0b747974b0bb3563$var$rLeadingNumeric = /^(\d+[\w\d_$])/;
var $0b747974b0bb3563$export$821e81707b1677f9 = Object[$0b747974b0bb3563$var$strGetPrototypeOf];
function $0b747974b0bb3563$export$e7321bf46d18757f(value) {
    return !(0, $533f826bbc418791$export$fce6876652108ab)(value);
}
function $0b747974b0bb3563$export$71fc1ee3e76bc1fe(value) {
    return !(0, $533f826bbc418791$export$bedb7023a7733221)(value);
}
function $0b747974b0bb3563$export$f60443f194e40bc2(name) {
    var value = name;
    if (value && (0, $533f826bbc418791$export$844ec244b1367d54)(value)) {
        // CamelCase everything after the "-" and remove the dash
        value = value[0, $1ae5573ce493bccc$export$ef9ef3ed86c4485 /* @min:%2ereplace */ ]($0b747974b0bb3563$var$rCamelCase, function(_all, letter) {
            return letter.toUpperCase();
        });
        value = value[0, $1ae5573ce493bccc$export$ef9ef3ed86c4485 /* @min:%2ereplace */ ]($0b747974b0bb3563$var$rNormalizeInvalid, "_");
        value = value[0, $1ae5573ce493bccc$export$ef9ef3ed86c4485 /* @min:%2ereplace */ ]($0b747974b0bb3563$var$rLeadingNumeric, function(_all, match) {
            return "_" + match;
        });
    }
    return value;
}
function $0b747974b0bb3563$export$3185d777c612e61f(value, search) {
    if (value && search) return (0, $0194d45a55d79548$export$7c0888b0c4641088)(value, search) !== -1;
    return false;
}
function $0b747974b0bb3563$export$dfaaa8705752128f(date) {
    return date && date.toISOString() || "";
}
var $0b747974b0bb3563$export$7e32b29e1cb162e1 = (0, $36a077d9f4439b69$export$a15782d21797da4c);
function $0b747974b0bb3563$export$39c4487b36c98fec(object) {
    if ((0, $533f826bbc418791$export$e6127cc7fe7395c3)(object)) return object[0, $1ae5573ce493bccc$export$9734b0a24bf02e93 /* @min:%2ename */ ];
    return 0, $9fe4a5d5204a4cff$export$5e8607ab26634759;
}
function $0b747974b0bb3563$export$80746c6bc6142fc8(target, field, value, valChk, srcChk) {
    var theValue = value;
    if (target) {
        theValue = target[field];
        if (theValue !== value && (!srcChk || srcChk(theValue)) && (!valChk || valChk(value))) {
            theValue = value;
            target[field] = theValue;
        }
    }
    return theValue;
}
function $0b747974b0bb3563$export$51417ccc212471e(target, field, defValue) {
    var theValue;
    if (target) {
        theValue = target[field];
        if (!theValue && (0, $533f826bbc418791$export$bedb7023a7733221)(theValue)) {
            // Supports having the default as null
            theValue = !(0, $533f826bbc418791$export$fce6876652108ab)(defValue) ? defValue : {};
            target[field] = theValue;
        }
    } else // Expanded for performance so we only check defValue if required
    theValue = !(0, $533f826bbc418791$export$fce6876652108ab)(defValue) ? defValue : {};
    return theValue;
}
function $0b747974b0bb3563$var$_createProxyFunction(source, funcName) {
    var srcFunc = null;
    var src = null;
    if ((0, $533f826bbc418791$export$f6e2535fb5126e54)(source)) srcFunc = source;
    else src = source;
    return function() {
        // Capture the original arguments passed to the method
        var originalArguments = arguments;
        if (srcFunc) src = srcFunc();
        if (src) return src[funcName][0, $1ae5573ce493bccc$export$2f85ca6962b15ff8 /* @min:%2eapply */ ](src, originalArguments);
    };
}
function $0b747974b0bb3563$export$21c1f632458708da(target, source, chkSet) {
    if (target && source && (0, $533f826bbc418791$export$a6cdc56e425d0d0a)(target) && (0, $533f826bbc418791$export$a6cdc56e425d0d0a)(source)) {
        var _loop_1 = function(field) {
            if ((0, $533f826bbc418791$export$844ec244b1367d54)(field)) {
                var value = source[field];
                if ((0, $533f826bbc418791$export$f6e2535fb5126e54)(value)) {
                    if (!chkSet || chkSet(field, true, source, target)) // Create a proxy function rather than just copying the (possible) prototype to the new object as an instance function
                    target[field] = $0b747974b0bb3563$var$_createProxyFunction(source, field);
                } else if (!chkSet || chkSet(field, false, source, target)) {
                    if ((0, $08325aa6d8565cc0$export$34e6b98f73578a9c)(target, field)) // Remove any previous instance property
                    delete target[field];
                    (0, $d212d948d25f959a$export$d0d2ebf910ad6e2)(target, field, {
                        g: function() {
                            return source[field];
                        },
                        s: function(theValue) {
                            source[field] = theValue;
                        }
                    });
                }
            }
        };
        // effectively apply/proxy full source to the target instance
        for(var field in source)_loop_1(field);
    }
    return target;
}
function $0b747974b0bb3563$export$5dd8d245f6f94a18(target, name, source, theFunc, overwriteTarget) {
    if (target && name && source) {
        if (overwriteTarget !== false || (0, $533f826bbc418791$export$fce6876652108ab)(target[name])) target[name] = $0b747974b0bb3563$var$_createProxyFunction(source, theFunc);
    }
}
function $0b747974b0bb3563$export$94f4c7fb7e7d8dc7(target, source, functionsToProxy, overwriteTarget) {
    if (target && source && (0, $533f826bbc418791$export$a6cdc56e425d0d0a)(target) && (0, $533f826bbc418791$export$43bee75e5e14138e)(functionsToProxy)) (0, $f6bb085f8cf12216$export$e2e5bcdbdc49c586)(functionsToProxy, function(theFuncName) {
        if ((0, $533f826bbc418791$export$844ec244b1367d54)(theFuncName)) $0b747974b0bb3563$export$5dd8d245f6f94a18(target, theFuncName, source, theFuncName, overwriteTarget);
    });
    return target;
}
function $0b747974b0bb3563$export$f0facb5bce2741f0(defaults) {
    return /** @class */ function() {
        function class_1() {
            var _this = this;
            if (defaults) (0, $45e528077703ac0c$export$aa0705d5774c95d1)(defaults, function(field, value) {
                _this[field] = value;
            });
        }
        return class_1;
    }();
}
function $0b747974b0bb3563$export$3e03fa3fc3e422d7(theObject) {
    // V8 Optimization to cause the JIT compiler to create a new optimized object for looking up the own properties
    // primarily for object with <= 19 properties for >= 20 the effect is reduced or non-existent
    if (theObject && (0, $36a077d9f4439b69$export$afe328edc487dcfe)) theObject = (0, $67b827af57eed1eb$export$9ec954dd81c90a5d)((0, $36a077d9f4439b69$export$afe328edc487dcfe)({}, theObject));
    return theObject;
}
function $0b747974b0bb3563$export$a7f7e50f928053df(obj1, obj2, obj3, obj4, obj5, obj6) {
    // Variables
    var theArgs = arguments;
    var extended = theArgs[0] || {};
    var argLen = theArgs[0, $1ae5573ce493bccc$export$6eae51590aaea43 /* @min:%2elength */ ];
    var deep = false;
    var idx = 1;
    // Check for "Deep" flag
    if (argLen > 0 && (0, $533f826bbc418791$export$f9ce7b637dfbe238)(extended)) {
        deep = extended;
        extended = theArgs[idx] || {};
        idx++;
    }
    // Handle case when target is a string or something (possible in deep copy)
    if (!(0, $533f826bbc418791$export$a6cdc56e425d0d0a)(extended)) extended = {};
    // Loop through each remaining object and conduct a merge
    for(; idx < argLen; idx++){
        var arg = theArgs[idx];
        var isArgArray = (0, $533f826bbc418791$export$43bee75e5e14138e)(arg);
        var isArgObj = (0, $533f826bbc418791$export$a6cdc56e425d0d0a)(arg);
        for(var prop in arg){
            var propOk = isArgArray && prop in arg || isArgObj && (0, $08325aa6d8565cc0$export$34e6b98f73578a9c)(arg, prop);
            if (!propOk) continue;
            var newValue = arg[prop];
            var isNewArray = void 0;
            // If deep merge and property is an object, merge properties
            if (deep && newValue && ((isNewArray = (0, $533f826bbc418791$export$43bee75e5e14138e)(newValue)) || (0, $a339b44c6e62d324$export$53b83ca8eaab0383)(newValue))) {
                // Grab the current value of the extended object
                var clone = extended[prop];
                if (isNewArray) {
                    if (!(0, $533f826bbc418791$export$43bee75e5e14138e)(clone)) // We can't "merge" an array with a non-array so overwrite the original
                    clone = [];
                } else if (!(0, $a339b44c6e62d324$export$53b83ca8eaab0383)(clone)) // We can't "merge" an object with a non-object
                clone = {};
                // Never move the original objects always clone them
                newValue = $0b747974b0bb3563$export$a7f7e50f928053df(deep, clone, newValue);
            }
            // Assign the new (or previous) value (unless undefined)
            if (newValue !== undefined) extended[prop] = newValue;
        }
    }
    return extended;
}
var $0b747974b0bb3563$export$590567be997858b6 = (0, $d813f4522b40a37e$export$590567be997858b6);



"use strict";
/**
 * This file exists to hold environment utilities that are required to check and
 * validate the current operating environment. Unless otherwise required, please
 * only use defined methods (functions) in this class so that users of these
 * functions/properties only need to include those that are used within their own modules.
 */ var $0c599844349363c4$var$strDocumentMode = "documentMode";
var $0c599844349363c4$var$strLocation = "location";
var $0c599844349363c4$var$strConsole = "console";
var $0c599844349363c4$var$strPerformance = "performance";
var $0c599844349363c4$var$strJSON = "JSON";
var $0c599844349363c4$var$strCrypto = "crypto";
var $0c599844349363c4$var$strMsCrypto = "msCrypto";
var $0c599844349363c4$var$strReactNative = "ReactNative";
var $0c599844349363c4$var$strMsie = "msie";
var $0c599844349363c4$var$strTrident = "trident/";
var $0c599844349363c4$var$strXMLHttpRequest = "XMLHttpRequest";
var $0c599844349363c4$var$_isTrident = null;
var $0c599844349363c4$var$_navUserAgentCheck = null;
var $0c599844349363c4$var$_enableMocks = false;
var $0c599844349363c4$var$_useXDomainRequest = null;
var $0c599844349363c4$var$_beaconsSupported = null;
function $0c599844349363c4$var$_hasProperty(theClass, property) {
    var supported = false;
    if (theClass) {
        try {
            supported = property in theClass;
            if (!supported) {
                var proto = theClass[0, $67b827af57eed1eb$export$ecddaaeb55ecf049];
                if (proto) supported = property in proto;
            }
        } catch (e) {
        // Do Nothing
        }
        if (!supported) try {
            var tmp = new theClass();
            supported = !(0, $533f826bbc418791$export$fce6876652108ab)(tmp[property]);
        } catch (e) {
        // Do Nothing
        }
    }
    return supported;
}
function $0c599844349363c4$export$6b8934f3c937d22f(enabled) {
    $0c599844349363c4$var$_enableMocks = enabled;
}
function $0c599844349363c4$export$e7fd20fad3cf4b5f(checkForMock) {
    if (checkForMock && $0c599844349363c4$var$_enableMocks) {
        var mockLocation = (0, $3d5fcb60a9467a45$export$3df6e51375017edd)("__mockLocation");
        if (mockLocation) return mockLocation;
    }
    if (typeof location === (0, $67b827af57eed1eb$export$127e9c2439c2ee16) && location) return location;
    return (0, $3d5fcb60a9467a45$export$3df6e51375017edd)($0c599844349363c4$var$strLocation);
}
function $0c599844349363c4$export$bbe488cec1edd401() {
    if (typeof console !== (0, $67b827af57eed1eb$export$9b7d2d86cf58b987)) return console;
    return (0, $3d5fcb60a9467a45$export$3df6e51375017edd)($0c599844349363c4$var$strConsole);
}
function $0c599844349363c4$export$a2856ab6913b9fff() {
    return Boolean(typeof JSON === (0, $67b827af57eed1eb$export$127e9c2439c2ee16) && JSON || (0, $3d5fcb60a9467a45$export$3df6e51375017edd)($0c599844349363c4$var$strJSON) !== null);
}
function $0c599844349363c4$export$d047a7c56db64af4() {
    if ($0c599844349363c4$export$a2856ab6913b9fff()) return JSON || (0, $3d5fcb60a9467a45$export$3df6e51375017edd)($0c599844349363c4$var$strJSON);
    return null;
}
function $0c599844349363c4$export$e003cc239f955cb6() {
    return (0, $3d5fcb60a9467a45$export$3df6e51375017edd)($0c599844349363c4$var$strCrypto);
}
function $0c599844349363c4$export$6bc5093edbd2ea6() {
    return (0, $3d5fcb60a9467a45$export$3df6e51375017edd)($0c599844349363c4$var$strMsCrypto);
}
function $0c599844349363c4$export$f7a1e23e542d38e3() {
    // If running in React Native, navigator.product will be populated
    var nav = (0, $3d5fcb60a9467a45$export$a56241c767c1d89f)();
    if (nav && nav.product) return nav.product === $0c599844349363c4$var$strReactNative;
    return false;
}
function $0c599844349363c4$export$7e7b1a9668aaed8() {
    var nav = (0, $3d5fcb60a9467a45$export$a56241c767c1d89f)();
    if (nav && (nav[0, $1ae5573ce493bccc$export$2e850152cb3355e2 /* @min:%2euserAgent */ ] !== $0c599844349363c4$var$_navUserAgentCheck || $0c599844349363c4$var$_isTrident === null)) {
        // Added to support test mocking of the user agent
        $0c599844349363c4$var$_navUserAgentCheck = nav[0, $1ae5573ce493bccc$export$2e850152cb3355e2 /* @min:%2euserAgent */ ];
        var userAgent = ($0c599844349363c4$var$_navUserAgentCheck || (0, $9fe4a5d5204a4cff$export$5e8607ab26634759))[0, $1ae5573ce493bccc$export$e4eaee9e01d9baaa /* @min:%2etoLowerCase */ ]();
        $0c599844349363c4$var$_isTrident = (0, $0b747974b0bb3563$export$3185d777c612e61f)(userAgent, $0c599844349363c4$var$strMsie) || (0, $0b747974b0bb3563$export$3185d777c612e61f)(userAgent, $0c599844349363c4$var$strTrident);
    }
    return $0c599844349363c4$var$_isTrident;
}
function $0c599844349363c4$export$eb7ff627fa81c42e(userAgentStr) {
    if (userAgentStr === void 0) userAgentStr = null;
    if (!userAgentStr) {
        var navigator_1 = (0, $3d5fcb60a9467a45$export$a56241c767c1d89f)() || {};
        userAgentStr = navigator_1 ? (navigator_1.userAgent || (0, $9fe4a5d5204a4cff$export$5e8607ab26634759))[0, $1ae5573ce493bccc$export$e4eaee9e01d9baaa /* @min:%2etoLowerCase */ ]() : (0, $9fe4a5d5204a4cff$export$5e8607ab26634759);
    }
    var ua = (userAgentStr || (0, $9fe4a5d5204a4cff$export$5e8607ab26634759))[0, $1ae5573ce493bccc$export$e4eaee9e01d9baaa /* @min:%2etoLowerCase */ ]();
    // Also check for documentMode in case X-UA-Compatible meta tag was included in HTML.
    if ((0, $0b747974b0bb3563$export$3185d777c612e61f)(ua, $0c599844349363c4$var$strMsie)) {
        var doc = (0, $3d5fcb60a9467a45$export$f65ca476c09acec0)() || {};
        return Math.max(parseInt(ua[0, $1ae5573ce493bccc$export$b889f1d4cb07c706 /* @min:%2esplit */ ]($0c599844349363c4$var$strMsie)[1]), doc[$0c599844349363c4$var$strDocumentMode] || 0);
    } else if ((0, $0b747974b0bb3563$export$3185d777c612e61f)(ua, $0c599844349363c4$var$strTrident)) {
        var tridentVer = parseInt(ua[0, $1ae5573ce493bccc$export$b889f1d4cb07c706 /* @min:%2esplit */ ]($0c599844349363c4$var$strTrident)[1]);
        if (tridentVer) return tridentVer + 4;
    }
    return null;
}
function $0c599844349363c4$export$95df08bae54cb4df(userAgentStr) {
    if (!userAgentStr || !(0, $533f826bbc418791$export$844ec244b1367d54)(userAgentStr)) {
        var navigator_2 = (0, $3d5fcb60a9467a45$export$a56241c767c1d89f)() || {};
        userAgentStr = navigator_2 ? (navigator_2.userAgent || (0, $9fe4a5d5204a4cff$export$5e8607ab26634759))[0, $1ae5573ce493bccc$export$e4eaee9e01d9baaa /* @min:%2etoLowerCase */ ]() : (0, $9fe4a5d5204a4cff$export$5e8607ab26634759);
    }
    var ua = (userAgentStr || (0, $9fe4a5d5204a4cff$export$5e8607ab26634759))[0, $1ae5573ce493bccc$export$e4eaee9e01d9baaa /* @min:%2etoLowerCase */ ]();
    return (0, $0194d45a55d79548$export$7c0888b0c4641088)(ua, "safari") >= 0;
}
function $0c599844349363c4$export$cf496c79c05967a0() {
    if ($0c599844349363c4$var$_beaconsSupported === null) $0c599844349363c4$var$_beaconsSupported = (0, $3d5fcb60a9467a45$export$bd82d106260417bf)() && Boolean((0, $3d5fcb60a9467a45$export$a56241c767c1d89f)().sendBeacon);
    return $0c599844349363c4$var$_beaconsSupported;
}
function $0c599844349363c4$export$f8c1c61350d9749(withKeepAlive) {
    var isSupported = false;
    try {
        isSupported = !!(0, $3d5fcb60a9467a45$export$3df6e51375017edd)("fetch");
        var request = (0, $3d5fcb60a9467a45$export$3df6e51375017edd)("Request");
        if (isSupported && withKeepAlive && request) isSupported = $0c599844349363c4$var$_hasProperty(request, "keepalive");
    } catch (e) {
    // Just Swallow any failure during availability checks
    }
    return isSupported;
}
function $0c599844349363c4$export$b9f2bc09e5ac0fa5() {
    if ($0c599844349363c4$var$_useXDomainRequest === null) {
        $0c599844349363c4$var$_useXDomainRequest = typeof XDomainRequest !== (0, $67b827af57eed1eb$export$9b7d2d86cf58b987);
        if ($0c599844349363c4$var$_useXDomainRequest && $0c599844349363c4$export$cfeac9aa070f0108()) $0c599844349363c4$var$_useXDomainRequest = $0c599844349363c4$var$_useXDomainRequest && !$0c599844349363c4$var$_hasProperty((0, $3d5fcb60a9467a45$export$3df6e51375017edd)($0c599844349363c4$var$strXMLHttpRequest), "withCredentials");
    }
    return $0c599844349363c4$var$_useXDomainRequest;
}
function $0c599844349363c4$export$cfeac9aa070f0108() {
    var isSupported = false;
    try {
        var xmlHttpRequest = (0, $3d5fcb60a9467a45$export$3df6e51375017edd)($0c599844349363c4$var$strXMLHttpRequest);
        isSupported = !!xmlHttpRequest;
    } catch (e) {
    // Just Swallow any failure during availability checks
    }
    return isSupported;
}
function $0c599844349363c4$var$_getNamedValue(values, name) {
    if (values) for(var i = 0; i < values[0, $1ae5573ce493bccc$export$6eae51590aaea43 /* @min:%2elength */ ]; i++){
        var value = values[i];
        if (value[0, $1ae5573ce493bccc$export$9734b0a24bf02e93 /* @min:%2ename */ ]) {
            if (value[0, $1ae5573ce493bccc$export$9734b0a24bf02e93 /* @min:%2ename */ ] === name) return value;
        }
    }
    return {};
}
function $0c599844349363c4$export$cdb9869d6805c74f(name) {
    var doc = (0, $3d5fcb60a9467a45$export$f65ca476c09acec0)();
    if (doc && name) // Look for a meta-tag
    return $0c599844349363c4$var$_getNamedValue(doc.querySelectorAll("meta"), name).content;
    return null;
}
function $0c599844349363c4$export$a25efeeb107534e6(name) {
    var value;
    var perf = (0, $824d7bc9d9e48f68$export$28a0276e10aa78d7)();
    if (perf) {
        // Try looking for a server-timing header
        var navPerf = perf.getEntriesByType("navigation") || [];
        value = $0c599844349363c4$var$_getNamedValue((navPerf[0, $1ae5573ce493bccc$export$6eae51590aaea43 /* @min:%2elength */ ] > 0 ? navPerf[0] : {}).serverTiming, name).description;
    }
    return value;
}



var $dd28c90c4d15de9c$var$UInt32Mask = 0x100000000;
var $dd28c90c4d15de9c$var$MaxUInt32 = 0xffffffff;
var $dd28c90c4d15de9c$var$SEED1 = 123456789;
var $dd28c90c4d15de9c$var$SEED2 = 987654321;
// MWC based Random generator (for IE)
var $dd28c90c4d15de9c$var$_mwcSeeded = false;
var $dd28c90c4d15de9c$var$_mwcW = $dd28c90c4d15de9c$var$SEED1;
var $dd28c90c4d15de9c$var$_mwcZ = $dd28c90c4d15de9c$var$SEED2;
// Takes any integer
function $dd28c90c4d15de9c$var$_mwcSeed(seedValue) {
    if (seedValue < 0) // Make sure we end up with a positive number and not -ve one.
    seedValue >>>= 0;
    $dd28c90c4d15de9c$var$_mwcW = $dd28c90c4d15de9c$var$SEED1 + seedValue & $dd28c90c4d15de9c$var$MaxUInt32;
    $dd28c90c4d15de9c$var$_mwcZ = $dd28c90c4d15de9c$var$SEED2 - seedValue & $dd28c90c4d15de9c$var$MaxUInt32;
    $dd28c90c4d15de9c$var$_mwcSeeded = true;
}
function $dd28c90c4d15de9c$var$_autoSeedMwc() {
    // Simple initialization using default Math.random() - So we inherit any entropy from the browser
    // and bitwise XOR with the current milliseconds
    try {
        var now = (0, $628cad25a0769458$export$a56f095995763cca)() & 0x7fffffff;
        $dd28c90c4d15de9c$var$_mwcSeed((Math.random() * $dd28c90c4d15de9c$var$UInt32Mask ^ now) + now);
    } catch (e) {
    // Don't crash if something goes wrong
    }
}
function $dd28c90c4d15de9c$export$b2cfcb5c32671fa4(maxValue) {
    if (maxValue > 0) return Math.floor($dd28c90c4d15de9c$export$aec042b223b6f5f9() / $dd28c90c4d15de9c$var$MaxUInt32 * (maxValue + 1)) >>> 0;
    return 0;
}
function $dd28c90c4d15de9c$export$aec042b223b6f5f9(signed) {
    var value = 0;
    var c = (0, $0c599844349363c4$export$e003cc239f955cb6)() || (0, $0c599844349363c4$export$6bc5093edbd2ea6)();
    if (c && c.getRandomValues) // Make sure the number is converted into the specified range (-0x80000000..0x7FFFFFFF)
    value = c.getRandomValues(new Uint32Array(1))[0] & $dd28c90c4d15de9c$var$MaxUInt32;
    if (value === 0 && (0, $0c599844349363c4$export$7e7b1a9668aaed8)()) {
        // For IE 6, 7, 8 (especially on XP) Math.random is not very random
        if (!$dd28c90c4d15de9c$var$_mwcSeeded) // Set the seed for the Mwc algorithm
        $dd28c90c4d15de9c$var$_autoSeedMwc();
        // Don't use Math.random for IE
        // Make sure the number is converted into the specified range (-0x80000000..0x7FFFFFFF)
        value = $dd28c90c4d15de9c$export$3ffb74f7babdd68f() & $dd28c90c4d15de9c$var$MaxUInt32;
    }
    if (value === 0) // Make sure the number is converted into the specified range (-0x80000000..0x7FFFFFFF)
    value = Math.floor($dd28c90c4d15de9c$var$UInt32Mask * Math.random() | 0);
    if (!signed) // Make sure we end up with a positive number and not -ve one.
    value >>>= 0;
    return value;
}
function $dd28c90c4d15de9c$export$195aff7adbfe974f(value) {
    if (!value) $dd28c90c4d15de9c$var$_autoSeedMwc();
    else $dd28c90c4d15de9c$var$_mwcSeed(value);
}
function $dd28c90c4d15de9c$export$3ffb74f7babdd68f(signed) {
    $dd28c90c4d15de9c$var$_mwcZ = 36969 * ($dd28c90c4d15de9c$var$_mwcZ & 0xFFFF) + ($dd28c90c4d15de9c$var$_mwcZ >> 16) & $dd28c90c4d15de9c$var$MaxUInt32;
    $dd28c90c4d15de9c$var$_mwcW = 18000 * ($dd28c90c4d15de9c$var$_mwcW & 0xFFFF) + ($dd28c90c4d15de9c$var$_mwcW >> 16) & $dd28c90c4d15de9c$var$MaxUInt32;
    var value = ($dd28c90c4d15de9c$var$_mwcZ << 16) + ($dd28c90c4d15de9c$var$_mwcW & 0xFFFF) >>> 0 & $dd28c90c4d15de9c$var$MaxUInt32 | 0;
    if (!signed) // Make sure we end up with a positive number and not -ve one.
    value >>>= 0;
    return value;
}
function $dd28c90c4d15de9c$export$9ffd10a3fbdc175b(maxLength) {
    if (maxLength === void 0) maxLength = 22;
    var base64chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    // Start with an initial random number, consuming the value in reverse byte order
    var number = $dd28c90c4d15de9c$export$aec042b223b6f5f9() >>> 0; // Make sure it's a +ve number
    var chars = 0;
    var result = (0, $9fe4a5d5204a4cff$export$5e8607ab26634759);
    while(result[0, $1ae5573ce493bccc$export$6eae51590aaea43 /* @min:%2elength */ ] < maxLength){
        chars++;
        result += base64chars.charAt(number & 0x3F);
        number >>>= 6; // Zero fill with right shift
        if (chars === 5) {
            // 5 base64 characters === 30 bits so we don't have enough bits for another base64 char
            // So add on another 30 bits and make sure it's +ve
            number = ($dd28c90c4d15de9c$export$aec042b223b6f5f9() << 2 & 0xFFFFFFFF | number & 0x03) >>> 0;
            chars = 0; // We need to reset the number every 5 chars (30 bits)
        }
    }
    return result;
}


"use strict";
var $945e40d4195d77bb$export$3bac393b8225adab = (0, $67b827af57eed1eb$export$9b7d2d86cf58b987);
function $945e40d4195d77bb$export$665eeb3ced5fba0b() {
    var uuid = $945e40d4195d77bb$export$58d1fad45f39d957();
    return (0, $c3f3bf8012a4b2d4$export$9d1aa7361d7a6e87)(uuid, 0, 8) + "-" + (0, $c3f3bf8012a4b2d4$export$9d1aa7361d7a6e87)(uuid, 8, 12) + "-" + (0, $c3f3bf8012a4b2d4$export$9d1aa7361d7a6e87)(uuid, 12, 16) + "-" + (0, $c3f3bf8012a4b2d4$export$9d1aa7361d7a6e87)(uuid, 16, 20) + "-" + (0, $c3f3bf8012a4b2d4$export$9d1aa7361d7a6e87)(uuid, 20);
}
function $945e40d4195d77bb$export$5222b9460f3ddbec(value, search) {
    if (value && search) {
        var len = value[0, $1ae5573ce493bccc$export$6eae51590aaea43 /* @min:%2elength */ ];
        var start = len - search[0, $1ae5573ce493bccc$export$6eae51590aaea43 /* @min:%2elength */ ];
        return (0, $c3f3bf8012a4b2d4$export$9d1aa7361d7a6e87)(value, start >= 0 ? start : 0, len) === search;
    }
    return false;
}
function $945e40d4195d77bb$export$58d1fad45f39d957() {
    var hexValues = [
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "a",
        "b",
        "c",
        "d",
        "e",
        "f"
    ];
    // rfc4122 version 4 UUID without dashes and with lowercase letters
    var oct = (0, $9fe4a5d5204a4cff$export$5e8607ab26634759), tmp;
    for(var a = 0; a < 4; a++){
        tmp = (0, $dd28c90c4d15de9c$export$aec042b223b6f5f9)();
        oct += hexValues[tmp & 0xF] + hexValues[tmp >> 4 & 0xF] + hexValues[tmp >> 8 & 0xF] + hexValues[tmp >> 12 & 0xF] + hexValues[tmp >> 16 & 0xF] + hexValues[tmp >> 20 & 0xF] + hexValues[tmp >> 24 & 0xF] + hexValues[tmp >> 28 & 0xF];
    }
    // "Set the two most significant bits (bits 6 and 7) of the clock_seq_hi_and_reserved to zero and one, respectively"
    var clockSequenceHi = hexValues[8 + ((0, $dd28c90c4d15de9c$export$aec042b223b6f5f9)() & 0x03) | 0];
    return (0, $c3f3bf8012a4b2d4$export$25b2a9bb66b0078d)(oct, 0, 8) + (0, $c3f3bf8012a4b2d4$export$25b2a9bb66b0078d)(oct, 9, 4) + "4" + (0, $c3f3bf8012a4b2d4$export$25b2a9bb66b0078d)(oct, 13, 3) + clockSequenceHi + (0, $c3f3bf8012a4b2d4$export$25b2a9bb66b0078d)(oct, 16, 3) + (0, $c3f3bf8012a4b2d4$export$25b2a9bb66b0078d)(oct, 19, 12);
}




// using {0,16} for leading and trailing whitespace just to constrain the possible runtime of a random string
var $6f47dad7a26666b5$var$TRACE_PARENT_REGEX = /^([\da-f]{2})-([\da-f]{32})-([\da-f]{16})-([\da-f]{2})(-[^\s]{1,64})?$/i;
var $6f47dad7a26666b5$var$DEFAULT_VERSION = "00";
var $6f47dad7a26666b5$var$INVALID_VERSION = "ff";
var $6f47dad7a26666b5$var$INVALID_TRACE_ID = "00000000000000000000000000000000";
var $6f47dad7a26666b5$var$INVALID_SPAN_ID = "0000000000000000";
var $6f47dad7a26666b5$var$SAMPLED_FLAG = 0x01;
function $6f47dad7a26666b5$var$_isValid(value, len, invalidValue) {
    if (value && value[0, $1ae5573ce493bccc$export$6eae51590aaea43 /* @min:%2elength */ ] === len && value !== invalidValue) return !!value.match(/^[\da-f]*$/i);
    return false;
}
function $6f47dad7a26666b5$var$_formatValue(value, len, defValue) {
    if ($6f47dad7a26666b5$var$_isValid(value, len)) return value;
    return defValue;
}
function $6f47dad7a26666b5$var$_formatFlags(value) {
    if (isNaN(value) || value < 0 || value > 255) value = 0x01;
    var result = value.toString(16);
    while(result[0, $1ae5573ce493bccc$export$6eae51590aaea43 /* @min:%2elength */ ] < 2)result = "0" + result;
    return result;
}
function $6f47dad7a26666b5$export$2f21fe23413fe96b(traceId, spanId, flags, version) {
    var _a;
    return _a = {}, _a[0, $1ae5573ce493bccc$export$568c4302d11f2b22 /* @min:version */ ] = $6f47dad7a26666b5$var$_isValid(version, 2, $6f47dad7a26666b5$var$INVALID_VERSION) ? version : $6f47dad7a26666b5$var$DEFAULT_VERSION, _a[0, $1ae5573ce493bccc$export$a5eb52c53bba8560 /* @min:traceId */ ] = $6f47dad7a26666b5$export$29dd34cf1269f6da(traceId) ? traceId : (0, $945e40d4195d77bb$export$58d1fad45f39d957)(), _a[0, $1ae5573ce493bccc$export$c105b94efa183847 /* @min:spanId */ ] = $6f47dad7a26666b5$export$8e51c6d8f0586aff(spanId) ? spanId : (0, $c3f3bf8012a4b2d4$export$a1120f14ec6f7ada)((0, $945e40d4195d77bb$export$58d1fad45f39d957)(), 16), _a.traceFlags = flags >= 0 && flags <= 0xFF ? flags : 1, _a;
}
function $6f47dad7a26666b5$export$f4d87f8901a93f5d(value) {
    var _a;
    if (!value) // Don't pass a null/undefined or empty string
    return null;
    if ((0, $533f826bbc418791$export$43bee75e5e14138e)(value)) // The value may have been encoded on the page into an array so handle this automatically
    value = value[0] || "";
    if (!value || !(0, $533f826bbc418791$export$844ec244b1367d54)(value) || value[0, $1ae5573ce493bccc$export$6eae51590aaea43 /* @min:%2elength */ ] > 8192) // limit potential processing based on total length
    return null;
    // See https://www.w3.org/TR/trace-context/#versioning-of-traceparent
    var match = $6f47dad7a26666b5$var$TRACE_PARENT_REGEX.exec((0, $f67365b40c49b6c1$export$ef0e11c5f5f351f7)(value));
    if (!match || // No match
    match[1] === $6f47dad7a26666b5$var$INVALID_VERSION || // version ff is forbidden
    match[2] === $6f47dad7a26666b5$var$INVALID_TRACE_ID || // All zeros is considered to be invalid
    match[3] === $6f47dad7a26666b5$var$INVALID_SPAN_ID) return null;
    return _a = {
        version: (match[1] || (0, $9fe4a5d5204a4cff$export$5e8607ab26634759))[0, $1ae5573ce493bccc$export$e4eaee9e01d9baaa /* @min:%2etoLowerCase */ ](),
        traceId: (match[2] || (0, $9fe4a5d5204a4cff$export$5e8607ab26634759))[0, $1ae5573ce493bccc$export$e4eaee9e01d9baaa /* @min:%2etoLowerCase */ ](),
        spanId: (match[3] || (0, $9fe4a5d5204a4cff$export$5e8607ab26634759))[0, $1ae5573ce493bccc$export$e4eaee9e01d9baaa /* @min:%2etoLowerCase */ ]()
    }, _a[0, $1ae5573ce493bccc$export$4e92e4b92b41ba2d /* @min:traceFlags */ ] = parseInt(match[4], 16), _a;
}
function $6f47dad7a26666b5$export$29dd34cf1269f6da(value) {
    return $6f47dad7a26666b5$var$_isValid(value, 32, $6f47dad7a26666b5$var$INVALID_TRACE_ID);
}
function $6f47dad7a26666b5$export$8e51c6d8f0586aff(value) {
    return $6f47dad7a26666b5$var$_isValid(value, 16, $6f47dad7a26666b5$var$INVALID_SPAN_ID);
}
function $6f47dad7a26666b5$export$a210ed246a03bbf(value) {
    if (!value || !$6f47dad7a26666b5$var$_isValid(value[0, $1ae5573ce493bccc$export$568c4302d11f2b22 /* @min:%2eversion */ ], 2, $6f47dad7a26666b5$var$INVALID_VERSION) || !$6f47dad7a26666b5$var$_isValid(value[0, $1ae5573ce493bccc$export$a5eb52c53bba8560 /* @min:%2etraceId */ ], 32, $6f47dad7a26666b5$var$INVALID_TRACE_ID) || !$6f47dad7a26666b5$var$_isValid(value[0, $1ae5573ce493bccc$export$c105b94efa183847 /* @min:%2espanId */ ], 16, $6f47dad7a26666b5$var$INVALID_SPAN_ID) || !$6f47dad7a26666b5$var$_isValid($6f47dad7a26666b5$var$_formatFlags(value[0, $1ae5573ce493bccc$export$4e92e4b92b41ba2d /* @min:%2etraceFlags */ ]), 2)) // Each known field must contain a valid value
    return false;
    return true;
}
function $6f47dad7a26666b5$export$8577d514cd55191e(value) {
    if ($6f47dad7a26666b5$export$a210ed246a03bbf(value)) return (value[0, $1ae5573ce493bccc$export$4e92e4b92b41ba2d /* @min:%2etraceFlags */ ] & $6f47dad7a26666b5$var$SAMPLED_FLAG) === $6f47dad7a26666b5$var$SAMPLED_FLAG;
    return false;
}
function $6f47dad7a26666b5$export$55f8c39d2c902d0d(value) {
    if (value) {
        // Special Note: This only supports formatting as version 00, future versions should encode any known supported version
        // So parsing a future version will populate the correct version value but reformatting will reduce it to version 00.
        var flags = $6f47dad7a26666b5$var$_formatFlags(value[0, $1ae5573ce493bccc$export$4e92e4b92b41ba2d /* @min:%2etraceFlags */ ]);
        if (!$6f47dad7a26666b5$var$_isValid(flags, 2)) flags = "01";
        var version = value[0, $1ae5573ce493bccc$export$568c4302d11f2b22 /* @min:%2eversion */ ] || $6f47dad7a26666b5$var$DEFAULT_VERSION;
        if (version !== "00" && version !== "ff") // Reduce version to "00"
        version = $6f47dad7a26666b5$var$DEFAULT_VERSION;
        // Format as version 00
        return "".concat(version.toLowerCase(), "-").concat($6f47dad7a26666b5$var$_formatValue(value.traceId, 32, $6f47dad7a26666b5$var$INVALID_TRACE_ID).toLowerCase(), "-").concat($6f47dad7a26666b5$var$_formatValue(value.spanId, 16, $6f47dad7a26666b5$var$INVALID_SPAN_ID).toLowerCase(), "-").concat(flags.toLowerCase());
    }
    return "";
}
function $6f47dad7a26666b5$export$2a00dfdbe257ef74() {
    var name = "traceparent";
    var traceParent = $6f47dad7a26666b5$export$f4d87f8901a93f5d((0, $0c599844349363c4$export$cdb9869d6805c74f)(name));
    if (!traceParent) traceParent = $6f47dad7a26666b5$export$f4d87f8901a93f5d((0, $0c599844349363c4$export$a25efeeb107534e6)(name));
    return traceParent;
}



/*
 * Application Insights JavaScript SDK - Common, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ /**
 * This is an internal property used to cause internal (reporting) requests to be ignored from reporting
 * additional telemetry, to handle polyfil implementations ALL urls used with a disabled request will
 * also be ignored for future requests even when this property is not provided.
 * Tagging as Ignore as this is an internal value and is not expected to be used outside of the SDK
 * @ignore
 */ var $71dfba5ea0640485$export$7c6abff2f2bdd9c0 = "Microsoft_ApplicationInsights_BypassAjaxInstrumentation";
var $71dfba5ea0640485$export$dc288b6444e20c04 = "sampleRate";
var $71dfba5ea0640485$export$ea8a69bf327def66 = "ProcessLegacy";
var $71dfba5ea0640485$export$8343e6f32f5246de = "http.method";
var $71dfba5ea0640485$export$5c9ec0fce655ebcf = "https://dc.services.visualstudio.com";
var $71dfba5ea0640485$export$e6c0f3431c6cd728 = "/v2/track";
var $71dfba5ea0640485$export$4003f5e1672d759 = "not_specified";
var $71dfba5ea0640485$export$7d566319b90dbb26 = "iKey";


/*
 * Application Insights JavaScript SDK - Common, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ /*
 * Application Insights JavaScript SDK - Core, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ /*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */ /*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */ 
function $51d848565ca908fc$export$8557db26cff37a74(values, keyType, valueType, completeFn) {
    var theMap = {};
    (0, $45e528077703ac0c$export$aa0705d5774c95d1)(values, function(key, value) {
        theMap[key] = keyType ? value : key;
        theMap[value] = valueType ? value : key;
    });
    return completeFn(theMap);
}




function $1a927735c653b0c3$export$37b2eedf6b7b231a(values) {
    return (0, $51d848565ca908fc$export$8557db26cff37a74)(values, 1 /* eMapValues.Value */ , 0 /* eMapValues.Key */ , (0, $36a077d9f4439b69$export$a15782d21797da4c));
}
function $1a927735c653b0c3$export$db29bd6ce1af3f68(values) {
    return (0, $51d848565ca908fc$export$8557db26cff37a74)(values, 0 /* eMapValues.Key */ , 0 /* eMapValues.Key */ , (0, $36a077d9f4439b69$export$a15782d21797da4c));
}
function $1a927735c653b0c3$export$dbf89c68f5157b55(values) {
    return (0, $51d848565ca908fc$export$8557db26cff37a74)(values, 1 /* eMapValues.Value */ , 1 /* eMapValues.Value */ , (0, $36a077d9f4439b69$export$a15782d21797da4c));
}
function $1a927735c653b0c3$export$4cf8c4bb9ca98f0b(values) {
    var mapClass = {};
    (0, $45e528077703ac0c$export$aa0705d5774c95d1)(values, function(key, value) {
        mapClass[key] = value[1];
        mapClass[value[0]] = value[1];
    });
    return (0, $36a077d9f4439b69$export$a15782d21797da4c)(mapClass);
}
function $1a927735c653b0c3$export$a6025b6424227e7e(values) {
    return $1a927735c653b0c3$export$4cf8c4bb9ca98f0b(values);
}


var $4c75282440d4ddf3$export$fd52abd0b2703048 = (0, $1a927735c653b0c3$export$37b2eedf6b7b231a);
var $4c75282440d4ddf3$export$8980fe7abaa99712 = (0, $1a927735c653b0c3$export$a6025b6424227e7e);


var $78a4729d55fca66a$export$e499e02a1fe05177 = (0, $4c75282440d4ddf3$export$8980fe7abaa99712)({
    requestContextHeader: [
        0 /* eRequestHeaders.requestContextHeader */ ,
        "Request-Context"
    ],
    requestContextTargetKey: [
        1 /* eRequestHeaders.requestContextTargetKey */ ,
        "appId"
    ],
    requestContextAppIdFormat: [
        2 /* eRequestHeaders.requestContextAppIdFormat */ ,
        "appId=cid-v1:"
    ],
    requestIdHeader: [
        3 /* eRequestHeaders.requestIdHeader */ ,
        "Request-Id"
    ],
    traceParentHeader: [
        4 /* eRequestHeaders.traceParentHeader */ ,
        "traceparent"
    ],
    traceStateHeader: [
        5 /* eRequestHeaders.traceStateHeader */ ,
        "tracestate"
    ],
    sdkContextHeader: [
        6 /* eRequestHeaders.sdkContextHeader */ ,
        "Sdk-Context"
    ],
    sdkContextHeaderAppIdRequest: [
        7 /* eRequestHeaders.sdkContextHeaderAppIdRequest */ ,
        "appId"
    ],
    requestContextHeaderLowerCase: [
        8 /* eRequestHeaders.requestContextHeaderLowerCase */ ,
        "request-context"
    ]
});


/*
 * Application Insights JavaScript SDK - Common, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ /*
 * Application Insights JavaScript SDK - Core, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 

/*
 * Application Insights JavaScript SDK - Core, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
/*
 * Application Insights JavaScript SDK - Core, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 




var $8a2d104e2647a310$var$version = "3.0.2";
var $8a2d104e2647a310$var$instanceName = "." + (0, $dd28c90c4d15de9c$export$9ffd10a3fbdc175b)(6);
var $8a2d104e2647a310$var$_dataUid = 0;
// Accepts only:
//  - Node
//    - Node.ELEMENT_NODE
//    - Node.DOCUMENT_NODE
//  - Object
//    - Any
function $8a2d104e2647a310$var$_canAcceptData(target) {
    return target[0, $1ae5573ce493bccc$export$aa192ee35fac3196 /* @min:%2enodeType */ ] === 1 || target[0, $1ae5573ce493bccc$export$aa192ee35fac3196 /* @min:%2enodeType */ ] === 9 || !+target[0, $1ae5573ce493bccc$export$aa192ee35fac3196 /* @min:%2enodeType */ ];
}
function $8a2d104e2647a310$var$_getCache(data, target) {
    var theCache = target[data.id];
    if (!theCache) {
        theCache = {};
        try {
            if ($8a2d104e2647a310$var$_canAcceptData(target)) (0, $d212d948d25f959a$export$d0d2ebf910ad6e2)(target, data.id, {
                e: false,
                v: theCache
            });
        } catch (e) {
        // Not all environments allow extending all objects, so just ignore the cache in those cases
        }
    }
    return theCache;
}
function $8a2d104e2647a310$export$eb4a6badb18ead04(name, includeVersion) {
    if (includeVersion === void 0) includeVersion = false;
    return (0, $0b747974b0bb3563$export$f60443f194e40bc2)(name + $8a2d104e2647a310$var$_dataUid++ + (includeVersion ? "." + $8a2d104e2647a310$var$version : (0, $9fe4a5d5204a4cff$export$5e8607ab26634759)) + $8a2d104e2647a310$var$instanceName);
}
function $8a2d104e2647a310$export$b95c3438408d78aa(name) {
    var data = {
        id: $8a2d104e2647a310$export$eb4a6badb18ead04("_aiData-" + (name || (0, $9fe4a5d5204a4cff$export$5e8607ab26634759)) + "." + $8a2d104e2647a310$var$version),
        accept: function(target) {
            return $8a2d104e2647a310$var$_canAcceptData(target);
        },
        get: function(target, name, defValue, addDefault) {
            var theCache = target[data.id];
            if (!theCache) {
                if (addDefault) {
                    // Side effect is adds the cache
                    theCache = $8a2d104e2647a310$var$_getCache(data, target);
                    theCache[(0, $0b747974b0bb3563$export$f60443f194e40bc2)(name)] = defValue;
                }
                return defValue;
            }
            return theCache[(0, $0b747974b0bb3563$export$f60443f194e40bc2)(name)];
        },
        kill: function(target, name) {
            if (target && target[name]) try {
                delete target[name];
            } catch (e) {
            // Just cleaning up, so if this fails -- ignore
            }
        }
    };
    return data;
}




/*
 * Application Insights JavaScript SDK - Core, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 

function $2b347a3380a9d5e1$var$_isConfigDefaults(value) {
    return value && (0, $533f826bbc418791$export$a6cdc56e425d0d0a)(value) && (value.isVal || value.fb || (0, $08325aa6d8565cc0$export$34e6b98f73578a9c)(value, "v") || (0, $08325aa6d8565cc0$export$34e6b98f73578a9c)(value, "mrg") || (0, $08325aa6d8565cc0$export$34e6b98f73578a9c)(value, "ref") || value.set);
}
function $2b347a3380a9d5e1$var$_getDefault(dynamicHandler, theConfig, cfgDefaults) {
    var defValue;
    var isDefaultValid = cfgDefaults.dfVal || (0, $533f826bbc418791$export$4e62c701997796c1);
    // There is a fallback config key so try and grab that first
    if (theConfig && cfgDefaults.fb) {
        var fallbacks = cfgDefaults.fb;
        if (!(0, $533f826bbc418791$export$43bee75e5e14138e)(fallbacks)) fallbacks = [
            fallbacks
        ];
        for(var lp = 0; lp < fallbacks[0, $1ae5573ce493bccc$export$6eae51590aaea43 /* @min:%2elength */ ]; lp++){
            var fallback = fallbacks[lp];
            var fbValue = theConfig[fallback];
            if (isDefaultValid(fbValue)) defValue = fbValue;
            else if (dynamicHandler) {
                // Needed to ensure that the fallback value (and potentially) new field is also dynamic even if null/undefined
                fbValue = dynamicHandler.cfg[fallback];
                if (isDefaultValid(fbValue)) defValue = fbValue;
                // Needed to ensure that the fallback value (and potentially) new field is also dynamic even if null/undefined
                dynamicHandler.set(dynamicHandler.cfg, (0, $d813f4522b40a37e$export$590567be997858b6)(fallback), fbValue);
            }
            if (isDefaultValid(defValue)) break;
        }
    }
    // If the value is still not defined and we have a default value then use that
    if (!isDefaultValid(defValue) && isDefaultValid(cfgDefaults.v)) defValue = cfgDefaults.v;
    return defValue;
}
/**
 * Recursively resolve the default value
 * @param dynamicHandler
 * @param theConfig
 * @param cfgDefaults
 * @returns
 */ function $2b347a3380a9d5e1$var$_resolveDefaultValue(dynamicHandler, theConfig, cfgDefaults) {
    var theValue = cfgDefaults;
    if (cfgDefaults && $2b347a3380a9d5e1$var$_isConfigDefaults(cfgDefaults)) theValue = $2b347a3380a9d5e1$var$_getDefault(dynamicHandler, theConfig, cfgDefaults);
    if (theValue) {
        if ($2b347a3380a9d5e1$var$_isConfigDefaults(theValue)) theValue = $2b347a3380a9d5e1$var$_resolveDefaultValue(dynamicHandler, theConfig, theValue);
        var newValue_1;
        if ((0, $533f826bbc418791$export$43bee75e5e14138e)(theValue)) {
            newValue_1 = [];
            newValue_1[0, $1ae5573ce493bccc$export$6eae51590aaea43 /* @min:%2elength */ ] = theValue[0, $1ae5573ce493bccc$export$6eae51590aaea43 /* @min:%2elength */ ];
        } else if ((0, $a339b44c6e62d324$export$53b83ca8eaab0383)(theValue)) newValue_1 = {};
        if (newValue_1) {
            (0, $45e528077703ac0c$export$aa0705d5774c95d1)(theValue, function(key, value) {
                if (value && $2b347a3380a9d5e1$var$_isConfigDefaults(value)) value = $2b347a3380a9d5e1$var$_resolveDefaultValue(dynamicHandler, theConfig, value);
                newValue_1[key] = value;
            });
            theValue = newValue_1;
        }
    }
    return theValue;
}
function $2b347a3380a9d5e1$export$f11b7d3a4617b9e9(dynamicHandler, theConfig, name, defaultValue) {
    // Resolve the initial config value from the provided value or use the defined default
    var isValid;
    var setFn;
    var defValue;
    var cfgDefaults = defaultValue;
    var mergeDf;
    var reference;
    var readOnly;
    var blkDynamicValue;
    if ($2b347a3380a9d5e1$var$_isConfigDefaults(cfgDefaults)) {
        // looks like a IConfigDefault
        isValid = cfgDefaults.isVal;
        setFn = cfgDefaults.set;
        readOnly = cfgDefaults[0, $1ae5573ce493bccc$export$9e4bb115c58de388 /* @min:%2erdOnly */ ];
        blkDynamicValue = cfgDefaults[0, $1ae5573ce493bccc$export$9d71a37f0770d87f /* @min:%2eblkVal */ ];
        mergeDf = cfgDefaults.mrg;
        reference = cfgDefaults.ref;
        if (!reference && (0, $533f826bbc418791$export$fce6876652108ab)(reference)) reference = !!mergeDf;
        defValue = $2b347a3380a9d5e1$var$_getDefault(dynamicHandler, theConfig, cfgDefaults);
    } else defValue = defaultValue;
    if (blkDynamicValue) // Mark the property so that any value assigned will be blocked from conversion, we need to do this
    // before assigning or fetching the value to ensure it's not converted
    dynamicHandler[0, $1ae5573ce493bccc$export$9d71a37f0770d87f /* @min:%2eblkVal */ ](theConfig, name);
    // Set the value to the default value;
    var theValue;
    var usingDefault = true;
    var cfgValue = theConfig[name];
    // try and get and user provided values
    if (cfgValue || !(0, $533f826bbc418791$export$bedb7023a7733221)(cfgValue)) {
        // Use the defined theConfig[name] value
        theValue = cfgValue;
        usingDefault = false;
        // The values are different and we have a special default value check, which is used to
        // override config values like empty strings to continue using the default
        if (isValid && theValue !== defValue && !isValid(theValue)) {
            theValue = defValue;
            usingDefault = true;
        }
        if (setFn) {
            theValue = setFn(theValue, defValue, theConfig);
            usingDefault = theValue === defValue;
        }
    }
    if (!usingDefault) {
        if ((0, $a339b44c6e62d324$export$53b83ca8eaab0383)(theValue) || (0, $533f826bbc418791$export$43bee75e5e14138e)(defValue)) // we are using the user supplied value and it's an object
        {
            if (mergeDf && defValue && ((0, $a339b44c6e62d324$export$53b83ca8eaab0383)(defValue) || (0, $533f826bbc418791$export$43bee75e5e14138e)(defValue))) // Resolve/apply the defaults
            (0, $45e528077703ac0c$export$aa0705d5774c95d1)(defValue, function(dfName, dfValue) {
                // Sets the value and makes it dynamic (if it doesn't already exist)
                $2b347a3380a9d5e1$export$f11b7d3a4617b9e9(dynamicHandler, theValue, dfName, dfValue);
            });
        }
    } else if (defValue) // Just resolve the default
    theValue = $2b347a3380a9d5e1$var$_resolveDefaultValue(dynamicHandler, theConfig, defValue);
    else theValue = defValue;
    // if (theValue && usingDefault && (isPlainObject(theValue) || isArray(theValue))) {
    //     theValue = _cfgDeepCopy(theValue);
    // }
    // Needed to ensure that the (potentially) new field is dynamic even if null/undefined
    dynamicHandler.set(theConfig, name, theValue);
    if (reference) dynamicHandler.ref(theConfig, name);
    if (readOnly) dynamicHandler[0, $1ae5573ce493bccc$export$9e4bb115c58de388 /* @min:%2erdOnly */ ](theConfig, name);
}


/*
 * Application Insights JavaScript SDK - Core, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 


/*
 * Application Insights JavaScript SDK - Core, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ /*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */ 
/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */ /*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */ 
var $49e650e29acde80b$export$aad005cc63185e9e = (0, $1a927735c653b0c3$export$db29bd6ce1af3f68)({
    asyncIterator: 0 /* WellKnownSymbols.asyncIterator */ ,
    hasInstance: 1 /* WellKnownSymbols.hasInstance */ ,
    isConcatSpreadable: 2 /* WellKnownSymbols.isConcatSpreadable */ ,
    iterator: 3 /* WellKnownSymbols.iterator */ ,
    match: 4 /* WellKnownSymbols.match */ ,
    matchAll: 5 /* WellKnownSymbols.matchAll */ ,
    replace: 6 /* WellKnownSymbols.replace */ ,
    search: 7 /* WellKnownSymbols.search */ ,
    species: 8 /* WellKnownSymbols.species */ ,
    split: 9 /* WellKnownSymbols.split */ ,
    toPrimitive: 10 /* WellKnownSymbols.toPrimitive */ ,
    toStringTag: 11 /* WellKnownSymbols.toStringTag */ ,
    unscopables: 12 /* WellKnownSymbols.unscopables */ 
});







/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */ 






var $a8afde6386ad83e8$export$da061769d961e150 = (0, $d491d25af4ac425c$export$e4412260893e0ee4)("startsWith", (0, $b347daff6f5f8dc1$export$a31bd47275edb702), $a8afde6386ad83e8$export$4385daccb55bb3a3);
function $a8afde6386ad83e8$export$4385daccb55bb3a3(value, searchString, position) {
    if (!(0, $533f826bbc418791$export$844ec244b1367d54)(value)) (0, $44a1c24c0e411039$export$3f7738bd7dcba681)("'" + (0, $386f00e3a193a7da$export$21fce7cbd4dc679f)(value) + "' is not a string");
    var searchValue = (0, $533f826bbc418791$export$844ec244b1367d54)(searchString) ? searchString : (0, $d813f4522b40a37e$export$590567be997858b6)(searchString);
    var chkLen = searchValue[0, $b347daff6f5f8dc1$export$5f32d5745d700b0e];
    var pos = position > 0 ? position : 0;
    return (0, $c3f3bf8012a4b2d4$export$9d1aa7361d7a6e87)(value, pos, pos + chkLen) === searchValue;
}


var $f26b93b472d141b0$var$_polySymbols;
function $f26b93b472d141b0$var$_globalSymbolRegistry() {
    if (!$f26b93b472d141b0$var$_polySymbols) {
        var gblCfg = (0, $6b9be1171d21f18a$export$8a1a74f726f2b336)();
        $f26b93b472d141b0$var$_polySymbols = gblCfg.gblSym = gblCfg.gblSym || {
            k: {},
            s: {}
        };
    }
    return $f26b93b472d141b0$var$_polySymbols;
}
var $f26b93b472d141b0$var$_wellKnownSymbolCache = {};
function $f26b93b472d141b0$export$1e4b0b24415108a8(description) {
    var theSymbol = {
        description: (0, $d813f4522b40a37e$export$590567be997858b6)(description),
        toString: function() {
            return (0, $b347daff6f5f8dc1$export$27c95a7104c1f7aa) + "(" + description + ")";
        }
    };
    // Tag the symbol so we know it a polyfill
    theSymbol[0, $b347daff6f5f8dc1$export$e674ec9e2c0d330e] = true;
    return theSymbol;
}
function $f26b93b472d141b0$export$c35d76cf82622c51(key) {
    var registry = $f26b93b472d141b0$var$_globalSymbolRegistry();
    if (!(0, $08325aa6d8565cc0$export$34e6b98f73578a9c)(registry, key)) {
        var newSymbol = $f26b93b472d141b0$export$1e4b0b24415108a8(key);
        registry.k[key] = newSymbol;
        registry.s[newSymbol] = (0, $d813f4522b40a37e$export$590567be997858b6)(key);
    }
    return registry.k[key];
}
function $f26b93b472d141b0$export$205212be62415f78(sym) {
    if (!sym || !sym.toString || !(0, $a8afde6386ad83e8$export$da061769d961e150)(sym.toString(), (0, $b347daff6f5f8dc1$export$27c95a7104c1f7aa))) (0, $44a1c24c0e411039$export$3f7738bd7dcba681)(sym + " is not a symbol");
    return $f26b93b472d141b0$var$_globalSymbolRegistry().s[sym];
}
function $f26b93b472d141b0$export$b9abc24179dacbc5(name) {
    var result;
    var knownName = (0, $49e650e29acde80b$export$aad005cc63185e9e)[name];
    if (knownName) result = $f26b93b472d141b0$var$_wellKnownSymbolCache[knownName] = $f26b93b472d141b0$var$_wellKnownSymbolCache[knownName] || $f26b93b472d141b0$export$1e4b0b24415108a8((0, $b347daff6f5f8dc1$export$27c95a7104c1f7aa) + "." + knownName);
    return result;
}







var $3ab078397ef07bc3$var$_symbol;
var $3ab078397ef07bc3$var$_symbolFor;
var $3ab078397ef07bc3$var$_symbolKeyFor;
function $3ab078397ef07bc3$var$_getSymbolValue(name) {
    return (0, $f07ca4f3c96b6502$export$c6675fd9042172d2)(function() {
        return $3ab078397ef07bc3$var$_symbol.v ? $3ab078397ef07bc3$var$_symbol[name] : (0, $b347daff6f5f8dc1$export$375c5ccc31575c19);
    }, (0, $b347daff6f5f8dc1$export$375c5ccc31575c19));
}
var $3ab078397ef07bc3$export$a244864fd9645c7f = (0, $533f826bbc418791$export$baab46d9fe4a4eef)("symbol");
function $3ab078397ef07bc3$export$1e6e45ea4c3f892c() {
    return !!$3ab078397ef07bc3$export$57af67db727bc7c7();
}
function $3ab078397ef07bc3$export$57af67db727bc7c7() {
    var resetCache = !$3ab078397ef07bc3$var$_symbol || (0, $d8ec17546a34ef88$export$2d4a6284764f647f) && (0, $d8ec17546a34ef88$export$2d4a6284764f647f).lzy && !$3ab078397ef07bc3$var$_symbol.b;
    resetCache && ($3ab078397ef07bc3$var$_symbol = (0, $3d5fcb60a9467a45$export$45fd08e1bc14fe1c)((0, $b347daff6f5f8dc1$export$27c95a7104c1f7aa)));
    (!$3ab078397ef07bc3$var$_symbolFor || resetCache) && ($3ab078397ef07bc3$var$_symbolFor = $3ab078397ef07bc3$var$_getSymbolValue("for"));
    (!$3ab078397ef07bc3$var$_symbolKeyFor || resetCache) && ($3ab078397ef07bc3$var$_symbolKeyFor = $3ab078397ef07bc3$var$_getSymbolValue("keyFor"));
    return $3ab078397ef07bc3$var$_symbol.v;
}
function $3ab078397ef07bc3$export$3a9aefdadea26115(name, noPoly) {
    var knownName = (0, $49e650e29acde80b$export$aad005cc63185e9e)[name];
    // Cause lazy symbol to get initialized
    (!$3ab078397ef07bc3$var$_symbol || (0, $d8ec17546a34ef88$export$2d4a6284764f647f).lzy && !$3ab078397ef07bc3$var$_symbol.b) && $3ab078397ef07bc3$export$57af67db727bc7c7();
    return $3ab078397ef07bc3$var$_symbol.v ? $3ab078397ef07bc3$var$_symbol.v[knownName || name] : !noPoly ? (0, $f26b93b472d141b0$export$b9abc24179dacbc5)(name) : (0, $b347daff6f5f8dc1$export$375c5ccc31575c19);
}
function $3ab078397ef07bc3$export$70503d621eee7e7b(description, noPoly) {
    // Cause lazy _symbol to get initialized
    (!$3ab078397ef07bc3$var$_symbol || (0, $d8ec17546a34ef88$export$2d4a6284764f647f).lzy && !$3ab078397ef07bc3$var$_symbol.b) && $3ab078397ef07bc3$export$57af67db727bc7c7();
    return $3ab078397ef07bc3$var$_symbol.v ? $3ab078397ef07bc3$var$_symbol.v(description) : !noPoly ? (0, $f26b93b472d141b0$export$1e4b0b24415108a8)(description) : (0, $b347daff6f5f8dc1$export$38c7ba05d207d137);
}
function $3ab078397ef07bc3$export$4d0ba04d25a41f31(key) {
    // Cause lazy symbol to get initialized
    (!$3ab078397ef07bc3$var$_symbolFor || (0, $d8ec17546a34ef88$export$2d4a6284764f647f).lzy && !$3ab078397ef07bc3$var$_symbol.b) && $3ab078397ef07bc3$export$57af67db727bc7c7();
    return ($3ab078397ef07bc3$var$_symbolFor.v || (0, $f26b93b472d141b0$export$c35d76cf82622c51))(key);
}
function $3ab078397ef07bc3$export$5cc35ecfe266eba7(sym) {
    // Cause lazy symbol to get initialized
    (!$3ab078397ef07bc3$var$_symbolKeyFor || (0, $d8ec17546a34ef88$export$2d4a6284764f647f).lzy && !$3ab078397ef07bc3$var$_symbol.b) && $3ab078397ef07bc3$export$57af67db727bc7c7();
    return ($3ab078397ef07bc3$var$_symbolKeyFor.v || (0, $f26b93b472d141b0$export$205212be62415f78))(sym);
}



var $36be0cb20f115b6f$export$3af51e1f665d1d72 = (0, $3ab078397ef07bc3$export$4d0ba04d25a41f31)("[[ai_dynCfg_1]]");
/**
 * @internal
 * @ignore
 * The symbol to tag objects / arrays with if they should not be converted
 */ var $36be0cb20f115b6f$var$BLOCK_DYNAMIC = (0, $3ab078397ef07bc3$export$4d0ba04d25a41f31)("[[ai_blkDynCfg_1]]");
/**
 * @internal
 * @ignore
 * The symbol to tag objects to indicate that when included into the configuration that
 * they should be converted into a trackable dynamic object.
 */ var $36be0cb20f115b6f$var$FORCE_DYNAMIC = (0, $3ab078397ef07bc3$export$4d0ba04d25a41f31)("[[ai_frcDynCfg_1]]");
function $36be0cb20f115b6f$export$36c4765ffcb8ffc1(source) {
    if (source) {
        var target_1;
        if ((0, $533f826bbc418791$export$43bee75e5e14138e)(source)) {
            target_1 = [];
            target_1[0, $1ae5573ce493bccc$export$6eae51590aaea43 /* @min:%2elength */ ] = source[0, $1ae5573ce493bccc$export$6eae51590aaea43 /* @min:%2elength */ ];
        } else if ((0, $a339b44c6e62d324$export$53b83ca8eaab0383)(source)) target_1 = {};
        if (target_1) {
            // Copying index values by property name as the extensionConfig can be an array or object
            (0, $45e528077703ac0c$export$aa0705d5774c95d1)(source, function(key, value) {
                // Perform a deep copy of the object
                target_1[key] = $36be0cb20f115b6f$export$36c4765ffcb8ffc1(value);
            });
            return target_1;
        }
    }
    return source;
}
function $36be0cb20f115b6f$export$ebfc7adde882cbe6(value) {
    if (value) {
        var handler = value[$36be0cb20f115b6f$export$3af51e1f665d1d72] || value;
        if (handler.cfg && (handler.cfg === value || handler.cfg[$36be0cb20f115b6f$export$3af51e1f665d1d72] === handler)) return handler;
    }
    return null;
}
function $36be0cb20f115b6f$export$9ab6a1069e1e797e(value) {
    if (value && ((0, $a339b44c6e62d324$export$53b83ca8eaab0383)(value) || (0, $533f826bbc418791$export$43bee75e5e14138e)(value))) try {
        value[$36be0cb20f115b6f$var$BLOCK_DYNAMIC] = true;
    } catch (e) {
    // Don't throw for this case as it's an ask only
    }
    return value;
}
function $36be0cb20f115b6f$export$89d2831ef182f832(value) {
    if (value) try {
        value[$36be0cb20f115b6f$var$FORCE_DYNAMIC] = true;
    } catch (e) {
    // Don't throw for this case as it's an ask only
    }
    return value;
}
function $36be0cb20f115b6f$export$d4b814eca8f802e7(getFunc, state, value) {
    var result = false;
    // Object must exist and be truthy
    if (value && !getFunc[state.blkVal]) {
        // Tagged as always convert
        result = value[$36be0cb20f115b6f$var$FORCE_DYNAMIC];
        // Check that it's not explicitly tagged as blocked
        if (!result && !value[$36be0cb20f115b6f$var$BLOCK_DYNAMIC]) // Only convert plain objects or arrays by default
        result = (0, $a339b44c6e62d324$export$53b83ca8eaab0383)(value) || (0, $533f826bbc418791$export$43bee75e5e14138e)(value);
    }
    return result;
}
function $36be0cb20f115b6f$export$e2aa058b2c3c7959(message) {
    (0, $44a1c24c0e411039$export$3f7738bd7dcba681)("InvalidAccess:" + message);
}


var $b2527bd3661c8e9e$var$arrayMethodsToPatch = [
    "push",
    "pop",
    "shift",
    "unshift",
    "splice"
];
var $b2527bd3661c8e9e$export$6103ab389f3208de = function(logger, name, desc, e) {
    logger && logger[0, $1ae5573ce493bccc$export$6c078c21a0c6c1ce /* @min:%2ethrowInternal */ ](3 /* eLoggingSeverity.DEBUG */ , 108 /* _eInternalMessageId.DynamicConfigException */ , "".concat(desc, " [").concat(name, "] failed - ") + (0, $386f00e3a193a7da$export$21fce7cbd4dc679f)(e));
};
function $b2527bd3661c8e9e$var$_patchArray(state, target, name) {
    if ((0, $533f826bbc418791$export$43bee75e5e14138e)(target)) // Monkey Patch the methods that might change the array
    (0, $f6bb085f8cf12216$export$e2e5bcdbdc49c586)($b2527bd3661c8e9e$var$arrayMethodsToPatch, function(method) {
        var orgMethod = target[method];
        target[method] = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var result = orgMethod[0, $1ae5573ce493bccc$export$2f85ca6962b15ff8 /* @min:%2eapply */ ](this, args);
            // items may be added, removed or moved so need to make some new dynamic properties
            $b2527bd3661c8e9e$export$f24b4ed0a40d3d27(state, target, name, "Patching");
            return result;
        };
    });
}
function $b2527bd3661c8e9e$var$_getOwnPropGetter(target, name) {
    var propDesc = (0, $a1ed021ceb472abb$export$1bd5e8b059facbe9)(target, name);
    return propDesc && propDesc.get;
}
function $b2527bd3661c8e9e$var$_createDynamicProperty(state, theConfig, name, value) {
    // Does not appear to be dynamic so lets make it so
    var detail = {
        n: name,
        h: [],
        trk: function(handler) {
            if (handler && handler.fn) {
                if ((0, $a96d4958027d6f85$export$9f3b3ffa84393d30)(detail.h, handler) === -1) // Add this handler to the collection that should be notified when the value changes
                detail.h[0, $1ae5573ce493bccc$export$a0a330e7fa1e278c /* @min:%2epush */ ](handler);
                state.trk(handler, detail);
            }
        },
        clr: function(handler) {
            var idx = (0, $a96d4958027d6f85$export$9f3b3ffa84393d30)(detail.h, handler);
            if (idx !== -1) detail.h[0, $1ae5573ce493bccc$export$84020a2e4fe863b0 /* @min:%2esplice */ ](idx, 1);
        }
    };
    // Flag to optimize lookup response time by avoiding additional function calls
    var checkDynamic = true;
    var isObjectOrArray = false;
    function _getProperty() {
        if (checkDynamic) {
            isObjectOrArray = isObjectOrArray || (0, $36be0cb20f115b6f$export$d4b814eca8f802e7)(_getProperty, state, value);
            // Make sure that if it's an object that we make it dynamic
            if (value && !value[0, $36be0cb20f115b6f$export$3af51e1f665d1d72] && isObjectOrArray) // It doesn't look like it's already dynamic so lets make sure it's converted the object into a dynamic Config as well
            value = $b2527bd3661c8e9e$export$f24b4ed0a40d3d27(state, value, name, "Converting");
            // If it needed to be converted it now has been
            checkDynamic = false;
        }
        // If there is an active handler then add it to the tracking set of handlers
        var activeHandler = state.act;
        if (activeHandler) detail.trk(activeHandler);
        return value;
    }
    // Tag this getter as our dynamic property and provide shortcut for notifying a change
    _getProperty[state.prop] = {
        chng: function() {
            state.add(detail);
        }
    };
    function _setProperty(newValue) {
        if (value !== newValue) {
            if (!!_getProperty[state.ro] && !state.upd) // field is marked as readonly so return false
            (0, $36be0cb20f115b6f$export$e2aa058b2c3c7959)("[" + name + "] is read-only:" + (0, $386f00e3a193a7da$export$21fce7cbd4dc679f)(theConfig));
            if (checkDynamic) {
                isObjectOrArray = isObjectOrArray || (0, $36be0cb20f115b6f$export$d4b814eca8f802e7)(_getProperty, state, value);
                checkDynamic = false;
            }
            // The value must be a plain object or an array to enforce the reference (in-place updates)
            var isReferenced = isObjectOrArray && _getProperty[state.rf];
            if (isObjectOrArray) {
                // We are about to replace a plain object or an array
                if (isReferenced) {
                    // Reassign the properties from the current value to the same properties from the newValue
                    // This will set properties not in the newValue to undefined
                    (0, $45e528077703ac0c$export$aa0705d5774c95d1)(value, function(key) {
                        value[key] = newValue ? newValue[key] : (0, $9fe4a5d5204a4cff$export$a43287864529b8fd);
                    });
                    // Now assign / re-assign value with all of the keys from newValue
                    try {
                        (0, $45e528077703ac0c$export$aa0705d5774c95d1)(newValue, function(key, theValue) {
                            $b2527bd3661c8e9e$export$7d85a661fa08a14d(state, value, key, theValue);
                        });
                        // Now drop newValue so when we assign value later it keeps the existing reference
                        newValue = value;
                    } catch (e) {
                        // Unable to convert to dynamic property so just leave as non-dynamic
                        $b2527bd3661c8e9e$export$6103ab389f3208de((state.hdlr || {})[0, $1ae5573ce493bccc$export$e6a243fe757439f9 /* @min:%2elogger */ ], name, "Assigning", e);
                        // Mark as not an object or array so we don't try and do this again
                        isObjectOrArray = false;
                    }
                } else if (value && value[0, $36be0cb20f115b6f$export$3af51e1f665d1d72]) // As we are replacing the value, if it's already dynamic then we need to notify the listeners
                // for every property it has already
                (0, $45e528077703ac0c$export$aa0705d5774c95d1)(value, function(key) {
                    // Check if the value is dynamic
                    var getter = $b2527bd3661c8e9e$var$_getOwnPropGetter(value, key);
                    if (getter) {
                        // And if it is tell it's listeners that the value has changed
                        var valueState = getter[state.prop];
                        valueState && valueState.chng();
                    }
                });
            }
            if (newValue !== value) {
                var newIsObjectOrArray = newValue && (0, $36be0cb20f115b6f$export$d4b814eca8f802e7)(_getProperty, state, newValue);
                if (!isReferenced && newIsObjectOrArray) // As the newValue is an object/array lets preemptively make it dynamic
                newValue = $b2527bd3661c8e9e$export$f24b4ed0a40d3d27(state, newValue, name, "Converting");
                // Now assign the internal "value" to the newValue
                value = newValue;
                isObjectOrArray = newIsObjectOrArray;
            }
            // Cause any listeners to be scheduled for notification
            state.add(detail);
        }
    }
    (0, $d212d948d25f959a$export$d0d2ebf910ad6e2)(theConfig, detail.n, {
        g: _getProperty,
        s: _setProperty
    });
}
function $b2527bd3661c8e9e$export$7d85a661fa08a14d(state, target, name, value) {
    if (target) {
        // To be a dynamic property it needs to have a get function
        var getter = $b2527bd3661c8e9e$var$_getOwnPropGetter(target, name);
        var isDynamic = getter && !!getter[state.prop];
        if (!isDynamic) $b2527bd3661c8e9e$var$_createDynamicProperty(state, target, name, value);
        else // Looks like it's already dynamic just assign the new value
        target[name] = value;
    }
    return target;
}
function $b2527bd3661c8e9e$export$945b6f6a011a9f7a(state, target, name, flags) {
    if (target) {
        // To be a dynamic property it needs to have a get function
        var getter = $b2527bd3661c8e9e$var$_getOwnPropGetter(target, name);
        var isDynamic = getter && !!getter[state.prop];
        var inPlace = flags && flags[0 /* _eSetDynamicPropertyFlags.inPlace */ ];
        var rdOnly = flags && flags[1 /* _eSetDynamicPropertyFlags.readOnly */ ];
        var blkProp = flags && flags[2 /* _eSetDynamicPropertyFlags.blockDynamicProperty */ ];
        if (!isDynamic) {
            if (blkProp) try {
                // Attempt to mark the target as blocked from conversion
                (0, $36be0cb20f115b6f$export$9ab6a1069e1e797e)(target);
            } catch (e) {
                $b2527bd3661c8e9e$export$6103ab389f3208de((state.hdlr || {})[0, $1ae5573ce493bccc$export$e6a243fe757439f9 /* @min:%2elogger */ ], name, "Blocking", e);
            }
            try {
                // Make sure it's dynamic so that we can tag the property as per the state
                $b2527bd3661c8e9e$export$7d85a661fa08a14d(state, target, name, target[name]);
                getter = $b2527bd3661c8e9e$var$_getOwnPropGetter(target, name);
            } catch (e) {
                // Unable to convert to dynamic property so just leave as non-dynamic
                $b2527bd3661c8e9e$export$6103ab389f3208de((state.hdlr || {})[0, $1ae5573ce493bccc$export$e6a243fe757439f9 /* @min:%2elogger */ ], name, "State", e);
            }
        }
        // Assign the optional flags if true
        if (inPlace) getter[state.rf] = inPlace;
        if (rdOnly) getter[state.ro] = rdOnly;
        if (blkProp) getter[state.blkVal] = true;
    }
    return target;
}
function $b2527bd3661c8e9e$export$f24b4ed0a40d3d27(state, target, name, desc) {
    try {
        // Assign target with new value properties (converting into dynamic properties in the process)
        (0, $45e528077703ac0c$export$aa0705d5774c95d1)(target, function(key, value) {
            // Assign and/or make the property dynamic
            $b2527bd3661c8e9e$export$7d85a661fa08a14d(state, target, key, value);
        });
        if (!target[0, $36be0cb20f115b6f$export$3af51e1f665d1d72]) {
            // Link the config back to the dynamic config details
            (0, $d212d948d25f959a$export$8b8fd4dfd45f6b81)(target, (0, $36be0cb20f115b6f$export$3af51e1f665d1d72), {
                get: function() {
                    return state[0, $1ae5573ce493bccc$export$d17a699c20d379ac /* @min:%2ehdlr */ ];
                }
            });
            $b2527bd3661c8e9e$var$_patchArray(state, target, name);
        }
    } catch (e) {
        // Unable to convert to dynamic property so just leave as non-dynamic
        $b2527bd3661c8e9e$export$6103ab389f3208de((state.hdlr || {})[0, $1ae5573ce493bccc$export$e6a243fe757439f9 /* @min:%2elogger */ ], name, desc, e);
    }
    return target;
}


/*
 * Application Insights JavaScript SDK - Core, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ /*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */ /*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */ 

var $46728a52dfc641a6$export$1bea104a0e2567f0 = (0, $d491d25af4ac425c$export$34d1cd0b62238dad)((0, $b347daff6f5f8dc1$export$ddd00fe728e19670), (0, $b347daff6f5f8dc1$export$f3f471c81a14426));


/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2023 Nevware21
 * Licensed under the MIT license.
 */ 
var $d88e50d36d3d9760$export$2801572b9d3736b5 = (0, $d491d25af4ac425c$export$fe708dcfc359f940)("apply");




/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */ 

var $de882ae8157e9b9b$var$REF = "ref";
var $de882ae8157e9b9b$var$UNREF = "un" + $de882ae8157e9b9b$var$REF;
var $de882ae8157e9b9b$var$HAS_REF = "hasRef";
var $de882ae8157e9b9b$var$ENABLED = "enabled";
function $de882ae8157e9b9b$export$bf688d278153f393(startTimer, refreshFn, cancelFn) {
    var _a;
    var ref = true;
    var timerId = startTimer ? refreshFn((0, $b347daff6f5f8dc1$export$38c7ba05d207d137)) : (0, $b347daff6f5f8dc1$export$38c7ba05d207d137);
    var theTimerHandler;
    var _unref = function() {
        ref = false;
        timerId && timerId[$de882ae8157e9b9b$var$UNREF] && timerId[$de882ae8157e9b9b$var$UNREF]();
        return theTimerHandler;
    };
    var _ref = function() {
        ref = true;
        timerId && timerId[$de882ae8157e9b9b$var$REF] && timerId[$de882ae8157e9b9b$var$REF]();
        return theTimerHandler;
    };
    var _hasRef = function() {
        if (timerId && timerId[$de882ae8157e9b9b$var$HAS_REF]) return timerId[$de882ae8157e9b9b$var$HAS_REF]();
        return ref;
    };
    var _refresh = function() {
        timerId = refreshFn(timerId);
        if (!ref) _unref();
        return theTimerHandler;
    };
    var _cancel = function() {
        timerId && cancelFn(timerId);
        timerId = (0, $b347daff6f5f8dc1$export$38c7ba05d207d137);
    };
    var _setEnabled = function(value) {
        !value && timerId && _cancel();
        value && !timerId && _refresh();
    };
    theTimerHandler = (_a = {
        cancel: _cancel,
        refresh: _refresh
    }, _a[$de882ae8157e9b9b$var$HAS_REF] = _hasRef, _a[$de882ae8157e9b9b$var$REF] = _ref, _a[$de882ae8157e9b9b$var$UNREF] = _unref, _a[$de882ae8157e9b9b$var$ENABLED] = false, _a);
    (0, $d212d948d25f959a$export$8b8fd4dfd45f6b81)(theTimerHandler, $de882ae8157e9b9b$var$ENABLED, {
        get: function() {
            return !!timerId;
        },
        set: _setEnabled
    });
    return {
        h: theTimerHandler,
        dn: function() {
            timerId = (0, $b347daff6f5f8dc1$export$38c7ba05d207d137);
        }
    };
}


function $d03b12effd00bf96$var$_createTimeoutWith(self, startTimer, overrideFn, theArgs) {
    var isArr = (0, $533f826bbc418791$export$43bee75e5e14138e)(overrideFn);
    var len = isArr ? overrideFn.length : 0;
    var setFn = (len > 0 ? overrideFn[0] : !isArr ? overrideFn : (0, $b347daff6f5f8dc1$export$375c5ccc31575c19)) || setTimeout;
    var clearFn = (len > 1 ? overrideFn[1] : (0, $b347daff6f5f8dc1$export$375c5ccc31575c19)) || clearTimeout;
    var timerFn = theArgs[0];
    theArgs[0] = function() {
        handler.dn();
        (0, $d88e50d36d3d9760$export$2801572b9d3736b5)(timerFn, self, (0, $46728a52dfc641a6$export$1bea104a0e2567f0)(arguments));
    };
    var handler = (0, $de882ae8157e9b9b$export$bf688d278153f393)(startTimer, function(timerId) {
        if (timerId) {
            if (timerId.refresh) {
                timerId.refresh();
                return timerId;
            }
            (0, $d88e50d36d3d9760$export$2801572b9d3736b5)(clearFn, self, [
                timerId
            ]);
        }
        return (0, $d88e50d36d3d9760$export$2801572b9d3736b5)(setFn, self, theArgs);
    }, function(timerId) {
        (0, $d88e50d36d3d9760$export$2801572b9d3736b5)(clearFn, self, [
            timerId
        ]);
    });
    return handler.h;
}
function $d03b12effd00bf96$export$5f4d6617421d489b(callback, timeout) {
    return $d03b12effd00bf96$var$_createTimeoutWith(this, true, (0, $b347daff6f5f8dc1$export$375c5ccc31575c19), (0, $46728a52dfc641a6$export$1bea104a0e2567f0)(arguments));
}
function $d03b12effd00bf96$export$9e7e48cc39f2a8d3(overrideFn, callback, timeout) {
    return $d03b12effd00bf96$var$_createTimeoutWith(this, true, overrideFn, (0, $46728a52dfc641a6$export$1bea104a0e2567f0)(arguments, 1));
}
function $d03b12effd00bf96$export$6eae7cf7a129a986(callback, timeout) {
    return $d03b12effd00bf96$var$_createTimeoutWith(this, false, (0, $b347daff6f5f8dc1$export$375c5ccc31575c19), (0, $46728a52dfc641a6$export$1bea104a0e2567f0)(arguments));
}
function $d03b12effd00bf96$export$320dbce2ee83dc77(overrideFn, callback, timeout) {
    return $d03b12effd00bf96$var$_createTimeoutWith(this, false, overrideFn, (0, $46728a52dfc641a6$export$1bea104a0e2567f0)(arguments, 1));
}


/*
 * Application Insights JavaScript SDK - Core, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ /*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */ 





/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */ 


var $6037ad71549710c7$var$_isProtoArray;
function $6037ad71549710c7$export$97268f64d317ba65(obj, proto) {
    var fn = (0, $b347daff6f5f8dc1$export$9ec954dd81c90a5d)["setPrototypeOf"] || // tslint:disable-next-line: only-arrow-functions
    function(d, b) {
        !$6037ad71549710c7$var$_isProtoArray && ($6037ad71549710c7$var$_isProtoArray = (0, $d8ec17546a34ef88$export$db98eae15987454c)(function() {
            var _a;
            return (_a = {}, _a[0, $b347daff6f5f8dc1$export$bac6e64dee11e7fb] = [], _a) instanceof Array;
        }));
        $6037ad71549710c7$var$_isProtoArray.v ? d[0, $b347daff6f5f8dc1$export$bac6e64dee11e7fb] = b : (0, $45e528077703ac0c$export$aa0705d5774c95d1)(b, function(key, value) {
            return d[key] = value;
        });
    };
    return fn(obj, proto);
}


/**
 * @internal
 * @ignore
 */ var $0cd2c3ce211547d0$var$_createCustomError = function(name, d, b) {
    $0cd2c3ce211547d0$var$_safeDefineName(d, name);
    d = (0, $6037ad71549710c7$export$97268f64d317ba65)(d, b);
    function __() {
        this.constructor = d;
        $0cd2c3ce211547d0$var$_safeDefineName(this, name);
    }
    d[0, $b347daff6f5f8dc1$export$4ddd10988dd20ff4] = b === (0, $b347daff6f5f8dc1$export$38c7ba05d207d137) ? (0, $f80c2443c3b8028d$export$c09f2411a4ae511b)(b) : (__[0, $b347daff6f5f8dc1$export$4ddd10988dd20ff4] = b[0, $b347daff6f5f8dc1$export$4ddd10988dd20ff4], new __());
    return d;
};
var $0cd2c3ce211547d0$var$_safeSetName = function(baseClass, name) {
    try {
        name && (baseClass[0, $b347daff6f5f8dc1$export$3c5e605ca7ade9f2] = name);
    //name && (baseClass[PROTOTYPE][NAME] = name);
    } catch (e) {
    // Do nothing
    }
};
var $0cd2c3ce211547d0$var$_safeDefineName = function(target, name) {
    try {
        (0, $d212d948d25f959a$export$d0d2ebf910ad6e2)(target, (0, $b347daff6f5f8dc1$export$3c5e605ca7ade9f2), {
            v: name,
            c: true,
            e: false
        });
    } catch (e) {
    // Do nothing
    }
};
function $0cd2c3ce211547d0$export$435492119a21bab3(name, constructCb, errorBase) {
    var theBaseClass = errorBase || Error;
    var orgName = theBaseClass[0, $b347daff6f5f8dc1$export$4ddd10988dd20ff4][0, $b347daff6f5f8dc1$export$3c5e605ca7ade9f2];
    var captureFn = Error.captureStackTrace;
    return $0cd2c3ce211547d0$var$_createCustomError(name, function() {
        var _this = this;
        try {
            $0cd2c3ce211547d0$var$_safeSetName(theBaseClass, name);
            var _self = (0, $d88e50d36d3d9760$export$2801572b9d3736b5)(theBaseClass, _this, (0, $46728a52dfc641a6$export$1bea104a0e2567f0)(arguments)) || _this;
            if (_self !== _this) {
                // Looks like runtime error constructor reset the prototype chain, so restore it
                var orgProto = (0, $36a077d9f4439b69$export$743454acee35f1d4)(_this);
                if (orgProto !== (0, $36a077d9f4439b69$export$743454acee35f1d4)(_self)) (0, $6037ad71549710c7$export$97268f64d317ba65)(_self, orgProto);
            }
            // Make sure we only capture our stack details
            captureFn && captureFn(_self, _this[0, $b347daff6f5f8dc1$export$943e078395581e44]);
            // Run the provided construction function
            constructCb && constructCb(_self, arguments);
            return _self;
        } finally{
            $0cd2c3ce211547d0$var$_safeSetName(theBaseClass, orgName);
        }
    }, theBaseClass);
}
/**
 * @internal
 * @ignore
 */ var $0cd2c3ce211547d0$var$_unsupportedError;
function $0cd2c3ce211547d0$export$6523a1bd3b6e3128(message) {
    if (!$0cd2c3ce211547d0$var$_unsupportedError) // Lazily create the class
    $0cd2c3ce211547d0$var$_unsupportedError = $0cd2c3ce211547d0$export$435492119a21bab3("UnsupportedError");
    throw new $0cd2c3ce211547d0$var$_unsupportedError(message);
}



var $6d79a478fc63a9ca$var$aggregationErrorType;
function $6d79a478fc63a9ca$export$a2765bc4230e591f(message, sourceErrors) {
    if (!$6d79a478fc63a9ca$var$aggregationErrorType) $6d79a478fc63a9ca$var$aggregationErrorType = (0, $0cd2c3ce211547d0$export$435492119a21bab3)("AggregationError", function(self, args) {
        if (args[0, $1ae5573ce493bccc$export$6eae51590aaea43 /* @min:%2elength */ ] > 1) // Save the provided errors
        self.errors = args[1];
    });
    var theMessage = message || "One or more errors occurred.";
    (0, $f6bb085f8cf12216$export$e2e5bcdbdc49c586)(sourceErrors, function(srcError, idx) {
        theMessage += "\n".concat(idx, " > ").concat((0, $386f00e3a193a7da$export$21fce7cbd4dc679f)(srcError));
    });
    throw new $6d79a478fc63a9ca$var$aggregationErrorType(theMessage, sourceErrors || []);
}



var $83c3e1b1398a495d$var$symPrefix = "[[ai_";
var $83c3e1b1398a495d$var$symPostfix = "]]";
function $83c3e1b1398a495d$export$8b125ae28a27d4c(cfgHandler) {
    var _a;
    var dynamicPropertySymbol = (0, $3ab078397ef07bc3$export$70503d621eee7e7b)($83c3e1b1398a495d$var$symPrefix + "get" + cfgHandler.uid + $83c3e1b1398a495d$var$symPostfix);
    var dynamicPropertyReadOnly = (0, $3ab078397ef07bc3$export$70503d621eee7e7b)($83c3e1b1398a495d$var$symPrefix + "ro" + cfgHandler.uid + $83c3e1b1398a495d$var$symPostfix);
    var dynamicPropertyReferenced = (0, $3ab078397ef07bc3$export$70503d621eee7e7b)($83c3e1b1398a495d$var$symPrefix + "rf" + cfgHandler.uid + $83c3e1b1398a495d$var$symPostfix);
    var dynamicPropertyBlockValue = (0, $3ab078397ef07bc3$export$70503d621eee7e7b)($83c3e1b1398a495d$var$symPrefix + "blkVal" + cfgHandler.uid + $83c3e1b1398a495d$var$symPostfix);
    var dynamicPropertyDetail = (0, $3ab078397ef07bc3$export$70503d621eee7e7b)($83c3e1b1398a495d$var$symPrefix + "dtl" + cfgHandler.uid + $83c3e1b1398a495d$var$symPostfix);
    var _waitingHandlers = null;
    var _watcherTimer = null;
    var theState;
    function _useHandler(activeHandler, callback) {
        var prevWatcher = theState.act;
        try {
            theState.act = activeHandler;
            if (activeHandler && activeHandler[dynamicPropertyDetail]) {
                // Clear out the previously tracked details for this handler, so that access are re-evaluated
                (0, $f6bb085f8cf12216$export$e2e5bcdbdc49c586)(activeHandler[dynamicPropertyDetail], function(detail) {
                    detail.clr(activeHandler);
                });
                activeHandler[dynamicPropertyDetail] = [];
            }
            callback({
                cfg: cfgHandler.cfg,
                set: cfgHandler.set.bind(cfgHandler),
                setDf: cfgHandler[0, $1ae5573ce493bccc$export$24caac6d68ff1537 /* @min:%2esetDf */ ].bind(cfgHandler),
                ref: cfgHandler.ref.bind(cfgHandler),
                rdOnly: cfgHandler[0, $1ae5573ce493bccc$export$9e4bb115c58de388 /* @min:%2erdOnly */ ].bind(cfgHandler)
            });
        } catch (e) {
            var logger = cfgHandler[0, $1ae5573ce493bccc$export$e6a243fe757439f9 /* @min:%2elogger */ ];
            if (logger) // Don't let one individual failure break everyone
            logger[0, $1ae5573ce493bccc$export$6c078c21a0c6c1ce /* @min:%2ethrowInternal */ ](1 /* eLoggingSeverity.CRITICAL */ , 107 /* _eInternalMessageId.ConfigWatcherException */ , (0, $386f00e3a193a7da$export$21fce7cbd4dc679f)(e));
            // Re-throw the exception so that any true "error" is reported back to the called
            throw e;
        } finally{
            theState.act = prevWatcher || null;
        }
    }
    function _notifyWatchers() {
        if (_waitingHandlers) {
            var notifyHandlers = _waitingHandlers;
            _waitingHandlers = null;
            // Stop any timer as we are running them now anyway
            _watcherTimer && _watcherTimer[0, $1ae5573ce493bccc$export$bd01c5e3f12db01c /* @min:%2ecancel */ ]();
            _watcherTimer = null;
            var watcherFailures_1 = [];
            // Now run the handlers
            (0, $f6bb085f8cf12216$export$e2e5bcdbdc49c586)(notifyHandlers, function(handler) {
                if (handler) {
                    if (handler[dynamicPropertyDetail]) {
                        (0, $f6bb085f8cf12216$export$e2e5bcdbdc49c586)(handler[dynamicPropertyDetail], function(detail) {
                            // Clear out this handler from  previously tracked details, so that access are re-evaluated
                            detail.clr(handler);
                        });
                        handler[dynamicPropertyDetail] = null;
                    }
                    // The handler may have self removed as part of another handler so re-check
                    if (handler.fn) try {
                        _useHandler(handler, handler.fn);
                    } catch (e) {
                        // Don't let a single failing watcher cause other watches to fail
                        watcherFailures_1[0, $1ae5573ce493bccc$export$a0a330e7fa1e278c /* @min:%2epush */ ](e);
                    }
                }
            });
            // During notification we may have had additional updates -- so notify those updates as well
            if (_waitingHandlers) try {
                _notifyWatchers();
            } catch (e) {
                watcherFailures_1[0, $1ae5573ce493bccc$export$a0a330e7fa1e278c /* @min:%2epush */ ](e);
            }
            if (watcherFailures_1[0, $1ae5573ce493bccc$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) (0, $6d79a478fc63a9ca$export$a2765bc4230e591f)("Watcher error(s): ", watcherFailures_1);
        }
    }
    function _addWatcher(detail) {
        if (detail && detail.h[0, $1ae5573ce493bccc$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) {
            if (!_waitingHandlers) _waitingHandlers = [];
            if (!_watcherTimer) _watcherTimer = (0, $d03b12effd00bf96$export$5f4d6617421d489b)(function() {
                _watcherTimer = null;
                _notifyWatchers();
            }, 0);
            // Add all of the handlers for this detail (if not already present) - using normal for-loop for performance
            for(var idx = 0; idx < detail.h[0, $1ae5573ce493bccc$export$6eae51590aaea43 /* @min:%2elength */ ]; idx++){
                var handler = detail.h[idx];
                // Add this handler to the collection of handlers to re-execute
                if (handler && (0, $a96d4958027d6f85$export$9f3b3ffa84393d30)(_waitingHandlers, handler) === -1) _waitingHandlers[0, $1ae5573ce493bccc$export$a0a330e7fa1e278c /* @min:%2epush */ ](handler);
            }
        }
    }
    function _trackHandler(handler, detail) {
        if (handler) {
            var details = handler[dynamicPropertyDetail] = handler[dynamicPropertyDetail] || [];
            if ((0, $a96d4958027d6f85$export$9f3b3ffa84393d30)(details, detail) === -1) // If this detail is not already listed as tracked then add it so that we re-evaluate it's usage
            details[0, $1ae5573ce493bccc$export$a0a330e7fa1e278c /* @min:%2epush */ ](detail);
        }
    }
    theState = (_a = {
        prop: dynamicPropertySymbol,
        ro: dynamicPropertyReadOnly,
        rf: dynamicPropertyReferenced
    }, _a[0, $1ae5573ce493bccc$export$9d71a37f0770d87f /* @min:blkVal */ ] = dynamicPropertyBlockValue, _a[0, $1ae5573ce493bccc$export$d17a699c20d379ac /* @min:hdlr */ ] = cfgHandler, _a.add = _addWatcher, _a[0, $1ae5573ce493bccc$export$6c2b24c6eee14c46 /* @min:notify */ ] = _notifyWatchers, _a.use = _useHandler, _a.trk = _trackHandler, _a);
    return theState;
}



/**
 * Identifies a function which will be re-called whenever any of it's accessed configuration values
 * change.
 * @param configHandler - The callback that will be called for the initial request and then whenever any
 * accessed configuration changes are identified.
 */ function $acb30f9e62dc5705$var$_createAndUseHandler(state, configHandler) {
    var handler = {
        fn: configHandler,
        rm: function() {
            // Clear all references to the handler so it can be garbage collected
            // This will also cause this handler to never get called and eventually removed
            handler.fn = null;
            state = null;
            configHandler = null;
        }
    };
    state.use(handler, configHandler);
    return handler;
}
/**
 * Creates the dynamic config handler and associates with the target config as the root object
 * @param target - The config that you want to be root of the dynamic config
 * @param inPlace - Should the passed config be converted in-place or a new proxy returned
 * @returns The existing dynamic handler or a new instance with the provided config values
 */ function $acb30f9e62dc5705$var$_createDynamicHandler(logger, target, inPlace) {
    var _a;
    var dynamicHandler = (0, $36be0cb20f115b6f$export$ebfc7adde882cbe6)(target);
    if (dynamicHandler) // The passed config is already dynamic so return it's tracker
    return dynamicHandler;
    var uid = (0, $8a2d104e2647a310$export$eb4a6badb18ead04)("dyncfg", true);
    var newTarget = target && inPlace !== false ? target : (0, $36be0cb20f115b6f$export$36c4765ffcb8ffc1)(target);
    var theState;
    function _notifyWatchers() {
        theState[0, $1ae5573ce493bccc$export$6c2b24c6eee14c46 /* @min:%2enotify */ ]();
    }
    function _setValue(target, name, value) {
        try {
            target = (0, $b2527bd3661c8e9e$export$7d85a661fa08a14d)(theState, target, name, value);
        } catch (e) {
            // Unable to convert to dynamic property so just leave as non-dynamic
            (0, $b2527bd3661c8e9e$export$6103ab389f3208de)(logger, name, "Setting value", e);
        }
        return target[name];
    }
    function _watch(configHandler) {
        return $acb30f9e62dc5705$var$_createAndUseHandler(theState, configHandler);
    }
    function _block(configHandler, allowUpdate) {
        theState.use(null, function(details) {
            var prevUpd = theState.upd;
            try {
                if (!(0, $533f826bbc418791$export$fce6876652108ab)(allowUpdate)) theState.upd = allowUpdate;
                configHandler(details);
            } finally{
                theState.upd = prevUpd;
            }
        });
    }
    function _ref(target, name) {
        var _a;
        // Make sure it's dynamic and mark as referenced with it's current value
        return (0, $b2527bd3661c8e9e$export$945b6f6a011a9f7a)(theState, target, name, (_a = {}, _a[0 /* _eSetDynamicPropertyFlags.inPlace */ ] = true, _a))[name];
    }
    function _rdOnly(target, name) {
        var _a;
        // Make sure it's dynamic and mark as readonly with it's current value
        return (0, $b2527bd3661c8e9e$export$945b6f6a011a9f7a)(theState, target, name, (_a = {}, _a[1 /* _eSetDynamicPropertyFlags.readOnly */ ] = true, _a))[name];
    }
    function _blkPropValue(target, name) {
        var _a;
        // Make sure it's dynamic and mark as readonly with it's current value
        return (0, $b2527bd3661c8e9e$export$945b6f6a011a9f7a)(theState, target, name, (_a = {}, _a[2 /* _eSetDynamicPropertyFlags.blockDynamicProperty */ ] = true, _a))[name];
    }
    function _applyDefaults(theConfig, defaultValues) {
        if (defaultValues) // Resolve/apply the defaults
        (0, $45e528077703ac0c$export$aa0705d5774c95d1)(defaultValues, function(name, value) {
            // Sets the value and makes it dynamic (if it doesn't already exist)
            (0, $2b347a3380a9d5e1$export$f11b7d3a4617b9e9)(cfgHandler, theConfig, name, value);
        });
        return theConfig;
    }
    var cfgHandler = (_a = {
        uid: null,
        cfg: newTarget
    }, _a[0, $1ae5573ce493bccc$export$e6a243fe757439f9 /* @min:logger */ ] = logger, _a[0, $1ae5573ce493bccc$export$6c2b24c6eee14c46 /* @min:notify */ ] = _notifyWatchers, _a.set = _setValue, _a[0, $1ae5573ce493bccc$export$24caac6d68ff1537 /* @min:setDf */ ] = _applyDefaults, _a[0, $1ae5573ce493bccc$export$fc59eec8d77f3766 /* @min:watch */ ] = _watch, _a.ref = _ref, _a[0, $1ae5573ce493bccc$export$9e4bb115c58de388 /* @min:rdOnly */ ] = _rdOnly, _a[0, $1ae5573ce493bccc$export$9d71a37f0770d87f /* @min:blkVal */ ] = _blkPropValue, _a._block = _block, _a);
    (0, $d212d948d25f959a$export$d0d2ebf910ad6e2)(cfgHandler, "uid", {
        c: false,
        e: false,
        w: false,
        v: uid
    });
    theState = (0, $83c3e1b1398a495d$export$8b125ae28a27d4c)(cfgHandler);
    // Setup tracking for all defined default keys
    (0, $b2527bd3661c8e9e$export$f24b4ed0a40d3d27)(theState, newTarget, "config", "Creating");
    return cfgHandler;
}
/**
 * Log an invalid access message to the console
 * @param message
 */ function $acb30f9e62dc5705$var$_logInvalidAccess(logger, message) {
    if (logger) {
        logger[0, $1ae5573ce493bccc$export$667d3cd09d258d38 /* @min:%2ewarnToConsole */ ](message);
        logger[0, $1ae5573ce493bccc$export$6c078c21a0c6c1ce /* @min:%2ethrowInternal */ ](2 /* eLoggingSeverity.WARNING */ , 108 /* _eInternalMessageId.DynamicConfigException */ , message);
    } else // We don't have a logger so just throw an exception
    (0, $36be0cb20f115b6f$export$e2aa058b2c3c7959)(message);
}
function $acb30f9e62dc5705$export$3a9e9180c14487fd(config, defaultConfig, logger, inPlace) {
    var dynamicHandler = $acb30f9e62dc5705$var$_createDynamicHandler(logger, config || {}, inPlace);
    if (defaultConfig) dynamicHandler[0, $1ae5573ce493bccc$export$24caac6d68ff1537 /* @min:%2esetDf */ ](dynamicHandler.cfg, defaultConfig);
    return dynamicHandler;
}
function $acb30f9e62dc5705$export$454a433e4deb244f(config, configHandler, logger) {
    var handler = config[0, $36be0cb20f115b6f$export$3af51e1f665d1d72] || config;
    if (handler.cfg && (handler.cfg === config || handler.cfg[0, $36be0cb20f115b6f$export$3af51e1f665d1d72] === handler)) return handler[0, $1ae5573ce493bccc$export$fc59eec8d77f3766 /* @min:%2ewatch */ ](configHandler);
    $acb30f9e62dc5705$var$_logInvalidAccess(logger, (0, $9fe4a5d5204a4cff$export$80c7dcdabc53a7db) + (0, $386f00e3a193a7da$export$21fce7cbd4dc679f)(config));
    return $acb30f9e62dc5705$export$3a9e9180c14487fd(config, null, logger)[0, $1ae5573ce493bccc$export$fc59eec8d77f3766 /* @min:%2ewatch */ ](configHandler);
}



/*
 * Application Insights JavaScript SDK - Core, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 


var $12f08319fee74ea0$var$listenerFuncs = [
    (0, $9fe4a5d5204a4cff$export$bb3c4bc1b1175d3d),
    (0, $9fe4a5d5204a4cff$export$bacb5b2f4c1081b9),
    (0, $9fe4a5d5204a4cff$export$d75e063cb88a1c25),
    (0, $9fe4a5d5204a4cff$export$5d265841733c97c3)
];
var $12f08319fee74ea0$var$_aiNamespace = null;
var $12f08319fee74ea0$var$_debugListener;
function $12f08319fee74ea0$var$_listenerProxyFunc(name, config) {
    return function() {
        var args = arguments;
        var dbgExt = $12f08319fee74ea0$export$a0b1f407ae6b45dc(config);
        if (dbgExt) {
            var listener = dbgExt.listener;
            if (listener && listener[name]) listener[name][0, $1ae5573ce493bccc$export$2f85ca6962b15ff8 /* @min:%2eapply */ ](listener, args);
        }
    };
}
function $12f08319fee74ea0$var$_getExtensionNamespace() {
    // Cache the lookup of the global namespace object
    var target = (0, $3d5fcb60a9467a45$export$3df6e51375017edd)("Microsoft");
    if (target) $12f08319fee74ea0$var$_aiNamespace = target["ApplicationInsights"];
    return $12f08319fee74ea0$var$_aiNamespace;
}
function $12f08319fee74ea0$export$a0b1f407ae6b45dc(config) {
    var ns = $12f08319fee74ea0$var$_aiNamespace;
    if (!ns && config.disableDbgExt !== true) ns = $12f08319fee74ea0$var$_aiNamespace || $12f08319fee74ea0$var$_getExtensionNamespace();
    return ns ? ns["ChromeDbgExt"] : null;
}
function $12f08319fee74ea0$export$dae5ac50a0df0f5f(config) {
    if (!$12f08319fee74ea0$var$_debugListener) {
        $12f08319fee74ea0$var$_debugListener = {};
        for(var lp = 0; lp < $12f08319fee74ea0$var$listenerFuncs[0, $1ae5573ce493bccc$export$6eae51590aaea43 /* @min:%2elength */ ]; lp++)$12f08319fee74ea0$var$_debugListener[$12f08319fee74ea0$var$listenerFuncs[lp]] = $12f08319fee74ea0$var$_listenerProxyFunc($12f08319fee74ea0$var$listenerFuncs[lp], config);
    }
    return $12f08319fee74ea0$var$_debugListener;
}




"use strict";
var $cc2aaaebf96ac6a7$var$_a;
var $cc2aaaebf96ac6a7$var$STR_WARN_TO_CONSOLE = "warnToConsole";
/**
 * For user non actionable traces use AI Internal prefix.
 */ var $cc2aaaebf96ac6a7$var$AiNonUserActionablePrefix = "AI (Internal): ";
/**
 * Prefix of the traces in portal.
 */ var $cc2aaaebf96ac6a7$var$AiUserActionablePrefix = "AI: ";
/**
 *  Session storage key for the prefix for the key indicating message type already logged
 */ var $cc2aaaebf96ac6a7$var$AIInternalMessagePrefix = "AITR_";
var $cc2aaaebf96ac6a7$var$defaultValues = {
    loggingLevelConsole: 0,
    loggingLevelTelemetry: 1,
    maxMessageLimit: 25,
    enableDebug: false
};
var $cc2aaaebf96ac6a7$var$_logFuncs = ($cc2aaaebf96ac6a7$var$_a = {}, $cc2aaaebf96ac6a7$var$_a[0 /* eLoggingSeverity.DISABLED */ ] = null, $cc2aaaebf96ac6a7$var$_a[1 /* eLoggingSeverity.CRITICAL */ ] = "errorToConsole", $cc2aaaebf96ac6a7$var$_a[2 /* eLoggingSeverity.WARNING */ ] = $cc2aaaebf96ac6a7$var$STR_WARN_TO_CONSOLE, $cc2aaaebf96ac6a7$var$_a[3 /* eLoggingSeverity.DEBUG */ ] = "debugToConsole", $cc2aaaebf96ac6a7$var$_a);
function $cc2aaaebf96ac6a7$var$_sanitizeDiagnosticText(text) {
    if (text) return '"' + text[0, $1ae5573ce493bccc$export$ef9ef3ed86c4485 /* @min:%2ereplace */ ](/\"/g, (0, $9fe4a5d5204a4cff$export$5e8607ab26634759)) + '"';
    return 0, $9fe4a5d5204a4cff$export$5e8607ab26634759;
}
function $cc2aaaebf96ac6a7$var$_logToConsole(func, message) {
    var theConsole = (0, $0c599844349363c4$export$bbe488cec1edd401)();
    if (!!theConsole) {
        var logFunc = "log";
        if (theConsole[func]) logFunc = func;
        if ((0, $533f826bbc418791$export$f6e2535fb5126e54)(theConsole[logFunc])) theConsole[logFunc](message);
    }
}
var $cc2aaaebf96ac6a7$export$70ef838ed08aad47 = /** @class */ function() {
    function _InternalLogMessage(msgId, msg, isUserAct, properties) {
        if (isUserAct === void 0) isUserAct = false;
        var _self = this;
        _self[0, $1ae5573ce493bccc$export$2cc5b49df2eed261 /* @min:%2emessageId */ ] = msgId;
        _self[0, $1ae5573ce493bccc$export$923606b70907833e /* @min:%2emessage */ ] = (isUserAct ? $cc2aaaebf96ac6a7$var$AiUserActionablePrefix : $cc2aaaebf96ac6a7$var$AiNonUserActionablePrefix) + msgId;
        var strProps = (0, $9fe4a5d5204a4cff$export$5e8607ab26634759);
        if ((0, $0c599844349363c4$export$a2856ab6913b9fff)()) strProps = (0, $0c599844349363c4$export$d047a7c56db64af4)().stringify(properties);
        var diagnosticText = (msg ? " message:" + $cc2aaaebf96ac6a7$var$_sanitizeDiagnosticText(msg) : (0, $9fe4a5d5204a4cff$export$5e8607ab26634759)) + (properties ? " props:" + $cc2aaaebf96ac6a7$var$_sanitizeDiagnosticText(strProps) : (0, $9fe4a5d5204a4cff$export$5e8607ab26634759));
        _self[0, $1ae5573ce493bccc$export$923606b70907833e /* @min:%2emessage */ ] += diagnosticText;
    }
    _InternalLogMessage.dataType = "MessageData";
    return _InternalLogMessage;
}();
function $cc2aaaebf96ac6a7$export$5102d32ea1d740a(core, config) {
    return (core || {})[0, $1ae5573ce493bccc$export$e6a243fe757439f9 /* @min:%2elogger */ ] || new $cc2aaaebf96ac6a7$export$4f80edb2e10dc14c(config);
}
var $cc2aaaebf96ac6a7$export$4f80edb2e10dc14c = /** @class */ function() {
    function DiagnosticLogger(config) {
        this.identifier = "DiagnosticLogger";
        /**
         * The internal logging queue
         */ this.queue = [];
        /**
         * Count of internal messages sent
         */ var _messageCount = 0;
        /**
         * Holds information about what message types were already logged to console or sent to server.
         */ var _messageLogged = {};
        var _loggingLevelConsole;
        var _loggingLevelTelemetry;
        var _maxInternalMessageLimit;
        var _enableDebug;
        var _unloadHandler;
        (0, $c9b63384299a3252$export$2e2bcd8739ae039)(DiagnosticLogger, this, function(_self) {
            _unloadHandler = _setDefaultsFromConfig(config || {});
            _self.consoleLoggingLevel = function() {
                return _loggingLevelConsole;
            };
            /**
             * This method will throw exceptions in debug mode or attempt to log the error as a console warning.
             * @param severity - {LoggingSeverity} - The severity of the log message
             * @param message - {_InternalLogMessage} - The log message.
             */ _self[0, $1ae5573ce493bccc$export$6c078c21a0c6c1ce /* @min:%2ethrowInternal */ ] = function(severity, msgId, msg, properties, isUserAct) {
                if (isUserAct === void 0) isUserAct = false;
                var message = new $cc2aaaebf96ac6a7$export$70ef838ed08aad47(msgId, msg, isUserAct, properties);
                if (_enableDebug) throw (0, $386f00e3a193a7da$export$21fce7cbd4dc679f)(message);
                else {
                    // Get the logging function and fallback to warnToConsole of for some reason errorToConsole doesn't exist
                    var logFunc = $cc2aaaebf96ac6a7$var$_logFuncs[severity] || $cc2aaaebf96ac6a7$var$STR_WARN_TO_CONSOLE;
                    if (!(0, $533f826bbc418791$export$fce6876652108ab)(message[0, $1ae5573ce493bccc$export$923606b70907833e /* @min:%2emessage */ ])) {
                        if (isUserAct) {
                            // check if this message type was already logged to console for this page view and if so, don't log it again
                            var messageKey = +message[0, $1ae5573ce493bccc$export$2cc5b49df2eed261 /* @min:%2emessageId */ ];
                            if (!_messageLogged[messageKey] && _loggingLevelConsole >= severity) {
                                _self[logFunc](message[0, $1ae5573ce493bccc$export$923606b70907833e /* @min:%2emessage */ ]);
                                _messageLogged[messageKey] = true;
                            }
                        } else // Only log traces if the console Logging Level is >= the throwInternal severity level
                        if (_loggingLevelConsole >= severity) _self[logFunc](message[0, $1ae5573ce493bccc$export$923606b70907833e /* @min:%2emessage */ ]);
                        _logInternalMessage(severity, message);
                    } else _debugExtMsg("throw" + (severity === 1 /* eLoggingSeverity.CRITICAL */  ? "Critical" : "Warning"), message);
                }
            };
            _self.debugToConsole = function(message) {
                $cc2aaaebf96ac6a7$var$_logToConsole("debug", message);
                _debugExtMsg("warning", message);
            };
            _self[0, $1ae5573ce493bccc$export$667d3cd09d258d38 /* @min:%2ewarnToConsole */ ] = function(message) {
                $cc2aaaebf96ac6a7$var$_logToConsole("warn", message);
                _debugExtMsg("warning", message);
            };
            _self.errorToConsole = function(message) {
                $cc2aaaebf96ac6a7$var$_logToConsole("error", message);
                _debugExtMsg("error", message);
            };
            _self.resetInternalMessageCount = function() {
                _messageCount = 0;
                _messageLogged = {};
            };
            _self[0, $1ae5573ce493bccc$export$6a3333b2109fff2a /* @min:%2elogInternalMessage */ ] = _logInternalMessage;
            _self[0, $1ae5573ce493bccc$export$7eb85b5cba77a43d /* @min:%2eunload */ ] = function(isAsync) {
                _unloadHandler && _unloadHandler.rm();
                _unloadHandler = null;
            };
            function _logInternalMessage(severity, message) {
                if (_areInternalMessagesThrottled()) return;
                // check if this message type was already logged for this session and if so, don't log it again
                var logMessage = true;
                var messageKey = $cc2aaaebf96ac6a7$var$AIInternalMessagePrefix + message[0, $1ae5573ce493bccc$export$2cc5b49df2eed261 /* @min:%2emessageId */ ];
                // if the session storage is not available, limit to only one message type per page view
                if (_messageLogged[messageKey]) logMessage = false;
                else _messageLogged[messageKey] = true;
                if (logMessage) {
                    // Push the event in the internal queue
                    if (severity <= _loggingLevelTelemetry) {
                        _self.queue[0, $1ae5573ce493bccc$export$a0a330e7fa1e278c /* @min:%2epush */ ](message);
                        _messageCount++;
                        _debugExtMsg(severity === 1 /* eLoggingSeverity.CRITICAL */  ? "error" : "warn", message);
                    }
                    // When throttle limit reached, send a special event
                    if (_messageCount === _maxInternalMessageLimit) {
                        var throttleLimitMessage = "Internal events throttle limit per PageView reached for this app.";
                        var throttleMessage = new $cc2aaaebf96ac6a7$export$70ef838ed08aad47(23 /* _eInternalMessageId.MessageLimitPerPVExceeded */ , throttleLimitMessage, false);
                        _self.queue[0, $1ae5573ce493bccc$export$a0a330e7fa1e278c /* @min:%2epush */ ](throttleMessage);
                        if (severity === 1 /* eLoggingSeverity.CRITICAL */ ) _self.errorToConsole(throttleLimitMessage);
                        else _self[0, $1ae5573ce493bccc$export$667d3cd09d258d38 /* @min:%2ewarnToConsole */ ](throttleLimitMessage);
                    }
                }
            }
            function _setDefaultsFromConfig(config) {
                // make sure the config is dynamic
                return (0, $acb30f9e62dc5705$export$454a433e4deb244f)((0, $acb30f9e62dc5705$export$3a9e9180c14487fd)(config, $cc2aaaebf96ac6a7$var$defaultValues, _self).cfg, function(details) {
                    var config = details.cfg;
                    _loggingLevelConsole = config[0, $1ae5573ce493bccc$export$e53d8cae4d527530 /* @min:%2eloggingLevelConsole */ ];
                    _loggingLevelTelemetry = config.loggingLevelTelemetry;
                    _maxInternalMessageLimit = config.maxMessageLimit;
                    _enableDebug = config.enableDebug;
                });
            }
            function _areInternalMessagesThrottled() {
                return _messageCount >= _maxInternalMessageLimit;
            }
            function _debugExtMsg(name, data) {
                var dbgExt = (0, $12f08319fee74ea0$export$a0b1f407ae6b45dc)(config || {});
                if (dbgExt && dbgExt[0, $1ae5573ce493bccc$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ]) dbgExt[0, $1ae5573ce493bccc$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](name, data);
            }
        });
    }
    // Removed Stub for DiagnosticLogger.prototype.consoleLoggingLevel.
    // Removed Stub for DiagnosticLogger.prototype.throwInternal.
    // Removed Stub for DiagnosticLogger.prototype.debugToConsole.
    // Removed Stub for DiagnosticLogger.prototype.warnToConsole.
    // Removed Stub for DiagnosticLogger.prototype.errorToConsole.
    // Removed Stub for DiagnosticLogger.prototype.resetInternalMessageCount.
    // Removed Stub for DiagnosticLogger.prototype.logInternalMessage.
    // Removed Stub for DiagnosticLogger.prototype.unload.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    DiagnosticLogger.__ieDyn = 1;
    return DiagnosticLogger;
}();
function $cc2aaaebf96ac6a7$var$_getLogger(logger) {
    return logger || new $cc2aaaebf96ac6a7$export$4f80edb2e10dc14c();
}
function $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4(logger, severity, msgId, msg, properties, isUserAct) {
    if (isUserAct === void 0) isUserAct = false;
    $cc2aaaebf96ac6a7$var$_getLogger(logger)[0, $1ae5573ce493bccc$export$6c078c21a0c6c1ce /* @min:%2ethrowInternal */ ](severity, msgId, msg, properties, isUserAct);
}
function $cc2aaaebf96ac6a7$export$25fb4cb97863f0a8(logger, message) {
    $cc2aaaebf96ac6a7$var$_getLogger(logger)[0, $1ae5573ce493bccc$export$667d3cd09d258d38 /* @min:%2ewarnToConsole */ ](message);
}
function $cc2aaaebf96ac6a7$export$e15fbe42d9bc9d3d(logger, severity, message) {
    $cc2aaaebf96ac6a7$var$_getLogger(logger)[0, $1ae5573ce493bccc$export$6a3333b2109fff2a /* @min:%2elogInternalMessage */ ](severity, message);
}



/*
 * Application Insights JavaScript SDK - Common, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var $db8f3a1d23da96b1$export$b889f1d4cb07c706 = "split"; // Count: 6
var $db8f3a1d23da96b1$export$6eae51590aaea43 = "length"; // Count: 41
var $db8f3a1d23da96b1$export$e4eaee9e01d9baaa = "toLowerCase"; // Count: 6
var $db8f3a1d23da96b1$export$3960f2eafedb8f1 = "ingestionendpoint"; // Count: 4
var $db8f3a1d23da96b1$export$e2818d11505fa034 = "toString"; // Count: 9
var $db8f3a1d23da96b1$export$596e0e0dc14a1e9b = "removeItem"; // Count: 3
var $db8f3a1d23da96b1$export$9734b0a24bf02e93 = "name"; // Count: 11
var $db8f3a1d23da96b1$export$923606b70907833e = "message"; // Count: 10
var $db8f3a1d23da96b1$export$e9679ef501b0d1 = "count"; // Count: 8
var $db8f3a1d23da96b1$export$89a9ed6e0f1c703a = "preTriggerDate"; // Count: 4
var $db8f3a1d23da96b1$export$bf48f5cc9167f468 = "disabled"; // Count: 3
var $db8f3a1d23da96b1$export$67d4e5d95e63e1b3 = "interval"; // Count: 3
var $db8f3a1d23da96b1$export$ffc8d7f1d37c54ec = "daysOfMonth"; // Count: 3
var $db8f3a1d23da96b1$export$abbddaba4ad71f38 = "date"; // Count: 5
var $db8f3a1d23da96b1$export$44cd8e854cee592d = "getUTCDate"; // Count: 3
var $db8f3a1d23da96b1$export$a318a8141fc98747 = "stringify"; // Count: 4
var $db8f3a1d23da96b1$export$34ec22d747521ad = "pathname"; // Count: 4
var $db8f3a1d23da96b1$export$89ce3552c03e8ec9 = "correlationHeaderExcludePatterns"; // Count: 2
var $db8f3a1d23da96b1$export$e298802ab42a3b7f = "extensionConfig"; // Count: 4
var $db8f3a1d23da96b1$export$967696d490ed5a4a = "exceptions"; // Count: 6
var $db8f3a1d23da96b1$export$4b848bcab7cafe5d = "parsedStack"; // Count: 13
var $db8f3a1d23da96b1$export$14814e6f9bf337b4 = "properties"; // Count: 9
var $db8f3a1d23da96b1$export$32fc64677eb5b7a2 = "measurements"; // Count: 9
var $db8f3a1d23da96b1$export$59a1581bc81a9aae = "sizeInBytes"; // Count: 11
var $db8f3a1d23da96b1$export$6008dba8ea08a587 = "typeName"; // Count: 11
var $db8f3a1d23da96b1$export$2675b0014c60aa10 = "severityLevel"; // Count: 5
var $db8f3a1d23da96b1$export$5bc84cbcfe97e161 = "problemGroup"; // Count: 3
var $db8f3a1d23da96b1$export$880f71e9a894c474 = "isManual"; // Count: 3
var $db8f3a1d23da96b1$export$aadef743ee7d1db8 = "CreateFromInterface"; // Count: 2
var $db8f3a1d23da96b1$export$7e3ee7b01672f321 = "assembly"; // Count: 7
var $db8f3a1d23da96b1$export$b1b7551538b2085 = "hasFullStack"; // Count: 6
var $db8f3a1d23da96b1$export$25f3022e0cda8855 = "level"; // Count: 5
var $db8f3a1d23da96b1$export$47d30bd816d62bdc = "method"; // Count: 7
var $db8f3a1d23da96b1$export$8ea03ef8a4bcfeeb = "fileName"; // Count: 6
var $db8f3a1d23da96b1$export$138215f6c1f0eedf = "line"; // Count: 6
var $db8f3a1d23da96b1$export$aa395e58f404db90 = "duration"; // Count: 4
var $db8f3a1d23da96b1$export$e046465ee502552 = "receivedResponse"; // Count: 2


function $8c3059962bb1d83c$export$1e3742b0a5fad0e9(logger, key, map) {
    var origLength = key[0, $db8f3a1d23da96b1$export$6eae51590aaea43 /* @min:%2elength */ ];
    var field = $8c3059962bb1d83c$export$100c3b44eeb2bd0b(logger, key);
    // validation truncated the length.  We need to add uniqueness
    if (field[0, $db8f3a1d23da96b1$export$6eae51590aaea43 /* @min:%2elength */ ] !== origLength) {
        var i = 0;
        var uniqueField = field;
        while(map[uniqueField] !== undefined){
            i++;
            uniqueField = (0, $c3f3bf8012a4b2d4$export$9d1aa7361d7a6e87)(field, 0, 147) + $8c3059962bb1d83c$export$d924cb9df01a6484(i);
        }
        field = uniqueField;
    }
    return field;
}
function $8c3059962bb1d83c$export$100c3b44eeb2bd0b(logger, name) {
    var nameTrunc;
    if (name) {
        // Remove any leading or trailing whitespace
        name = (0, $f67365b40c49b6c1$export$ef0e11c5f5f351f7)((0, $d813f4522b40a37e$export$590567be997858b6)(name));
        // truncate the string to 150 chars
        if (name[0, $db8f3a1d23da96b1$export$6eae51590aaea43 /* @min:%2elength */ ] > 150 /* DataSanitizerValues.MAX_NAME_LENGTH */ ) {
            nameTrunc = (0, $c3f3bf8012a4b2d4$export$9d1aa7361d7a6e87)(name, 0, 150 /* DataSanitizerValues.MAX_NAME_LENGTH */ );
            (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , 57 /* _eInternalMessageId.NameTooLong */ , "name is too long.  It has been truncated to 150 characters.", {
                name: name
            }, true);
        }
    }
    return nameTrunc || name;
}
function $8c3059962bb1d83c$export$4e25b1d4bcd67eb8(logger, value, maxLength) {
    if (maxLength === void 0) maxLength = 1024 /* DataSanitizerValues.MAX_STRING_LENGTH */ ;
    var valueTrunc;
    if (value) {
        maxLength = maxLength ? maxLength : 1024 /* DataSanitizerValues.MAX_STRING_LENGTH */ ; // in case default parameters dont work
        value = (0, $f67365b40c49b6c1$export$ef0e11c5f5f351f7)((0, $d813f4522b40a37e$export$590567be997858b6)(value));
        if (value[0, $db8f3a1d23da96b1$export$6eae51590aaea43 /* @min:%2elength */ ] > maxLength) {
            valueTrunc = (0, $c3f3bf8012a4b2d4$export$9d1aa7361d7a6e87)(value, 0, maxLength);
            (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , 61 /* _eInternalMessageId.StringValueTooLong */ , "string value is too long. It has been truncated to " + maxLength + " characters.", {
                value: value
            }, true);
        }
    }
    return valueTrunc || value;
}
function $8c3059962bb1d83c$export$356146502a9f860c(logger, url) {
    return $8c3059962bb1d83c$export$8860beb3484248f1(logger, url, 2048 /* DataSanitizerValues.MAX_URL_LENGTH */ , 66 /* _eInternalMessageId.UrlTooLong */ );
}
function $8c3059962bb1d83c$export$dff84a9939b48dc0(logger, message) {
    var messageTrunc;
    if (message) {
        if (message[0, $db8f3a1d23da96b1$export$6eae51590aaea43 /* @min:%2elength */ ] > 32768 /* DataSanitizerValues.MAX_MESSAGE_LENGTH */ ) {
            messageTrunc = (0, $c3f3bf8012a4b2d4$export$9d1aa7361d7a6e87)(message, 0, 32768 /* DataSanitizerValues.MAX_MESSAGE_LENGTH */ );
            (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , 56 /* _eInternalMessageId.MessageTruncated */ , "message is too long, it has been truncated to 32768 characters.", {
                message: message
            }, true);
        }
    }
    return messageTrunc || message;
}
function $8c3059962bb1d83c$export$e47d8a961052f8bc(logger, exception) {
    var exceptionTrunc;
    if (exception) {
        // Make surte its a string
        var value = "" + exception;
        if (value[0, $db8f3a1d23da96b1$export$6eae51590aaea43 /* @min:%2elength */ ] > 32768 /* DataSanitizerValues.MAX_EXCEPTION_LENGTH */ ) {
            exceptionTrunc = (0, $c3f3bf8012a4b2d4$export$9d1aa7361d7a6e87)(value, 0, 32768 /* DataSanitizerValues.MAX_EXCEPTION_LENGTH */ );
            (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , 52 /* _eInternalMessageId.ExceptionTruncated */ , "exception is too long, it has been truncated to 32768 characters.", {
                exception: exception
            }, true);
        }
    }
    return exceptionTrunc || exception;
}
function $8c3059962bb1d83c$export$efba9e468fe3b2cf(logger, properties) {
    if (properties) {
        var tempProps_1 = {};
        (0, $45e528077703ac0c$export$aa0705d5774c95d1)(properties, function(prop, value) {
            if ((0, $533f826bbc418791$export$a6cdc56e425d0d0a)(value) && (0, $0c599844349363c4$export$a2856ab6913b9fff)()) // Stringify any part C properties
            try {
                value = (0, $0c599844349363c4$export$d047a7c56db64af4)()[0, $db8f3a1d23da96b1$export$a318a8141fc98747 /* @min:%2estringify */ ](value);
            } catch (e) {
                (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , 49 /* _eInternalMessageId.CannotSerializeObjectNonSerializable */ , "custom property is not valid", {
                    exception: e
                }, true);
            }
            value = $8c3059962bb1d83c$export$4e25b1d4bcd67eb8(logger, value, 8192 /* DataSanitizerValues.MAX_PROPERTY_LENGTH */ );
            prop = $8c3059962bb1d83c$export$1e3742b0a5fad0e9(logger, prop, tempProps_1);
            tempProps_1[prop] = value;
        });
        properties = tempProps_1;
    }
    return properties;
}
function $8c3059962bb1d83c$export$3f0e10abe91e800b(logger, measurements) {
    if (measurements) {
        var tempMeasurements_1 = {};
        (0, $45e528077703ac0c$export$aa0705d5774c95d1)(measurements, function(measure, value) {
            measure = $8c3059962bb1d83c$export$1e3742b0a5fad0e9(logger, measure, tempMeasurements_1);
            tempMeasurements_1[measure] = value;
        });
        measurements = tempMeasurements_1;
    }
    return measurements;
}
function $8c3059962bb1d83c$export$808d3905d3d31f01(logger, id) {
    return id ? $8c3059962bb1d83c$export$8860beb3484248f1(logger, id, 128 /* DataSanitizerValues.MAX_ID_LENGTH */ , 69 /* _eInternalMessageId.IdTooLong */ )[0, $db8f3a1d23da96b1$export$e2818d11505fa034 /* @min:%2etoString */ ]() : id;
}
function $8c3059962bb1d83c$export$8860beb3484248f1(logger, input, maxLength, _msgId) {
    var inputTrunc;
    if (input) {
        input = (0, $f67365b40c49b6c1$export$ef0e11c5f5f351f7)((0, $d813f4522b40a37e$export$590567be997858b6)(input));
        if (input[0, $db8f3a1d23da96b1$export$6eae51590aaea43 /* @min:%2elength */ ] > maxLength) {
            inputTrunc = (0, $c3f3bf8012a4b2d4$export$9d1aa7361d7a6e87)(input, 0, maxLength);
            (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , _msgId, "input is too long, it has been truncated to " + maxLength + " characters.", {
                data: input
            }, true);
        }
    }
    return inputTrunc || input;
}
function $8c3059962bb1d83c$export$d924cb9df01a6484(num) {
    var s = "00" + num;
    return (0, $c3f3bf8012a4b2d4$export$25b2a9bb66b0078d)(s, s[0, $db8f3a1d23da96b1$export$6eae51590aaea43 /* @min:%2elength */ ] - 3);
}


/*
 * Application Insights JavaScript SDK - Common, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 

var $8ef642882a9aa00a$var$_document = (0, $3d5fcb60a9467a45$export$f65ca476c09acec0)() || {};
var $8ef642882a9aa00a$var$_htmlAnchorIdx = 0;
// Use an array of temporary values as it's possible for multiple calls to parseUrl() will be called with different URLs
// Using a cache size of 5 for now as it current depth usage is at least 2, so adding a minor buffer to handle future updates
var $8ef642882a9aa00a$var$_htmlAnchorElement = [
    null,
    null,
    null,
    null,
    null
];
function $8ef642882a9aa00a$export$7121b8cb971a9df2(url) {
    var anchorIdx = $8ef642882a9aa00a$var$_htmlAnchorIdx;
    var anchorCache = $8ef642882a9aa00a$var$_htmlAnchorElement;
    var tempAnchor = anchorCache[anchorIdx];
    if (!$8ef642882a9aa00a$var$_document.createElement) // Always create the temp instance if createElement is not available
    tempAnchor = {
        host: $8ef642882a9aa00a$export$ff1d1b7a9bae98f(url, true)
    };
    else if (!anchorCache[anchorIdx]) // Create and cache the unattached anchor instance
    tempAnchor = anchorCache[anchorIdx] = $8ef642882a9aa00a$var$_document.createElement("a");
    tempAnchor.href = url;
    // Move the cache index forward
    anchorIdx++;
    if (anchorIdx >= anchorCache[0, $db8f3a1d23da96b1$export$6eae51590aaea43 /* @min:%2elength */ ]) anchorIdx = 0;
    $8ef642882a9aa00a$var$_htmlAnchorIdx = anchorIdx;
    return tempAnchor;
}
function $8ef642882a9aa00a$export$a98678973ebe2123(url) {
    var result;
    var a = $8ef642882a9aa00a$export$7121b8cb971a9df2(url);
    if (a) result = a.href;
    return result;
}
function $8ef642882a9aa00a$export$d19e0ccf7100cfb3(url) {
    var result;
    var a = $8ef642882a9aa00a$export$7121b8cb971a9df2(url);
    if (a) result = a[0, $db8f3a1d23da96b1$export$34ec22d747521ad /* @min:%2epathname */ ];
    return result;
}
function $8ef642882a9aa00a$export$b959f3bc0a239498(method, absoluteUrl) {
    if (method) return method.toUpperCase() + " " + absoluteUrl;
    return absoluteUrl;
}
function $8ef642882a9aa00a$export$ff1d1b7a9bae98f(url, inclPort) {
    var fullHost = $8ef642882a9aa00a$export$eac70d47569302de(url, inclPort) || "";
    if (fullHost) {
        var match = fullHost.match(/(www\d{0,5}\.)?([^\/:]{1,256})(:\d{1,20})?/i);
        if (match != null && match[0, $db8f3a1d23da96b1$export$6eae51590aaea43 /* @min:%2elength */ ] > 3 && (0, $533f826bbc418791$export$844ec244b1367d54)(match[2]) && match[2][0, $db8f3a1d23da96b1$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) return match[2] + (match[3] || "");
    }
    return fullHost;
}
function $8ef642882a9aa00a$export$eac70d47569302de(url, inclPort) {
    var result = null;
    if (url) {
        var match = url.match(/(\w{1,150}):\/\/([^\/:]{1,256})(:\d{1,20})?/i);
        if (match != null && match[0, $db8f3a1d23da96b1$export$6eae51590aaea43 /* @min:%2elength */ ] > 2 && (0, $533f826bbc418791$export$844ec244b1367d54)(match[2]) && match[2][0, $db8f3a1d23da96b1$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) {
            result = match[2] || "";
            if (inclPort && match[0, $db8f3a1d23da96b1$export$6eae51590aaea43 /* @min:%2elength */ ] > 2) {
                var protocol = (match[1] || "")[0, $db8f3a1d23da96b1$export$e4eaee9e01d9baaa /* @min:%2etoLowerCase */ ]();
                var port = match[3] || "";
                // IE includes the standard port so pass it off if it's the same as the protocol
                if (protocol === "http" && port === ":80") port = "";
                else if (protocol === "https" && port === ":443") port = "";
                result += port;
            }
        }
    }
    return result;
}



// listing only non-geo specific locations
var $d98b699aeccdabc6$var$_internalEndpoints = [
    (0, $71dfba5ea0640485$export$5c9ec0fce655ebcf) + (0, $71dfba5ea0640485$export$e6c0f3431c6cd728),
    "https://breeze.aimon.applicationinsights.io" + (0, $71dfba5ea0640485$export$e6c0f3431c6cd728),
    "https://dc-int.services.visualstudio.com" + (0, $71dfba5ea0640485$export$e6c0f3431c6cd728)
];
var $d98b699aeccdabc6$var$_correlationIdPrefix = "cid-v1:";
function $d98b699aeccdabc6$export$edade5317663baa4(endpointUrl) {
    return (0, $a96d4958027d6f85$export$9f3b3ffa84393d30)($d98b699aeccdabc6$var$_internalEndpoints, endpointUrl[0, $db8f3a1d23da96b1$export$e4eaee9e01d9baaa /* @min:%2etoLowerCase */ ]()) !== -1;
}
function $d98b699aeccdabc6$export$11cd7bb42a058181(prefix) {
    $d98b699aeccdabc6$var$_correlationIdPrefix = prefix;
}
function $d98b699aeccdabc6$export$34b74e57304d137() {
    return $d98b699aeccdabc6$var$_correlationIdPrefix;
}
function $d98b699aeccdabc6$export$a62d10d7f896c08c(config, requestUrl, currentHost) {
    if (!requestUrl || config && config.disableCorrelationHeaders) return false;
    if (config && config[0, $db8f3a1d23da96b1$export$89ce3552c03e8ec9 /* @min:%2ecorrelationHeaderExcludePatterns */ ]) for(var i = 0; i < config.correlationHeaderExcludePatterns[0, $db8f3a1d23da96b1$export$6eae51590aaea43 /* @min:%2elength */ ]; i++){
        if (config[0, $db8f3a1d23da96b1$export$89ce3552c03e8ec9 /* @min:%2ecorrelationHeaderExcludePatterns */ ][i].test(requestUrl)) return false;
    }
    var requestHost = (0, $8ef642882a9aa00a$export$7121b8cb971a9df2)(requestUrl).host[0, $db8f3a1d23da96b1$export$e4eaee9e01d9baaa /* @min:%2etoLowerCase */ ]();
    if (requestHost && ((0, $0194d45a55d79548$export$7c0888b0c4641088)(requestHost, ":443") !== -1 || (0, $0194d45a55d79548$export$7c0888b0c4641088)(requestHost, ":80") !== -1)) // [Bug #1260] IE can include the port even for http and https URLs so if present
    // try and parse it to remove if it matches the default protocol port
    requestHost = ((0, $8ef642882a9aa00a$export$eac70d47569302de)(requestUrl, true) || "")[0, $db8f3a1d23da96b1$export$e4eaee9e01d9baaa /* @min:%2etoLowerCase */ ]();
    if ((!config || !config.enableCorsCorrelation) && requestHost && requestHost !== currentHost) return false;
    var includedDomains = config && config.correlationHeaderDomains;
    if (includedDomains) {
        var matchExists_1;
        (0, $f6bb085f8cf12216$export$e2e5bcdbdc49c586)(includedDomains, function(domain) {
            var regex = new RegExp(domain.toLowerCase().replace(/\\/g, "\\\\").replace(/\./g, "\\.").replace(/\*/g, ".*"));
            matchExists_1 = matchExists_1 || regex.test(requestHost);
        });
        if (!matchExists_1) return false;
    }
    var excludedDomains = config && config.correlationHeaderExcludedDomains;
    if (!excludedDomains || excludedDomains[0, $db8f3a1d23da96b1$export$6eae51590aaea43 /* @min:%2elength */ ] === 0) return true;
    for(var i = 0; i < excludedDomains[0, $db8f3a1d23da96b1$export$6eae51590aaea43 /* @min:%2elength */ ]; i++){
        var regex = new RegExp(excludedDomains[i].toLowerCase().replace(/\\/g, "\\\\").replace(/\./g, "\\.").replace(/\*/g, ".*"));
        if (regex.test(requestHost)) return false;
    }
    // if we don't know anything about the requestHost, require the user to use included/excludedDomains.
    // Previously we always returned false for a falsy requestHost
    return requestHost && requestHost[0, $db8f3a1d23da96b1$export$6eae51590aaea43 /* @min:%2elength */ ] > 0;
}
function $d98b699aeccdabc6$export$dbaf37203f788583(responseHeader) {
    if (responseHeader) {
        var correlationId = $d98b699aeccdabc6$export$23620a0eaa22fb00(responseHeader, (0, $78a4729d55fca66a$export$e499e02a1fe05177)[1 /* eRequestHeaders.requestContextTargetKey */ ]);
        if (correlationId && correlationId !== $d98b699aeccdabc6$var$_correlationIdPrefix) return correlationId;
    }
}
function $d98b699aeccdabc6$export$23620a0eaa22fb00(responseHeader, key) {
    if (responseHeader) {
        var keyValues = responseHeader[0, $db8f3a1d23da96b1$export$b889f1d4cb07c706 /* @min:%2esplit */ ](",");
        for(var i = 0; i < keyValues[0, $db8f3a1d23da96b1$export$6eae51590aaea43 /* @min:%2elength */ ]; ++i){
            var keyValue = keyValues[i][0, $db8f3a1d23da96b1$export$b889f1d4cb07c706 /* @min:%2esplit */ ]("=");
            if (keyValue[0, $db8f3a1d23da96b1$export$6eae51590aaea43 /* @min:%2elength */ ] === 2 && keyValue[0] === key) return keyValue[1];
        }
    }
}
function $d98b699aeccdabc6$export$92b0aba7cb1d0e30(logger, absoluteUrl, method, commandName) {
    var target, name = commandName, data = commandName;
    if (absoluteUrl && absoluteUrl[0, $db8f3a1d23da96b1$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) {
        var parsedUrl = (0, $8ef642882a9aa00a$export$7121b8cb971a9df2)(absoluteUrl);
        target = parsedUrl.host;
        if (!name) {
            if (parsedUrl[0, $db8f3a1d23da96b1$export$34ec22d747521ad /* @min:%2epathname */ ] != null) {
                var pathName = parsedUrl.pathname[0, $db8f3a1d23da96b1$export$6eae51590aaea43 /* @min:%2elength */ ] === 0 ? "/" : parsedUrl[0, $db8f3a1d23da96b1$export$34ec22d747521ad /* @min:%2epathname */ ];
                if (pathName.charAt(0) !== "/") pathName = "/" + pathName;
                data = parsedUrl[0, $db8f3a1d23da96b1$export$34ec22d747521ad /* @min:%2epathname */ ];
                name = (0, $8c3059962bb1d83c$export$4e25b1d4bcd67eb8)(logger, method ? method + " " + pathName : pathName);
            } else name = (0, $8c3059962bb1d83c$export$4e25b1d4bcd67eb8)(logger, absoluteUrl);
        }
    } else {
        target = commandName;
        name = commandName;
    }
    return {
        target: target,
        name: name,
        data: data
    };
}
function $d98b699aeccdabc6$export$30a447e32c58a836() {
    // returns the window or webworker performance object
    var perf = (0, $824d7bc9d9e48f68$export$28a0276e10aa78d7)();
    if (perf && perf.now && perf.timing) {
        var now = perf.now() + perf.timing.navigationStart;
        // Known issue with IE where this calculation can be negative, so if it is then ignore and fallback
        if (now > 0) return now;
    }
    return (0, $628cad25a0769458$export$a56f095995763cca)();
}
function $d98b699aeccdabc6$export$bfc7deb7f4f00987(start, end) {
    var result = null;
    if (start !== 0 && end !== 0 && !(0, $533f826bbc418791$export$bedb7023a7733221)(start) && !(0, $533f826bbc418791$export$bedb7023a7733221)(end)) result = end - start;
    return result;
}
function $d98b699aeccdabc6$export$847d5dabba5fabb9(telemetryTrace, parentCtx) {
    var trace = telemetryTrace || {};
    return {
        getName: function() {
            return trace[0, $db8f3a1d23da96b1$export$9734b0a24bf02e93 /* @min:%2ename */ ];
        },
        setName: function(newValue) {
            parentCtx && parentCtx.setName(newValue);
            trace[0, $db8f3a1d23da96b1$export$9734b0a24bf02e93 /* @min:%2ename */ ] = newValue;
        },
        getTraceId: function() {
            return trace.traceID;
        },
        setTraceId: function(newValue) {
            parentCtx && parentCtx.setTraceId(newValue);
            if ((0, $6f47dad7a26666b5$export$29dd34cf1269f6da)(newValue)) trace.traceID = newValue;
        },
        getSpanId: function() {
            return trace.parentID;
        },
        setSpanId: function(newValue) {
            parentCtx && parentCtx.setSpanId(newValue);
            if ((0, $6f47dad7a26666b5$export$8e51c6d8f0586aff)(newValue)) trace.parentID = newValue;
        },
        getTraceFlags: function() {
            return trace.traceFlags;
        },
        setTraceFlags: function(newTraceFlags) {
            parentCtx && parentCtx.setTraceFlags(newTraceFlags);
            trace.traceFlags = newTraceFlags;
        }
    };
}



/*
 * Application Insights JavaScript SDK - Common, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ /*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */ 

var $63cf4b7ad6b789c0$export$a16e2b23dbd5466c = (0, $d491d25af4ac425c$export$34d1cd0b62238dad)("reduce", (0, $b347daff6f5f8dc1$export$f3f471c81a14426));




var $41f84b9a47a38dfe$var$_FIELDS_SEPARATOR = ";";
var $41f84b9a47a38dfe$var$_FIELD_KEY_VALUE_SEPARATOR = "=";
function $41f84b9a47a38dfe$export$6369f286b474466d(connectionString) {
    if (!connectionString) return {};
    var kvPairs = connectionString[0, $db8f3a1d23da96b1$export$b889f1d4cb07c706 /* @min:%2esplit */ ]($41f84b9a47a38dfe$var$_FIELDS_SEPARATOR);
    var result = (0, $63cf4b7ad6b789c0$export$a16e2b23dbd5466c)(kvPairs, function(fields, kv) {
        var kvParts = kv[0, $db8f3a1d23da96b1$export$b889f1d4cb07c706 /* @min:%2esplit */ ]($41f84b9a47a38dfe$var$_FIELD_KEY_VALUE_SEPARATOR);
        if (kvParts[0, $db8f3a1d23da96b1$export$6eae51590aaea43 /* @min:%2elength */ ] === 2) {
            var key = kvParts[0][0, $db8f3a1d23da96b1$export$e4eaee9e01d9baaa /* @min:%2etoLowerCase */ ]();
            var value = kvParts[1];
            fields[key] = value;
        }
        return fields;
    }, {});
    if ((0, $36a077d9f4439b69$export$f7628dc18f4211e5)(result)[0, $db8f3a1d23da96b1$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) {
        // this is a valid connection string, so parse the results
        if (result.endpointsuffix) {
            // use endpoint suffix where overrides are not provided
            var locationPrefix = result.location ? result.location + "." : "";
            result[0, $db8f3a1d23da96b1$export$3960f2eafedb8f1 /* @min:%2eingestionendpoint */ ] = result[0, $db8f3a1d23da96b1$export$3960f2eafedb8f1 /* @min:%2eingestionendpoint */ ] || "https://" + locationPrefix + "dc." + result.endpointsuffix;
        }
        // apply the default endpoints
        result[0, $db8f3a1d23da96b1$export$3960f2eafedb8f1 /* @min:%2eingestionendpoint */ ] = result[0, $db8f3a1d23da96b1$export$3960f2eafedb8f1 /* @min:%2eingestionendpoint */ ] || (0, $71dfba5ea0640485$export$5c9ec0fce655ebcf);
    }
    return result;
}
var $41f84b9a47a38dfe$export$9fc8be9be2105769 = {
    parse: $41f84b9a47a38dfe$export$6369f286b474466d
};




/*
 * Application Insights JavaScript SDK - Common, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 



var $a383874e4b463649$export$4e2d65a9843399df = /** @class */ function() {
    /**
     * Constructs a new instance of telemetry data.
     */ function Envelope(logger, data, name) {
        var _this = this;
        var _self = this;
        _self.ver = 1;
        _self.sampleRate = 100.0;
        _self.tags = {};
        _self[0, $db8f3a1d23da96b1$export$9734b0a24bf02e93 /* @min:%2ename */ ] = (0, $8c3059962bb1d83c$export$4e25b1d4bcd67eb8)(logger, name) || (0, $71dfba5ea0640485$export$4003f5e1672d759);
        _self.data = data;
        _self.time = (0, $0b747974b0bb3563$export$dfaaa8705752128f)(new Date());
        _self.aiDataContract = {
            time: 1 /* FieldType.Required */ ,
            iKey: 1 /* FieldType.Required */ ,
            name: 1 /* FieldType.Required */ ,
            sampleRate: function() {
                return _this.sampleRate === 100 ? 4 /* FieldType.Hidden */  : 1 /* FieldType.Required */ ;
            },
            tags: 1 /* FieldType.Required */ ,
            data: 1 /* FieldType.Required */ 
        };
    }
    return Envelope;
}();


/*
 * Application Insights JavaScript SDK - Common, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 


var $9bdc8b7e7935e83a$export$d61e24a684f9e51 = /** @class */ function() {
    /**
     * Constructs a new instance of the EventTelemetry object
     */ function Event(logger, name, properties, measurements) {
        this.aiDataContract = {
            ver: 1 /* FieldType.Required */ ,
            name: 1 /* FieldType.Required */ ,
            properties: 0 /* FieldType.Default */ ,
            measurements: 0 /* FieldType.Default */ 
        };
        var _self = this;
        _self.ver = 2;
        _self[0, $db8f3a1d23da96b1$export$9734b0a24bf02e93 /* @min:%2ename */ ] = (0, $8c3059962bb1d83c$export$4e25b1d4bcd67eb8)(logger, name) || (0, $71dfba5ea0640485$export$4003f5e1672d759);
        _self[0, $db8f3a1d23da96b1$export$14814e6f9bf337b4 /* @min:%2eproperties */ ] = (0, $8c3059962bb1d83c$export$efba9e468fe3b2cf)(logger, properties);
        _self[0, $db8f3a1d23da96b1$export$32fc64677eb5b7a2 /* @min:%2emeasurements */ ] = (0, $8c3059962bb1d83c$export$3f0e10abe91e800b)(logger, measurements);
    }
    Event.envelopeType = "Microsoft.ApplicationInsights.{0}.Event";
    Event.dataType = "EventData";
    return Event;
}();


/*
 * Application Insights JavaScript SDK - Common, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */ 

var $7ce500be4896551d$export$76f1a28030e24fa6 = (0, $d491d25af4ac425c$export$34d1cd0b62238dad)("map", (0, $b347daff6f5f8dc1$export$f3f471c81a14426));






var $1e8d24b24fb574aa$var$NoMethod = "<no_method>";
var $1e8d24b24fb574aa$var$strError = "error";
var $1e8d24b24fb574aa$var$strStack = "stack";
var $1e8d24b24fb574aa$var$strStackDetails = "stackDetails";
var $1e8d24b24fb574aa$var$strErrorSrc = "errorSrc";
var $1e8d24b24fb574aa$var$strMessage = "message";
var $1e8d24b24fb574aa$var$strDescription = "description";
function $1e8d24b24fb574aa$var$_stringify(value, convertToString) {
    var result = value;
    if (result && !(0, $533f826bbc418791$export$844ec244b1367d54)(result)) {
        if (JSON && JSON[0, $db8f3a1d23da96b1$export$a318a8141fc98747 /* @min:%2estringify */ ]) {
            result = JSON[0, $db8f3a1d23da96b1$export$a318a8141fc98747 /* @min:%2estringify */ ](value);
            if (convertToString && (!result || result === "{}")) {
                if ((0, $533f826bbc418791$export$f6e2535fb5126e54)(value[0, $db8f3a1d23da96b1$export$e2818d11505fa034 /* @min:%2etoString */ ])) result = value[0, $db8f3a1d23da96b1$export$e2818d11505fa034 /* @min:%2etoString */ ]();
                else result = "" + value;
            }
        } else result = "" + value + " - (Missing JSON.stringify)";
    }
    return result || "";
}
function $1e8d24b24fb574aa$var$_formatMessage(theEvent, errorType) {
    var evtMessage = theEvent;
    if (theEvent) {
        if (evtMessage && !(0, $533f826bbc418791$export$844ec244b1367d54)(evtMessage)) evtMessage = theEvent[$1e8d24b24fb574aa$var$strMessage] || theEvent[$1e8d24b24fb574aa$var$strDescription] || evtMessage;
        // Make sure the message is a string
        if (evtMessage && !(0, $533f826bbc418791$export$844ec244b1367d54)(evtMessage)) // tslint:disable-next-line: prefer-conditional-expression
        evtMessage = $1e8d24b24fb574aa$var$_stringify(evtMessage, true);
        if (theEvent["filename"]) // Looks like an event object with filename
        evtMessage = evtMessage + " @" + (theEvent["filename"] || "") + ":" + (theEvent["lineno"] || "?") + ":" + (theEvent["colno"] || "?");
    }
    // Automatically add the error type to the message if it does already appear to be present
    if (errorType && errorType !== "String" && errorType !== "Object" && errorType !== "Error" && (0, $0194d45a55d79548$export$7c0888b0c4641088)(evtMessage || "", errorType) === -1) evtMessage = errorType + ": " + evtMessage;
    return evtMessage || "";
}
function $1e8d24b24fb574aa$var$_isExceptionDetailsInternal(value) {
    try {
        if ((0, $533f826bbc418791$export$a6cdc56e425d0d0a)(value)) return "hasFullStack" in value && "typeName" in value;
    } catch (e) {
    // This can happen with some native browser objects, but should not happen for the type we are checking for
    }
    return false;
}
function $1e8d24b24fb574aa$var$_isExceptionInternal(value) {
    try {
        if ((0, $533f826bbc418791$export$a6cdc56e425d0d0a)(value)) return "ver" in value && "exceptions" in value && "properties" in value;
    } catch (e) {
    // This can happen with some native browser objects, but should not happen for the type we are checking for
    }
    return false;
}
function $1e8d24b24fb574aa$var$_isStackDetails(details) {
    return details && details.src && (0, $533f826bbc418791$export$844ec244b1367d54)(details.src) && details.obj && (0, $533f826bbc418791$export$43bee75e5e14138e)(details.obj);
}
function $1e8d24b24fb574aa$var$_convertStackObj(errorStack) {
    var src = errorStack || "";
    if (!(0, $533f826bbc418791$export$844ec244b1367d54)(src)) {
        if ((0, $533f826bbc418791$export$844ec244b1367d54)(src[$1e8d24b24fb574aa$var$strStack])) src = src[$1e8d24b24fb574aa$var$strStack];
        else src = "" + src;
    }
    var items = src[0, $db8f3a1d23da96b1$export$b889f1d4cb07c706 /* @min:%2esplit */ ]("\n");
    return {
        src: src,
        obj: items
    };
}
function $1e8d24b24fb574aa$var$_getOperaStack(errorMessage) {
    var stack = [];
    var lines = errorMessage[0, $db8f3a1d23da96b1$export$b889f1d4cb07c706 /* @min:%2esplit */ ]("\n");
    for(var lp = 0; lp < lines[0, $db8f3a1d23da96b1$export$6eae51590aaea43 /* @min:%2elength */ ]; lp++){
        var entry = lines[lp];
        if (lines[lp + 1]) {
            entry += "@" + lines[lp + 1];
            lp++;
        }
        stack.push(entry);
    }
    return {
        src: errorMessage,
        obj: stack
    };
}
function $1e8d24b24fb574aa$var$_getStackFromErrorObj(errorObj) {
    var details = null;
    if (errorObj) try {
        /* Using bracket notation is support older browsers (IE 7/8 -- dont remember the version) that throw when using dot
            notation for undefined objects and we don't want to loose the error from being reported */ if (errorObj[$1e8d24b24fb574aa$var$strStack]) // Chrome/Firefox
        details = $1e8d24b24fb574aa$var$_convertStackObj(errorObj[$1e8d24b24fb574aa$var$strStack]);
        else if (errorObj[$1e8d24b24fb574aa$var$strError] && errorObj[$1e8d24b24fb574aa$var$strError][$1e8d24b24fb574aa$var$strStack]) // Edge error event provides the stack and error object
        details = $1e8d24b24fb574aa$var$_convertStackObj(errorObj[$1e8d24b24fb574aa$var$strError][$1e8d24b24fb574aa$var$strStack]);
        else if (errorObj["exception"] && errorObj.exception[$1e8d24b24fb574aa$var$strStack]) details = $1e8d24b24fb574aa$var$_convertStackObj(errorObj.exception[$1e8d24b24fb574aa$var$strStack]);
        else if ($1e8d24b24fb574aa$var$_isStackDetails(errorObj)) details = errorObj;
        else if ($1e8d24b24fb574aa$var$_isStackDetails(errorObj[$1e8d24b24fb574aa$var$strStackDetails])) details = errorObj[$1e8d24b24fb574aa$var$strStackDetails];
        else if (window && window["opera"] && errorObj[$1e8d24b24fb574aa$var$strMessage]) // Opera
        details = $1e8d24b24fb574aa$var$_getOperaStack(errorObj[0, $db8f3a1d23da96b1$export$923606b70907833e /* @min:%2emessage */ ]);
        else if (errorObj["reason"] && errorObj.reason[$1e8d24b24fb574aa$var$strStack]) // UnhandledPromiseRejection
        details = $1e8d24b24fb574aa$var$_convertStackObj(errorObj.reason[$1e8d24b24fb574aa$var$strStack]);
        else if ((0, $533f826bbc418791$export$844ec244b1367d54)(errorObj)) details = $1e8d24b24fb574aa$var$_convertStackObj(errorObj);
        else {
            var evtMessage = errorObj[$1e8d24b24fb574aa$var$strMessage] || errorObj[$1e8d24b24fb574aa$var$strDescription] || "";
            if ((0, $533f826bbc418791$export$844ec244b1367d54)(errorObj[$1e8d24b24fb574aa$var$strErrorSrc])) {
                if (evtMessage) evtMessage += "\n";
                evtMessage += " from " + errorObj[$1e8d24b24fb574aa$var$strErrorSrc];
            }
            if (evtMessage) details = $1e8d24b24fb574aa$var$_convertStackObj(evtMessage);
        }
    } catch (e) {
        // something unexpected happened so to avoid failing to report any error lets swallow the exception
        // and fallback to the callee/caller method
        details = $1e8d24b24fb574aa$var$_convertStackObj(e);
    }
    return details || {
        src: "",
        obj: null
    };
}
function $1e8d24b24fb574aa$var$_formatStackTrace(stackDetails) {
    var stack = "";
    if (stackDetails) {
        if (stackDetails.obj) (0, $f6bb085f8cf12216$export$e2e5bcdbdc49c586)(stackDetails.obj, function(entry) {
            stack += entry + "\n";
        });
        else stack = stackDetails.src || "";
    }
    return stack;
}
function $1e8d24b24fb574aa$var$_parseStack(stack) {
    var parsedStack;
    var frames = stack.obj;
    if (frames && frames[0, $db8f3a1d23da96b1$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) {
        parsedStack = [];
        var level_1 = 0;
        var totalSizeInBytes_1 = 0;
        (0, $f6bb085f8cf12216$export$e2e5bcdbdc49c586)(frames, function(frame) {
            var theFrame = frame[0, $db8f3a1d23da96b1$export$e2818d11505fa034 /* @min:%2etoString */ ]();
            if ($1e8d24b24fb574aa$export$b9d0519a34c90616.regex.test(theFrame)) {
                var parsedFrame = new $1e8d24b24fb574aa$export$b9d0519a34c90616(theFrame, level_1++);
                totalSizeInBytes_1 += parsedFrame[0, $db8f3a1d23da96b1$export$59a1581bc81a9aae /* @min:%2esizeInBytes */ ];
                parsedStack.push(parsedFrame);
            }
        });
        // DP Constraint - exception parsed stack must be < 32KB
        // remove frames from the middle to meet the threshold
        var exceptionParsedStackThreshold = 32768;
        if (totalSizeInBytes_1 > exceptionParsedStackThreshold) {
            var left = 0;
            var right = parsedStack[0, $db8f3a1d23da96b1$export$6eae51590aaea43 /* @min:%2elength */ ] - 1;
            var size = 0;
            var acceptedLeft = left;
            var acceptedRight = right;
            while(left < right){
                // check size
                var lSize = parsedStack[left][0, $db8f3a1d23da96b1$export$59a1581bc81a9aae /* @min:%2esizeInBytes */ ];
                var rSize = parsedStack[right][0, $db8f3a1d23da96b1$export$59a1581bc81a9aae /* @min:%2esizeInBytes */ ];
                size += lSize + rSize;
                if (size > exceptionParsedStackThreshold) {
                    // remove extra frames from the middle
                    var howMany = acceptedRight - acceptedLeft + 1;
                    parsedStack.splice(acceptedLeft, howMany);
                    break;
                }
                // update pointers
                acceptedLeft = left;
                acceptedRight = right;
                left++;
                right--;
            }
        }
    }
    return parsedStack;
}
function $1e8d24b24fb574aa$var$_getErrorType(errorType) {
    // Gets the Error Type by passing the constructor (used to get the true type of native error object).
    var typeName = "";
    if (errorType) {
        typeName = errorType.typeName || errorType[0, $db8f3a1d23da96b1$export$9734b0a24bf02e93 /* @min:%2ename */ ] || "";
        if (!typeName) try {
            var funcNameRegex = /function (.{1,200})\(/;
            var results = funcNameRegex.exec(errorType.constructor[0, $db8f3a1d23da96b1$export$e2818d11505fa034 /* @min:%2etoString */ ]());
            typeName = results && results[0, $db8f3a1d23da96b1$export$6eae51590aaea43 /* @min:%2elength */ ] > 1 ? results[1] : "";
        } catch (e) {
        // eslint-disable-next-line no-empty -- Ignoring any failures as nothing we can do
        }
    }
    return typeName;
}
function $1e8d24b24fb574aa$export$7eb96e918bb60d21(errorObj) {
    if (errorObj) try {
        if (!(0, $533f826bbc418791$export$844ec244b1367d54)(errorObj)) {
            var errorType = $1e8d24b24fb574aa$var$_getErrorType(errorObj);
            var result = $1e8d24b24fb574aa$var$_stringify(errorObj, false);
            if (!result || result === "{}") {
                if (errorObj[$1e8d24b24fb574aa$var$strError]) {
                    // Looks like an MS Error Event
                    errorObj = errorObj[$1e8d24b24fb574aa$var$strError];
                    errorType = $1e8d24b24fb574aa$var$_getErrorType(errorObj);
                }
                result = $1e8d24b24fb574aa$var$_stringify(errorObj, true);
            }
            if ((0, $0194d45a55d79548$export$7c0888b0c4641088)(result, errorType) !== 0 && errorType !== "String") return errorType + ":" + result;
            return result;
        }
    } catch (e) {
    // eslint-disable-next-line no-empty -- Ignoring any failures as nothing we can do
    }
    // Fallback to just letting the object format itself into a string
    return "" + (errorObj || "");
}
var $1e8d24b24fb574aa$export$e2f174de097e0bcd = /** @class */ function() {
    /**
     * Constructs a new instance of the ExceptionTelemetry object
     */ function Exception(logger, exception, properties, measurements, severityLevel, id) {
        this.aiDataContract = {
            ver: 1 /* FieldType.Required */ ,
            exceptions: 1 /* FieldType.Required */ ,
            severityLevel: 0 /* FieldType.Default */ ,
            properties: 0 /* FieldType.Default */ ,
            measurements: 0 /* FieldType.Default */ 
        };
        var _self = this;
        _self.ver = 2; // TODO: handle the CS"4.0" ==> breeze 2 conversion in a better way
        if (!$1e8d24b24fb574aa$var$_isExceptionInternal(exception)) {
            if (!properties) properties = {};
            _self[0, $db8f3a1d23da96b1$export$967696d490ed5a4a /* @min:%2eexceptions */ ] = [
                new $1e8d24b24fb574aa$export$39152eac9dc76c5e(logger, exception, properties)
            ];
            _self[0, $db8f3a1d23da96b1$export$14814e6f9bf337b4 /* @min:%2eproperties */ ] = (0, $8c3059962bb1d83c$export$efba9e468fe3b2cf)(logger, properties);
            _self[0, $db8f3a1d23da96b1$export$32fc64677eb5b7a2 /* @min:%2emeasurements */ ] = (0, $8c3059962bb1d83c$export$3f0e10abe91e800b)(logger, measurements);
            if (severityLevel) _self[0, $db8f3a1d23da96b1$export$2675b0014c60aa10 /* @min:%2eseverityLevel */ ] = severityLevel;
            if (id) _self.id = id;
        } else {
            _self[0, $db8f3a1d23da96b1$export$967696d490ed5a4a /* @min:%2eexceptions */ ] = exception[0, $db8f3a1d23da96b1$export$967696d490ed5a4a /* @min:%2eexceptions */ ] || [];
            _self[0, $db8f3a1d23da96b1$export$14814e6f9bf337b4 /* @min:%2eproperties */ ] = exception[0, $db8f3a1d23da96b1$export$14814e6f9bf337b4 /* @min:%2eproperties */ ];
            _self[0, $db8f3a1d23da96b1$export$32fc64677eb5b7a2 /* @min:%2emeasurements */ ] = exception[0, $db8f3a1d23da96b1$export$32fc64677eb5b7a2 /* @min:%2emeasurements */ ];
            if (exception[0, $db8f3a1d23da96b1$export$2675b0014c60aa10 /* @min:%2eseverityLevel */ ]) _self[0, $db8f3a1d23da96b1$export$2675b0014c60aa10 /* @min:%2eseverityLevel */ ] = exception[0, $db8f3a1d23da96b1$export$2675b0014c60aa10 /* @min:%2eseverityLevel */ ];
            if (exception.id) _self.id = exception.id;
            if (exception[0, $db8f3a1d23da96b1$export$5bc84cbcfe97e161 /* @min:%2eproblemGroup */ ]) _self[0, $db8f3a1d23da96b1$export$5bc84cbcfe97e161 /* @min:%2eproblemGroup */ ] = exception[0, $db8f3a1d23da96b1$export$5bc84cbcfe97e161 /* @min:%2eproblemGroup */ ];
            // bool/int types, use isNullOrUndefined
            if (!(0, $533f826bbc418791$export$bedb7023a7733221)(exception[0, $db8f3a1d23da96b1$export$880f71e9a894c474 /* @min:%2eisManual */ ])) _self[0, $db8f3a1d23da96b1$export$880f71e9a894c474 /* @min:%2eisManual */ ] = exception[0, $db8f3a1d23da96b1$export$880f71e9a894c474 /* @min:%2eisManual */ ];
        }
    }
    Exception.CreateAutoException = function(message, url, lineNumber, columnNumber, error, evt, stack, errorSrc) {
        var _a;
        var errorType = $1e8d24b24fb574aa$var$_getErrorType(error || evt || message);
        return _a = {}, _a[0, $db8f3a1d23da96b1$export$923606b70907833e /* @min:message */ ] = $1e8d24b24fb574aa$var$_formatMessage(message, errorType), _a.url = url, _a.lineNumber = lineNumber, _a.columnNumber = columnNumber, _a.error = $1e8d24b24fb574aa$export$7eb96e918bb60d21(error || evt || message), _a.evt = $1e8d24b24fb574aa$export$7eb96e918bb60d21(evt || message), _a[0, $db8f3a1d23da96b1$export$6008dba8ea08a587 /* @min:typeName */ ] = errorType, _a.stackDetails = $1e8d24b24fb574aa$var$_getStackFromErrorObj(stack || error || evt), _a.errorSrc = errorSrc, _a;
    };
    Exception.CreateFromInterface = function(logger, exception, properties, measurements) {
        var exceptions = exception[0, $db8f3a1d23da96b1$export$967696d490ed5a4a /* @min:%2eexceptions */ ] && (0, $7ce500be4896551d$export$76f1a28030e24fa6)(exception[0, $db8f3a1d23da96b1$export$967696d490ed5a4a /* @min:%2eexceptions */ ], function(ex) {
            return $1e8d24b24fb574aa$export$39152eac9dc76c5e[0, $db8f3a1d23da96b1$export$aadef743ee7d1db8 /* @min:%2eCreateFromInterface */ ](logger, ex);
        });
        var exceptionData = new Exception(logger, (0, $2a74b38b87b38cda$export$b3cf7a802e578501)((0, $2a74b38b87b38cda$export$b3cf7a802e578501)({}, exception), {
            exceptions: exceptions
        }), properties, measurements);
        return exceptionData;
    };
    Exception.prototype.toInterface = function() {
        var _a;
        var _b = this, exceptions = _b.exceptions, properties = _b.properties, measurements = _b.measurements, severityLevel = _b.severityLevel, problemGroup = _b.problemGroup, id = _b.id, isManual = _b.isManual;
        var exceptionDetailsInterface = exceptions instanceof Array && (0, $7ce500be4896551d$export$76f1a28030e24fa6)(exceptions, function(exception) {
            return exception.toInterface();
        }) || undefined;
        return _a = {
            ver: "4.0"
        }, _a[0, $db8f3a1d23da96b1$export$967696d490ed5a4a /* @min:exceptions */ ] = exceptionDetailsInterface, _a.severityLevel = severityLevel, _a.properties = properties, _a.measurements = measurements, _a.problemGroup = problemGroup, _a.id = id, _a.isManual = isManual, _a;
    };
    /**
     * Creates a simple exception with 1 stack frame. Useful for manual constracting of exception.
     */ Exception.CreateSimpleException = function(message, typeName, assembly, fileName, details, line) {
        var _a;
        return {
            exceptions: [
                (_a = {}, _a[0, $db8f3a1d23da96b1$export$b1b7551538b2085 /* @min:hasFullStack */ ] = true, _a.message = message, _a.stack = details, _a.typeName = typeName, _a)
            ]
        };
    };
    Exception.envelopeType = "Microsoft.ApplicationInsights.{0}.Exception";
    Exception.dataType = "ExceptionData";
    Exception.formatError = $1e8d24b24fb574aa$export$7eb96e918bb60d21;
    return Exception;
}();
var $1e8d24b24fb574aa$export$39152eac9dc76c5e = /** @class */ function() {
    function _ExceptionDetails(logger, exception, properties) {
        this.aiDataContract = {
            id: 0 /* FieldType.Default */ ,
            outerId: 0 /* FieldType.Default */ ,
            typeName: 1 /* FieldType.Required */ ,
            message: 1 /* FieldType.Required */ ,
            hasFullStack: 0 /* FieldType.Default */ ,
            stack: 0 /* FieldType.Default */ ,
            parsedStack: 2 /* FieldType.Array */ 
        };
        var _self = this;
        if (!$1e8d24b24fb574aa$var$_isExceptionDetailsInternal(exception)) {
            var error = exception;
            var evt = error && error.evt;
            if (!(0, $533f826bbc418791$export$e6127cc7fe7395c3)(error)) error = error[$1e8d24b24fb574aa$var$strError] || evt || error;
            _self[0, $db8f3a1d23da96b1$export$6008dba8ea08a587 /* @min:%2etypeName */ ] = (0, $8c3059962bb1d83c$export$4e25b1d4bcd67eb8)(logger, $1e8d24b24fb574aa$var$_getErrorType(error)) || (0, $71dfba5ea0640485$export$4003f5e1672d759);
            _self[0, $db8f3a1d23da96b1$export$923606b70907833e /* @min:%2emessage */ ] = (0, $8c3059962bb1d83c$export$dff84a9939b48dc0)(logger, $1e8d24b24fb574aa$var$_formatMessage(exception || error, _self[0, $db8f3a1d23da96b1$export$6008dba8ea08a587 /* @min:%2etypeName */ ])) || (0, $71dfba5ea0640485$export$4003f5e1672d759);
            var stack = exception[$1e8d24b24fb574aa$var$strStackDetails] || $1e8d24b24fb574aa$var$_getStackFromErrorObj(exception);
            _self[0, $db8f3a1d23da96b1$export$4b848bcab7cafe5d /* @min:%2eparsedStack */ ] = $1e8d24b24fb574aa$var$_parseStack(stack);
            // after parsedStack is inited, iterate over each frame object, sanitize its assembly field
            if ((0, $533f826bbc418791$export$43bee75e5e14138e)(_self[0, $db8f3a1d23da96b1$export$4b848bcab7cafe5d /* @min:%2eparsedStack */ ])) (0, $7ce500be4896551d$export$76f1a28030e24fa6)(_self[0, $db8f3a1d23da96b1$export$4b848bcab7cafe5d /* @min:%2eparsedStack */ ], function(frame) {
                return frame[0, $db8f3a1d23da96b1$export$7e3ee7b01672f321 /* @min:%2eassembly */ ] = (0, $8c3059962bb1d83c$export$4e25b1d4bcd67eb8)(logger, frame[0, $db8f3a1d23da96b1$export$7e3ee7b01672f321 /* @min:%2eassembly */ ]);
            });
            _self[$1e8d24b24fb574aa$var$strStack] = (0, $8c3059962bb1d83c$export$e47d8a961052f8bc)(logger, $1e8d24b24fb574aa$var$_formatStackTrace(stack));
            _self.hasFullStack = (0, $533f826bbc418791$export$43bee75e5e14138e)(_self.parsedStack) && _self.parsedStack[0, $db8f3a1d23da96b1$export$6eae51590aaea43 /* @min:%2elength */ ] > 0;
            if (properties) properties[0, $db8f3a1d23da96b1$export$6008dba8ea08a587 /* @min:%2etypeName */ ] = properties[0, $db8f3a1d23da96b1$export$6008dba8ea08a587 /* @min:%2etypeName */ ] || _self[0, $db8f3a1d23da96b1$export$6008dba8ea08a587 /* @min:%2etypeName */ ];
        } else {
            _self[0, $db8f3a1d23da96b1$export$6008dba8ea08a587 /* @min:%2etypeName */ ] = exception[0, $db8f3a1d23da96b1$export$6008dba8ea08a587 /* @min:%2etypeName */ ];
            _self[0, $db8f3a1d23da96b1$export$923606b70907833e /* @min:%2emessage */ ] = exception[0, $db8f3a1d23da96b1$export$923606b70907833e /* @min:%2emessage */ ];
            _self[$1e8d24b24fb574aa$var$strStack] = exception[$1e8d24b24fb574aa$var$strStack];
            _self[0, $db8f3a1d23da96b1$export$4b848bcab7cafe5d /* @min:%2eparsedStack */ ] = exception[0, $db8f3a1d23da96b1$export$4b848bcab7cafe5d /* @min:%2eparsedStack */ ] || [];
            _self[0, $db8f3a1d23da96b1$export$b1b7551538b2085 /* @min:%2ehasFullStack */ ] = exception[0, $db8f3a1d23da96b1$export$b1b7551538b2085 /* @min:%2ehasFullStack */ ];
        }
    }
    _ExceptionDetails.prototype.toInterface = function() {
        var _a;
        var _self = this;
        var parsedStack = _self[0, $db8f3a1d23da96b1$export$4b848bcab7cafe5d /* @min:%2eparsedStack */ ] instanceof Array && (0, $7ce500be4896551d$export$76f1a28030e24fa6)(_self[0, $db8f3a1d23da96b1$export$4b848bcab7cafe5d /* @min:%2eparsedStack */ ], function(frame) {
            return frame.toInterface();
        });
        var exceptionDetailsInterface = (_a = {
            id: _self.id,
            outerId: _self.outerId,
            typeName: _self[0, $db8f3a1d23da96b1$export$6008dba8ea08a587 /* @min:%2etypeName */ ],
            message: _self[0, $db8f3a1d23da96b1$export$923606b70907833e /* @min:%2emessage */ ],
            hasFullStack: _self[0, $db8f3a1d23da96b1$export$b1b7551538b2085 /* @min:%2ehasFullStack */ ],
            stack: _self[$1e8d24b24fb574aa$var$strStack]
        }, _a[0, $db8f3a1d23da96b1$export$4b848bcab7cafe5d /* @min:parsedStack */ ] = parsedStack || undefined, _a);
        return exceptionDetailsInterface;
    };
    _ExceptionDetails.CreateFromInterface = function(logger, exception) {
        var parsedStack = exception[0, $db8f3a1d23da96b1$export$4b848bcab7cafe5d /* @min:%2eparsedStack */ ] instanceof Array && (0, $7ce500be4896551d$export$76f1a28030e24fa6)(exception[0, $db8f3a1d23da96b1$export$4b848bcab7cafe5d /* @min:%2eparsedStack */ ], function(frame) {
            return $1e8d24b24fb574aa$export$b9d0519a34c90616[0, $db8f3a1d23da96b1$export$aadef743ee7d1db8 /* @min:%2eCreateFromInterface */ ](frame);
        }) || exception[0, $db8f3a1d23da96b1$export$4b848bcab7cafe5d /* @min:%2eparsedStack */ ];
        var exceptionDetails = new _ExceptionDetails(logger, (0, $2a74b38b87b38cda$export$b3cf7a802e578501)((0, $2a74b38b87b38cda$export$b3cf7a802e578501)({}, exception), {
            parsedStack: parsedStack
        }));
        return exceptionDetails;
    };
    return _ExceptionDetails;
}();
var $1e8d24b24fb574aa$export$b9d0519a34c90616 = /** @class */ function() {
    function _StackFrame(sourceFrame, level) {
        this.aiDataContract = {
            level: 1 /* FieldType.Required */ ,
            method: 1 /* FieldType.Required */ ,
            assembly: 0 /* FieldType.Default */ ,
            fileName: 0 /* FieldType.Default */ ,
            line: 0 /* FieldType.Default */ 
        };
        var _self = this;
        _self[0, $db8f3a1d23da96b1$export$59a1581bc81a9aae /* @min:%2esizeInBytes */ ] = 0;
        // Not converting this to isString() as typescript uses this logic to "understand" the different
        // types for the 2 different code paths
        if (typeof sourceFrame === "string") {
            var frame = sourceFrame;
            _self[0, $db8f3a1d23da96b1$export$25f3022e0cda8855 /* @min:%2elevel */ ] = level;
            _self[0, $db8f3a1d23da96b1$export$47d30bd816d62bdc /* @min:%2emethod */ ] = $1e8d24b24fb574aa$var$NoMethod;
            _self[0, $db8f3a1d23da96b1$export$7e3ee7b01672f321 /* @min:%2eassembly */ ] = (0, $f67365b40c49b6c1$export$ef0e11c5f5f351f7)(frame);
            _self[0, $db8f3a1d23da96b1$export$8ea03ef8a4bcfeeb /* @min:%2efileName */ ] = "";
            _self[0, $db8f3a1d23da96b1$export$138215f6c1f0eedf /* @min:%2eline */ ] = 0;
            var matches = frame.match(_StackFrame.regex);
            if (matches && matches[0, $db8f3a1d23da96b1$export$6eae51590aaea43 /* @min:%2elength */ ] >= 5) {
                _self[0, $db8f3a1d23da96b1$export$47d30bd816d62bdc /* @min:%2emethod */ ] = (0, $f67365b40c49b6c1$export$ef0e11c5f5f351f7)(matches[2]) || _self[0, $db8f3a1d23da96b1$export$47d30bd816d62bdc /* @min:%2emethod */ ];
                _self[0, $db8f3a1d23da96b1$export$8ea03ef8a4bcfeeb /* @min:%2efileName */ ] = (0, $f67365b40c49b6c1$export$ef0e11c5f5f351f7)(matches[4]);
                _self[0, $db8f3a1d23da96b1$export$138215f6c1f0eedf /* @min:%2eline */ ] = parseInt(matches[5]) || 0;
            }
        } else {
            _self[0, $db8f3a1d23da96b1$export$25f3022e0cda8855 /* @min:%2elevel */ ] = sourceFrame[0, $db8f3a1d23da96b1$export$25f3022e0cda8855 /* @min:%2elevel */ ];
            _self[0, $db8f3a1d23da96b1$export$47d30bd816d62bdc /* @min:%2emethod */ ] = sourceFrame[0, $db8f3a1d23da96b1$export$47d30bd816d62bdc /* @min:%2emethod */ ];
            _self[0, $db8f3a1d23da96b1$export$7e3ee7b01672f321 /* @min:%2eassembly */ ] = sourceFrame[0, $db8f3a1d23da96b1$export$7e3ee7b01672f321 /* @min:%2eassembly */ ];
            _self[0, $db8f3a1d23da96b1$export$8ea03ef8a4bcfeeb /* @min:%2efileName */ ] = sourceFrame[0, $db8f3a1d23da96b1$export$8ea03ef8a4bcfeeb /* @min:%2efileName */ ];
            _self[0, $db8f3a1d23da96b1$export$138215f6c1f0eedf /* @min:%2eline */ ] = sourceFrame[0, $db8f3a1d23da96b1$export$138215f6c1f0eedf /* @min:%2eline */ ];
            _self[0, $db8f3a1d23da96b1$export$59a1581bc81a9aae /* @min:%2esizeInBytes */ ] = 0;
        }
        _self.sizeInBytes += _self.method[0, $db8f3a1d23da96b1$export$6eae51590aaea43 /* @min:%2elength */ ];
        _self.sizeInBytes += _self.fileName[0, $db8f3a1d23da96b1$export$6eae51590aaea43 /* @min:%2elength */ ];
        _self.sizeInBytes += _self.assembly[0, $db8f3a1d23da96b1$export$6eae51590aaea43 /* @min:%2elength */ ];
        // todo: these might need to be removed depending on how the back-end settles on their size calculation
        _self[0, $db8f3a1d23da96b1$export$59a1581bc81a9aae /* @min:%2esizeInBytes */ ] += _StackFrame.baseSize;
        _self.sizeInBytes += _self.level.toString()[0, $db8f3a1d23da96b1$export$6eae51590aaea43 /* @min:%2elength */ ];
        _self.sizeInBytes += _self.line.toString()[0, $db8f3a1d23da96b1$export$6eae51590aaea43 /* @min:%2elength */ ];
    }
    _StackFrame.CreateFromInterface = function(frame) {
        return new _StackFrame(frame, null);
    };
    _StackFrame.prototype.toInterface = function() {
        var _self = this;
        return {
            level: _self[0, $db8f3a1d23da96b1$export$25f3022e0cda8855 /* @min:%2elevel */ ],
            method: _self[0, $db8f3a1d23da96b1$export$47d30bd816d62bdc /* @min:%2emethod */ ],
            assembly: _self[0, $db8f3a1d23da96b1$export$7e3ee7b01672f321 /* @min:%2eassembly */ ],
            fileName: _self[0, $db8f3a1d23da96b1$export$8ea03ef8a4bcfeeb /* @min:%2efileName */ ],
            line: _self[0, $db8f3a1d23da96b1$export$138215f6c1f0eedf /* @min:%2eline */ ]
        };
    };
    // regex to match stack frames from ie/chrome/ff
    // methodName=$2, fileName=$4, lineNo=$5, column=$6
    _StackFrame.regex = /^([\s]+at)?[\s]{0,50}([^\@\()]+?)[\s]{0,50}(\@|\()([^\(\n]+):([0-9]+):([0-9]+)(\)?)$/;
    _StackFrame.baseSize = 58; // '{"method":"","level":,"assembly":"","fileName":"","line":}'.length
    return _StackFrame;
}();


/*
 * Application Insights JavaScript SDK - Common, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 

/*
 * Application Insights JavaScript SDK - Common, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ var $5048f48c42282ced$export$7e0232b0f089a6b8 = /** @class */ function() {
    function DataPoint() {
        /**
         * The data contract for serializing this object.
         */ this.aiDataContract = {
            name: 1 /* FieldType.Required */ ,
            kind: 0 /* FieldType.Default */ ,
            value: 1 /* FieldType.Required */ ,
            count: 0 /* FieldType.Default */ ,
            min: 0 /* FieldType.Default */ ,
            max: 0 /* FieldType.Default */ ,
            stdDev: 0 /* FieldType.Default */ 
        };
        /**
         * Metric type. Single measurement or the aggregated value.
         */ this.kind = 0 /* DataPointType.Measurement */ ;
    }
    return DataPoint;
}();



var $659de0afdff509f2$export$efdd3e096bc27746 = /** @class */ function() {
    /**
     * Constructs a new instance of the MetricTelemetry object
     */ function Metric(logger, name, value, count, min, max, stdDev, properties, measurements) {
        this.aiDataContract = {
            ver: 1 /* FieldType.Required */ ,
            metrics: 1 /* FieldType.Required */ ,
            properties: 0 /* FieldType.Default */ 
        };
        var _self = this;
        _self.ver = 2;
        var dataPoint = new (0, $5048f48c42282ced$export$7e0232b0f089a6b8)();
        dataPoint[0, $db8f3a1d23da96b1$export$e9679ef501b0d1 /* @min:%2ecount */ ] = count > 0 ? count : undefined;
        dataPoint.max = isNaN(max) || max === null ? undefined : max;
        dataPoint.min = isNaN(min) || min === null ? undefined : min;
        dataPoint[0, $db8f3a1d23da96b1$export$9734b0a24bf02e93 /* @min:%2ename */ ] = (0, $8c3059962bb1d83c$export$4e25b1d4bcd67eb8)(logger, name) || (0, $71dfba5ea0640485$export$4003f5e1672d759);
        dataPoint.value = value;
        dataPoint.stdDev = isNaN(stdDev) || stdDev === null ? undefined : stdDev;
        _self.metrics = [
            dataPoint
        ];
        _self[0, $db8f3a1d23da96b1$export$14814e6f9bf337b4 /* @min:%2eproperties */ ] = (0, $8c3059962bb1d83c$export$efba9e468fe3b2cf)(logger, properties);
        _self[0, $db8f3a1d23da96b1$export$32fc64677eb5b7a2 /* @min:%2emeasurements */ ] = (0, $8c3059962bb1d83c$export$3f0e10abe91e800b)(logger, measurements);
    }
    Metric.envelopeType = "Microsoft.ApplicationInsights.{0}.Metric";
    Metric.dataType = "MetricData";
    return Metric;
}();


/*
 * Application Insights JavaScript SDK - Common, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
/*
 * Application Insights JavaScript SDK - Common, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 

var $8ce53fcb9c1dc1db$var$strEmpty = "";
function $8ce53fcb9c1dc1db$export$4e47185aa280358c(str, defaultValue) {
    if (defaultValue === void 0) defaultValue = false;
    if (str === undefined || str === null) return defaultValue;
    return str.toString()[0, $db8f3a1d23da96b1$export$e4eaee9e01d9baaa /* @min:%2etoLowerCase */ ]() === "true";
}
function $8ce53fcb9c1dc1db$export$4460ed97e7c4a927(totalms) {
    if (isNaN(totalms) || totalms < 0) totalms = 0;
    totalms = Math.round(totalms);
    var ms = $8ce53fcb9c1dc1db$var$strEmpty + totalms % 1000;
    var sec = $8ce53fcb9c1dc1db$var$strEmpty + Math.floor(totalms / 1000) % 60;
    var min = $8ce53fcb9c1dc1db$var$strEmpty + Math.floor(totalms / 60000) % 60;
    var hour = $8ce53fcb9c1dc1db$var$strEmpty + Math.floor(totalms / 3600000) % 24;
    var days = Math.floor(totalms / 86400000);
    ms = ms[0, $db8f3a1d23da96b1$export$6eae51590aaea43 /* @min:%2elength */ ] === 1 ? "00" + ms : ms[0, $db8f3a1d23da96b1$export$6eae51590aaea43 /* @min:%2elength */ ] === 2 ? "0" + ms : ms;
    sec = sec[0, $db8f3a1d23da96b1$export$6eae51590aaea43 /* @min:%2elength */ ] < 2 ? "0" + sec : sec;
    min = min[0, $db8f3a1d23da96b1$export$6eae51590aaea43 /* @min:%2elength */ ] < 2 ? "0" + min : min;
    hour = hour[0, $db8f3a1d23da96b1$export$6eae51590aaea43 /* @min:%2elength */ ] < 2 ? "0" + hour : hour;
    return (days > 0 ? days + "." : $8ce53fcb9c1dc1db$var$strEmpty) + hour + ":" + min + ":" + sec + "." + ms;
}
function $8ce53fcb9c1dc1db$export$80a37ba429dff231(extensions, identifier) {
    var extension = null;
    (0, $f6bb085f8cf12216$export$e2e5bcdbdc49c586)(extensions, function(value) {
        if (value.identifier === identifier) {
            extension = value;
            return -1;
        }
    });
    return extension;
}
function $8ce53fcb9c1dc1db$export$8c465f5f14327ccd(message, url, lineNumber, columnNumber, error) {
    return !error && (0, $533f826bbc418791$export$844ec244b1367d54)(message) && (message === "Script error." || message === "Script error");
}




var $5c5f40703ef3d51c$export$12c0fdede1c6bc6c = /** @class */ function() {
    /**
     * Constructs a new instance of the PageEventTelemetry object
     */ function PageView(logger, name, url, durationMs, properties, measurements, id) {
        this.aiDataContract = {
            ver: 1 /* FieldType.Required */ ,
            name: 0 /* FieldType.Default */ ,
            url: 0 /* FieldType.Default */ ,
            duration: 0 /* FieldType.Default */ ,
            properties: 0 /* FieldType.Default */ ,
            measurements: 0 /* FieldType.Default */ ,
            id: 0 /* FieldType.Default */ 
        };
        var _self = this;
        _self.ver = 2;
        _self.id = (0, $8c3059962bb1d83c$export$808d3905d3d31f01)(logger, id);
        _self.url = (0, $8c3059962bb1d83c$export$356146502a9f860c)(logger, url);
        _self[0, $db8f3a1d23da96b1$export$9734b0a24bf02e93 /* @min:%2ename */ ] = (0, $8c3059962bb1d83c$export$4e25b1d4bcd67eb8)(logger, name) || (0, $71dfba5ea0640485$export$4003f5e1672d759);
        if (!isNaN(durationMs)) _self[0, $db8f3a1d23da96b1$export$aa395e58f404db90 /* @min:%2eduration */ ] = (0, $8ce53fcb9c1dc1db$export$4460ed97e7c4a927)(durationMs);
        _self[0, $db8f3a1d23da96b1$export$14814e6f9bf337b4 /* @min:%2eproperties */ ] = (0, $8c3059962bb1d83c$export$efba9e468fe3b2cf)(logger, properties);
        _self[0, $db8f3a1d23da96b1$export$32fc64677eb5b7a2 /* @min:%2emeasurements */ ] = (0, $8c3059962bb1d83c$export$3f0e10abe91e800b)(logger, measurements);
    }
    PageView.envelopeType = "Microsoft.ApplicationInsights.{0}.Pageview";
    PageView.dataType = "PageviewData";
    return PageView;
}();


/*
 * Application Insights JavaScript SDK - Common, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 



var $0dd1de134f090c69$export$a7b48490930dbffa = /** @class */ function() {
    /**
     * Constructs a new instance of the RemoteDependencyData object
     */ function RemoteDependencyData(logger, id, absoluteUrl, commandName, value, success, resultCode, method, requestAPI, correlationContext, properties, measurements) {
        if (requestAPI === void 0) requestAPI = "Ajax";
        this.aiDataContract = {
            id: 1 /* FieldType.Required */ ,
            ver: 1 /* FieldType.Required */ ,
            name: 0 /* FieldType.Default */ ,
            resultCode: 0 /* FieldType.Default */ ,
            duration: 0 /* FieldType.Default */ ,
            success: 0 /* FieldType.Default */ ,
            data: 0 /* FieldType.Default */ ,
            target: 0 /* FieldType.Default */ ,
            type: 0 /* FieldType.Default */ ,
            properties: 0 /* FieldType.Default */ ,
            measurements: 0 /* FieldType.Default */ ,
            kind: 0 /* FieldType.Default */ ,
            value: 0 /* FieldType.Default */ ,
            count: 0 /* FieldType.Default */ ,
            min: 0 /* FieldType.Default */ ,
            max: 0 /* FieldType.Default */ ,
            stdDev: 0 /* FieldType.Default */ ,
            dependencyKind: 0 /* FieldType.Default */ ,
            dependencySource: 0 /* FieldType.Default */ ,
            commandName: 0 /* FieldType.Default */ ,
            dependencyTypeName: 0 /* FieldType.Default */ 
        };
        var _self = this;
        _self.ver = 2;
        _self.id = id;
        _self[0, $db8f3a1d23da96b1$export$aa395e58f404db90 /* @min:%2eduration */ ] = (0, $8ce53fcb9c1dc1db$export$4460ed97e7c4a927)(value);
        _self.success = success;
        _self.resultCode = resultCode + "";
        _self.type = (0, $8c3059962bb1d83c$export$4e25b1d4bcd67eb8)(logger, requestAPI);
        var dependencyFields = (0, $d98b699aeccdabc6$export$92b0aba7cb1d0e30)(logger, absoluteUrl, method, commandName);
        _self.data = (0, $8c3059962bb1d83c$export$356146502a9f860c)(logger, commandName) || dependencyFields.data; // get a value from hosturl if commandName not available
        _self.target = (0, $8c3059962bb1d83c$export$4e25b1d4bcd67eb8)(logger, dependencyFields.target);
        if (correlationContext) _self.target = "".concat(_self.target, " | ").concat(correlationContext);
        _self[0, $db8f3a1d23da96b1$export$9734b0a24bf02e93 /* @min:%2ename */ ] = (0, $8c3059962bb1d83c$export$4e25b1d4bcd67eb8)(logger, dependencyFields[0, $db8f3a1d23da96b1$export$9734b0a24bf02e93 /* @min:%2ename */ ]);
        _self[0, $db8f3a1d23da96b1$export$14814e6f9bf337b4 /* @min:%2eproperties */ ] = (0, $8c3059962bb1d83c$export$efba9e468fe3b2cf)(logger, properties);
        _self[0, $db8f3a1d23da96b1$export$32fc64677eb5b7a2 /* @min:%2emeasurements */ ] = (0, $8c3059962bb1d83c$export$3f0e10abe91e800b)(logger, measurements);
    }
    RemoteDependencyData.envelopeType = "Microsoft.ApplicationInsights.{0}.RemoteDependency";
    RemoteDependencyData.dataType = "RemoteDependencyData";
    return RemoteDependencyData;
}();


/*
 * Application Insights JavaScript SDK - Common, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 


var $16adbdbcb0ae9015$export$78e1bea9036f120f = /** @class */ function() {
    /**
     * Constructs a new instance of the TraceTelemetry object
     */ function Trace(logger, message, severityLevel, properties, measurements) {
        this.aiDataContract = {
            ver: 1 /* FieldType.Required */ ,
            message: 1 /* FieldType.Required */ ,
            severityLevel: 0 /* FieldType.Default */ ,
            properties: 0 /* FieldType.Default */ 
        };
        var _self = this;
        _self.ver = 2;
        message = message || (0, $71dfba5ea0640485$export$4003f5e1672d759);
        _self[0, $db8f3a1d23da96b1$export$923606b70907833e /* @min:%2emessage */ ] = (0, $8c3059962bb1d83c$export$dff84a9939b48dc0)(logger, message);
        _self[0, $db8f3a1d23da96b1$export$14814e6f9bf337b4 /* @min:%2eproperties */ ] = (0, $8c3059962bb1d83c$export$efba9e468fe3b2cf)(logger, properties);
        _self[0, $db8f3a1d23da96b1$export$32fc64677eb5b7a2 /* @min:%2emeasurements */ ] = (0, $8c3059962bb1d83c$export$3f0e10abe91e800b)(logger, measurements);
        if (severityLevel) _self[0, $db8f3a1d23da96b1$export$2675b0014c60aa10 /* @min:%2eseverityLevel */ ] = severityLevel;
    }
    Trace.envelopeType = "Microsoft.ApplicationInsights.{0}.Message";
    Trace.dataType = "MessageData";
    return Trace;
}();


/*
 * Application Insights JavaScript SDK - Common, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 


var $27d410d508f4b32f$export$709aae57ec681346 = /** @class */ function() {
    /**
     * Constructs a new instance of the PageEventTelemetry object
     */ function PageViewPerformance(logger, name, url, unused, properties, measurements, cs4BaseData) {
        this.aiDataContract = {
            ver: 1 /* FieldType.Required */ ,
            name: 0 /* FieldType.Default */ ,
            url: 0 /* FieldType.Default */ ,
            duration: 0 /* FieldType.Default */ ,
            perfTotal: 0 /* FieldType.Default */ ,
            networkConnect: 0 /* FieldType.Default */ ,
            sentRequest: 0 /* FieldType.Default */ ,
            receivedResponse: 0 /* FieldType.Default */ ,
            domProcessing: 0 /* FieldType.Default */ ,
            properties: 0 /* FieldType.Default */ ,
            measurements: 0 /* FieldType.Default */ 
        };
        var _self = this;
        _self.ver = 2;
        _self.url = (0, $8c3059962bb1d83c$export$356146502a9f860c)(logger, url);
        _self[0, $db8f3a1d23da96b1$export$9734b0a24bf02e93 /* @min:%2ename */ ] = (0, $8c3059962bb1d83c$export$4e25b1d4bcd67eb8)(logger, name) || (0, $71dfba5ea0640485$export$4003f5e1672d759);
        _self[0, $db8f3a1d23da96b1$export$14814e6f9bf337b4 /* @min:%2eproperties */ ] = (0, $8c3059962bb1d83c$export$efba9e468fe3b2cf)(logger, properties);
        _self[0, $db8f3a1d23da96b1$export$32fc64677eb5b7a2 /* @min:%2emeasurements */ ] = (0, $8c3059962bb1d83c$export$3f0e10abe91e800b)(logger, measurements);
        if (cs4BaseData) {
            _self.domProcessing = cs4BaseData.domProcessing;
            _self[0, $db8f3a1d23da96b1$export$aa395e58f404db90 /* @min:%2eduration */ ] = cs4BaseData[0, $db8f3a1d23da96b1$export$aa395e58f404db90 /* @min:%2eduration */ ];
            _self.networkConnect = cs4BaseData.networkConnect;
            _self.perfTotal = cs4BaseData.perfTotal;
            _self[0, $db8f3a1d23da96b1$export$e046465ee502552 /* @min:%2ereceivedResponse */ ] = cs4BaseData[0, $db8f3a1d23da96b1$export$e046465ee502552 /* @min:%2ereceivedResponse */ ];
            _self.sentRequest = cs4BaseData.sentRequest;
        }
    }
    PageViewPerformance.envelopeType = "Microsoft.ApplicationInsights.{0}.PageviewPerformance";
    PageViewPerformance.dataType = "PageviewPerformanceData";
    return PageViewPerformance;
}();


/*
 * Application Insights JavaScript SDK - Common, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ var $74e0f4254782bad9$export$2d0294657ab35f1b = /** @class */ function() {
    /**
     * Constructs a new instance of telemetry data.
     */ function Data(baseType, data) {
        /**
         * The data contract for serializing this object.
         */ this.aiDataContract = {
            baseType: 1 /* FieldType.Required */ ,
            baseData: 1 /* FieldType.Required */ 
        };
        this.baseType = baseType;
        this.baseData = data;
    }
    return Data;
}();




/*
 * Application Insights JavaScript SDK - Common, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 

function $d1bdc0f4cef94745$var$_aiNameFunc(baseName) {
    var aiName = "ai." + baseName + ".";
    return function(name) {
        return aiName + name;
    };
}
var $d1bdc0f4cef94745$var$_aiApplication = $d1bdc0f4cef94745$var$_aiNameFunc("application");
var $d1bdc0f4cef94745$var$_aiDevice = $d1bdc0f4cef94745$var$_aiNameFunc("device");
var $d1bdc0f4cef94745$var$_aiLocation = $d1bdc0f4cef94745$var$_aiNameFunc("location");
var $d1bdc0f4cef94745$var$_aiOperation = $d1bdc0f4cef94745$var$_aiNameFunc("operation");
var $d1bdc0f4cef94745$var$_aiSession = $d1bdc0f4cef94745$var$_aiNameFunc("session");
var $d1bdc0f4cef94745$var$_aiUser = $d1bdc0f4cef94745$var$_aiNameFunc("user");
var $d1bdc0f4cef94745$var$_aiCloud = $d1bdc0f4cef94745$var$_aiNameFunc("cloud");
var $d1bdc0f4cef94745$var$_aiInternal = $d1bdc0f4cef94745$var$_aiNameFunc("internal");
var $d1bdc0f4cef94745$export$8e2bcdf18620784a = /** @class */ function(_super) {
    (0, $2a74b38b87b38cda$export$1f9c32e3fbfb8e62)(ContextTagKeys, _super);
    function ContextTagKeys() {
        return _super.call(this) || this;
    }
    return ContextTagKeys;
}((0, $0b747974b0bb3563$export$f0facb5bce2741f0)({
    applicationVersion: $d1bdc0f4cef94745$var$_aiApplication("ver"),
    applicationBuild: $d1bdc0f4cef94745$var$_aiApplication("build"),
    applicationTypeId: $d1bdc0f4cef94745$var$_aiApplication("typeId"),
    applicationId: $d1bdc0f4cef94745$var$_aiApplication("applicationId"),
    applicationLayer: $d1bdc0f4cef94745$var$_aiApplication("layer"),
    deviceId: $d1bdc0f4cef94745$var$_aiDevice("id"),
    deviceIp: $d1bdc0f4cef94745$var$_aiDevice("ip"),
    deviceLanguage: $d1bdc0f4cef94745$var$_aiDevice("language"),
    deviceLocale: $d1bdc0f4cef94745$var$_aiDevice("locale"),
    deviceModel: $d1bdc0f4cef94745$var$_aiDevice("model"),
    deviceFriendlyName: $d1bdc0f4cef94745$var$_aiDevice("friendlyName"),
    deviceNetwork: $d1bdc0f4cef94745$var$_aiDevice("network"),
    deviceNetworkName: $d1bdc0f4cef94745$var$_aiDevice("networkName"),
    deviceOEMName: $d1bdc0f4cef94745$var$_aiDevice("oemName"),
    deviceOS: $d1bdc0f4cef94745$var$_aiDevice("os"),
    deviceOSVersion: $d1bdc0f4cef94745$var$_aiDevice("osVersion"),
    deviceRoleInstance: $d1bdc0f4cef94745$var$_aiDevice("roleInstance"),
    deviceRoleName: $d1bdc0f4cef94745$var$_aiDevice("roleName"),
    deviceScreenResolution: $d1bdc0f4cef94745$var$_aiDevice("screenResolution"),
    deviceType: $d1bdc0f4cef94745$var$_aiDevice("type"),
    deviceMachineName: $d1bdc0f4cef94745$var$_aiDevice("machineName"),
    deviceVMName: $d1bdc0f4cef94745$var$_aiDevice("vmName"),
    deviceBrowser: $d1bdc0f4cef94745$var$_aiDevice("browser"),
    deviceBrowserVersion: $d1bdc0f4cef94745$var$_aiDevice("browserVersion"),
    locationIp: $d1bdc0f4cef94745$var$_aiLocation("ip"),
    locationCountry: $d1bdc0f4cef94745$var$_aiLocation("country"),
    locationProvince: $d1bdc0f4cef94745$var$_aiLocation("province"),
    locationCity: $d1bdc0f4cef94745$var$_aiLocation("city"),
    operationId: $d1bdc0f4cef94745$var$_aiOperation("id"),
    operationName: $d1bdc0f4cef94745$var$_aiOperation("name"),
    operationParentId: $d1bdc0f4cef94745$var$_aiOperation("parentId"),
    operationRootId: $d1bdc0f4cef94745$var$_aiOperation("rootId"),
    operationSyntheticSource: $d1bdc0f4cef94745$var$_aiOperation("syntheticSource"),
    operationCorrelationVector: $d1bdc0f4cef94745$var$_aiOperation("correlationVector"),
    sessionId: $d1bdc0f4cef94745$var$_aiSession("id"),
    sessionIsFirst: $d1bdc0f4cef94745$var$_aiSession("isFirst"),
    sessionIsNew: $d1bdc0f4cef94745$var$_aiSession("isNew"),
    userAccountAcquisitionDate: $d1bdc0f4cef94745$var$_aiUser("accountAcquisitionDate"),
    userAccountId: $d1bdc0f4cef94745$var$_aiUser("accountId"),
    userAgent: $d1bdc0f4cef94745$var$_aiUser("userAgent"),
    userId: $d1bdc0f4cef94745$var$_aiUser("id"),
    userStoreRegion: $d1bdc0f4cef94745$var$_aiUser("storeRegion"),
    userAuthUserId: $d1bdc0f4cef94745$var$_aiUser("authUserId"),
    userAnonymousUserAcquisitionDate: $d1bdc0f4cef94745$var$_aiUser("anonUserAcquisitionDate"),
    userAuthenticatedUserAcquisitionDate: $d1bdc0f4cef94745$var$_aiUser("authUserAcquisitionDate"),
    cloudName: $d1bdc0f4cef94745$var$_aiCloud("name"),
    cloudRole: $d1bdc0f4cef94745$var$_aiCloud("role"),
    cloudRoleVer: $d1bdc0f4cef94745$var$_aiCloud("roleVer"),
    cloudRoleInstance: $d1bdc0f4cef94745$var$_aiCloud("roleInstance"),
    cloudEnvironment: $d1bdc0f4cef94745$var$_aiCloud("environment"),
    cloudLocation: $d1bdc0f4cef94745$var$_aiCloud("location"),
    cloudDeploymentUnit: $d1bdc0f4cef94745$var$_aiCloud("deploymentUnit"),
    internalNodeName: $d1bdc0f4cef94745$var$_aiInternal("nodeName"),
    internalSdkVersion: $d1bdc0f4cef94745$var$_aiInternal("sdkVersion"),
    internalAgentVersion: $d1bdc0f4cef94745$var$_aiInternal("agentVersion"),
    internalSnippet: $d1bdc0f4cef94745$var$_aiInternal("snippet"),
    internalSdkSrc: $d1bdc0f4cef94745$var$_aiInternal("sdkSrc")
}));



/*
 * Application Insights JavaScript SDK - Common, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 



function $932e93a8e5adf75c$export$2dc41327de8d98f1(item, baseType, envelopeName, logger, customProperties, systemProperties) {
    var _a;
    envelopeName = (0, $8c3059962bb1d83c$export$4e25b1d4bcd67eb8)(logger, envelopeName) || (0, $71dfba5ea0640485$export$4003f5e1672d759);
    if ((0, $533f826bbc418791$export$bedb7023a7733221)(item) || (0, $533f826bbc418791$export$bedb7023a7733221)(baseType) || (0, $533f826bbc418791$export$bedb7023a7733221)(envelopeName)) (0, $44a1c24c0e411039$export$8bf7aba4a9e09055)("Input doesn't contain all required fields");
    var iKey = "";
    if (item[0, $71dfba5ea0640485$export$7d566319b90dbb26]) {
        iKey = item[0, $71dfba5ea0640485$export$7d566319b90dbb26];
        delete item[0, $71dfba5ea0640485$export$7d566319b90dbb26];
    }
    var telemetryItem = (_a = {}, _a[0, $db8f3a1d23da96b1$export$9734b0a24bf02e93 /* @min:name */ ] = envelopeName, _a.time = (0, $0b747974b0bb3563$export$dfaaa8705752128f)(new Date()), _a.iKey = iKey, _a.ext = systemProperties ? systemProperties : {}, _a.tags = [], _a.data = {}, _a.baseType = baseType, _a.baseData = item // Part B
    , _a);
    // Part C
    if (!(0, $533f826bbc418791$export$bedb7023a7733221)(customProperties)) (0, $45e528077703ac0c$export$aa0705d5774c95d1)(customProperties, function(prop, value) {
        telemetryItem.data[prop] = value;
    });
    return telemetryItem;
}
var $932e93a8e5adf75c$export$7af32501561f3b4a = /** @class */ function() {
    function TelemetryItemCreator() {}
    /**
     * Create a telemetry item that the 1DS channel understands
     * @param item - domain specific properties; part B
     * @param baseType - telemetry item type. ie PageViewData
     * @param envelopeName - name of the envelope. ie Microsoft.ApplicationInsights.<instrumentation key>.PageView
     * @param customProperties - user defined custom properties; part C
     * @param systemProperties - system properties that are added to the context; part A
     * @returns ITelemetryItem that is sent to channel
     */ TelemetryItemCreator.create = $932e93a8e5adf75c$export$2dc41327de8d98f1;
    return TelemetryItemCreator;
}();


/*
 * Application Insights JavaScript SDK - Common, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $1185376df44832bd$export$152f4bb29f8263d0 = {
    UserExt: "user",
    DeviceExt: "device",
    TraceExt: "trace",
    WebExt: "web",
    AppExt: "app",
    OSExt: "os",
    SessionExt: "ses",
    SDKExt: "sdk"
};
var $1185376df44832bd$export$ebc7727f2a4272f6 = new (0, $d1bdc0f4cef94745$export$8e2bcdf18620784a)();





/*
 * Application Insights JavaScript SDK - Common, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
function $b5e9c029fdfb79a5$export$58aa8b47bf337bc8(eventName) {
    var event = null;
    if ((0, $533f826bbc418791$export$f6e2535fb5126e54)(Event)) event = new Event(eventName);
    else {
        var doc = (0, $3d5fcb60a9467a45$export$f65ca476c09acec0)();
        if (doc && doc.createEvent) {
            event = doc.createEvent("Event");
            event.initEvent(eventName, true, true);
        }
    }
    return event;
}


/*
 * Application Insights JavaScript SDK - Common, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
/*
 * Application Insights JavaScript SDK - Common, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $524c8ecd2c7c151d$export$d5f3ec63cad061d9 = (0, $4c75282440d4ddf3$export$fd52abd0b2703048)({
    LocalStorage: 0 /* eStorageType.LocalStorage */ ,
    SessionStorage: 1 /* eStorageType.SessionStorage */ 
});
var $524c8ecd2c7c151d$export$29bb472f6d62625c = (0, $4c75282440d4ddf3$export$fd52abd0b2703048)({
    AI: 0 /* eDistributedTracingModes.AI */ ,
    AI_AND_W3C: 1 /* eDistributedTracingModes.AI_AND_W3C */ ,
    W3C: 2 /* eDistributedTracingModes.W3C */ 
});



var $8e03bdff803b84be$var$_canUseLocalStorage = undefined;
var $8e03bdff803b84be$var$_canUseSessionStorage = undefined;
/**
 * Gets the localStorage object if available
 * @return {Storage} - Returns the storage object if available else returns null
 */ function $8e03bdff803b84be$var$_getLocalStorageObject() {
    if ($8e03bdff803b84be$export$f28746933126d63f()) return $8e03bdff803b84be$var$_getVerifiedStorageObject((0, $524c8ecd2c7c151d$export$d5f3ec63cad061d9).LocalStorage);
    return null;
}
/**
 * Tests storage object (localStorage or sessionStorage) to verify that it is usable
 * More details here: https://mathiasbynens.be/notes/localstorage-pattern
 * @param storageType - Type of storage
 * @return {Storage} Returns storage object verified that it is usable
 */ function $8e03bdff803b84be$var$_getVerifiedStorageObject(storageType) {
    try {
        if ((0, $533f826bbc418791$export$bedb7023a7733221)((0, $3d5fcb60a9467a45$export$a4e55266d2135a7f)())) return null;
        var uid = (new Date)[0, $db8f3a1d23da96b1$export$e2818d11505fa034 /* @min:%2etoString */ ]();
        var storage = (0, $3d5fcb60a9467a45$export$3df6e51375017edd)(storageType === (0, $524c8ecd2c7c151d$export$d5f3ec63cad061d9).LocalStorage ? "localStorage" : "sessionStorage");
        storage.setItem(uid, uid);
        var fail = storage.getItem(uid) !== uid;
        storage[0, $db8f3a1d23da96b1$export$596e0e0dc14a1e9b /* @min:%2eremoveItem */ ](uid);
        if (!fail) return storage;
    } catch (exception) {
    // eslint-disable-next-line no-empty
    }
    return null;
}
/**
 * Gets the sessionStorage object if available
 * @return {Storage} - Returns the storage object if available else returns null
 */ function $8e03bdff803b84be$var$_getSessionStorageObject() {
    if ($8e03bdff803b84be$export$c81985c4209bac26()) return $8e03bdff803b84be$var$_getVerifiedStorageObject((0, $524c8ecd2c7c151d$export$d5f3ec63cad061d9).SessionStorage);
    return null;
}
function $8e03bdff803b84be$export$53ddd0ab7db9403() {
    $8e03bdff803b84be$var$_canUseLocalStorage = false;
    $8e03bdff803b84be$var$_canUseSessionStorage = false;
}
function $8e03bdff803b84be$export$f08cf9bcd292b981() {
    $8e03bdff803b84be$var$_canUseLocalStorage = $8e03bdff803b84be$export$f28746933126d63f(true);
    $8e03bdff803b84be$var$_canUseSessionStorage = $8e03bdff803b84be$export$c81985c4209bac26(true);
}
function $8e03bdff803b84be$export$f28746933126d63f(reset) {
    if (reset || $8e03bdff803b84be$var$_canUseLocalStorage === undefined) $8e03bdff803b84be$var$_canUseLocalStorage = !!$8e03bdff803b84be$var$_getVerifiedStorageObject((0, $524c8ecd2c7c151d$export$d5f3ec63cad061d9).LocalStorage);
    return $8e03bdff803b84be$var$_canUseLocalStorage;
}
function $8e03bdff803b84be$export$c3876355f131c85c(logger, name) {
    var storage = $8e03bdff803b84be$var$_getLocalStorageObject();
    if (storage !== null) try {
        return storage.getItem(name);
    } catch (e) {
        $8e03bdff803b84be$var$_canUseLocalStorage = false;
        (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , 1 /* _eInternalMessageId.BrowserCannotReadLocalStorage */ , "Browser failed read of local storage. " + (0, $0b747974b0bb3563$export$39c4487b36c98fec)(e), {
            exception: (0, $386f00e3a193a7da$export$21fce7cbd4dc679f)(e)
        });
    }
    return null;
}
function $8e03bdff803b84be$export$631bce20500dc098(logger, name, data) {
    var storage = $8e03bdff803b84be$var$_getLocalStorageObject();
    if (storage !== null) try {
        storage.setItem(name, data);
        return true;
    } catch (e) {
        $8e03bdff803b84be$var$_canUseLocalStorage = false;
        (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , 3 /* _eInternalMessageId.BrowserCannotWriteLocalStorage */ , "Browser failed write to local storage. " + (0, $0b747974b0bb3563$export$39c4487b36c98fec)(e), {
            exception: (0, $386f00e3a193a7da$export$21fce7cbd4dc679f)(e)
        });
    }
    return false;
}
function $8e03bdff803b84be$export$63137c65c2cc6743(logger, name) {
    var storage = $8e03bdff803b84be$var$_getLocalStorageObject();
    if (storage !== null) try {
        storage[0, $db8f3a1d23da96b1$export$596e0e0dc14a1e9b /* @min:%2eremoveItem */ ](name);
        return true;
    } catch (e) {
        $8e03bdff803b84be$var$_canUseLocalStorage = false;
        (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , 5 /* _eInternalMessageId.BrowserFailedRemovalFromLocalStorage */ , "Browser failed removal of local storage item. " + (0, $0b747974b0bb3563$export$39c4487b36c98fec)(e), {
            exception: (0, $386f00e3a193a7da$export$21fce7cbd4dc679f)(e)
        });
    }
    return false;
}
function $8e03bdff803b84be$export$c81985c4209bac26(reset) {
    if (reset || $8e03bdff803b84be$var$_canUseSessionStorage === undefined) $8e03bdff803b84be$var$_canUseSessionStorage = !!$8e03bdff803b84be$var$_getVerifiedStorageObject((0, $524c8ecd2c7c151d$export$d5f3ec63cad061d9).SessionStorage);
    return $8e03bdff803b84be$var$_canUseSessionStorage;
}
function $8e03bdff803b84be$export$42f95336fa01d38e() {
    var keys = [];
    if ($8e03bdff803b84be$export$c81985c4209bac26()) (0, $45e528077703ac0c$export$aa0705d5774c95d1)((0, $3d5fcb60a9467a45$export$3df6e51375017edd)("sessionStorage"), function(key) {
        keys.push(key);
    });
    return keys;
}
function $8e03bdff803b84be$export$a398bd2f40e2eb6e(logger, name) {
    var storage = $8e03bdff803b84be$var$_getSessionStorageObject();
    if (storage !== null) try {
        return storage.getItem(name);
    } catch (e) {
        $8e03bdff803b84be$var$_canUseSessionStorage = false;
        (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , 2 /* _eInternalMessageId.BrowserCannotReadSessionStorage */ , "Browser failed read of session storage. " + (0, $0b747974b0bb3563$export$39c4487b36c98fec)(e), {
            exception: (0, $386f00e3a193a7da$export$21fce7cbd4dc679f)(e)
        });
    }
    return null;
}
function $8e03bdff803b84be$export$21abea3a85fee3f5(logger, name, data) {
    var storage = $8e03bdff803b84be$var$_getSessionStorageObject();
    if (storage !== null) try {
        storage.setItem(name, data);
        return true;
    } catch (e) {
        $8e03bdff803b84be$var$_canUseSessionStorage = false;
        (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , 4 /* _eInternalMessageId.BrowserCannotWriteSessionStorage */ , "Browser failed write to session storage. " + (0, $0b747974b0bb3563$export$39c4487b36c98fec)(e), {
            exception: (0, $386f00e3a193a7da$export$21fce7cbd4dc679f)(e)
        });
    }
    return false;
}
function $8e03bdff803b84be$export$9f411b4ea05fb92a(logger, name) {
    var storage = $8e03bdff803b84be$var$_getSessionStorageObject();
    if (storage !== null) try {
        storage[0, $db8f3a1d23da96b1$export$596e0e0dc14a1e9b /* @min:%2eremoveItem */ ](name);
        return true;
    } catch (e) {
        $8e03bdff803b84be$var$_canUseSessionStorage = false;
        (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , 6 /* _eInternalMessageId.BrowserFailedRemovalFromSessionStorage */ , "Browser failed removal of session storage item. " + (0, $0b747974b0bb3563$export$39c4487b36c98fec)(e), {
            exception: (0, $386f00e3a193a7da$export$21fce7cbd4dc679f)(e)
        });
    }
    return false;
}



var $ca7353bd9238d340$export$2268e69a6d93b7cc = "AppInsightsPropertiesPlugin";
var $ca7353bd9238d340$export$a714a094d3058c99 = "AppInsightsChannelPlugin";
var $ca7353bd9238d340$export$862d858b0002f352 = "ApplicationInsightsAnalytics";


/*
 * Application Insights JavaScript SDK - Core, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 






/*
 * Application Insights JavaScript SDK - Core, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 






/*
 * Application Insights JavaScript SDK - Core, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 



var $28deccfc004f252b$var$strExecutionContextKey = "ctx";
var $28deccfc004f252b$var$strParentContextKey = "ParentContextKey";
var $28deccfc004f252b$var$strChildrenContextKey = "ChildrenContextKey";
var $28deccfc004f252b$var$_defaultPerfManager = null;
var $28deccfc004f252b$export$e3556d2ce46cdae0 = /** @class */ function() {
    function PerfEvent(name, payloadDetails, isAsync) {
        var _self = this;
        _self.start = (0, $628cad25a0769458$export$a56f095995763cca)();
        _self[0, $1ae5573ce493bccc$export$9734b0a24bf02e93 /* @min:%2ename */ ] = name;
        _self[0, $1ae5573ce493bccc$export$d8114c9e990204cb /* @min:%2eisAsync */ ] = isAsync;
        _self[0, $1ae5573ce493bccc$export$3a89026537e5dfec /* @min:%2eisChildEvt */ ] = function() {
            return false;
        };
        if ((0, $533f826bbc418791$export$f6e2535fb5126e54)(payloadDetails)) {
            // Create an accessor to minimize the potential performance impact of executing the payloadDetails callback
            var theDetails_1;
            (0, $d212d948d25f959a$export$d0d2ebf910ad6e2)(_self, "payload", {
                g: function() {
                    // Delay the execution of the payloadDetails until needed
                    if (!theDetails_1 && (0, $533f826bbc418791$export$f6e2535fb5126e54)(payloadDetails)) {
                        theDetails_1 = payloadDetails();
                        // clear it out now so the referenced objects can be garbage collected
                        payloadDetails = null;
                    }
                    return theDetails_1;
                }
            });
        }
        _self[0, $1ae5573ce493bccc$export$c405fd80acb80a5b /* @min:%2egetCtx */ ] = function(key) {
            if (key) {
                // The parent and child links are located directly on the object (for better viewing in the DebugPlugin)
                if (key === PerfEvent[$28deccfc004f252b$var$strParentContextKey] || key === PerfEvent[$28deccfc004f252b$var$strChildrenContextKey]) return _self[key];
                return (_self[$28deccfc004f252b$var$strExecutionContextKey] || {})[key];
            }
            return null;
        };
        _self[0, $1ae5573ce493bccc$export$2ec27a3df8fa4130 /* @min:%2esetCtx */ ] = function(key, value) {
            if (key) {
                // Put the parent and child links directly on the object (for better viewing in the DebugPlugin)
                if (key === PerfEvent[$28deccfc004f252b$var$strParentContextKey]) {
                    // Simple assumption, if we are setting a parent then we must be a child
                    if (!_self[key]) _self[0, $1ae5573ce493bccc$export$3a89026537e5dfec /* @min:%2eisChildEvt */ ] = function() {
                        return true;
                    };
                    _self[key] = value;
                } else if (key === PerfEvent[$28deccfc004f252b$var$strChildrenContextKey]) _self[key] = value;
                else {
                    var ctx = _self[$28deccfc004f252b$var$strExecutionContextKey] = _self[$28deccfc004f252b$var$strExecutionContextKey] || {};
                    ctx[key] = value;
                }
            }
        };
        _self[0, $1ae5573ce493bccc$export$b6736e780b133181 /* @min:%2ecomplete */ ] = function() {
            var childTime = 0;
            var childEvts = _self[0, $1ae5573ce493bccc$export$c405fd80acb80a5b /* @min:%2egetCtx */ ](PerfEvent[$28deccfc004f252b$var$strChildrenContextKey]);
            if ((0, $533f826bbc418791$export$43bee75e5e14138e)(childEvts)) for(var lp = 0; lp < childEvts[0, $1ae5573ce493bccc$export$6eae51590aaea43 /* @min:%2elength */ ]; lp++){
                var childEvt = childEvts[lp];
                if (childEvt) childTime += childEvt[0, $1ae5573ce493bccc$export$7b5ba5854159c1f0 /* @min:%2etime */ ];
            }
            _self[0, $1ae5573ce493bccc$export$7b5ba5854159c1f0 /* @min:%2etime */ ] = (0, $628cad25a0769458$export$a56f095995763cca)() - _self.start;
            _self.exTime = _self[0, $1ae5573ce493bccc$export$7b5ba5854159c1f0 /* @min:%2etime */ ] - childTime;
            _self[0, $1ae5573ce493bccc$export$b6736e780b133181 /* @min:%2ecomplete */ ] = function() {};
        };
    }
    PerfEvent.ParentContextKey = "parent";
    PerfEvent.ChildrenContextKey = "childEvts";
    return PerfEvent;
}();
var $28deccfc004f252b$export$cbeb6df2e8e9b5ae = /** @class */ function() {
    function PerfManager(manager) {
        /**
         * General bucket used for execution context set and retrieved via setCtx() and getCtx.
         * Defined as private so it can be visualized via the DebugPlugin
         */ this.ctx = {};
        (0, $c9b63384299a3252$export$2e2bcd8739ae039)(PerfManager, this, function(_self) {
            _self.create = function(src, payloadDetails, isAsync) {
                // TODO (@MSNev): at some point we will want to add additional configuration to "select" which events to instrument
                // for now this is just a simple do everything.
                return new $28deccfc004f252b$export$e3556d2ce46cdae0(src, payloadDetails, isAsync);
            };
            _self.fire = function(perfEvent) {
                if (perfEvent) {
                    perfEvent[0, $1ae5573ce493bccc$export$b6736e780b133181 /* @min:%2ecomplete */ ]();
                    if (manager && (0, $533f826bbc418791$export$f6e2535fb5126e54)(manager[0, $9fe4a5d5204a4cff$export$5d265841733c97c3 /* @min:%2eperfEvent */ ])) manager[0, $9fe4a5d5204a4cff$export$5d265841733c97c3 /* @min:%2eperfEvent */ ](perfEvent);
                }
            };
            _self[0, $1ae5573ce493bccc$export$2ec27a3df8fa4130 /* @min:%2esetCtx */ ] = function(key, value) {
                if (key) {
                    var ctx = _self[$28deccfc004f252b$var$strExecutionContextKey] = _self[$28deccfc004f252b$var$strExecutionContextKey] || {};
                    ctx[key] = value;
                }
            };
            _self[0, $1ae5573ce493bccc$export$c405fd80acb80a5b /* @min:%2egetCtx */ ] = function(key) {
                return (_self[$28deccfc004f252b$var$strExecutionContextKey] || {})[key];
            };
        });
    }
    // Removed Stub for PerfManager.prototype.create.
    // Removed Stub for PerfManager.prototype.fire.
    // Removed Stub for PerfManager.prototype.setCtx.
    // Removed Stub for PerfManager.prototype.getCtx.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    PerfManager.__ieDyn = 1;
    return PerfManager;
}();
var $28deccfc004f252b$var$doPerfActiveKey = "CoreUtils.doPerf";
function $28deccfc004f252b$export$c6fbeb260600c482(mgrSource, getSource, func, details, isAsync) {
    if (mgrSource) {
        var perfMgr = mgrSource;
        if (perfMgr[0, $9fe4a5d5204a4cff$export$f8b08c7de64edfbf]) // Looks like a perf manager provider object
        perfMgr = perfMgr[0, $9fe4a5d5204a4cff$export$f8b08c7de64edfbf]();
        if (perfMgr) {
            var perfEvt = void 0;
            var currentActive = perfMgr[0, $1ae5573ce493bccc$export$c405fd80acb80a5b /* @min:%2egetCtx */ ]($28deccfc004f252b$var$doPerfActiveKey);
            try {
                perfEvt = perfMgr.create(getSource(), details, isAsync);
                if (perfEvt) {
                    if (currentActive && perfEvt[0, $1ae5573ce493bccc$export$2ec27a3df8fa4130 /* @min:%2esetCtx */ ]) {
                        perfEvt[0, $1ae5573ce493bccc$export$2ec27a3df8fa4130 /* @min:%2esetCtx */ ]($28deccfc004f252b$export$e3556d2ce46cdae0[$28deccfc004f252b$var$strParentContextKey], currentActive);
                        if (currentActive[0, $1ae5573ce493bccc$export$c405fd80acb80a5b /* @min:%2egetCtx */ ] && currentActive[0, $1ae5573ce493bccc$export$2ec27a3df8fa4130 /* @min:%2esetCtx */ ]) {
                            var children = currentActive[0, $1ae5573ce493bccc$export$c405fd80acb80a5b /* @min:%2egetCtx */ ]($28deccfc004f252b$export$e3556d2ce46cdae0[$28deccfc004f252b$var$strChildrenContextKey]);
                            if (!children) {
                                children = [];
                                currentActive[0, $1ae5573ce493bccc$export$2ec27a3df8fa4130 /* @min:%2esetCtx */ ]($28deccfc004f252b$export$e3556d2ce46cdae0[$28deccfc004f252b$var$strChildrenContextKey], children);
                            }
                            children[0, $1ae5573ce493bccc$export$a0a330e7fa1e278c /* @min:%2epush */ ](perfEvt);
                        }
                    }
                    // Set this event as the active event now
                    perfMgr[0, $1ae5573ce493bccc$export$2ec27a3df8fa4130 /* @min:%2esetCtx */ ]($28deccfc004f252b$var$doPerfActiveKey, perfEvt);
                    return func(perfEvt);
                }
            } catch (ex) {
                if (perfEvt && perfEvt[0, $1ae5573ce493bccc$export$2ec27a3df8fa4130 /* @min:%2esetCtx */ ]) perfEvt[0, $1ae5573ce493bccc$export$2ec27a3df8fa4130 /* @min:%2esetCtx */ ]("exception", ex);
            } finally{
                // fire the perf event
                if (perfEvt) perfMgr.fire(perfEvt);
                // Reset the active event to the previous value
                perfMgr[0, $1ae5573ce493bccc$export$2ec27a3df8fa4130 /* @min:%2esetCtx */ ]($28deccfc004f252b$var$doPerfActiveKey, currentActive);
            }
        }
    }
    return func();
}
function $28deccfc004f252b$export$1e94af82fd6977f1(perfManager) {
    $28deccfc004f252b$var$_defaultPerfManager = perfManager;
}
function $28deccfc004f252b$export$6cdbf3f34ace6568() {
    return $28deccfc004f252b$var$_defaultPerfManager;
}


/*
 * Application Insights JavaScript SDK - Core, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 




"use strict";
var $757da337740268ac$var$pluginStateData = (0, $8a2d104e2647a310$export$b95c3438408d78aa)("plugin");
function $757da337740268ac$export$37cfaecb9b4b1b3b(plugin) {
    return $757da337740268ac$var$pluginStateData.get(plugin, "state", {}, true);
}
function $757da337740268ac$export$be211df7b1eeb33e(processContext, extensions) {
    // Set the next plugin and identified the uninitialized plugins
    var initPlugins = [];
    var lastPlugin = null;
    var proxy = processContext[0, $1ae5573ce493bccc$export$36754a48de7fd714 /* @min:%2egetNext */ ]();
    var pluginState;
    while(proxy){
        var thePlugin = proxy[0, $1ae5573ce493bccc$export$37717a508eca6e2d /* @min:%2egetPlugin */ ]();
        if (thePlugin) {
            if (lastPlugin && lastPlugin[0, $1ae5573ce493bccc$export$55d672a1dc4d50c1 /* @min:%2esetNextPlugin */ ] && thePlugin[0, $9fe4a5d5204a4cff$export$820a3bce4a265606 /* @min:%2eprocessTelemetry */ ]) // Set this plugin as the next for the previous one
            lastPlugin[0, $1ae5573ce493bccc$export$55d672a1dc4d50c1 /* @min:%2esetNextPlugin */ ](thePlugin);
            pluginState = $757da337740268ac$export$37cfaecb9b4b1b3b(thePlugin);
            var isInitialized = !!pluginState[0, $1ae5573ce493bccc$export$2e2716e9c35a66a8 /* @min:%2eisInitialized */ ];
            if (thePlugin[0, $1ae5573ce493bccc$export$2e2716e9c35a66a8 /* @min:%2eisInitialized */ ]) isInitialized = thePlugin[0, $1ae5573ce493bccc$export$2e2716e9c35a66a8 /* @min:%2eisInitialized */ ]();
            if (!isInitialized) initPlugins[0, $1ae5573ce493bccc$export$a0a330e7fa1e278c /* @min:%2epush */ ](thePlugin);
            lastPlugin = thePlugin;
            proxy = proxy[0, $1ae5573ce493bccc$export$36754a48de7fd714 /* @min:%2egetNext */ ]();
        }
    }
    // Now initialize the plugins
    (0, $f6bb085f8cf12216$export$e2e5bcdbdc49c586)(initPlugins, function(thePlugin) {
        var core = processContext[0, $9fe4a5d5204a4cff$export$3094ace9cd82ff99 /* @min:%2ecore */ ]();
        thePlugin[0, $1ae5573ce493bccc$export$65cd33bb52d04675 /* @min:%2einitialize */ ](processContext.getCfg(), core, extensions, processContext[0, $1ae5573ce493bccc$export$36754a48de7fd714 /* @min:%2egetNext */ ]());
        pluginState = $757da337740268ac$export$37cfaecb9b4b1b3b(thePlugin);
        // Only add the core to the state if the plugin didn't set it (doesn't extend from BaseTelemetryPlugin)
        if (!thePlugin[0, $9fe4a5d5204a4cff$export$3094ace9cd82ff99] && !pluginState[0, $9fe4a5d5204a4cff$export$3094ace9cd82ff99]) pluginState[0, $9fe4a5d5204a4cff$export$3094ace9cd82ff99] = core;
        pluginState[0, $1ae5573ce493bccc$export$2e2716e9c35a66a8 /* @min:%2eisInitialized */ ] = true;
        delete pluginState[0, $1ae5573ce493bccc$export$7176fb2a7d11927e /* @min:%2eteardown */ ];
    });
}
function $757da337740268ac$export$478771939b7b39a2(plugins) {
    // Sort by priority
    return plugins.sort(function(extA, extB) {
        var result = 0;
        if (extB) {
            var bHasProcess = extB[0, $9fe4a5d5204a4cff$export$820a3bce4a265606];
            if (extA[0, $9fe4a5d5204a4cff$export$820a3bce4a265606]) result = bHasProcess ? extA[0, $9fe4a5d5204a4cff$export$58efcc07763b37be] - extB[0, $9fe4a5d5204a4cff$export$58efcc07763b37be] : 1;
            else if (bHasProcess) result = -1;
        } else result = extA ? 1 : -1;
        return result;
    });
// sort complete
}
function $757da337740268ac$export$24978f1b175640d9(components, unloadCtx, unloadState, asyncCallback) {
    var idx = 0;
    function _doUnload() {
        while(idx < components[0, $1ae5573ce493bccc$export$6eae51590aaea43 /* @min:%2elength */ ]){
            var component = components[idx++];
            if (component) {
                var func = component._doUnload || component[0, $1ae5573ce493bccc$export$458d234b616d0745 /* @min:%2e_doTeardown */ ];
                if ((0, $533f826bbc418791$export$f6e2535fb5126e54)(func)) {
                    if (func.call(component, unloadCtx, unloadState, _doUnload) === true) return true;
                }
            }
        }
    }
    return _doUnload();
}
function $757da337740268ac$export$10fa4480433f402c(parentCtx) {
    var trace = {};
    return {
        getName: function() {
            return trace[0, $1ae5573ce493bccc$export$9734b0a24bf02e93 /* @min:%2ename */ ];
        },
        setName: function(newValue) {
            parentCtx && parentCtx.setName(newValue);
            trace[0, $1ae5573ce493bccc$export$9734b0a24bf02e93 /* @min:%2ename */ ] = newValue;
        },
        getTraceId: function() {
            return trace[0, $1ae5573ce493bccc$export$a5eb52c53bba8560 /* @min:%2etraceId */ ];
        },
        setTraceId: function(newValue) {
            parentCtx && parentCtx.setTraceId(newValue);
            if ((0, $6f47dad7a26666b5$export$29dd34cf1269f6da)(newValue)) trace[0, $1ae5573ce493bccc$export$a5eb52c53bba8560 /* @min:%2etraceId */ ] = newValue;
        },
        getSpanId: function() {
            return trace[0, $1ae5573ce493bccc$export$c105b94efa183847 /* @min:%2espanId */ ];
        },
        setSpanId: function(newValue) {
            parentCtx && parentCtx.setSpanId(newValue);
            if ((0, $6f47dad7a26666b5$export$8e51c6d8f0586aff)(newValue)) trace[0, $1ae5573ce493bccc$export$c105b94efa183847 /* @min:%2espanId */ ] = newValue;
        },
        getTraceFlags: function() {
            return trace[0, $1ae5573ce493bccc$export$4e92e4b92b41ba2d /* @min:%2etraceFlags */ ];
        },
        setTraceFlags: function(newTraceFlags) {
            parentCtx && parentCtx.setTraceFlags(newTraceFlags);
            trace[0, $1ae5573ce493bccc$export$4e92e4b92b41ba2d /* @min:%2etraceFlags */ ] = newTraceFlags;
        }
    };
}


"use strict";
var $bc7124acb0f73e64$var$strTelemetryPluginChain = "TelemetryPluginChain";
var $bc7124acb0f73e64$var$strHasRunFlags = "_hasRun";
var $bc7124acb0f73e64$var$strGetTelCtx = "_getTelCtx";
var $bc7124acb0f73e64$var$_chainId = 0;
function $bc7124acb0f73e64$var$_getNextProxyStart(proxy, core, startAt) {
    while(proxy){
        if (proxy[0, $1ae5573ce493bccc$export$37717a508eca6e2d /* @min:%2egetPlugin */ ]() === startAt) return proxy;
        proxy = proxy[0, $1ae5573ce493bccc$export$36754a48de7fd714 /* @min:%2egetNext */ ]();
    }
    // This wasn't found in the existing chain so create an isolated one with just this plugin
    return $bc7124acb0f73e64$export$107e639207cdf742([
        startAt
    ], core.config || {}, core);
}
/**
 * @ignore
 * @param telemetryChain
 * @param dynamicHandler
 * @param core
 * @param startAt - Identifies the next plugin to execute, if null there is no "next" plugin and if undefined it should assume the start of the chain
 * @returns
 */ function $bc7124acb0f73e64$var$_createInternalContext(telemetryChain, dynamicHandler, core, startAt) {
    // We have a special case where we want to start execution from this specific plugin
    // or we simply reuse the existing telemetry plugin chain (normal execution case)
    var _nextProxy = null; // By Default set as no next plugin
    var _onComplete = [];
    if (!dynamicHandler) dynamicHandler = (0, $acb30f9e62dc5705$export$3a9e9180c14487fd)({}, null, core[0, $1ae5573ce493bccc$export$e6a243fe757439f9 /* @min:%2elogger */ ]);
    if (startAt !== null) // There is no next element (null) vs not defined (undefined) so use the full chain
    _nextProxy = startAt ? $bc7124acb0f73e64$var$_getNextProxyStart(telemetryChain, core, startAt) : telemetryChain;
    var context = {
        _next: _moveNext,
        ctx: {
            core: function() {
                return core;
            },
            diagLog: function() {
                return (0, $cc2aaaebf96ac6a7$export$5102d32ea1d740a)(core, dynamicHandler.cfg);
            },
            getCfg: function() {
                return dynamicHandler.cfg;
            },
            getExtCfg: _resolveExtCfg,
            getConfig: _getConfig,
            hasNext: function() {
                return !!_nextProxy;
            },
            getNext: function() {
                return _nextProxy;
            },
            setNext: function(nextPlugin) {
                _nextProxy = nextPlugin;
            },
            iterate: _iterateChain,
            onComplete: _addOnComplete
        }
    };
    function _addOnComplete(onComplete, that) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        if (onComplete) _onComplete[0, $1ae5573ce493bccc$export$a0a330e7fa1e278c /* @min:%2epush */ ]({
            func: onComplete,
            self: !(0, $533f826bbc418791$export$fce6876652108ab)(that) ? that : context.ctx,
            args: args
        });
    }
    function _moveNext() {
        var nextProxy = _nextProxy;
        // Automatically move to the next plugin
        _nextProxy = nextProxy ? nextProxy[0, $1ae5573ce493bccc$export$36754a48de7fd714 /* @min:%2egetNext */ ]() : null;
        if (!nextProxy) {
            var onComplete = _onComplete;
            if (onComplete && onComplete[0, $1ae5573ce493bccc$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) {
                (0, $f6bb085f8cf12216$export$e2e5bcdbdc49c586)(onComplete, function(completeDetails) {
                    try {
                        completeDetails.func.call(completeDetails.self, completeDetails.args);
                    } catch (e) {
                        (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(core[0, $1ae5573ce493bccc$export$e6a243fe757439f9 /* @min:%2elogger */ ], 2 /* eLoggingSeverity.WARNING */ , 73 /* _eInternalMessageId.PluginException */ , "Unexpected Exception during onComplete - " + (0, $386f00e3a193a7da$export$21fce7cbd4dc679f)(e));
                    }
                });
                _onComplete = [];
            }
        }
        return nextProxy;
    }
    function _getExtCfg(identifier, createIfMissing) {
        var idCfg = null;
        var cfg = dynamicHandler.cfg;
        if (cfg && identifier) {
            var extCfg = cfg[0, $9fe4a5d5204a4cff$export$ffb2356587263734 /* @min:%2eextensionConfig */ ];
            if (!extCfg && createIfMissing) extCfg = {};
            // Always set the value so that the property always exists
            cfg[0, $9fe4a5d5204a4cff$export$ffb2356587263734] = extCfg; // Note: it is valid for the "value" to be undefined
            // Calling `ref()` has a side effect of causing the referenced property to become dynamic  (if not already)
            extCfg = dynamicHandler.ref(cfg, (0, $9fe4a5d5204a4cff$export$ffb2356587263734));
            if (extCfg) {
                idCfg = extCfg[identifier];
                if (!idCfg && createIfMissing) idCfg = {};
                // Always set the value so that the property always exists
                extCfg[identifier] = idCfg; // Note: it is valid for the "value" to be undefined
                // Calling `ref()` has a side effect of causing the referenced property to become dynamic  (if not already)
                idCfg = dynamicHandler.ref(extCfg, identifier);
            }
        }
        return idCfg;
    }
    function _resolveExtCfg(identifier, defaultValues) {
        var newConfig = _getExtCfg(identifier, true);
        if (defaultValues) // Enumerate over the defaultValues and if not already populated attempt to
        // find a value from the root config or use the default value
        (0, $45e528077703ac0c$export$aa0705d5774c95d1)(defaultValues, function(field, defaultValue) {
            // for each unspecified field, set the default value
            if ((0, $533f826bbc418791$export$bedb7023a7733221)(newConfig[field])) {
                var cfgValue = dynamicHandler.cfg[field];
                if (cfgValue || !(0, $533f826bbc418791$export$bedb7023a7733221)(cfgValue)) newConfig[field] = cfgValue;
            }
            (0, $2b347a3380a9d5e1$export$f11b7d3a4617b9e9)(dynamicHandler, newConfig, field, defaultValue);
        });
        return dynamicHandler[0, $1ae5573ce493bccc$export$24caac6d68ff1537 /* @min:%2esetDf */ ](newConfig, defaultValues);
    }
    function _getConfig(identifier, field, defaultValue) {
        if (defaultValue === void 0) defaultValue = false;
        var theValue;
        var extConfig = _getExtCfg(identifier, false);
        var rootConfig = dynamicHandler.cfg;
        if (extConfig && (extConfig[field] || !(0, $533f826bbc418791$export$bedb7023a7733221)(extConfig[field]))) theValue = extConfig[field];
        else if (rootConfig[field] || !(0, $533f826bbc418791$export$bedb7023a7733221)(rootConfig[field])) theValue = rootConfig[field];
        return theValue || !(0, $533f826bbc418791$export$bedb7023a7733221)(theValue) ? theValue : defaultValue;
    }
    function _iterateChain(cb) {
        // Keep processing until we reach the end of the chain
        var nextPlugin;
        while(!!(nextPlugin = context._next())){
            var plugin = nextPlugin[0, $1ae5573ce493bccc$export$37717a508eca6e2d /* @min:%2egetPlugin */ ]();
            if (plugin) // callback with the current on
            cb(plugin);
        }
    }
    return context;
}
function $bc7124acb0f73e64$export$ca98f11e981bcfd6(telemetryChain, cfg, core, startAt) {
    var config = (0, $acb30f9e62dc5705$export$3a9e9180c14487fd)(cfg);
    var internalContext = $bc7124acb0f73e64$var$_createInternalContext(telemetryChain, config, core, startAt);
    var context = internalContext.ctx;
    function _processNext(env) {
        var nextPlugin = internalContext._next();
        if (nextPlugin) // Run the next plugin which will call "processNext()"
        nextPlugin[0, $9fe4a5d5204a4cff$export$820a3bce4a265606 /* @min:%2eprocessTelemetry */ ](env, context);
        return !nextPlugin;
    }
    function _createNew(plugins, startAt) {
        if (plugins === void 0) plugins = null;
        if ((0, $533f826bbc418791$export$43bee75e5e14138e)(plugins)) plugins = $bc7124acb0f73e64$export$107e639207cdf742(plugins, config.cfg, core, startAt);
        return $bc7124acb0f73e64$export$ca98f11e981bcfd6(plugins || context[0, $1ae5573ce493bccc$export$36754a48de7fd714 /* @min:%2egetNext */ ](), config.cfg, core, startAt);
    }
    context[0, $1ae5573ce493bccc$export$5c220169317cd6de /* @min:%2eprocessNext */ ] = _processNext;
    context[0, $1ae5573ce493bccc$export$1e6514b499ba4d34 /* @min:%2ecreateNew */ ] = _createNew;
    return context;
}
function $bc7124acb0f73e64$export$91bbbd4999751948(telemetryChain, core, startAt) {
    var config = (0, $acb30f9e62dc5705$export$3a9e9180c14487fd)(core.config);
    var internalContext = $bc7124acb0f73e64$var$_createInternalContext(telemetryChain, config, core, startAt);
    var context = internalContext.ctx;
    function _processNext(unloadState) {
        var nextPlugin = internalContext._next();
        nextPlugin && nextPlugin[0, $1ae5573ce493bccc$export$7eb85b5cba77a43d /* @min:%2eunload */ ](context, unloadState);
        return !nextPlugin;
    }
    function _createNew(plugins, startAt) {
        if (plugins === void 0) plugins = null;
        if ((0, $533f826bbc418791$export$43bee75e5e14138e)(plugins)) plugins = $bc7124acb0f73e64$export$107e639207cdf742(plugins, config.cfg, core, startAt);
        return $bc7124acb0f73e64$export$91bbbd4999751948(plugins || context[0, $1ae5573ce493bccc$export$36754a48de7fd714 /* @min:%2egetNext */ ](), core, startAt);
    }
    context[0, $1ae5573ce493bccc$export$5c220169317cd6de /* @min:%2eprocessNext */ ] = _processNext;
    context[0, $1ae5573ce493bccc$export$1e6514b499ba4d34 /* @min:%2ecreateNew */ ] = _createNew;
    return context;
}
function $bc7124acb0f73e64$export$e4c32b40c4fbf98a(telemetryChain, core, startAt) {
    var config = (0, $acb30f9e62dc5705$export$3a9e9180c14487fd)(core.config);
    var internalContext = $bc7124acb0f73e64$var$_createInternalContext(telemetryChain, config, core, startAt);
    var context = internalContext.ctx;
    function _processNext(updateState) {
        return context.iterate(function(plugin) {
            if ((0, $533f826bbc418791$export$f6e2535fb5126e54)(plugin[0, $1ae5573ce493bccc$export$c9f4bebf02f459de /* @min:%2eupdate */ ])) plugin[0, $1ae5573ce493bccc$export$c9f4bebf02f459de /* @min:%2eupdate */ ](context, updateState);
        });
    }
    function _createNew(plugins, startAt) {
        if (plugins === void 0) plugins = null;
        if ((0, $533f826bbc418791$export$43bee75e5e14138e)(plugins)) plugins = $bc7124acb0f73e64$export$107e639207cdf742(plugins, config.cfg, core, startAt);
        return $bc7124acb0f73e64$export$e4c32b40c4fbf98a(plugins || context[0, $1ae5573ce493bccc$export$36754a48de7fd714 /* @min:%2egetNext */ ](), core, startAt);
    }
    context[0, $1ae5573ce493bccc$export$5c220169317cd6de /* @min:%2eprocessNext */ ] = _processNext;
    context[0, $1ae5573ce493bccc$export$1e6514b499ba4d34 /* @min:%2ecreateNew */ ] = _createNew;
    return context;
}
function $bc7124acb0f73e64$export$107e639207cdf742(plugins, config, core, startAt) {
    var firstProxy = null;
    var add = startAt ? false : true;
    if ((0, $533f826bbc418791$export$43bee75e5e14138e)(plugins) && plugins[0, $1ae5573ce493bccc$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) {
        // Create the proxies and wire up the next plugin chain
        var lastProxy_1 = null;
        (0, $f6bb085f8cf12216$export$e2e5bcdbdc49c586)(plugins, function(thePlugin) {
            if (!add && startAt === thePlugin) add = true;
            if (add && thePlugin && (0, $533f826bbc418791$export$f6e2535fb5126e54)(thePlugin[0, $9fe4a5d5204a4cff$export$820a3bce4a265606 /* @min:%2eprocessTelemetry */ ])) {
                // Only add plugins that are processors
                var newProxy = $bc7124acb0f73e64$export$7f7b955927f4ae5e(thePlugin, config, core);
                if (!firstProxy) firstProxy = newProxy;
                if (lastProxy_1) // Set this new proxy as the next for the previous one
                lastProxy_1._setNext(newProxy);
                lastProxy_1 = newProxy;
            }
        });
    }
    if (startAt && !firstProxy) // Special case where the "startAt" was not in the original list of plugins
    return $bc7124acb0f73e64$export$107e639207cdf742([
        startAt
    ], config, core);
    return firstProxy;
}
function $bc7124acb0f73e64$export$7f7b955927f4ae5e(plugin, config, core) {
    var nextProxy = null;
    var hasProcessTelemetry = (0, $533f826bbc418791$export$f6e2535fb5126e54)(plugin[0, $9fe4a5d5204a4cff$export$820a3bce4a265606 /* @min:%2eprocessTelemetry */ ]);
    var hasSetNext = (0, $533f826bbc418791$export$f6e2535fb5126e54)(plugin[0, $1ae5573ce493bccc$export$55d672a1dc4d50c1 /* @min:%2esetNextPlugin */ ]);
    var chainId;
    if (plugin) chainId = plugin[0, $1ae5573ce493bccc$export$f001befbf8417151 /* @min:%2eidentifier */ ] + "-" + plugin[0, $9fe4a5d5204a4cff$export$58efcc07763b37be /* @min:%2epriority */ ] + "-" + $bc7124acb0f73e64$var$_chainId++;
    else chainId = "Unknown-0-" + $bc7124acb0f73e64$var$_chainId++;
    var proxyChain = {
        getPlugin: function() {
            return plugin;
        },
        getNext: function() {
            return nextProxy;
        },
        processTelemetry: _processTelemetry,
        unload: _unloadPlugin,
        update: _updatePlugin,
        _id: chainId,
        _setNext: function(nextPlugin) {
            nextProxy = nextPlugin;
        }
    };
    function _getTelCtx() {
        var itemCtx;
        // Looks like a plugin didn't pass the (optional) context, so create a new one
        if (plugin && (0, $533f826bbc418791$export$f6e2535fb5126e54)(plugin[$bc7124acb0f73e64$var$strGetTelCtx])) // This plugin extends from the BaseTelemetryPlugin so lets use it
        itemCtx = plugin[$bc7124acb0f73e64$var$strGetTelCtx]();
        if (!itemCtx) // Create a temporary one
        itemCtx = $bc7124acb0f73e64$export$ca98f11e981bcfd6(proxyChain, config, core);
        return itemCtx;
    }
    function _processChain(itemCtx, processPluginFn, name, details, isAsync) {
        var hasRun = false;
        var identifier = plugin ? plugin[0, $1ae5573ce493bccc$export$f001befbf8417151 /* @min:%2eidentifier */ ] : $bc7124acb0f73e64$var$strTelemetryPluginChain;
        var hasRunContext = itemCtx[$bc7124acb0f73e64$var$strHasRunFlags];
        if (!hasRunContext) // Assign and populate
        hasRunContext = itemCtx[$bc7124acb0f73e64$var$strHasRunFlags] = {};
        // Ensure that we keep the context in sync
        itemCtx.setNext(nextProxy);
        if (plugin) (0, $28deccfc004f252b$export$c6fbeb260600c482)(itemCtx[0, $9fe4a5d5204a4cff$export$3094ace9cd82ff99 /* @min:%2ecore */ ](), function() {
            return identifier + ":" + name;
        }, function() {
            // Mark this component as having run
            hasRunContext[chainId] = true;
            try {
                // Set a flag on the next plugin so we know if it was attempted to be executed
                var nextId = nextProxy ? nextProxy._id : (0, $9fe4a5d5204a4cff$export$5e8607ab26634759);
                if (nextId) hasRunContext[nextId] = false;
                hasRun = processPluginFn(itemCtx);
            } catch (error) {
                var hasNextRun = nextProxy ? hasRunContext[nextProxy._id] : true;
                if (hasNextRun) // The next plugin after us has already run so set this one as complete
                hasRun = true;
                if (!nextProxy || !hasNextRun) // Either we have no next plugin or the current one did not attempt to call the next plugin
                // Which means the current one is the root of the failure so log/report this failure
                (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(itemCtx[0, $1ae5573ce493bccc$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), 1 /* eLoggingSeverity.CRITICAL */ , 73 /* _eInternalMessageId.PluginException */ , "Plugin [" + identifier + "] failed during " + name + " - " + (0, $386f00e3a193a7da$export$21fce7cbd4dc679f)(error) + ", run flags: " + (0, $386f00e3a193a7da$export$21fce7cbd4dc679f)(hasRunContext));
            }
        }, details, isAsync);
        return hasRun;
    }
    function _processTelemetry(env, itemCtx) {
        itemCtx = itemCtx || _getTelCtx();
        function _callProcessTelemetry(itemCtx) {
            if (!plugin || !hasProcessTelemetry) return false;
            var pluginState = (0, $757da337740268ac$export$37cfaecb9b4b1b3b)(plugin);
            if (pluginState[0, $1ae5573ce493bccc$export$7176fb2a7d11927e /* @min:%2eteardown */ ] || pluginState[0, $9fe4a5d5204a4cff$export$49e9417944569ae8]) return false;
            // Ensure that we keep the context in sync (for processNext()), just in case a plugin
            // doesn't calls processTelemetry() instead of itemContext.processNext() or some
            // other form of error occurred
            if (hasSetNext) // Backward compatibility setting the next plugin on the instance
            plugin[0, $1ae5573ce493bccc$export$55d672a1dc4d50c1 /* @min:%2esetNextPlugin */ ](nextProxy);
            plugin[0, $9fe4a5d5204a4cff$export$820a3bce4a265606 /* @min:%2eprocessTelemetry */ ](env, itemCtx);
            // Process Telemetry is expected to call itemCtx.processNext() or nextPlugin.processTelemetry()
            return true;
        }
        if (!_processChain(itemCtx, _callProcessTelemetry, "processTelemetry", function() {
            return {
                item: env
            };
        }, !env.sync)) // The underlying plugin is either not defined, not enabled or does not have a processTelemetry implementation
        // so we still want the next plugin to be executed.
        itemCtx[0, $1ae5573ce493bccc$export$5c220169317cd6de /* @min:%2eprocessNext */ ](env);
    }
    function _unloadPlugin(unloadCtx, unloadState) {
        function _callTeardown() {
            // Setting default of hasRun as false so the proxyProcessFn() is called as teardown() doesn't have to exist or call unloadNext().
            var hasRun = false;
            if (plugin) {
                var pluginState = (0, $757da337740268ac$export$37cfaecb9b4b1b3b)(plugin);
                var pluginCore = plugin[0, $9fe4a5d5204a4cff$export$3094ace9cd82ff99] || pluginState[0, $9fe4a5d5204a4cff$export$3094ace9cd82ff99 /* @min:%2ecore */ ];
                // Only teardown the plugin if it was initialized by the current core (i.e. It's not a shared plugin)
                if (plugin && (!pluginCore || pluginCore === unloadCtx.core()) && !pluginState[0, $1ae5573ce493bccc$export$7176fb2a7d11927e /* @min:%2eteardown */ ]) {
                    // Handle plugins that don't extend from the BaseTelemetryPlugin
                    pluginState[0, $9fe4a5d5204a4cff$export$3094ace9cd82ff99 /* @min:%2ecore */ ] = null;
                    pluginState[0, $1ae5573ce493bccc$export$7176fb2a7d11927e /* @min:%2eteardown */ ] = true;
                    pluginState[0, $1ae5573ce493bccc$export$2e2716e9c35a66a8 /* @min:%2eisInitialized */ ] = false;
                    if (plugin[0, $1ae5573ce493bccc$export$7176fb2a7d11927e /* @min:%2eteardown */ ] && plugin[0, $1ae5573ce493bccc$export$7176fb2a7d11927e /* @min:%2eteardown */ ](unloadCtx, unloadState) === true) // plugin told us that it was going to (or has) call unloadCtx.processNext()
                    hasRun = true;
                }
            }
            return hasRun;
        }
        if (!_processChain(unloadCtx, _callTeardown, "unload", function() {}, unloadState[0, $1ae5573ce493bccc$export$d8114c9e990204cb /* @min:%2eisAsync */ ])) // Only called if we hasRun was not true
        unloadCtx[0, $1ae5573ce493bccc$export$5c220169317cd6de /* @min:%2eprocessNext */ ](unloadState);
    }
    function _updatePlugin(updateCtx, updateState) {
        function _callUpdate() {
            // Setting default of hasRun as false so the proxyProcessFn() is called as teardown() doesn't have to exist or call unloadNext().
            var hasRun = false;
            if (plugin) {
                var pluginState = (0, $757da337740268ac$export$37cfaecb9b4b1b3b)(plugin);
                var pluginCore = plugin[0, $9fe4a5d5204a4cff$export$3094ace9cd82ff99] || pluginState[0, $9fe4a5d5204a4cff$export$3094ace9cd82ff99 /* @min:%2ecore */ ];
                // Only update the plugin if it was initialized by the current core (i.e. It's not a shared plugin)
                if (plugin && (!pluginCore || pluginCore === updateCtx.core()) && !pluginState[0, $1ae5573ce493bccc$export$7176fb2a7d11927e /* @min:%2eteardown */ ]) {
                    if (plugin[0, $1ae5573ce493bccc$export$c9f4bebf02f459de /* @min:%2eupdate */ ] && plugin[0, $1ae5573ce493bccc$export$c9f4bebf02f459de /* @min:%2eupdate */ ](updateCtx, updateState) === true) // plugin told us that it was going to (or has) call unloadCtx.processNext()
                    hasRun = true;
                }
            }
            return hasRun;
        }
        if (!_processChain(updateCtx, _callUpdate, "update", function() {}, false)) // Only called if we hasRun was not true
        updateCtx[0, $1ae5573ce493bccc$export$5c220169317cd6de /* @min:%2eprocessNext */ ](updateState);
    }
    return (0, $36a077d9f4439b69$export$5da24d7703175bc5)(proxyChain);
}
/**
 * This class will be removed!
 * @deprecated use createProcessTelemetryContext() instead
 */ var $bc7124acb0f73e64$export$7c2ac74a00234af1 = /** @class */ function() {
    /**
     * Creates a new Telemetry Item context with the current config, core and plugin execution chain
     * @param plugins - The plugin instances that will be executed
     * @param config - The current config
     * @param core - The current core instance
     */ function ProcessTelemetryContext(pluginChain, config, core, startAt) {
        var _self = this;
        var context = $bc7124acb0f73e64$export$ca98f11e981bcfd6(pluginChain, config, core, startAt);
        // Proxy all functions of the context to this object
        (0, $0b747974b0bb3563$export$94f4c7fb7e7d8dc7)(_self, context, (0, $36a077d9f4439b69$export$f7628dc18f4211e5)(context));
    }
    return ProcessTelemetryContext;
}();


/*
 * Application Insights JavaScript SDK - Core, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 


function $d13bf4befeee29ad$export$1dd1604aeaf8cfed() {
    var handlers = [];
    function _addHandler(handler) {
        if (handler) handlers[0, $1ae5573ce493bccc$export$a0a330e7fa1e278c /* @min:%2epush */ ](handler);
    }
    function _runHandlers(unloadCtx, unloadState) {
        (0, $f6bb085f8cf12216$export$e2e5bcdbdc49c586)(handlers, function(handler) {
            try {
                handler(unloadCtx, unloadState);
            } catch (e) {
                (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(unloadCtx[0, $1ae5573ce493bccc$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), 2 /* eLoggingSeverity.WARNING */ , 73 /* _eInternalMessageId.PluginException */ , "Unexpected error calling unload handler - " + (0, $386f00e3a193a7da$export$21fce7cbd4dc679f)(e));
            }
        });
        handlers = [];
    }
    return {
        add: _addHandler,
        run: _runHandlers
    };
}


/*
 * Application Insights JavaScript SDK - Core, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ /*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */ 
/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */ 

function $9d91a18754d7a062$export$50db6e277db66ea0(value) {
    return !!value && (0, $533f826bbc418791$export$f6e2535fb5126e54)(value.next);
}
function $9d91a18754d7a062$export$9652023d9040757(value) {
    return !(0, $533f826bbc418791$export$3388cdee8977b866)(value) && (0, $533f826bbc418791$export$f6e2535fb5126e54)(value[(0, $3ab078397ef07bc3$export$3a9aefdadea26115)(3 /* WellKnownSymbols.iterator */ )]);
}


/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */ 



var $4f88a205a18f32bb$var$_iterSymbol;
function $4f88a205a18f32bb$export$1180a64ad833b902(iter, callbackfn, thisArg) {
    if (iter) {
        if (!(0, $9d91a18754d7a062$export$50db6e277db66ea0)(iter)) {
            !$4f88a205a18f32bb$var$_iterSymbol && ($4f88a205a18f32bb$var$_iterSymbol = (0, $d8ec17546a34ef88$export$db98eae15987454c)(function() {
                return (0, $3ab078397ef07bc3$export$3a9aefdadea26115)(3 /* WellKnownSymbols.iterator */ );
            }));
            iter = iter[$4f88a205a18f32bb$var$_iterSymbol.v] ? iter[$4f88a205a18f32bb$var$_iterSymbol.v]() : null;
        }
        if ((0, $9d91a18754d7a062$export$50db6e277db66ea0)(iter)) {
            var err = void 0;
            var iterResult = void 0;
            try {
                var count = 0;
                while(!(iterResult = iter.next())[0, $b347daff6f5f8dc1$export$71efb3495f6084f2]){
                    if (callbackfn.call(thisArg || iter, iterResult[0, $b347daff6f5f8dc1$export$764bd63f4c2043a2], count, iter) === -1) break;
                    count++;
                }
            } catch (failed) {
                err = {
                    e: failed
                };
                if (iter.throw) {
                    iterResult = null;
                    iter.throw(err);
                }
            } finally{
                try {
                    if (iterResult && !iterResult[0, $b347daff6f5f8dc1$export$71efb3495f6084f2]) iter.return && iter.return(iterResult);
                } finally{
                    if (err) // eslint-disable-next-line no-unsafe-finally
                    throw err.e;
                }
            }
        }
    }
}



function $54343718a076ab6e$export$69c7b96f216fdf7b(target, elms) {
    if (!(0, $533f826bbc418791$export$fce6876652108ab)(elms) && target) {
        if ((0, $533f826bbc418791$export$43bee75e5e14138e)(elms)) // This is not just "target.push(elms)" but becomes effectively "target.push(elms[0], elms[1], ...)"
        (0, $d88e50d36d3d9760$export$2801572b9d3736b5)(target.push, target, elms);
        else if ((0, $9d91a18754d7a062$export$50db6e277db66ea0)(elms) || (0, $9d91a18754d7a062$export$9652023d9040757)(elms)) (0, $4f88a205a18f32bb$export$1180a64ad833b902)(elms, function(elm) {
            target.push(elm);
        });
        else target.push(elms);
    }
    return target;
}



function $efe9376777343289$export$31fa167f9d342989() {
    var _hooks = [];
    function _doUnload(logger) {
        var oldHooks = _hooks;
        _hooks = [];
        // Remove all registered unload hooks
        (0, $f6bb085f8cf12216$export$e2e5bcdbdc49c586)(oldHooks, function(fn) {
            // allow either rm or remove callback function
            try {
                (fn.rm || fn.remove).call(fn);
            } catch (e) {
                (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , 73 /* _eInternalMessageId.PluginException */ , "Unloading:" + (0, $386f00e3a193a7da$export$21fce7cbd4dc679f)(e));
            }
        });
    }
    function _addHook(hooks) {
        if (hooks) (0, $54343718a076ab6e$export$69c7b96f216fdf7b)(_hooks, hooks);
    }
    return {
        run: _doUnload,
        add: _addHook
    };
}


"use strict";
var $b61d51369f8191a4$var$_a;
var $b61d51369f8191a4$var$strGetPlugin = "getPlugin";
var $b61d51369f8191a4$var$defaultValues = ($b61d51369f8191a4$var$_a = {}, $b61d51369f8191a4$var$_a[0, $9fe4a5d5204a4cff$export$ffb2356587263734] = {
    isVal: (0, $0b747974b0bb3563$export$71fc1ee3e76bc1fe),
    v: {}
}, $b61d51369f8191a4$var$_a);
/**
 * BaseTelemetryPlugin provides a basic implementation of the ITelemetryPlugin interface so that plugins
 * can avoid implementation the same set of boiler plate code as well as provide a base
 * implementation so that new default implementations can be added without breaking all plugins.
 */ var $b61d51369f8191a4$export$64a11c2f90e6766c = /** @class */ function() {
    function BaseTelemetryPlugin() {
        var _self = this; // Setting _self here as it's used outside of the dynamicProto as well
        // NOTE!: DON'T set default values here, instead set them in the _initDefaults() function as it is also called during teardown()
        var _isinitialized;
        var _rootCtx; // Used as the root context, holding the current config and initialized core
        var _nextPlugin; // Used for backward compatibility where plugins don't call the main pipeline
        var _unloadHandlerContainer;
        var _hookContainer;
        _initDefaults();
        (0, $c9b63384299a3252$export$2e2bcd8739ae039)(BaseTelemetryPlugin, _self, function(_self) {
            _self[0, $1ae5573ce493bccc$export$65cd33bb52d04675 /* @min:%2einitialize */ ] = function(config, core, extensions, pluginChain) {
                _setDefaults(config, core, pluginChain);
                _isinitialized = true;
            };
            _self[0, $1ae5573ce493bccc$export$7176fb2a7d11927e /* @min:%2eteardown */ ] = function(unloadCtx, unloadState) {
                var _a;
                // If this plugin has already been torn down (not operational) or is not initialized (core is not set)
                // or the core being used for unload was not the same core used for initialization.
                var core = _self[0, $9fe4a5d5204a4cff$export$3094ace9cd82ff99 /* @min:%2ecore */ ];
                if (!core || unloadCtx && core !== unloadCtx[0, $9fe4a5d5204a4cff$export$3094ace9cd82ff99 /* @min:%2ecore */ ]()) // Do Nothing as either the plugin is not initialized or was not initialized by the current core
                return;
                var result;
                var unloadDone = false;
                var theUnloadCtx = unloadCtx || (0, $bc7124acb0f73e64$export$91bbbd4999751948)(null, core, _nextPlugin && _nextPlugin[$b61d51369f8191a4$var$strGetPlugin] ? _nextPlugin[$b61d51369f8191a4$var$strGetPlugin]() : _nextPlugin);
                var theUnloadState = unloadState || (_a = {
                    reason: 0 /* TelemetryUnloadReason.ManualTeardown */ 
                }, _a[0, $1ae5573ce493bccc$export$d8114c9e990204cb /* @min:isAsync */ ] = false, _a);
                function _unloadCallback() {
                    if (!unloadDone) {
                        unloadDone = true;
                        _unloadHandlerContainer.run(theUnloadCtx, unloadState);
                        _hookContainer.run(theUnloadCtx[0, $1ae5573ce493bccc$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ]());
                        if (result === true) theUnloadCtx[0, $1ae5573ce493bccc$export$5c220169317cd6de /* @min:%2eprocessNext */ ](theUnloadState);
                        _initDefaults();
                    }
                }
                if (!_self[0, $1ae5573ce493bccc$export$458d234b616d0745 /* @min:%2e_doTeardown */ ] || _self[0, $1ae5573ce493bccc$export$458d234b616d0745 /* @min:%2e_doTeardown */ ](theUnloadCtx, theUnloadState, _unloadCallback) !== true) _unloadCallback();
                else // Tell the caller that we will be calling processNext()
                result = true;
                return result;
            };
            _self[0, $1ae5573ce493bccc$export$c9f4bebf02f459de /* @min:%2eupdate */ ] = function(updateCtx, updateState) {
                // If this plugin has already been torn down (not operational) or is not initialized (core is not set)
                // or the core being used for unload was not the same core used for initialization.
                var core = _self[0, $9fe4a5d5204a4cff$export$3094ace9cd82ff99 /* @min:%2ecore */ ];
                if (!core || updateCtx && core !== updateCtx[0, $9fe4a5d5204a4cff$export$3094ace9cd82ff99 /* @min:%2ecore */ ]()) // Do Nothing
                return;
                var result;
                var updateDone = false;
                var theUpdateCtx = updateCtx || (0, $bc7124acb0f73e64$export$e4c32b40c4fbf98a)(null, core, _nextPlugin && _nextPlugin[$b61d51369f8191a4$var$strGetPlugin] ? _nextPlugin[$b61d51369f8191a4$var$strGetPlugin]() : _nextPlugin);
                var theUpdateState = updateState || {
                    reason: 0 /* TelemetryUpdateReason.Unknown */ 
                };
                function _updateCallback() {
                    if (!updateDone) {
                        updateDone = true;
                        _setDefaults(theUpdateCtx.getCfg(), theUpdateCtx.core(), theUpdateCtx[0, $1ae5573ce493bccc$export$36754a48de7fd714 /* @min:%2egetNext */ ]());
                    }
                }
                if (!_self._doUpdate || _self._doUpdate(theUpdateCtx, theUpdateState, _updateCallback) !== true) _updateCallback();
                else result = true;
                return result;
            };
            (0, $0b747974b0bb3563$export$5dd8d245f6f94a18)(_self, "_addUnloadCb", function() {
                return _unloadHandlerContainer;
            }, "add");
            (0, $0b747974b0bb3563$export$5dd8d245f6f94a18)(_self, "_addHook", function() {
                return _hookContainer;
            }, "add");
            (0, $d212d948d25f959a$export$d0d2ebf910ad6e2)(_self, "_unloadHooks", {
                g: function() {
                    return _hookContainer;
                }
            });
        });
        // These are added after the dynamicProto so that are not moved to the prototype
        _self[0, $1ae5573ce493bccc$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ] = function(itemCtx) {
            return _getTelCtx(itemCtx)[0, $1ae5573ce493bccc$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ]();
        };
        _self[0, $1ae5573ce493bccc$export$2e2716e9c35a66a8 /* @min:%2eisInitialized */ ] = function() {
            return _isinitialized;
        };
        _self.setInitialized = function(isInitialized) {
            _isinitialized = isInitialized;
        };
        // _self.getNextPlugin = () => DO NOT IMPLEMENT
        // Sub-classes of this base class *should* not be relying on this value and instead
        // should use processNext() function. If you require access to the plugin use the
        // IProcessTelemetryContext.getNext().getPlugin() while in the pipeline, Note getNext() may return null.
        _self[0, $1ae5573ce493bccc$export$55d672a1dc4d50c1 /* @min:%2esetNextPlugin */ ] = function(next) {
            _nextPlugin = next;
        };
        _self[0, $1ae5573ce493bccc$export$5c220169317cd6de /* @min:%2eprocessNext */ ] = function(env, itemCtx) {
            if (itemCtx) // Normal core execution sequence
            itemCtx[0, $1ae5573ce493bccc$export$5c220169317cd6de /* @min:%2eprocessNext */ ](env);
            else if (_nextPlugin && (0, $533f826bbc418791$export$f6e2535fb5126e54)(_nextPlugin[0, $9fe4a5d5204a4cff$export$820a3bce4a265606 /* @min:%2eprocessTelemetry */ ])) // Looks like backward compatibility or out of band processing. And as it looks
            // like a ITelemetryPlugin or ITelemetryPluginChain, just call processTelemetry
            _nextPlugin[0, $9fe4a5d5204a4cff$export$820a3bce4a265606 /* @min:%2eprocessTelemetry */ ](env, null);
        };
        _self._getTelCtx = _getTelCtx;
        function _getTelCtx(currentCtx) {
            if (currentCtx === void 0) currentCtx = null;
            var itemCtx = currentCtx;
            if (!itemCtx) {
                var rootCtx = _rootCtx || (0, $bc7124acb0f73e64$export$ca98f11e981bcfd6)(null, {}, _self[0, $9fe4a5d5204a4cff$export$3094ace9cd82ff99 /* @min:%2ecore */ ]);
                // tslint:disable-next-line: prefer-conditional-expression
                if (_nextPlugin && _nextPlugin[$b61d51369f8191a4$var$strGetPlugin]) // Looks like a chain object
                itemCtx = rootCtx[0, $1ae5573ce493bccc$export$1e6514b499ba4d34 /* @min:%2ecreateNew */ ](null, _nextPlugin[$b61d51369f8191a4$var$strGetPlugin]);
                else itemCtx = rootCtx[0, $1ae5573ce493bccc$export$1e6514b499ba4d34 /* @min:%2ecreateNew */ ](null, _nextPlugin);
            }
            return itemCtx;
        }
        function _setDefaults(config, core, pluginChain) {
            // Make sure the extensionConfig exists and the config is dynamic
            (0, $acb30f9e62dc5705$export$3a9e9180c14487fd)(config, $b61d51369f8191a4$var$defaultValues, (0, $cc2aaaebf96ac6a7$export$5102d32ea1d740a)(core));
            if (!pluginChain && core) // Get the first plugin from the core
            pluginChain = core[0, $1ae5573ce493bccc$export$a08d24db8e8aa3f3 /* @min:%2egetProcessTelContext */ ]()[0, $1ae5573ce493bccc$export$36754a48de7fd714 /* @min:%2egetNext */ ]();
            var nextPlugin = _nextPlugin;
            if (_nextPlugin && _nextPlugin[$b61d51369f8191a4$var$strGetPlugin]) // If it looks like a proxy/chain then get the plugin
            nextPlugin = _nextPlugin[$b61d51369f8191a4$var$strGetPlugin]();
            // Support legacy plugins where core was defined as a property
            _self[0, $9fe4a5d5204a4cff$export$3094ace9cd82ff99 /* @min:%2ecore */ ] = core;
            _rootCtx = (0, $bc7124acb0f73e64$export$ca98f11e981bcfd6)(pluginChain, config, core, nextPlugin);
        }
        function _initDefaults() {
            _isinitialized = false;
            _self[0, $9fe4a5d5204a4cff$export$3094ace9cd82ff99 /* @min:%2ecore */ ] = null;
            _rootCtx = null;
            _nextPlugin = null;
            _hookContainer = (0, $efe9376777343289$export$31fa167f9d342989)();
            _unloadHandlerContainer = (0, $d13bf4befeee29ad$export$1dd1604aeaf8cfed)();
        }
    }
    // Removed Stub for BaseTelemetryPlugin.prototype.initialize.
    // Removed Stub for BaseTelemetryPlugin.prototype.teardown.
    // Removed Stub for BaseTelemetryPlugin.prototype.update.
    // Removed Stub for BaseTelemetryPlugin.prototype._addUnloadCb.
    // Removed Stub for BaseTelemetryPlugin.prototype._addHook.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    BaseTelemetryPlugin.__ieDyn = 1;
    return BaseTelemetryPlugin;
}();

/*
 * Application Insights JavaScript SDK - Core, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 


/**
 * @internal
 * @ignore
 * @param str
 * @param defaultValue
 * @returns
 */ function $61c4d9dd4226f64e$var$_stringToBoolOrDefault(theValue, defaultValue, theConfig) {
    if (!theValue && (0, $533f826bbc418791$export$bedb7023a7733221)(theValue)) return defaultValue;
    if ((0, $533f826bbc418791$export$f9ce7b637dfbe238)(theValue)) return theValue;
    return (0, $d813f4522b40a37e$export$590567be997858b6)(theValue)[0, $1ae5573ce493bccc$export$e4eaee9e01d9baaa /* @min:%2etoLowerCase */ ]() === "true";
}
function $61c4d9dd4226f64e$export$5d17fe34e1e248ba(defaultValue) {
    return {
        mrg: true,
        v: defaultValue
    };
}
function $61c4d9dd4226f64e$export$e86b712d02676c90(setter, defaultValue) {
    return {
        set: setter,
        v: defaultValue
    };
}
function $61c4d9dd4226f64e$export$d0884590a6a82e6c(validator, defaultValue, fallBackName) {
    return {
        fb: fallBackName,
        isVal: validator,
        v: defaultValue
    };
}
function $61c4d9dd4226f64e$export$bad0d7bace730ae(defaultValue, fallBackName) {
    return {
        fb: fallBackName,
        set: $61c4d9dd4226f64e$var$_stringToBoolOrDefault,
        v: !!defaultValue
    };
}
function $61c4d9dd4226f64e$export$4308728f2256db2f(defaultValue) {
    return {
        isVal: (0, $533f826bbc418791$export$f6e2535fb5126e54),
        v: defaultValue || null
    };
}
function $61c4d9dd4226f64e$export$75965e1022d5969a(defaultValue) {
    return {
        isVal: (0, $533f826bbc418791$export$844ec244b1367d54),
        v: (0, $d813f4522b40a37e$export$590567be997858b6)(defaultValue || (0, $9fe4a5d5204a4cff$export$5e8607ab26634759))
    };
}
function $61c4d9dd4226f64e$export$4ebeffd29cffbfb(defaultValue) {
    var _a;
    return _a = {}, _a[0, $1ae5573ce493bccc$export$9d71a37f0770d87f /* @min:blkVal */ ] = true, _a.v = defaultValue, _a;
}

/*
 * Application Insights JavaScript SDK - Core, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 



// Added to help with minfication
var $12cc003c7fb5ccde$var$strOnPrefix = "on";
var $12cc003c7fb5ccde$var$strAttachEvent = "attachEvent";
var $12cc003c7fb5ccde$var$strAddEventHelper = "addEventListener";
var $12cc003c7fb5ccde$var$strDetachEvent = "detachEvent";
var $12cc003c7fb5ccde$var$strRemoveEventListener = "removeEventListener";
var $12cc003c7fb5ccde$var$strEvents = "events";
var $12cc003c7fb5ccde$var$strVisibilityChangeEvt = "visibilitychange";
var $12cc003c7fb5ccde$var$strPageHide = "pagehide";
var $12cc003c7fb5ccde$var$strPageShow = "pageshow";
var $12cc003c7fb5ccde$var$strUnload = "unload";
var $12cc003c7fb5ccde$var$strBeforeUnload = "beforeunload";
var $12cc003c7fb5ccde$var$strPageHideNamespace = (0, $8a2d104e2647a310$export$eb4a6badb18ead04)("aiEvtPageHide");
var $12cc003c7fb5ccde$var$strPageShowNamespace = (0, $8a2d104e2647a310$export$eb4a6badb18ead04)("aiEvtPageShow");
var $12cc003c7fb5ccde$var$rRemoveEmptyNs = /\.[\.]+/g;
var $12cc003c7fb5ccde$var$rRemoveTrailingEmptyNs = /[\.]+$/;
var $12cc003c7fb5ccde$var$_guid = 1;
var $12cc003c7fb5ccde$var$elmNodeData = (0, $8a2d104e2647a310$export$b95c3438408d78aa)("events");
var $12cc003c7fb5ccde$var$eventNamespace = /^([^.]*)(?:\.(.+)|)/;
function $12cc003c7fb5ccde$var$_normalizeNamespace(name) {
    if (name && name[0, $1ae5573ce493bccc$export$ef9ef3ed86c4485 /* @min:%2ereplace */ ]) return name[0, $1ae5573ce493bccc$export$ef9ef3ed86c4485 /* @min:%2ereplace */ ](/^[\s\.]+|(?=[\s\.])[\.\s]+$/g, (0, $9fe4a5d5204a4cff$export$5e8607ab26634759));
    return name;
}
function $12cc003c7fb5ccde$var$_getEvtNamespace(eventName, evtNamespace) {
    var _a;
    if (evtNamespace) {
        var theNamespace_1 = (0, $9fe4a5d5204a4cff$export$5e8607ab26634759);
        if ((0, $533f826bbc418791$export$43bee75e5e14138e)(evtNamespace)) {
            theNamespace_1 = (0, $9fe4a5d5204a4cff$export$5e8607ab26634759);
            (0, $f6bb085f8cf12216$export$e2e5bcdbdc49c586)(evtNamespace, function(name) {
                name = $12cc003c7fb5ccde$var$_normalizeNamespace(name);
                if (name) {
                    if (name[0] !== ".") name = "." + name;
                    theNamespace_1 += name;
                }
            });
        } else theNamespace_1 = $12cc003c7fb5ccde$var$_normalizeNamespace(evtNamespace);
        if (theNamespace_1) {
            if (theNamespace_1[0] !== ".") theNamespace_1 = "." + theNamespace_1;
            // We may only have the namespace and not an eventName
            eventName = (eventName || (0, $9fe4a5d5204a4cff$export$5e8607ab26634759)) + theNamespace_1;
        }
    }
    var parsedEvent = $12cc003c7fb5ccde$var$eventNamespace.exec(eventName || (0, $9fe4a5d5204a4cff$export$5e8607ab26634759)) || [];
    return _a = {}, _a[0, $1ae5573ce493bccc$export$8fdcd26070ec159 /* @min:type */ ] = parsedEvent[1], _a.ns = (parsedEvent[2] || (0, $9fe4a5d5204a4cff$export$5e8607ab26634759)).replace($12cc003c7fb5ccde$var$rRemoveEmptyNs, ".").replace($12cc003c7fb5ccde$var$rRemoveTrailingEmptyNs, (0, $9fe4a5d5204a4cff$export$5e8607ab26634759))[0, $1ae5573ce493bccc$export$b889f1d4cb07c706 /* @min:%2esplit */ ](".").sort().join("."), _a;
}
function $12cc003c7fb5ccde$export$e2bcc16f65e2a5d2(target, eventName, evtNamespace) {
    var theEvents = [];
    var eventCache = $12cc003c7fb5ccde$var$elmNodeData.get(target, $12cc003c7fb5ccde$var$strEvents, {}, false);
    var evtName = $12cc003c7fb5ccde$var$_getEvtNamespace(eventName, evtNamespace);
    (0, $45e528077703ac0c$export$aa0705d5774c95d1)(eventCache, function(evtType, registeredEvents) {
        (0, $f6bb085f8cf12216$export$e2e5bcdbdc49c586)(registeredEvents, function(value) {
            var _a;
            if (!evtName[0, $1ae5573ce493bccc$export$8fdcd26070ec159 /* @min:%2etype */ ] || evtName[0, $1ae5573ce493bccc$export$8fdcd26070ec159 /* @min:%2etype */ ] === value.evtName[0, $1ae5573ce493bccc$export$8fdcd26070ec159 /* @min:%2etype */ ]) {
                if (!evtName.ns || evtName.ns === evtName.ns) theEvents[0, $1ae5573ce493bccc$export$a0a330e7fa1e278c /* @min:%2epush */ ]((_a = {}, _a[0, $1ae5573ce493bccc$export$9734b0a24bf02e93 /* @min:name */ ] = value.evtName[0, $1ae5573ce493bccc$export$8fdcd26070ec159 /* @min:%2etype */ ] + (value.evtName.ns ? "." + value.evtName.ns : (0, $9fe4a5d5204a4cff$export$5e8607ab26634759)), _a.handler = value[0, $1ae5573ce493bccc$export$b353fcbe1ae31450 /* @min:%2ehandler */ ], _a));
            }
        });
    });
    return theEvents;
}
// Exported for internal unit testing only
function $12cc003c7fb5ccde$var$_getRegisteredEvents(target, evtName, addDefault) {
    if (addDefault === void 0) addDefault = true;
    var aiEvts = $12cc003c7fb5ccde$var$elmNodeData.get(target, $12cc003c7fb5ccde$var$strEvents, {}, addDefault);
    var registeredEvents = aiEvts[evtName];
    if (!registeredEvents) registeredEvents = aiEvts[evtName] = [];
    return registeredEvents;
}
function $12cc003c7fb5ccde$var$_doDetach(obj, evtName, handlerRef, useCapture) {
    if (obj && evtName && evtName[0, $1ae5573ce493bccc$export$8fdcd26070ec159 /* @min:%2etype */ ]) {
        if (obj[$12cc003c7fb5ccde$var$strRemoveEventListener]) obj[$12cc003c7fb5ccde$var$strRemoveEventListener](evtName[0, $1ae5573ce493bccc$export$8fdcd26070ec159 /* @min:%2etype */ ], handlerRef, useCapture);
        else if (obj[$12cc003c7fb5ccde$var$strDetachEvent]) obj[$12cc003c7fb5ccde$var$strDetachEvent]($12cc003c7fb5ccde$var$strOnPrefix + evtName[0, $1ae5573ce493bccc$export$8fdcd26070ec159 /* @min:%2etype */ ], handlerRef);
    }
}
function $12cc003c7fb5ccde$var$_doAttach(obj, evtName, handlerRef, useCapture) {
    var result = false;
    if (obj && evtName && evtName[0, $1ae5573ce493bccc$export$8fdcd26070ec159 /* @min:%2etype */ ] && handlerRef) {
        if (obj[$12cc003c7fb5ccde$var$strAddEventHelper]) {
            // all browsers except IE before version 9
            obj[$12cc003c7fb5ccde$var$strAddEventHelper](evtName[0, $1ae5573ce493bccc$export$8fdcd26070ec159 /* @min:%2etype */ ], handlerRef, useCapture);
            result = true;
        } else if (obj[$12cc003c7fb5ccde$var$strAttachEvent]) {
            // IE before version 9
            obj[$12cc003c7fb5ccde$var$strAttachEvent]($12cc003c7fb5ccde$var$strOnPrefix + evtName[0, $1ae5573ce493bccc$export$8fdcd26070ec159 /* @min:%2etype */ ], handlerRef);
            result = true;
        }
    }
    return result;
}
function $12cc003c7fb5ccde$var$_doUnregister(target, events, evtName, unRegFn) {
    var idx = events[0, $1ae5573ce493bccc$export$6eae51590aaea43 /* @min:%2elength */ ];
    while(idx--){
        var theEvent = events[idx];
        if (theEvent) {
            if (!evtName.ns || evtName.ns === theEvent.evtName.ns) {
                if (!unRegFn || unRegFn(theEvent)) {
                    $12cc003c7fb5ccde$var$_doDetach(target, theEvent.evtName, theEvent[0, $1ae5573ce493bccc$export$b353fcbe1ae31450 /* @min:%2ehandler */ ], theEvent.capture);
                    // Remove the registered event
                    events[0, $1ae5573ce493bccc$export$84020a2e4fe863b0 /* @min:%2esplice */ ](idx, 1);
                }
            }
        }
    }
}
function $12cc003c7fb5ccde$var$_unregisterEvents(target, evtName, unRegFn) {
    if (evtName[0, $1ae5573ce493bccc$export$8fdcd26070ec159 /* @min:%2etype */ ]) $12cc003c7fb5ccde$var$_doUnregister(target, $12cc003c7fb5ccde$var$_getRegisteredEvents(target, evtName[0, $1ae5573ce493bccc$export$8fdcd26070ec159 /* @min:%2etype */ ]), evtName, unRegFn);
    else {
        var eventCache = $12cc003c7fb5ccde$var$elmNodeData.get(target, $12cc003c7fb5ccde$var$strEvents, {});
        (0, $45e528077703ac0c$export$aa0705d5774c95d1)(eventCache, function(evtType, events) {
            $12cc003c7fb5ccde$var$_doUnregister(target, events, evtName, unRegFn);
        });
        // Cleanup
        if ((0, $36a077d9f4439b69$export$f7628dc18f4211e5)(eventCache)[0, $1ae5573ce493bccc$export$6eae51590aaea43 /* @min:%2elength */ ] === 0) $12cc003c7fb5ccde$var$elmNodeData.kill(target, $12cc003c7fb5ccde$var$strEvents);
    }
}
function $12cc003c7fb5ccde$export$3f37a50e0edde3be(theNamespace, namespaces) {
    var newNamespaces;
    if (namespaces) {
        if ((0, $533f826bbc418791$export$43bee75e5e14138e)(namespaces)) newNamespaces = [
            theNamespace
        ].concat(namespaces);
        else newNamespaces = [
            theNamespace,
            namespaces
        ];
        // resort the namespaces so they are always in order
        newNamespaces = $12cc003c7fb5ccde$var$_getEvtNamespace("xx", newNamespaces).ns[0, $1ae5573ce493bccc$export$b889f1d4cb07c706 /* @min:%2esplit */ ](".");
    } else newNamespaces = theNamespace;
    return newNamespaces;
}
function $12cc003c7fb5ccde$export$324ab159353a60a9(target, eventName, handlerRef, evtNamespace, useCapture) {
    var _a;
    if (useCapture === void 0) useCapture = false;
    var result = false;
    if (target) try {
        var evtName = $12cc003c7fb5ccde$var$_getEvtNamespace(eventName, evtNamespace);
        result = $12cc003c7fb5ccde$var$_doAttach(target, evtName, handlerRef, useCapture);
        if (result && $12cc003c7fb5ccde$var$elmNodeData.accept(target)) {
            var registeredEvent = (_a = {
                guid: $12cc003c7fb5ccde$var$_guid++,
                evtName: evtName
            }, _a[0, $1ae5573ce493bccc$export$b353fcbe1ae31450 /* @min:handler */ ] = handlerRef, _a.capture = useCapture, _a);
            $12cc003c7fb5ccde$var$_getRegisteredEvents(target, evtName.type)[0, $1ae5573ce493bccc$export$a0a330e7fa1e278c /* @min:%2epush */ ](registeredEvent);
        }
    } catch (e) {
    // Just Ignore any error so that we don't break any execution path
    }
    return result;
}
function $12cc003c7fb5ccde$export$51dedceb7c784eff(target, eventName, handlerRef, evtNamespace, useCapture) {
    if (useCapture === void 0) useCapture = false;
    if (target) try {
        var evtName_1 = $12cc003c7fb5ccde$var$_getEvtNamespace(eventName, evtNamespace);
        var found_1 = false;
        $12cc003c7fb5ccde$var$_unregisterEvents(target, evtName_1, function(regEvent) {
            if (evtName_1.ns && !handlerRef || regEvent[0, $1ae5573ce493bccc$export$b353fcbe1ae31450 /* @min:%2ehandler */ ] === handlerRef) {
                found_1 = true;
                return true;
            }
            return false;
        });
        if (!found_1) // fallback to try and remove as requested
        $12cc003c7fb5ccde$var$_doDetach(target, evtName_1, handlerRef, useCapture);
    } catch (e) {
    // Just Ignore any error so that we don't break any execution path
    }
}
function $12cc003c7fb5ccde$export$c7861dcba2385fcd(obj, eventNameWithoutOn, handlerRef, useCapture) {
    if (useCapture === void 0) useCapture = false;
    return $12cc003c7fb5ccde$export$324ab159353a60a9(obj, eventNameWithoutOn, handlerRef, null, useCapture);
}
function $12cc003c7fb5ccde$export$647f6b935c1d6b6(obj, eventNameWithoutOn, handlerRef, useCapture) {
    if (useCapture === void 0) useCapture = false;
    $12cc003c7fb5ccde$export$51dedceb7c784eff(obj, eventNameWithoutOn, handlerRef, null, useCapture);
}
function $12cc003c7fb5ccde$export$3b37be979ee3303a(eventName, callback, evtNamespace) {
    var result = false;
    var w = (0, $3d5fcb60a9467a45$export$38b2d434cce3ea22)();
    if (w) {
        result = $12cc003c7fb5ccde$export$324ab159353a60a9(w, eventName, callback, evtNamespace);
        result = $12cc003c7fb5ccde$export$324ab159353a60a9(w["body"], eventName, callback, evtNamespace) || result;
    }
    var doc = (0, $3d5fcb60a9467a45$export$f65ca476c09acec0)();
    if (doc) result = $12cc003c7fb5ccde$export$324ab159353a60a9(doc, eventName, callback, evtNamespace) || result;
    return result;
}
function $12cc003c7fb5ccde$export$546f5991fce5bf06(eventName, callback, evtNamespace) {
    var w = (0, $3d5fcb60a9467a45$export$38b2d434cce3ea22)();
    if (w) {
        $12cc003c7fb5ccde$export$51dedceb7c784eff(w, eventName, callback, evtNamespace);
        $12cc003c7fb5ccde$export$51dedceb7c784eff(w["body"], eventName, callback, evtNamespace);
    }
    var doc = (0, $3d5fcb60a9467a45$export$f65ca476c09acec0)();
    if (doc) $12cc003c7fb5ccde$export$51dedceb7c784eff(doc, eventName, callback, evtNamespace);
}
/**
 * Bind the listener to the array of events
 * @param events - An string array of event names to bind the listener to
 * @param listener - The event callback to call when the event is triggered
 * @param excludeEvents - [Optional] An array of events that should not be hooked (if possible), unless no other events can be.
 * @param evtNamespace - [Optional] Namespace(s) to append to the event listeners so they can be uniquely identified and removed based on this namespace.
 * @returns true - when at least one of the events was registered otherwise false
 */ function $12cc003c7fb5ccde$var$_addEventListeners(events, listener, excludeEvents, evtNamespace) {
    var added = false;
    if (listener && events && events[0, $1ae5573ce493bccc$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) (0, $f6bb085f8cf12216$export$e2e5bcdbdc49c586)(events, function(name) {
        if (name) {
            if (!excludeEvents || (0, $a96d4958027d6f85$export$9f3b3ffa84393d30)(excludeEvents, name) === -1) added = $12cc003c7fb5ccde$export$3b37be979ee3303a(name, listener, evtNamespace) || added;
        }
    });
    return added;
}
function $12cc003c7fb5ccde$export$40a4ed63e5cb7043(events, listener, excludeEvents, evtNamespace) {
    var added = false;
    if (listener && events && (0, $533f826bbc418791$export$43bee75e5e14138e)(events)) {
        added = $12cc003c7fb5ccde$var$_addEventListeners(events, listener, excludeEvents, evtNamespace);
        if (!added && excludeEvents && excludeEvents[0, $1ae5573ce493bccc$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) // Failed to add any listeners and we excluded some, so just attempt to add the excluded events
        added = $12cc003c7fb5ccde$var$_addEventListeners(events, listener, null, evtNamespace);
    }
    return added;
}
function $12cc003c7fb5ccde$export$8c7b13b21690651d(events, listener, evtNamespace) {
    if (events && (0, $533f826bbc418791$export$43bee75e5e14138e)(events)) (0, $f6bb085f8cf12216$export$e2e5bcdbdc49c586)(events, function(name) {
        if (name) $12cc003c7fb5ccde$export$546f5991fce5bf06(name, listener, evtNamespace);
    });
}
function $12cc003c7fb5ccde$export$f16ce149aca77fdd(listener, excludeEvents, evtNamespace) {
    // Hook the unload event for the document, window and body to ensure that the client events are flushed to the server
    // As just hooking the window does not always fire (on chrome) for page navigation's.
    return $12cc003c7fb5ccde$export$40a4ed63e5cb7043([
        $12cc003c7fb5ccde$var$strBeforeUnload,
        $12cc003c7fb5ccde$var$strUnload,
        $12cc003c7fb5ccde$var$strPageHide
    ], listener, excludeEvents, evtNamespace);
}
function $12cc003c7fb5ccde$export$272dc813b0b2654c(listener, evtNamespace) {
    $12cc003c7fb5ccde$export$8c7b13b21690651d([
        $12cc003c7fb5ccde$var$strBeforeUnload,
        $12cc003c7fb5ccde$var$strUnload,
        $12cc003c7fb5ccde$var$strPageHide
    ], listener, evtNamespace);
}
function $12cc003c7fb5ccde$export$46744aee53e5e558(listener, excludeEvents, evtNamespace) {
    function _handlePageVisibility(evt) {
        var doc = (0, $3d5fcb60a9467a45$export$f65ca476c09acec0)();
        if (listener && doc && doc.visibilityState === "hidden") listener(evt);
    }
    // add the unique page show namespace to any provided namespace so we can only remove the ones added by "pagehide"
    var newNamespaces = $12cc003c7fb5ccde$export$3f37a50e0edde3be($12cc003c7fb5ccde$var$strPageHideNamespace, evtNamespace);
    var pageUnloadAdded = $12cc003c7fb5ccde$var$_addEventListeners([
        $12cc003c7fb5ccde$var$strPageHide
    ], listener, excludeEvents, newNamespaces);
    if (!excludeEvents || (0, $a96d4958027d6f85$export$9f3b3ffa84393d30)(excludeEvents, $12cc003c7fb5ccde$var$strVisibilityChangeEvt) === -1) pageUnloadAdded = $12cc003c7fb5ccde$var$_addEventListeners([
        $12cc003c7fb5ccde$var$strVisibilityChangeEvt
    ], _handlePageVisibility, excludeEvents, newNamespaces) || pageUnloadAdded;
    if (!pageUnloadAdded && excludeEvents) // Failed to add any listeners and we where requested to exclude some, so just call again without excluding anything
    pageUnloadAdded = $12cc003c7fb5ccde$export$46744aee53e5e558(listener, null, evtNamespace);
    return pageUnloadAdded;
}
function $12cc003c7fb5ccde$export$6aca6ee3a147169f(listener, evtNamespace) {
    // add the unique page show namespace to any provided namespace so we only remove the ones added by "pagehide"
    var newNamespaces = $12cc003c7fb5ccde$export$3f37a50e0edde3be($12cc003c7fb5ccde$var$strPageHideNamespace, evtNamespace);
    $12cc003c7fb5ccde$export$8c7b13b21690651d([
        $12cc003c7fb5ccde$var$strPageHide
    ], listener, newNamespaces);
    $12cc003c7fb5ccde$export$8c7b13b21690651d([
        $12cc003c7fb5ccde$var$strVisibilityChangeEvt
    ], null, newNamespaces);
}
function $12cc003c7fb5ccde$export$cce4a6563c734c0(listener, excludeEvents, evtNamespace) {
    function _handlePageVisibility(evt) {
        var doc = (0, $3d5fcb60a9467a45$export$f65ca476c09acec0)();
        if (listener && doc && doc.visibilityState === "visible") listener(evt);
    }
    // add the unique page show namespace to any provided namespace so we can only remove the ones added by "pageshow"
    var newNamespaces = $12cc003c7fb5ccde$export$3f37a50e0edde3be($12cc003c7fb5ccde$var$strPageShowNamespace, evtNamespace);
    var pageShowAdded = $12cc003c7fb5ccde$var$_addEventListeners([
        $12cc003c7fb5ccde$var$strPageShow
    ], listener, excludeEvents, newNamespaces);
    pageShowAdded = $12cc003c7fb5ccde$var$_addEventListeners([
        $12cc003c7fb5ccde$var$strVisibilityChangeEvt
    ], _handlePageVisibility, excludeEvents, newNamespaces) || pageShowAdded;
    if (!pageShowAdded && excludeEvents) // Failed to add any listeners and we where requested to exclude some, so just call again without excluding anything
    pageShowAdded = $12cc003c7fb5ccde$export$cce4a6563c734c0(listener, null, evtNamespace);
    return pageShowAdded;
}
function $12cc003c7fb5ccde$export$c49093a8bd06690f(listener, evtNamespace) {
    // add the unique page show namespace to any provided namespace so we only remove the ones added by "pageshow"
    var newNamespaces = $12cc003c7fb5ccde$export$3f37a50e0edde3be($12cc003c7fb5ccde$var$strPageShowNamespace, evtNamespace);
    $12cc003c7fb5ccde$export$8c7b13b21690651d([
        $12cc003c7fb5ccde$var$strPageShow
    ], listener, newNamespaces);
    $12cc003c7fb5ccde$export$8c7b13b21690651d([
        $12cc003c7fb5ccde$var$strVisibilityChangeEvt
    ], null, newNamespaces);
}

/*
 * Application Insights JavaScript SDK - Core, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 



var $963b9811c2275531$var$aiInstrumentHooks = "_aiHooks";
var $963b9811c2275531$var$cbNames = [
    "req",
    "rsp",
    "hkErr",
    "fnErr"
];
/** @ignore */ function $963b9811c2275531$var$_arrLoop(arr, fn) {
    if (arr) for(var lp = 0; lp < arr[0, $1ae5573ce493bccc$export$6eae51590aaea43 /* @min:%2elength */ ]; lp++){
        if (fn(arr[lp], lp)) break;
    }
}
/** @ignore */ function $963b9811c2275531$var$_doCallbacks(hooks, callDetails, cbArgs, hookCtx, type) {
    if (type >= 0 /* CallbackType.Request */  && type <= 2 /* CallbackType.HookError */ ) $963b9811c2275531$var$_arrLoop(hooks, function(hook, idx) {
        var cbks = hook.cbks;
        var cb = cbks[$963b9811c2275531$var$cbNames[type]];
        if (cb) {
            // Set the specific hook context implementation using a lazy creation pattern
            callDetails.ctx = function() {
                var ctx = hookCtx[idx] = hookCtx[idx] || {};
                return ctx;
            };
            try {
                cb[0, $1ae5573ce493bccc$export$2f85ca6962b15ff8 /* @min:%2eapply */ ](callDetails.inst, cbArgs);
            } catch (err) {
                var orgEx = callDetails.err;
                try {
                    // Report Hook error via the callback
                    var hookErrorCb = cbks[$963b9811c2275531$var$cbNames[2 /* CallbackType.HookError */ ]];
                    if (hookErrorCb) {
                        callDetails.err = err;
                        hookErrorCb[0, $1ae5573ce493bccc$export$2f85ca6962b15ff8 /* @min:%2eapply */ ](callDetails.inst, cbArgs);
                    }
                } catch (e) {
                // Not much we can do here -- swallowing the exception to avoid crashing the hosting app
                } finally{
                    // restore the original exception (if any)
                    callDetails.err = orgEx;
                }
            }
        }
    });
}
/** @ignore */ function $963b9811c2275531$var$_createFunctionHook(aiHook) {
    // Define a temporary method that queues-up a the real method call
    return function() {
        var _a;
        var funcThis = this;
        // Capture the original arguments passed to the method
        var orgArgs = arguments;
        var hooks = aiHook.h;
        var funcArgs = (_a = {}, _a[0, $1ae5573ce493bccc$export$9734b0a24bf02e93 /* @min:name */ ] = aiHook.n, _a.inst = funcThis, _a.ctx = null, _a.set = _replaceArg, _a);
        var hookCtx = [];
        var cbArgs = _createArgs([
            funcArgs
        ], orgArgs);
        funcArgs.evt = (0, $3d5fcb60a9467a45$export$3df6e51375017edd)("event");
        function _createArgs(target, theArgs) {
            $963b9811c2275531$var$_arrLoop(theArgs, function(arg) {
                target[0, $1ae5573ce493bccc$export$a0a330e7fa1e278c /* @min:%2epush */ ](arg);
            });
            return target;
        }
        function _replaceArg(idx, value) {
            orgArgs = _createArgs([], orgArgs);
            orgArgs[idx] = value;
            cbArgs = _createArgs([
                funcArgs
            ], orgArgs);
        }
        // Call the pre-request hooks
        $963b9811c2275531$var$_doCallbacks(hooks, funcArgs, cbArgs, hookCtx, 0 /* CallbackType.Request */ );
        // Call the original function was called
        var theFunc = aiHook.f;
        if (theFunc) try {
            funcArgs.rslt = theFunc[0, $1ae5573ce493bccc$export$2f85ca6962b15ff8 /* @min:%2eapply */ ](funcThis, orgArgs);
        } catch (err) {
            // Report the request callback
            funcArgs.err = err;
            $963b9811c2275531$var$_doCallbacks(hooks, funcArgs, cbArgs, hookCtx, 3 /* CallbackType.FunctionError */ );
            // rethrow the original exception so anyone listening for it can catch the exception
            throw err;
        }
        // Call the post-request hooks
        $963b9811c2275531$var$_doCallbacks(hooks, funcArgs, cbArgs, hookCtx, 1 /* CallbackType.Response */ );
        return funcArgs.rslt;
    };
}
/** @ignore */ function $963b9811c2275531$var$_getOwner(target, name, checkPrototype, checkParentProto) {
    var owner = null;
    if (target) {
        if ((0, $78c14fe71626d827$export$d76937f5d45b7158)(target, name)) owner = target;
        else if (checkPrototype) owner = $963b9811c2275531$var$_getOwner((0, $0b747974b0bb3563$export$821e81707b1677f9)(target), name, checkParentProto, false);
    }
    return owner;
}
function $963b9811c2275531$export$6b32104a5f4313f6(target, funcName, callbacks) {
    if (target) return $963b9811c2275531$export$152e6c4c396a57a(target[0, $67b827af57eed1eb$export$ecddaaeb55ecf049], funcName, callbacks, false);
    return null;
}
function $963b9811c2275531$export$aaa214566a8b50d(target, funcNames, callbacks) {
    if (target) return $963b9811c2275531$export$3bccad25f6aafea4(target[0, $67b827af57eed1eb$export$ecddaaeb55ecf049], funcNames, callbacks, false);
    return null;
}
function $963b9811c2275531$var$_createInstrumentHook(owner, funcName, fn, callbacks) {
    var aiHook = fn && fn[$963b9811c2275531$var$aiInstrumentHooks];
    if (!aiHook) {
        // Only hook the function once
        aiHook = {
            i: 0,
            n: funcName,
            f: fn,
            h: []
        };
        // Override (hook) the original function
        var newFunc = $963b9811c2275531$var$_createFunctionHook(aiHook);
        newFunc[$963b9811c2275531$var$aiInstrumentHooks] = aiHook; // Tag and store the function hooks
        owner[funcName] = newFunc;
    }
    var theHook = {
        // tslint:disable:object-literal-shorthand
        id: aiHook.i,
        cbks: callbacks,
        rm: function() {
            // DO NOT Use () => { shorthand for the function as the this gets replaced
            // with the outer this and not the this for theHook instance.
            var id = this.id;
            $963b9811c2275531$var$_arrLoop(aiHook.h, function(hook, idx) {
                if (hook.id === id) {
                    aiHook.h[0, $1ae5573ce493bccc$export$84020a2e4fe863b0 /* @min:%2esplice */ ](idx, 1);
                    return 1;
                }
            });
        }
    };
    aiHook.i++;
    aiHook.h[0, $1ae5573ce493bccc$export$a0a330e7fa1e278c /* @min:%2epush */ ](theHook);
    return theHook;
}
function $963b9811c2275531$export$152e6c4c396a57a(target, funcName, callbacks, checkPrototype, checkParentProto) {
    if (checkPrototype === void 0) checkPrototype = true;
    if (target && funcName && callbacks) {
        var owner = $963b9811c2275531$var$_getOwner(target, funcName, checkPrototype, checkParentProto);
        if (owner) {
            var fn = owner[funcName];
            if (typeof fn === (0, $67b827af57eed1eb$export$327014e6dfd5ba11)) return $963b9811c2275531$var$_createInstrumentHook(owner, funcName, fn, callbacks);
        }
    }
    return null;
}
function $963b9811c2275531$export$3bccad25f6aafea4(target, funcNames, callbacks, checkPrototype, checkParentProto) {
    if (checkPrototype === void 0) checkPrototype = true;
    var hooks = null;
    $963b9811c2275531$var$_arrLoop(funcNames, function(funcName) {
        var hook = $963b9811c2275531$export$152e6c4c396a57a(target, funcName, callbacks, checkPrototype, checkParentProto);
        if (hook) {
            if (!hooks) hooks = [];
            hooks[0, $1ae5573ce493bccc$export$a0a330e7fa1e278c /* @min:%2epush */ ](hook);
        }
    });
    return hooks;
}
function $963b9811c2275531$export$b96f6cbe9b035430(target, evtName, callbacks, checkPrototype, checkParentProto) {
    if (target && evtName && callbacks) {
        var owner = $963b9811c2275531$var$_getOwner(target, evtName, checkPrototype, checkParentProto) || target;
        if (owner) return $963b9811c2275531$var$_createInstrumentHook(owner, evtName, owner[evtName], callbacks);
    }
    return null;
}

/*
 * Application Insights JavaScript SDK - Core, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ /*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */ 






var $2b52e71bd2d7d7f0$export$5222b9460f3ddbec = (0, $d491d25af4ac425c$export$e4412260893e0ee4)("endsWith", (0, $b347daff6f5f8dc1$export$a31bd47275edb702), $2b52e71bd2d7d7f0$export$fe3b71ba5ba4a9ec);
function $2b52e71bd2d7d7f0$export$fe3b71ba5ba4a9ec(value, searchString, length) {
    if (!(0, $533f826bbc418791$export$844ec244b1367d54)(value)) (0, $44a1c24c0e411039$export$3f7738bd7dcba681)("'" + (0, $386f00e3a193a7da$export$21fce7cbd4dc679f)(value) + "' is not a string");
    var searchValue = (0, $533f826bbc418791$export$844ec244b1367d54)(searchString) ? searchString : (0, $d813f4522b40a37e$export$590567be997858b6)(searchString);
    var chkLen = searchValue[0, $b347daff6f5f8dc1$export$5f32d5745d700b0e];
    var len = value[0, $b347daff6f5f8dc1$export$5f32d5745d700b0e];
    var end = !(0, $533f826bbc418791$export$fce6876652108ab)(length) && length < len ? length : len;
    return (0, $c3f3bf8012a4b2d4$export$9d1aa7361d7a6e87)(value, end - chkLen, end) === searchValue;
}









var $d751d7cd1b1c5598$var$_a, $d751d7cd1b1c5598$var$_b;
var $d751d7cd1b1c5598$var$strToGMTString = "toGMTString";
var $d751d7cd1b1c5598$var$strToUTCString = "toUTCString";
var $d751d7cd1b1c5598$var$strCookie = "cookie";
var $d751d7cd1b1c5598$var$strExpires = "expires";
var $d751d7cd1b1c5598$var$strIsCookieUseDisabled = "isCookieUseDisabled";
var $d751d7cd1b1c5598$var$strDisableCookiesUsage = "disableCookiesUsage";
var $d751d7cd1b1c5598$var$strConfigCookieMgr = "_ckMgr";
var $d751d7cd1b1c5598$var$_supportsCookies = null;
var $d751d7cd1b1c5598$var$_allowUaSameSite = null;
var $d751d7cd1b1c5598$var$_parsedCookieValue = null;
var $d751d7cd1b1c5598$var$_doc;
var $d751d7cd1b1c5598$var$_cookieCache = {};
var $d751d7cd1b1c5598$var$_globalCookieConfig = {};
// // `isCookieUseDisabled` is deprecated, so explicitly casting as a key of IConfiguration to avoid typing error
// // when both isCookieUseDisabled and disableCookiesUsage are used disableCookiesUsage will take precedent, which is
// // why its listed first
/**
 * Set the supported dynamic config values as undefined (or an empty object) so that
 * any listeners will be informed of any changes.
 * Explicitly NOT including the deprecated `isCookieUseDisabled` as we don't want to support
 * the v1 deprecated field as dynamic for updates
 */ var $d751d7cd1b1c5598$var$rootDefaultConfig = ($d751d7cd1b1c5598$var$_a = {
    cookieCfg: (0, $61c4d9dd4226f64e$export$5d17fe34e1e248ba)(($d751d7cd1b1c5598$var$_b = {}, $d751d7cd1b1c5598$var$_b[0, $9fe4a5d5204a4cff$export$8f3e5386cefa231e] = {
        fb: "cookieDomain",
        dfVal: (0, $0b747974b0bb3563$export$71fc1ee3e76bc1fe)
    }, $d751d7cd1b1c5598$var$_b.path = {
        fb: "cookiePath",
        dfVal: (0, $0b747974b0bb3563$export$71fc1ee3e76bc1fe)
    }, $d751d7cd1b1c5598$var$_b.enabled = (0, $9fe4a5d5204a4cff$export$a43287864529b8fd), $d751d7cd1b1c5598$var$_b.ignoreCookies = (0, $9fe4a5d5204a4cff$export$a43287864529b8fd), $d751d7cd1b1c5598$var$_b.blockedCookies = (0, $9fe4a5d5204a4cff$export$a43287864529b8fd), $d751d7cd1b1c5598$var$_b)),
    cookieDomain: (0, $9fe4a5d5204a4cff$export$a43287864529b8fd),
    cookiePath: (0, $9fe4a5d5204a4cff$export$a43287864529b8fd)
}, $d751d7cd1b1c5598$var$_a[$d751d7cd1b1c5598$var$strDisableCookiesUsage] = (0, $9fe4a5d5204a4cff$export$a43287864529b8fd), $d751d7cd1b1c5598$var$_a);
function $d751d7cd1b1c5598$var$_getDoc() {
    !$d751d7cd1b1c5598$var$_doc && ($d751d7cd1b1c5598$var$_doc = (0, $d8ec17546a34ef88$export$db98eae15987454c)(function() {
        return (0, $3d5fcb60a9467a45$export$f65ca476c09acec0)();
    }));
}
/**
 * @ignore
 * DO NOT USE or export from the module, this is exposed as public to support backward compatibility of previous static utility methods only.
 * If you want to manager cookies either use the ICookieMgr available from the core instance via getCookieMgr() or create
 * your own instance of the CookieMgr and use that.
 * Using this directly for enabling / disabling cookie handling will not only affect your usage but EVERY user of cookies.
 * Example, if you are using a shared component that is also using Application Insights you will affect their cookie handling.
 * @param logger - The DiagnosticLogger to use for reporting errors.
 */ function $d751d7cd1b1c5598$var$_gblCookieMgr(config, logger) {
    // Stash the global instance against the BaseCookieMgr class
    var inst = $d751d7cd1b1c5598$export$2ae082191ac44e5a[$d751d7cd1b1c5598$var$strConfigCookieMgr] || $d751d7cd1b1c5598$var$_globalCookieConfig[$d751d7cd1b1c5598$var$strConfigCookieMgr];
    if (!inst) {
        // Note: not using the getSetValue() helper as that would require always creating a temporary cookieMgr
        // that ultimately is never used
        inst = $d751d7cd1b1c5598$export$2ae082191ac44e5a[$d751d7cd1b1c5598$var$strConfigCookieMgr] = $d751d7cd1b1c5598$export$2ae082191ac44e5a(config, logger);
        $d751d7cd1b1c5598$var$_globalCookieConfig[$d751d7cd1b1c5598$var$strConfigCookieMgr] = inst;
    }
    return inst;
}
function $d751d7cd1b1c5598$var$_isMgrEnabled(cookieMgr) {
    if (cookieMgr) return cookieMgr.isEnabled();
    return true;
}
function $d751d7cd1b1c5598$var$_isIgnoredCookie(cookieMgrCfg, name) {
    if (name && cookieMgrCfg && (0, $533f826bbc418791$export$43bee75e5e14138e)(cookieMgrCfg.ignoreCookies)) return (0, $a96d4958027d6f85$export$9f3b3ffa84393d30)(cookieMgrCfg.ignoreCookies, name) !== -1;
    return false;
}
function $d751d7cd1b1c5598$var$_isBlockedCookie(cookieMgrCfg, name) {
    if (name && cookieMgrCfg && (0, $533f826bbc418791$export$43bee75e5e14138e)(cookieMgrCfg.blockedCookies)) {
        if ((0, $a96d4958027d6f85$export$9f3b3ffa84393d30)(cookieMgrCfg.blockedCookies, name) !== -1) return true;
    }
    return $d751d7cd1b1c5598$var$_isIgnoredCookie(cookieMgrCfg, name);
}
function $d751d7cd1b1c5598$var$_isCfgEnabled(rootConfig, cookieMgrConfig) {
    var isCfgEnabled = cookieMgrConfig[0, $1ae5573ce493bccc$export$c9b1609f2b84393a /* @min:%2eenabled */ ];
    if ((0, $533f826bbc418791$export$bedb7023a7733221)(isCfgEnabled)) {
        // Set the enabled from the provided setting or the legacy root values
        var cookieEnabled = void 0;
        // This field is deprecated and dynamic updates will not be fully supported
        if (!(0, $533f826bbc418791$export$fce6876652108ab)(rootConfig[$d751d7cd1b1c5598$var$strIsCookieUseDisabled])) cookieEnabled = !rootConfig[$d751d7cd1b1c5598$var$strIsCookieUseDisabled];
        // If this value is defined it takes precedent over the above
        if (!(0, $533f826bbc418791$export$fce6876652108ab)(rootConfig[$d751d7cd1b1c5598$var$strDisableCookiesUsage])) cookieEnabled = !rootConfig[$d751d7cd1b1c5598$var$strDisableCookiesUsage];
        // Not setting the cookieMgrConfig.enabled as that will update (set) the global dynamic config
        // So future "updates" then may not be as expected
        isCfgEnabled = cookieEnabled;
    }
    return isCfgEnabled;
}
function $d751d7cd1b1c5598$export$76c0b273586c25c7(core, config) {
    var cookieMgr;
    if (core) // Always returns an instance
    cookieMgr = core.getCookieMgr();
    else if (config) {
        var cookieCfg = config.cookieCfg;
        if (cookieCfg && cookieCfg[$d751d7cd1b1c5598$var$strConfigCookieMgr]) cookieMgr = cookieCfg[$d751d7cd1b1c5598$var$strConfigCookieMgr];
        else cookieMgr = $d751d7cd1b1c5598$export$2ae082191ac44e5a(config);
    }
    if (!cookieMgr) // Get or initialize the default global (legacy) cookie manager if we couldn't find one
    cookieMgr = $d751d7cd1b1c5598$var$_gblCookieMgr(config, (core || {})[0, $1ae5573ce493bccc$export$e6a243fe757439f9 /* @min:%2elogger */ ]);
    return cookieMgr;
}
function $d751d7cd1b1c5598$export$2ae082191ac44e5a(rootConfig, logger) {
    var _a;
    var cookieMgrConfig;
    var _path;
    var _domain;
    var unloadHandler;
    // Explicitly checking against false, so that setting to undefined will === true
    var _enabled;
    var _getCookieFn;
    var _setCookieFn;
    var _delCookieFn;
    // Make sure the root config is dynamic as it may be the global config
    rootConfig = (0, $acb30f9e62dc5705$export$3a9e9180c14487fd)(rootConfig || $d751d7cd1b1c5598$var$_globalCookieConfig, null, logger).cfg;
    // Will get recalled if the referenced configuration is changed
    unloadHandler = (0, $acb30f9e62dc5705$export$454a433e4deb244f)(rootConfig, function(details) {
        // Make sure the root config has all of the the defaults to the root config to ensure they are dynamic
        details[0, $1ae5573ce493bccc$export$24caac6d68ff1537 /* @min:%2esetDf */ ](details.cfg, $d751d7cd1b1c5598$var$rootDefaultConfig);
        // Create and apply the defaults to the cookieCfg element
        cookieMgrConfig = details.ref(details.cfg, "cookieCfg"); // details.setDf(details.cfg.cookieCfg, defaultConfig);
        _path = cookieMgrConfig[0, $9fe4a5d5204a4cff$export$bdba10701e0ccff3 /* @min:%2epath */ ] || "/";
        _domain = cookieMgrConfig[0, $9fe4a5d5204a4cff$export$8f3e5386cefa231e /* @min:%2edomain */ ];
        // Explicitly checking against false, so that setting to undefined will === true
        _enabled = $d751d7cd1b1c5598$var$_isCfgEnabled(rootConfig, cookieMgrConfig) !== false;
        _getCookieFn = cookieMgrConfig.getCookie || $d751d7cd1b1c5598$var$_getCookieValue;
        _setCookieFn = cookieMgrConfig.setCookie || $d751d7cd1b1c5598$var$_setCookieValue;
        _delCookieFn = cookieMgrConfig.delCookie || $d751d7cd1b1c5598$var$_setCookieValue;
    }, logger);
    var cookieMgr = (_a = {
        isEnabled: function() {
            var enabled = $d751d7cd1b1c5598$var$_isCfgEnabled(rootConfig, cookieMgrConfig) !== false && _enabled && $d751d7cd1b1c5598$export$25d06da9c29ef62a(logger);
            // Using an indirect lookup for any global cookie manager to support tree shaking for SDK's
            // that don't use the "applicationinsights-core" version of the default cookie function
            var gblManager = $d751d7cd1b1c5598$var$_globalCookieConfig[$d751d7cd1b1c5598$var$strConfigCookieMgr];
            if (enabled && gblManager && cookieMgr !== gblManager) // Make sure the GlobalCookie Manager instance (if not this instance) is also enabled.
            // As the global (deprecated) functions may have been called (for backward compatibility)
            enabled = $d751d7cd1b1c5598$var$_isMgrEnabled(gblManager);
            return enabled;
        },
        setEnabled: function(value) {
            // Explicitly checking against false, so that setting to undefined will === true
            _enabled = value !== false;
            cookieMgrConfig[0, $1ae5573ce493bccc$export$c9b1609f2b84393a /* @min:%2eenabled */ ] = value;
        },
        set: function(name, value, maxAgeSec, domain, path) {
            var result = false;
            if ($d751d7cd1b1c5598$var$_isMgrEnabled(cookieMgr) && !$d751d7cd1b1c5598$var$_isBlockedCookie(cookieMgrConfig, name)) {
                var values = {};
                var theValue = (0, $f67365b40c49b6c1$export$ef0e11c5f5f351f7)(value || (0, $9fe4a5d5204a4cff$export$5e8607ab26634759));
                var idx = (0, $0194d45a55d79548$export$7c0888b0c4641088)(theValue, ";");
                if (idx !== -1) {
                    theValue = (0, $f67365b40c49b6c1$export$ef0e11c5f5f351f7)((0, $c3f3bf8012a4b2d4$export$a1120f14ec6f7ada)(value, idx));
                    values = $d751d7cd1b1c5598$var$_extractParts((0, $c3f3bf8012a4b2d4$export$9d1aa7361d7a6e87)(value, idx + 1));
                }
                // Only update domain if not already present (isUndefined) and the value is truthy (not null, undefined or empty string)
                (0, $0b747974b0bb3563$export$80746c6bc6142fc8)(values, (0, $9fe4a5d5204a4cff$export$8f3e5386cefa231e), domain || _domain, (0, $533f826bbc418791$export$8f9cae6546f97a9f), (0, $533f826bbc418791$export$fce6876652108ab));
                if (!(0, $533f826bbc418791$export$bedb7023a7733221)(maxAgeSec)) {
                    var _isIE = (0, $0c599844349363c4$export$7e7b1a9668aaed8)();
                    if ((0, $533f826bbc418791$export$fce6876652108ab)(values[$d751d7cd1b1c5598$var$strExpires])) {
                        var nowMs = (0, $628cad25a0769458$export$a56f095995763cca)();
                        // Only add expires if not already present
                        var expireMs = nowMs + maxAgeSec * 1000;
                        // Sanity check, if zero or -ve then ignore
                        if (expireMs > 0) {
                            var expiry = new Date();
                            expiry.setTime(expireMs);
                            (0, $0b747974b0bb3563$export$80746c6bc6142fc8)(values, $d751d7cd1b1c5598$var$strExpires, $d751d7cd1b1c5598$var$_formatDate(expiry, !_isIE ? $d751d7cd1b1c5598$var$strToUTCString : $d751d7cd1b1c5598$var$strToGMTString) || $d751d7cd1b1c5598$var$_formatDate(expiry, _isIE ? $d751d7cd1b1c5598$var$strToGMTString : $d751d7cd1b1c5598$var$strToUTCString) || (0, $9fe4a5d5204a4cff$export$5e8607ab26634759), (0, $533f826bbc418791$export$8f9cae6546f97a9f));
                        }
                    }
                    if (!_isIE) // Only replace if not already present
                    (0, $0b747974b0bb3563$export$80746c6bc6142fc8)(values, "max-age", (0, $9fe4a5d5204a4cff$export$5e8607ab26634759) + maxAgeSec, null, (0, $533f826bbc418791$export$fce6876652108ab));
                }
                var location_1 = (0, $0c599844349363c4$export$e7fd20fad3cf4b5f)();
                if (location_1 && location_1.protocol === "https:") {
                    (0, $0b747974b0bb3563$export$80746c6bc6142fc8)(values, "secure", null, null, (0, $533f826bbc418791$export$fce6876652108ab));
                    // Only set same site if not also secure
                    if ($d751d7cd1b1c5598$var$_allowUaSameSite === null) $d751d7cd1b1c5598$var$_allowUaSameSite = !$d751d7cd1b1c5598$export$e44499c7a8a6a268(((0, $3d5fcb60a9467a45$export$a56241c767c1d89f)() || {})[0, $1ae5573ce493bccc$export$2e850152cb3355e2 /* @min:%2euserAgent */ ]);
                    if ($d751d7cd1b1c5598$var$_allowUaSameSite) (0, $0b747974b0bb3563$export$80746c6bc6142fc8)(values, "SameSite", "None", null, (0, $533f826bbc418791$export$fce6876652108ab));
                }
                (0, $0b747974b0bb3563$export$80746c6bc6142fc8)(values, (0, $9fe4a5d5204a4cff$export$bdba10701e0ccff3), path || _path, null, (0, $533f826bbc418791$export$fce6876652108ab));
                //let setCookieFn = cookieMgrConfig.setCookie || _setCookieValue;
                _setCookieFn(name, $d751d7cd1b1c5598$var$_formatCookieValue(theValue, values));
                result = true;
            }
            return result;
        },
        get: function(name) {
            var value = (0, $9fe4a5d5204a4cff$export$5e8607ab26634759);
            if ($d751d7cd1b1c5598$var$_isMgrEnabled(cookieMgr) && !$d751d7cd1b1c5598$var$_isIgnoredCookie(cookieMgrConfig, name)) value = _getCookieFn(name);
            return value;
        },
        del: function(name, path) {
            var result = false;
            if ($d751d7cd1b1c5598$var$_isMgrEnabled(cookieMgr)) // Only remove the cookie if the manager and cookie support has not been disabled
            result = cookieMgr.purge(name, path);
            return result;
        },
        purge: function(name, path) {
            var _a;
            var result = false;
            if ($d751d7cd1b1c5598$export$25d06da9c29ef62a(logger)) {
                // Setting the expiration date in the past immediately removes the cookie
                var values = (_a = {}, _a[0, $9fe4a5d5204a4cff$export$bdba10701e0ccff3] = path ? path : "/", _a[$d751d7cd1b1c5598$var$strExpires] = "Thu, 01 Jan 1970 00:00:01 GMT", _a);
                if (!(0, $0c599844349363c4$export$7e7b1a9668aaed8)()) // Set max age to expire now
                values["max-age"] = "0";
                // let delCookie = cookieMgrConfig.delCookie || _setCookieValue;
                _delCookieFn(name, $d751d7cd1b1c5598$var$_formatCookieValue((0, $9fe4a5d5204a4cff$export$5e8607ab26634759), values));
                result = true;
            }
            return result;
        }
    }, _a[0, $1ae5573ce493bccc$export$7eb85b5cba77a43d /* @min:unload */ ] = function(isAsync) {
        unloadHandler && unloadHandler.rm();
        unloadHandler = null;
    }, _a);
    // Associated this cookie manager with the config
    cookieMgr[$d751d7cd1b1c5598$var$strConfigCookieMgr] = cookieMgr;
    return cookieMgr;
}
function $d751d7cd1b1c5598$export$25d06da9c29ef62a(logger) {
    if ($d751d7cd1b1c5598$var$_supportsCookies === null) {
        $d751d7cd1b1c5598$var$_supportsCookies = false;
        !$d751d7cd1b1c5598$var$_doc && $d751d7cd1b1c5598$var$_getDoc();
        try {
            var doc = $d751d7cd1b1c5598$var$_doc.v || {};
            $d751d7cd1b1c5598$var$_supportsCookies = doc[$d751d7cd1b1c5598$var$strCookie] !== undefined;
        } catch (e) {
            (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , 68 /* _eInternalMessageId.CannotAccessCookie */ , "Cannot access document.cookie - " + (0, $0b747974b0bb3563$export$39c4487b36c98fec)(e), {
                exception: (0, $386f00e3a193a7da$export$21fce7cbd4dc679f)(e)
            });
        }
    }
    return $d751d7cd1b1c5598$var$_supportsCookies;
}
function $d751d7cd1b1c5598$var$_extractParts(theValue) {
    var values = {};
    if (theValue && theValue[0, $1ae5573ce493bccc$export$6eae51590aaea43 /* @min:%2elength */ ]) {
        var parts = (0, $f67365b40c49b6c1$export$ef0e11c5f5f351f7)(theValue)[0, $1ae5573ce493bccc$export$b889f1d4cb07c706 /* @min:%2esplit */ ](";");
        (0, $f6bb085f8cf12216$export$e2e5bcdbdc49c586)(parts, function(thePart) {
            thePart = (0, $f67365b40c49b6c1$export$ef0e11c5f5f351f7)(thePart || (0, $9fe4a5d5204a4cff$export$5e8607ab26634759));
            if (thePart) {
                var idx = (0, $0194d45a55d79548$export$7c0888b0c4641088)(thePart, "=");
                if (idx === -1) values[thePart] = null;
                else values[(0, $f67365b40c49b6c1$export$ef0e11c5f5f351f7)((0, $c3f3bf8012a4b2d4$export$a1120f14ec6f7ada)(thePart, idx))] = (0, $f67365b40c49b6c1$export$ef0e11c5f5f351f7)((0, $c3f3bf8012a4b2d4$export$9d1aa7361d7a6e87)(thePart, idx + 1));
            }
        });
    }
    return values;
}
function $d751d7cd1b1c5598$var$_formatDate(theDate, func) {
    if ((0, $533f826bbc418791$export$f6e2535fb5126e54)(theDate[func])) return theDate[func]();
    return null;
}
function $d751d7cd1b1c5598$var$_formatCookieValue(value, values) {
    var cookieValue = value || (0, $9fe4a5d5204a4cff$export$5e8607ab26634759);
    (0, $45e528077703ac0c$export$aa0705d5774c95d1)(values, function(name, theValue) {
        cookieValue += "; " + name + (!(0, $533f826bbc418791$export$bedb7023a7733221)(theValue) ? "=" + theValue : (0, $9fe4a5d5204a4cff$export$5e8607ab26634759));
    });
    return cookieValue;
}
function $d751d7cd1b1c5598$var$_getCookieValue(name) {
    var cookieValue = (0, $9fe4a5d5204a4cff$export$5e8607ab26634759);
    !$d751d7cd1b1c5598$var$_doc && $d751d7cd1b1c5598$var$_getDoc();
    if ($d751d7cd1b1c5598$var$_doc.v) {
        var theCookie = $d751d7cd1b1c5598$var$_doc.v[$d751d7cd1b1c5598$var$strCookie] || (0, $9fe4a5d5204a4cff$export$5e8607ab26634759);
        if ($d751d7cd1b1c5598$var$_parsedCookieValue !== theCookie) {
            $d751d7cd1b1c5598$var$_cookieCache = $d751d7cd1b1c5598$var$_extractParts(theCookie);
            $d751d7cd1b1c5598$var$_parsedCookieValue = theCookie;
        }
        cookieValue = (0, $f67365b40c49b6c1$export$ef0e11c5f5f351f7)($d751d7cd1b1c5598$var$_cookieCache[name] || (0, $9fe4a5d5204a4cff$export$5e8607ab26634759));
    }
    return cookieValue;
}
function $d751d7cd1b1c5598$var$_setCookieValue(name, cookieValue) {
    !$d751d7cd1b1c5598$var$_doc && $d751d7cd1b1c5598$var$_getDoc();
    if ($d751d7cd1b1c5598$var$_doc.v) $d751d7cd1b1c5598$var$_doc.v[$d751d7cd1b1c5598$var$strCookie] = name + "=" + cookieValue;
}
function $d751d7cd1b1c5598$export$e44499c7a8a6a268(userAgent) {
    if (!(0, $533f826bbc418791$export$844ec244b1367d54)(userAgent)) return false;
    // Cover all iOS based browsers here. This includes:
    // - Safari on iOS 12 for iPhone, iPod Touch, iPad
    // - WkWebview on iOS 12 for iPhone, iPod Touch, iPad
    // - Chrome on iOS 12 for iPhone, iPod Touch, iPad
    // All of which are broken by SameSite=None, because they use the iOS networking stack
    if ((0, $0b747974b0bb3563$export$3185d777c612e61f)(userAgent, "CPU iPhone OS 12") || (0, $0b747974b0bb3563$export$3185d777c612e61f)(userAgent, "iPad; CPU OS 12")) return true;
    // Cover Mac OS X based browsers that use the Mac OS networking stack. This includes:
    // - Safari on Mac OS X
    // This does not include:
    // - Internal browser on Mac OS X
    // - Chrome on Mac OS X
    // - Chromium on Mac OS X
    // Because they do not use the Mac OS networking stack.
    if ((0, $0b747974b0bb3563$export$3185d777c612e61f)(userAgent, "Macintosh; Intel Mac OS X 10_14") && (0, $0b747974b0bb3563$export$3185d777c612e61f)(userAgent, "Version/") && (0, $0b747974b0bb3563$export$3185d777c612e61f)(userAgent, "Safari")) return true;
    // Cover Mac OS X internal browsers that use the Mac OS networking stack. This includes:
    // - Internal browser on Mac OS X
    // This does not include:
    // - Safari on Mac OS X
    // - Chrome on Mac OS X
    // - Chromium on Mac OS X
    // Because they do not use the Mac OS networking stack.
    if ((0, $0b747974b0bb3563$export$3185d777c612e61f)(userAgent, "Macintosh; Intel Mac OS X 10_14") && (0, $2b52e71bd2d7d7f0$export$5222b9460f3ddbec)(userAgent, "AppleWebKit/605.1.15 (KHTML, like Gecko)")) return true;
    // Cover Chrome 50-69, because some versions are broken by SameSite=None, and none in this range require it.
    // Note: this covers some pre-Chromium Edge versions, but pre-Chromim Edge does not require SameSite=None, so this is fine.
    // Note: this regex applies to Windows, Mac OS X, and Linux, deliberately.
    if ((0, $0b747974b0bb3563$export$3185d777c612e61f)(userAgent, "Chrome/5") || (0, $0b747974b0bb3563$export$3185d777c612e61f)(userAgent, "Chrome/6")) return true;
    // Unreal Engine runs Chromium 59, but does not advertise as Chrome until 4.23. Treat versions of Unreal
    // that don't specify their Chrome version as lacking support for SameSite=None.
    if ((0, $0b747974b0bb3563$export$3185d777c612e61f)(userAgent, "UnrealEngine") && !(0, $0b747974b0bb3563$export$3185d777c612e61f)(userAgent, "Chrome")) return true;
    // UCBrowser < 12.13.2 ignores Set-Cookie headers with SameSite=None
    // NB: this rule isn't complete - you need regex to make a complete rule.
    // See: https://www.chromium.org/updates/same-site/incompatible-clients
    if ((0, $0b747974b0bb3563$export$3185d777c612e61f)(userAgent, "UCBrowser/12") || (0, $0b747974b0bb3563$export$3185d777c612e61f)(userAgent, "UCBrowser/11")) return true;
    return false;
}



/*
 * Application Insights JavaScript SDK - Web Analytics, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var $9acc3b97657eaaf0$export$e2818d11505fa034 = "toString"; // Count: 4
var $9acc3b97657eaaf0$export$f357d96937d91514 = "isStorageUseDisabled"; // Count: 3
var $9acc3b97657eaaf0$export$3b3afe26ca0e015c = "_addHook"; // Count: 6
var $9acc3b97657eaaf0$export$f9ae8d0acf86503e = "core"; // Count: 7
var $9acc3b97657eaaf0$export$9e16762ab4f2648 = "dataType"; // Count: 8
var $9acc3b97657eaaf0$export$2672d4f7ccc80348 = "envelopeType"; // Count: 7
var $9acc3b97657eaaf0$export$c7ff2c36e5c78421 = "diagLog"; // Count: 13
var $9acc3b97657eaaf0$export$548634e98b3af9c4 = "track"; // Count: 7
var $9acc3b97657eaaf0$export$ab1a8669316b7a02 = "trackPageView"; // Count: 4
var $9acc3b97657eaaf0$export$5b63a890d51a5194 = "trackPreviousPageVisit"; // Count: 3
var $9acc3b97657eaaf0$export$e4d43b697816aae1 = "sendPageViewInternal"; // Count: 7
var $9acc3b97657eaaf0$export$fe3039bd0e70dd3f = "sendPageViewPerformanceInternal"; // Count: 3
var $9acc3b97657eaaf0$export$20270e2265c2a185 = "populatePageViewPerformanceEvent"; // Count: 3
var $9acc3b97657eaaf0$export$8d0bd9d006f3ecea = "href"; // Count: 6
var $9acc3b97657eaaf0$export$5414b86ab837cb07 = "sendExceptionInternal"; // Count: 2
var $9acc3b97657eaaf0$export$4852fd87b68a6e1f = "exception"; // Count: 3
var $9acc3b97657eaaf0$export$ff0a0f80c43edd37 = "error"; // Count: 5
var $9acc3b97657eaaf0$export$31fe7bcf0f7c83e8 = "_onerror"; // Count: 3
var $9acc3b97657eaaf0$export$d190ee0b6bfe36d8 = "errorSrc"; // Count: 3
var $9acc3b97657eaaf0$export$4d19a8ea486d5967 = "lineNumber"; // Count: 5
var $9acc3b97657eaaf0$export$91a182df12726bcd = "columnNumber"; // Count: 5
var $9acc3b97657eaaf0$export$923606b70907833e = "message"; // Count: 4
var $9acc3b97657eaaf0$export$3dedbd38aa3b0c11 = "CreateAutoException"; // Count: 3
var $9acc3b97657eaaf0$export$935b759388157821 = "addTelemetryInitializer"; // Count: 4
var $9acc3b97657eaaf0$export$c653a2fea2d8252a = "overridePageViewDuration"; // Count: 2
var $9acc3b97657eaaf0$export$aa395e58f404db90 = "duration"; // Count: 10
var $9acc3b97657eaaf0$export$e4892641d6ea1b45 = "autoTrackPageVisitTime"; // Count: 2
var $9acc3b97657eaaf0$export$204917ab19f7a461 = "isBrowserLinkTrackingEnabled"; // Count: 2
var $9acc3b97657eaaf0$export$6eae51590aaea43 = "length"; // Count: 5
var $9acc3b97657eaaf0$export$6390687f17a52950 = "enableAutoRouteTracking"; // Count: 2
var $9acc3b97657eaaf0$export$72fe3f7aecc0d015 = "enableUnhandledPromiseRejectionTracking"; // Count: 2
var $9acc3b97657eaaf0$export$527cc291f0159d2a = "autoUnhandledPromiseInstrumented"; // Count: 3
var $9acc3b97657eaaf0$export$379c72358869fe15 = "isPerformanceTimingSupported"; // Count: 2
var $9acc3b97657eaaf0$export$f80d3e3d3d24d8e2 = "getPerformanceTiming"; // Count: 2
var $9acc3b97657eaaf0$export$f8670e269dbf7411 = "navigationStart"; // Count: 4
var $9acc3b97657eaaf0$export$7d974758a7a955a6 = "shouldCollectDuration"; // Count: 3
var $9acc3b97657eaaf0$export$2e020f7b1a6ecc9d = "isPerformanceTimingDataReady"; // Count: 2
var $9acc3b97657eaaf0$export$96ba0dffa6c93bb1 = "getEntriesByType"; // Count: 3
var $9acc3b97657eaaf0$export$efd7bea2390142dc = "responseStart"; // Count: 5
var $9acc3b97657eaaf0$export$2a979904ebe4c805 = "requestStart"; // Count: 3
var $9acc3b97657eaaf0$export$3e2743adb5050880 = "loadEventEnd"; // Count: 4
var $9acc3b97657eaaf0$export$cb472b94f03785cf = "responseEnd"; // Count: 5
var $9acc3b97657eaaf0$export$ade5c25ec120f74e = "connectEnd"; // Count: 4
var $9acc3b97657eaaf0$export$204c1f54732d882 = "pageVisitStartTime"; // Count: 2


/*
 * Application Insights JavaScript SDK - Web Analytics, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 




/**
 * Class encapsulates sending page views and page view performance telemetry.
 */ var $6e4263cfc9177d6e$export$5bb8d6768724bf86 = /** @class */ function() {
    function PageViewManager(appInsights, overridePageViewDuration, core, pageViewPerformanceManager) {
        (0, $c9b63384299a3252$export$2e2bcd8739ae039)(PageViewManager, this, function(_self) {
            var queueTimer = null;
            var itemQueue = [];
            var pageViewPerformanceSent = false;
            var _logger;
            if (core) _logger = core.logger;
            function _flushChannels(isAsync) {
                if (core) core.flush(isAsync, function() {
                // Event flushed, callback added to prevent promise creation
                });
            }
            function _startTimer() {
                if (!queueTimer) queueTimer = (0, $d03b12effd00bf96$export$5f4d6617421d489b)(function() {
                    queueTimer = null;
                    var allItems = itemQueue.slice(0);
                    var doFlush = false;
                    itemQueue = [];
                    (0, $f6bb085f8cf12216$export$e2e5bcdbdc49c586)(allItems, function(item) {
                        if (!item()) // Not processed so rescheduled
                        itemQueue.push(item);
                        else doFlush = true;
                    });
                    if (itemQueue[0, $9acc3b97657eaaf0$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) _startTimer();
                    if (doFlush) // We process at least one item so flush the queue
                    _flushChannels(true);
                }, 100);
            }
            function _addQueue(cb) {
                itemQueue.push(cb);
                _startTimer();
            }
            _self[0, $9acc3b97657eaaf0$export$ab1a8669316b7a02 /* @min:%2etrackPageView */ ] = function(pageView, customProperties) {
                var name = pageView.name;
                if ((0, $533f826bbc418791$export$bedb7023a7733221)(name) || typeof name !== "string") {
                    var doc = (0, $3d5fcb60a9467a45$export$f65ca476c09acec0)();
                    name = pageView.name = doc && doc.title || "";
                }
                var uri = pageView.uri;
                if ((0, $533f826bbc418791$export$bedb7023a7733221)(uri) || typeof uri !== "string") {
                    var location_1 = (0, $0c599844349363c4$export$e7fd20fad3cf4b5f)();
                    uri = pageView.uri = location_1 && location_1[0, $9acc3b97657eaaf0$export$8d0bd9d006f3ecea /* @min:%2ehref */ ] || "";
                }
                // case 1a. if performance timing is not supported by the browser, send the page view telemetry with the duration provided by the user. If the user
                // do not provide the duration, set duration to undefined
                // Also this is case 4
                if (!pageViewPerformanceManager[0, $9acc3b97657eaaf0$export$379c72358869fe15 /* @min:%2eisPerformanceTimingSupported */ ]()) {
                    appInsights[0, $9acc3b97657eaaf0$export$e4d43b697816aae1 /* @min:%2esendPageViewInternal */ ](pageView, customProperties);
                    _flushChannels(true);
                    if (!(0, $3d5fcb60a9467a45$export$97b87b8868ff7a3c)()) // no navigation timing (IE 8, iOS Safari 8.4, Opera Mini 8 - see http://caniuse.com/#feat=nav-timing)
                    (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(_logger, 2 /* eLoggingSeverity.WARNING */ , 25 /* _eInternalMessageId.NavigationTimingNotSupported */ , "trackPageView: navigation timing API used for calculation of page duration is not supported in this browser. This page view will be collected without duration and timing info.");
                    return;
                }
                var pageViewSent = false;
                var customDuration;
                // if the performance timing is supported by the browser, calculate the custom duration
                var start = pageViewPerformanceManager[0, $9acc3b97657eaaf0$export$f80d3e3d3d24d8e2 /* @min:%2egetPerformanceTiming */ ]()[0, $9acc3b97657eaaf0$export$f8670e269dbf7411 /* @min:%2enavigationStart */ ];
                if (start > 0) {
                    customDuration = (0, $d98b699aeccdabc6$export$bfc7deb7f4f00987)(start, +new Date);
                    if (!pageViewPerformanceManager[0, $9acc3b97657eaaf0$export$7d974758a7a955a6 /* @min:%2eshouldCollectDuration */ ](customDuration)) customDuration = undefined;
                }
                // if the user has provided duration, send a page view telemetry with the provided duration. Otherwise, if
                // overridePageViewDuration is set to true, send a page view telemetry with the custom duration calculated earlier
                var duration;
                if (!(0, $533f826bbc418791$export$bedb7023a7733221)(customProperties) && !(0, $533f826bbc418791$export$bedb7023a7733221)(customProperties[0, $9acc3b97657eaaf0$export$aa395e58f404db90 /* @min:%2eduration */ ])) duration = customProperties[0, $9acc3b97657eaaf0$export$aa395e58f404db90 /* @min:%2eduration */ ];
                if (overridePageViewDuration || !isNaN(duration)) {
                    if (isNaN(duration)) {
                        // case 3
                        if (!customProperties) customProperties = {};
                        customProperties[0, $9acc3b97657eaaf0$export$aa395e58f404db90 /* @min:%2eduration */ ] = customDuration;
                    }
                    // case 2
                    appInsights[0, $9acc3b97657eaaf0$export$e4d43b697816aae1 /* @min:%2esendPageViewInternal */ ](pageView, customProperties);
                    _flushChannels(true);
                    pageViewSent = true;
                }
                // now try to send the page view performance telemetry
                var maxDurationLimit = 60000;
                if (!customProperties) customProperties = {};
                // Queue the event for processing
                _addQueue(function() {
                    var processed = false;
                    try {
                        if (pageViewPerformanceManager[0, $9acc3b97657eaaf0$export$2e020f7b1a6ecc9d /* @min:%2eisPerformanceTimingDataReady */ ]()) {
                            processed = true;
                            var pageViewPerformance = {
                                name: name,
                                uri: uri
                            };
                            pageViewPerformanceManager[0, $9acc3b97657eaaf0$export$20270e2265c2a185 /* @min:%2epopulatePageViewPerformanceEvent */ ](pageViewPerformance);
                            if (!pageViewPerformance.isValid && !pageViewSent) {
                                // If navigation timing gives invalid numbers, then go back to "override page view duration" mode.
                                // That's the best value we can get that makes sense.
                                customProperties[0, $9acc3b97657eaaf0$export$aa395e58f404db90 /* @min:%2eduration */ ] = customDuration;
                                appInsights[0, $9acc3b97657eaaf0$export$e4d43b697816aae1 /* @min:%2esendPageViewInternal */ ](pageView, customProperties);
                            } else {
                                if (!pageViewSent) {
                                    customProperties[0, $9acc3b97657eaaf0$export$aa395e58f404db90 /* @min:%2eduration */ ] = pageViewPerformance.durationMs;
                                    appInsights[0, $9acc3b97657eaaf0$export$e4d43b697816aae1 /* @min:%2esendPageViewInternal */ ](pageView, customProperties);
                                }
                                if (!pageViewPerformanceSent) {
                                    appInsights[0, $9acc3b97657eaaf0$export$fe3039bd0e70dd3f /* @min:%2esendPageViewPerformanceInternal */ ](pageViewPerformance, customProperties);
                                    pageViewPerformanceSent = true;
                                }
                            }
                        } else if (start > 0 && (0, $d98b699aeccdabc6$export$bfc7deb7f4f00987)(start, +new Date) > maxDurationLimit) {
                            // if performance timings are not ready but we exceeded the maximum duration limit, just log a page view telemetry
                            // with the maximum duration limit. Otherwise, keep waiting until performance timings are ready
                            processed = true;
                            if (!pageViewSent) {
                                customProperties[0, $9acc3b97657eaaf0$export$aa395e58f404db90 /* @min:%2eduration */ ] = maxDurationLimit;
                                appInsights[0, $9acc3b97657eaaf0$export$e4d43b697816aae1 /* @min:%2esendPageViewInternal */ ](pageView, customProperties);
                            }
                        }
                    } catch (e) {
                        (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(_logger, 1 /* eLoggingSeverity.CRITICAL */ , 38 /* _eInternalMessageId.TrackPVFailedCalc */ , "trackPageView failed on page load calculation: " + (0, $0b747974b0bb3563$export$39c4487b36c98fec)(e), {
                            exception: (0, $386f00e3a193a7da$export$21fce7cbd4dc679f)(e)
                        });
                    }
                    return processed;
                });
            };
            _self.teardown = function(unloadCtx, unloadState) {
                if (queueTimer) {
                    clearInterval(queueTimer);
                    queueTimer = null;
                    var allItems = itemQueue.slice(0);
                    var doFlush_1 = false;
                    itemQueue = [];
                    (0, $f6bb085f8cf12216$export$e2e5bcdbdc49c586)(allItems, function(item) {
                        if (item()) doFlush_1 = true;
                    });
                }
            };
        });
    }
    // Removed Stub for PageViewManager.prototype.trackPageView.
    // Removed Stub for PageViewManager.prototype.teardown.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    PageViewManager.__ieDyn = 1;
    return PageViewManager;
}();


/*
 * Application Insights JavaScript SDK - Web Analytics, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 




var $14a28652d5a6e87a$var$MAX_DURATION_ALLOWED = 3600000; // 1h
var $14a28652d5a6e87a$var$botAgentNames = [
    "googlebot",
    "adsbot-google",
    "apis-google",
    "mediapartners-google"
];
function $14a28652d5a6e87a$var$_isPerformanceTimingSupported() {
    var perf = (0, $824d7bc9d9e48f68$export$28a0276e10aa78d7)();
    return perf && !!perf.timing;
}
function $14a28652d5a6e87a$var$_isPerformanceNavigationTimingSupported() {
    var perf = (0, $824d7bc9d9e48f68$export$28a0276e10aa78d7)();
    return perf && perf.getEntriesByType && perf.getEntriesByType("navigation")[0, $9acc3b97657eaaf0$export$6eae51590aaea43 /* @min:%2elength */ ] > 0;
}
function $14a28652d5a6e87a$var$_isPerformanceTimingDataReady() {
    var perf = (0, $824d7bc9d9e48f68$export$28a0276e10aa78d7)();
    var timing = perf ? perf.timing : 0;
    return timing && timing.domainLookupStart > 0 && timing[0, $9acc3b97657eaaf0$export$f8670e269dbf7411 /* @min:%2enavigationStart */ ] > 0 && timing[0, $9acc3b97657eaaf0$export$efd7bea2390142dc /* @min:%2eresponseStart */ ] > 0 && timing[0, $9acc3b97657eaaf0$export$2a979904ebe4c805 /* @min:%2erequestStart */ ] > 0 && timing[0, $9acc3b97657eaaf0$export$3e2743adb5050880 /* @min:%2eloadEventEnd */ ] > 0 && timing[0, $9acc3b97657eaaf0$export$cb472b94f03785cf /* @min:%2eresponseEnd */ ] > 0 && timing[0, $9acc3b97657eaaf0$export$ade5c25ec120f74e /* @min:%2econnectEnd */ ] > 0 && timing.domLoading > 0;
}
function $14a28652d5a6e87a$var$_getPerformanceTiming() {
    if ($14a28652d5a6e87a$var$_isPerformanceTimingSupported()) return (0, $824d7bc9d9e48f68$export$28a0276e10aa78d7)().timing;
    return null;
}
function $14a28652d5a6e87a$var$_getPerformanceNavigationTiming() {
    if ($14a28652d5a6e87a$var$_isPerformanceNavigationTimingSupported()) return (0, $824d7bc9d9e48f68$export$28a0276e10aa78d7)()[0, $9acc3b97657eaaf0$export$96ba0dffa6c93bb1 /* @min:%2egetEntriesByType */ ]("navigation")[0];
    return null;
}
/**
* This method tells if given durations should be excluded from collection.
*/ function $14a28652d5a6e87a$var$_shouldCollectDuration() {
    var durations = [];
    for(var _i = 0; _i < arguments.length; _i++)durations[_i] = arguments[_i];
    var _navigator = (0, $3d5fcb60a9467a45$export$a56241c767c1d89f)() || {};
    // a full list of Google crawlers user agent strings - https://support.google.com/webmasters/answer/1061943?hl=en
    var userAgent = _navigator.userAgent;
    var isGoogleBot = false;
    if (userAgent) for(var i = 0; i < $14a28652d5a6e87a$var$botAgentNames[0, $9acc3b97657eaaf0$export$6eae51590aaea43 /* @min:%2elength */ ]; i++)isGoogleBot = isGoogleBot || (0, $0194d45a55d79548$export$7c0888b0c4641088)(userAgent.toLowerCase(), $14a28652d5a6e87a$var$botAgentNames[i]) !== -1;
    if (isGoogleBot) // Don't report durations for GoogleBot, it is returning invalid values in performance.timing API.
    return false;
    else // for other page views, don't report if it's outside of a reasonable range
    for(var i = 0; i < durations[0, $9acc3b97657eaaf0$export$6eae51590aaea43 /* @min:%2elength */ ]; i++){
        if (durations[i] < 0 || durations[i] >= $14a28652d5a6e87a$var$MAX_DURATION_ALLOWED) return false;
    }
    return true;
}
/**
 * Class encapsulates sending page view performance telemetry.
 */ var $14a28652d5a6e87a$export$da80ef98bc1bafa6 = /** @class */ function() {
    function PageViewPerformanceManager(core) {
        var _logger = (0, $cc2aaaebf96ac6a7$export$5102d32ea1d740a)(core);
        (0, $c9b63384299a3252$export$2e2bcd8739ae039)(PageViewPerformanceManager, this, function(_self) {
            _self[0, $9acc3b97657eaaf0$export$20270e2265c2a185 /* @min:%2epopulatePageViewPerformanceEvent */ ] = function(pageViewPerformance) {
                pageViewPerformance.isValid = false;
                /*
                 * http://www.w3.org/TR/navigation-timing/#processing-model
                 *  |-navigationStart
                 *  |             |-connectEnd
                 *  |             ||-requestStart
                 *  |             ||             |-responseStart
                 *  |             ||             |              |-responseEnd
                 *  |             ||             |              |
                 *  |             ||             |              |         |-loadEventEnd
                 *  |---network---||---request---|---response---|---dom---|
                 *  |--------------------------total----------------------|
                 *
                 *  total = The difference between the load event of the current document is completed and the first recorded timestamp of the performance entry : https://developer.mozilla.org/en-US/docs/Web/Performance/Navigation_and_resource_timings#duration
                 *  network = Redirect time + App Cache + DNS lookup time + TCP connection time
                 *  request = Request time : https://developer.mozilla.org/en-US/docs/Web/Performance/Navigation_and_resource_timings#request_time
                 *  response = Response time
                 *  dom = Document load time : https://html.spec.whatwg.org/multipage/dom.html#document-load-timing-info
                 *      = Document processing time : https://developers.google.com/web/fundamentals/performance/navigation-and-resource-timing/#document_processing
                 *      + Loading time : https://developers.google.com/web/fundamentals/performance/navigation-and-resource-timing/#loading
                 */ var navigationTiming = $14a28652d5a6e87a$var$_getPerformanceNavigationTiming();
                var timing = $14a28652d5a6e87a$var$_getPerformanceTiming();
                var total = 0;
                var network = 0;
                var request = 0;
                var response = 0;
                var dom = 0;
                if (navigationTiming || timing) {
                    if (navigationTiming) {
                        total = navigationTiming[0, $9acc3b97657eaaf0$export$aa395e58f404db90 /* @min:%2eduration */ ];
                        /**
                         * support both cases:
                         * - startTime is always zero: https://developer.mozilla.org/en-US/docs/Web/API/PerformanceNavigationTiming
                         * - for older browsers where the startTime is not zero
                         */ network = navigationTiming.startTime === 0 ? navigationTiming[0, $9acc3b97657eaaf0$export$ade5c25ec120f74e /* @min:%2econnectEnd */ ] : (0, $d98b699aeccdabc6$export$bfc7deb7f4f00987)(navigationTiming.startTime, navigationTiming[0, $9acc3b97657eaaf0$export$ade5c25ec120f74e /* @min:%2econnectEnd */ ]);
                        request = (0, $d98b699aeccdabc6$export$bfc7deb7f4f00987)(navigationTiming.requestStart, navigationTiming[0, $9acc3b97657eaaf0$export$efd7bea2390142dc /* @min:%2eresponseStart */ ]);
                        response = (0, $d98b699aeccdabc6$export$bfc7deb7f4f00987)(navigationTiming[0, $9acc3b97657eaaf0$export$efd7bea2390142dc /* @min:%2eresponseStart */ ], navigationTiming[0, $9acc3b97657eaaf0$export$cb472b94f03785cf /* @min:%2eresponseEnd */ ]);
                        dom = (0, $d98b699aeccdabc6$export$bfc7deb7f4f00987)(navigationTiming.responseEnd, navigationTiming[0, $9acc3b97657eaaf0$export$3e2743adb5050880 /* @min:%2eloadEventEnd */ ]);
                    } else {
                        total = (0, $d98b699aeccdabc6$export$bfc7deb7f4f00987)(timing[0, $9acc3b97657eaaf0$export$f8670e269dbf7411 /* @min:%2enavigationStart */ ], timing[0, $9acc3b97657eaaf0$export$3e2743adb5050880 /* @min:%2eloadEventEnd */ ]);
                        network = (0, $d98b699aeccdabc6$export$bfc7deb7f4f00987)(timing[0, $9acc3b97657eaaf0$export$f8670e269dbf7411 /* @min:%2enavigationStart */ ], timing[0, $9acc3b97657eaaf0$export$ade5c25ec120f74e /* @min:%2econnectEnd */ ]);
                        request = (0, $d98b699aeccdabc6$export$bfc7deb7f4f00987)(timing.requestStart, timing[0, $9acc3b97657eaaf0$export$efd7bea2390142dc /* @min:%2eresponseStart */ ]);
                        response = (0, $d98b699aeccdabc6$export$bfc7deb7f4f00987)(timing[0, $9acc3b97657eaaf0$export$efd7bea2390142dc /* @min:%2eresponseStart */ ], timing[0, $9acc3b97657eaaf0$export$cb472b94f03785cf /* @min:%2eresponseEnd */ ]);
                        dom = (0, $d98b699aeccdabc6$export$bfc7deb7f4f00987)(timing.responseEnd, timing[0, $9acc3b97657eaaf0$export$3e2743adb5050880 /* @min:%2eloadEventEnd */ ]);
                    }
                    if (total === 0) (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(_logger, 2 /* eLoggingSeverity.WARNING */ , 10 /* _eInternalMessageId.ErrorPVCalc */ , "error calculating page view performance.", {
                        total: total,
                        network: network,
                        request: request,
                        response: response,
                        dom: dom
                    });
                    else if (!_self[0, $9acc3b97657eaaf0$export$7d974758a7a955a6 /* @min:%2eshouldCollectDuration */ ](total, network, request, response, dom)) (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(_logger, 2 /* eLoggingSeverity.WARNING */ , 45 /* _eInternalMessageId.InvalidDurationValue */ , "Invalid page load duration value. Browser perf data won't be sent.", {
                        total: total,
                        network: network,
                        request: request,
                        response: response,
                        dom: dom
                    });
                    else if (total < Math.floor(network) + Math.floor(request) + Math.floor(response) + Math.floor(dom)) // some browsers may report individual components incorrectly so that the sum of the parts will be bigger than total PLT
                    // in this case, don't report client performance from this page
                    (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(_logger, 2 /* eLoggingSeverity.WARNING */ , 8 /* _eInternalMessageId.ClientPerformanceMathError */ , "client performance math error.", {
                        total: total,
                        network: network,
                        request: request,
                        response: response,
                        dom: dom
                    });
                    else {
                        pageViewPerformance.durationMs = total;
                        // // convert to timespans
                        pageViewPerformance.perfTotal = pageViewPerformance[0, $9acc3b97657eaaf0$export$aa395e58f404db90 /* @min:%2eduration */ ] = (0, $8ce53fcb9c1dc1db$export$4460ed97e7c4a927)(total);
                        pageViewPerformance.networkConnect = (0, $8ce53fcb9c1dc1db$export$4460ed97e7c4a927)(network);
                        pageViewPerformance.sentRequest = (0, $8ce53fcb9c1dc1db$export$4460ed97e7c4a927)(request);
                        pageViewPerformance.receivedResponse = (0, $8ce53fcb9c1dc1db$export$4460ed97e7c4a927)(response);
                        pageViewPerformance.domProcessing = (0, $8ce53fcb9c1dc1db$export$4460ed97e7c4a927)(dom);
                        pageViewPerformance.isValid = true;
                    }
                }
            };
            _self[0, $9acc3b97657eaaf0$export$f80d3e3d3d24d8e2 /* @min:%2egetPerformanceTiming */ ] = $14a28652d5a6e87a$var$_getPerformanceTiming;
            _self[0, $9acc3b97657eaaf0$export$379c72358869fe15 /* @min:%2eisPerformanceTimingSupported */ ] = $14a28652d5a6e87a$var$_isPerformanceTimingSupported;
            _self[0, $9acc3b97657eaaf0$export$2e020f7b1a6ecc9d /* @min:%2eisPerformanceTimingDataReady */ ] = $14a28652d5a6e87a$var$_isPerformanceTimingDataReady;
            _self[0, $9acc3b97657eaaf0$export$7d974758a7a955a6 /* @min:%2eshouldCollectDuration */ ] = $14a28652d5a6e87a$var$_shouldCollectDuration;
        });
    }
    // Removed Stub for PageViewPerformanceManager.prototype.populatePageViewPerformanceEvent.
    // Removed Stub for PageViewPerformanceManager.prototype.getPerformanceTiming.
    // Removed Stub for PageViewPerformanceManager.prototype.isPerformanceTimingSupported.
    // Removed Stub for PageViewPerformanceManager.prototype.isPerformanceTimingDataReady.
    // Removed Stub for PageViewPerformanceManager.prototype.shouldCollectDuration.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    PageViewPerformanceManager.__ieDyn = 1;
    return PageViewPerformanceManager;
}();


/*
 * Application Insights JavaScript SDK - Web Analytics, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 




/**
 * Used to track page visit durations
 */ var $55f799186175501d$export$f6fdd81afb2fe76 = /** @class */ function() {
    /**
     * Creates a new instance of PageVisitTimeManager
     * @param pageVisitTimeTrackingHandler - Delegate that will be called to send telemetry data to AI (when trackPreviousPageVisit is called)
     * @returns {}
     */ function PageVisitTimeManager(logger, pageVisitTimeTrackingHandler) {
        var prevPageVisitDataKeyName = "prevPageVisitData";
        (0, $c9b63384299a3252$export$2e2bcd8739ae039)(PageVisitTimeManager, this, function(_self) {
            _self[0, $9acc3b97657eaaf0$export$5b63a890d51a5194 /* @min:%2etrackPreviousPageVisit */ ] = function(currentPageName, currentPageUrl) {
                try {
                    // Restart timer for new page view
                    var prevPageVisitTimeData = restartPageVisitTimer(currentPageName, currentPageUrl);
                    // If there was a page already being timed, track the visit time for it now.
                    if (prevPageVisitTimeData) pageVisitTimeTrackingHandler(prevPageVisitTimeData.pageName, prevPageVisitTimeData.pageUrl, prevPageVisitTimeData.pageVisitTime);
                } catch (e) {
                    (0, $cc2aaaebf96ac6a7$export$25fb4cb97863f0a8)(logger, "Auto track page visit time failed, metric will not be collected: " + (0, $386f00e3a193a7da$export$21fce7cbd4dc679f)(e));
                }
            };
            /**
             * Stops timing of current page (if exists) and starts timing for duration of visit to pageName
             * @param pageName - Name of page to begin timing visit duration
             * @returns {PageVisitData} Page visit data (including duration) of pageName from last call to start or restart, if exists. Null if not.
             */ function restartPageVisitTimer(pageName, pageUrl) {
                var prevPageVisitData = null;
                try {
                    prevPageVisitData = stopPageVisitTimer();
                    if ((0, $8e03bdff803b84be$export$c81985c4209bac26)()) {
                        if ((0, $8e03bdff803b84be$export$a398bd2f40e2eb6e)(logger, prevPageVisitDataKeyName) != null) (0, $44a1c24c0e411039$export$8bf7aba4a9e09055)("Cannot call startPageVisit consecutively without first calling stopPageVisit");
                        var currPageVisitDataStr = (0, $0c599844349363c4$export$d047a7c56db64af4)().stringify(new $55f799186175501d$export$513202441432a369(pageName, pageUrl));
                        (0, $8e03bdff803b84be$export$21abea3a85fee3f5)(logger, prevPageVisitDataKeyName, currPageVisitDataStr);
                    }
                } catch (e) {
                    (0, $cc2aaaebf96ac6a7$export$25fb4cb97863f0a8)(logger, "Call to restart failed: " + (0, $386f00e3a193a7da$export$21fce7cbd4dc679f)(e));
                    prevPageVisitData = null;
                }
                return prevPageVisitData;
            }
            /**
             * Stops timing of current page, if exists.
             * @returns {PageVisitData} Page visit data (including duration) of pageName from call to start, if exists. Null if not.
             */ function stopPageVisitTimer() {
                var prevPageVisitData = null;
                try {
                    if ((0, $8e03bdff803b84be$export$c81985c4209bac26)()) {
                        // Define end time of page's visit
                        var pageVisitEndTime = (0, $628cad25a0769458$export$a56f095995763cca)();
                        // Try to retrieve  page name and start time from session storage
                        var pageVisitDataJsonStr = (0, $8e03bdff803b84be$export$a398bd2f40e2eb6e)(logger, prevPageVisitDataKeyName);
                        if (pageVisitDataJsonStr && (0, $0c599844349363c4$export$a2856ab6913b9fff)()) {
                            // if previous page data exists, set end time of visit
                            prevPageVisitData = (0, $0c599844349363c4$export$d047a7c56db64af4)().parse(pageVisitDataJsonStr);
                            prevPageVisitData.pageVisitTime = pageVisitEndTime - prevPageVisitData[0, $9acc3b97657eaaf0$export$204c1f54732d882 /* @min:%2epageVisitStartTime */ ];
                            // Remove data from storage since we already used it
                            (0, $8e03bdff803b84be$export$9f411b4ea05fb92a)(logger, prevPageVisitDataKeyName);
                        }
                    }
                } catch (e) {
                    (0, $cc2aaaebf96ac6a7$export$25fb4cb97863f0a8)(logger, "Stop page visit timer failed: " + (0, $386f00e3a193a7da$export$21fce7cbd4dc679f)(e));
                    prevPageVisitData = null;
                }
                return prevPageVisitData;
            }
            // For backward compatibility
            (0, $d212d948d25f959a$export$d0d2ebf910ad6e2)(_self, "_logger", {
                g: function() {
                    return logger;
                }
            });
            (0, $d212d948d25f959a$export$d0d2ebf910ad6e2)(_self, "pageVisitTimeTrackingHandler", {
                g: function() {
                    return pageVisitTimeTrackingHandler;
                }
            });
        });
    }
    // Removed Stub for PageVisitTimeManager.prototype.trackPreviousPageVisit.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    PageVisitTimeManager.__ieDyn = 1;
    return PageVisitTimeManager;
}();
var $55f799186175501d$export$513202441432a369 = /** @class */ function() {
    function PageVisitData(pageName, pageUrl) {
        this[0, $9acc3b97657eaaf0$export$204c1f54732d882 /* @min:%2epageVisitStartTime */ ] = (0, $628cad25a0769458$export$a56f095995763cca)();
        this.pageName = pageName;
        this.pageUrl = pageUrl;
    }
    return PageVisitData;
}();


/*
 * Application Insights JavaScript SDK - Web Analytics, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 

/**
 * Used to record timed events and page views.
 */ var $6610fcdfc52ae3ca$export$ef1e5872612852d1 = /** @class */ function() {
    function Timing(logger, name) {
        var _self = this;
        var _events = {};
        _self.start = function(name) {
            if (typeof _events[name] !== "undefined") (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , 62 /* _eInternalMessageId.StartCalledMoreThanOnce */ , "start was called more than once for this event without calling stop.", {
                name: name,
                key: name
            }, true);
            _events[name] = +new Date;
        };
        _self.stop = function(name, url, properties, measurements) {
            var start = _events[name];
            if (isNaN(start)) (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , 63 /* _eInternalMessageId.StopCalledWithoutStart */ , "stop was called without a corresponding start.", {
                name: name,
                key: name
            }, true);
            else {
                var end = +new Date;
                var duration = (0, $d98b699aeccdabc6$export$bfc7deb7f4f00987)(start, end);
                _self.action(name, url, duration, properties, measurements);
            }
            delete _events[name];
            _events[name] = undefined;
        };
    }
    return Timing;
}();


var $826a9f6c1286ca27$var$_a;
var $826a9f6c1286ca27$var$strEvent = "event";
function $826a9f6c1286ca27$var$_dispatchEvent(target, evnt) {
    if (target && target.dispatchEvent && evnt) target.dispatchEvent(evnt);
}
function $826a9f6c1286ca27$var$_getReason(error) {
    if (error && error.reason) {
        var reason = error.reason;
        if (!(0, $533f826bbc418791$export$844ec244b1367d54)(reason) && (0, $533f826bbc418791$export$f6e2535fb5126e54)(reason[0, $9acc3b97657eaaf0$export$e2818d11505fa034 /* @min:%2etoString */ ])) return reason[0, $9acc3b97657eaaf0$export$e2818d11505fa034 /* @min:%2etoString */ ]();
        return (0, $386f00e3a193a7da$export$21fce7cbd4dc679f)(reason);
    }
    // Pass the original object down which will eventually get evaluated for any message or description
    return error || "";
}
var $826a9f6c1286ca27$var$MinMilliSeconds = 60000;
var $826a9f6c1286ca27$var$defaultValues = (0, $36a077d9f4439b69$export$a15782d21797da4c)(($826a9f6c1286ca27$var$_a = {
    sessionRenewalMs: (0, $61c4d9dd4226f64e$export$e86b712d02676c90)($826a9f6c1286ca27$var$_chkConfigMilliseconds, 1800000),
    sessionExpirationMs: (0, $61c4d9dd4226f64e$export$e86b712d02676c90)($826a9f6c1286ca27$var$_chkConfigMilliseconds, 86400000),
    disableExceptionTracking: (0, $61c4d9dd4226f64e$export$bad0d7bace730ae)()
}, $826a9f6c1286ca27$var$_a[0, $9acc3b97657eaaf0$export$e4892641d6ea1b45 /* @min:autoTrackPageVisitTime */ ] = (0, $61c4d9dd4226f64e$export$bad0d7bace730ae)(), $826a9f6c1286ca27$var$_a[0, $9acc3b97657eaaf0$export$c653a2fea2d8252a /* @min:overridePageViewDuration */ ] = (0, $61c4d9dd4226f64e$export$bad0d7bace730ae)(), $826a9f6c1286ca27$var$_a[0, $9acc3b97657eaaf0$export$72fe3f7aecc0d015 /* @min:enableUnhandledPromiseRejectionTracking */ ] = (0, $61c4d9dd4226f64e$export$bad0d7bace730ae)(), $826a9f6c1286ca27$var$_a[0, $9acc3b97657eaaf0$export$527cc291f0159d2a /* @min:autoUnhandledPromiseInstrumented */ ] = false, $826a9f6c1286ca27$var$_a.samplingPercentage = (0, $61c4d9dd4226f64e$export$d0884590a6a82e6c)($826a9f6c1286ca27$var$_chkSampling, 100), $826a9f6c1286ca27$var$_a[0, $9acc3b97657eaaf0$export$f357d96937d91514 /* @min:isStorageUseDisabled */ ] = (0, $61c4d9dd4226f64e$export$bad0d7bace730ae)(), $826a9f6c1286ca27$var$_a[0, $9acc3b97657eaaf0$export$204917ab19f7a461 /* @min:isBrowserLinkTrackingEnabled */ ] = (0, $61c4d9dd4226f64e$export$bad0d7bace730ae)(), $826a9f6c1286ca27$var$_a[0, $9acc3b97657eaaf0$export$6390687f17a52950 /* @min:enableAutoRouteTracking */ ] = (0, $61c4d9dd4226f64e$export$bad0d7bace730ae)(), $826a9f6c1286ca27$var$_a.namePrefix = (0, $61c4d9dd4226f64e$export$75965e1022d5969a)(), $826a9f6c1286ca27$var$_a.enableDebug = (0, $61c4d9dd4226f64e$export$bad0d7bace730ae)(), $826a9f6c1286ca27$var$_a.disableFlushOnBeforeUnload = (0, $61c4d9dd4226f64e$export$bad0d7bace730ae)(), $826a9f6c1286ca27$var$_a.disableFlushOnUnload = (0, $61c4d9dd4226f64e$export$bad0d7bace730ae)(false, "disableFlushOnBeforeUnload"), $826a9f6c1286ca27$var$_a));
function $826a9f6c1286ca27$var$_chkConfigMilliseconds(value, defValue) {
    value = value || defValue;
    if (value < $826a9f6c1286ca27$var$MinMilliSeconds) value = $826a9f6c1286ca27$var$MinMilliSeconds;
    return +value;
}
function $826a9f6c1286ca27$var$_chkSampling(value) {
    return !isNaN(value) && value > 0 && value <= 100;
}
function $826a9f6c1286ca27$var$_updateStorageUsage(extConfig) {
    // Not resetting the storage usage as someone may have manually called utlDisableStorage, so this will only
    // reset based if the configuration option is provided
    if (!(0, $533f826bbc418791$export$fce6876652108ab)(extConfig[0, $9acc3b97657eaaf0$export$f357d96937d91514 /* @min:%2eisStorageUseDisabled */ ])) {
        if (extConfig[0, $9acc3b97657eaaf0$export$f357d96937d91514 /* @min:%2eisStorageUseDisabled */ ]) (0, $8e03bdff803b84be$export$53ddd0ab7db9403)();
        else (0, $8e03bdff803b84be$export$f08cf9bcd292b981)();
    }
}
var $826a9f6c1286ca27$export$ca681bfeb2cf0fca = /** @class */ function(_super) {
    (0, $2a74b38b87b38cda$export$1f9c32e3fbfb8e62)(AnalyticsPlugin, _super);
    function AnalyticsPlugin() {
        var _this = _super.call(this) || this;
        _this.identifier = (0, $ca7353bd9238d340$export$862d858b0002f352); // do not change name or priority
        _this.priority = 180; // take from reserved priority range 100- 200
        _this.autoRoutePVDelay = 500; // ms; Time to wait after a route change before triggering a pageview to allow DOM changes to take place
        var _eventTracking;
        var _pageTracking;
        var _pageViewManager;
        var _pageViewPerformanceManager;
        var _pageVisitTimeManager;
        var _preInitTelemetryInitializers;
        var _isBrowserLinkTrackingEnabled;
        var _browserLinkInitializerAdded;
        var _enableAutoRouteTracking;
        var _historyListenerAdded;
        var _disableExceptionTracking;
        var _autoExceptionInstrumented;
        var _enableUnhandledPromiseRejectionTracking;
        var _autoUnhandledPromiseInstrumented;
        var _extConfig;
        var _autoTrackPageVisitTime;
        // Counts number of trackAjax invocations.
        // By default we only monitor X ajax call per view to avoid too much load.
        // Default value is set in config.
        // This counter keeps increasing even after the limit is reached.
        var _trackAjaxAttempts = 0;
        // array with max length of 2 that store current url and previous url for SPA page route change trackPageview use.
        var _prevUri; // Assigned in the constructor
        var _currUri;
        var _evtNamespace;
        (0, $c9b63384299a3252$export$2e2bcd8739ae039)(AnalyticsPlugin, _this, function(_self, _base) {
            var _addHook = _base[0, $9acc3b97657eaaf0$export$3b3afe26ca0e015c /* @min:%2e_addHook */ ];
            _initDefaults();
            _self.getCookieMgr = function() {
                return (0, $d751d7cd1b1c5598$export$76c0b273586c25c7)(_self[0, $9acc3b97657eaaf0$export$f9ae8d0acf86503e /* @min:%2ecore */ ]);
            };
            _self.processTelemetry = function(env, itemCtx) {
                _self.processNext(env, itemCtx);
            };
            _self.trackEvent = function(event, customProperties) {
                try {
                    var telemetryItem = (0, $932e93a8e5adf75c$export$2dc41327de8d98f1)(event, (0, $9bdc8b7e7935e83a$export$d61e24a684f9e51)[0, $9acc3b97657eaaf0$export$9e16762ab4f2648 /* @min:%2edataType */ ], (0, $9bdc8b7e7935e83a$export$d61e24a684f9e51)[0, $9acc3b97657eaaf0$export$2672d4f7ccc80348 /* @min:%2eenvelopeType */ ], _self[0, $9acc3b97657eaaf0$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), customProperties);
                    _self[0, $9acc3b97657eaaf0$export$f9ae8d0acf86503e /* @min:%2ecore */ ][0, $9acc3b97657eaaf0$export$548634e98b3af9c4 /* @min:%2etrack */ ](telemetryItem);
                } catch (e) {
                    _throwInternal(2 /* eLoggingSeverity.WARNING */ , 39 /* _eInternalMessageId.TrackTraceFailed */ , "trackTrace failed, trace will not be collected: " + (0, $0b747974b0bb3563$export$39c4487b36c98fec)(e), {
                        exception: (0, $386f00e3a193a7da$export$21fce7cbd4dc679f)(e)
                    });
                }
            };
            /**
             * Start timing an extended event. Call `stopTrackEvent` to log the event when it ends.
             * @param   name    A string that identifies this event uniquely within the document.
             */ _self.startTrackEvent = function(name) {
                try {
                    _eventTracking.start(name);
                } catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */ , 29 /* _eInternalMessageId.StartTrackEventFailed */ , "startTrackEvent failed, event will not be collected: " + (0, $0b747974b0bb3563$export$39c4487b36c98fec)(e), {
                        exception: (0, $386f00e3a193a7da$export$21fce7cbd4dc679f)(e)
                    });
                }
            };
            /**
             * Log an extended event that you started timing with `startTrackEvent`.
             * @param   name    The string you used to identify this event in `startTrackEvent`.
             * @param   properties  map[string, string] - additional data used to filter events and metrics in the portal. Defaults to empty.
             * @param   measurements    map[string, number] - metrics associated with this event, displayed in Metrics Explorer on the portal. Defaults to empty.
             */ _self.stopTrackEvent = function(name, properties, measurements) {
                try {
                    _eventTracking.stop(name, undefined, properties, measurements);
                } catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */ , 30 /* _eInternalMessageId.StopTrackEventFailed */ , "stopTrackEvent failed, event will not be collected: " + (0, $0b747974b0bb3563$export$39c4487b36c98fec)(e), {
                        exception: (0, $386f00e3a193a7da$export$21fce7cbd4dc679f)(e)
                    });
                }
            };
            /**
             * @description Log a diagnostic message
             * @param trace
             * @param ICustomProperties.
             * @memberof ApplicationInsights
             */ _self.trackTrace = function(trace, customProperties) {
                try {
                    var telemetryItem = (0, $932e93a8e5adf75c$export$2dc41327de8d98f1)(trace, (0, $16adbdbcb0ae9015$export$78e1bea9036f120f)[0, $9acc3b97657eaaf0$export$9e16762ab4f2648 /* @min:%2edataType */ ], (0, $16adbdbcb0ae9015$export$78e1bea9036f120f)[0, $9acc3b97657eaaf0$export$2672d4f7ccc80348 /* @min:%2eenvelopeType */ ], _self[0, $9acc3b97657eaaf0$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), customProperties);
                    _self[0, $9acc3b97657eaaf0$export$f9ae8d0acf86503e /* @min:%2ecore */ ][0, $9acc3b97657eaaf0$export$548634e98b3af9c4 /* @min:%2etrack */ ](telemetryItem);
                } catch (e) {
                    _throwInternal(2 /* eLoggingSeverity.WARNING */ , 39 /* _eInternalMessageId.TrackTraceFailed */ , "trackTrace failed, trace will not be collected: " + (0, $0b747974b0bb3563$export$39c4487b36c98fec)(e), {
                        exception: (0, $386f00e3a193a7da$export$21fce7cbd4dc679f)(e)
                    });
                }
            };
            /**
             * @description Log a numeric value that is not associated with a specific event. Typically
             * used to send regular reports of performance indicators. To send single measurement, just
             * use the name and average fields of {@link IMetricTelemetry}. If you take measurements
             * frequently, you can reduce the telemetry bandwidth by aggregating multiple measurements
             * and sending the resulting average at intervals
             * @param metric - input object argument. Only name and average are mandatory.
             * @param } customProperties additional data used to filter metrics in the
             * portal. Defaults to empty.
             * @memberof ApplicationInsights
             */ _self.trackMetric = function(metric, customProperties) {
                try {
                    var telemetryItem = (0, $932e93a8e5adf75c$export$2dc41327de8d98f1)(metric, (0, $659de0afdff509f2$export$efdd3e096bc27746)[0, $9acc3b97657eaaf0$export$9e16762ab4f2648 /* @min:%2edataType */ ], (0, $659de0afdff509f2$export$efdd3e096bc27746)[0, $9acc3b97657eaaf0$export$2672d4f7ccc80348 /* @min:%2eenvelopeType */ ], _self[0, $9acc3b97657eaaf0$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), customProperties);
                    _self[0, $9acc3b97657eaaf0$export$f9ae8d0acf86503e /* @min:%2ecore */ ][0, $9acc3b97657eaaf0$export$548634e98b3af9c4 /* @min:%2etrack */ ](telemetryItem);
                } catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */ , 36 /* _eInternalMessageId.TrackMetricFailed */ , "trackMetric failed, metric will not be collected: " + (0, $0b747974b0bb3563$export$39c4487b36c98fec)(e), {
                        exception: (0, $386f00e3a193a7da$export$21fce7cbd4dc679f)(e)
                    });
                }
            };
            /**
             * Logs that a page or other item was viewed.
             * @param IPageViewTelemetry - The string you used as the name in startTrackPage. Defaults to the document title.
             * @param customProperties - Additional data used to filter events and metrics. Defaults to empty.
             * If a user wants to provide duration for pageLoad, it'll have to be in pageView.properties.duration
             */ _self[0, $9acc3b97657eaaf0$export$ab1a8669316b7a02 /* @min:%2etrackPageView */ ] = function(pageView, customProperties) {
                try {
                    var inPv = pageView || {};
                    _pageViewManager[0, $9acc3b97657eaaf0$export$ab1a8669316b7a02 /* @min:%2etrackPageView */ ](inPv, (0, $2a74b38b87b38cda$export$b3cf7a802e578501)((0, $2a74b38b87b38cda$export$b3cf7a802e578501)((0, $2a74b38b87b38cda$export$b3cf7a802e578501)({}, inPv.properties), inPv.measurements), customProperties));
                    if (_autoTrackPageVisitTime) _pageVisitTimeManager[0, $9acc3b97657eaaf0$export$5b63a890d51a5194 /* @min:%2etrackPreviousPageVisit */ ](inPv.name, inPv.uri);
                } catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */ , 37 /* _eInternalMessageId.TrackPVFailed */ , "trackPageView failed, page view will not be collected: " + (0, $0b747974b0bb3563$export$39c4487b36c98fec)(e), {
                        exception: (0, $386f00e3a193a7da$export$21fce7cbd4dc679f)(e)
                    });
                }
            };
            /**
             * Create a page view telemetry item and send it to the SDK pipeline through the core.track API
             * @param pageView - Page view item to be sent
             * @param properties - Custom properties (Part C) that a user can add to the telemetry item
             * @param systemProperties - System level properties (Part A) that a user can add to the telemetry item
             */ _self[0, $9acc3b97657eaaf0$export$e4d43b697816aae1 /* @min:%2esendPageViewInternal */ ] = function(pageView, properties, systemProperties) {
                var doc = (0, $3d5fcb60a9467a45$export$f65ca476c09acec0)();
                if (doc) pageView.refUri = pageView.refUri === undefined ? doc.referrer : pageView.refUri;
                var telemetryItem = (0, $932e93a8e5adf75c$export$2dc41327de8d98f1)(pageView, (0, $5c5f40703ef3d51c$export$12c0fdede1c6bc6c)[0, $9acc3b97657eaaf0$export$9e16762ab4f2648 /* @min:%2edataType */ ], (0, $5c5f40703ef3d51c$export$12c0fdede1c6bc6c)[0, $9acc3b97657eaaf0$export$2672d4f7ccc80348 /* @min:%2eenvelopeType */ ], _self[0, $9acc3b97657eaaf0$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), properties, systemProperties);
                _self[0, $9acc3b97657eaaf0$export$f9ae8d0acf86503e /* @min:%2ecore */ ][0, $9acc3b97657eaaf0$export$548634e98b3af9c4 /* @min:%2etrack */ ](telemetryItem);
                // reset ajaxes counter
                _trackAjaxAttempts = 0;
            };
            /**
             * @ignore INTERNAL ONLY
             * @param pageViewPerformance
             * @param properties
             */ _self[0, $9acc3b97657eaaf0$export$fe3039bd0e70dd3f /* @min:%2esendPageViewPerformanceInternal */ ] = function(pageViewPerformance, properties, systemProperties) {
                var telemetryItem = (0, $932e93a8e5adf75c$export$2dc41327de8d98f1)(pageViewPerformance, (0, $27d410d508f4b32f$export$709aae57ec681346)[0, $9acc3b97657eaaf0$export$9e16762ab4f2648 /* @min:%2edataType */ ], (0, $27d410d508f4b32f$export$709aae57ec681346)[0, $9acc3b97657eaaf0$export$2672d4f7ccc80348 /* @min:%2eenvelopeType */ ], _self[0, $9acc3b97657eaaf0$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), properties, systemProperties);
                _self[0, $9acc3b97657eaaf0$export$f9ae8d0acf86503e /* @min:%2ecore */ ][0, $9acc3b97657eaaf0$export$548634e98b3af9c4 /* @min:%2etrack */ ](telemetryItem);
            };
            /**
             * Send browser performance metrics.
             * @param pageViewPerformance
             * @param customProperties
             */ _self.trackPageViewPerformance = function(pageViewPerformance, customProperties) {
                var inPvp = pageViewPerformance || {};
                try {
                    _pageViewPerformanceManager[0, $9acc3b97657eaaf0$export$20270e2265c2a185 /* @min:%2epopulatePageViewPerformanceEvent */ ](inPvp);
                    _self[0, $9acc3b97657eaaf0$export$fe3039bd0e70dd3f /* @min:%2esendPageViewPerformanceInternal */ ](inPvp, customProperties);
                } catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */ , 37 /* _eInternalMessageId.TrackPVFailed */ , "trackPageViewPerformance failed, page view will not be collected: " + (0, $0b747974b0bb3563$export$39c4487b36c98fec)(e), {
                        exception: (0, $386f00e3a193a7da$export$21fce7cbd4dc679f)(e)
                    });
                }
            };
            /**
             * Starts the timer for tracking a page load time. Use this instead of `trackPageView` if you want to control when the page view timer starts and stops,
             * but don't want to calculate the duration yourself. This method doesn't send any telemetry. Call `stopTrackPage` to log the end of the page view
             * and send the event.
             * @param name - A string that idenfities this item, unique within this HTML document. Defaults to the document title.
             */ _self.startTrackPage = function(name) {
                try {
                    if (typeof name !== "string") {
                        var doc = (0, $3d5fcb60a9467a45$export$f65ca476c09acec0)();
                        name = doc && doc.title || "";
                    }
                    _pageTracking.start(name);
                } catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */ , 31 /* _eInternalMessageId.StartTrackFailed */ , "startTrackPage failed, page view may not be collected: " + (0, $0b747974b0bb3563$export$39c4487b36c98fec)(e), {
                        exception: (0, $386f00e3a193a7da$export$21fce7cbd4dc679f)(e)
                    });
                }
            };
            /**
             * Stops the timer that was started by calling `startTrackPage` and sends the pageview load time telemetry with the specified properties and measurements.
             * The duration of the page view will be the time between calling `startTrackPage` and `stopTrackPage`.
             * @param   name  The string you used as the name in startTrackPage. Defaults to the document title.
             * @param   url   String - a relative or absolute URL that identifies the page or other item. Defaults to the window location.
             * @param   properties  map[string, string] - additional data used to filter pages and metrics in the portal. Defaults to empty.
             * @param   measurements    map[string, number] - metrics associated with this page, displayed in Metrics Explorer on the portal. Defaults to empty.
             */ _self.stopTrackPage = function(name, url, properties, measurement) {
                try {
                    if (typeof name !== "string") {
                        var doc = (0, $3d5fcb60a9467a45$export$f65ca476c09acec0)();
                        name = doc && doc.title || "";
                    }
                    if (typeof url !== "string") {
                        var loc = (0, $0c599844349363c4$export$e7fd20fad3cf4b5f)();
                        url = loc && loc[0, $9acc3b97657eaaf0$export$8d0bd9d006f3ecea /* @min:%2ehref */ ] || "";
                    }
                    _pageTracking.stop(name, url, properties, measurement);
                    if (_autoTrackPageVisitTime) _pageVisitTimeManager[0, $9acc3b97657eaaf0$export$5b63a890d51a5194 /* @min:%2etrackPreviousPageVisit */ ](name, url);
                } catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */ , 32 /* _eInternalMessageId.StopTrackFailed */ , "stopTrackPage failed, page view will not be collected: " + (0, $0b747974b0bb3563$export$39c4487b36c98fec)(e), {
                        exception: (0, $386f00e3a193a7da$export$21fce7cbd4dc679f)(e)
                    });
                }
            };
            /**
            * @ignore INTERNAL ONLY
            * @param exception
            * @param properties
            * @param systemProperties
            */ _self[0, $9acc3b97657eaaf0$export$5414b86ab837cb07 /* @min:%2esendExceptionInternal */ ] = function(exception, customProperties, systemProperties) {
                // Adding additional edge cases to handle
                // - Not passing anything (null / undefined)
                var theError = exception && (exception[0, $9acc3b97657eaaf0$export$4852fd87b68a6e1f /* @min:%2eexception */ ] || exception[0, $9acc3b97657eaaf0$export$ff0a0f80c43edd37 /* @min:%2eerror */ ]) || // - Handle someone calling trackException based of v1 API where the exception was the Error
                (0, $533f826bbc418791$export$e6127cc7fe7395c3)(exception) && exception || // - Handles no error being defined and instead of creating a new Error() instance attempt to map so any stacktrace
                //   is preserved and does not list ApplicationInsights code as the source
                {
                    name: exception && typeof exception,
                    message: exception || (0, $71dfba5ea0640485$export$4003f5e1672d759)
                };
                // If no exception object was passed assign to an empty object to avoid internal exceptions
                exception = exception || {};
                var exceptionPartB = new (0, $1e8d24b24fb574aa$export$e2f174de097e0bcd)(_self[0, $9acc3b97657eaaf0$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), theError, exception.properties || customProperties, exception.measurements, exception.severityLevel, exception.id).toInterface();
                var telemetryItem = (0, $932e93a8e5adf75c$export$2dc41327de8d98f1)(exceptionPartB, (0, $1e8d24b24fb574aa$export$e2f174de097e0bcd)[0, $9acc3b97657eaaf0$export$9e16762ab4f2648 /* @min:%2edataType */ ], (0, $1e8d24b24fb574aa$export$e2f174de097e0bcd)[0, $9acc3b97657eaaf0$export$2672d4f7ccc80348 /* @min:%2eenvelopeType */ ], _self[0, $9acc3b97657eaaf0$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), customProperties, systemProperties);
                _self[0, $9acc3b97657eaaf0$export$f9ae8d0acf86503e /* @min:%2ecore */ ][0, $9acc3b97657eaaf0$export$548634e98b3af9c4 /* @min:%2etrack */ ](telemetryItem);
            };
            /**
             * Log an exception you have caught.
             *
             * @param exception -   Object which contains exception to be sent
             * @param } customProperties   Additional data used to filter pages and metrics in the portal. Defaults to empty.
             *
             * Any property of type double will be considered a measurement, and will be treated by Application Insights as a metric.
             * @memberof ApplicationInsights
             */ _self.trackException = function(exception, customProperties) {
                if (exception && !exception[0, $9acc3b97657eaaf0$export$4852fd87b68a6e1f /* @min:%2eexception */ ] && exception[0, $9acc3b97657eaaf0$export$ff0a0f80c43edd37 /* @min:%2eerror */ ]) exception[0, $9acc3b97657eaaf0$export$4852fd87b68a6e1f /* @min:%2eexception */ ] = exception[0, $9acc3b97657eaaf0$export$ff0a0f80c43edd37 /* @min:%2eerror */ ];
                try {
                    _self[0, $9acc3b97657eaaf0$export$5414b86ab837cb07 /* @min:%2esendExceptionInternal */ ](exception, customProperties);
                } catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */ , 35 /* _eInternalMessageId.TrackExceptionFailed */ , "trackException failed, exception will not be collected: " + (0, $0b747974b0bb3563$export$39c4487b36c98fec)(e), {
                        exception: (0, $386f00e3a193a7da$export$21fce7cbd4dc679f)(e)
                    });
                }
            };
            /**
             * @description Custom error handler for Application Insights Analytics
             * @param exception
             * @memberof ApplicationInsights
             */ _self[0, $9acc3b97657eaaf0$export$31fe7bcf0f7c83e8 /* @min:%2e_onerror */ ] = function(exception) {
                var error = exception && exception[0, $9acc3b97657eaaf0$export$ff0a0f80c43edd37 /* @min:%2eerror */ ];
                var evt = exception && exception.evt;
                try {
                    if (!evt) {
                        var _window = (0, $3d5fcb60a9467a45$export$38b2d434cce3ea22)();
                        if (_window) evt = _window[$826a9f6c1286ca27$var$strEvent];
                    }
                    var url = exception && exception.url || ((0, $3d5fcb60a9467a45$export$f65ca476c09acec0)() || {}).URL;
                    // If no error source is provided assume the default window.onerror handler
                    var errorSrc = exception[0, $9acc3b97657eaaf0$export$d190ee0b6bfe36d8 /* @min:%2eerrorSrc */ ] || "window.onerror@" + url + ":" + (exception[0, $9acc3b97657eaaf0$export$4d19a8ea486d5967 /* @min:%2elineNumber */ ] || 0) + ":" + (exception[0, $9acc3b97657eaaf0$export$91a182df12726bcd /* @min:%2ecolumnNumber */ ] || 0);
                    var properties = {
                        errorSrc: errorSrc,
                        url: url,
                        lineNumber: exception[0, $9acc3b97657eaaf0$export$4d19a8ea486d5967 /* @min:%2elineNumber */ ] || 0,
                        columnNumber: exception[0, $9acc3b97657eaaf0$export$91a182df12726bcd /* @min:%2ecolumnNumber */ ] || 0,
                        message: exception[0, $9acc3b97657eaaf0$export$923606b70907833e /* @min:%2emessage */ ]
                    };
                    if ((0, $8ce53fcb9c1dc1db$export$8c465f5f14327ccd)(exception.message, exception.url, exception.lineNumber, exception.columnNumber, exception[0, $9acc3b97657eaaf0$export$ff0a0f80c43edd37 /* @min:%2eerror */ ])) _sendCORSException((0, $1e8d24b24fb574aa$export$e2f174de097e0bcd)[0, $9acc3b97657eaaf0$export$3dedbd38aa3b0c11 /* @min:%2eCreateAutoException */ ]("Script error: The browser's same-origin policy prevents us from getting the details of this exception. Consider using the 'crossorigin' attribute.", url, exception[0, $9acc3b97657eaaf0$export$4d19a8ea486d5967 /* @min:%2elineNumber */ ] || 0, exception[0, $9acc3b97657eaaf0$export$91a182df12726bcd /* @min:%2ecolumnNumber */ ] || 0, error, evt, null, errorSrc), properties);
                    else {
                        if (!exception[0, $9acc3b97657eaaf0$export$d190ee0b6bfe36d8 /* @min:%2eerrorSrc */ ]) exception[0, $9acc3b97657eaaf0$export$d190ee0b6bfe36d8 /* @min:%2eerrorSrc */ ] = errorSrc;
                        _self.trackException({
                            exception: exception,
                            severityLevel: 3 /* eSeverityLevel.Error */ 
                        }, properties);
                    }
                } catch (e) {
                    var errorString = error ? error.name + ", " + error[0, $9acc3b97657eaaf0$export$923606b70907833e /* @min:%2emessage */ ] : "null";
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */ , 11 /* _eInternalMessageId.ExceptionWhileLoggingError */ , "_onError threw exception while logging error, error will not be collected: " + (0, $0b747974b0bb3563$export$39c4487b36c98fec)(e), {
                        exception: (0, $386f00e3a193a7da$export$21fce7cbd4dc679f)(e),
                        errorString: errorString
                    });
                }
            };
            _self[0, $9acc3b97657eaaf0$export$935b759388157821 /* @min:%2eaddTelemetryInitializer */ ] = function(telemetryInitializer) {
                if (_self[0, $9acc3b97657eaaf0$export$f9ae8d0acf86503e /* @min:%2ecore */ ]) // Just add to the core
                return _self[0, $9acc3b97657eaaf0$export$f9ae8d0acf86503e /* @min:%2ecore */ ][0, $9acc3b97657eaaf0$export$935b759388157821 /* @min:%2eaddTelemetryInitializer */ ](telemetryInitializer);
                // Handle "pre-initialization" telemetry initializers (for backward compatibility)
                if (!_preInitTelemetryInitializers) _preInitTelemetryInitializers = [];
                _preInitTelemetryInitializers.push(telemetryInitializer);
            };
            _self.initialize = function(config, core, extensions, pluginChain) {
                if (_self.isInitialized()) return;
                if ((0, $533f826bbc418791$export$bedb7023a7733221)(core)) (0, $44a1c24c0e411039$export$8bf7aba4a9e09055)("Error initializing");
                _base.initialize(config, core, extensions, pluginChain);
                try {
                    _evtNamespace = (0, $12cc003c7fb5ccde$export$3f37a50e0edde3be)((0, $8a2d104e2647a310$export$eb4a6badb18ead04)(_self.identifier), core.evtNamespace && core.evtNamespace());
                    if (_preInitTelemetryInitializers) {
                        (0, $f6bb085f8cf12216$export$e2e5bcdbdc49c586)(_preInitTelemetryInitializers, function(initializer) {
                            core[0, $9acc3b97657eaaf0$export$935b759388157821 /* @min:%2eaddTelemetryInitializer */ ](initializer);
                        });
                        _preInitTelemetryInitializers = null;
                    }
                    _populateDefaults(config);
                    _pageViewPerformanceManager = new (0, $14a28652d5a6e87a$export$da80ef98bc1bafa6)(_self[0, $9acc3b97657eaaf0$export$f9ae8d0acf86503e /* @min:%2ecore */ ]);
                    _pageViewManager = new (0, $6e4263cfc9177d6e$export$5bb8d6768724bf86)(_self, _extConfig.overridePageViewDuration, _self[0, $9acc3b97657eaaf0$export$f9ae8d0acf86503e /* @min:%2ecore */ ], _pageViewPerformanceManager);
                    _pageVisitTimeManager = new (0, $55f799186175501d$export$f6fdd81afb2fe76)(_self[0, $9acc3b97657eaaf0$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), function(pageName, pageUrl, pageVisitTime) {
                        return trackPageVisitTime(pageName, pageUrl, pageVisitTime);
                    });
                    _eventTracking = new (0, $6610fcdfc52ae3ca$export$ef1e5872612852d1)(_self[0, $9acc3b97657eaaf0$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), "trackEvent");
                    _eventTracking.action = function(name, url, duration, properties, measurements) {
                        if (!properties) properties = {};
                        if (!measurements) measurements = {};
                        properties.duration = duration[0, $9acc3b97657eaaf0$export$e2818d11505fa034 /* @min:%2etoString */ ]();
                        _self.trackEvent({
                            name: name,
                            properties: properties,
                            measurements: measurements
                        });
                    };
                    // initialize page view timing
                    _pageTracking = new (0, $6610fcdfc52ae3ca$export$ef1e5872612852d1)(_self[0, $9acc3b97657eaaf0$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), "trackPageView");
                    _pageTracking.action = function(name, url, duration, properties, measurements) {
                        // duration must be a custom property in order for the collector to extract it
                        if ((0, $533f826bbc418791$export$bedb7023a7733221)(properties)) properties = {};
                        properties.duration = duration[0, $9acc3b97657eaaf0$export$e2818d11505fa034 /* @min:%2etoString */ ]();
                        var pageViewItem = {
                            name: name,
                            uri: url,
                            properties: properties,
                            measurements: measurements
                        };
                        _self[0, $9acc3b97657eaaf0$export$e4d43b697816aae1 /* @min:%2esendPageViewInternal */ ](pageViewItem, properties);
                    };
                    if ((0, $3d5fcb60a9467a45$export$fef62134eea24008)()) {
                        _updateExceptionTracking();
                        _updateLocationChange();
                    }
                } catch (e) {
                    // resetting the initialized state because of failure
                    _self.setInitialized(false);
                    throw e;
                }
            };
            _self._doTeardown = function(unloadCtx, unloadState) {
                _pageViewManager && _pageViewManager.teardown(unloadCtx, unloadState);
                // Just register to remove all events associated with this namespace
                (0, $12cc003c7fb5ccde$export$51dedceb7c784eff)(window, null, null, _evtNamespace);
                _initDefaults();
            };
            function _populateDefaults(config) {
                var identifier = _self.identifier;
                var core = _self[0, $9acc3b97657eaaf0$export$f9ae8d0acf86503e /* @min:%2ecore */ ];
                _self[0, $9acc3b97657eaaf0$export$3b3afe26ca0e015c /* @min:%2e_addHook */ ]((0, $acb30f9e62dc5705$export$454a433e4deb244f)(config, function() {
                    var ctx = (0, $bc7124acb0f73e64$export$ca98f11e981bcfd6)(null, config, core);
                    _extConfig = ctx.getExtCfg(identifier, $826a9f6c1286ca27$var$defaultValues);
                    _autoTrackPageVisitTime = _extConfig[0, $9acc3b97657eaaf0$export$e4892641d6ea1b45 /* @min:%2eautoTrackPageVisitTime */ ];
                    $826a9f6c1286ca27$var$_updateStorageUsage(_extConfig);
                    // _updateBrowserLinkTracking
                    _isBrowserLinkTrackingEnabled = _extConfig[0, $9acc3b97657eaaf0$export$204917ab19f7a461 /* @min:%2eisBrowserLinkTrackingEnabled */ ];
                    _addDefaultTelemetryInitializers();
                }));
            }
            /**
             * Log a page visit time
             * @param    pageName    Name of page
             * @param    pageVisitDuration Duration of visit to the page in milliseconds
             */ function trackPageVisitTime(pageName, pageUrl, pageVisitTime) {
                var properties = {
                    PageName: pageName,
                    PageUrl: pageUrl
                };
                _self.trackMetric({
                    name: "PageVisitTime",
                    average: pageVisitTime,
                    max: pageVisitTime,
                    min: pageVisitTime,
                    sampleCount: 1
                }, properties);
            }
            function _addDefaultTelemetryInitializers() {
                if (!_browserLinkInitializerAdded && _isBrowserLinkTrackingEnabled) {
                    var browserLinkPaths_1 = [
                        "/browserLinkSignalR/",
                        "/__browserLink/"
                    ];
                    var dropBrowserLinkRequests = function(envelope) {
                        if (_isBrowserLinkTrackingEnabled && envelope.baseType === (0, $0dd1de134f090c69$export$a7b48490930dbffa)[0, $9acc3b97657eaaf0$export$9e16762ab4f2648 /* @min:%2edataType */ ]) {
                            var remoteData = envelope.baseData;
                            if (remoteData) for(var i = 0; i < browserLinkPaths_1[0, $9acc3b97657eaaf0$export$6eae51590aaea43 /* @min:%2elength */ ]; i++){
                                if (remoteData.target && (0, $0194d45a55d79548$export$7c0888b0c4641088)(remoteData.target, browserLinkPaths_1[i]) >= 0) return false;
                            }
                        }
                        return true;
                    };
                    _self[0, $9acc3b97657eaaf0$export$3b3afe26ca0e015c /* @min:%2e_addHook */ ](_self[0, $9acc3b97657eaaf0$export$935b759388157821 /* @min:%2eaddTelemetryInitializer */ ](dropBrowserLinkRequests));
                    _browserLinkInitializerAdded = true;
                }
            }
            function _sendCORSException(exception, properties) {
                var telemetryItem = (0, $932e93a8e5adf75c$export$2dc41327de8d98f1)(exception, (0, $1e8d24b24fb574aa$export$e2f174de097e0bcd)[0, $9acc3b97657eaaf0$export$9e16762ab4f2648 /* @min:%2edataType */ ], (0, $1e8d24b24fb574aa$export$e2f174de097e0bcd)[0, $9acc3b97657eaaf0$export$2672d4f7ccc80348 /* @min:%2eenvelopeType */ ], _self[0, $9acc3b97657eaaf0$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), properties);
                _self[0, $9acc3b97657eaaf0$export$f9ae8d0acf86503e /* @min:%2ecore */ ][0, $9acc3b97657eaaf0$export$548634e98b3af9c4 /* @min:%2etrack */ ](telemetryItem);
            }
            function _updateExceptionTracking() {
                var _window = (0, $3d5fcb60a9467a45$export$38b2d434cce3ea22)();
                var locn = (0, $0c599844349363c4$export$e7fd20fad3cf4b5f)(true);
                _self[0, $9acc3b97657eaaf0$export$3b3afe26ca0e015c /* @min:%2e_addHook */ ]((0, $acb30f9e62dc5705$export$454a433e4deb244f)(_extConfig, function() {
                    _disableExceptionTracking = _extConfig.disableExceptionTracking;
                    if (!_disableExceptionTracking && !_autoExceptionInstrumented && !_extConfig.autoExceptionInstrumented) {
                        // We want to enable exception auto collection and it has not been done so yet
                        _addHook((0, $963b9811c2275531$export$b96f6cbe9b035430)(_window, "onerror", {
                            ns: _evtNamespace,
                            rsp: function(callDetails, message, url, lineNumber, columnNumber, error) {
                                if (!_disableExceptionTracking && callDetails.rslt !== true) _self[0, $9acc3b97657eaaf0$export$31fe7bcf0f7c83e8 /* @min:%2e_onerror */ ]((0, $1e8d24b24fb574aa$export$e2f174de097e0bcd)[0, $9acc3b97657eaaf0$export$3dedbd38aa3b0c11 /* @min:%2eCreateAutoException */ ](message, url, lineNumber, columnNumber, error, callDetails.evt));
                            }
                        }, false));
                        _autoExceptionInstrumented = true;
                    }
                }));
                _addUnhandledPromiseRejectionTracking(_window, locn);
            }
            function _updateLocationChange() {
                var win = (0, $3d5fcb60a9467a45$export$38b2d434cce3ea22)();
                var locn = (0, $0c599844349363c4$export$e7fd20fad3cf4b5f)(true);
                _self[0, $9acc3b97657eaaf0$export$3b3afe26ca0e015c /* @min:%2e_addHook */ ]((0, $acb30f9e62dc5705$export$454a433e4deb244f)(_extConfig, function() {
                    _enableAutoRouteTracking = _extConfig[0, $9acc3b97657eaaf0$export$6390687f17a52950 /* @min:%2eenableAutoRouteTracking */ ] === true;
                    /**
                     * Create a custom "locationchange" event which is triggered each time the history object is changed
                     */ if (win && _enableAutoRouteTracking && !_historyListenerAdded && (0, $3d5fcb60a9467a45$export$b79afd6d47f11781)()) {
                        var _history = (0, $3d5fcb60a9467a45$export$f9582a3c130d9538)();
                        if ((0, $533f826bbc418791$export$f6e2535fb5126e54)(_history.pushState) && (0, $533f826bbc418791$export$f6e2535fb5126e54)(_history.replaceState) && typeof Event !== (0, $67b827af57eed1eb$export$9b7d2d86cf58b987)) _addHistoryListener(win, _history, locn);
                    }
                }));
            }
            function _getDistributedTraceCtx() {
                var distributedTraceCtx = null;
                if (_self[0, $9acc3b97657eaaf0$export$f9ae8d0acf86503e /* @min:%2ecore */ ] && _self[0, $9acc3b97657eaaf0$export$f9ae8d0acf86503e /* @min:%2ecore */ ].getTraceCtx) distributedTraceCtx = _self[0, $9acc3b97657eaaf0$export$f9ae8d0acf86503e /* @min:%2ecore */ ].getTraceCtx(false);
                if (!distributedTraceCtx) {
                    // Fallback when using an older Core and PropertiesPlugin
                    var properties = _self[0, $9acc3b97657eaaf0$export$f9ae8d0acf86503e /* @min:%2ecore */ ].getPlugin((0, $ca7353bd9238d340$export$2268e69a6d93b7cc));
                    if (properties) {
                        var context = properties.plugin.context;
                        if (context) distributedTraceCtx = (0, $d98b699aeccdabc6$export$847d5dabba5fabb9)(context.telemetryTrace);
                    }
                }
                return distributedTraceCtx;
            }
            /**
             * Create a custom "locationchange" event which is triggered each time the history object is changed
             */ function _addHistoryListener(win, history, locn) {
                if (_historyListenerAdded) return;
                // Name Prefix is only referenced during the initial initialization and cannot be changed afterwards
                var namePrefix = _extConfig.namePrefix || "";
                function _popstateHandler() {
                    if (_enableAutoRouteTracking) $826a9f6c1286ca27$var$_dispatchEvent(win, (0, $b5e9c029fdfb79a5$export$58aa8b47bf337bc8)(namePrefix + "locationchange"));
                }
                function _locationChangeHandler() {
                    // We always track the changes (if the handler is installed) to handle the feature being disabled between location changes
                    if (_currUri) {
                        _prevUri = _currUri;
                        _currUri = locn && locn[0, $9acc3b97657eaaf0$export$8d0bd9d006f3ecea /* @min:%2ehref */ ] || "";
                    } else _currUri = locn && locn[0, $9acc3b97657eaaf0$export$8d0bd9d006f3ecea /* @min:%2ehref */ ] || "";
                    if (_enableAutoRouteTracking) {
                        var distributedTraceCtx = _getDistributedTraceCtx();
                        if (distributedTraceCtx) {
                            distributedTraceCtx.setTraceId((0, $945e40d4195d77bb$export$58d1fad45f39d957)());
                            var traceLocationName = "_unknown_";
                            if (locn && locn.pathname) traceLocationName = locn.pathname + (locn.hash || "");
                            // This populates the ai.operation.name which has a maximum size of 1024 so we need to sanitize it
                            distributedTraceCtx.setName((0, $8c3059962bb1d83c$export$4e25b1d4bcd67eb8)(_self[0, $9acc3b97657eaaf0$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), traceLocationName));
                        }
                        (0, $d03b12effd00bf96$export$5f4d6617421d489b)((function(uri) {
                            // todo: override start time so that it is not affected by autoRoutePVDelay
                            _self[0, $9acc3b97657eaaf0$export$ab1a8669316b7a02 /* @min:%2etrackPageView */ ]({
                                refUri: uri,
                                properties: {
                                    duration: 0
                                }
                            }); // SPA route change loading durations are undefined, so send 0
                        }).bind(_self, _prevUri), _self.autoRoutePVDelay);
                    }
                }
                _addHook((0, $963b9811c2275531$export$b96f6cbe9b035430)(history, "pushState", {
                    ns: _evtNamespace,
                    rsp: function() {
                        if (_enableAutoRouteTracking) {
                            $826a9f6c1286ca27$var$_dispatchEvent(win, (0, $b5e9c029fdfb79a5$export$58aa8b47bf337bc8)(namePrefix + "pushState"));
                            $826a9f6c1286ca27$var$_dispatchEvent(win, (0, $b5e9c029fdfb79a5$export$58aa8b47bf337bc8)(namePrefix + "locationchange"));
                        }
                    }
                }, true));
                _addHook((0, $963b9811c2275531$export$b96f6cbe9b035430)(history, "replaceState", {
                    ns: _evtNamespace,
                    rsp: function() {
                        if (_enableAutoRouteTracking) {
                            $826a9f6c1286ca27$var$_dispatchEvent(win, (0, $b5e9c029fdfb79a5$export$58aa8b47bf337bc8)(namePrefix + "replaceState"));
                            $826a9f6c1286ca27$var$_dispatchEvent(win, (0, $b5e9c029fdfb79a5$export$58aa8b47bf337bc8)(namePrefix + "locationchange"));
                        }
                    }
                }, true));
                (0, $12cc003c7fb5ccde$export$324ab159353a60a9)(win, namePrefix + "popstate", _popstateHandler, _evtNamespace);
                (0, $12cc003c7fb5ccde$export$324ab159353a60a9)(win, namePrefix + "locationchange", _locationChangeHandler, _evtNamespace);
                _historyListenerAdded = true;
            }
            function _addUnhandledPromiseRejectionTracking(_window, _location) {
                _self[0, $9acc3b97657eaaf0$export$3b3afe26ca0e015c /* @min:%2e_addHook */ ]((0, $acb30f9e62dc5705$export$454a433e4deb244f)(_extConfig, function() {
                    _enableUnhandledPromiseRejectionTracking = _extConfig[0, $9acc3b97657eaaf0$export$72fe3f7aecc0d015 /* @min:%2eenableUnhandledPromiseRejectionTracking */ ] === true;
                    _autoExceptionInstrumented = _autoExceptionInstrumented || _extConfig[0, $9acc3b97657eaaf0$export$527cc291f0159d2a /* @min:%2eautoUnhandledPromiseInstrumented */ ];
                    if (_enableUnhandledPromiseRejectionTracking && !_autoUnhandledPromiseInstrumented) {
                        // We want to enable exception auto collection and it has not been done so yet
                        _addHook((0, $963b9811c2275531$export$b96f6cbe9b035430)(_window, "onunhandledrejection", {
                            ns: _evtNamespace,
                            rsp: function(callDetails, error) {
                                if (_enableUnhandledPromiseRejectionTracking && callDetails.rslt !== true) _self[0, $9acc3b97657eaaf0$export$31fe7bcf0f7c83e8 /* @min:%2e_onerror */ ]((0, $1e8d24b24fb574aa$export$e2f174de097e0bcd)[0, $9acc3b97657eaaf0$export$3dedbd38aa3b0c11 /* @min:%2eCreateAutoException */ ]($826a9f6c1286ca27$var$_getReason(error), _location ? _location[0, $9acc3b97657eaaf0$export$8d0bd9d006f3ecea /* @min:%2ehref */ ] : "", 0, 0, error, callDetails.evt));
                            }
                        }, false));
                        _extConfig[0, $9acc3b97657eaaf0$export$527cc291f0159d2a /* @min:%2eautoUnhandledPromiseInstrumented */ ] = _autoUnhandledPromiseInstrumented = true;
                    }
                }));
            }
            /**
             * This method will throw exceptions in debug mode or attempt to log the error as a console warning.
             * @param severity - {eLoggingSeverity} - The severity of the log message
             * @param msgId - {_eInternalLogMessage} - The log message.
             */ function _throwInternal(severity, msgId, msg, properties, isUserAct) {
                _self[0, $9acc3b97657eaaf0$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ]().throwInternal(severity, msgId, msg, properties, isUserAct);
            }
            function _initDefaults() {
                _eventTracking = null;
                _pageTracking = null;
                _pageViewManager = null;
                _pageViewPerformanceManager = null;
                _pageVisitTimeManager = null;
                _preInitTelemetryInitializers = null;
                _isBrowserLinkTrackingEnabled = false;
                _browserLinkInitializerAdded = false;
                _enableAutoRouteTracking = false;
                _historyListenerAdded = false;
                _disableExceptionTracking = false;
                _autoExceptionInstrumented = false;
                _enableUnhandledPromiseRejectionTracking = false;
                _autoUnhandledPromiseInstrumented = false;
                _autoTrackPageVisitTime = false;
                // Counts number of trackAjax invocations.
                // By default we only monitor X ajax call per view to avoid too much load.
                // Default value is set in config.
                // This counter keeps increasing even after the limit is reached.
                _trackAjaxAttempts = 0;
                // array with max length of 2 that store current url and previous url for SPA page route change trackPageview use.
                var location = (0, $0c599844349363c4$export$e7fd20fad3cf4b5f)(true);
                _prevUri = location && location[0, $9acc3b97657eaaf0$export$8d0bd9d006f3ecea /* @min:%2ehref */ ] || "";
                _currUri = null;
                _evtNamespace = null;
                _extConfig = null;
                // Define _self.config
                (0, $d212d948d25f959a$export$d0d2ebf910ad6e2)(_self, "config", {
                    g: function() {
                        return _extConfig;
                    }
                });
            }
            // For backward compatibility
            (0, $d212d948d25f959a$export$d0d2ebf910ad6e2)(_self, "_pageViewManager", {
                g: function() {
                    return _pageViewManager;
                }
            });
            (0, $d212d948d25f959a$export$d0d2ebf910ad6e2)(_self, "_pageViewPerformanceManager", {
                g: function() {
                    return _pageViewPerformanceManager;
                }
            });
            (0, $d212d948d25f959a$export$d0d2ebf910ad6e2)(_self, "_pageVisitTimeManager", {
                g: function() {
                    return _pageVisitTimeManager;
                }
            });
            (0, $d212d948d25f959a$export$d0d2ebf910ad6e2)(_self, "_evtNamespace", {
                g: function() {
                    return "." + _evtNamespace;
                }
            });
        });
        return _this;
    }
    // Removed Stub for AnalyticsPlugin.prototype.getCookieMgr.
    // Removed Stub for AnalyticsPlugin.prototype.processTelemetry.
    // Removed Stub for AnalyticsPlugin.prototype.trackEvent.
    // Removed Stub for AnalyticsPlugin.prototype.startTrackEvent.
    // Removed Stub for AnalyticsPlugin.prototype.stopTrackEvent.
    // Removed Stub for AnalyticsPlugin.prototype.trackTrace.
    // Removed Stub for AnalyticsPlugin.prototype.trackMetric.
    // Removed Stub for AnalyticsPlugin.prototype.trackPageView.
    // Removed Stub for AnalyticsPlugin.prototype.sendPageViewInternal.
    // Removed Stub for AnalyticsPlugin.prototype.sendPageViewPerformanceInternal.
    // Removed Stub for AnalyticsPlugin.prototype.trackPageViewPerformance.
    // Removed Stub for AnalyticsPlugin.prototype.startTrackPage.
    // Removed Stub for AnalyticsPlugin.prototype.stopTrackPage.
    // Removed Stub for AnalyticsPlugin.prototype.sendExceptionInternal.
    // Removed Stub for AnalyticsPlugin.prototype.trackException.
    // Removed Stub for AnalyticsPlugin.prototype._onerror.
    // Removed Stub for AnalyticsPlugin.prototype.addTelemetryInitializer.
    // Removed Stub for AnalyticsPlugin.prototype.initialize.
    AnalyticsPlugin.Version = "3.0.2"; // Not currently used anywhere
    return AnalyticsPlugin;
}((0, $b61d51369f8191a4$export$64a11c2f90e6766c));


/*
 * Application Insights JavaScript SDK - Channel, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 


/*
 * Application Insights JavaScript SDK - Core, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ /*
 * @nevware21/ts-async
 * https://github.com/nevware21/ts-async
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */ 
/*
 * @nevware21/ts-async
 * https://github.com/nevware21/ts-async
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */ 
/*
 * @nevware21/ts-async
 * https://github.com/nevware21/ts-async
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */ 
function $a99c2448b4d73401$export$856fe465480fa77a(value, cb) {
    return $a99c2448b4d73401$export$96acbd3e4fcaef01(value, function(value) {
        cb && cb({
            value: value,
            rejected: false
        });
    }, function(reason) {
        cb && cb({
            rejected: true,
            reason: reason
        });
    });
}
function $a99c2448b4d73401$export$96acbd3e4fcaef01(value, resolveFn, rejectFn, finallyFn) {
    var result = value;
    if ((0, $533f826bbc418791$export$ae936b9d47e5870e)(value)) {
        if (resolveFn || rejectFn) result = value.then(resolveFn, rejectFn);
    } else resolveFn && resolveFn(value);
    if (finallyFn) result = $a99c2448b4d73401$export$8a7042cf3f497261(result, finallyFn);
    return result;
}
function $a99c2448b4d73401$export$8a7042cf3f497261(value, finallyFn) {
    var result = value;
    if (finallyFn) {
        if ((0, $533f826bbc418791$export$ae936b9d47e5870e)(value)) {
            if (value.finally) result = value.finally(finallyFn);
            else // Simulate finally if not available
            result = value.then(function(value) {
                finallyFn();
                return value;
            }, function(reason) {
                finallyFn();
                throw reason;
            });
        } else finallyFn();
    }
    return result;
}


/*
 * @nevware21/ts-async
 * https://github.com/nevware21/ts-async
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */ 
var $9f9d8893ee48294d$var$_debugState;
var $9f9d8893ee48294d$var$_debugResult;
var $9f9d8893ee48294d$var$_debugHandled;
var $9f9d8893ee48294d$export$5b878ab00d3f2b4 = false;
var $9f9d8893ee48294d$var$_theLogger = null;
function $9f9d8893ee48294d$export$b51733f9a2116765(id, message) {
//#ifdef DEBUG
//#:(!DEBUG) if (_theLogger) {
//#:(!DEBUG)     _theLogger(id, message);
//#:(!DEBUG) }
//#endif
}
function $9f9d8893ee48294d$export$8727038be1f3be06(thePromise, stateFn, resultFn, handledFn) {
    // While the IPromise implementations provide a `state` property, keeping the `[[PromiseState]]`
    // as native promises also have a non-enumerable property of the same name
    $9f9d8893ee48294d$var$_debugState = $9f9d8893ee48294d$var$_debugState || {
        toString: function() {
            return "[[PromiseState]]";
        }
    };
    $9f9d8893ee48294d$var$_debugResult = $9f9d8893ee48294d$var$_debugResult || {
        toString: function() {
            return "[[PromiseResult]]";
        }
    };
    $9f9d8893ee48294d$var$_debugHandled = $9f9d8893ee48294d$var$_debugHandled || {
        toString: function() {
            return "[[PromiseIsHandled]]";
        }
    };
    (0, $d212d948d25f959a$export$8b8fd4dfd45f6b81)(thePromise, $9f9d8893ee48294d$var$_debugState, {
        get: stateFn
    });
    (0, $d212d948d25f959a$export$8b8fd4dfd45f6b81)(thePromise, $9f9d8893ee48294d$var$_debugResult, {
        get: resultFn
    });
    (0, $d212d948d25f959a$export$8b8fd4dfd45f6b81)(thePromise, $9f9d8893ee48294d$var$_debugHandled, {
        get: handledFn
    });
}
function $9f9d8893ee48294d$export$8e8a3d6691d8254(enabled, logger) {
    $9f9d8893ee48294d$export$5b878ab00d3f2b4 = enabled;
    $9f9d8893ee48294d$var$_theLogger = logger;
}


/*
 * @nevware21/ts-async
 * https://github.com/nevware21/ts-async
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */ /**
 * @ignore -- Don't include in the generated documentation
 * @internal
 */ var $896661fc40700b02$export$61c67cf036cd42e2 = [
    "pending",
    "resolving",
    "resolved",
    "rejected"
];


/*
 * @nevware21/ts-async
 * https://github.com/nevware21/ts-async
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */ 
var $62835fabb9e36d10$var$DISPATCH_EVENT = "dispatchEvent";
var $62835fabb9e36d10$var$_hasInitEvent;
function $62835fabb9e36d10$export$e3bf03cc76d2c0a1(target, evtName, populateEvent, useNewEvent) {
    var doc = (0, $3d5fcb60a9467a45$export$f65ca476c09acec0)();
    !$62835fabb9e36d10$var$_hasInitEvent && ($62835fabb9e36d10$var$_hasInitEvent = (0, $f07ca4f3c96b6502$export$c6675fd9042172d2)(function() {
        var evt;
        if (doc && doc.createEvent) evt = doc.createEvent("Event");
        return !!evt && evt.initEvent;
    }, null));
    var theEvt = $62835fabb9e36d10$var$_hasInitEvent.v ? doc.createEvent("Event") : useNewEvent ? new Event(evtName) : {};
    populateEvent && populateEvent(theEvt);
    if ($62835fabb9e36d10$var$_hasInitEvent.v) theEvt.initEvent(evtName, false, true);
    if (theEvt && target[$62835fabb9e36d10$var$DISPATCH_EVENT]) target[$62835fabb9e36d10$var$DISPATCH_EVENT](theEvt);
    else {
        var handler = target["on" + evtName];
        if (handler) handler(theEvt);
        else {
            var theConsole = (0, $3d5fcb60a9467a45$export$3df6e51375017edd)("console");
            theConsole && (theConsole["error"] || theConsole["log"])(evtName, (0, $386f00e3a193a7da$export$21fce7cbd4dc679f)(theEvt));
        }
    }
}


/*
 * @nevware21/ts-async
 * https://github.com/nevware21/ts-async
 *
 * Copyright (c) 2023 Nevware21
 * Licensed under the MIT license.
 */ var $f66d8c7e331f9ecc$export$b50db53b804b62d = "Promise";



var $d9a1248df50a1c7f$var$NODE_UNHANDLED_REJECTION = "unhandledRejection";
var $d9a1248df50a1c7f$var$UNHANDLED_REJECTION = $d9a1248df50a1c7f$var$NODE_UNHANDLED_REJECTION.toLowerCase();
var $d9a1248df50a1c7f$var$_currentPromiseId = [];
var $d9a1248df50a1c7f$var$_uniquePromiseId = 0;
var $d9a1248df50a1c7f$var$_unhandledRejectionTimeout = 10;
var $d9a1248df50a1c7f$var$_hasPromiseRejectionEvent;
function $d9a1248df50a1c7f$var$dumpFnObj(value) {
    if ((0, $533f826bbc418791$export$f6e2535fb5126e54)(value)) return value.toString();
    return (0, $386f00e3a193a7da$export$21fce7cbd4dc679f)(value);
}
function $d9a1248df50a1c7f$export$21e4c442dc33ad2f(newPromise, processor, executor) {
    var additionalArgs = (0, $46728a52dfc641a6$export$1bea104a0e2567f0)(arguments, 3);
    var _state = 0 /* ePromiseState.Pending */ ;
    var _hasResolved = false;
    var _settledValue;
    var _queue = [];
    var _id = $d9a1248df50a1c7f$var$_uniquePromiseId++;
    var _parentId = $d9a1248df50a1c7f$var$_currentPromiseId.length > 0 ? $d9a1248df50a1c7f$var$_currentPromiseId[$d9a1248df50a1c7f$var$_currentPromiseId.length - 1] : undefined;
    var _handled = false;
    var _unHandledRejectionHandler = null;
    var _thePromise;
    !$d9a1248df50a1c7f$var$_hasPromiseRejectionEvent && ($d9a1248df50a1c7f$var$_hasPromiseRejectionEvent = (0, $3d5fcb60a9467a45$export$45fd08e1bc14fe1c)((0, $f66d8c7e331f9ecc$export$b50db53b804b62d) + "RejectionEvent"));
    // https://tc39.es/ecma262/#sec-promise.prototype.then
    var _then = function(onResolved, onRejected) {
        try {
            $d9a1248df50a1c7f$var$_currentPromiseId.push(_id);
            _handled = true;
            _unHandledRejectionHandler && _unHandledRejectionHandler.cancel();
            _unHandledRejectionHandler = null;
            //#ifdef DEBUG
            //#:(!DEBUG) _debugLog(_toString(), "then(" + dumpFnObj(onResolved)+ ", " + dumpFnObj(onResolved) +  ")");
            //#endif
            var thenPromise = newPromise(function(resolve, reject) {
                // Queue the new promise returned to be resolved or rejected
                // when this promise settles.
                _queue.push(function() {
                    // https://tc39.es/ecma262/#sec-newpromisereactionjob
                    //let value: any;
                    try {
                        // First call the onFulfilled or onRejected handler, on the settled value
                        // of this promise. If the corresponding `handler` does not exist, simply
                        // pass through the settled value.
                        //#ifdef DEBUG
                        //#:(!DEBUG) _debugLog(_toString(), "Handling settled value " + dumpFnObj(_settledValue));
                        //#endif
                        var handler = _state === 2 /* ePromiseState.Resolved */  ? onResolved : onRejected;
                        var value = (0, $533f826bbc418791$export$fce6876652108ab)(handler) ? _settledValue : (0, $533f826bbc418791$export$f6e2535fb5126e54)(handler) ? handler(_settledValue) : handler;
                        //#ifdef DEBUG
                        //#:(!DEBUG) _debugLog(_toString(), "Handling Result " + dumpFnObj(value));
                        //#endif
                        if ((0, $533f826bbc418791$export$ae936b9d47e5870e)(value)) // The called handlers returned a new promise, so the chained promise
                        // will follow the state of this promise.
                        value.then(resolve, reject);
                        else if (handler) // If we have a handler then chained promises are always "resolved" with the result returned
                        resolve(value);
                        else if (_state === 3 /* ePromiseState.Rejected */ ) // If this promise is rejected then the chained promise should be rejected
                        // with either the settled value of this promise or the return value of the handler.
                        reject(value);
                        else // If this promise is fulfilled, then the chained promise is also fulfilled
                        // with either the settled value of this promise or the return value of the handler.
                        resolve(value);
                    } catch (e) {
                        reject(e);
                    }
                });
                //#ifdef DEBUG
                //#:(!DEBUG) _debugLog(_toString(), "Added to Queue " + _queue.length);
                //#endif
                // If this promise is already settled, then immediately process the callback we
                // just added to the queue.
                if (_hasResolved) _processQueue();
            }, additionalArgs);
            //#ifdef DEBUG
            //#:(!DEBUG) _debugLog(_toString(), "Created -> " + thenPromise.toString());
            //#endif
            return thenPromise;
        } finally{
            $d9a1248df50a1c7f$var$_currentPromiseId.pop();
        }
    };
    // https://tc39.es/ecma262/#sec-promise.prototype.catch
    var _catch = function(onRejected) {
        // Reuse then onRejected to support rejection
        return _then(undefined, onRejected);
    };
    // https://tc39.es/ecma262/#sec-promise.prototype.finally
    var _finally = function(onFinally) {
        var thenFinally = onFinally;
        var catchFinally = onFinally;
        if ((0, $533f826bbc418791$export$f6e2535fb5126e54)(onFinally)) {
            thenFinally = function(value) {
                onFinally && onFinally();
                return value;
            };
            catchFinally = function(reason) {
                onFinally && onFinally();
                throw reason;
            };
        }
        return _then(thenFinally, catchFinally);
    };
    var _strState = function() {
        return (0, $896661fc40700b02$export$61c67cf036cd42e2)[_state];
    };
    var _processQueue = function() {
        if (_queue.length > 0) {
            // The onFulfilled and onRejected handlers must be called asynchronously. Thus,
            // we make a copy of the queue and work on it once the current call stack unwinds.
            var pending = _queue.slice();
            _queue = [];
            //#ifdef DEBUG
            //#:(!DEBUG) _debugLog(_toString(), "Processing queue " + pending.length);
            //#endif
            _handled = true;
            processor(pending);
            //#ifdef DEBUG
            //#:(!DEBUG) _debugLog(_toString(), "Processing done");
            //#endif
            _unHandledRejectionHandler && _unHandledRejectionHandler.cancel();
            _unHandledRejectionHandler = null;
        }
    };
    var _createSettleIfFn = function(newState, allowState) {
        return function(theValue) {
            if (_state === allowState) {
                if (newState === 2 /* ePromiseState.Resolved */  && (0, $533f826bbc418791$export$ae936b9d47e5870e)(theValue)) {
                    _state = 1 /* ePromiseState.Resolving */ ;
                    //#ifdef DEBUG
                    //#:(!DEBUG) _debugLog(_toString(), "Resolving");
                    //#endif
                    theValue.then(_createSettleIfFn(2 /* ePromiseState.Resolved */ , 1 /* ePromiseState.Resolving */ ), _createSettleIfFn(3 /* ePromiseState.Rejected */ , 1 /* ePromiseState.Resolving */ ));
                    return;
                }
                _state = newState;
                _hasResolved = true;
                _settledValue = theValue;
                //#ifdef DEBUG
                //#:(!DEBUG) _debugLog(_toString(), _strState());
                //#endif
                _processQueue();
                if (!_handled && newState === 3 /* ePromiseState.Rejected */  && !_unHandledRejectionHandler) _unHandledRejectionHandler = (0, $d03b12effd00bf96$export$5f4d6617421d489b)(_notifyUnhandledRejection, $d9a1248df50a1c7f$var$_unhandledRejectionTimeout);
            }
        };
    };
    var _notifyUnhandledRejection = function() {
        if (!_handled) {
            if ((0, $3d5fcb60a9467a45$export$8ee0fc9ee280b4ee)()) //#ifdef DEBUG
            //#:(!DEBUG) _debugLog(_toString(), "Emitting " + NODE_UNHANDLED_REJECTION);
            //#endif
            $b364f2cd2faf3e98$exports.emit($d9a1248df50a1c7f$var$NODE_UNHANDLED_REJECTION, _settledValue, _thePromise);
            else {
                var gbl = (0, $3d5fcb60a9467a45$export$38b2d434cce3ea22)() || (0, $3d5fcb60a9467a45$export$a4e55266d2135a7f)();
                //#ifdef DEBUG
                //#:(!DEBUG) _debugLog(_toString(), "Emitting " + UNHANDLED_REJECTION);
                //#endif
                (0, $62835fabb9e36d10$export$e3bf03cc76d2c0a1)(gbl, $d9a1248df50a1c7f$var$UNHANDLED_REJECTION, function(theEvt) {
                    (0, $d212d948d25f959a$export$d0d2ebf910ad6e2)(theEvt, "promise", {
                        g: function() {
                            return _thePromise;
                        }
                    });
                    theEvt.reason = _settledValue;
                    return theEvt;
                }, !!$d9a1248df50a1c7f$var$_hasPromiseRejectionEvent.v);
            }
        }
    };
    _thePromise = {
        then: _then,
        "catch": _catch,
        finally: _finally
    };
    (0, $d212d948d25f959a$export$8b8fd4dfd45f6b81)(_thePromise, "state", {
        get: _strState
    });
    if (0, $9f9d8893ee48294d$export$5b878ab00d3f2b4) // eslint-disable-next-line brace-style
    (0, $9f9d8893ee48294d$export$8727038be1f3be06)(_thePromise, _strState, function() {
        return (0, $533f826bbc418791$export$3cbb80dec8953997)(_settledValue);
    }, function() {
        return _handled;
    });
    if ((0, $3ab078397ef07bc3$export$1e6e45ea4c3f892c)()) _thePromise[(0, $3ab078397ef07bc3$export$3a9aefdadea26115)(11 /* WellKnownSymbols.toStringTag */ )] = "IPromise";
    var _toString = function() {
        return "IPromise" + ((0, $9f9d8893ee48294d$export$5b878ab00d3f2b4) ? "[" + _id + (!(0, $533f826bbc418791$export$fce6876652108ab)(_parentId) ? ":" + _parentId : "") + "]" : "") + " " + _strState() + (_hasResolved ? " - " + $d9a1248df50a1c7f$var$dumpFnObj(_settledValue) : "");
    };
    _thePromise.toString = _toString;
    (function _initialize() {
        if (!(0, $533f826bbc418791$export$f6e2535fb5126e54)(executor)) (0, $44a1c24c0e411039$export$3f7738bd7dcba681)((0, $f66d8c7e331f9ecc$export$b50db53b804b62d) + ": executor is not a function - " + $d9a1248df50a1c7f$var$dumpFnObj(executor));
        var _rejectFn = _createSettleIfFn(3 /* ePromiseState.Rejected */ , 0 /* ePromiseState.Pending */ );
        try {
            //#ifdef DEBUG
            //#:(!DEBUG) _debugLog(_toString(), "Executing");
            //#endif
            executor.call(_thePromise, _createSettleIfFn(2 /* ePromiseState.Resolved */ , 0 /* ePromiseState.Pending */ ), _rejectFn);
        } catch (e) {
            _rejectFn(e);
        }
    })();
    //#ifdef DEBUG
    //#:(!DEBUG) _debugLog(_toString(), "Returning");
    //#endif
    return _thePromise;
}
function $d9a1248df50a1c7f$export$2e2d787d49b332bf(newPromise) {
    return function(input) {
        var additionalArgs = (0, $46728a52dfc641a6$export$1bea104a0e2567f0)(arguments, 1);
        return newPromise(function(resolve, reject) {
            try {
                var values_1 = [];
                var pending_1 = 1; // Prefix to 1 so we finish iterating over all of the input promises first
                (0, $f6bb085f8cf12216$export$e2e5bcdbdc49c586)(input, function(item, idx) {
                    if (item) {
                        pending_1++;
                        (0, $a99c2448b4d73401$export$96acbd3e4fcaef01)(item, function(value) {
                            // Set the result values
                            values_1[idx] = value;
                            if (--pending_1 === 0) resolve(values_1);
                        }, reject);
                    }
                });
                // Now decrement the pending so that we finish correctly
                pending_1--;
                if (pending_1 === 0) // All promises were either resolved or where not a promise
                resolve(values_1);
            } catch (e) {
                reject(e);
            }
        }, additionalArgs);
    };
}
function $d9a1248df50a1c7f$export$4ea99934313e7d98(newPromise) {
    return function(value) {
        var additionalArgs = (0, $46728a52dfc641a6$export$1bea104a0e2567f0)(arguments, 1);
        if ((0, $533f826bbc418791$export$ae936b9d47e5870e)(value)) return value;
        return newPromise(function(resolve) {
            resolve(value);
        }, additionalArgs);
    };
}
function $d9a1248df50a1c7f$export$71a67f20b06fc70e(newPromise) {
    return function(reason) {
        var additionalArgs = (0, $46728a52dfc641a6$export$1bea104a0e2567f0)(arguments, 1);
        return newPromise(function(_resolve, reject) {
            reject(reason);
        }, additionalArgs);
    };
}


/*
 * @nevware21/ts-async
 * https://github.com/nevware21/ts-async
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */ /*
 * @nevware21/ts-async
 * https://github.com/nevware21/ts-async
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */ 
/*
 * @nevware21/ts-async
 * https://github.com/nevware21/ts-async
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */ /*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */ 




var $657fe58c1330d658$var$_hasIdleCallback;
var $657fe58c1330d658$var$_defaultIdleTimeout = 100;
var $657fe58c1330d658$var$_maxExecutionTime = 50;
function $657fe58c1330d658$export$b9301f2c5b7c2533() {
    !$657fe58c1330d658$var$_hasIdleCallback && ($657fe58c1330d658$var$_hasIdleCallback = (0, $f07ca4f3c96b6502$export$c6675fd9042172d2)(function() {
        return (0, $533f826bbc418791$export$4e62c701997796c1)(requestIdleCallback);
    }, false));
    return !!($657fe58c1330d658$var$_hasIdleCallback.v ? requestIdleCallback : false);
}
function $657fe58c1330d658$export$b588248e012cdf5c(timeout) {
    $657fe58c1330d658$var$_defaultIdleTimeout = timeout;
}
function $657fe58c1330d658$export$b062c6607588fb47(maxTime) {
    $657fe58c1330d658$var$_maxExecutionTime = maxTime;
}
function $657fe58c1330d658$export$553e359f3bef3995(callback, options) {
    function _createDeadline(timedOut) {
        var startTime = (0, $824d7bc9d9e48f68$export$ba2b1ec760f018ed)();
        return {
            didTimeout: timedOut,
            timeRemaining: function() {
                return $657fe58c1330d658$var$_maxExecutionTime - (0, $824d7bc9d9e48f68$export$1ea91570c695dfb2)(startTime);
            }
        };
    }
    if ($657fe58c1330d658$export$b9301f2c5b7c2533()) {
        var handler_1 = (0, $de882ae8157e9b9b$export$bf688d278153f393)(true, function(idleId) {
            idleId && cancelIdleCallback(idleId);
            return requestIdleCallback(function(deadline) {
                handler_1.dn();
                callback(deadline || _createDeadline(false));
            }, options);
        }, function(idleId) {
            cancelIdleCallback(idleId);
        });
        return handler_1.h;
    }
    var timeout = (options || {}).timeout;
    if ((0, $533f826bbc418791$export$fce6876652108ab)(timeout)) timeout = $657fe58c1330d658$var$_defaultIdleTimeout;
    return (0, $d03b12effd00bf96$export$5f4d6617421d489b)(function() {
        callback(_createDeadline(true));
    }, timeout);
}


var $f5e6aa96df7c2079$var$_processPendingItems = function(pending) {
    (0, $f6bb085f8cf12216$export$e2e5bcdbdc49c586)(pending, function(fn) {
        try {
            fn();
        } catch (e) {
        // Don't let 1 failing handler break all others
        // TODO: Add some form of error reporting (i.e. Call any registered JS error handler so the error is reported)
        }
    });
};
function $f5e6aa96df7c2079$export$b1d1b246da82fff7() {
    return $f5e6aa96df7c2079$var$_processPendingItems;
}
function $f5e6aa96df7c2079$export$96972de3caafb39c(timeout) {
    var callbackTimeout = (0, $533f826bbc418791$export$7e4aa119212bc614)(timeout) ? timeout : 0;
    return function(pending) {
        (0, $d03b12effd00bf96$export$5f4d6617421d489b)(function() {
            $f5e6aa96df7c2079$var$_processPendingItems(pending);
        }, callbackTimeout);
    };
}
function $f5e6aa96df7c2079$export$c55fbffc6a3672ed(timeout) {
    var options;
    if (timeout >= 0) options = {
        timeout: +timeout
    };
    return function(pending) {
        (0, $657fe58c1330d658$export$553e359f3bef3995)(function(deadline) {
            $f5e6aa96df7c2079$var$_processPendingItems(pending);
        }, options);
    };
}


function $635d6d63c46ba6e7$export$74d26603c0c38da8(executor, timeout) {
    return (0, $d9a1248df50a1c7f$export$21e4c442dc33ad2f)($635d6d63c46ba6e7$export$74d26603c0c38da8, (0, $f5e6aa96df7c2079$export$96972de3caafb39c)(timeout), executor, timeout);
}
var $635d6d63c46ba6e7$export$1735e21d720f8bc0 = (0, $d9a1248df50a1c7f$export$2e2d787d49b332bf)($635d6d63c46ba6e7$export$74d26603c0c38da8);
var $635d6d63c46ba6e7$export$f2163a387efd1843 = (0, $d9a1248df50a1c7f$export$4ea99934313e7d98)($635d6d63c46ba6e7$export$74d26603c0c38da8);
var $635d6d63c46ba6e7$export$adb3940d4617f918 = (0, $d9a1248df50a1c7f$export$71a67f20b06fc70e)($635d6d63c46ba6e7$export$74d26603c0c38da8);






var $4ec0308f22f7433a$var$_isPromiseSupported;
function $4ec0308f22f7433a$export$7edeaca5327f34ec(executor, timeout) {
    !$4ec0308f22f7433a$var$_isPromiseSupported && ($4ec0308f22f7433a$var$_isPromiseSupported = (0, $3d5fcb60a9467a45$export$45fd08e1bc14fe1c)((0, $f66d8c7e331f9ecc$export$b50db53b804b62d)));
    var PrmCls = $4ec0308f22f7433a$var$_isPromiseSupported.v;
    if (!PrmCls) return (0, $635d6d63c46ba6e7$export$74d26603c0c38da8)(executor);
    if (!(0, $533f826bbc418791$export$f6e2535fb5126e54)(executor)) (0, $44a1c24c0e411039$export$3f7738bd7dcba681)((0, $f66d8c7e331f9ecc$export$b50db53b804b62d) + ": executor is not a function - " + (0, $386f00e3a193a7da$export$21fce7cbd4dc679f)(executor));
    var _state = 0 /* ePromiseState.Pending */ ;
    function _strState() {
        return (0, $896661fc40700b02$export$61c67cf036cd42e2)[_state];
    }
    var thePromise = new PrmCls(function(resolve, reject) {
        function _resolve(value) {
            _state = 2 /* ePromiseState.Resolved */ ;
            resolve(value);
        }
        function _reject(reason) {
            _state = 3 /* ePromiseState.Rejected */ ;
            reject(reason);
        }
        executor(_resolve, _reject);
    });
    (0, $d212d948d25f959a$export$8b8fd4dfd45f6b81)(thePromise, "state", {
        get: _strState
    });
    return thePromise;
}
var $4ec0308f22f7433a$export$9eb857118f5fb9d3 = (0, $d9a1248df50a1c7f$export$2e2d787d49b332bf)($4ec0308f22f7433a$export$7edeaca5327f34ec);
var $4ec0308f22f7433a$export$c6f7d656137b22c7 = (0, $d9a1248df50a1c7f$export$4ea99934313e7d98)($4ec0308f22f7433a$export$7edeaca5327f34ec);
var $4ec0308f22f7433a$export$ff6e17a8cb47ba93 = (0, $d9a1248df50a1c7f$export$71a67f20b06fc70e)($4ec0308f22f7433a$export$7edeaca5327f34ec);


var $911d39c591a62618$var$_promiseCreator;
function $911d39c591a62618$export$c6c514c2f7329b79(creator) {
    $911d39c591a62618$var$_promiseCreator = creator ? (0, $d8ec17546a34ef88$export$db98eae15987454c)(function() {
        return creator;
    }) : null;
}
function $911d39c591a62618$export$5a1eb20c68656e88(executor, timeout) {
    !$911d39c591a62618$var$_promiseCreator && ($911d39c591a62618$var$_promiseCreator = (0, $d8ec17546a34ef88$export$db98eae15987454c)(function() {
        return 0, $4ec0308f22f7433a$export$7edeaca5327f34ec;
    }));
    return $911d39c591a62618$var$_promiseCreator.v.call(this, executor, timeout);
}
var $911d39c591a62618$export$1ed2fd8fe9f5c6 = (0, $d9a1248df50a1c7f$export$2e2d787d49b332bf)($911d39c591a62618$export$5a1eb20c68656e88);
var $911d39c591a62618$export$c6056e052f93dbce = (0, $d9a1248df50a1c7f$export$4ea99934313e7d98)($911d39c591a62618$export$5a1eb20c68656e88);
var $911d39c591a62618$export$d22877ef6074ba31 = (0, $d9a1248df50a1c7f$export$71a67f20b06fc70e)($911d39c591a62618$export$5a1eb20c68656e88);


/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */ 

var $d70982046c7dc734$export$f0d11c074a923179 = (0, $d491d25af4ac425c$export$b9deaf03e58c2bf5)((0, $b347daff6f5f8dc1$export$5f32d5745d700b0e));



function $2cb93c1cbddb67ab$export$86347c3dd68c03f6(target, isAsync) {
    if (target && target[0, $1ae5573ce493bccc$export$7eb85b5cba77a43d /* @min:%2eunload */ ]) return target[0, $1ae5573ce493bccc$export$7eb85b5cba77a43d /* @min:%2eunload */ ](isAsync);
}
function $2cb93c1cbddb67ab$export$bc81824d13c51ef3(targets, isAsync, done) {
    var result;
    if (!done) result = (0, $911d39c591a62618$export$5a1eb20c68656e88)(function(resolved) {
        done = resolved;
    });
    if (targets && (0, $d70982046c7dc734$export$f0d11c074a923179)(targets) > 0) (0, $a99c2448b4d73401$export$856fe465480fa77a)($2cb93c1cbddb67ab$export$86347c3dd68c03f6(targets[0], isAsync), function() {
        $2cb93c1cbddb67ab$export$bc81824d13c51ef3((0, $46728a52dfc641a6$export$1bea104a0e2567f0)(targets, 1), isAsync, done);
    });
    else done();
    return result;
}




/*
 * Application Insights JavaScript SDK - Channel, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 


/*
 * Application Insights JavaScript SDK - Channel, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // ###################################################################################################################################################
// Note: DON'T Export these const from the package as we are still targeting IE/ES5 this will export a mutable variables that someone could change ###
// ###################################################################################################################################################
// Generally you should only put values that are used more than 2 times and then only if not already exposed as a constant (such as SdkCoreNames)
// as when using "short" named values from here they will be will be minified smaller than the SdkCoreNames[eSdkCoreNames.xxxx] value.
var $c0ca326fc9479ec0$export$be41298b7716c698 = "duration";


/*
 * Application Insights JavaScript SDK - Channel, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var $e5f8715adea0dc31$export$d0f526aa8043f6d7 = "tags"; // Count: 17
var $e5f8715adea0dc31$export$f393dda3e1c87f59 = "deviceType"; // Count: 3
var $e5f8715adea0dc31$export$2f5ff0b46814907e = "data"; // Count: 13
var $e5f8715adea0dc31$export$9734b0a24bf02e93 = "name"; // Count: 8
var $e5f8715adea0dc31$export$a5eb52c53bba8560 = "traceID"; // Count: 5
var $e5f8715adea0dc31$export$6eae51590aaea43 = "length"; // Count: 36
var $e5f8715adea0dc31$export$a318a8141fc98747 = "stringify"; // Count: 5
var $e5f8715adea0dc31$export$32fc64677eb5b7a2 = "measurements"; // Count: 7
var $e5f8715adea0dc31$export$9e16762ab4f2648 = "dataType"; // Count: 10
var $e5f8715adea0dc31$export$2672d4f7ccc80348 = "envelopeType"; // Count: 7
var $e5f8715adea0dc31$export$e2818d11505fa034 = "toString"; // Count: 7
var $e5f8715adea0dc31$export$a9130fdcd11ec7ef = "onLine"; // Count: 4
var $e5f8715adea0dc31$export$704cf8098f85ad0f = "isOnline"; // Count: 3
var $e5f8715adea0dc31$export$7768b9624b4c70a6 = "_get"; // Count: 5
var $e5f8715adea0dc31$export$4aae77f3ba3c48b4 = "enqueue"; // Count: 7
var $e5f8715adea0dc31$export$e9679ef501b0d1 = "count"; // Count: 6
var $e5f8715adea0dc31$export$c8dd872dc774fa7c = "eventsLimitInMem"; // Count: 2
var $e5f8715adea0dc31$export$a0a330e7fa1e278c = "push"; // Count: 6
var $e5f8715adea0dc31$export$b18aabdfc0aaf6b = "emitLineDelimitedJson"; // Count: 3
var $e5f8715adea0dc31$export$5eeb73fac03da74a = "clear"; // Count: 7
var $e5f8715adea0dc31$export$a5da323a4da829fc = "batchPayloads"; // Count: 5
var $e5f8715adea0dc31$export$1e6514b499ba4d34 = "createNew"; // Count: 3
var $e5f8715adea0dc31$export$52e50651d87300e3 = "markAsSent"; // Count: 7
var $e5f8715adea0dc31$export$13da1b5a005ef035 = "clearSent"; // Count: 5
var $e5f8715adea0dc31$export$4637bcb72c509e60 = "bufferOverride"; // Count: 3
var $e5f8715adea0dc31$export$63ab2dad6d8a60ed = "BUFFER_KEY"; // Count: 5
var $e5f8715adea0dc31$export$d03f333763905c89 = "SENT_BUFFER_KEY"; // Count: 8
var $e5f8715adea0dc31$export$20d3a25105cda3b1 = "MAX_BUFFER_SIZE"; // Count: 5
var $e5f8715adea0dc31$export$df21ab0de9057cc4 = "triggerSend"; // Count: 5
var $e5f8715adea0dc31$export$c7ff2c36e5c78421 = "diagLog"; // Count: 16
var $e5f8715adea0dc31$export$e5390b88ba6f1b04 = "_sender"; // Count: 5
var $e5f8715adea0dc31$export$dbe59923e879fdc5 = "customHeaders"; // Count: 3
var $e5f8715adea0dc31$export$803d432e48ba5ceb = "maxBatchSizeInBytes"; // Count: 2
var $e5f8715adea0dc31$export$6b8e1dc9b77f253c = "onunloadDisableBeacon"; // Count: 2
var $e5f8715adea0dc31$export$f5629284a6f7ec3d = "isBeaconApiDisabled"; // Count: 3
var $e5f8715adea0dc31$export$782dd40ba58c3597 = "enableSessionStorageBuffer"; // Count: 2
var $e5f8715adea0dc31$export$3f8a6394c5f7e7be = "_buffer"; // Count: 11
var $e5f8715adea0dc31$export$81cfd43387c8dbcc = "instrumentationKey"; // Count: 2
var $e5f8715adea0dc31$export$85f018eb7798fb52 = "disableXhr"; // Count: 5
var $e5f8715adea0dc31$export$d1f891e9714d3108 = "onunloadDisableFetch"; // Count: 2
var $e5f8715adea0dc31$export$12df46deb7379c67 = "convertUndefined"; // Count: 2
var $e5f8715adea0dc31$export$983774f06380e463 = "maxBatchInterval"; // Count: 2
var $e5f8715adea0dc31$export$aa558e99f83347cf = "baseType"; // Count: 4
var $e5f8715adea0dc31$export$c2afe23fa18f9dff = "sampleRate"; // Count: 4
var $e5f8715adea0dc31$export$9b55da9813cf231b = "_xhrReadyStateChange"; // Count: 2
var $e5f8715adea0dc31$export$fd0c91d4da43d71b = "_onError"; // Count: 11
var $e5f8715adea0dc31$export$689c49d56ac33585 = "_onPartialSuccess"; // Count: 3
var $e5f8715adea0dc31$export$82a109ffee49e423 = "_onSuccess"; // Count: 6
var $e5f8715adea0dc31$export$fb8523c8667e286a = "itemsAccepted"; // Count: 5
var $e5f8715adea0dc31$export$746df81af2cb9d94 = "itemsReceived"; // Count: 6
var $e5f8715adea0dc31$export$84ecd29f369f5b1d = "setRequestHeader"; // Count: 3
var $e5f8715adea0dc31$export$298b8388870fcfe9 = "eventsSendRequest"; // Count: 2
var $e5f8715adea0dc31$export$2c3af30a5c45aa6e = "getSamplingScore"; // Count: 2
var $e5f8715adea0dc31$export$d676f8c50f371355 = "getHashCodeScore"; // Count: 4


// these two constants are used to filter out properties not needed when trying to extract custom properties and measurements from the incoming payload
var $0b044846db0c77e8$var$strBaseType = "baseType";
var $0b044846db0c77e8$var$strBaseData = "baseData";
var $0b044846db0c77e8$var$strProperties = "properties";
var $0b044846db0c77e8$var$strTrue = "true";
function $0b044846db0c77e8$var$_setValueIf(target, field, value) {
    return (0, $0b747974b0bb3563$export$80746c6bc6142fc8)(target, field, value, (0, $533f826bbc418791$export$8f9cae6546f97a9f));
}
/*
 * Maps Part A data from CS 4.0
 */ function $0b044846db0c77e8$var$_extractPartAExtensions(logger, item, env) {
    // todo: switch to keys from common in this method
    var envTags = env[0, $e5f8715adea0dc31$export$d0f526aa8043f6d7 /* @min:%2etags */ ] = env[0, $e5f8715adea0dc31$export$d0f526aa8043f6d7 /* @min:%2etags */ ] || {};
    var itmExt = item.ext = item.ext || {};
    var itmTags = item[0, $e5f8715adea0dc31$export$d0f526aa8043f6d7 /* @min:%2etags */ ] = item[0, $e5f8715adea0dc31$export$d0f526aa8043f6d7 /* @min:%2etags */ ] || [];
    var extUser = itmExt.user;
    if (extUser) {
        $0b044846db0c77e8$var$_setValueIf(envTags, (0, $1185376df44832bd$export$ebc7727f2a4272f6).userAuthUserId, extUser.authId);
        $0b044846db0c77e8$var$_setValueIf(envTags, (0, $1185376df44832bd$export$ebc7727f2a4272f6).userId, extUser.id || extUser.localId);
    }
    var extApp = itmExt.app;
    if (extApp) $0b044846db0c77e8$var$_setValueIf(envTags, (0, $1185376df44832bd$export$ebc7727f2a4272f6).sessionId, extApp.sesId);
    var extDevice = itmExt.device;
    if (extDevice) {
        $0b044846db0c77e8$var$_setValueIf(envTags, (0, $1185376df44832bd$export$ebc7727f2a4272f6).deviceId, extDevice.id || extDevice.localId);
        $0b044846db0c77e8$var$_setValueIf(envTags, (0, $1185376df44832bd$export$ebc7727f2a4272f6)[0, $e5f8715adea0dc31$export$f393dda3e1c87f59 /* @min:%2edeviceType */ ], extDevice.deviceClass);
        $0b044846db0c77e8$var$_setValueIf(envTags, (0, $1185376df44832bd$export$ebc7727f2a4272f6).deviceIp, extDevice.ip);
        $0b044846db0c77e8$var$_setValueIf(envTags, (0, $1185376df44832bd$export$ebc7727f2a4272f6).deviceModel, extDevice.model);
        $0b044846db0c77e8$var$_setValueIf(envTags, (0, $1185376df44832bd$export$ebc7727f2a4272f6)[0, $e5f8715adea0dc31$export$f393dda3e1c87f59 /* @min:%2edeviceType */ ], extDevice[0, $e5f8715adea0dc31$export$f393dda3e1c87f59 /* @min:%2edeviceType */ ]);
    }
    var web = item.ext.web;
    if (web) {
        $0b044846db0c77e8$var$_setValueIf(envTags, (0, $1185376df44832bd$export$ebc7727f2a4272f6).deviceLanguage, web.browserLang);
        $0b044846db0c77e8$var$_setValueIf(envTags, (0, $1185376df44832bd$export$ebc7727f2a4272f6).deviceBrowserVersion, web.browserVer);
        $0b044846db0c77e8$var$_setValueIf(envTags, (0, $1185376df44832bd$export$ebc7727f2a4272f6).deviceBrowser, web.browser);
        var envData = env[0, $e5f8715adea0dc31$export$2f5ff0b46814907e /* @min:%2edata */ ] = env[0, $e5f8715adea0dc31$export$2f5ff0b46814907e /* @min:%2edata */ ] || {};
        var envBaseData = envData[$0b044846db0c77e8$var$strBaseData] = envData[$0b044846db0c77e8$var$strBaseData] || {};
        var envProps = envBaseData[$0b044846db0c77e8$var$strProperties] = envBaseData[$0b044846db0c77e8$var$strProperties] || {};
        $0b044846db0c77e8$var$_setValueIf(envProps, "domain", web.domain);
        $0b044846db0c77e8$var$_setValueIf(envProps, "isManual", web.isManual ? $0b044846db0c77e8$var$strTrue : null);
        $0b044846db0c77e8$var$_setValueIf(envProps, "screenRes", web.screenRes);
        $0b044846db0c77e8$var$_setValueIf(envProps, "userConsent", web.userConsent ? $0b044846db0c77e8$var$strTrue : null);
    }
    var extOs = itmExt.os;
    if (extOs) $0b044846db0c77e8$var$_setValueIf(envTags, (0, $1185376df44832bd$export$ebc7727f2a4272f6).deviceOS, extOs[0, $e5f8715adea0dc31$export$9734b0a24bf02e93 /* @min:%2ename */ ]);
    // No support for mapping Trace.traceState to 2.0 as it is currently empty
    var extTrace = itmExt.trace;
    if (extTrace) {
        $0b044846db0c77e8$var$_setValueIf(envTags, (0, $1185376df44832bd$export$ebc7727f2a4272f6).operationParentId, extTrace.parentID);
        $0b044846db0c77e8$var$_setValueIf(envTags, (0, $1185376df44832bd$export$ebc7727f2a4272f6).operationName, (0, $8c3059962bb1d83c$export$4e25b1d4bcd67eb8)(logger, extTrace[0, $e5f8715adea0dc31$export$9734b0a24bf02e93 /* @min:%2ename */ ]));
        $0b044846db0c77e8$var$_setValueIf(envTags, (0, $1185376df44832bd$export$ebc7727f2a4272f6).operationId, extTrace[0, $e5f8715adea0dc31$export$a5eb52c53bba8560 /* @min:%2etraceID */ ]);
    }
    // Sample 4.0 schema
    //  {
    //     "time" : "2018-09-05T22:51:22.4936Z",
    //     "name" : "MetricWithNamespace",
    //     "iKey" : "ABC-5a4cbd20-e601-4ef5-a3c6-5d6577e4398e",
    //     "ext": {  "cloud": {
    //          "role": "WATSON3",
    //          "roleInstance": "CO4AEAP00000260"
    //      },
    //      "device": {}, "correlation": {} },
    //      "tags": [
    //        { "amazon.region" : "east2" },
    //        { "os.expid" : "wp:02df239" }
    //     ]
    //   }
    var tgs = {};
    // deals with tags.push({object})
    for(var i = itmTags[0, $e5f8715adea0dc31$export$6eae51590aaea43 /* @min:%2elength */ ] - 1; i >= 0; i--){
        var tg = itmTags[i];
        (0, $45e528077703ac0c$export$aa0705d5774c95d1)(tg, function(key, value) {
            tgs[key] = value;
        });
        itmTags.splice(i, 1);
    }
    // deals with tags[key]=value (and handles hasOwnProperty)
    (0, $45e528077703ac0c$export$aa0705d5774c95d1)(itmTags, function(tg, value) {
        tgs[tg] = value;
    });
    var theTags = (0, $2a74b38b87b38cda$export$b3cf7a802e578501)((0, $2a74b38b87b38cda$export$b3cf7a802e578501)({}, envTags), tgs);
    if (!theTags[(0, $1185376df44832bd$export$ebc7727f2a4272f6).internalSdkVersion]) // Append a version in case it is not already set
    theTags[(0, $1185376df44832bd$export$ebc7727f2a4272f6).internalSdkVersion] = (0, $8c3059962bb1d83c$export$4e25b1d4bcd67eb8)(logger, "javascript:".concat($0b044846db0c77e8$export$3f11c9a3e644970c.Version), 64);
    env[0, $e5f8715adea0dc31$export$d0f526aa8043f6d7 /* @min:%2etags */ ] = (0, $0b747974b0bb3563$export$3e03fa3fc3e422d7)(theTags);
}
function $0b044846db0c77e8$var$_extractPropsAndMeasurements(data, properties, measurements) {
    if (!(0, $533f826bbc418791$export$bedb7023a7733221)(data)) (0, $45e528077703ac0c$export$aa0705d5774c95d1)(data, function(key, value) {
        if ((0, $533f826bbc418791$export$7e4aa119212bc614)(value)) measurements[key] = value;
        else if ((0, $533f826bbc418791$export$844ec244b1367d54)(value)) properties[key] = value;
        else if ((0, $0c599844349363c4$export$a2856ab6913b9fff)()) properties[key] = (0, $0c599844349363c4$export$d047a7c56db64af4)()[0, $e5f8715adea0dc31$export$a318a8141fc98747 /* @min:%2estringify */ ](value);
    });
}
function $0b044846db0c77e8$var$_convertPropsUndefinedToCustomDefinedValue(properties, customUndefinedValue) {
    if (!(0, $533f826bbc418791$export$bedb7023a7733221)(properties)) (0, $45e528077703ac0c$export$aa0705d5774c95d1)(properties, function(key, value) {
        properties[key] = value || customUndefinedValue;
    });
}
// TODO: Do we want this to take logger as arg or use this._logger as nonstatic?
function $0b044846db0c77e8$var$_createEnvelope(logger, envelopeType, telemetryItem, data) {
    var envelope = new (0, $a383874e4b463649$export$4e2d65a9843399df)(logger, data, envelopeType);
    $0b044846db0c77e8$var$_setValueIf(envelope, "sampleRate", telemetryItem[0, $71dfba5ea0640485$export$dc288b6444e20c04]);
    if ((telemetryItem[$0b044846db0c77e8$var$strBaseData] || {}).startTime) envelope.time = (0, $0b747974b0bb3563$export$dfaaa8705752128f)(telemetryItem[$0b044846db0c77e8$var$strBaseData].startTime);
    envelope.iKey = telemetryItem.iKey;
    var iKeyNoDashes = telemetryItem.iKey.replace(/-/g, "");
    envelope[0, $e5f8715adea0dc31$export$9734b0a24bf02e93 /* @min:%2ename */ ] = envelope[0, $e5f8715adea0dc31$export$9734b0a24bf02e93 /* @min:%2ename */ ].replace("{0}", iKeyNoDashes);
    // extract all extensions from ctx
    $0b044846db0c77e8$var$_extractPartAExtensions(logger, telemetryItem, envelope);
    // loop through the envelope tags (extension of Part A) and pick out the ones that should go in outgoing envelope tags
    telemetryItem[0, $e5f8715adea0dc31$export$d0f526aa8043f6d7 /* @min:%2etags */ ] = telemetryItem[0, $e5f8715adea0dc31$export$d0f526aa8043f6d7 /* @min:%2etags */ ] || [];
    return (0, $0b747974b0bb3563$export$3e03fa3fc3e422d7)(envelope);
}
function $0b044846db0c77e8$var$EnvelopeCreatorInit(logger, telemetryItem) {
    if ((0, $533f826bbc418791$export$bedb7023a7733221)(telemetryItem[$0b044846db0c77e8$var$strBaseData])) (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(logger, 1 /* eLoggingSeverity.CRITICAL */ , 46 /* _eInternalMessageId.TelemetryEnvelopeInvalid */ , "telemetryItem.baseData cannot be null.");
}
var $0b044846db0c77e8$export$3f11c9a3e644970c = {
    Version: "3.0.2"
};
function $0b044846db0c77e8$export$74e603a08a7deabe(logger, telemetryItem, customUndefinedValue) {
    $0b044846db0c77e8$var$EnvelopeCreatorInit(logger, telemetryItem);
    var customMeasurements = telemetryItem[$0b044846db0c77e8$var$strBaseData][0, $e5f8715adea0dc31$export$32fc64677eb5b7a2 /* @min:%2emeasurements */ ] || {};
    var customProperties = telemetryItem[$0b044846db0c77e8$var$strBaseData][$0b044846db0c77e8$var$strProperties] || {};
    $0b044846db0c77e8$var$_extractPropsAndMeasurements(telemetryItem[0, $e5f8715adea0dc31$export$2f5ff0b46814907e /* @min:%2edata */ ], customProperties, customMeasurements);
    if (!(0, $533f826bbc418791$export$bedb7023a7733221)(customUndefinedValue)) $0b044846db0c77e8$var$_convertPropsUndefinedToCustomDefinedValue(customProperties, customUndefinedValue);
    var bd = telemetryItem[$0b044846db0c77e8$var$strBaseData];
    if ((0, $533f826bbc418791$export$bedb7023a7733221)(bd)) {
        (0, $cc2aaaebf96ac6a7$export$25fb4cb97863f0a8)(logger, "Invalid input for dependency data");
        return null;
    }
    var method = bd[$0b044846db0c77e8$var$strProperties] && bd[$0b044846db0c77e8$var$strProperties][0, $71dfba5ea0640485$export$8343e6f32f5246de] ? bd[$0b044846db0c77e8$var$strProperties][0, $71dfba5ea0640485$export$8343e6f32f5246de] : "GET";
    var remoteDepData = new (0, $0dd1de134f090c69$export$a7b48490930dbffa)(logger, bd.id, bd.target, bd[0, $e5f8715adea0dc31$export$9734b0a24bf02e93 /* @min:%2ename */ ], bd[0, $c0ca326fc9479ec0$export$be41298b7716c698 /* @min:%2eduration */ ], bd.success, bd.responseCode, method, bd.type, bd.correlationContext, customProperties, customMeasurements);
    var data = new (0, $74e0f4254782bad9$export$2d0294657ab35f1b)((0, $0dd1de134f090c69$export$a7b48490930dbffa)[0, $e5f8715adea0dc31$export$9e16762ab4f2648 /* @min:%2edataType */ ], remoteDepData);
    return $0b044846db0c77e8$var$_createEnvelope(logger, (0, $0dd1de134f090c69$export$a7b48490930dbffa)[0, $e5f8715adea0dc31$export$2672d4f7ccc80348 /* @min:%2eenvelopeType */ ], telemetryItem, data);
}
function $0b044846db0c77e8$export$b74153364c2066d1(logger, telemetryItem, customUndefinedValue) {
    $0b044846db0c77e8$var$EnvelopeCreatorInit(logger, telemetryItem);
    var customProperties = {};
    var customMeasurements = {};
    if (telemetryItem[$0b044846db0c77e8$var$strBaseType] !== (0, $9bdc8b7e7935e83a$export$d61e24a684f9e51)[0, $e5f8715adea0dc31$export$9e16762ab4f2648 /* @min:%2edataType */ ]) customProperties["baseTypeSource"] = telemetryItem[$0b044846db0c77e8$var$strBaseType]; // save the passed in base type as a property
    if (telemetryItem[$0b044846db0c77e8$var$strBaseType] === (0, $9bdc8b7e7935e83a$export$d61e24a684f9e51)[0, $e5f8715adea0dc31$export$9e16762ab4f2648 /* @min:%2edataType */ ]) {
        customProperties = telemetryItem[$0b044846db0c77e8$var$strBaseData][$0b044846db0c77e8$var$strProperties] || {};
        customMeasurements = telemetryItem[$0b044846db0c77e8$var$strBaseData][0, $e5f8715adea0dc31$export$32fc64677eb5b7a2 /* @min:%2emeasurements */ ] || {};
    } else if (telemetryItem[$0b044846db0c77e8$var$strBaseData]) $0b044846db0c77e8$var$_extractPropsAndMeasurements(telemetryItem[$0b044846db0c77e8$var$strBaseData], customProperties, customMeasurements);
    // Extract root level properties from part C telemetryItem.data
    $0b044846db0c77e8$var$_extractPropsAndMeasurements(telemetryItem[0, $e5f8715adea0dc31$export$2f5ff0b46814907e /* @min:%2edata */ ], customProperties, customMeasurements);
    if (!(0, $533f826bbc418791$export$bedb7023a7733221)(customUndefinedValue)) $0b044846db0c77e8$var$_convertPropsUndefinedToCustomDefinedValue(customProperties, customUndefinedValue);
    var eventName = telemetryItem[$0b044846db0c77e8$var$strBaseData][0, $e5f8715adea0dc31$export$9734b0a24bf02e93 /* @min:%2ename */ ];
    var eventData = new (0, $9bdc8b7e7935e83a$export$d61e24a684f9e51)(logger, eventName, customProperties, customMeasurements);
    var data = new (0, $74e0f4254782bad9$export$2d0294657ab35f1b)((0, $9bdc8b7e7935e83a$export$d61e24a684f9e51)[0, $e5f8715adea0dc31$export$9e16762ab4f2648 /* @min:%2edataType */ ], eventData);
    return $0b044846db0c77e8$var$_createEnvelope(logger, (0, $9bdc8b7e7935e83a$export$d61e24a684f9e51)[0, $e5f8715adea0dc31$export$2672d4f7ccc80348 /* @min:%2eenvelopeType */ ], telemetryItem, data);
}
function $0b044846db0c77e8$export$eca78b65eeb356ed(logger, telemetryItem, customUndefinedValue) {
    $0b044846db0c77e8$var$EnvelopeCreatorInit(logger, telemetryItem);
    // Extract root level properties from part C telemetryItem.data
    var customMeasurements = telemetryItem[$0b044846db0c77e8$var$strBaseData][0, $e5f8715adea0dc31$export$32fc64677eb5b7a2 /* @min:%2emeasurements */ ] || {};
    var customProperties = telemetryItem[$0b044846db0c77e8$var$strBaseData][$0b044846db0c77e8$var$strProperties] || {};
    $0b044846db0c77e8$var$_extractPropsAndMeasurements(telemetryItem[0, $e5f8715adea0dc31$export$2f5ff0b46814907e /* @min:%2edata */ ], customProperties, customMeasurements);
    if (!(0, $533f826bbc418791$export$bedb7023a7733221)(customUndefinedValue)) $0b044846db0c77e8$var$_convertPropsUndefinedToCustomDefinedValue(customProperties, customUndefinedValue);
    var bd = telemetryItem[$0b044846db0c77e8$var$strBaseData];
    var exData = (0, $1e8d24b24fb574aa$export$e2f174de097e0bcd).CreateFromInterface(logger, bd, customProperties, customMeasurements);
    var data = new (0, $74e0f4254782bad9$export$2d0294657ab35f1b)((0, $1e8d24b24fb574aa$export$e2f174de097e0bcd)[0, $e5f8715adea0dc31$export$9e16762ab4f2648 /* @min:%2edataType */ ], exData);
    return $0b044846db0c77e8$var$_createEnvelope(logger, (0, $1e8d24b24fb574aa$export$e2f174de097e0bcd)[0, $e5f8715adea0dc31$export$2672d4f7ccc80348 /* @min:%2eenvelopeType */ ], telemetryItem, data);
}
function $0b044846db0c77e8$export$bb5bee4039a2e495(logger, telemetryItem, customUndefinedValue) {
    $0b044846db0c77e8$var$EnvelopeCreatorInit(logger, telemetryItem);
    var baseData = telemetryItem[$0b044846db0c77e8$var$strBaseData];
    var props = baseData[$0b044846db0c77e8$var$strProperties] || {};
    var measurements = baseData[0, $e5f8715adea0dc31$export$32fc64677eb5b7a2 /* @min:%2emeasurements */ ] || {};
    $0b044846db0c77e8$var$_extractPropsAndMeasurements(telemetryItem[0, $e5f8715adea0dc31$export$2f5ff0b46814907e /* @min:%2edata */ ], props, measurements);
    if (!(0, $533f826bbc418791$export$bedb7023a7733221)(customUndefinedValue)) $0b044846db0c77e8$var$_convertPropsUndefinedToCustomDefinedValue(props, customUndefinedValue);
    var baseMetricData = new (0, $659de0afdff509f2$export$efdd3e096bc27746)(logger, baseData[0, $e5f8715adea0dc31$export$9734b0a24bf02e93 /* @min:%2ename */ ], baseData.average, baseData.sampleCount, baseData.min, baseData.max, baseData.stdDev, props, measurements);
    var data = new (0, $74e0f4254782bad9$export$2d0294657ab35f1b)((0, $659de0afdff509f2$export$efdd3e096bc27746)[0, $e5f8715adea0dc31$export$9e16762ab4f2648 /* @min:%2edataType */ ], baseMetricData);
    return $0b044846db0c77e8$var$_createEnvelope(logger, (0, $659de0afdff509f2$export$efdd3e096bc27746)[0, $e5f8715adea0dc31$export$2672d4f7ccc80348 /* @min:%2eenvelopeType */ ], telemetryItem, data);
}
function $0b044846db0c77e8$export$edbb8a2c6529947a(logger, telemetryItem, customUndefinedValue) {
    $0b044846db0c77e8$var$EnvelopeCreatorInit(logger, telemetryItem);
    // Since duration is not part of the domain properties in Common Schema, extract it from part C
    var duration;
    var baseData = telemetryItem[$0b044846db0c77e8$var$strBaseData];
    if (!(0, $533f826bbc418791$export$bedb7023a7733221)(baseData) && !(0, $533f826bbc418791$export$bedb7023a7733221)(baseData[$0b044846db0c77e8$var$strProperties]) && !(0, $533f826bbc418791$export$bedb7023a7733221)(baseData[$0b044846db0c77e8$var$strProperties][0, $c0ca326fc9479ec0$export$be41298b7716c698])) {
        duration = baseData[$0b044846db0c77e8$var$strProperties][0, $c0ca326fc9479ec0$export$be41298b7716c698];
        delete baseData[$0b044846db0c77e8$var$strProperties][0, $c0ca326fc9479ec0$export$be41298b7716c698];
    } else if (!(0, $533f826bbc418791$export$bedb7023a7733221)(telemetryItem[0, $e5f8715adea0dc31$export$2f5ff0b46814907e /* @min:%2edata */ ]) && !(0, $533f826bbc418791$export$bedb7023a7733221)(telemetryItem[0, $e5f8715adea0dc31$export$2f5ff0b46814907e /* @min:%2edata */ ][0, $c0ca326fc9479ec0$export$be41298b7716c698])) {
        duration = telemetryItem[0, $e5f8715adea0dc31$export$2f5ff0b46814907e /* @min:%2edata */ ][0, $c0ca326fc9479ec0$export$be41298b7716c698];
        delete telemetryItem[0, $e5f8715adea0dc31$export$2f5ff0b46814907e /* @min:%2edata */ ][0, $c0ca326fc9479ec0$export$be41298b7716c698];
    }
    var bd = telemetryItem[$0b044846db0c77e8$var$strBaseData];
    // special case: pageview.id is grabbed from current operation id. Analytics plugin is decoupled from properties plugin, so this is done here instead. This can be made a default telemetry intializer instead if needed to be decoupled from channel
    var currentContextId;
    if (((telemetryItem.ext || {}).trace || {})[0, $e5f8715adea0dc31$export$a5eb52c53bba8560 /* @min:%2etraceID */ ]) currentContextId = telemetryItem.ext.trace[0, $e5f8715adea0dc31$export$a5eb52c53bba8560 /* @min:%2etraceID */ ];
    var id = bd.id || currentContextId;
    var name = bd[0, $e5f8715adea0dc31$export$9734b0a24bf02e93 /* @min:%2ename */ ];
    var url = bd.uri;
    var properties = bd[$0b044846db0c77e8$var$strProperties] || {};
    var measurements = bd[0, $e5f8715adea0dc31$export$32fc64677eb5b7a2 /* @min:%2emeasurements */ ] || {};
    // refUri is a field that Breeze still does not recognize as part of Part B. For now, put it in Part C until it supports it as a domain property
    if (!(0, $533f826bbc418791$export$bedb7023a7733221)(bd.refUri)) properties["refUri"] = bd.refUri;
    // pageType is a field that Breeze still does not recognize as part of Part B. For now, put it in Part C until it supports it as a domain property
    if (!(0, $533f826bbc418791$export$bedb7023a7733221)(bd.pageType)) properties["pageType"] = bd.pageType;
    // isLoggedIn is a field that Breeze still does not recognize as part of Part B. For now, put it in Part C until it supports it as a domain property
    if (!(0, $533f826bbc418791$export$bedb7023a7733221)(bd.isLoggedIn)) properties["isLoggedIn"] = bd.isLoggedIn[0, $e5f8715adea0dc31$export$e2818d11505fa034 /* @min:%2etoString */ ]();
    // pageTags is a field that Breeze still does not recognize as part of Part B. For now, put it in Part C until it supports it as a domain property
    if (!(0, $533f826bbc418791$export$bedb7023a7733221)(bd[$0b044846db0c77e8$var$strProperties])) {
        var pageTags = bd[$0b044846db0c77e8$var$strProperties];
        (0, $45e528077703ac0c$export$aa0705d5774c95d1)(pageTags, function(key, value) {
            properties[key] = value;
        });
    }
    $0b044846db0c77e8$var$_extractPropsAndMeasurements(telemetryItem[0, $e5f8715adea0dc31$export$2f5ff0b46814907e /* @min:%2edata */ ], properties, measurements);
    if (!(0, $533f826bbc418791$export$bedb7023a7733221)(customUndefinedValue)) $0b044846db0c77e8$var$_convertPropsUndefinedToCustomDefinedValue(properties, customUndefinedValue);
    var pageViewData = new (0, $5c5f40703ef3d51c$export$12c0fdede1c6bc6c)(logger, name, url, duration, properties, measurements, id);
    var data = new (0, $74e0f4254782bad9$export$2d0294657ab35f1b)((0, $5c5f40703ef3d51c$export$12c0fdede1c6bc6c)[0, $e5f8715adea0dc31$export$9e16762ab4f2648 /* @min:%2edataType */ ], pageViewData);
    return $0b044846db0c77e8$var$_createEnvelope(logger, (0, $5c5f40703ef3d51c$export$12c0fdede1c6bc6c)[0, $e5f8715adea0dc31$export$2672d4f7ccc80348 /* @min:%2eenvelopeType */ ], telemetryItem, data);
}
function $0b044846db0c77e8$export$bb801863268e7049(logger, telemetryItem, customUndefinedValue) {
    $0b044846db0c77e8$var$EnvelopeCreatorInit(logger, telemetryItem);
    var bd = telemetryItem[$0b044846db0c77e8$var$strBaseData];
    var name = bd[0, $e5f8715adea0dc31$export$9734b0a24bf02e93 /* @min:%2ename */ ];
    var url = bd.uri || bd.url;
    var properties = bd[$0b044846db0c77e8$var$strProperties] || {};
    var measurements = bd[0, $e5f8715adea0dc31$export$32fc64677eb5b7a2 /* @min:%2emeasurements */ ] || {};
    $0b044846db0c77e8$var$_extractPropsAndMeasurements(telemetryItem[0, $e5f8715adea0dc31$export$2f5ff0b46814907e /* @min:%2edata */ ], properties, measurements);
    if (!(0, $533f826bbc418791$export$bedb7023a7733221)(customUndefinedValue)) $0b044846db0c77e8$var$_convertPropsUndefinedToCustomDefinedValue(properties, customUndefinedValue);
    var baseData = new (0, $27d410d508f4b32f$export$709aae57ec681346)(logger, name, url, undefined, properties, measurements, bd);
    var data = new (0, $74e0f4254782bad9$export$2d0294657ab35f1b)((0, $27d410d508f4b32f$export$709aae57ec681346)[0, $e5f8715adea0dc31$export$9e16762ab4f2648 /* @min:%2edataType */ ], baseData);
    return $0b044846db0c77e8$var$_createEnvelope(logger, (0, $27d410d508f4b32f$export$709aae57ec681346)[0, $e5f8715adea0dc31$export$2672d4f7ccc80348 /* @min:%2eenvelopeType */ ], telemetryItem, data);
}
function $0b044846db0c77e8$export$bc9e843f2eb8a61c(logger, telemetryItem, customUndefinedValue) {
    $0b044846db0c77e8$var$EnvelopeCreatorInit(logger, telemetryItem);
    var message = telemetryItem[$0b044846db0c77e8$var$strBaseData].message;
    var severityLevel = telemetryItem[$0b044846db0c77e8$var$strBaseData].severityLevel;
    var props = telemetryItem[$0b044846db0c77e8$var$strBaseData][$0b044846db0c77e8$var$strProperties] || {};
    var measurements = telemetryItem[$0b044846db0c77e8$var$strBaseData][0, $e5f8715adea0dc31$export$32fc64677eb5b7a2 /* @min:%2emeasurements */ ] || {};
    $0b044846db0c77e8$var$_extractPropsAndMeasurements(telemetryItem[0, $e5f8715adea0dc31$export$2f5ff0b46814907e /* @min:%2edata */ ], props, measurements);
    if (!(0, $533f826bbc418791$export$bedb7023a7733221)(customUndefinedValue)) $0b044846db0c77e8$var$_convertPropsUndefinedToCustomDefinedValue(props, customUndefinedValue);
    var baseData = new (0, $16adbdbcb0ae9015$export$78e1bea9036f120f)(logger, message, severityLevel, props, measurements);
    var data = new (0, $74e0f4254782bad9$export$2d0294657ab35f1b)((0, $16adbdbcb0ae9015$export$78e1bea9036f120f)[0, $e5f8715adea0dc31$export$9e16762ab4f2648 /* @min:%2edataType */ ], baseData);
    return $0b044846db0c77e8$var$_createEnvelope(logger, (0, $16adbdbcb0ae9015$export$78e1bea9036f120f)[0, $e5f8715adea0dc31$export$2672d4f7ccc80348 /* @min:%2eenvelopeType */ ], telemetryItem, data);
}


/*
 * Application Insights JavaScript SDK - Channel, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 

function $9f852541a61ca36f$var$_disableEvents(target, evtNamespace) {
    (0, $12cc003c7fb5ccde$export$51dedceb7c784eff)(target, null, null, evtNamespace);
}
function $9f852541a61ca36f$export$798b7fe42d5e3d06(parentEvtNamespace) {
    var _a;
    var _document = (0, $3d5fcb60a9467a45$export$f65ca476c09acec0)();
    var _navigator = (0, $3d5fcb60a9467a45$export$a56241c767c1d89f)(); // Gets the window.navigator or workerNavigator depending on the global
    var _isListening = false;
    var _onlineStatus = true;
    var _evtNamespace = (0, $12cc003c7fb5ccde$export$3f37a50e0edde3be)((0, $8a2d104e2647a310$export$eb4a6badb18ead04)("OfflineListener"), parentEvtNamespace);
    try {
        if (_enableEvents((0, $3d5fcb60a9467a45$export$38b2d434cce3ea22)())) _isListening = true;
        if (_document) {
            // Also attach to the document.body or document
            var target = _document.body || _document;
            if (target.ononline) {
                if (_enableEvents(target)) _isListening = true;
            }
        }
        if (_isListening) // We are listening to events so lets set the current status rather than assuming we are online #1538
        {
            if (_navigator && !(0, $533f826bbc418791$export$bedb7023a7733221)(_navigator[0, $e5f8715adea0dc31$export$a9130fdcd11ec7ef /* @min:%2eonLine */ ])) _onlineStatus = _navigator[0, $e5f8715adea0dc31$export$a9130fdcd11ec7ef /* @min:%2eonLine */ ];
        }
    } catch (e) {
        // this makes react-native less angry
        _isListening = false;
    }
    function _enableEvents(target) {
        var enabled = false;
        if (target) {
            enabled = (0, $12cc003c7fb5ccde$export$324ab159353a60a9)(target, "online", _setOnline, _evtNamespace);
            if (enabled) (0, $12cc003c7fb5ccde$export$324ab159353a60a9)(target, "offline", _setOffline, _evtNamespace);
        }
        return enabled;
    }
    function _setOnline() {
        _onlineStatus = true;
    }
    function _setOffline() {
        _onlineStatus = false;
    }
    function _isOnline() {
        var result = true;
        if (_isListening) result = _onlineStatus;
        else if (_navigator && !(0, $533f826bbc418791$export$bedb7023a7733221)(_navigator[0, $e5f8715adea0dc31$export$a9130fdcd11ec7ef /* @min:%2eonLine */ ])) result = _navigator[0, $e5f8715adea0dc31$export$a9130fdcd11ec7ef /* @min:%2eonLine */ ];
        return result;
    }
    function _unload() {
        var win = (0, $3d5fcb60a9467a45$export$38b2d434cce3ea22)();
        if (win && _isListening) {
            $9f852541a61ca36f$var$_disableEvents(win, _evtNamespace);
            if (_document) {
                // Also attach to the document.body or document
                var target = _document.body || _document;
                if (!(0, $533f826bbc418791$export$fce6876652108ab)(target.ononline)) $9f852541a61ca36f$var$_disableEvents(target, _evtNamespace);
            }
            _isListening = false;
        }
    }
    return _a = {}, _a[0, $e5f8715adea0dc31$export$704cf8098f85ad0f /* @min:isOnline */ ] = _isOnline, _a.isListening = function() {
        return _isListening;
    }, _a.unload = _unload, _a;
}


/*
 * Application Insights JavaScript SDK - Channel, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 




var $633f36e5bb6b03ff$var$BaseSendBuffer = /** @class */ function() {
    function BaseSendBuffer(logger, config) {
        var _buffer = [];
        var _bufferFullMessageSent = false;
        this[0, $e5f8715adea0dc31$export$7768b9624b4c70a6 /* @min:%2e_get */ ] = function() {
            return _buffer;
        };
        this._set = function(buffer) {
            _buffer = buffer;
            return _buffer;
        };
        (0, $c9b63384299a3252$export$2e2bcd8739ae039)(BaseSendBuffer, this, function(_self) {
            _self[0, $e5f8715adea0dc31$export$4aae77f3ba3c48b4 /* @min:%2eenqueue */ ] = function(payload) {
                if (_self[0, $e5f8715adea0dc31$export$e9679ef501b0d1 /* @min:%2ecount */ ]() >= config[0, $e5f8715adea0dc31$export$c8dd872dc774fa7c /* @min:%2eeventsLimitInMem */ ]) {
                    // sent internal log only once per page view
                    if (!_bufferFullMessageSent) {
                        (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , 105 /* _eInternalMessageId.InMemoryStorageBufferFull */ , "Maximum in-memory buffer size reached: " + _self[0, $e5f8715adea0dc31$export$e9679ef501b0d1 /* @min:%2ecount */ ](), true);
                        _bufferFullMessageSent = true;
                    }
                    return;
                }
                _buffer[0, $e5f8715adea0dc31$export$a0a330e7fa1e278c /* @min:%2epush */ ](payload);
            };
            _self[0, $e5f8715adea0dc31$export$e9679ef501b0d1 /* @min:%2ecount */ ] = function() {
                return _buffer[0, $e5f8715adea0dc31$export$6eae51590aaea43 /* @min:%2elength */ ];
            };
            _self.size = function() {
                var size = _buffer[0, $e5f8715adea0dc31$export$6eae51590aaea43 /* @min:%2elength */ ];
                for(var lp = 0; lp < _buffer[0, $e5f8715adea0dc31$export$6eae51590aaea43 /* @min:%2elength */ ]; lp++)size += _buffer[lp][0, $e5f8715adea0dc31$export$6eae51590aaea43 /* @min:%2elength */ ];
                if (!config[0, $e5f8715adea0dc31$export$b18aabdfc0aaf6b /* @min:%2eemitLineDelimitedJson */ ]) size += 2;
                return size;
            };
            _self[0, $e5f8715adea0dc31$export$5eeb73fac03da74a /* @min:%2eclear */ ] = function() {
                _buffer = [];
                _bufferFullMessageSent = false;
            };
            _self.getItems = function() {
                return _buffer.slice(0);
            };
            _self[0, $e5f8715adea0dc31$export$a5da323a4da829fc /* @min:%2ebatchPayloads */ ] = function(payload) {
                if (payload && payload[0, $e5f8715adea0dc31$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) {
                    var batch = config[0, $e5f8715adea0dc31$export$b18aabdfc0aaf6b /* @min:%2eemitLineDelimitedJson */ ] ? payload.join("\n") : "[" + payload.join(",") + "]";
                    return batch;
                }
                return null;
            };
            _self[0, $e5f8715adea0dc31$export$1e6514b499ba4d34 /* @min:%2ecreateNew */ ] = function(newLogger, newConfig, canUseSessionStorage) {
                var items = _buffer.slice(0);
                newLogger = newLogger || logger;
                newConfig = newConfig || {};
                var newBuffer = !!canUseSessionStorage ? new $633f36e5bb6b03ff$export$dcb776947c16915f(newLogger, newConfig) : new $633f36e5bb6b03ff$export$d706e5fd60d36d56(newLogger, newConfig);
                (0, $f6bb085f8cf12216$export$e2e5bcdbdc49c586)(items, function(payload) {
                    newBuffer[0, $e5f8715adea0dc31$export$4aae77f3ba3c48b4 /* @min:%2eenqueue */ ](payload);
                });
                return newBuffer;
            };
        });
    }
    // Removed Stub for BaseSendBuffer.prototype.enqueue.
    // Removed Stub for BaseSendBuffer.prototype.count.
    // Removed Stub for BaseSendBuffer.prototype.size.
    // Removed Stub for BaseSendBuffer.prototype.clear.
    // Removed Stub for BaseSendBuffer.prototype.getItems.
    // Removed Stub for BaseSendBuffer.prototype.batchPayloads.
    // Removed Stub for BaseSendBuffer.prototype.createNew.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    BaseSendBuffer.__ieDyn = 1;
    return BaseSendBuffer;
}();
/*
 * An array based send buffer.
 */ var $633f36e5bb6b03ff$export$d706e5fd60d36d56 = /** @class */ function(_super) {
    (0, $2a74b38b87b38cda$export$1f9c32e3fbfb8e62)(ArraySendBuffer, _super);
    function ArraySendBuffer(logger, config) {
        var _this = _super.call(this, logger, config) || this;
        (0, $c9b63384299a3252$export$2e2bcd8739ae039)(ArraySendBuffer, _this, function(_self, _base) {
            _self[0, $e5f8715adea0dc31$export$52e50651d87300e3 /* @min:%2emarkAsSent */ ] = function(payload) {
                _base[0, $e5f8715adea0dc31$export$5eeb73fac03da74a /* @min:%2eclear */ ]();
            };
            _self[0, $e5f8715adea0dc31$export$13da1b5a005ef035 /* @min:%2eclearSent */ ] = function(payload) {
            // not supported
            };
        });
        return _this;
    }
    // Removed Stub for ArraySendBuffer.prototype.markAsSent.
    // Removed Stub for ArraySendBuffer.prototype.clearSent.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    ArraySendBuffer.__ieDyn = 1;
    return ArraySendBuffer;
}($633f36e5bb6b03ff$var$BaseSendBuffer);
/*
 * Session storage buffer holds a copy of all unsent items in the browser session storage.
 */ var $633f36e5bb6b03ff$export$dcb776947c16915f = /** @class */ function(_super) {
    (0, $2a74b38b87b38cda$export$1f9c32e3fbfb8e62)(SessionStorageSendBuffer, _super);
    function SessionStorageSendBuffer(logger, config) {
        var _this = _super.call(this, logger, config) || this;
        var _bufferFullMessageSent = false;
        //Note: should not use config.namePrefix directly, because it will always refers to the latest namePrefix
        var _namePrefix = config === null || config === void 0 ? void 0 : config.namePrefix;
        var _a = config[0, $e5f8715adea0dc31$export$4637bcb72c509e60 /* @min:%2ebufferOverride */ ] || {
            getItem: (0, $8e03bdff803b84be$export$a398bd2f40e2eb6e),
            setItem: (0, $8e03bdff803b84be$export$21abea3a85fee3f5)
        }, getItem = _a.getItem, setItem = _a.setItem;
        (0, $c9b63384299a3252$export$2e2bcd8739ae039)(SessionStorageSendBuffer, _this, function(_self, _base) {
            var bufferItems = _getBuffer(SessionStorageSendBuffer[0, $e5f8715adea0dc31$export$63ab2dad6d8a60ed /* @min:%2eBUFFER_KEY */ ]);
            var notDeliveredItems = _getBuffer(SessionStorageSendBuffer[0, $e5f8715adea0dc31$export$d03f333763905c89 /* @min:%2eSENT_BUFFER_KEY */ ]);
            var buffer = _self._set(bufferItems.concat(notDeliveredItems));
            // If the buffer has too many items, drop items from the end.
            if (buffer[0, $e5f8715adea0dc31$export$6eae51590aaea43 /* @min:%2elength */ ] > SessionStorageSendBuffer[0, $e5f8715adea0dc31$export$20d3a25105cda3b1 /* @min:%2eMAX_BUFFER_SIZE */ ]) buffer[0, $e5f8715adea0dc31$export$6eae51590aaea43 /* @min:%2elength */ ] = SessionStorageSendBuffer[0, $e5f8715adea0dc31$export$20d3a25105cda3b1 /* @min:%2eMAX_BUFFER_SIZE */ ];
            _setBuffer(SessionStorageSendBuffer[0, $e5f8715adea0dc31$export$d03f333763905c89 /* @min:%2eSENT_BUFFER_KEY */ ], []);
            _setBuffer(SessionStorageSendBuffer[0, $e5f8715adea0dc31$export$63ab2dad6d8a60ed /* @min:%2eBUFFER_KEY */ ], buffer);
            _self[0, $e5f8715adea0dc31$export$4aae77f3ba3c48b4 /* @min:%2eenqueue */ ] = function(payload) {
                if (_self[0, $e5f8715adea0dc31$export$e9679ef501b0d1 /* @min:%2ecount */ ]() >= SessionStorageSendBuffer[0, $e5f8715adea0dc31$export$20d3a25105cda3b1 /* @min:%2eMAX_BUFFER_SIZE */ ]) {
                    // sent internal log only once per page view
                    if (!_bufferFullMessageSent) {
                        (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , 67 /* _eInternalMessageId.SessionStorageBufferFull */ , "Maximum buffer size reached: " + _self[0, $e5f8715adea0dc31$export$e9679ef501b0d1 /* @min:%2ecount */ ](), true);
                        _bufferFullMessageSent = true;
                    }
                    return;
                }
                _base[0, $e5f8715adea0dc31$export$4aae77f3ba3c48b4 /* @min:%2eenqueue */ ](payload);
                _setBuffer(SessionStorageSendBuffer.BUFFER_KEY, _self[0, $e5f8715adea0dc31$export$7768b9624b4c70a6 /* @min:%2e_get */ ]());
            };
            _self[0, $e5f8715adea0dc31$export$5eeb73fac03da74a /* @min:%2eclear */ ] = function() {
                _base[0, $e5f8715adea0dc31$export$5eeb73fac03da74a /* @min:%2eclear */ ]();
                _setBuffer(SessionStorageSendBuffer.BUFFER_KEY, _self[0, $e5f8715adea0dc31$export$7768b9624b4c70a6 /* @min:%2e_get */ ]());
                _setBuffer(SessionStorageSendBuffer[0, $e5f8715adea0dc31$export$d03f333763905c89 /* @min:%2eSENT_BUFFER_KEY */ ], []);
                _bufferFullMessageSent = false;
            };
            _self[0, $e5f8715adea0dc31$export$52e50651d87300e3 /* @min:%2emarkAsSent */ ] = function(payload) {
                _setBuffer(SessionStorageSendBuffer[0, $e5f8715adea0dc31$export$63ab2dad6d8a60ed /* @min:%2eBUFFER_KEY */ ], _self._set(_removePayloadsFromBuffer(payload, _self[0, $e5f8715adea0dc31$export$7768b9624b4c70a6 /* @min:%2e_get */ ]())));
                var sentElements = _getBuffer(SessionStorageSendBuffer[0, $e5f8715adea0dc31$export$d03f333763905c89 /* @min:%2eSENT_BUFFER_KEY */ ]);
                if (sentElements instanceof Array && payload instanceof Array) {
                    sentElements = sentElements.concat(payload);
                    if (sentElements[0, $e5f8715adea0dc31$export$6eae51590aaea43 /* @min:%2elength */ ] > SessionStorageSendBuffer[0, $e5f8715adea0dc31$export$20d3a25105cda3b1 /* @min:%2eMAX_BUFFER_SIZE */ ]) {
                        // We send telemetry normally. If the SENT_BUFFER is too big we don't add new elements
                        // until we receive a response from the backend and the buffer has free space again (see clearSent method)
                        (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(logger, 1 /* eLoggingSeverity.CRITICAL */ , 67 /* _eInternalMessageId.SessionStorageBufferFull */ , "Sent buffer reached its maximum size: " + sentElements[0, $e5f8715adea0dc31$export$6eae51590aaea43 /* @min:%2elength */ ], true);
                        sentElements[0, $e5f8715adea0dc31$export$6eae51590aaea43 /* @min:%2elength */ ] = SessionStorageSendBuffer[0, $e5f8715adea0dc31$export$20d3a25105cda3b1 /* @min:%2eMAX_BUFFER_SIZE */ ];
                    }
                    _setBuffer(SessionStorageSendBuffer[0, $e5f8715adea0dc31$export$d03f333763905c89 /* @min:%2eSENT_BUFFER_KEY */ ], sentElements);
                }
            };
            _self[0, $e5f8715adea0dc31$export$13da1b5a005ef035 /* @min:%2eclearSent */ ] = function(payload) {
                var sentElements = _getBuffer(SessionStorageSendBuffer[0, $e5f8715adea0dc31$export$d03f333763905c89 /* @min:%2eSENT_BUFFER_KEY */ ]);
                sentElements = _removePayloadsFromBuffer(payload, sentElements);
                _setBuffer(SessionStorageSendBuffer[0, $e5f8715adea0dc31$export$d03f333763905c89 /* @min:%2eSENT_BUFFER_KEY */ ], sentElements);
            };
            _self[0, $e5f8715adea0dc31$export$1e6514b499ba4d34 /* @min:%2ecreateNew */ ] = function(newLogger, newConfig, canUseSessionStorage) {
                canUseSessionStorage = !!canUseSessionStorage;
                var unsentItems = _self[0, $e5f8715adea0dc31$export$7768b9624b4c70a6 /* @min:%2e_get */ ]().slice(0);
                var sentItems = _getBuffer(SessionStorageSendBuffer[0, $e5f8715adea0dc31$export$d03f333763905c89 /* @min:%2eSENT_BUFFER_KEY */ ]).slice(0);
                newLogger = newLogger || logger;
                newConfig = newConfig || {};
                // to make sure that we do not send duplicated payloads when it is switched back to previous one
                _self[0, $e5f8715adea0dc31$export$5eeb73fac03da74a /* @min:%2eclear */ ]();
                var newBuffer = canUseSessionStorage ? new SessionStorageSendBuffer(newLogger, newConfig) : new $633f36e5bb6b03ff$export$d706e5fd60d36d56(newLogger, newConfig);
                (0, $f6bb085f8cf12216$export$e2e5bcdbdc49c586)(unsentItems, function(payload) {
                    newBuffer[0, $e5f8715adea0dc31$export$4aae77f3ba3c48b4 /* @min:%2eenqueue */ ](payload);
                });
                if (canUseSessionStorage) // arr buffer will clear all payloads if markAsSent() is called
                newBuffer[0, $e5f8715adea0dc31$export$52e50651d87300e3 /* @min:%2emarkAsSent */ ](sentItems);
                return newBuffer;
            };
            function _removePayloadsFromBuffer(payloads, buffer) {
                var remaining = [];
                (0, $f6bb085f8cf12216$export$e2e5bcdbdc49c586)(buffer, function(value) {
                    if (!(0, $533f826bbc418791$export$f6e2535fb5126e54)(value) && (0, $a96d4958027d6f85$export$9f3b3ffa84393d30)(payloads, value) === -1) remaining[0, $e5f8715adea0dc31$export$a0a330e7fa1e278c /* @min:%2epush */ ](value);
                });
                return remaining;
            }
            function _getBuffer(key) {
                var prefixedKey = key;
                try {
                    prefixedKey = _namePrefix ? _namePrefix + "_" + prefixedKey : prefixedKey;
                    var bufferJson = getItem(logger, prefixedKey);
                    if (bufferJson) {
                        var buffer_1 = (0, $0c599844349363c4$export$d047a7c56db64af4)().parse(bufferJson);
                        if ((0, $533f826bbc418791$export$844ec244b1367d54)(buffer_1)) // When using some version prototype.js the stringify / parse cycle does not decode array's correctly
                        buffer_1 = (0, $0c599844349363c4$export$d047a7c56db64af4)().parse(buffer_1);
                        if (buffer_1 && (0, $533f826bbc418791$export$43bee75e5e14138e)(buffer_1)) return buffer_1;
                    }
                } catch (e) {
                    (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(logger, 1 /* eLoggingSeverity.CRITICAL */ , 42 /* _eInternalMessageId.FailedToRestoreStorageBuffer */ , " storage key: " + prefixedKey + ", " + (0, $0b747974b0bb3563$export$39c4487b36c98fec)(e), {
                        exception: (0, $386f00e3a193a7da$export$21fce7cbd4dc679f)(e)
                    });
                }
                return [];
            }
            function _setBuffer(key, buffer) {
                var prefixedKey = key;
                try {
                    prefixedKey = _namePrefix ? _namePrefix + "_" + prefixedKey : prefixedKey;
                    var bufferJson = JSON[0, $e5f8715adea0dc31$export$a318a8141fc98747 /* @min:%2estringify */ ](buffer);
                    setItem(logger, prefixedKey, bufferJson);
                } catch (e) {
                    // if there was an error, clear the buffer
                    // telemetry is stored in the _buffer array so we won't loose any items
                    setItem(logger, prefixedKey, JSON[0, $e5f8715adea0dc31$export$a318a8141fc98747 /* @min:%2estringify */ ]([]));
                    (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , 41 /* _eInternalMessageId.FailedToSetStorageBuffer */ , " storage key: " + prefixedKey + ", " + (0, $0b747974b0bb3563$export$39c4487b36c98fec)(e) + ". Buffer cleared", {
                        exception: (0, $386f00e3a193a7da$export$21fce7cbd4dc679f)(e)
                    });
                }
            }
        });
        return _this;
    }
    // Removed Stub for SessionStorageSendBuffer.prototype.enqueue.
    // Removed Stub for SessionStorageSendBuffer.prototype.clear.
    // Removed Stub for SessionStorageSendBuffer.prototype.markAsSent.
    // Removed Stub for SessionStorageSendBuffer.prototype.clearSent.
    // Removed Stub for SessionStorageSendBuffer.prototype.createNew.
    SessionStorageSendBuffer.BUFFER_KEY = "AI_buffer";
    SessionStorageSendBuffer.SENT_BUFFER_KEY = "AI_sentBuffer";
    // Maximum number of payloads stored in the buffer. If the buffer is full, new elements will be dropped.
    SessionStorageSendBuffer.MAX_BUFFER_SIZE = 2000;
    return SessionStorageSendBuffer;
}($633f36e5bb6b03ff$var$BaseSendBuffer);


/*
 * Application Insights JavaScript SDK - Channel, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 


var $2c9268977b2520db$export$ef852775387a0be7 = /** @class */ function() {
    function Serializer(logger) {
        (0, $c9b63384299a3252$export$2e2bcd8739ae039)(Serializer, this, function(_self) {
            /**
             * Serializes the current object to a JSON string.
             */ _self.serialize = function(input) {
                var output = _serializeObject(input, "root");
                try {
                    return (0, $0c599844349363c4$export$d047a7c56db64af4)()[0, $e5f8715adea0dc31$export$a318a8141fc98747 /* @min:%2estringify */ ](output);
                } catch (e) {
                    // if serialization fails return an empty string
                    (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(logger, 1 /* eLoggingSeverity.CRITICAL */ , 48 /* _eInternalMessageId.CannotSerializeObject */ , e && (0, $533f826bbc418791$export$f6e2535fb5126e54)(e[0, $e5f8715adea0dc31$export$e2818d11505fa034 /* @min:%2etoString */ ]) ? e[0, $e5f8715adea0dc31$export$e2818d11505fa034 /* @min:%2etoString */ ]() : "Error serializing object", null, true);
                }
            };
            function _serializeObject(source, name) {
                var circularReferenceCheck = "__aiCircularRefCheck";
                var output = {};
                if (!source) {
                    (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(logger, 1 /* eLoggingSeverity.CRITICAL */ , 48 /* _eInternalMessageId.CannotSerializeObject */ , "cannot serialize object because it is null or undefined", {
                        name: name
                    }, true);
                    return output;
                }
                if (source[circularReferenceCheck]) {
                    (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , 50 /* _eInternalMessageId.CircularReferenceDetected */ , "Circular reference detected while serializing object", {
                        name: name
                    }, true);
                    return output;
                }
                if (!source.aiDataContract) {
                    // special case for measurements/properties/tags
                    if (name === "measurements") output = _serializeStringMap(source, "number", name);
                    else if (name === "properties") output = _serializeStringMap(source, "string", name);
                    else if (name === "tags") output = _serializeStringMap(source, "string", name);
                    else if ((0, $533f826bbc418791$export$43bee75e5e14138e)(source)) output = _serializeArray(source, name);
                    else {
                        (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , 49 /* _eInternalMessageId.CannotSerializeObjectNonSerializable */ , "Attempting to serialize an object which does not implement ISerializable", {
                            name: name
                        }, true);
                        try {
                            // verify that the object can be stringified
                            (0, $0c599844349363c4$export$d047a7c56db64af4)()[0, $e5f8715adea0dc31$export$a318a8141fc98747 /* @min:%2estringify */ ](source);
                            output = source;
                        } catch (e) {
                            // if serialization fails return an empty string
                            (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(logger, 1 /* eLoggingSeverity.CRITICAL */ , 48 /* _eInternalMessageId.CannotSerializeObject */ , e && (0, $533f826bbc418791$export$f6e2535fb5126e54)(e[0, $e5f8715adea0dc31$export$e2818d11505fa034 /* @min:%2etoString */ ]) ? e[0, $e5f8715adea0dc31$export$e2818d11505fa034 /* @min:%2etoString */ ]() : "Error serializing object", null, true);
                        }
                    }
                    return output;
                }
                source[circularReferenceCheck] = true;
                (0, $45e528077703ac0c$export$aa0705d5774c95d1)(source.aiDataContract, function(field, contract) {
                    var isRequired = (0, $533f826bbc418791$export$f6e2535fb5126e54)(contract) ? contract() & 1 /* FieldType.Required */  : contract & 1 /* FieldType.Required */ ;
                    var isHidden = (0, $533f826bbc418791$export$f6e2535fb5126e54)(contract) ? contract() & 4 /* FieldType.Hidden */  : contract & 4 /* FieldType.Hidden */ ;
                    var isArray = contract & 2 /* FieldType.Array */ ;
                    var isPresent = source[field] !== undefined;
                    var isObj = (0, $533f826bbc418791$export$a6cdc56e425d0d0a)(source[field]) && source[field] !== null;
                    if (isRequired && !isPresent && !isArray) (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(logger, 1 /* eLoggingSeverity.CRITICAL */ , 24 /* _eInternalMessageId.MissingRequiredFieldSpecification */ , "Missing required field specification. The field is required but not present on source", {
                        field: field,
                        name: name
                    });
                    else if (!isHidden) {
                        var value = void 0;
                        if (isObj) {
                            if (isArray) // special case; recurse on each object in the source array
                            value = _serializeArray(source[field], field);
                            else // recurse on the source object in this field
                            value = _serializeObject(source[field], field);
                        } else // assign the source field to the output even if undefined or required
                        value = source[field];
                        // only emit this field if the value is defined
                        if (value !== undefined) output[field] = value;
                    }
                });
                delete source[circularReferenceCheck];
                return output;
            }
            function _serializeArray(sources, name) {
                var output;
                if (!!sources) {
                    if (!(0, $533f826bbc418791$export$43bee75e5e14138e)(sources)) (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(logger, 1 /* eLoggingSeverity.CRITICAL */ , 54 /* _eInternalMessageId.ItemNotInArray */ , "This field was specified as an array in the contract but the item is not an array.\r\n", {
                        name: name
                    }, true);
                    else {
                        output = [];
                        for(var i = 0; i < sources[0, $e5f8715adea0dc31$export$6eae51590aaea43 /* @min:%2elength */ ]; i++){
                            var source = sources[i];
                            var item = _serializeObject(source, name + "[" + i + "]");
                            output[0, $e5f8715adea0dc31$export$a0a330e7fa1e278c /* @min:%2epush */ ](item);
                        }
                    }
                }
                return output;
            }
            function _serializeStringMap(map, expectedType, name) {
                var output;
                if (map) {
                    output = {};
                    (0, $45e528077703ac0c$export$aa0705d5774c95d1)(map, function(field, value) {
                        if (expectedType === "string") {
                            if (value === undefined) output[field] = "undefined";
                            else if (value === null) output[field] = "null";
                            else if (!value[0, $e5f8715adea0dc31$export$e2818d11505fa034 /* @min:%2etoString */ ]) output[field] = "invalid field: toString() is not defined.";
                            else output[field] = value[0, $e5f8715adea0dc31$export$e2818d11505fa034 /* @min:%2etoString */ ]();
                        } else if (expectedType === "number") {
                            if (value === undefined) output[field] = "undefined";
                            else if (value === null) output[field] = "null";
                            else {
                                var num = parseFloat(value);
                                if (isNaN(num)) output[field] = "NaN";
                                else output[field] = num;
                            }
                        } else {
                            output[field] = "invalid field: " + name + " is of unknown type.";
                            (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(logger, 1 /* eLoggingSeverity.CRITICAL */ , output[field], null, true);
                        }
                    });
                }
                return output;
            }
        });
    }
    // Removed Stub for Serializer.prototype.serialize.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    Serializer.__ieDyn = 1;
    return Serializer;
}();


/*
 * Application Insights JavaScript SDK - Channel, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 


/*
 * Application Insights JavaScript SDK - Channel, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 

/*
 * Application Insights JavaScript SDK - Channel, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
// (Magic number) DJB algorithm can't work on shorter strings (results in poor distribution
var $7d0a42f949c72b34$var$MIN_INPUT_LENGTH = 8;
var $7d0a42f949c72b34$export$e2bdf7ff70742e42 = /** @class */ function() {
    function HashCodeScoreGenerator() {}
    HashCodeScoreGenerator.prototype.getHashCodeScore = function(key) {
        var score = this.getHashCode(key) / HashCodeScoreGenerator.INT_MAX_VALUE;
        return score * 100;
    };
    HashCodeScoreGenerator.prototype.getHashCode = function(input) {
        if (input === "") return 0;
        while(input[0, $e5f8715adea0dc31$export$6eae51590aaea43 /* @min:%2elength */ ] < $7d0a42f949c72b34$var$MIN_INPUT_LENGTH)input = input.concat(input);
        // 5381 is a magic number: http://stackoverflow.com/questions/10696223/reason-for-5381-number-in-djb-hash-function
        var hash = 5381;
        for(var i = 0; i < input[0, $e5f8715adea0dc31$export$6eae51590aaea43 /* @min:%2elength */ ]; ++i){
            hash = (hash << 5) + hash + input.charCodeAt(i);
            // 'hash' is of number type which means 53 bit integer (http://www.ecma-international.org/ecma-262/6.0/#sec-ecmascript-language-types-number-type)
            // 'hash & hash' will keep it 32 bit integer - just to make it clearer what the result is.
            hash = hash & hash;
        }
        return Math.abs(hash);
    };
    // We're using 32 bit math, hence max value is (2^31 - 1)
    HashCodeScoreGenerator.INT_MAX_VALUE = 2147483647;
    return HashCodeScoreGenerator;
}();


var $a511b226057b3229$export$4526db980ad5b8a1 = /** @class */ function() {
    function SamplingScoreGenerator() {
        var _self = this;
        var hashCodeGenerator = new (0, $7d0a42f949c72b34$export$e2bdf7ff70742e42)();
        var keys = new (0, $d1bdc0f4cef94745$export$8e2bcdf18620784a)();
        _self[0, $e5f8715adea0dc31$export$2c3af30a5c45aa6e /* @min:%2egetSamplingScore */ ] = function(item) {
            var score = 0;
            if (item[0, $e5f8715adea0dc31$export$d0f526aa8043f6d7 /* @min:%2etags */ ] && item[0, $e5f8715adea0dc31$export$d0f526aa8043f6d7 /* @min:%2etags */ ][keys.userId]) score = hashCodeGenerator.getHashCodeScore(item[0, $e5f8715adea0dc31$export$d0f526aa8043f6d7 /* @min:%2etags */ ][keys.userId]);
            else if (item.ext && item.ext.user && item.ext.user.id) score = hashCodeGenerator[0, $e5f8715adea0dc31$export$d676f8c50f371355 /* @min:%2egetHashCodeScore */ ](item.ext.user.id);
            else if (item[0, $e5f8715adea0dc31$export$d0f526aa8043f6d7 /* @min:%2etags */ ] && item[0, $e5f8715adea0dc31$export$d0f526aa8043f6d7 /* @min:%2etags */ ][keys.operationId]) score = hashCodeGenerator.getHashCodeScore(item[0, $e5f8715adea0dc31$export$d0f526aa8043f6d7 /* @min:%2etags */ ][keys.operationId]);
            else if (item.ext && item.ext.telemetryTrace && item.ext.telemetryTrace[0, $e5f8715adea0dc31$export$a5eb52c53bba8560 /* @min:%2etraceID */ ]) score = hashCodeGenerator.getHashCodeScore(item.ext.telemetryTrace[0, $e5f8715adea0dc31$export$a5eb52c53bba8560 /* @min:%2etraceID */ ]);
            else // tslint:disable-next-line:insecure-random
            score = Math.random() * 100;
            return score;
        };
    }
    return SamplingScoreGenerator;
}();


var $9c8a4bf222316b8c$export$21a3eccb8a1780eb = /** @class */ function() {
    function Sample(sampleRate, logger) {
        // We're using 32 bit math, hence max value is (2^31 - 1)
        this.INT_MAX_VALUE = 2147483647;
        var _logger = logger || (0, $cc2aaaebf96ac6a7$export$5102d32ea1d740a)(null);
        if (sampleRate > 100 || sampleRate < 0) {
            _logger.throwInternal(2 /* eLoggingSeverity.WARNING */ , 58 /* _eInternalMessageId.SampleRateOutOfRange */ , "Sampling rate is out of range (0..100). Sampling will be disabled, you may be sending too much data which may affect your AI service level.", {
                samplingRate: sampleRate
            }, true);
            sampleRate = 100;
        }
        this[0, $e5f8715adea0dc31$export$c2afe23fa18f9dff /* @min:%2esampleRate */ ] = sampleRate;
        this.samplingScoreGenerator = new (0, $a511b226057b3229$export$4526db980ad5b8a1)();
    }
    /**
    * Determines if an envelope is sampled in (i.e. will be sent) or not (i.e. will be dropped).
    */ Sample.prototype.isSampledIn = function(envelope) {
        var samplingPercentage = this[0, $e5f8715adea0dc31$export$c2afe23fa18f9dff /* @min:%2esampleRate */ ]; // 0 - 100
        var isSampledIn = false;
        if (samplingPercentage === null || samplingPercentage === undefined || samplingPercentage >= 100) return true;
        else if (envelope.baseType === (0, $659de0afdff509f2$export$efdd3e096bc27746)[0, $e5f8715adea0dc31$export$9e16762ab4f2648 /* @min:%2edataType */ ]) // exclude MetricData telemetry from sampling
        return true;
        isSampledIn = this.samplingScoreGenerator[0, $e5f8715adea0dc31$export$2c3af30a5c45aa6e /* @min:%2egetSamplingScore */ ](envelope) < samplingPercentage;
        return isSampledIn;
    };
    return Sample;
}();



var $de50c0f740c66740$var$_a, $de50c0f740c66740$var$_b;
var $de50c0f740c66740$var$UNDEFINED_VALUE = undefined;
var $de50c0f740c66740$var$FetchSyncRequestSizeLimitBytes = 65000; // approx 64kb (the current Edge, Firefox and Chrome max limit)
function $de50c0f740c66740$var$_getResponseText(xhr) {
    try {
        return xhr.responseText;
    } catch (e) {
    // Best effort, as XHR may throw while XDR wont so just ignore
    }
    return null;
}
var $de50c0f740c66740$var$defaultAppInsightsChannelConfig = (0, $36a077d9f4439b69$export$a15782d21797da4c)(($de50c0f740c66740$var$_a = {
    // Use the default value (handles empty string in the configuration)
    endpointUrl: (0, $61c4d9dd4226f64e$export$d0884590a6a82e6c)((0, $533f826bbc418791$export$8f9cae6546f97a9f), (0, $71dfba5ea0640485$export$5c9ec0fce655ebcf) + (0, $71dfba5ea0640485$export$e6c0f3431c6cd728))
}, $de50c0f740c66740$var$_a[0, $e5f8715adea0dc31$export$b18aabdfc0aaf6b /* @min:emitLineDelimitedJson */ ] = (0, $61c4d9dd4226f64e$export$bad0d7bace730ae)(), $de50c0f740c66740$var$_a[0, $e5f8715adea0dc31$export$983774f06380e463 /* @min:maxBatchInterval */ ] = 15000, $de50c0f740c66740$var$_a[0, $e5f8715adea0dc31$export$803d432e48ba5ceb /* @min:maxBatchSizeInBytes */ ] = 102400, $de50c0f740c66740$var$_a.disableTelemetry = (0, $61c4d9dd4226f64e$export$bad0d7bace730ae)(), $de50c0f740c66740$var$_a[0, $e5f8715adea0dc31$export$782dd40ba58c3597 /* @min:enableSessionStorageBuffer */ ] = (0, $61c4d9dd4226f64e$export$bad0d7bace730ae)(true), $de50c0f740c66740$var$_a.isRetryDisabled = (0, $61c4d9dd4226f64e$export$bad0d7bace730ae)(), $de50c0f740c66740$var$_a[0, $e5f8715adea0dc31$export$f5629284a6f7ec3d /* @min:isBeaconApiDisabled */ ] = (0, $61c4d9dd4226f64e$export$bad0d7bace730ae)(true), $de50c0f740c66740$var$_a[0, $e5f8715adea0dc31$export$85f018eb7798fb52 /* @min:disableXhr */ ] = (0, $61c4d9dd4226f64e$export$bad0d7bace730ae)(), $de50c0f740c66740$var$_a[0, $e5f8715adea0dc31$export$d1f891e9714d3108 /* @min:onunloadDisableFetch */ ] = (0, $61c4d9dd4226f64e$export$bad0d7bace730ae)(), $de50c0f740c66740$var$_a[0, $e5f8715adea0dc31$export$6b8e1dc9b77f253c /* @min:onunloadDisableBeacon */ ] = (0, $61c4d9dd4226f64e$export$bad0d7bace730ae)(), $de50c0f740c66740$var$_a[0, $e5f8715adea0dc31$export$81cfd43387c8dbcc /* @min:instrumentationKey */ ] = $de50c0f740c66740$var$UNDEFINED_VALUE, $de50c0f740c66740$var$_a.namePrefix = $de50c0f740c66740$var$UNDEFINED_VALUE, $de50c0f740c66740$var$_a.samplingPercentage = (0, $61c4d9dd4226f64e$export$d0884590a6a82e6c)($de50c0f740c66740$var$_chkSampling, 100), $de50c0f740c66740$var$_a[0, $e5f8715adea0dc31$export$dbe59923e879fdc5 /* @min:customHeaders */ ] = $de50c0f740c66740$var$UNDEFINED_VALUE, $de50c0f740c66740$var$_a[0, $e5f8715adea0dc31$export$12df46deb7379c67 /* @min:convertUndefined */ ] = $de50c0f740c66740$var$UNDEFINED_VALUE, $de50c0f740c66740$var$_a[0, $e5f8715adea0dc31$export$c8dd872dc774fa7c /* @min:eventsLimitInMem */ ] = 10000, $de50c0f740c66740$var$_a[0, $e5f8715adea0dc31$export$4637bcb72c509e60 /* @min:bufferOverride */ ] = false, $de50c0f740c66740$var$_a));
function $de50c0f740c66740$var$_chkSampling(value) {
    return !isNaN(value) && value > 0 && value <= 100;
}
var $de50c0f740c66740$var$EnvelopeTypeCreator = ($de50c0f740c66740$var$_b = {}, $de50c0f740c66740$var$_b[(0, $9bdc8b7e7935e83a$export$d61e24a684f9e51).dataType] = (0, $0b044846db0c77e8$export$b74153364c2066d1), $de50c0f740c66740$var$_b[(0, $16adbdbcb0ae9015$export$78e1bea9036f120f).dataType] = (0, $0b044846db0c77e8$export$bc9e843f2eb8a61c), $de50c0f740c66740$var$_b[(0, $5c5f40703ef3d51c$export$12c0fdede1c6bc6c).dataType] = (0, $0b044846db0c77e8$export$edbb8a2c6529947a), $de50c0f740c66740$var$_b[(0, $27d410d508f4b32f$export$709aae57ec681346).dataType] = (0, $0b044846db0c77e8$export$bb801863268e7049), $de50c0f740c66740$var$_b[(0, $1e8d24b24fb574aa$export$e2f174de097e0bcd).dataType] = (0, $0b044846db0c77e8$export$eca78b65eeb356ed), $de50c0f740c66740$var$_b[(0, $659de0afdff509f2$export$efdd3e096bc27746).dataType] = (0, $0b044846db0c77e8$export$bb5bee4039a2e495), $de50c0f740c66740$var$_b[(0, $0dd1de134f090c69$export$a7b48490930dbffa).dataType] = (0, $0b044846db0c77e8$export$74e603a08a7deabe), $de50c0f740c66740$var$_b);
var $de50c0f740c66740$export$c5a96f3e01fb6582 = /** @class */ function(_super) {
    (0, $2a74b38b87b38cda$export$1f9c32e3fbfb8e62)(Sender, _super);
    function Sender() {
        var _this = _super.call(this) || this;
        _this.priority = 1001;
        _this.identifier = (0, $ca7353bd9238d340$export$a714a094d3058c99);
        // Don't set the defaults here, set them in the _initDefaults() as this is also called during unload
        var _consecutiveErrors; // How many times in a row a retryable error condition has occurred.
        var _retryAt; // The time to retry at in milliseconds from 1970/01/01 (this makes the timer calculation easy).
        var _lastSend; // The time of the last send operation.
        var _paused; // Flag indicating that the sending should be paused
        var _timeoutHandle; // Handle to the timer for delayed sending of batches of data.
        var _serializer;
        var _stamp_specific_redirects;
        var _headers;
        var _syncFetchPayload = 0; // Keep track of the outstanding sync fetch payload total (as sync fetch has limits)
        var _fallbackSender; // The sender to use if the payload size is too large
        var _syncUnloadSender; // The identified sender to use for the synchronous unload stage
        var _offlineListener;
        var _evtNamespace;
        var _endpointUrl;
        var _orgEndpointUrl;
        var _maxBatchSizeInBytes;
        var _beaconSupported;
        var _customHeaders;
        var _disableTelemetry;
        var _instrumentationKey;
        var _convertUndefined;
        var _isRetryDisabled;
        var _maxBatchInterval;
        var _sessionStorageUsed;
        var _bufferOverrideUsed;
        var _namePrefix;
        var _enableSendPromise;
        (0, $c9b63384299a3252$export$2e2bcd8739ae039)(Sender, _this, function(_self, _base) {
            _initDefaults();
            _self.pause = function() {
                _clearScheduledTimer();
                _paused = true;
            };
            _self.resume = function() {
                if (_paused) {
                    _paused = false;
                    _retryAt = null;
                    // flush if we have exceeded the max-size already
                    _checkMaxSize();
                    _setupTimer();
                }
            };
            _self.flush = function(isAsync, callBack, sendReason) {
                if (isAsync === void 0) isAsync = true;
                if (!_paused) {
                    // Clear the normal schedule timer as we are going to try and flush ASAP
                    _clearScheduledTimer();
                    try {
                        return _self[0, $e5f8715adea0dc31$export$df21ab0de9057cc4 /* @min:%2etriggerSend */ ](isAsync, null, sendReason || 1 /* SendRequestReason.ManualFlush */ );
                    } catch (e) {
                        (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(_self[0, $e5f8715adea0dc31$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), 1 /* eLoggingSeverity.CRITICAL */ , 22 /* _eInternalMessageId.FlushFailed */ , "flush failed, telemetry will not be collected: " + (0, $0b747974b0bb3563$export$39c4487b36c98fec)(e), {
                            exception: (0, $386f00e3a193a7da$export$21fce7cbd4dc679f)(e)
                        });
                    }
                }
            };
            _self.onunloadFlush = function() {
                if (!_paused) {
                    if (_beaconSupported) try {
                        return _self[0, $e5f8715adea0dc31$export$df21ab0de9057cc4 /* @min:%2etriggerSend */ ](true, _doUnloadSend, 2 /* SendRequestReason.Unload */ );
                    } catch (e) {
                        (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(_self[0, $e5f8715adea0dc31$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), 1 /* eLoggingSeverity.CRITICAL */ , 20 /* _eInternalMessageId.FailedToSendQueuedTelemetry */ , "failed to flush with beacon sender on page unload, telemetry will not be collected: " + (0, $0b747974b0bb3563$export$39c4487b36c98fec)(e), {
                            exception: (0, $386f00e3a193a7da$export$21fce7cbd4dc679f)(e)
                        });
                    }
                    else _self.flush(false);
                }
            };
            _self.addHeader = function(name, value) {
                _headers[name] = value;
            };
            _self.initialize = function(config, core, extensions, pluginChain) {
                if (_self.isInitialized()) (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(_self[0, $e5f8715adea0dc31$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), 1 /* eLoggingSeverity.CRITICAL */ , 28 /* _eInternalMessageId.SenderNotInitialized */ , "Sender is already initialized");
                _base.initialize(config, core, extensions, pluginChain);
                var identifier = _self.identifier;
                _serializer = new (0, $2c9268977b2520db$export$ef852775387a0be7)(core.logger);
                _consecutiveErrors = 0;
                _retryAt = null;
                _lastSend = 0;
                _self[0, $e5f8715adea0dc31$export$e5390b88ba6f1b04 /* @min:%2e_sender */ ] = null;
                _stamp_specific_redirects = 0;
                var diagLog = _self[0, $e5f8715adea0dc31$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ]();
                _evtNamespace = (0, $12cc003c7fb5ccde$export$3f37a50e0edde3be)((0, $8a2d104e2647a310$export$eb4a6badb18ead04)("Sender"), core.evtNamespace && core.evtNamespace());
                _offlineListener = (0, $9f852541a61ca36f$export$798b7fe42d5e3d06)(_evtNamespace);
                // This function will be re-called whenever any referenced configuration is changed
                _self._addHook((0, $acb30f9e62dc5705$export$454a433e4deb244f)(config, function(details) {
                    var config = details.cfg;
                    var ctx = (0, $bc7124acb0f73e64$export$ca98f11e981bcfd6)(null, config, core);
                    var senderConfig = ctx.getExtCfg(identifier, $de50c0f740c66740$var$defaultAppInsightsChannelConfig);
                    (0, $d212d948d25f959a$export$d0d2ebf910ad6e2)(_self, "_senderConfig", {
                        g: function() {
                            return senderConfig;
                        }
                    });
                    // Only update the endpoint if the original config !== the current config
                    // This is so any redirect endpointUrl is not overwritten
                    if (_orgEndpointUrl !== senderConfig.endpointUrl) {
                        _orgEndpointUrl;
                        _endpointUrl = _orgEndpointUrl = senderConfig.endpointUrl;
                    }
                    if (_customHeaders && _customHeaders !== senderConfig[0, $e5f8715adea0dc31$export$dbe59923e879fdc5 /* @min:%2ecustomHeaders */ ]) // Removing any previously defined custom headers as they have changed
                    (0, $f6bb085f8cf12216$export$e2e5bcdbdc49c586)(_customHeaders, function(customHeader) {
                        delete _headers[customHeader.header];
                    });
                    _maxBatchSizeInBytes = senderConfig[0, $e5f8715adea0dc31$export$803d432e48ba5ceb /* @min:%2emaxBatchSizeInBytes */ ];
                    _beaconSupported = (senderConfig[0, $e5f8715adea0dc31$export$6b8e1dc9b77f253c /* @min:%2eonunloadDisableBeacon */ ] === false || senderConfig[0, $e5f8715adea0dc31$export$f5629284a6f7ec3d /* @min:%2eisBeaconApiDisabled */ ] === false) && (0, $0c599844349363c4$export$cf496c79c05967a0)();
                    var bufferOverride = senderConfig[0, $e5f8715adea0dc31$export$4637bcb72c509e60 /* @min:%2ebufferOverride */ ];
                    var canUseSessionStorage = !!senderConfig[0, $e5f8715adea0dc31$export$782dd40ba58c3597 /* @min:%2eenableSessionStorageBuffer */ ] && (!!bufferOverride || (0, $8e03bdff803b84be$export$c81985c4209bac26)());
                    var namePrefix = senderConfig.namePrefix;
                    //Note: emitLineDelimitedJson and eventsLimitInMem is directly accessed via config in senderBuffer
                    //Therefore, if canUseSessionStorage is not changed, we do not need to re initialize a new one
                    var shouldUpdate = canUseSessionStorage !== _sessionStorageUsed || canUseSessionStorage && _namePrefix !== namePrefix // prefixName is only used in session storage
                     || canUseSessionStorage && _bufferOverrideUsed !== bufferOverride;
                    if (_self[0, $e5f8715adea0dc31$export$3f8a6394c5f7e7be /* @min:%2e_buffer */ ]) {
                        // case1 (Pre and Now enableSessionStorageBuffer settings are same)
                        // if namePrefix changes, transfer current buffer to new buffer
                        // else no action needed
                        //case2 (Pre and Now enableSessionStorageBuffer settings are changed)
                        // transfer current buffer to new buffer
                        if (shouldUpdate) try {
                            _self._buffer = _self._buffer[0, $e5f8715adea0dc31$export$1e6514b499ba4d34 /* @min:%2ecreateNew */ ](diagLog, senderConfig, canUseSessionStorage);
                        } catch (e) {
                            (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(_self[0, $e5f8715adea0dc31$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), 1 /* eLoggingSeverity.CRITICAL */ , 12 /* _eInternalMessageId.FailedAddingTelemetryToBuffer */ , "failed to transfer telemetry to different buffer storage, telemetry will be lost: " + (0, $0b747974b0bb3563$export$39c4487b36c98fec)(e), {
                                exception: (0, $386f00e3a193a7da$export$21fce7cbd4dc679f)(e)
                            });
                        }
                        _checkMaxSize();
                    } else _self[0, $e5f8715adea0dc31$export$3f8a6394c5f7e7be /* @min:%2e_buffer */ ] = canUseSessionStorage ? new (0, $633f36e5bb6b03ff$export$dcb776947c16915f)(diagLog, senderConfig) : new (0, $633f36e5bb6b03ff$export$d706e5fd60d36d56)(diagLog, senderConfig);
                    _namePrefix = namePrefix;
                    _sessionStorageUsed = canUseSessionStorage;
                    _bufferOverrideUsed = bufferOverride;
                    _self._sample = new (0, $9c8a4bf222316b8c$export$21a3eccb8a1780eb)(senderConfig.samplingPercentage, diagLog);
                    _instrumentationKey = senderConfig[0, $e5f8715adea0dc31$export$81cfd43387c8dbcc /* @min:%2einstrumentationKey */ ];
                    if (!_validateInstrumentationKey(_instrumentationKey, config)) (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(diagLog, 1 /* eLoggingSeverity.CRITICAL */ , 100 /* _eInternalMessageId.InvalidInstrumentationKey */ , "Invalid Instrumentation key " + _instrumentationKey);
                    _customHeaders = senderConfig[0, $e5f8715adea0dc31$export$dbe59923e879fdc5 /* @min:%2ecustomHeaders */ ];
                    if (!(0, $d98b699aeccdabc6$export$edade5317663baa4)(_endpointUrl) && _customHeaders && _customHeaders[0, $e5f8715adea0dc31$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) (0, $f6bb085f8cf12216$export$e2e5bcdbdc49c586)(_customHeaders, function(customHeader) {
                        _this.addHeader(customHeader.header, customHeader.value);
                    });
                    else _customHeaders = null;
                    _enableSendPromise = senderConfig.enableSendPromise;
                    var sendPostFunc = null;
                    if (!senderConfig[0, $e5f8715adea0dc31$export$85f018eb7798fb52 /* @min:%2edisableXhr */ ] && (0, $0c599844349363c4$export$b9f2bc09e5ac0fa5)()) sendPostFunc = _xdrSender; // IE 8 and 9
                    else if (!senderConfig[0, $e5f8715adea0dc31$export$85f018eb7798fb52 /* @min:%2edisableXhr */ ] && (0, $0c599844349363c4$export$cfeac9aa070f0108)()) sendPostFunc = _xhrSender;
                    if (!sendPostFunc && (0, $0c599844349363c4$export$f8c1c61350d9749)()) sendPostFunc = _fetchSender;
                    // always fallback to XHR
                    _fallbackSender = sendPostFunc || _xhrSender;
                    if (!senderConfig[0, $e5f8715adea0dc31$export$f5629284a6f7ec3d /* @min:%2eisBeaconApiDisabled */ ] && (0, $0c599844349363c4$export$cf496c79c05967a0)()) // Config is set to always used beacon sending
                    sendPostFunc = _beaconSender;
                    _self[0, $e5f8715adea0dc31$export$e5390b88ba6f1b04 /* @min:%2e_sender */ ] = sendPostFunc || _xhrSender;
                    if (!senderConfig[0, $e5f8715adea0dc31$export$d1f891e9714d3108 /* @min:%2eonunloadDisableFetch */ ] && (0, $0c599844349363c4$export$f8c1c61350d9749)(true)) // Try and use the fetch with keepalive
                    _syncUnloadSender = _fetchKeepAliveSender;
                    else if ((0, $0c599844349363c4$export$cf496c79c05967a0)()) // Try and use sendBeacon
                    _syncUnloadSender = _beaconSender;
                    else if (!senderConfig[0, $e5f8715adea0dc31$export$85f018eb7798fb52 /* @min:%2edisableXhr */ ] && (0, $0c599844349363c4$export$b9f2bc09e5ac0fa5)()) _syncUnloadSender = _xdrSender; // IE 8 and 9
                    else if (!senderConfig[0, $e5f8715adea0dc31$export$85f018eb7798fb52 /* @min:%2edisableXhr */ ] && (0, $0c599844349363c4$export$cfeac9aa070f0108)()) _syncUnloadSender = _xhrSender;
                    else _syncUnloadSender = _fallbackSender;
                    _disableTelemetry = senderConfig.disableTelemetry;
                    _convertUndefined = senderConfig[0, $e5f8715adea0dc31$export$12df46deb7379c67 /* @min:%2econvertUndefined */ ] || $de50c0f740c66740$var$UNDEFINED_VALUE;
                    _isRetryDisabled = senderConfig.isRetryDisabled;
                    _maxBatchInterval = senderConfig[0, $e5f8715adea0dc31$export$983774f06380e463 /* @min:%2emaxBatchInterval */ ];
                }));
            };
            _self.processTelemetry = function(telemetryItem, itemCtx) {
                itemCtx = _self._getTelCtx(itemCtx);
                var diagLogger = itemCtx[0, $e5f8715adea0dc31$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ]();
                try {
                    // if master off switch is set, don't send any data
                    if (_disableTelemetry) // Do not send/save data
                    return;
                    // validate input
                    if (!telemetryItem) {
                        (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(diagLogger, 1 /* eLoggingSeverity.CRITICAL */ , 7 /* _eInternalMessageId.CannotSendEmptyTelemetry */ , "Cannot send empty telemetry");
                        return;
                    }
                    // validate event
                    if (telemetryItem.baseData && !telemetryItem[0, $e5f8715adea0dc31$export$aa558e99f83347cf /* @min:%2ebaseType */ ]) {
                        (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(diagLogger, 1 /* eLoggingSeverity.CRITICAL */ , 70 /* _eInternalMessageId.InvalidEvent */ , "Cannot send telemetry without baseData and baseType");
                        return;
                    }
                    if (!telemetryItem[0, $e5f8715adea0dc31$export$aa558e99f83347cf /* @min:%2ebaseType */ ]) // Default
                    telemetryItem[0, $e5f8715adea0dc31$export$aa558e99f83347cf /* @min:%2ebaseType */ ] = "EventData";
                    // ensure a sender was constructed
                    if (!_self[0, $e5f8715adea0dc31$export$e5390b88ba6f1b04 /* @min:%2e_sender */ ]) {
                        (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(diagLogger, 1 /* eLoggingSeverity.CRITICAL */ , 28 /* _eInternalMessageId.SenderNotInitialized */ , "Sender was not initialized");
                        return;
                    }
                    // check if this item should be sampled in, else add sampleRate tag
                    if (!_isSampledIn(telemetryItem)) {
                        // Item is sampled out, do not send it
                        (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(diagLogger, 2 /* eLoggingSeverity.WARNING */ , 33 /* _eInternalMessageId.TelemetrySampledAndNotSent */ , "Telemetry item was sampled out and not sent", {
                            SampleRate: _self._sample[0, $e5f8715adea0dc31$export$c2afe23fa18f9dff /* @min:%2esampleRate */ ]
                        });
                        return;
                    } else telemetryItem[0, $71dfba5ea0640485$export$dc288b6444e20c04] = _self._sample[0, $e5f8715adea0dc31$export$c2afe23fa18f9dff /* @min:%2esampleRate */ ];
                    // construct an envelope that Application Insights endpoint can understand
                    // if ikey of telemetry is provided and not empty, envelope will use this iKey instead of senderConfig iKey
                    var defaultEnvelopeIkey = telemetryItem.iKey || _instrumentationKey;
                    var aiEnvelope_1 = Sender.constructEnvelope(telemetryItem, defaultEnvelopeIkey, diagLogger, _convertUndefined);
                    if (!aiEnvelope_1) {
                        (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(diagLogger, 1 /* eLoggingSeverity.CRITICAL */ , 47 /* _eInternalMessageId.CreateEnvelopeError */ , "Unable to create an AppInsights envelope");
                        return;
                    }
                    var doNotSendItem_1 = false;
                    // this is for running in legacy mode, where customer may already have a custom initializer present
                    if (telemetryItem[0, $e5f8715adea0dc31$export$d0f526aa8043f6d7 /* @min:%2etags */ ] && telemetryItem[0, $e5f8715adea0dc31$export$d0f526aa8043f6d7 /* @min:%2etags */ ][0, $71dfba5ea0640485$export$ea8a69bf327def66]) {
                        (0, $f6bb085f8cf12216$export$e2e5bcdbdc49c586)(telemetryItem[0, $e5f8715adea0dc31$export$d0f526aa8043f6d7 /* @min:%2etags */ ][0, $71dfba5ea0640485$export$ea8a69bf327def66], function(callBack) {
                            try {
                                if (callBack && callBack(aiEnvelope_1) === false) {
                                    doNotSendItem_1 = true;
                                    (0, $cc2aaaebf96ac6a7$export$25fb4cb97863f0a8)(diagLogger, "Telemetry processor check returns false");
                                }
                            } catch (e) {
                                // log error but dont stop executing rest of the telemetry initializers
                                // doNotSendItem = true;
                                (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(diagLogger, 1 /* eLoggingSeverity.CRITICAL */ , 64 /* _eInternalMessageId.TelemetryInitializerFailed */ , "One of telemetry initializers failed, telemetry item will not be sent: " + (0, $0b747974b0bb3563$export$39c4487b36c98fec)(e), {
                                    exception: (0, $386f00e3a193a7da$export$21fce7cbd4dc679f)(e)
                                }, true);
                            }
                        });
                        delete telemetryItem[0, $e5f8715adea0dc31$export$d0f526aa8043f6d7 /* @min:%2etags */ ][0, $71dfba5ea0640485$export$ea8a69bf327def66];
                    }
                    if (doNotSendItem_1) return; // do not send, no need to execute next plugin
                    // check if the incoming payload is too large, truncate if necessary
                    var payload = _serializer.serialize(aiEnvelope_1);
                    // flush if we would exceed the max-size limit by adding this item
                    var buffer = _self[0, $e5f8715adea0dc31$export$3f8a6394c5f7e7be /* @min:%2e_buffer */ ];
                    _checkMaxSize(payload);
                    // enqueue the payload
                    buffer[0, $e5f8715adea0dc31$export$4aae77f3ba3c48b4 /* @min:%2eenqueue */ ](payload);
                    // ensure an invocation timeout is set
                    _setupTimer();
                } catch (e) {
                    (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(diagLogger, 2 /* eLoggingSeverity.WARNING */ , 12 /* _eInternalMessageId.FailedAddingTelemetryToBuffer */ , "Failed adding telemetry to the sender's buffer, some telemetry will be lost: " + (0, $0b747974b0bb3563$export$39c4487b36c98fec)(e), {
                        exception: (0, $386f00e3a193a7da$export$21fce7cbd4dc679f)(e)
                    });
                }
                // hand off the telemetry item to the next plugin
                _self.processNext(telemetryItem, itemCtx);
            };
            /**
             * xhr state changes
             */ _self[0, $e5f8715adea0dc31$export$9b55da9813cf231b /* @min:%2e_xhrReadyStateChange */ ] = function(xhr, payload, countOfItemsInPayload) {
                if (xhr.readyState === 4) _checkResponsStatus(xhr.status, payload, xhr.responseURL, countOfItemsInPayload, _formatErrorMessageXhr(xhr), $de50c0f740c66740$var$_getResponseText(xhr) || xhr.response);
            };
            /**
             * Immediately send buffered data
             * @param async - {boolean} - Indicates if the events should be sent asynchronously
             * @param forcedSender - {SenderFunction} - Indicates the forcedSender, undefined if not passed
             */ _self[0, $e5f8715adea0dc31$export$df21ab0de9057cc4 /* @min:%2etriggerSend */ ] = function(async, forcedSender, sendReason) {
                if (async === void 0) async = true;
                var result;
                if (!_paused) try {
                    var buffer = _self[0, $e5f8715adea0dc31$export$3f8a6394c5f7e7be /* @min:%2e_buffer */ ];
                    // Send data only if disableTelemetry is false
                    if (!_disableTelemetry) {
                        if (buffer[0, $e5f8715adea0dc31$export$e9679ef501b0d1 /* @min:%2ecount */ ]() > 0) {
                            var payload = buffer.getItems();
                            _notifySendRequest(sendReason || 0 /* SendRequestReason.Undefined */ , async);
                            // invoke send
                            if (forcedSender) result = forcedSender.call(_self, payload, async);
                            else result = _self[0, $e5f8715adea0dc31$export$e5390b88ba6f1b04 /* @min:%2e_sender */ ](payload, async);
                        }
                        // update lastSend time to enable throttling
                        _lastSend = +new Date;
                    } else buffer[0, $e5f8715adea0dc31$export$5eeb73fac03da74a /* @min:%2eclear */ ]();
                    _clearScheduledTimer();
                } catch (e) {
                    /* Ignore this error for IE under v10 */ var ieVer = (0, $0c599844349363c4$export$eb7ff627fa81c42e)();
                    if (!ieVer || ieVer > 9) (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(_self[0, $e5f8715adea0dc31$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), 1 /* eLoggingSeverity.CRITICAL */ , 40 /* _eInternalMessageId.TransmissionFailed */ , "Telemetry transmission failed, some telemetry will be lost: " + (0, $0b747974b0bb3563$export$39c4487b36c98fec)(e), {
                        exception: (0, $386f00e3a193a7da$export$21fce7cbd4dc679f)(e)
                    });
                }
                return result;
            };
            _self._doTeardown = function(unloadCtx, unloadState) {
                _self.onunloadFlush();
                (0, $2cb93c1cbddb67ab$export$86347c3dd68c03f6)(_offlineListener, false);
                _initDefaults();
            };
            /**
             * error handler
             */ _self[0, $e5f8715adea0dc31$export$fd0c91d4da43d71b /* @min:%2e_onError */ ] = function(payload, message, event) {
                (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(_self[0, $e5f8715adea0dc31$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), 2 /* eLoggingSeverity.WARNING */ , 26 /* _eInternalMessageId.OnError */ , "Failed to send telemetry.", {
                    message: message
                });
                _self._buffer && _self._buffer[0, $e5f8715adea0dc31$export$13da1b5a005ef035 /* @min:%2eclearSent */ ](payload);
            };
            /**
             * partial success handler
             */ _self[0, $e5f8715adea0dc31$export$689c49d56ac33585 /* @min:%2e_onPartialSuccess */ ] = function(payload, results) {
                var failed = [];
                var retry = [];
                // Iterate through the reversed array of errors so that splicing doesn't have invalid indexes after the first item.
                var errors = results.errors.reverse();
                for(var _i = 0, errors_1 = errors; _i < errors_1.length; _i++){
                    var error = errors_1[_i];
                    var extracted = payload.splice(error.index, 1)[0];
                    if (_isRetriable(error.statusCode)) retry[0, $e5f8715adea0dc31$export$a0a330e7fa1e278c /* @min:%2epush */ ](extracted);
                    else // All other errors, including: 402 (Monthly quota exceeded) and 439 (Too many requests and refresh cache).
                    failed[0, $e5f8715adea0dc31$export$a0a330e7fa1e278c /* @min:%2epush */ ](extracted);
                }
                if (payload[0, $e5f8715adea0dc31$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) _self[0, $e5f8715adea0dc31$export$82a109ffee49e423 /* @min:%2e_onSuccess */ ](payload, results[0, $e5f8715adea0dc31$export$fb8523c8667e286a /* @min:%2eitemsAccepted */ ]);
                if (failed[0, $e5f8715adea0dc31$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) _self[0, $e5f8715adea0dc31$export$fd0c91d4da43d71b /* @min:%2e_onError */ ](failed, _formatErrorMessageXhr(null, [
                    "partial success",
                    results[0, $e5f8715adea0dc31$export$fb8523c8667e286a /* @min:%2eitemsAccepted */ ],
                    "of",
                    results.itemsReceived
                ].join(" ")));
                if (retry[0, $e5f8715adea0dc31$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) {
                    _resendPayload(retry);
                    (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(_self[0, $e5f8715adea0dc31$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), 2 /* eLoggingSeverity.WARNING */ , 40 /* _eInternalMessageId.TransmissionFailed */ , "Partial success. Delivered: " + payload[0, $e5f8715adea0dc31$export$6eae51590aaea43 /* @min:%2elength */ ] + ", Failed: " + failed[0, $e5f8715adea0dc31$export$6eae51590aaea43 /* @min:%2elength */ ] + ". Will retry to send " + retry[0, $e5f8715adea0dc31$export$6eae51590aaea43 /* @min:%2elength */ ] + " our of " + results[0, $e5f8715adea0dc31$export$746df81af2cb9d94 /* @min:%2eitemsReceived */ ] + " items");
                }
            };
            /**
             * success handler
             */ _self[0, $e5f8715adea0dc31$export$82a109ffee49e423 /* @min:%2e_onSuccess */ ] = function(payload, countOfItemsInPayload) {
                _self._buffer && _self._buffer[0, $e5f8715adea0dc31$export$13da1b5a005ef035 /* @min:%2eclearSent */ ](payload);
            };
            /**
             * xdr state changes
             */ _self._xdrOnLoad = function(xdr, payload) {
                var responseText = $de50c0f740c66740$var$_getResponseText(xdr);
                if (xdr && (responseText + "" === "200" || responseText === "")) {
                    _consecutiveErrors = 0;
                    _self[0, $e5f8715adea0dc31$export$82a109ffee49e423 /* @min:%2e_onSuccess */ ](payload, 0);
                } else {
                    var results = _parseResponse(responseText);
                    if (results && results.itemsReceived && results.itemsReceived > results[0, $e5f8715adea0dc31$export$fb8523c8667e286a /* @min:%2eitemsAccepted */ ] && !_isRetryDisabled) _self[0, $e5f8715adea0dc31$export$689c49d56ac33585 /* @min:%2e_onPartialSuccess */ ](payload, results);
                    else _self[0, $e5f8715adea0dc31$export$fd0c91d4da43d71b /* @min:%2e_onError */ ](payload, _formatErrorMessageXdr(xdr));
                }
            };
            function _isSampledIn(envelope) {
                return _self._sample.isSampledIn(envelope);
            }
            function _checkMaxSize(incomingPayload) {
                var incomingSize = incomingPayload ? incomingPayload[0, $e5f8715adea0dc31$export$6eae51590aaea43 /* @min:%2elength */ ] : 0;
                if (_self[0, $e5f8715adea0dc31$export$3f8a6394c5f7e7be /* @min:%2e_buffer */ ].size() + incomingSize > _maxBatchSizeInBytes) {
                    if (!_offlineListener || _offlineListener[0, $e5f8715adea0dc31$export$704cf8098f85ad0f /* @min:%2eisOnline */ ]()) _self[0, $e5f8715adea0dc31$export$df21ab0de9057cc4 /* @min:%2etriggerSend */ ](true, null, 10 /* SendRequestReason.MaxBatchSize */ );
                    return true;
                }
                return false;
            }
            function _checkResponsStatus(status, payload, responseUrl, countOfItemsInPayload, errorMessage, res) {
                var response = null;
                if (!_self._appId) {
                    response = _parseResponse(res);
                    if (response && response.appId) _self._appId = response.appId;
                }
                if ((status < 200 || status >= 300) && status !== 0) {
                    // Update End Point url if permanent redirect or moved permanently
                    // Updates the end point url before retry
                    if (status === 301 || status === 307 || status === 308) {
                        if (!_checkAndUpdateEndPointUrl(responseUrl)) {
                            _self[0, $e5f8715adea0dc31$export$fd0c91d4da43d71b /* @min:%2e_onError */ ](payload, errorMessage);
                            return;
                        }
                    }
                    if (!_isRetryDisabled && _isRetriable(status)) {
                        _resendPayload(payload);
                        (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(_self[0, $e5f8715adea0dc31$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), 2 /* eLoggingSeverity.WARNING */ , 40 /* _eInternalMessageId.TransmissionFailed */ , ". Response code " + status + ". Will retry to send " + payload[0, $e5f8715adea0dc31$export$6eae51590aaea43 /* @min:%2elength */ ] + " items.");
                    } else _self[0, $e5f8715adea0dc31$export$fd0c91d4da43d71b /* @min:%2e_onError */ ](payload, errorMessage);
                } else if (_offlineListener && !_offlineListener[0, $e5f8715adea0dc31$export$704cf8098f85ad0f /* @min:%2eisOnline */ ]()) // Note: Don't check for status == 0, since adblock gives this code
                {
                    if (!_isRetryDisabled) {
                        var offlineBackOffMultiplier = 10; // arbritrary number
                        _resendPayload(payload, offlineBackOffMultiplier);
                        (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(_self[0, $e5f8715adea0dc31$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), 2 /* eLoggingSeverity.WARNING */ , 40 /* _eInternalMessageId.TransmissionFailed */ , ". Offline - Response Code: ".concat(status, ". Offline status: ").concat(!_offlineListener.isOnline(), ". Will retry to send ").concat(payload.length, " items."));
                    }
                } else {
                    // check if the xhr's responseURL or fetch's response.url is same as endpoint url
                    // TODO after 10 redirects force send telemetry with 'redirect=false' as query parameter.
                    _checkAndUpdateEndPointUrl(responseUrl);
                    if (status === 206) {
                        if (!response) response = _parseResponse(res);
                        if (response && !_isRetryDisabled) _self[0, $e5f8715adea0dc31$export$689c49d56ac33585 /* @min:%2e_onPartialSuccess */ ](payload, response);
                        else _self[0, $e5f8715adea0dc31$export$fd0c91d4da43d71b /* @min:%2e_onError */ ](payload, errorMessage);
                    } else {
                        _consecutiveErrors = 0;
                        _self[0, $e5f8715adea0dc31$export$82a109ffee49e423 /* @min:%2e_onSuccess */ ](payload, countOfItemsInPayload);
                    }
                }
            }
            function _checkAndUpdateEndPointUrl(responseUrl) {
                // Maximum stamp specific redirects allowed(uncomment this when breeze is ready with not allowing redirects feature)
                if (_stamp_specific_redirects >= 10) //  _self._senderConfig.endpointUrl = () => Sender._getDefaultAppInsightsChannelConfig().endpointUrl()+"/?redirect=false";
                //  _stamp_specific_redirects = 0;
                return false;
                if (!(0, $533f826bbc418791$export$bedb7023a7733221)(responseUrl) && responseUrl !== "") {
                    if (responseUrl !== _endpointUrl) {
                        _endpointUrl = responseUrl;
                        ++_stamp_specific_redirects;
                        return true;
                    }
                }
                return false;
            }
            function _doUnloadSend(payload, isAsync) {
                if (_syncUnloadSender) // We are unloading so always call the sender with sync set to false
                _syncUnloadSender(payload, false);
                else // Fallback to the previous beacon Sender (which causes a CORB warning on chrome now)
                _beaconSender(payload, isAsync);
            }
            function _doBeaconSend(payload) {
                var nav = (0, $3d5fcb60a9467a45$export$a56241c767c1d89f)();
                var buffer = _self[0, $e5f8715adea0dc31$export$3f8a6394c5f7e7be /* @min:%2e_buffer */ ];
                var url = _endpointUrl;
                var batch = _self._buffer[0, $e5f8715adea0dc31$export$a5da323a4da829fc /* @min:%2ebatchPayloads */ ](payload);
                // Chrome only allows CORS-safelisted values for the sendBeacon data argument
                // see: https://bugs.chromium.org/p/chromium/issues/detail?id=720283
                var plainTextBatch = new Blob([
                    batch
                ], {
                    type: "text/plain;charset=UTF-8"
                });
                // The sendBeacon method returns true if the user agent is able to successfully queue the data for transfer. Otherwise it returns false.
                var queued = nav.sendBeacon(url, plainTextBatch);
                if (queued) {
                    buffer[0, $e5f8715adea0dc31$export$52e50651d87300e3 /* @min:%2emarkAsSent */ ](payload);
                    // no response from beaconSender, clear buffer
                    _self._onSuccess(payload, payload[0, $e5f8715adea0dc31$export$6eae51590aaea43 /* @min:%2elength */ ]);
                }
                return queued;
            }
            /**
             * Send Beacon API request
             * @param payload - {string} - The data payload to be sent.
             * @param isAsync - {boolean} - not used
             * Note: Beacon API does not support custom headers and we are not able to get
             * appId from the backend for the correct correlation.
             */ function _beaconSender(payload, isAsync) {
                if ((0, $533f826bbc418791$export$43bee75e5e14138e)(payload) && payload[0, $e5f8715adea0dc31$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) // The sendBeacon method returns true if the user agent is able to successfully queue the data for transfer. Otherwise it returns false.
                {
                    if (!_doBeaconSend(payload)) {
                        // Failed to send entire payload so try and split data and try to send as much events as possible
                        var droppedPayload = [];
                        for(var lp = 0; lp < payload[0, $e5f8715adea0dc31$export$6eae51590aaea43 /* @min:%2elength */ ]; lp++){
                            var thePayload = payload[lp];
                            if (!_doBeaconSend([
                                thePayload
                            ])) // Can't send anymore, so split the batch and drop the rest
                            droppedPayload[0, $e5f8715adea0dc31$export$a0a330e7fa1e278c /* @min:%2epush */ ](thePayload);
                        }
                        if (droppedPayload[0, $e5f8715adea0dc31$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) {
                            _fallbackSender && _fallbackSender(droppedPayload, true);
                            (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(_self[0, $e5f8715adea0dc31$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), 2 /* eLoggingSeverity.WARNING */ , 40 /* _eInternalMessageId.TransmissionFailed */ , ". Failed to send telemetry with Beacon API, retried with normal sender.");
                        }
                    }
                }
            }
            /**
             * Send XMLHttpRequest
             * @param payload - {string} - The data payload to be sent.
             * @param isAsync - {boolean} - Indicates if the request should be sent asynchronously
             */ function _xhrSender(payload, isAsync) {
                var thePromise;
                var resolveFunc;
                var rejectFunc;
                var xhr = new XMLHttpRequest();
                var endPointUrl = _endpointUrl;
                try {
                    xhr[0, $71dfba5ea0640485$export$7c6abff2f2bdd9c0] = true;
                } catch (e) {
                // If the environment has locked down the XMLHttpRequest (preventExtensions and/or freeze), this would
                // cause the request to fail and we no telemetry would be sent
                }
                xhr.open("POST", endPointUrl, isAsync);
                xhr[0, $e5f8715adea0dc31$export$84ecd29f369f5b1d /* @min:%2esetRequestHeader */ ]("Content-type", "application/json");
                // append Sdk-Context request header only in case of breeze endpoint
                if ((0, $d98b699aeccdabc6$export$edade5317663baa4)(endPointUrl)) xhr[0, $e5f8715adea0dc31$export$84ecd29f369f5b1d /* @min:%2esetRequestHeader */ ]((0, $78a4729d55fca66a$export$e499e02a1fe05177)[6 /* eRequestHeaders.sdkContextHeader */ ], (0, $78a4729d55fca66a$export$e499e02a1fe05177)[7 /* eRequestHeaders.sdkContextHeaderAppIdRequest */ ]);
                (0, $f6bb085f8cf12216$export$e2e5bcdbdc49c586)((0, $36a077d9f4439b69$export$f7628dc18f4211e5)(_headers), function(headerName) {
                    xhr[0, $e5f8715adea0dc31$export$84ecd29f369f5b1d /* @min:%2esetRequestHeader */ ](headerName, _headers[headerName]);
                });
                xhr.onreadystatechange = function() {
                    _self._xhrReadyStateChange(xhr, payload, payload[0, $e5f8715adea0dc31$export$6eae51590aaea43 /* @min:%2elength */ ]);
                    if (xhr.readyState === 4) resolveFunc && resolveFunc(true);
                };
                xhr.onerror = function(event) {
                    _self[0, $e5f8715adea0dc31$export$fd0c91d4da43d71b /* @min:%2e_onError */ ](payload, _formatErrorMessageXhr(xhr), event);
                    rejectFunc && rejectFunc(event);
                };
                if (isAsync && _enableSendPromise) thePromise = (0, $911d39c591a62618$export$5a1eb20c68656e88)(function(resolve, reject) {
                    resolveFunc = resolve;
                    rejectFunc = reject;
                });
                // compose an array of payloads
                var batch = _self._buffer[0, $e5f8715adea0dc31$export$a5da323a4da829fc /* @min:%2ebatchPayloads */ ](payload);
                xhr.send(batch);
                _self._buffer[0, $e5f8715adea0dc31$export$52e50651d87300e3 /* @min:%2emarkAsSent */ ](payload);
                return thePromise;
            }
            function _fetchKeepAliveSender(payload, isAsync) {
                if ((0, $533f826bbc418791$export$43bee75e5e14138e)(payload)) {
                    var payloadSize = payload[0, $e5f8715adea0dc31$export$6eae51590aaea43 /* @min:%2elength */ ];
                    for(var lp = 0; lp < payload[0, $e5f8715adea0dc31$export$6eae51590aaea43 /* @min:%2elength */ ]; lp++)payloadSize += payload[lp][0, $e5f8715adea0dc31$export$6eae51590aaea43 /* @min:%2elength */ ];
                    if (_syncFetchPayload + payloadSize <= $de50c0f740c66740$var$FetchSyncRequestSizeLimitBytes) _doFetchSender(payload, false);
                    else if ((0, $0c599844349363c4$export$cf496c79c05967a0)()) // Fallback to beacon sender as we at least get told which events can't be scheduled
                    _beaconSender(payload, isAsync);
                    else {
                        // Payload is going to be too big so just try and send via XHR
                        _fallbackSender && _fallbackSender(payload, true);
                        (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(_self[0, $e5f8715adea0dc31$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), 2 /* eLoggingSeverity.WARNING */ , 40 /* _eInternalMessageId.TransmissionFailed */ , ". Failed to send telemetry with Beacon API, retried with xhrSender.");
                    }
                }
            }
            /**
             * Send fetch API request
             * @param payload - {string} - The data payload to be sent.
             * @param isAsync - {boolean} - not used
             */ function _fetchSender(payload, isAsync) {
                return _doFetchSender(payload, true);
            }
            /**
             * Send fetch API request
             * @param payload - {string} - The data payload to be sent.
             * @param isAsync - {boolean} - For fetch this identifies whether we are "unloading" (false) or a normal request
             */ function _doFetchSender(payload, isAsync) {
                var _a;
                var endPointUrl = _endpointUrl;
                var batch = _self._buffer[0, $e5f8715adea0dc31$export$a5da323a4da829fc /* @min:%2ebatchPayloads */ ](payload);
                var plainTextBatch = new Blob([
                    batch
                ], {
                    type: "application/json"
                });
                var thePromise;
                var resolveFunc;
                var rejectFunc;
                var requestHeaders = new Headers();
                var batchLength = batch[0, $e5f8715adea0dc31$export$6eae51590aaea43 /* @min:%2elength */ ];
                var ignoreResponse = false;
                var responseHandled = false;
                // append Sdk-Context request header only in case of breeze endpoint
                if ((0, $d98b699aeccdabc6$export$edade5317663baa4)(endPointUrl)) requestHeaders.append((0, $78a4729d55fca66a$export$e499e02a1fe05177)[6 /* eRequestHeaders.sdkContextHeader */ ], (0, $78a4729d55fca66a$export$e499e02a1fe05177)[7 /* eRequestHeaders.sdkContextHeaderAppIdRequest */ ]);
                (0, $f6bb085f8cf12216$export$e2e5bcdbdc49c586)((0, $36a077d9f4439b69$export$f7628dc18f4211e5)(_headers), function(headerName) {
                    requestHeaders.append(headerName, _headers[headerName]);
                });
                var init = (_a = {
                    method: "POST",
                    headers: requestHeaders,
                    body: plainTextBatch
                }, _a[0, $71dfba5ea0640485$export$7c6abff2f2bdd9c0] = true // Mark so we don't attempt to track this request
                , _a);
                if (!isAsync) {
                    init.keepalive = true;
                    // As a sync request (during unload), it is unlikely that we will get a chance to process the response so
                    // just like beacon send assume that the events have been accepted and processed
                    ignoreResponse = true;
                    _syncFetchPayload += batchLength;
                }
                var request = new Request(endPointUrl, init);
                try {
                    // Also try and tag the request (just in case the value in init is not copied over)
                    request[0, $71dfba5ea0640485$export$7c6abff2f2bdd9c0] = true;
                } catch (e) {
                // If the environment has locked down the XMLHttpRequest (preventExtensions and/or freeze), this would
                // cause the request to fail and we no telemetry would be sent
                }
                _self._buffer[0, $e5f8715adea0dc31$export$52e50651d87300e3 /* @min:%2emarkAsSent */ ](payload);
                if (isAsync && _enableSendPromise) thePromise = (0, $911d39c591a62618$export$5a1eb20c68656e88)(function(resolve, reject) {
                    resolveFunc = resolve;
                    rejectFunc = reject;
                });
                try {
                    (0, $a99c2448b4d73401$export$856fe465480fa77a)(fetch(request), function(result) {
                        if (!isAsync) {
                            _syncFetchPayload -= batchLength;
                            batchLength = 0;
                        }
                        if (!responseHandled) {
                            responseHandled = true;
                            if (!result.rejected) {
                                var response_1 = result.value;
                                /**
                                 * The Promise returned from fetch() won’t reject on HTTP error status even if the response is an HTTP 404 or 500.
                                 * Instead, it will resolve normally (with ok status set to false), and it will only reject on network failure
                                 * or if anything prevented the request from completing.
                                 */ if (!response_1.ok) {
                                    _self[0, $e5f8715adea0dc31$export$fd0c91d4da43d71b /* @min:%2e_onError */ ](payload, response_1.statusText);
                                    resolveFunc && resolveFunc(false);
                                } else (0, $a99c2448b4d73401$export$856fe465480fa77a)(response_1.text(), function(resp) {
                                    _checkResponsStatus(response_1.status, payload, response_1.url, payload[0, $e5f8715adea0dc31$export$6eae51590aaea43 /* @min:%2elength */ ], response_1.statusText, resp.value || "");
                                    resolveFunc && resolveFunc(true);
                                });
                            } else {
                                _self[0, $e5f8715adea0dc31$export$fd0c91d4da43d71b /* @min:%2e_onError */ ](payload, result.reason && result.reason.message);
                                rejectFunc && rejectFunc(result.reason);
                            }
                        }
                    });
                } catch (e) {
                    if (!responseHandled) {
                        _self[0, $e5f8715adea0dc31$export$fd0c91d4da43d71b /* @min:%2e_onError */ ](payload, (0, $386f00e3a193a7da$export$21fce7cbd4dc679f)(e));
                        rejectFunc && rejectFunc(e);
                    }
                }
                if (ignoreResponse && !responseHandled) {
                    // Assume success during unload processing as we most likely won't get the response
                    responseHandled = true;
                    _self._onSuccess(payload, payload[0, $e5f8715adea0dc31$export$6eae51590aaea43 /* @min:%2elength */ ]);
                    resolveFunc && resolveFunc(true);
                }
                return thePromise;
            }
            /**
             * Parses the response from the backend.
             * @param response - XMLHttpRequest or XDomainRequest response
             */ function _parseResponse(response) {
                try {
                    if (response && response !== "") {
                        var result = (0, $0c599844349363c4$export$d047a7c56db64af4)().parse(response);
                        if (result && result.itemsReceived && result.itemsReceived >= result[0, $e5f8715adea0dc31$export$fb8523c8667e286a /* @min:%2eitemsAccepted */ ] && result.itemsReceived - result.itemsAccepted === result.errors[0, $e5f8715adea0dc31$export$6eae51590aaea43 /* @min:%2elength */ ]) return result;
                    }
                } catch (e) {
                    (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(_self[0, $e5f8715adea0dc31$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), 1 /* eLoggingSeverity.CRITICAL */ , 43 /* _eInternalMessageId.InvalidBackendResponse */ , "Cannot parse the response. " + (0, $0b747974b0bb3563$export$39c4487b36c98fec)(e), {
                        response: response
                    });
                }
                return null;
            }
            /**
             * Resend payload. Adds payload back to the send buffer and setup a send timer (with exponential backoff).
             * @param payload
             */ function _resendPayload(payload, linearFactor) {
                if (linearFactor === void 0) linearFactor = 1;
                if (!payload || payload[0, $e5f8715adea0dc31$export$6eae51590aaea43 /* @min:%2elength */ ] === 0) return;
                var buffer = _self[0, $e5f8715adea0dc31$export$3f8a6394c5f7e7be /* @min:%2e_buffer */ ];
                buffer[0, $e5f8715adea0dc31$export$13da1b5a005ef035 /* @min:%2eclearSent */ ](payload);
                _consecutiveErrors++;
                for(var _i = 0, payload_1 = payload; _i < payload_1.length; _i++){
                    var item = payload_1[_i];
                    buffer[0, $e5f8715adea0dc31$export$4aae77f3ba3c48b4 /* @min:%2eenqueue */ ](item);
                }
                // setup timer
                _setRetryTime(linearFactor);
                _setupTimer();
            }
            /**
             * Calculates the time to wait before retrying in case of an error based on
             * http://en.wikipedia.org/wiki/Exponential_backoff
             */ function _setRetryTime(linearFactor) {
                var SlotDelayInSeconds = 10;
                var delayInSeconds;
                if (_consecutiveErrors <= 1) delayInSeconds = SlotDelayInSeconds;
                else {
                    var backOffSlot = (Math.pow(2, _consecutiveErrors) - 1) / 2;
                    // tslint:disable-next-line:insecure-random
                    var backOffDelay = Math.floor(Math.random() * backOffSlot * SlotDelayInSeconds) + 1;
                    backOffDelay = linearFactor * backOffDelay;
                    delayInSeconds = Math.max(Math.min(backOffDelay, 3600), SlotDelayInSeconds);
                }
                // TODO: Log the backoff time like the C# version does.
                var retryAfterTimeSpan = (0, $628cad25a0769458$export$a56f095995763cca)() + delayInSeconds * 1000;
                // TODO: Log the retry at time like the C# version does.
                _retryAt = retryAfterTimeSpan;
            }
            /**
             * Sets up the timer which triggers actually sending the data.
             */ function _setupTimer() {
                if (!_timeoutHandle && !_paused) {
                    var retryInterval = _retryAt ? Math.max(0, _retryAt - (0, $628cad25a0769458$export$a56f095995763cca)()) : 0;
                    var timerValue = Math.max(_maxBatchInterval, retryInterval);
                    _timeoutHandle = (0, $d03b12effd00bf96$export$5f4d6617421d489b)(function() {
                        _timeoutHandle = null;
                        _self[0, $e5f8715adea0dc31$export$df21ab0de9057cc4 /* @min:%2etriggerSend */ ](true, null, 1 /* SendRequestReason.NormalSchedule */ );
                    }, timerValue);
                }
            }
            function _clearScheduledTimer() {
                _timeoutHandle && _timeoutHandle.cancel();
                _timeoutHandle = null;
                _retryAt = null;
            }
            /**
             * Checks if the SDK should resend the payload after receiving this status code from the backend.
             * @param statusCode
             */ function _isRetriable(statusCode) {
                return statusCode === 401 // Unauthorized
                 || statusCode === 403 // Forbidden
                 || statusCode === 408 // Timeout
                 || statusCode === 429 // Too many requests.
                 || statusCode === 500 // Internal server error.
                 || statusCode === 502 // Bad Gateway.
                 || statusCode === 503 // Service unavailable.
                 || statusCode === 504; // Gateway timeout.
            }
            function _formatErrorMessageXhr(xhr, message) {
                if (xhr) return "XMLHttpRequest,Status:" + xhr.status + ",Response:" + $de50c0f740c66740$var$_getResponseText(xhr) || xhr.response || "";
                return message;
            }
            /**
             * Send XDomainRequest
             * @param payload - {string} - The data payload to be sent.
             * @param isAsync - {boolean} - Indicates if the request should be sent asynchronously
             *
             * Note: XDomainRequest does not support sync requests. This 'isAsync' parameter is added
             * to maintain consistency with the xhrSender's contract
             * Note: XDomainRequest does not support custom headers and we are not able to get
             * appId from the backend for the correct correlation.
             */ function _xdrSender(payload, isAsync) {
                var buffer = _self[0, $e5f8715adea0dc31$export$3f8a6394c5f7e7be /* @min:%2e_buffer */ ];
                var _window = (0, $3d5fcb60a9467a45$export$38b2d434cce3ea22)();
                var xdr = new XDomainRequest();
                // NOTE: xdr may send previous retry payload to new endpoint since we are not able to check response URL
                xdr.onload = function() {
                    return _self._xdrOnLoad(xdr, payload);
                };
                xdr.onerror = function(event) {
                    return _self[0, $e5f8715adea0dc31$export$fd0c91d4da43d71b /* @min:%2e_onError */ ](payload, _formatErrorMessageXdr(xdr), event);
                };
                // XDomainRequest requires the same protocol as the hosting page.
                // If the protocol doesn't match, we can't send the telemetry :(.
                var hostingProtocol = _window && _window.location && _window.location.protocol || "";
                if (_endpointUrl.lastIndexOf(hostingProtocol, 0) !== 0) {
                    (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(_self[0, $e5f8715adea0dc31$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), 2 /* eLoggingSeverity.WARNING */ , 40 /* _eInternalMessageId.TransmissionFailed */ , ". Cannot send XDomain request. The endpoint URL protocol doesn't match the hosting page protocol.");
                    buffer[0, $e5f8715adea0dc31$export$5eeb73fac03da74a /* @min:%2eclear */ ]();
                    return;
                }
                var endpointUrl = _endpointUrl.replace(/^(https?:)/, "");
                xdr.open("POST", endpointUrl);
                // compose an array of payloads
                var batch = buffer[0, $e5f8715adea0dc31$export$a5da323a4da829fc /* @min:%2ebatchPayloads */ ](payload);
                xdr.send(batch);
                buffer[0, $e5f8715adea0dc31$export$52e50651d87300e3 /* @min:%2emarkAsSent */ ](payload);
            }
            function _formatErrorMessageXdr(xdr, message) {
                if (xdr) return "XDomainRequest,Response:" + $de50c0f740c66740$var$_getResponseText(xdr);
                return message;
            }
            // Using function lookups for backward compatibility as the getNotifyMgr() did not exist until after v2.5.6
            function _getNotifyMgr() {
                var func = "getNotifyMgr";
                if (_self.core[func]) return _self.core[func]();
                // using _self.core['_notificationManager'] for backward compatibility
                return _self.core["_notificationManager"];
            }
            function _notifySendRequest(sendRequest, isAsync) {
                var manager = _getNotifyMgr();
                if (manager && manager[0, $e5f8715adea0dc31$export$298b8388870fcfe9 /* @min:%2eeventsSendRequest */ ]) try {
                    manager[0, $e5f8715adea0dc31$export$298b8388870fcfe9 /* @min:%2eeventsSendRequest */ ](sendRequest, isAsync);
                } catch (e) {
                    (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(_self[0, $e5f8715adea0dc31$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), 1 /* eLoggingSeverity.CRITICAL */ , 74 /* _eInternalMessageId.NotificationException */ , "send request notification failed: " + (0, $0b747974b0bb3563$export$39c4487b36c98fec)(e), {
                        exception: (0, $386f00e3a193a7da$export$21fce7cbd4dc679f)(e)
                    });
                }
            }
            /**
             * Validate UUID Format
             * Specs taken from https://tools.ietf.org/html/rfc4122 and breeze repo
             */ function _validateInstrumentationKey(instrumentationKey, config) {
                var disableValidation = config.disableInstrumentationKeyValidation;
                var disableIKeyValidationFlag = (0, $533f826bbc418791$export$bedb7023a7733221)(disableValidation) ? false : disableValidation;
                if (disableIKeyValidationFlag) return true;
                var UUID_Regex = "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$";
                var regexp = new RegExp(UUID_Regex);
                return regexp.test(instrumentationKey);
            }
            function _initDefaults() {
                _self[0, $e5f8715adea0dc31$export$e5390b88ba6f1b04 /* @min:%2e_sender */ ] = null;
                _self[0, $e5f8715adea0dc31$export$3f8a6394c5f7e7be /* @min:%2e_buffer */ ] = null;
                _self._appId = null;
                _self._sample = null;
                _headers = {};
                _offlineListener = null;
                _consecutiveErrors = 0;
                _retryAt = null;
                _lastSend = null;
                _paused = false;
                _timeoutHandle = null;
                _serializer = null;
                _stamp_specific_redirects = 0;
                _syncFetchPayload = 0;
                _fallbackSender = null;
                _syncUnloadSender = null;
                _evtNamespace = null;
                _endpointUrl = null;
                _orgEndpointUrl = null;
                _maxBatchSizeInBytes = 0;
                _beaconSupported = false;
                _customHeaders = null;
                _disableTelemetry = false;
                _instrumentationKey = null;
                _convertUndefined = $de50c0f740c66740$var$UNDEFINED_VALUE;
                _isRetryDisabled = false;
                _sessionStorageUsed = null;
                _namePrefix = $de50c0f740c66740$var$UNDEFINED_VALUE;
                (0, $d212d948d25f959a$export$d0d2ebf910ad6e2)(_self, "_senderConfig", {
                    g: function() {
                        return (0, $0b747974b0bb3563$export$a7f7e50f928053df)({}, $de50c0f740c66740$var$defaultAppInsightsChannelConfig);
                    }
                });
            }
        });
        return _this;
    }
    Sender.constructEnvelope = function(orig, iKey, logger, convertUndefined) {
        var envelope;
        if (iKey !== orig.iKey && !(0, $533f826bbc418791$export$bedb7023a7733221)(iKey)) envelope = (0, $2a74b38b87b38cda$export$b3cf7a802e578501)((0, $2a74b38b87b38cda$export$b3cf7a802e578501)({}, orig), {
            iKey: iKey
        });
        else envelope = orig;
        var creator = $de50c0f740c66740$var$EnvelopeTypeCreator[envelope.baseType] || (0, $0b044846db0c77e8$export$b74153364c2066d1);
        return creator(logger, envelope, convertUndefined);
    };
    // Removed Stub for Sender.prototype.pause.
    // Removed Stub for Sender.prototype.resume.
    // Removed Stub for Sender.prototype.flush.
    // Removed Stub for Sender.prototype.onunloadFlush.
    // Removed Stub for Sender.prototype.initialize.
    // Removed Stub for Sender.prototype.processTelemetry.
    // Removed Stub for Sender.prototype._xhrReadyStateChange.
    // Removed Stub for Sender.prototype.triggerSend.
    // Removed Stub for Sender.prototype._onError.
    // Removed Stub for Sender.prototype._onPartialSuccess.
    // Removed Stub for Sender.prototype._onSuccess.
    // Removed Stub for Sender.prototype._xdrOnLoad.
    // Removed Stub for Sender.prototype.addHeader.
    return Sender;
}((0, $b61d51369f8191a4$export$64a11c2f90e6766c));



/*
 * Application Insights JavaScript SDK - Core, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 


/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */ 

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */ 





/**
 * @internal
 * @ignore
 * Generic Object deep copy handler which creates a new plain object and copies enumerable properties from
 * the source to the new target plain object. The source object does not have to be a plain object.
 * @param details - The details object for the current property being copied
 * @returns true if the handler processed the field.
 */ var $eab8f97afa7948b4$var$_defaultDeepCopyHandler = function(details) {
    // Make sure we at least copy plain objects
    details.value && $eab8f97afa7948b4$export$7d1ebb7d4f033054(details);
    // Always return true so that the iteration completes
    return true;
};
/**
 * @internal
 * @ignore
 * The ordered default deep copy handlers
 */ var $eab8f97afa7948b4$var$defaultDeepCopyHandlers = [
    $eab8f97afa7948b4$export$cc4db57f4a8fbdc7,
    $eab8f97afa7948b4$export$7d1ebb7d4f033054,
    $eab8f97afa7948b4$export$56ca4b82c6e32658,
    $eab8f97afa7948b4$export$2b6207be55b7460b
];
/**
 * @internal
 * @ignore
 * Helper function used for detecting and handling recursive properties
 * @param visitMap - The current map of objects that have been visited
 * @param source - The value (object) to be copied
 * @param newPath - The new access path from the origin to the current property
 * @param cb - The callback function to call if the current object has not already been processed.
 * @returns The new deep copied property, may be incomplete as the object is recursive and is still in the process of being copied
 */ function $eab8f97afa7948b4$var$_getSetVisited(visitMap, source, newPath, cb) {
    var theEntry;
    (0, $f6bb085f8cf12216$export$e2e5bcdbdc49c586)(visitMap, function(entry) {
        if (entry.k === source) {
            theEntry = entry;
            return -1;
        }
    });
    if (!theEntry) {
        // Add the target to the visit map so that deep nested objects refer to the single instance
        // Even if we have not finished processing it yet.
        theEntry = {
            k: source,
            v: source
        };
        visitMap.push(theEntry);
        // Now call the copy callback so that it populates the target
        cb(theEntry);
    }
    return theEntry.v;
}
/**
 * @internal
 * @ignore
 * Internal helper which performs the recursive deep copy
 * @param visitMap - The current map of objects that have been visited
 * @param value - The value being copied
 * @param ctx - The current copy context
 * @param key - [Optional] the current `key` for the value from the source object
 * @returns The new deep copied instance of the value.
 */ function $eab8f97afa7948b4$var$_deepCopy(visitMap, value, ctx, key) {
    var userHandler = ctx.handler;
    var newPath = ctx.path ? key ? ctx.path.concat(key) : ctx.path : [];
    var newCtx = {
        handler: ctx.handler,
        src: ctx.src,
        path: newPath
    };
    var theType = typeof value;
    var isPlain = false;
    var isPrim = false;
    if (value && theType === (0, $b347daff6f5f8dc1$export$8b8a958a7f6f130c)) isPlain = (0, $a339b44c6e62d324$export$53b83ca8eaab0383)(value);
    else isPrim = value === (0, $b347daff6f5f8dc1$export$38c7ba05d207d137) || (0, $533f826bbc418791$export$1f3b27a0956fac0e)(theType);
    var details = {
        type: theType,
        isPrim: isPrim,
        isPlain: isPlain,
        value: value,
        result: value,
        path: newPath,
        origin: ctx.src,
        copy: function(source, newKey) {
            return $eab8f97afa7948b4$var$_deepCopy(visitMap, source, newKey ? newCtx : ctx, newKey);
        },
        copyTo: function(target, source) {
            return $eab8f97afa7948b4$var$_copyProps(visitMap, target, source, newCtx);
        }
    };
    if (!details.isPrim) return $eab8f97afa7948b4$var$_getSetVisited(visitMap, value, newPath, function(newEntry) {
        // Use an accessor to set the new value onto the new entry
        (0, $d212d948d25f959a$export$d0d2ebf910ad6e2)(details, "result", {
            g: function() {
                return newEntry.v;
            },
            s: function(newValue) {
                newEntry.v = newValue;
            }
        });
        var idx = 0;
        var handler = userHandler;
        while(!(0, $e9133230f0eaf267$export$4b40e215736a9426)(handler || (idx < $eab8f97afa7948b4$var$defaultDeepCopyHandlers.length ? $eab8f97afa7948b4$var$defaultDeepCopyHandlers[idx++] : $eab8f97afa7948b4$var$_defaultDeepCopyHandler), ctx, details))handler = (0, $b347daff6f5f8dc1$export$38c7ba05d207d137);
    });
    // Allow the user handler to override the provided value
    if (userHandler && (0, $e9133230f0eaf267$export$4b40e215736a9426)(userHandler, ctx, details)) return details.result;
    return value;
}
/**
 * @internal
 * @ignore
 * Internal helper to copy all of the enumerable properties from the source object to the new target object
 * @param visitMap - The current map of objects that have been visited
 * @param target - The target object to copy the properties to.
 * @param source - The source object to copy the properties from.
 * @param ctx - The current deep copy context
 * @returns The populated target object
 */ function $eab8f97afa7948b4$var$_copyProps(visitMap, target, source, ctx) {
    if (!(0, $533f826bbc418791$export$bedb7023a7733221)(source)) // Copy all properties (not just own properties)
    for(var key in source)// Perform a deep copy of the object
    target[key] = $eab8f97afa7948b4$var$_deepCopy(visitMap, source[key], ctx, key);
    return target;
}
function $eab8f97afa7948b4$export$eee89407658fa201(target, source, handler) {
    var ctx = {
        handler: handler,
        src: source,
        path: []
    };
    return $eab8f97afa7948b4$var$_copyProps([], target, source, ctx);
}
function $eab8f97afa7948b4$export$ee1b2e0d6501c954(source, handler) {
    var ctx = {
        handler: handler,
        src: source
    };
    return $eab8f97afa7948b4$var$_deepCopy([], source, ctx);
}
function $eab8f97afa7948b4$export$cc4db57f4a8fbdc7(details) {
    var value = details.value;
    if ((0, $533f826bbc418791$export$43bee75e5e14138e)(value)) {
        // Assign the "result" value before performing any additional deep Copying, so any recursive object get a reference to this instance
        var target = details.result = [];
        target.length = value.length;
        // Copying all properties as arrays can contain non-indexed based properties
        details.copyTo(target, value);
        return true;
    }
    return false;
}
function $eab8f97afa7948b4$export$2b6207be55b7460b(details) {
    var value = details.value;
    if ((0, $533f826bbc418791$export$871608497c498473)(value)) {
        details.result = new Date(value.getTime());
        return true;
    }
    return false;
}
function $eab8f97afa7948b4$export$56ca4b82c6e32658(details) {
    if (details.type === (0, $b347daff6f5f8dc1$export$601fe16600f10158)) return true;
    return false;
}
function $eab8f97afa7948b4$export$7d1ebb7d4f033054(details) {
    var value = details.value;
    if (value && details.isPlain) {
        // Assign the "result" value before performing any additional deep Copying, so any recursive object get a reference to this instance
        var target = details.result = {};
        details.copyTo(target, value);
        return true;
    }
    return false;
}


/**
 * @internal
 * @ignore
 */ function $9042921d36c971e1$var$_doExtend(target, theArgs) {
    (0, $f6bb085f8cf12216$export$e2e5bcdbdc49c586)(theArgs, function(theArg) {
        (0, $eab8f97afa7948b4$export$eee89407658fa201)(target, theArg);
    });
    return target;
}
function $9042921d36c971e1$export$54e9fb29908872fa(target, obj1, obj2, obj3, obj4, obj5, obj6) {
    return $9042921d36c971e1$var$_doExtend((0, $eab8f97afa7948b4$export$ee1b2e0d6501c954)(target) || {}, (0, $46728a52dfc641a6$export$1bea104a0e2567f0)(arguments));
}
function $9042921d36c971e1$export$a7f7e50f928053df(target, obj1, obj2, obj3, obj4, obj5, obj6) {
    return $9042921d36c971e1$var$_doExtend(target || {}, (0, $46728a52dfc641a6$export$1bea104a0e2567f0)(arguments));
}





/*
 * Application Insights JavaScript SDK - Core, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ var $f66a763d1ac581a5$export$a1373ad9f192f374 = 500;








/*
 * Application Insights JavaScript SDK - Core, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 





var $21e0e68428bc90cf$var$defaultValues = {
    perfEvtsSendAll: false
};
function $21e0e68428bc90cf$var$_runListeners(listeners, name, isAsync, callback) {
    (0, $f6bb085f8cf12216$export$e2e5bcdbdc49c586)(listeners, function(listener) {
        if (listener && listener[name]) {
            if (isAsync) (0, $d03b12effd00bf96$export$5f4d6617421d489b)(function() {
                return callback(listener);
            }, 0);
            else try {
                callback(listener);
            } catch (e) {
            // Catch errors to ensure we don't block sending the requests
            }
        }
    });
}
/**
 * Class to manage sending notifications to all the listeners.
 */ var $21e0e68428bc90cf$export$dfa1f14b6290f8c5 = /** @class */ function() {
    function NotificationManager(config) {
        this.listeners = [];
        var perfEvtsSendAll;
        var unloadHandler;
        var _listeners = [];
        var cfgHandler = (0, $acb30f9e62dc5705$export$3a9e9180c14487fd)(config, $21e0e68428bc90cf$var$defaultValues);
        unloadHandler = cfgHandler[0, $1ae5573ce493bccc$export$fc59eec8d77f3766 /* @min:%2ewatch */ ](function(details) {
            perfEvtsSendAll = !!details.cfg.perfEvtsSendAll;
        });
        (0, $c9b63384299a3252$export$2e2bcd8739ae039)(NotificationManager, this, function(_self) {
            (0, $d212d948d25f959a$export$d0d2ebf910ad6e2)(_self, "listeners", {
                g: function() {
                    return _listeners;
                }
            });
            _self[0, $1ae5573ce493bccc$export$5c8bcfab4f42ca62 /* @min:%2eaddNotificationListener */ ] = function(listener) {
                _listeners[0, $1ae5573ce493bccc$export$a0a330e7fa1e278c /* @min:%2epush */ ](listener);
            };
            /**
             * Removes all instances of the listener.
             * @param listener - AWTNotificationListener to remove.
             */ _self[0, $1ae5573ce493bccc$export$861144ba9c13be60 /* @min:%2eremoveNotificationListener */ ] = function(listener) {
                var index = (0, $a96d4958027d6f85$export$9f3b3ffa84393d30)(_listeners, listener);
                while(index > -1){
                    _listeners[0, $1ae5573ce493bccc$export$84020a2e4fe863b0 /* @min:%2esplice */ ](index, 1);
                    index = (0, $a96d4958027d6f85$export$9f3b3ffa84393d30)(_listeners, listener);
                }
            };
            /**
             * Notification for events sent.
             * @param events - The array of events that have been sent.
             */ _self[0, $9fe4a5d5204a4cff$export$bb3c4bc1b1175d3d /* @min:%2eeventsSent */ ] = function(events) {
                $21e0e68428bc90cf$var$_runListeners(_listeners, (0, $9fe4a5d5204a4cff$export$bb3c4bc1b1175d3d), true, function(listener) {
                    listener[0, $9fe4a5d5204a4cff$export$bb3c4bc1b1175d3d /* @min:%2eeventsSent */ ](events);
                });
            };
            /**
             * Notification for events being discarded.
             * @param events - The array of events that have been discarded by the SDK.
             * @param reason - The reason for which the SDK discarded the events. The EventsDiscardedReason
             * constant should be used to check the different values.
             */ _self[0, $9fe4a5d5204a4cff$export$bacb5b2f4c1081b9 /* @min:%2eeventsDiscarded */ ] = function(events, reason) {
                $21e0e68428bc90cf$var$_runListeners(_listeners, (0, $9fe4a5d5204a4cff$export$bacb5b2f4c1081b9), true, function(listener) {
                    listener[0, $9fe4a5d5204a4cff$export$bacb5b2f4c1081b9 /* @min:%2eeventsDiscarded */ ](events, reason);
                });
            };
            /**
             * [Optional] A function called when the events have been requested to be sent to the sever.
             * @param sendReason - The reason why the event batch is being sent.
             * @param isAsync - A flag which identifies whether the requests are being sent in an async or sync manner.
             */ _self[0, $9fe4a5d5204a4cff$export$d75e063cb88a1c25 /* @min:%2eeventsSendRequest */ ] = function(sendReason, isAsync) {
                $21e0e68428bc90cf$var$_runListeners(_listeners, (0, $9fe4a5d5204a4cff$export$d75e063cb88a1c25), isAsync, function(listener) {
                    listener[0, $9fe4a5d5204a4cff$export$d75e063cb88a1c25 /* @min:%2eeventsSendRequest */ ](sendReason, isAsync);
                });
            };
            _self[0, $9fe4a5d5204a4cff$export$5d265841733c97c3 /* @min:%2eperfEvent */ ] = function(perfEvent) {
                if (perfEvent) // Send all events or only parent events
                {
                    if (perfEvtsSendAll || !perfEvent[0, $1ae5573ce493bccc$export$3a89026537e5dfec /* @min:%2eisChildEvt */ ]()) $21e0e68428bc90cf$var$_runListeners(_listeners, (0, $9fe4a5d5204a4cff$export$5d265841733c97c3), false, function(listener) {
                        if (perfEvent[0, $1ae5573ce493bccc$export$d8114c9e990204cb /* @min:%2eisAsync */ ]) (0, $d03b12effd00bf96$export$5f4d6617421d489b)(function() {
                            return listener[0, $9fe4a5d5204a4cff$export$5d265841733c97c3 /* @min:%2eperfEvent */ ](perfEvent);
                        }, 0);
                        else listener[0, $9fe4a5d5204a4cff$export$5d265841733c97c3 /* @min:%2eperfEvent */ ](perfEvent);
                    });
                }
            };
            _self[0, $1ae5573ce493bccc$export$7eb85b5cba77a43d /* @min:%2eunload */ ] = function(isAsync) {
                var _finishUnload = function() {
                    unloadHandler && unloadHandler.rm();
                    unloadHandler = null;
                    _listeners = [];
                };
                var waiting;
                $21e0e68428bc90cf$var$_runListeners(_listeners, "unload", false, function(listener) {
                    var asyncUnload = listener[0, $1ae5573ce493bccc$export$7eb85b5cba77a43d /* @min:%2eunload */ ](isAsync);
                    if (asyncUnload) {
                        if (!waiting) waiting = [];
                        waiting[0, $1ae5573ce493bccc$export$a0a330e7fa1e278c /* @min:%2epush */ ](asyncUnload);
                    }
                });
                if (waiting) return (0, $911d39c591a62618$export$5a1eb20c68656e88)(function(resolve) {
                    return (0, $a99c2448b4d73401$export$856fe465480fa77a)((0, $911d39c591a62618$export$1ed2fd8fe9f5c6)(waiting), function() {
                        _finishUnload();
                        resolve();
                    });
                });
                else _finishUnload();
            };
        });
    }
    // Removed Stub for NotificationManager.prototype.addNotificationListener.
    // Removed Stub for NotificationManager.prototype.removeNotificationListener.
    // Removed Stub for NotificationManager.prototype.eventsSent.
    // Removed Stub for NotificationManager.prototype.eventsDiscarded.
    // Removed Stub for NotificationManager.prototype.eventsSendRequest.
    // Removed Stub for NotificationManager.prototype.perfEvent.
    // Removed Stub for NotificationManager.prototype.unload.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    NotificationManager.__ieDyn = 1;
    return NotificationManager;
}();





/*
 * Application Insights JavaScript SDK - Core, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // 
// 








function $4d4645ee8836015f$var$_addInitializer(_initializers, id, telemetryInitializer) {
    var theInitializer = {
        id: id,
        fn: telemetryInitializer
    };
    (0, $54343718a076ab6e$export$69c7b96f216fdf7b)(_initializers, theInitializer);
    var handler = {
        remove: function() {
            (0, $f6bb085f8cf12216$export$e2e5bcdbdc49c586)(_initializers, function(initializer, idx) {
                if (initializer.id === theInitializer.id) {
                    _initializers[0, $1ae5573ce493bccc$export$84020a2e4fe863b0 /* @min:%2esplice */ ](idx, 1);
                    return -1;
                }
            });
        }
    };
    return handler;
}
function $4d4645ee8836015f$var$_runInitializers(_initializers, item, logger) {
    var doNotSendItem = false;
    var telemetryInitializersCount = _initializers[0, $1ae5573ce493bccc$export$6eae51590aaea43 /* @min:%2elength */ ];
    for(var i = 0; i < telemetryInitializersCount; ++i){
        var telemetryInitializer = _initializers[i];
        if (telemetryInitializer) try {
            if (telemetryInitializer.fn[0, $1ae5573ce493bccc$export$2f85ca6962b15ff8 /* @min:%2eapply */ ](null, [
                item
            ]) === false) {
                doNotSendItem = true;
                break;
            }
        } catch (e) {
            // log error but dont stop executing rest of the telemetry initializers
            // doNotSendItem = true;
            (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , 64 /* _eInternalMessageId.TelemetryInitializerFailed */ , "Telemetry initializer failed: " + (0, $0b747974b0bb3563$export$39c4487b36c98fec)(e), {
                exception: (0, $386f00e3a193a7da$export$21fce7cbd4dc679f)(e)
            }, true);
        }
    }
    return !doNotSendItem;
}
var $4d4645ee8836015f$export$5da7f32cc3b89dc1 = /** @class */ function(_super) {
    (0, $2a74b38b87b38cda$export$1f9c32e3fbfb8e62)(TelemetryInitializerPlugin, _super);
    function TelemetryInitializerPlugin() {
        var _this = _super.call(this) || this;
        _this.identifier = "TelemetryInitializerPlugin";
        _this.priority = 199;
        // NOTE!: DON'T set default values here, instead set them in the _initDefaults() function as it is also called during teardown()
        var _id;
        var _initializers;
        _initDefaults();
        (0, $c9b63384299a3252$export$2e2bcd8739ae039)(TelemetryInitializerPlugin, _this, function(_self, _base) {
            _self.addTelemetryInitializer = function(telemetryInitializer) {
                return $4d4645ee8836015f$var$_addInitializer(_initializers, _id++, telemetryInitializer);
            };
            _self[0, $9fe4a5d5204a4cff$export$820a3bce4a265606 /* @min:%2eprocessTelemetry */ ] = function(item, itemCtx) {
                if ($4d4645ee8836015f$var$_runInitializers(_initializers, item, itemCtx ? itemCtx[0, $1ae5573ce493bccc$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ]() : _self[0, $1ae5573ce493bccc$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ]())) _self[0, $1ae5573ce493bccc$export$5c220169317cd6de /* @min:%2eprocessNext */ ](item, itemCtx);
            };
            _self[0, $1ae5573ce493bccc$export$458d234b616d0745 /* @min:%2e_doTeardown */ ] = function() {
                _initDefaults();
            };
        });
        function _initDefaults() {
            _id = 0;
            _initializers = [];
        }
        return _this;
    }
    // Removed Stub for TelemetryInitializerPlugin.prototype.addTelemetryInitializer.
    // Removed Stub for TelemetryInitializerPlugin.prototype.processTelemetry.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    TelemetryInitializerPlugin.__ieDyn = 1;
    return TelemetryInitializerPlugin;
}((0, $b61d51369f8191a4$export$64a11c2f90e6766c));




"use strict";
var $e5177bba49076348$var$_a;
var $e5177bba49076348$var$strValidationError = "Plugins must provide initialize method";
var $e5177bba49076348$var$strNotificationManager = "_notificationManager";
var $e5177bba49076348$var$strSdkUnloadingError = "SDK is still unloading...";
var $e5177bba49076348$var$strSdkNotInitialized = "SDK is not initialized";
// const strPluginUnloadFailed = "Failed to unload plugin";
/**
 * The default settings for the config.
 * WE MUST include all defaults here to ensure that the config is created with all of the properties
 * defined as dynamic.
 */ var $e5177bba49076348$var$defaultConfig = (0, $36a077d9f4439b69$export$a15782d21797da4c)(($e5177bba49076348$var$_a = {
    cookieCfg: {}
}, $e5177bba49076348$var$_a[0, $9fe4a5d5204a4cff$export$a077ce616a1ab4ee] = {
    rdOnly: true,
    ref: true,
    v: []
}, $e5177bba49076348$var$_a[0, $9fe4a5d5204a4cff$export$829012af4b2055a2] = {
    rdOnly: true,
    ref: true,
    v: []
}, $e5177bba49076348$var$_a[0, $9fe4a5d5204a4cff$export$ffb2356587263734] = {
    ref: true,
    v: {}
}, $e5177bba49076348$var$_a[0, $9fe4a5d5204a4cff$export$1cf3476332da55b3] = (0, $9fe4a5d5204a4cff$export$a43287864529b8fd), $e5177bba49076348$var$_a.loggingLevelConsole = 0 /* eLoggingSeverity.DISABLED */ , $e5177bba49076348$var$_a.diagnosticLogInterval = (0, $9fe4a5d5204a4cff$export$a43287864529b8fd), $e5177bba49076348$var$_a));
/**
 * Helper to create the default performance manager
 * @param core
 * @param notificationMgr
 */ function $e5177bba49076348$var$_createPerfManager(core, notificationMgr) {
    return new (0, $28deccfc004f252b$export$cbeb6df2e8e9b5ae)(notificationMgr);
}
function $e5177bba49076348$var$_validateExtensions(logger, channelPriority, allExtensions) {
    var _a;
    // Concat all available extensions
    var coreExtensions = [];
    var channels = [];
    // Check if any two extensions have the same priority, then warn to console
    // And extract the local extensions from the
    var extPriorities = {};
    // Extension validation
    (0, $f6bb085f8cf12216$export$e2e5bcdbdc49c586)(allExtensions, function(ext) {
        // Check for ext.initialize
        if ((0, $533f826bbc418791$export$bedb7023a7733221)(ext) || (0, $533f826bbc418791$export$bedb7023a7733221)(ext[0, $1ae5573ce493bccc$export$65cd33bb52d04675 /* @min:%2einitialize */ ])) (0, $44a1c24c0e411039$export$8bf7aba4a9e09055)($e5177bba49076348$var$strValidationError);
        var extPriority = ext[0, $9fe4a5d5204a4cff$export$58efcc07763b37be /* @min:%2epriority */ ];
        var identifier = ext[0, $1ae5573ce493bccc$export$f001befbf8417151 /* @min:%2eidentifier */ ];
        if (ext && extPriority) {
            if (!(0, $533f826bbc418791$export$bedb7023a7733221)(extPriorities[extPriority])) (0, $cc2aaaebf96ac6a7$export$25fb4cb97863f0a8)(logger, "Two extensions have same priority #" + extPriority + " - " + extPriorities[extPriority] + ", " + identifier);
            else // set a value
            extPriorities[extPriority] = identifier;
        }
        // Split extensions to core and channels
        if (!extPriority || extPriority < channelPriority) // Add to core extension that will be managed by AppInsightsCore
        coreExtensions[0, $1ae5573ce493bccc$export$a0a330e7fa1e278c /* @min:%2epush */ ](ext);
        else channels[0, $1ae5573ce493bccc$export$a0a330e7fa1e278c /* @min:%2epush */ ](ext);
    });
    return _a = {}, _a[0, $9fe4a5d5204a4cff$export$3094ace9cd82ff99 /* @min:core */ ] = coreExtensions, _a[0, $9fe4a5d5204a4cff$export$829012af4b2055a2 /* @min:channels */ ] = channels, _a;
}
function $e5177bba49076348$var$_isPluginPresent(thePlugin, plugins) {
    var exists = false;
    (0, $f6bb085f8cf12216$export$e2e5bcdbdc49c586)(plugins, function(plugin) {
        if (plugin === thePlugin) {
            exists = true;
            return -1;
        }
    });
    return exists;
}
function $e5177bba49076348$var$_deepMergeConfig(details, target, newValues, merge) {
    // Lets assign the new values to the existing config
    if (newValues) (0, $45e528077703ac0c$export$aa0705d5774c95d1)(newValues, function(key, value) {
        if (merge) {
            if ((0, $a339b44c6e62d324$export$53b83ca8eaab0383)(value) && (0, $a339b44c6e62d324$export$53b83ca8eaab0383)(target[key])) // The target is an object and it has a value
            $e5177bba49076348$var$_deepMergeConfig(details, target[key], value, merge);
        }
        if (merge && (0, $a339b44c6e62d324$export$53b83ca8eaab0383)(value) && (0, $a339b44c6e62d324$export$53b83ca8eaab0383)(target[key])) // The target is an object and it has a value
        $e5177bba49076348$var$_deepMergeConfig(details, target[key], value, merge);
        else // Just Assign (replace) and/or make the property dynamic
        details.set(target, key, value);
    });
}
function $e5177bba49076348$var$_findWatcher(listeners, newWatcher) {
    var theListener = null;
    var idx = -1;
    (0, $f6bb085f8cf12216$export$e2e5bcdbdc49c586)(listeners, function(listener, lp) {
        if (listener.w === newWatcher) {
            theListener = listener;
            idx = lp;
            return -1;
        }
    });
    return {
        i: idx,
        l: theListener
    };
}
function $e5177bba49076348$var$_addDelayedCfgListener(listeners, newWatcher) {
    var theListener = $e5177bba49076348$var$_findWatcher(listeners, newWatcher).l;
    if (!theListener) {
        theListener = {
            w: newWatcher,
            rm: function() {
                var fnd = $e5177bba49076348$var$_findWatcher(listeners, newWatcher);
                if (fnd.i !== -1) listeners[0, $1ae5573ce493bccc$export$84020a2e4fe863b0 /* @min:%2esplice */ ](fnd.i, 1);
            }
        };
        listeners[0, $1ae5573ce493bccc$export$a0a330e7fa1e278c /* @min:%2epush */ ](theListener);
    }
    return theListener;
}
function $e5177bba49076348$var$_registerDelayedCfgListener(config, listeners, logger) {
    (0, $f6bb085f8cf12216$export$e2e5bcdbdc49c586)(listeners, function(listener) {
        var unloadHdl = (0, $acb30f9e62dc5705$export$454a433e4deb244f)(config, listener.w, logger);
        delete listener.w; // Clear the listener reference so it will get garbage collected.
        // replace the remove function
        listener.rm = function() {
            unloadHdl.rm();
        };
    });
}
var $e5177bba49076348$export$e7ac25a6828d23bf = /** @class */ function() {
    function AppInsightsCore() {
        // NOTE!: DON'T set default values here, instead set them in the _initDefaults() function as it is also called during teardown()
        var _configHandler;
        var _isInitialized;
        var _logger;
        var _eventQueue;
        var _notificationManager;
        var _perfManager;
        var _cfgPerfManager;
        var _cookieManager;
        var _pluginChain;
        var _configExtensions;
        var _channelConfig;
        var _channels;
        var _isUnloading;
        var _telemetryInitializerPlugin;
        var _internalLogsEventName;
        var _evtNamespace;
        var _unloadHandlers;
        var _hookContainer;
        var _debugListener;
        var _traceCtx;
        var _instrumentationKey;
        var _cfgListeners;
        var _extensions;
        var _pluginVersionStringArr;
        var _pluginVersionString;
        /**
         * Internal log poller
         */ var _internalLogPoller;
        var _internalLogPollerListening;
        var _forceStopInternalLogPoller;
        (0, $c9b63384299a3252$export$2e2bcd8739ae039)(AppInsightsCore, this, function(_self) {
            // Set the default values (also called during teardown)
            _initDefaults();
            // Special internal method to allow the unit tests and DebugPlugin to hook embedded objects
            _self["_getDbgPlgTargets"] = function() {
                return [
                    _extensions
                ];
            };
            _self[0, $1ae5573ce493bccc$export$2e2716e9c35a66a8 /* @min:%2eisInitialized */ ] = function() {
                return _isInitialized;
            };
            // Creating the self.initialize = ()
            _self[0, $1ae5573ce493bccc$export$65cd33bb52d04675 /* @min:%2einitialize */ ] = function(config, extensions, logger, notificationManager) {
                if (_isUnloading) (0, $44a1c24c0e411039$export$8bf7aba4a9e09055)($e5177bba49076348$var$strSdkUnloadingError);
                // Make sure core is only initialized once
                if (_self[0, $1ae5573ce493bccc$export$2e2716e9c35a66a8 /* @min:%2eisInitialized */ ]()) (0, $44a1c24c0e411039$export$8bf7aba4a9e09055)("Core cannot be initialized more than once");
                _configHandler = (0, $acb30f9e62dc5705$export$3a9e9180c14487fd)(config, $e5177bba49076348$var$defaultConfig, logger || _self[0, $1ae5573ce493bccc$export$e6a243fe757439f9 /* @min:%2elogger */ ], false);
                // Re-assigning the local config property so we don't have any references to the passed value and it can be garbage collected
                config = _configHandler.cfg;
                // This will be "re-run" if the referenced config properties are changed
                _addUnloadHook(_configHandler[0, $1ae5573ce493bccc$export$fc59eec8d77f3766 /* @min:%2ewatch */ ](function(details) {
                    _instrumentationKey = details.cfg.instrumentationKey;
                    // Mark the extensionConfig and all first level keys as referenced
                    // This is so that calls to getExtCfg() will always return the same object
                    // Even when a user may "re-assign" the plugin properties (or it's unloaded/reloaded)
                    var extCfg = details.ref(details.cfg, (0, $9fe4a5d5204a4cff$export$ffb2356587263734));
                    (0, $45e528077703ac0c$export$aa0705d5774c95d1)(extCfg, function(key) {
                        details.ref(extCfg, key);
                    });
                    if ((0, $533f826bbc418791$export$bedb7023a7733221)(_instrumentationKey)) (0, $44a1c24c0e411039$export$8bf7aba4a9e09055)("Please provide instrumentation key");
                }));
                _notificationManager = notificationManager;
                _initDebugListener();
                _initPerfManager();
                _self[0, $1ae5573ce493bccc$export$e6a243fe757439f9 /* @min:%2elogger */ ] = logger;
                var cfgExtensions = config[0, $9fe4a5d5204a4cff$export$a077ce616a1ab4ee /* @min:%2eextensions */ ];
                // Extension validation
                _configExtensions = [];
                _configExtensions[0, $1ae5573ce493bccc$export$a0a330e7fa1e278c /* @min:%2epush */ ].apply(_configExtensions, (0, $2a74b38b87b38cda$export$643fbb7023bc1942)((0, $2a74b38b87b38cda$export$643fbb7023bc1942)([], extensions, false), cfgExtensions, false));
                _channelConfig = config[0, $9fe4a5d5204a4cff$export$829012af4b2055a2 /* @min:%2echannels */ ];
                _initPluginChain(null);
                if (!_channels || _channels[0, $1ae5573ce493bccc$export$6eae51590aaea43 /* @min:%2elength */ ] === 0) (0, $44a1c24c0e411039$export$8bf7aba4a9e09055)("No " + (0, $9fe4a5d5204a4cff$export$829012af4b2055a2) + " available");
                if (_channelConfig && _channelConfig[0, $1ae5573ce493bccc$export$6eae51590aaea43 /* @min:%2elength */ ] > 1) {
                    var teeController = _self[0, $1ae5573ce493bccc$export$37717a508eca6e2d /* @min:%2egetPlugin */ ]("TeeChannelController");
                    if (!teeController || !teeController.plugin) (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(_logger, 1 /* eLoggingSeverity.CRITICAL */ , 28 /* _eInternalMessageId.SenderNotInitialized */ , "TeeChannel required");
                }
                $e5177bba49076348$var$_registerDelayedCfgListener(config, _cfgListeners, _logger);
                _cfgListeners = null;
                _isInitialized = true;
                _self.releaseQueue();
                _self[0, $1ae5573ce493bccc$export$538c138266a38409 /* @min:%2epollInternalLogs */ ]();
            };
            _self.getChannels = function() {
                var controls = [];
                if (_channels) (0, $f6bb085f8cf12216$export$e2e5bcdbdc49c586)(_channels, function(channel) {
                    controls[0, $1ae5573ce493bccc$export$a0a330e7fa1e278c /* @min:%2epush */ ](channel);
                });
                return (0, $36a077d9f4439b69$export$5da24d7703175bc5)(controls);
            };
            _self.track = function(telemetryItem) {
                (0, $28deccfc004f252b$export$c6fbeb260600c482)(_self[0, $9fe4a5d5204a4cff$export$f8b08c7de64edfbf /* @min:%2egetPerfMgr */ ](), function() {
                    return "AppInsightsCore:track";
                }, function() {
                    if (telemetryItem === null) {
                        _notifyInvalidEvent(telemetryItem);
                        // throw error
                        (0, $44a1c24c0e411039$export$8bf7aba4a9e09055)("Invalid telemetry item");
                    }
                    // do basic validation before sending it through the pipeline
                    if (!telemetryItem[0, $1ae5573ce493bccc$export$9734b0a24bf02e93 /* @min:%2ename */ ] && (0, $533f826bbc418791$export$bedb7023a7733221)(telemetryItem[0, $1ae5573ce493bccc$export$9734b0a24bf02e93 /* @min:%2ename */ ])) {
                        _notifyInvalidEvent(telemetryItem);
                        (0, $44a1c24c0e411039$export$8bf7aba4a9e09055)("telemetry name required");
                    }
                    // setup default iKey if not passed in
                    telemetryItem.iKey = telemetryItem.iKey || _instrumentationKey;
                    // add default timestamp if not passed in
                    telemetryItem[0, $1ae5573ce493bccc$export$7b5ba5854159c1f0 /* @min:%2etime */ ] = telemetryItem[0, $1ae5573ce493bccc$export$7b5ba5854159c1f0 /* @min:%2etime */ ] || (0, $0b747974b0bb3563$export$dfaaa8705752128f)(new Date());
                    // Common Schema 4.0
                    telemetryItem.ver = telemetryItem.ver || "4.0";
                    if (!_isUnloading && _self[0, $1ae5573ce493bccc$export$2e2716e9c35a66a8 /* @min:%2eisInitialized */ ]()) // Process the telemetry plugin chain
                    _createTelCtx()[0, $1ae5573ce493bccc$export$5c220169317cd6de /* @min:%2eprocessNext */ ](telemetryItem);
                    else // Queue events until all extensions are initialized
                    _eventQueue[0, $1ae5573ce493bccc$export$a0a330e7fa1e278c /* @min:%2epush */ ](telemetryItem);
                }, function() {
                    return {
                        item: telemetryItem
                    };
                }, !telemetryItem.sync);
            };
            _self[0, $1ae5573ce493bccc$export$a08d24db8e8aa3f3 /* @min:%2egetProcessTelContext */ ] = _createTelCtx;
            _self[0, $1ae5573ce493bccc$export$3a09068de032bb32 /* @min:%2egetNotifyMgr */ ] = function() {
                if (!_notificationManager) {
                    _notificationManager = new (0, $21e0e68428bc90cf$export$dfa1f14b6290f8c5)(_configHandler.cfg);
                    // For backward compatibility only
                    _self[$e5177bba49076348$var$strNotificationManager] = _notificationManager;
                }
                return _notificationManager;
            };
            /**
             * Adds a notification listener. The SDK calls methods on the listener when an appropriate notification is raised.
             * The added plugins must raise notifications. If the plugins do not implement the notifications, then no methods will be
             * called.
             * @param listener - An INotificationListener object.
             */ _self[0, $1ae5573ce493bccc$export$5c8bcfab4f42ca62 /* @min:%2eaddNotificationListener */ ] = function(listener) {
                _self[0, $1ae5573ce493bccc$export$3a09068de032bb32 /* @min:%2egetNotifyMgr */ ]()[0, $1ae5573ce493bccc$export$5c8bcfab4f42ca62 /* @min:%2eaddNotificationListener */ ](listener);
            };
            /**
             * Removes all instances of the listener.
             * @param listener - INotificationListener to remove.
             */ _self[0, $1ae5573ce493bccc$export$861144ba9c13be60 /* @min:%2eremoveNotificationListener */ ] = function(listener) {
                if (_notificationManager) _notificationManager[0, $1ae5573ce493bccc$export$861144ba9c13be60 /* @min:%2eremoveNotificationListener */ ](listener);
            };
            _self.getCookieMgr = function() {
                if (!_cookieManager) _cookieManager = (0, $d751d7cd1b1c5598$export$2ae082191ac44e5a)(_configHandler.cfg, _self[0, $1ae5573ce493bccc$export$e6a243fe757439f9 /* @min:%2elogger */ ]);
                return _cookieManager;
            };
            _self.setCookieMgr = function(cookieMgr) {
                if (_cookieManager !== cookieMgr) {
                    (0, $2cb93c1cbddb67ab$export$86347c3dd68c03f6)(_cookieManager, false);
                    _cookieManager = cookieMgr;
                }
            };
            _self[0, $9fe4a5d5204a4cff$export$f8b08c7de64edfbf /* @min:%2egetPerfMgr */ ] = function() {
                if (!_perfManager && !_cfgPerfManager) _addUnloadHook(_configHandler[0, $1ae5573ce493bccc$export$fc59eec8d77f3766 /* @min:%2ewatch */ ](function(details) {
                    if (details.cfg.enablePerfMgr) {
                        var createPerfMgr = details.cfg[0, $9fe4a5d5204a4cff$export$1cf3476332da55b3 /* @min:%2ecreatePerfMgr */ ];
                        if ((0, $533f826bbc418791$export$f6e2535fb5126e54)(createPerfMgr)) _cfgPerfManager = createPerfMgr(_self, _self[0, $1ae5573ce493bccc$export$3a09068de032bb32 /* @min:%2egetNotifyMgr */ ]());
                    }
                }));
                return _perfManager || _cfgPerfManager || (0, $28deccfc004f252b$export$6cdbf3f34ace6568)();
            };
            _self.setPerfMgr = function(perfMgr) {
                _perfManager = perfMgr;
            };
            _self.eventCnt = function() {
                return _eventQueue[0, $1ae5573ce493bccc$export$6eae51590aaea43 /* @min:%2elength */ ];
            };
            _self.releaseQueue = function() {
                if (_isInitialized && _eventQueue[0, $1ae5573ce493bccc$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) {
                    var eventQueue = _eventQueue;
                    _eventQueue = [];
                    (0, $f6bb085f8cf12216$export$e2e5bcdbdc49c586)(eventQueue, function(event) {
                        _createTelCtx()[0, $1ae5573ce493bccc$export$5c220169317cd6de /* @min:%2eprocessNext */ ](event);
                    });
                }
            };
            _self[0, $1ae5573ce493bccc$export$538c138266a38409 /* @min:%2epollInternalLogs */ ] = function(eventName) {
                _internalLogsEventName = eventName || null;
                _forceStopInternalLogPoller = false;
                _internalLogPoller && _internalLogPoller[0, $1ae5573ce493bccc$export$bd01c5e3f12db01c /* @min:%2ecancel */ ]();
                return _startLogPoller(true);
            };
            function _startLogPoller(alwaysStart) {
                if ((!_internalLogPoller || !_internalLogPoller[0, $1ae5573ce493bccc$export$c9b1609f2b84393a /* @min:%2eenabled */ ]) && !_forceStopInternalLogPoller) {
                    var shouldStart = alwaysStart || _logger && _logger.queue[0, $1ae5573ce493bccc$export$6eae51590aaea43 /* @min:%2elength */ ] > 0;
                    if (shouldStart) {
                        if (!_internalLogPollerListening) {
                            _internalLogPollerListening = true;
                            // listen for any configuration changes so that changes to the
                            // interval will cause the timer to be re-initialized
                            _addUnloadHook(_configHandler[0, $1ae5573ce493bccc$export$fc59eec8d77f3766 /* @min:%2ewatch */ ](function(details) {
                                var interval = details.cfg.diagnosticLogInterval;
                                if (!interval || !(interval > 0)) interval = 10000;
                                var isRunning = false;
                                if (_internalLogPoller) {
                                    // It was already created so remember it's running and cancel
                                    isRunning = _internalLogPoller[0, $1ae5573ce493bccc$export$c9b1609f2b84393a /* @min:%2eenabled */ ];
                                    _internalLogPoller[0, $1ae5573ce493bccc$export$bd01c5e3f12db01c /* @min:%2ecancel */ ]();
                                }
                                // Create / reconfigure
                                _internalLogPoller = (0, $d03b12effd00bf96$export$6eae7cf7a129a986)(_flushInternalLogs, interval);
                                _internalLogPoller.unref();
                                // Restart if previously running
                                _internalLogPoller[0, $1ae5573ce493bccc$export$c9b1609f2b84393a /* @min:%2eenabled */ ] = isRunning;
                            }));
                        }
                        _internalLogPoller[0, $1ae5573ce493bccc$export$c9b1609f2b84393a /* @min:%2eenabled */ ] = true;
                    }
                }
                return _internalLogPoller;
            }
            _self[0, $1ae5573ce493bccc$export$8d1c48dba7ad83a /* @min:%2estopPollingInternalLogs */ ] = function() {
                _forceStopInternalLogPoller = true;
                _internalLogPoller && _internalLogPoller[0, $1ae5573ce493bccc$export$bd01c5e3f12db01c /* @min:%2ecancel */ ]();
                _flushInternalLogs();
            };
            // Add addTelemetryInitializer
            (0, $0b747974b0bb3563$export$94f4c7fb7e7d8dc7)(_self, function() {
                return _telemetryInitializerPlugin;
            }, [
                "addTelemetryInitializer"
            ]);
            _self[0, $1ae5573ce493bccc$export$7eb85b5cba77a43d /* @min:%2eunload */ ] = function(isAsync, unloadComplete, cbTimeout) {
                var _a;
                if (isAsync === void 0) isAsync = true;
                if (!_isInitialized) // The SDK is not initialized
                (0, $44a1c24c0e411039$export$8bf7aba4a9e09055)($e5177bba49076348$var$strSdkNotInitialized);
                // Check if the SDK still unloading so throw
                if (_isUnloading) // The SDK is already unloading
                (0, $44a1c24c0e411039$export$8bf7aba4a9e09055)($e5177bba49076348$var$strSdkUnloadingError);
                var unloadState = (_a = {
                    reason: 50 /* TelemetryUnloadReason.SdkUnload */ 
                }, _a[0, $1ae5573ce493bccc$export$d8114c9e990204cb /* @min:isAsync */ ] = isAsync, _a.flushComplete = false, _a);
                var result;
                if (isAsync && !unloadComplete) result = (0, $911d39c591a62618$export$5a1eb20c68656e88)(function(resolve) {
                    // Set the callback to the promise resolve callback
                    unloadComplete = resolve;
                });
                var processUnloadCtx = (0, $bc7124acb0f73e64$export$91bbbd4999751948)(_getPluginChain(), _self);
                processUnloadCtx[0, $1ae5573ce493bccc$export$8693bdba21bfca93 /* @min:%2eonComplete */ ](function() {
                    _hookContainer.run(_self[0, $1ae5573ce493bccc$export$e6a243fe757439f9 /* @min:%2elogger */ ]);
                    // Run any "unload" functions for the _cookieManager, _notificationManager and _logger
                    (0, $2cb93c1cbddb67ab$export$bc81824d13c51ef3)([
                        _cookieManager,
                        _notificationManager,
                        _logger
                    ], isAsync, function() {
                        _initDefaults();
                        unloadComplete && unloadComplete(unloadState);
                    });
                }, _self);
                function _doUnload(flushComplete) {
                    unloadState.flushComplete = flushComplete;
                    _isUnloading = true;
                    // Run all of the unload handlers first (before unloading the plugins)
                    _unloadHandlers.run(processUnloadCtx, unloadState);
                    // Stop polling the internal logs
                    _self[0, $1ae5573ce493bccc$export$8d1c48dba7ad83a /* @min:%2estopPollingInternalLogs */ ]();
                    // Start unloading the components, from this point onwards the SDK should be considered to be in an unstable state
                    processUnloadCtx[0, $1ae5573ce493bccc$export$5c220169317cd6de /* @min:%2eprocessNext */ ](unloadState);
                }
                _flushInternalLogs();
                if (!_flushChannels(isAsync, _doUnload, 6 /* SendRequestReason.SdkUnload */ , cbTimeout)) _doUnload(false);
                return result;
            };
            _self[0, $1ae5573ce493bccc$export$37717a508eca6e2d /* @min:%2egetPlugin */ ] = _getPlugin;
            _self.addPlugin = function(plugin, replaceExisting, isAsync, addCb) {
                if (!plugin) {
                    addCb && addCb(false);
                    _logOrThrowError($e5177bba49076348$var$strValidationError);
                    return;
                }
                var existingPlugin = _getPlugin(plugin[0, $1ae5573ce493bccc$export$f001befbf8417151 /* @min:%2eidentifier */ ]);
                if (existingPlugin && !replaceExisting) {
                    addCb && addCb(false);
                    _logOrThrowError("Plugin [" + plugin[0, $1ae5573ce493bccc$export$f001befbf8417151 /* @min:%2eidentifier */ ] + "] is already loaded!");
                    return;
                }
                var updateState = {
                    reason: 16 /* TelemetryUpdateReason.PluginAdded */ 
                };
                function _addPlugin(removed) {
                    _configExtensions[0, $1ae5573ce493bccc$export$a0a330e7fa1e278c /* @min:%2epush */ ](plugin);
                    updateState.added = [
                        plugin
                    ];
                    // Re-Initialize the plugin chain
                    _initPluginChain(updateState);
                    addCb && addCb(true);
                }
                if (existingPlugin) {
                    var removedPlugins_1 = [
                        existingPlugin.plugin
                    ];
                    var unloadState = {
                        reason: 2 /* TelemetryUnloadReason.PluginReplace */ ,
                        isAsync: !!isAsync
                    };
                    _removePlugins(removedPlugins_1, unloadState, function(removed) {
                        if (!removed) // Previous plugin was successfully removed or was not installed
                        addCb && addCb(false);
                        else {
                            updateState.removed = removedPlugins_1;
                            updateState.reason |= 32 /* TelemetryUpdateReason.PluginRemoved */ ;
                            _addPlugin(true);
                        }
                    });
                } else _addPlugin(false);
            };
            _self.updateCfg = function(newConfig, mergeExisting) {
                if (mergeExisting === void 0) mergeExisting = true;
                var updateState;
                if (_self[0, $1ae5573ce493bccc$export$2e2716e9c35a66a8 /* @min:%2eisInitialized */ ]()) {
                    updateState = {
                        reason: 1 /* TelemetryUpdateReason.ConfigurationChanged */ ,
                        cfg: _configHandler.cfg,
                        oldCfg: (0, $9042921d36c971e1$export$54e9fb29908872fa)({}, _configHandler.cfg),
                        newConfig: (0, $9042921d36c971e1$export$54e9fb29908872fa)({}, newConfig),
                        merge: mergeExisting
                    };
                    newConfig = updateState.newConfig;
                    var cfg = _configHandler.cfg;
                    // replace the immutable (if initialized) values
                    // We don't currently allow updating the extensions and channels via the update config
                    // So overwriting any user provided values to reuse the existing values
                    newConfig[0, $9fe4a5d5204a4cff$export$a077ce616a1ab4ee /* @min:%2eextensions */ ] = cfg[0, $9fe4a5d5204a4cff$export$a077ce616a1ab4ee /* @min:%2eextensions */ ];
                    newConfig[0, $9fe4a5d5204a4cff$export$829012af4b2055a2 /* @min:%2echannels */ ] = cfg[0, $9fe4a5d5204a4cff$export$829012af4b2055a2 /* @min:%2echannels */ ];
                }
                // Explicitly blocking any previous config watchers so that they don't get called because
                // of this bulk update (Probably not necessary)
                _configHandler._block(function(details) {
                    // Lets assign the new values to the existing config either overwriting or re-assigning
                    var theConfig = details.cfg;
                    $e5177bba49076348$var$_deepMergeConfig(details, theConfig, newConfig, mergeExisting);
                    if (!mergeExisting) // Remove (unassign) the values "missing" from the newConfig and also not in the default config
                    (0, $45e528077703ac0c$export$aa0705d5774c95d1)(theConfig, function(key) {
                        if (!(0, $08325aa6d8565cc0$export$34e6b98f73578a9c)(newConfig, key)) // Set the value to undefined
                        details.set(theConfig, key, (0, $9fe4a5d5204a4cff$export$a43287864529b8fd));
                    });
                    // Apply defaults to the new config
                    details[0, $1ae5573ce493bccc$export$24caac6d68ff1537 /* @min:%2esetDf */ ](theConfig, $e5177bba49076348$var$defaultConfig);
                }, true);
                // Now execute all of the listeners (synchronously) so they update their values immediately
                _configHandler[0, $1ae5573ce493bccc$export$6c2b24c6eee14c46 /* @min:%2enotify */ ]();
                if (updateState) _doUpdate(updateState);
            };
            _self.evtNamespace = function() {
                return _evtNamespace;
            };
            _self.flush = _flushChannels;
            _self.getTraceCtx = function(createNew) {
                if (!_traceCtx) _traceCtx = (0, $757da337740268ac$export$10fa4480433f402c)();
                return _traceCtx;
            };
            _self.setTraceCtx = function(traceCtx) {
                _traceCtx = traceCtx || null;
            };
            _self.addUnloadHook = _addUnloadHook;
            // Create the addUnloadCb
            (0, $0b747974b0bb3563$export$5dd8d245f6f94a18)(_self, "addUnloadCb", function() {
                return _unloadHandlers;
            }, "add");
            _self.onCfgChange = function(handler) {
                var unloadHook;
                if (!_isInitialized) unloadHook = $e5177bba49076348$var$_addDelayedCfgListener(_cfgListeners, handler);
                else unloadHook = (0, $acb30f9e62dc5705$export$454a433e4deb244f)(_configHandler.cfg, handler, _self[0, $1ae5573ce493bccc$export$e6a243fe757439f9 /* @min:%2elogger */ ]);
                return {
                    rm: function() {
                        unloadHook.rm();
                    }
                };
            };
            _self.getWParam = function() {
                return (0, $3d5fcb60a9467a45$export$c4372eca9c56fe99)() || !!_configHandler.cfg.enableWParam ? 0 : -1;
            };
            function _setPluginVersions() {
                var thePlugins = {};
                _pluginVersionStringArr = [];
                var _addPluginVersions = function(plugins) {
                    if (plugins) (0, $f6bb085f8cf12216$export$e2e5bcdbdc49c586)(plugins, function(plugin) {
                        if (plugin[0, $1ae5573ce493bccc$export$f001befbf8417151 /* @min:%2eidentifier */ ] && plugin[0, $1ae5573ce493bccc$export$568c4302d11f2b22 /* @min:%2eversion */ ] && !thePlugins[plugin.identifier]) {
                            var ver = plugin[0, $1ae5573ce493bccc$export$f001befbf8417151 /* @min:%2eidentifier */ ] + "=" + plugin[0, $1ae5573ce493bccc$export$568c4302d11f2b22 /* @min:%2eversion */ ];
                            _pluginVersionStringArr[0, $1ae5573ce493bccc$export$a0a330e7fa1e278c /* @min:%2epush */ ](ver);
                            thePlugins[plugin.identifier] = plugin;
                        }
                    });
                };
                _addPluginVersions(_channels);
                if (_channelConfig) (0, $f6bb085f8cf12216$export$e2e5bcdbdc49c586)(_channelConfig, function(channels) {
                    _addPluginVersions(channels);
                });
                _addPluginVersions(_configExtensions);
            }
            function _initDefaults() {
                _isInitialized = false;
                // Use a default logger so initialization errors are not dropped on the floor with full logging
                _configHandler = (0, $acb30f9e62dc5705$export$3a9e9180c14487fd)({}, $e5177bba49076348$var$defaultConfig, _self[0, $1ae5573ce493bccc$export$e6a243fe757439f9 /* @min:%2elogger */ ]);
                // Set the logging level to critical so that any critical initialization failures are displayed on the console
                _configHandler.cfg[0, $1ae5573ce493bccc$export$e53d8cae4d527530 /* @min:%2eloggingLevelConsole */ ] = 1 /* eLoggingSeverity.CRITICAL */ ;
                // Define _self.config
                (0, $d212d948d25f959a$export$d0d2ebf910ad6e2)(_self, "config", {
                    g: function() {
                        return _configHandler.cfg;
                    },
                    s: function(newValue) {
                        _self.updateCfg(newValue, false);
                    }
                });
                (0, $d212d948d25f959a$export$d0d2ebf910ad6e2)(_self, "pluginVersionStringArr", {
                    g: function() {
                        if (!_pluginVersionStringArr) _setPluginVersions();
                        return _pluginVersionStringArr;
                    }
                });
                (0, $d212d948d25f959a$export$d0d2ebf910ad6e2)(_self, "pluginVersionString", {
                    g: function() {
                        if (!_pluginVersionString) {
                            if (!_pluginVersionStringArr) _setPluginVersions();
                            _pluginVersionString = _pluginVersionStringArr.join(";");
                        }
                        return _pluginVersionString || (0, $9fe4a5d5204a4cff$export$5e8607ab26634759);
                    }
                });
                (0, $d212d948d25f959a$export$d0d2ebf910ad6e2)(_self, "logger", {
                    g: function() {
                        if (!_logger) {
                            _logger = new (0, $cc2aaaebf96ac6a7$export$4f80edb2e10dc14c)(_configHandler.cfg);
                            _configHandler[0, $1ae5573ce493bccc$export$e6a243fe757439f9 /* @min:%2elogger */ ] = _logger;
                        }
                        return _logger;
                    },
                    s: function(newLogger) {
                        _configHandler[0, $1ae5573ce493bccc$export$e6a243fe757439f9 /* @min:%2elogger */ ] = newLogger;
                        if (_logger !== newLogger) {
                            (0, $2cb93c1cbddb67ab$export$86347c3dd68c03f6)(_logger, false);
                            _logger = newLogger;
                        }
                    }
                });
                _self[0, $1ae5573ce493bccc$export$e6a243fe757439f9 /* @min:%2elogger */ ] = new (0, $cc2aaaebf96ac6a7$export$4f80edb2e10dc14c)(_configHandler.cfg);
                _extensions = [];
                var cfgExtensions = _self.config[0, $9fe4a5d5204a4cff$export$a077ce616a1ab4ee /* @min:%2eextensions */ ] || [];
                cfgExtensions.splice(0, cfgExtensions[0, $1ae5573ce493bccc$export$6eae51590aaea43 /* @min:%2elength */ ]);
                (0, $54343718a076ab6e$export$69c7b96f216fdf7b)(cfgExtensions, _extensions);
                _telemetryInitializerPlugin = new (0, $4d4645ee8836015f$export$5da7f32cc3b89dc1)();
                _eventQueue = [];
                (0, $2cb93c1cbddb67ab$export$86347c3dd68c03f6)(_notificationManager, false);
                _notificationManager = null;
                _perfManager = null;
                _cfgPerfManager = null;
                (0, $2cb93c1cbddb67ab$export$86347c3dd68c03f6)(_cookieManager, false);
                _cookieManager = null;
                _pluginChain = null;
                _configExtensions = [];
                _channelConfig = null;
                _channels = null;
                _isUnloading = false;
                _internalLogsEventName = null;
                _evtNamespace = (0, $8a2d104e2647a310$export$eb4a6badb18ead04)("AIBaseCore", true);
                _unloadHandlers = (0, $d13bf4befeee29ad$export$1dd1604aeaf8cfed)();
                _traceCtx = null;
                _instrumentationKey = null;
                _hookContainer = (0, $efe9376777343289$export$31fa167f9d342989)();
                _cfgListeners = [];
                _pluginVersionString = null;
                _pluginVersionStringArr = null;
                _forceStopInternalLogPoller = false;
            }
            function _createTelCtx() {
                var theCtx = (0, $bc7124acb0f73e64$export$ca98f11e981bcfd6)(_getPluginChain(), _configHandler.cfg, _self);
                theCtx[0, $1ae5573ce493bccc$export$8693bdba21bfca93 /* @min:%2eonComplete */ ](_startLogPoller);
                return theCtx;
            }
            // Initialize or Re-initialize the plugins
            function _initPluginChain(updateState) {
                // Extension validation
                var theExtensions = $e5177bba49076348$var$_validateExtensions(_self[0, $1ae5573ce493bccc$export$e6a243fe757439f9 /* @min:%2elogger */ ], (0, $f66a763d1ac581a5$export$a1373ad9f192f374), _configExtensions);
                _pluginChain = null;
                _pluginVersionString = null;
                _pluginVersionStringArr = null;
                // Get the primary channel queue and include as part of the normal extensions
                _channels = (_channelConfig || [])[0] || [];
                // Add any channels provided in the extensions and sort them
                _channels = (0, $757da337740268ac$export$478771939b7b39a2)((0, $54343718a076ab6e$export$69c7b96f216fdf7b)(_channels, theExtensions[0, $9fe4a5d5204a4cff$export$829012af4b2055a2 /* @min:%2echannels */ ]));
                // Create an array of all extensions, including the _channels
                var allExtensions = (0, $54343718a076ab6e$export$69c7b96f216fdf7b)((0, $757da337740268ac$export$478771939b7b39a2)(theExtensions[0, $9fe4a5d5204a4cff$export$3094ace9cd82ff99 /* @min:%2ecore */ ]), _channels);
                // Required to allow plugins to call core.getPlugin() during their own initialization
                _extensions = (0, $36a077d9f4439b69$export$5da24d7703175bc5)(allExtensions);
                // This has a side effect of adding the extensions passed during initialization
                // into the config.extensions, so you can see all of the extensions loaded.
                // This will also get updated by the addPlugin() and remove plugin code.
                var cfgExtensions = _self.config[0, $9fe4a5d5204a4cff$export$a077ce616a1ab4ee /* @min:%2eextensions */ ] || [];
                cfgExtensions.splice(0, cfgExtensions[0, $1ae5573ce493bccc$export$6eae51590aaea43 /* @min:%2elength */ ]);
                (0, $54343718a076ab6e$export$69c7b96f216fdf7b)(cfgExtensions, _extensions);
                var rootCtx = _createTelCtx();
                // Initializing the channels first
                if (_channels && _channels[0, $1ae5573ce493bccc$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) (0, $757da337740268ac$export$be211df7b1eeb33e)(rootCtx[0, $1ae5573ce493bccc$export$1e6514b499ba4d34 /* @min:%2ecreateNew */ ](_channels), allExtensions);
                // Now initialize the normal extensions (explicitly not including the _channels as this can cause duplicate initialization)
                (0, $757da337740268ac$export$be211df7b1eeb33e)(rootCtx, allExtensions);
                if (updateState) _doUpdate(updateState);
            }
            function _getPlugin(pluginIdentifier) {
                var theExt = null;
                var thePlugin = null;
                var channelHosts = [];
                (0, $f6bb085f8cf12216$export$e2e5bcdbdc49c586)(_extensions, function(ext) {
                    if (ext[0, $1ae5573ce493bccc$export$f001befbf8417151 /* @min:%2eidentifier */ ] === pluginIdentifier && ext !== _telemetryInitializerPlugin) {
                        thePlugin = ext;
                        return -1;
                    }
                    if (ext.getChannel) channelHosts[0, $1ae5573ce493bccc$export$a0a330e7fa1e278c /* @min:%2epush */ ](ext);
                });
                if (!thePlugin && channelHosts[0, $1ae5573ce493bccc$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) (0, $f6bb085f8cf12216$export$e2e5bcdbdc49c586)(channelHosts, function(host) {
                    thePlugin = host.getChannel(pluginIdentifier);
                    if (!thePlugin) return -1;
                });
                if (thePlugin) theExt = {
                    plugin: thePlugin,
                    setEnabled: function(enabled) {
                        (0, $757da337740268ac$export$37cfaecb9b4b1b3b)(thePlugin)[0, $9fe4a5d5204a4cff$export$49e9417944569ae8] = !enabled;
                    },
                    isEnabled: function() {
                        var pluginState = (0, $757da337740268ac$export$37cfaecb9b4b1b3b)(thePlugin);
                        return !pluginState[0, $1ae5573ce493bccc$export$7176fb2a7d11927e /* @min:%2eteardown */ ] && !pluginState[0, $9fe4a5d5204a4cff$export$49e9417944569ae8];
                    },
                    remove: function(isAsync, removeCb) {
                        var _a;
                        if (isAsync === void 0) isAsync = true;
                        var pluginsToRemove = [
                            thePlugin
                        ];
                        var unloadState = (_a = {
                            reason: 1 /* TelemetryUnloadReason.PluginUnload */ 
                        }, _a[0, $1ae5573ce493bccc$export$d8114c9e990204cb /* @min:isAsync */ ] = isAsync, _a);
                        _removePlugins(pluginsToRemove, unloadState, function(removed) {
                            if (removed) // Re-Initialize the plugin chain
                            _initPluginChain({
                                reason: 32 /* TelemetryUpdateReason.PluginRemoved */ ,
                                removed: pluginsToRemove
                            });
                            removeCb && removeCb(removed);
                        });
                    }
                };
                return theExt;
            }
            function _getPluginChain() {
                if (!_pluginChain) {
                    // copy the collection of extensions
                    var extensions = (_extensions || []).slice();
                    // During add / remove this may get called again, so don't read if already present
                    if ((0, $a96d4958027d6f85$export$9f3b3ffa84393d30)(extensions, _telemetryInitializerPlugin) === -1) extensions[0, $1ae5573ce493bccc$export$a0a330e7fa1e278c /* @min:%2epush */ ](_telemetryInitializerPlugin);
                    _pluginChain = (0, $bc7124acb0f73e64$export$107e639207cdf742)((0, $757da337740268ac$export$478771939b7b39a2)(extensions), _configHandler.cfg, _self);
                }
                return _pluginChain;
            }
            function _removePlugins(thePlugins, unloadState, removeComplete) {
                if (thePlugins && thePlugins[0, $1ae5573ce493bccc$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) {
                    var unloadChain = (0, $bc7124acb0f73e64$export$107e639207cdf742)(thePlugins, _configHandler.cfg, _self);
                    var unloadCtx = (0, $bc7124acb0f73e64$export$91bbbd4999751948)(unloadChain, _self);
                    unloadCtx[0, $1ae5573ce493bccc$export$8693bdba21bfca93 /* @min:%2eonComplete */ ](function() {
                        var removed = false;
                        // Remove the listed config extensions
                        var newConfigExtensions = [];
                        (0, $f6bb085f8cf12216$export$e2e5bcdbdc49c586)(_configExtensions, function(plugin, idx) {
                            if (!$e5177bba49076348$var$_isPluginPresent(plugin, thePlugins)) newConfigExtensions[0, $1ae5573ce493bccc$export$a0a330e7fa1e278c /* @min:%2epush */ ](plugin);
                            else removed = true;
                        });
                        _configExtensions = newConfigExtensions;
                        _pluginVersionString = null;
                        _pluginVersionStringArr = null;
                        // Re-Create the channel config
                        var newChannelConfig = [];
                        if (_channelConfig) {
                            (0, $f6bb085f8cf12216$export$e2e5bcdbdc49c586)(_channelConfig, function(queue, idx) {
                                var newQueue = [];
                                (0, $f6bb085f8cf12216$export$e2e5bcdbdc49c586)(queue, function(channel) {
                                    if (!$e5177bba49076348$var$_isPluginPresent(channel, thePlugins)) newQueue[0, $1ae5573ce493bccc$export$a0a330e7fa1e278c /* @min:%2epush */ ](channel);
                                    else removed = true;
                                });
                                newChannelConfig[0, $1ae5573ce493bccc$export$a0a330e7fa1e278c /* @min:%2epush */ ](newQueue);
                            });
                            _channelConfig = newChannelConfig;
                        }
                        removeComplete && removeComplete(removed);
                        _startLogPoller();
                    });
                    unloadCtx[0, $1ae5573ce493bccc$export$5c220169317cd6de /* @min:%2eprocessNext */ ](unloadState);
                } else removeComplete(false);
            }
            function _flushInternalLogs() {
                if (_logger && _logger.queue) {
                    var queue = _logger.queue.slice(0);
                    _logger.queue[0, $1ae5573ce493bccc$export$6eae51590aaea43 /* @min:%2elength */ ] = 0;
                    (0, $f6bb085f8cf12216$export$e2e5bcdbdc49c586)(queue, function(logMessage) {
                        var _a;
                        var item = (_a = {}, _a[0, $1ae5573ce493bccc$export$9734b0a24bf02e93 /* @min:name */ ] = _internalLogsEventName ? _internalLogsEventName : "InternalMessageId: " + logMessage[0, $1ae5573ce493bccc$export$2cc5b49df2eed261 /* @min:%2emessageId */ ], _a.iKey = _instrumentationKey, _a[0, $1ae5573ce493bccc$export$7b5ba5854159c1f0 /* @min:time */ ] = (0, $0b747974b0bb3563$export$dfaaa8705752128f)(new Date()), _a.baseType = (0, $cc2aaaebf96ac6a7$export$70ef838ed08aad47).dataType, _a.baseData = {
                            message: logMessage[0, $1ae5573ce493bccc$export$923606b70907833e /* @min:%2emessage */ ]
                        }, _a);
                        _self.track(item);
                    });
                }
            }
            function _flushChannels(isAsync, callBack, sendReason, cbTimeout) {
                // Setting waiting to one so that we don't call the callBack until we finish iterating
                var waiting = 1;
                var doneIterating = false;
                var cbTimer = null;
                cbTimeout = cbTimeout || 5000;
                function doCallback() {
                    waiting--;
                    if (doneIterating && waiting === 0) {
                        cbTimer && cbTimer[0, $1ae5573ce493bccc$export$bd01c5e3f12db01c /* @min:%2ecancel */ ]();
                        cbTimer = null;
                        callBack && callBack(doneIterating);
                        callBack = null;
                    }
                }
                if (_channels && _channels[0, $1ae5573ce493bccc$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) {
                    var flushCtx = _createTelCtx()[0, $1ae5573ce493bccc$export$1e6514b499ba4d34 /* @min:%2ecreateNew */ ](_channels);
                    flushCtx.iterate(function(plugin) {
                        if (plugin.flush) {
                            waiting++;
                            var handled_1 = false;
                            // Not all channels will call this callback for every scenario
                            if (!plugin.flush(isAsync, function() {
                                handled_1 = true;
                                doCallback();
                            }, sendReason)) {
                                if (!handled_1) {
                                    // If any channel doesn't return true and it didn't call the callback, then we should assume that the callback
                                    // will never be called, so use a timeout to allow the channel(s) some time to "finish" before triggering any
                                    // followup function (such as unloading)
                                    if (isAsync && cbTimer == null) cbTimer = (0, $d03b12effd00bf96$export$5f4d6617421d489b)(function() {
                                        cbTimer = null;
                                        doCallback();
                                    }, cbTimeout);
                                    else doCallback();
                                }
                            }
                        }
                    });
                }
                doneIterating = true;
                doCallback();
                return true;
            }
            function _initDebugListener() {
                // Lazily ensure that the notification manager is created
                !_notificationManager && _self[0, $1ae5573ce493bccc$export$3a09068de032bb32 /* @min:%2egetNotifyMgr */ ]();
                // Will get recalled if any referenced config values are changed
                _addUnloadHook(_configHandler[0, $1ae5573ce493bccc$export$fc59eec8d77f3766 /* @min:%2ewatch */ ](function(details) {
                    var disableDbgExt = details.cfg.disableDbgExt;
                    if (disableDbgExt === true && _debugListener) {
                        // Remove any previously loaded debug listener
                        _notificationManager[0, $1ae5573ce493bccc$export$861144ba9c13be60 /* @min:%2eremoveNotificationListener */ ](_debugListener);
                        _debugListener = null;
                    }
                    if (_notificationManager && !_debugListener && disableDbgExt !== true) {
                        _debugListener = (0, $12f08319fee74ea0$export$dae5ac50a0df0f5f)(details.cfg);
                        _notificationManager[0, $1ae5573ce493bccc$export$5c8bcfab4f42ca62 /* @min:%2eaddNotificationListener */ ](_debugListener);
                    }
                }));
            }
            function _initPerfManager() {
                // Will get recalled if any referenced config values are changed
                _addUnloadHook(_configHandler[0, $1ae5573ce493bccc$export$fc59eec8d77f3766 /* @min:%2ewatch */ ](function(details) {
                    var enablePerfMgr = details.cfg.enablePerfMgr;
                    if (!enablePerfMgr && _cfgPerfManager) // Remove any existing config based performance manager
                    _cfgPerfManager = null;
                    if (enablePerfMgr) // Set the performance manager creation function if not defined
                    (0, $0b747974b0bb3563$export$51417ccc212471e)(details.cfg, (0, $9fe4a5d5204a4cff$export$1cf3476332da55b3), $e5177bba49076348$var$_createPerfManager);
                }));
            }
            function _doUpdate(updateState) {
                var updateCtx = (0, $bc7124acb0f73e64$export$e4c32b40c4fbf98a)(_getPluginChain(), _self);
                updateCtx[0, $1ae5573ce493bccc$export$8693bdba21bfca93 /* @min:%2eonComplete */ ](_startLogPoller);
                if (!_self._updateHook || _self._updateHook(updateCtx, updateState) !== true) updateCtx[0, $1ae5573ce493bccc$export$5c220169317cd6de /* @min:%2eprocessNext */ ](updateState);
            }
            function _logOrThrowError(message) {
                var logger = _self[0, $1ae5573ce493bccc$export$e6a243fe757439f9 /* @min:%2elogger */ ];
                if (logger) {
                    // there should always be a logger
                    (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , 73 /* _eInternalMessageId.PluginException */ , message);
                    _startLogPoller();
                } else (0, $44a1c24c0e411039$export$8bf7aba4a9e09055)(message);
            }
            function _notifyInvalidEvent(telemetryItem) {
                var manager = _self[0, $1ae5573ce493bccc$export$3a09068de032bb32 /* @min:%2egetNotifyMgr */ ]();
                if (manager) manager[0, $9fe4a5d5204a4cff$export$bacb5b2f4c1081b9 /* @min:%2eeventsDiscarded */ ]([
                    telemetryItem
                ], 2 /* eEventsDiscardedReason.InvalidEvent */ );
            }
            function _addUnloadHook(hooks) {
                _hookContainer.add(hooks);
            }
        });
    }
    // Removed Stub for AppInsightsCore.prototype.initialize.
    // Removed Stub for AppInsightsCore.prototype.getChannels.
    // Removed Stub for AppInsightsCore.prototype.track.
    // Removed Stub for AppInsightsCore.prototype.getProcessTelContext.
    // Removed Stub for AppInsightsCore.prototype.getNotifyMgr.
    // Removed Stub for AppInsightsCore.prototype.addNotificationListener.
    // Removed Stub for AppInsightsCore.prototype.removeNotificationListener.
    // Removed Stub for AppInsightsCore.prototype.getCookieMgr.
    // Removed Stub for AppInsightsCore.prototype.setCookieMgr.
    // Removed Stub for AppInsightsCore.prototype.getPerfMgr.
    // Removed Stub for AppInsightsCore.prototype.setPerfMgr.
    // Removed Stub for AppInsightsCore.prototype.eventCnt.
    // Removed Stub for AppInsightsCore.prototype.pollInternalLogs.
    // Removed Stub for AppInsightsCore.prototype.stopPollingInternalLogs.
    // Removed Stub for AppInsightsCore.prototype.addTelemetryInitializer.
    // Removed Stub for AppInsightsCore.prototype.unload.
    // Removed Stub for AppInsightsCore.prototype.getPlugin.
    // Removed Stub for AppInsightsCore.prototype.addPlugin.
    // Removed Stub for AppInsightsCore.prototype.updateCfg.
    // Removed Stub for AppInsightsCore.prototype.evtNamespace.
    // Removed Stub for AppInsightsCore.prototype.addUnloadCb.
    // Removed Stub for AppInsightsCore.prototype.flush.
    // Removed Stub for AppInsightsCore.prototype.getTraceCtx.
    // Removed Stub for AppInsightsCore.prototype.setTraceCtx.
    // Removed Stub for AppInsightsCore.prototype.addUnloadHook.
    // Removed Stub for AppInsightsCore.prototype.onCfgChange.
    // Removed Stub for AppInsightsCore.prototype.releaseQueue.
    // Removed Stub for AppInsightsCore.prototype._updateHook.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    AppInsightsCore.__ieDyn = 1;
    return AppInsightsCore;
}();


/*
 * Application Insights JavaScript SDK - Dependencies Plugin, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 




/*
 * Application Insights JavaScript SDK - Dependencies Plugin, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // ###################################################################################################################################################
// Note: DON'T Export these const from the package as we are still targeting IE/ES5 this will export a mutable variables that someone could change ###
// ###################################################################################################################################################
// Generally you should only put values that are used more than 2 times and then only if not already exposed as a constant (such as SdkCoreNames)
// as when using "short" named values from here they will be will be minified smaller than the SdkCoreNames[eSdkCoreNames.xxxx] value.
var $072e43366110cd19$export$be41298b7716c698 = "duration";
var $072e43366110cd19$export$400e70f2a2ecb5aa = "properties";


/*
 * Application Insights JavaScript SDK - Dependencies Plugin, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var $785f2f8595bbd489$export$8ff033ecd75b66c3 = "requestUrl"; // Count: 12
var $785f2f8595bbd489$export$25a34734290022f3 = "inst"; // Count: 5
var $785f2f8595bbd489$export$6eae51590aaea43 = "length"; // Count: 10
var $785f2f8595bbd489$export$a5eb52c53bba8560 = "traceID"; // Count: 9
var $785f2f8595bbd489$export$c105b94efa183847 = "spanID"; // Count: 8
var $785f2f8595bbd489$export$4e92e4b92b41ba2d = "traceFlags"; // Count: 13
var $785f2f8595bbd489$export$fdcd48959e13aba7 = "context"; // Count: 7
var $785f2f8595bbd489$export$fcf18cee9ee41961 = "aborted"; // Count: 7
var $785f2f8595bbd489$export$f8d9e07631527156 = "traceId"; // Count: 5
var $785f2f8595bbd489$export$e39be82dc519c4ae = "spanId"; // Count: 5
var $785f2f8595bbd489$export$3b3afe26ca0e015c = "_addHook"; // Count: 4
var $785f2f8595bbd489$export$f9ae8d0acf86503e = "core"; // Count: 8
var $785f2f8595bbd489$export$ec2c4b7da1ef8dd0 = "includeCorrelationHeaders"; // Count: 4
var $785f2f8595bbd489$export$de5be3709039b9b0 = "getAbsoluteUrl"; // Count: 3
var $785f2f8595bbd489$export$829ed22a43b4aada = "headers"; // Count: 6
var $785f2f8595bbd489$export$b58618e731cdb301 = "requestHeaders"; // Count: 13
var $785f2f8595bbd489$export$84ecd29f369f5b1d = "setRequestHeader"; // Count: 3
var $785f2f8595bbd489$export$2aa2820bfe761f5b = "trackDependencyDataInternal"; // Count: 2
var $785f2f8595bbd489$export$69cac26425c8ea23 = "startTime"; // Count: 6
var $785f2f8595bbd489$export$e4eaee9e01d9baaa = "toLowerCase"; // Count: 6
var $785f2f8595bbd489$export$abc5bbd8bd54996a = "enableRequestHeaderTracking"; // Count: 3
var $785f2f8595bbd489$export$928b837287a09b1f = "enableAjaxErrorStatusText"; // Count: 2
var $785f2f8595bbd489$export$a2e6a87e51acdf74 = "enableAjaxPerfTracking"; // Count: 2
var $785f2f8595bbd489$export$8e8c994d518b7819 = "maxAjaxCallsPerView"; // Count: 2
var $785f2f8595bbd489$export$e4bbd5d3fe5db54b = "excludeRequestFromAutoTrackingPatterns"; // Count: 2
var $785f2f8595bbd489$export$e9d1b90025f35753 = "addRequestContext"; // Count: 2
var $785f2f8595bbd489$export$1b35c99ae5c93631 = "disableAjaxTracking"; // Count: 3
var $785f2f8595bbd489$export$990dec05286abf9b = "ajaxPerfLookupDelay"; // Count: 2
var $785f2f8595bbd489$export$391aca270631e029 = "disableFetchTracking"; // Count: 2
var $785f2f8595bbd489$export$21cd44ec55cfc0f9 = "enableResponseHeaderTracking"; // Count: 2
var $785f2f8595bbd489$export$f8d169088a01f6f2 = "status"; // Count: 11
var $785f2f8595bbd489$export$e44f43b238a0c7f0 = "statusText"; // Count: 9
var $785f2f8595bbd489$export$422ea83a60e3414b = "headerMap"; // Count: 8
var $785f2f8595bbd489$export$9984940f44bb6769 = "openDone"; // Count: 3
var $785f2f8595bbd489$export$ebd7b63f645a373e = "sendDone"; // Count: 3
var $785f2f8595bbd489$export$b3507d39ae3f3e22 = "requestSentTime"; // Count: 9
var $785f2f8595bbd489$export$dda6370f5a5c9f36 = "abortDone"; // Count: 3
var $785f2f8595bbd489$export$90dab0fe9b2b7158 = "getTraceId"; // Count: 3
var $785f2f8595bbd489$export$1fd22cf8d803736f = "getTraceFlags"; // Count: 3
var $785f2f8595bbd489$export$47d30bd816d62bdc = "method"; // Count: 8
var $785f2f8595bbd489$export$cce28811c9041832 = "errorStatusText"; // Count: 3
var $785f2f8595bbd489$export$99588eb1c78d46e0 = "stateChangeAttached"; // Count: 2
var $785f2f8595bbd489$export$d9f76b3afffa4e88 = "responseText"; // Count: 6
var $785f2f8595bbd489$export$e52fa892d403cac3 = "responseFinishedTime"; // Count: 7
var $785f2f8595bbd489$export$e31aceb60e1b3a1a = "CreateTrackItem"; // Count: 3
var $785f2f8595bbd489$export$71a9f4a2e496846d = "response"; // Count: 4
var $785f2f8595bbd489$export$121ad73699ff0814 = "getAllResponseHeaders"; // Count: 2
var $785f2f8595bbd489$export$e2e640c31408a88f = "getPartAProps"; // Count: 3
var $785f2f8595bbd489$export$9e85e7b326182790 = "perfMark"; // Count: 4
var $785f2f8595bbd489$export$9734b0a24bf02e93 = "name"; // Count: 6
var $785f2f8595bbd489$export$6bec4987b5d3526c = "perfTiming"; // Count: 3
var $785f2f8595bbd489$export$4852fd87b68a6e1f = "exception"; // Count: 5
var $785f2f8595bbd489$export$c9bea9d79dd8e37a = "ajaxDiagnosticsMessage"; // Count: 3
var $785f2f8595bbd489$export$c4a9b5c39c7409f7 = "correlationContext"; // Count: 3
var $785f2f8595bbd489$export$7820e90f0eaab413 = "ajaxTotalDuration"; // Count: 3
var $785f2f8595bbd489$export$c050ff25390a2bce = "eventTraceCtx"; // Count: 3


/*
 * Application Insights JavaScript SDK - Dependencies Plugin, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 




/** @ignore */ function $9a2f7734ba2f502d$var$_calcPerfDuration(resourceEntry, start, end) {
    var result = 0;
    var from = resourceEntry[start];
    var to = resourceEntry[end];
    if (from && to) result = (0, $d98b699aeccdabc6$export$bfc7deb7f4f00987)(from, to);
    return result;
}
/** @ignore */ function $9a2f7734ba2f502d$var$_setPerfDuration(props, name, resourceEntry, start, end) {
    var result = 0;
    var value = $9a2f7734ba2f502d$var$_calcPerfDuration(resourceEntry, start, end);
    if (value) result = $9a2f7734ba2f502d$var$_setPerfValue(props, name, (0, $8ce53fcb9c1dc1db$export$4460ed97e7c4a927)(value));
    return result;
}
/** @ignore */ function $9a2f7734ba2f502d$var$_setPerfValue(props, name, value) {
    var strPerf = "ajaxPerf";
    var result = 0;
    if (props && name && value) {
        var perfData = props[strPerf] = props[strPerf] || {};
        perfData[name] = value;
        result = 1;
    }
    return result;
}
/** @ignore */ function $9a2f7734ba2f502d$var$_populatePerfData(ajaxData, dependency) {
    /*
    * https://developer.mozilla.org/en-US/docs/Web/API/Resource_Timing_API/Using_the_Resource_Timing_API
    *  | -startTime
    *  | -redirectStart
    *  |            | -redirectEnd
    *  |            | | -fetchStart
    *  |            | |   | -domainLookupStart
    *  |            | |   |                |- domainLookupEnd
    *  |            | |   |                | | -connectStart
    *  |            | |   |                | |  | -secureConnectionStart
    *  |            | |   |                | |  |        | -connectEnd
    *  |            | |   |                | |  |        | | -requestStart
    *  |            | |   |                | |  |        | |           | | -responseStart
    *  |            | |   |                | |  |        | |           | |            | | -responseEnd
    *  +------------+-+---+----------------+-+--+--------+-+-----------+-+------------+-+
    *  |--redirect--| |---|--domainLookup--| |--connect--| |--request--| |--response--| |
    *  |-------------------networkConnect----------------|
    *  |                                                   |---------sentRequest--------|
    *  |------------------------------------perfTotal-----------------------------------|
    */ var resourceEntry = ajaxData[0, $785f2f8595bbd489$export$6bec4987b5d3526c /* @min:%2eperfTiming */ ];
    var props = dependency[0, $072e43366110cd19$export$400e70f2a2ecb5aa /* @min:%2eproperties */ ] || {};
    var propsSet = 0;
    var strName = "name";
    var strStart = "Start";
    var strEnd = "End";
    var strDomainLookup = "domainLookup";
    var strConnect = "connect";
    var strRedirect = "redirect";
    var strRequest = "request";
    var strResponse = "response";
    var strStartTime = "startTime";
    var strDomainLookupStart = strDomainLookup + strStart;
    var strDomainLookupEnd = strDomainLookup + strEnd;
    var strConnectStart = strConnect + strStart;
    var strConnectEnd = strConnect + strEnd;
    var strRequestStart = strRequest + strStart;
    var strRequestEnd = strRequest + strEnd;
    var strResponseStart = strResponse + strStart;
    var strResponseEnd = strResponse + strEnd;
    var strRedirectStart = strRedirect + strStart;
    var strRedirectEnd = strRedirect = strEnd;
    var strTransferSize = "transferSize";
    var strEncodedBodySize = "encodedBodySize";
    var strDecodedBodySize = "decodedBodySize";
    var strServerTiming = "serverTiming";
    if (resourceEntry) {
        // redirect
        propsSet |= $9a2f7734ba2f502d$var$_setPerfDuration(props, strRedirect, resourceEntry, strRedirectStart, strRedirectEnd);
        // domainLookup
        propsSet |= $9a2f7734ba2f502d$var$_setPerfDuration(props, strDomainLookup, resourceEntry, strDomainLookupStart, strDomainLookupEnd);
        // connect
        propsSet |= $9a2f7734ba2f502d$var$_setPerfDuration(props, strConnect, resourceEntry, strConnectStart, strConnectEnd);
        // request
        propsSet |= $9a2f7734ba2f502d$var$_setPerfDuration(props, strRequest, resourceEntry, strRequestStart, strRequestEnd);
        // response
        propsSet |= $9a2f7734ba2f502d$var$_setPerfDuration(props, strResponse, resourceEntry, strResponseStart, strResponseEnd);
        // Network connection time
        propsSet |= $9a2f7734ba2f502d$var$_setPerfDuration(props, "networkConnect", resourceEntry, strStartTime, strConnectEnd);
        // Sent Request
        propsSet |= $9a2f7734ba2f502d$var$_setPerfDuration(props, "sentRequest", resourceEntry, strRequestStart, strResponseEnd);
        // PerfTotal / Duration
        var duration = resourceEntry[0, $072e43366110cd19$export$be41298b7716c698 /* @min:%2eduration */ ];
        if (!duration) duration = $9a2f7734ba2f502d$var$_calcPerfDuration(resourceEntry, strStartTime, strResponseEnd) || 0;
        propsSet |= $9a2f7734ba2f502d$var$_setPerfValue(props, (0, $072e43366110cd19$export$be41298b7716c698), duration);
        propsSet |= $9a2f7734ba2f502d$var$_setPerfValue(props, "perfTotal", duration);
        var serverTiming = resourceEntry[strServerTiming];
        if (serverTiming) {
            var server_1 = {};
            (0, $f6bb085f8cf12216$export$e2e5bcdbdc49c586)(serverTiming, function(value, idx) {
                var name = (0, $0b747974b0bb3563$export$f60443f194e40bc2)(value[strName] || "" + idx);
                var newValue = server_1[name] || {};
                (0, $45e528077703ac0c$export$aa0705d5774c95d1)(value, function(key, val) {
                    if (key !== strName && (0, $533f826bbc418791$export$844ec244b1367d54)(val) || (0, $533f826bbc418791$export$7e4aa119212bc614)(val)) {
                        if (newValue[key]) val = newValue[key] + ";" + val;
                        if (val || !(0, $533f826bbc418791$export$844ec244b1367d54)(val)) // Only set the value if it has a value and it's not an empty string
                        newValue[key] = val;
                    }
                });
                server_1[name] = newValue;
            });
            propsSet |= $9a2f7734ba2f502d$var$_setPerfValue(props, strServerTiming, server_1);
        }
        propsSet |= $9a2f7734ba2f502d$var$_setPerfValue(props, strTransferSize, resourceEntry[strTransferSize]);
        propsSet |= $9a2f7734ba2f502d$var$_setPerfValue(props, strEncodedBodySize, resourceEntry[strEncodedBodySize]);
        propsSet |= $9a2f7734ba2f502d$var$_setPerfValue(props, strDecodedBodySize, resourceEntry[strDecodedBodySize]);
    } else if (ajaxData[0, $785f2f8595bbd489$export$9e85e7b326182790 /* @min:%2eperfMark */ ]) propsSet |= $9a2f7734ba2f502d$var$_setPerfValue(props, "missing", ajaxData.perfAttempts);
    if (propsSet) dependency[0, $072e43366110cd19$export$400e70f2a2ecb5aa /* @min:%2eproperties */ ] = props;
}
var $9a2f7734ba2f502d$export$79f098456caec6e7 = /** @class */ function() {
    function XHRMonitoringState() {
        var self = this;
        self[0, $785f2f8595bbd489$export$9984940f44bb6769 /* @min:%2eopenDone */ ] = false;
        self.setRequestHeaderDone = false;
        self[0, $785f2f8595bbd489$export$ebd7b63f645a373e /* @min:%2esendDone */ ] = false;
        self[0, $785f2f8595bbd489$export$dda6370f5a5c9f36 /* @min:%2eabortDone */ ] = false;
        // <summary>True, if onreadyStateChangeCallback function attached to xhr, otherwise false</summary>
        self[0, $785f2f8595bbd489$export$99588eb1c78d46e0 /* @min:%2estateChangeAttached */ ] = false;
    }
    return XHRMonitoringState;
}();
var $9a2f7734ba2f502d$export$3391d178758cbbb1 = /** @class */ function() {
    function ajaxRecord(traceId, spanId, logger, traceCtx) {
        var _a;
        var self = this;
        var _logger = logger;
        var strResponseText = "responseText";
        // Assigning the initial/default values within the constructor to avoid typescript from creating a bunch of
        // this.XXXX = null
        self[0, $785f2f8595bbd489$export$9e85e7b326182790 /* @min:%2eperfMark */ ] = null;
        self.completed = false;
        self.requestHeadersSize = null;
        self[0, $785f2f8595bbd489$export$b58618e731cdb301 /* @min:%2erequestHeaders */ ] = null;
        self.responseReceivingDuration = null;
        self.callbackDuration = null;
        self[0, $785f2f8595bbd489$export$7820e90f0eaab413 /* @min:%2eajaxTotalDuration */ ] = null;
        self[0, $785f2f8595bbd489$export$fcf18cee9ee41961 /* @min:%2eaborted */ ] = 0;
        self.pageUrl = null;
        self[0, $785f2f8595bbd489$export$8ff033ecd75b66c3 /* @min:%2erequestUrl */ ] = null;
        self.requestSize = 0;
        self[0, $785f2f8595bbd489$export$47d30bd816d62bdc /* @min:%2emethod */ ] = null;
        self[0, $785f2f8595bbd489$export$f8d169088a01f6f2 /* @min:%2estatus */ ] = null;
        self[0, $785f2f8595bbd489$export$b3507d39ae3f3e22 /* @min:%2erequestSentTime */ ] = null;
        self.responseStartedTime = null;
        self[0, $785f2f8595bbd489$export$e52fa892d403cac3 /* @min:%2eresponseFinishedTime */ ] = null;
        self.callbackFinishedTime = null;
        self.endTime = null;
        self.xhrMonitoringState = new $9a2f7734ba2f502d$export$79f098456caec6e7();
        self.clientFailure = 0;
        self[0, $785f2f8595bbd489$export$a5eb52c53bba8560 /* @min:%2etraceID */ ] = traceId;
        self[0, $785f2f8595bbd489$export$c105b94efa183847 /* @min:%2espanID */ ] = spanId;
        self[0, $785f2f8595bbd489$export$4e92e4b92b41ba2d /* @min:%2etraceFlags */ ] = traceCtx === null || traceCtx === void 0 ? void 0 : traceCtx.getTraceFlags();
        if (traceCtx) self[0, $785f2f8595bbd489$export$c050ff25390a2bce /* @min:%2eeventTraceCtx */ ] = (_a = {}, _a[0, $785f2f8595bbd489$export$f8d9e07631527156 /* @min:traceId */ ] = traceCtx[0, $785f2f8595bbd489$export$90dab0fe9b2b7158 /* @min:%2egetTraceId */ ](), _a[0, $785f2f8595bbd489$export$e39be82dc519c4ae /* @min:spanId */ ] = traceCtx.getSpanId(), _a[0, $785f2f8595bbd489$export$4e92e4b92b41ba2d /* @min:traceFlags */ ] = traceCtx[0, $785f2f8595bbd489$export$1fd22cf8d803736f /* @min:%2egetTraceFlags */ ](), _a);
        else self[0, $785f2f8595bbd489$export$c050ff25390a2bce /* @min:%2eeventTraceCtx */ ] = null;
        (0, $c9b63384299a3252$export$2e2bcd8739ae039)(ajaxRecord, self, function(self) {
            self.getAbsoluteUrl = function() {
                return self[0, $785f2f8595bbd489$export$8ff033ecd75b66c3 /* @min:%2erequestUrl */ ] ? (0, $8ef642882a9aa00a$export$a98678973ebe2123)(self[0, $785f2f8595bbd489$export$8ff033ecd75b66c3 /* @min:%2erequestUrl */ ]) : null;
            };
            self.getPathName = function() {
                return self[0, $785f2f8595bbd489$export$8ff033ecd75b66c3 /* @min:%2erequestUrl */ ] ? (0, $8c3059962bb1d83c$export$356146502a9f860c)(_logger, (0, $8ef642882a9aa00a$export$b959f3bc0a239498)(self[0, $785f2f8595bbd489$export$47d30bd816d62bdc /* @min:%2emethod */ ], self[0, $785f2f8595bbd489$export$8ff033ecd75b66c3 /* @min:%2erequestUrl */ ])) : null;
            };
            self[0, $785f2f8595bbd489$export$e31aceb60e1b3a1a /* @min:%2eCreateTrackItem */ ] = function(ajaxType, enableRequestHeaderTracking, getResponse) {
                var _a;
                // round to 3 decimal points
                self.ajaxTotalDuration = Math.round((0, $d98b699aeccdabc6$export$bfc7deb7f4f00987)(self.requestSentTime, self.responseFinishedTime) * 1000) / 1000;
                if (self[0, $785f2f8595bbd489$export$7820e90f0eaab413 /* @min:%2eajaxTotalDuration */ ] < 0) return null;
                var dependency = (_a = {
                    id: "|" + self[0, $785f2f8595bbd489$export$a5eb52c53bba8560 /* @min:%2etraceID */ ] + "." + self[0, $785f2f8595bbd489$export$c105b94efa183847 /* @min:%2espanID */ ],
                    target: self[0, $785f2f8595bbd489$export$de5be3709039b9b0 /* @min:%2egetAbsoluteUrl */ ]()
                }, _a[0, $785f2f8595bbd489$export$9734b0a24bf02e93 /* @min:name */ ] = self.getPathName(), _a.type = ajaxType, _a[0, $785f2f8595bbd489$export$69cac26425c8ea23 /* @min:startTime */ ] = null, _a.duration = self[0, $785f2f8595bbd489$export$7820e90f0eaab413 /* @min:%2eajaxTotalDuration */ ], _a.success = +self[0, $785f2f8595bbd489$export$f8d169088a01f6f2 /* @min:%2estatus */ ] >= 200 && +self[0, $785f2f8595bbd489$export$f8d169088a01f6f2 /* @min:%2estatus */ ] < 400, _a.responseCode = +self[0, $785f2f8595bbd489$export$f8d169088a01f6f2 /* @min:%2estatus */ ], _a[0, $072e43366110cd19$export$400e70f2a2ecb5aa] = {
                    HttpMethod: self[0, $785f2f8595bbd489$export$47d30bd816d62bdc /* @min:%2emethod */ ]
                }, _a);
                var props = dependency[0, $072e43366110cd19$export$400e70f2a2ecb5aa];
                if (self[0, $785f2f8595bbd489$export$fcf18cee9ee41961 /* @min:%2eaborted */ ]) props[0, $785f2f8595bbd489$export$fcf18cee9ee41961 /* @min:%2eaborted */ ] = true;
                if (self[0, $785f2f8595bbd489$export$b3507d39ae3f3e22 /* @min:%2erequestSentTime */ ]) {
                    // Set the correct dependency start time
                    dependency[0, $785f2f8595bbd489$export$69cac26425c8ea23 /* @min:%2estartTime */ ] = new Date();
                    dependency[0, $785f2f8595bbd489$export$69cac26425c8ea23 /* @min:%2estartTime */ ].setTime(self[0, $785f2f8595bbd489$export$b3507d39ae3f3e22 /* @min:%2erequestSentTime */ ]);
                }
                // Add Ajax perf details if available
                $9a2f7734ba2f502d$var$_populatePerfData(self, dependency);
                if (enableRequestHeaderTracking) {
                    if ((0, $36a077d9f4439b69$export$f7628dc18f4211e5)(self.requestHeaders)[0, $785f2f8595bbd489$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) props[0, $785f2f8595bbd489$export$b58618e731cdb301 /* @min:%2erequestHeaders */ ] = self[0, $785f2f8595bbd489$export$b58618e731cdb301 /* @min:%2erequestHeaders */ ];
                }
                if (getResponse) {
                    var response = getResponse();
                    if (response) {
                        // enrich dependency target with correlation context from the server
                        var correlationContext = response[0, $785f2f8595bbd489$export$c4a9b5c39c7409f7 /* @min:%2ecorrelationContext */ ];
                        if (correlationContext) dependency.correlationContext = /* dependency.target + " | " + */ correlationContext;
                        if (response[0, $785f2f8595bbd489$export$422ea83a60e3414b /* @min:%2eheaderMap */ ]) {
                            if ((0, $36a077d9f4439b69$export$f7628dc18f4211e5)(response.headerMap)[0, $785f2f8595bbd489$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) props.responseHeaders = response[0, $785f2f8595bbd489$export$422ea83a60e3414b /* @min:%2eheaderMap */ ];
                        }
                        if (self[0, $785f2f8595bbd489$export$cce28811c9041832 /* @min:%2eerrorStatusText */ ]) {
                            if (self[0, $785f2f8595bbd489$export$f8d169088a01f6f2 /* @min:%2estatus */ ] >= 400) {
                                var responseType = response.type;
                                if (responseType === "" || responseType === "text") props.responseText = response.responseText ? response[0, $785f2f8595bbd489$export$e44f43b238a0c7f0 /* @min:%2estatusText */ ] + " - " + response[strResponseText] : response[0, $785f2f8595bbd489$export$e44f43b238a0c7f0 /* @min:%2estatusText */ ];
                                if (responseType === "json") props.responseText = response.response ? response[0, $785f2f8595bbd489$export$e44f43b238a0c7f0 /* @min:%2estatusText */ ] + " - " + JSON.stringify(response[0, $785f2f8595bbd489$export$71a9f4a2e496846d /* @min:%2eresponse */ ]) : response[0, $785f2f8595bbd489$export$e44f43b238a0c7f0 /* @min:%2estatusText */ ];
                            } else if (self[0, $785f2f8595bbd489$export$f8d169088a01f6f2 /* @min:%2estatus */ ] === 0) props.responseText = response[0, $785f2f8595bbd489$export$e44f43b238a0c7f0 /* @min:%2estatusText */ ] || "";
                        }
                    }
                }
                return dependency;
            };
            self[0, $785f2f8595bbd489$export$e2e640c31408a88f /* @min:%2egetPartAProps */ ] = function() {
                var _a;
                var partA = null;
                var traceCtx = self[0, $785f2f8595bbd489$export$c050ff25390a2bce /* @min:%2eeventTraceCtx */ ];
                if (traceCtx && (traceCtx[0, $785f2f8595bbd489$export$f8d9e07631527156 /* @min:%2etraceId */ ] || traceCtx[0, $785f2f8595bbd489$export$e39be82dc519c4ae /* @min:%2espanId */ ])) {
                    partA = {};
                    var traceExt = partA[(0, $1185376df44832bd$export$152f4bb29f8263d0).TraceExt] = (_a = {}, _a[0, $785f2f8595bbd489$export$a5eb52c53bba8560 /* @min:traceID */ ] = traceCtx[0, $785f2f8595bbd489$export$f8d9e07631527156 /* @min:%2etraceId */ ], _a.parentID = traceCtx[0, $785f2f8595bbd489$export$e39be82dc519c4ae /* @min:%2espanId */ ], _a);
                    if (!(0, $533f826bbc418791$export$bedb7023a7733221)(traceCtx[0, $785f2f8595bbd489$export$4e92e4b92b41ba2d /* @min:%2etraceFlags */ ])) traceExt[0, $785f2f8595bbd489$export$4e92e4b92b41ba2d /* @min:%2etraceFlags */ ] = traceCtx[0, $785f2f8595bbd489$export$4e92e4b92b41ba2d /* @min:%2etraceFlags */ ];
                }
                return partA;
            };
        });
    }
    // Removed Stub for ajaxRecord.prototype.getAbsoluteUrl.
    // Removed Stub for ajaxRecord.prototype.getPathName.
    // Removed Stub for ajaxRecord.prototype.CreateTrackItem.
    // Removed Stub for ajaxRecord.prototype.getPartAProps.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    ajaxRecord.__ieDyn = 1;
    return ajaxRecord;
}();


var $2569abef053897bd$var$_a;
var $2569abef053897bd$var$AJAX_MONITOR_PREFIX = "ai.ajxmn.";
var $2569abef053897bd$var$strDiagLog = "diagLog";
var $2569abef053897bd$var$strAjaxData = "ajaxData";
var $2569abef053897bd$var$STR_FETCH = "fetch";
var $2569abef053897bd$var$ERROR_HEADER = "Failed to monitor XMLHttpRequest";
var $2569abef053897bd$var$ERROR_PREFIX = ", monitoring data for this ajax call ";
var $2569abef053897bd$var$ERROR_POSTFIX = $2569abef053897bd$var$ERROR_PREFIX + "may be incorrect.";
var $2569abef053897bd$var$ERROR_NOT_SENT = $2569abef053897bd$var$ERROR_PREFIX + "won't be sent.";
var $2569abef053897bd$var$CORRELATION_HEADER_ERROR = "Failed to get Request-Context correlation header as it may be not included in the response or not accessible.";
var $2569abef053897bd$var$CUSTOM_REQUEST_CONTEXT_ERROR = "Failed to add custom defined request context as configured call back may missing a null check.";
var $2569abef053897bd$var$FAILED_TO_CALCULATE_DURATION_ERROR = "Failed to calculate the duration of the ";
// Using a global value so that to handle same iKey with multiple app insights instances (mostly for testing)
var $2569abef053897bd$var$_markCount = 0;
/** @Ignore */ function $2569abef053897bd$var$_supportsFetch() {
    var _global = (0, $3d5fcb60a9467a45$export$a4e55266d2135a7f)();
    if (!_global || (0, $533f826bbc418791$export$bedb7023a7733221)(_global.Request) || (0, $533f826bbc418791$export$bedb7023a7733221)(_global.Request[0, $67b827af57eed1eb$export$ecddaaeb55ecf049]) || (0, $533f826bbc418791$export$bedb7023a7733221)(_global[$2569abef053897bd$var$STR_FETCH])) return null;
    return _global[$2569abef053897bd$var$STR_FETCH];
}
/**
 * Determines whether ajax monitoring can be enabled on this document
 * @returns True if Ajax monitoring is supported on this page, otherwise false
 * @ignore
 */ function $2569abef053897bd$var$_supportsAjaxMonitoring(ajaxMonitorInstance) {
    var _a;
    var result = false;
    if ((0, $0c599844349363c4$export$cfeac9aa070f0108)()) {
        var proto = XMLHttpRequest[0, $67b827af57eed1eb$export$ecddaaeb55ecf049];
        result = !(0, $533f826bbc418791$export$bedb7023a7733221)(proto) && !(0, $533f826bbc418791$export$bedb7023a7733221)(proto.open) && // eslint-disable-line security/detect-non-literal-fs-filename -- false positive
        !(0, $533f826bbc418791$export$bedb7023a7733221)(proto.send) && !(0, $533f826bbc418791$export$bedb7023a7733221)(proto.abort);
    }
    var ieVer = (0, $0c599844349363c4$export$eb7ff627fa81c42e)();
    if (ieVer && ieVer < 9) result = false;
    if (result) // Disable if the XmlHttpRequest can't be extended or hooked
    try {
        var xhr = new XMLHttpRequest();
        xhr[$2569abef053897bd$var$strAjaxData] = {};
        // Check that we can update the prototype
        var theOpen = XMLHttpRequest[0, $67b827af57eed1eb$export$ecddaaeb55ecf049].open;
        XMLHttpRequest[0, $67b827af57eed1eb$export$ecddaaeb55ecf049].open = theOpen;
    } catch (e) {
        // We can't decorate the xhr object so disable monitoring
        result = false;
        $2569abef053897bd$var$_throwInternalCritical(ajaxMonitorInstance, 15 /* _eInternalMessageId.FailedMonitorAjaxOpen */ , "Failed to enable XMLHttpRequest monitoring, extension is not supported", (_a = {}, _a[0, $785f2f8595bbd489$export$4852fd87b68a6e1f /* @min:exception */ ] = (0, $386f00e3a193a7da$export$21fce7cbd4dc679f)(e), _a));
    }
    return result;
}
/** @Ignore */ function $2569abef053897bd$var$_getFailedAjaxDiagnosticsMessage(xhr) {
    var result = "";
    try {
        if (xhr && xhr[$2569abef053897bd$var$strAjaxData] && xhr[$2569abef053897bd$var$strAjaxData][0, $785f2f8595bbd489$export$8ff033ecd75b66c3 /* @min:%2erequestUrl */ ]) result += "(url: '" + xhr[$2569abef053897bd$var$strAjaxData][0, $785f2f8595bbd489$export$8ff033ecd75b66c3 /* @min:%2erequestUrl */ ] + "')";
    } catch (e) {
    // eslint-disable-next-line no-empty
    }
    return result;
}
/** @ignore */ function $2569abef053897bd$var$_throwInternalCritical(ajaxMonitorInstance, msgId, message, properties, isUserAct) {
    (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(ajaxMonitorInstance[$2569abef053897bd$var$strDiagLog](), 1 /* eLoggingSeverity.CRITICAL */ , msgId, message, properties, isUserAct);
}
/** @ignore */ function $2569abef053897bd$var$_throwInternalWarning(ajaxMonitorInstance, msgId, message, properties, isUserAct) {
    (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(ajaxMonitorInstance[$2569abef053897bd$var$strDiagLog](), 2 /* eLoggingSeverity.WARNING */ , msgId, message, properties, isUserAct);
}
/** @Ignore */ function $2569abef053897bd$var$_createErrorCallbackFunc(ajaxMonitorInstance, internalMessage, message) {
    // tslint:disable-next-line
    return function(args) {
        var _a;
        $2569abef053897bd$var$_throwInternalCritical(ajaxMonitorInstance, internalMessage, message, (_a = {
            ajaxDiagnosticsMessage: $2569abef053897bd$var$_getFailedAjaxDiagnosticsMessage(args[0, $785f2f8595bbd489$export$25a34734290022f3 /* @min:%2einst */ ])
        }, _a[0, $785f2f8595bbd489$export$4852fd87b68a6e1f /* @min:exception */ ] = (0, $386f00e3a193a7da$export$21fce7cbd4dc679f)(args.err), _a));
    };
}
function $2569abef053897bd$var$_indexOf(value, match) {
    if (value && match) return (0, $0194d45a55d79548$export$7c0888b0c4641088)(value, match);
    return -1;
}
function $2569abef053897bd$var$_addHandler(container, id, theFunc) {
    var theHandler = {
        id: id,
        fn: theFunc
    };
    container.push(theHandler);
    return {
        remove: function() {
            (0, $f6bb085f8cf12216$export$e2e5bcdbdc49c586)(container, function(initializer, idx) {
                if (initializer.id === theHandler.id) {
                    container.splice(idx, 1);
                    return -1;
                }
            });
        }
    };
}
function $2569abef053897bd$var$_processDependencyContainer(core, container, details, message) {
    var result = true;
    (0, $f6bb085f8cf12216$export$e2e5bcdbdc49c586)(container, function(theFunc, idx) {
        try {
            if (theFunc.fn.call(null, details) === false) result = false;
        } catch (e) {
            (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(core && core.logger, 1 /* eLoggingSeverity.CRITICAL */ , 64 /* _eInternalMessageId.TelemetryInitializerFailed */ , "Dependency " + message + " [#" + idx + "] failed: " + (0, $0b747974b0bb3563$export$39c4487b36c98fec)(e), {
                exception: (0, $386f00e3a193a7da$export$21fce7cbd4dc679f)(e)
            }, true);
        }
    });
    return result;
}
function $2569abef053897bd$var$_processDependencyListeners(listeners, core, ajaxData, xhr, input, init) {
    var _a;
    var initializersCount = listeners[0, $785f2f8595bbd489$export$6eae51590aaea43 /* @min:%2elength */ ];
    if (initializersCount > 0) {
        var details = (_a = {}, _a[0, $785f2f8595bbd489$export$f9ae8d0acf86503e /* @min:core */ ] = core, _a.xhr = xhr, _a.input = input, _a.init = init, _a.traceId = ajaxData[0, $785f2f8595bbd489$export$a5eb52c53bba8560 /* @min:%2etraceID */ ], _a.spanId = ajaxData[0, $785f2f8595bbd489$export$c105b94efa183847 /* @min:%2espanID */ ], _a.traceFlags = ajaxData[0, $785f2f8595bbd489$export$4e92e4b92b41ba2d /* @min:%2etraceFlags */ ], _a.context = ajaxData[0, $785f2f8595bbd489$export$fdcd48959e13aba7 /* @min:%2econtext */ ] || {}, _a.aborted = !!ajaxData[0, $785f2f8595bbd489$export$fcf18cee9ee41961 /* @min:%2eaborted */ ], _a);
        $2569abef053897bd$var$_processDependencyContainer(core, listeners, details, "listener");
        ajaxData[0, $785f2f8595bbd489$export$a5eb52c53bba8560 /* @min:%2etraceID */ ] = details[0, $785f2f8595bbd489$export$f8d9e07631527156 /* @min:%2etraceId */ ];
        ajaxData[0, $785f2f8595bbd489$export$c105b94efa183847 /* @min:%2espanID */ ] = details[0, $785f2f8595bbd489$export$e39be82dc519c4ae /* @min:%2espanId */ ];
        ajaxData[0, $785f2f8595bbd489$export$4e92e4b92b41ba2d /* @min:%2etraceFlags */ ] = details[0, $785f2f8595bbd489$export$4e92e4b92b41ba2d /* @min:%2etraceFlags */ ];
        ajaxData[0, $785f2f8595bbd489$export$fdcd48959e13aba7 /* @min:%2econtext */ ] = details[0, $785f2f8595bbd489$export$fdcd48959e13aba7 /* @min:%2econtext */ ];
    }
}
var $2569abef053897bd$var$BLOB_CORE = "*.blob.core.";
var $2569abef053897bd$export$ae1f7dcb3278b8bb = (0, $36a077d9f4439b69$export$5da24d7703175bc5)([
    $2569abef053897bd$var$BLOB_CORE + "windows.net",
    $2569abef053897bd$var$BLOB_CORE + "chinacloudapi.cn",
    $2569abef053897bd$var$BLOB_CORE + "cloudapi.de",
    $2569abef053897bd$var$BLOB_CORE + "usgovcloudapi.net"
]);
var $2569abef053897bd$var$_internalExcludeEndpoints = [
    /https:\/\/[^\/]*(\.pipe\.aria|aria\.pipe|events\.data|collector\.azure)\.[^\/]+\/(OneCollector\/1|Collector\/3)\.0/i
];
var $2569abef053897bd$var$_defaultConfig = (0, $36a077d9f4439b69$export$5da24d7703175bc5)(($2569abef053897bd$var$_a = {}, $2569abef053897bd$var$_a[0, $785f2f8595bbd489$export$8e8c994d518b7819 /* @min:maxAjaxCallsPerView */ ] = 500, $2569abef053897bd$var$_a[0, $785f2f8595bbd489$export$1b35c99ae5c93631 /* @min:disableAjaxTracking */ ] = false, $2569abef053897bd$var$_a[0, $785f2f8595bbd489$export$391aca270631e029 /* @min:disableFetchTracking */ ] = false, $2569abef053897bd$var$_a[0, $785f2f8595bbd489$export$e4bbd5d3fe5db54b /* @min:excludeRequestFromAutoTrackingPatterns */ ] = undefined, $2569abef053897bd$var$_a.disableCorrelationHeaders = false, $2569abef053897bd$var$_a.distributedTracingMode = 1 /* eDistributedTracingModes.AI_AND_W3C */ , $2569abef053897bd$var$_a.correlationHeaderExcludedDomains = $2569abef053897bd$export$ae1f7dcb3278b8bb, $2569abef053897bd$var$_a.correlationHeaderDomains = undefined, $2569abef053897bd$var$_a.correlationHeaderExcludePatterns = undefined, $2569abef053897bd$var$_a.appId = undefined, $2569abef053897bd$var$_a.enableCorsCorrelation = false, $2569abef053897bd$var$_a[0, $785f2f8595bbd489$export$abc5bbd8bd54996a /* @min:enableRequestHeaderTracking */ ] = false, $2569abef053897bd$var$_a[0, $785f2f8595bbd489$export$21cd44ec55cfc0f9 /* @min:enableResponseHeaderTracking */ ] = false, $2569abef053897bd$var$_a[0, $785f2f8595bbd489$export$928b837287a09b1f /* @min:enableAjaxErrorStatusText */ ] = false, $2569abef053897bd$var$_a[0, $785f2f8595bbd489$export$a2e6a87e51acdf74 /* @min:enableAjaxPerfTracking */ ] = false, $2569abef053897bd$var$_a.maxAjaxPerfLookupAttempts = 3, $2569abef053897bd$var$_a[0, $785f2f8595bbd489$export$990dec05286abf9b /* @min:ajaxPerfLookupDelay */ ] = 25, $2569abef053897bd$var$_a.ignoreHeaders = [
    "Authorization",
    "X-API-Key",
    "WWW-Authenticate"
], $2569abef053897bd$var$_a[0, $785f2f8595bbd489$export$e9d1b90025f35753 /* @min:addRequestContext */ ] = undefined, $2569abef053897bd$var$_a.addIntEndpoints = true, $2569abef053897bd$var$_a));
var $2569abef053897bd$export$d9a50c4d1eb2475f = /** @class */ function(_super) {
    (0, $2a74b38b87b38cda$export$1f9c32e3fbfb8e62)(AjaxMonitor, _super);
    function AjaxMonitor() {
        var _this = _super.call(this) || this;
        _this.identifier = AjaxMonitor.identifier;
        _this.priority = 120;
        var _fetchInitialized; // fetch monitoring initialized
        var _xhrInitialized; // XHR monitoring initialized
        var _currentWindowHost;
        var _extensionConfig;
        var _enableRequestHeaderTracking;
        var _enableAjaxErrorStatusText;
        var _trackAjaxAttempts;
        var _context;
        var _isUsingW3CHeaders;
        var _isUsingAIHeaders;
        var _markPrefix;
        var _enableAjaxPerfTracking;
        var _maxAjaxCallsPerView;
        var _enableResponseHeaderTracking;
        var _disabledUrls;
        var _disableAjaxTracking;
        var _disableFetchTracking;
        var _excludeRequestFromAutoTrackingPatterns;
        var _addRequestContext;
        var _evtNamespace;
        var _dependencyHandlerId;
        var _dependencyListeners;
        var _dependencyInitializers;
        var _ignoreHeaders;
        var _maxAjaxPerfLookupAttempts;
        var _ajaxPerfLookupDelay;
        var _distributedTracingMode;
        var _appId;
        var _polyfillInitialized;
        (0, $c9b63384299a3252$export$2e2bcd8739ae039)(AjaxMonitor, _this, function(_self, _base) {
            var _addHook = _base[0, $785f2f8595bbd489$export$3b3afe26ca0e015c /* @min:%2e_addHook */ ];
            _initDefaults();
            _self.initialize = function(config, core, extensions, pluginChain) {
                if (!_self.isInitialized()) {
                    _base.initialize(config, core, extensions, pluginChain);
                    _evtNamespace = (0, $12cc003c7fb5ccde$export$3f37a50e0edde3be)((0, $8a2d104e2647a310$export$eb4a6badb18ead04)("ajax"), core && core.evtNamespace && core.evtNamespace());
                    _populateDefaults(config);
                    _instrumentXhr();
                    _instrumentFetch();
                    _populateContext();
                }
            };
            _self._doTeardown = function() {
                _initDefaults();
            };
            _self.trackDependencyData = function(dependency, properties) {
                _reportDependencyInternal(_dependencyInitializers, _self[0, $785f2f8595bbd489$export$f9ae8d0acf86503e /* @min:%2ecore */ ], null, dependency, properties);
            };
            _self[0, $785f2f8595bbd489$export$ec2c4b7da1ef8dd0 /* @min:%2eincludeCorrelationHeaders */ ] = function(ajaxData, input, init, xhr) {
                // Test Hook to allow the overriding of the location host
                var currentWindowHost = _self["_currentWindowHost"] || _currentWindowHost;
                $2569abef053897bd$var$_processDependencyListeners(_dependencyListeners, _self[0, $785f2f8595bbd489$export$f9ae8d0acf86503e /* @min:%2ecore */ ], ajaxData, xhr, input, init);
                if (input) {
                    if ((0, $d98b699aeccdabc6$export$a62d10d7f896c08c)(_extensionConfig, ajaxData[0, $785f2f8595bbd489$export$de5be3709039b9b0 /* @min:%2egetAbsoluteUrl */ ](), currentWindowHost)) {
                        if (!init) init = {};
                        // init headers override original request headers
                        // so, if they exist use only them, otherwise use request's because they should have been applied in the first place
                        // not using original request headers will result in them being lost
                        var headers = new Headers(init[0, $785f2f8595bbd489$export$829ed22a43b4aada /* @min:%2eheaders */ ] || (input instanceof Request ? input[0, $785f2f8595bbd489$export$829ed22a43b4aada /* @min:%2eheaders */ ] || {} : {}));
                        if (_isUsingAIHeaders) {
                            var id = "|" + ajaxData[0, $785f2f8595bbd489$export$a5eb52c53bba8560 /* @min:%2etraceID */ ] + "." + ajaxData[0, $785f2f8595bbd489$export$c105b94efa183847 /* @min:%2espanID */ ];
                            headers.set((0, $78a4729d55fca66a$export$e499e02a1fe05177)[3 /* eRequestHeaders.requestIdHeader */ ], id);
                            if (_enableRequestHeaderTracking) ajaxData[0, $785f2f8595bbd489$export$b58618e731cdb301 /* @min:%2erequestHeaders */ ][(0, $78a4729d55fca66a$export$e499e02a1fe05177)[3 /* eRequestHeaders.requestIdHeader */ ]] = id;
                        }
                        var appId = _appId || _context && _context.appId();
                        if (appId) {
                            headers.set((0, $78a4729d55fca66a$export$e499e02a1fe05177)[0 /* eRequestHeaders.requestContextHeader */ ], (0, $78a4729d55fca66a$export$e499e02a1fe05177)[2 /* eRequestHeaders.requestContextAppIdFormat */ ] + appId);
                            if (_enableRequestHeaderTracking) ajaxData[0, $785f2f8595bbd489$export$b58618e731cdb301 /* @min:%2erequestHeaders */ ][(0, $78a4729d55fca66a$export$e499e02a1fe05177)[0 /* eRequestHeaders.requestContextHeader */ ]] = (0, $78a4729d55fca66a$export$e499e02a1fe05177)[2 /* eRequestHeaders.requestContextAppIdFormat */ ] + appId;
                        }
                        if (_isUsingW3CHeaders) {
                            var traceFlags = ajaxData[0, $785f2f8595bbd489$export$4e92e4b92b41ba2d /* @min:%2etraceFlags */ ];
                            if ((0, $533f826bbc418791$export$bedb7023a7733221)(traceFlags)) traceFlags = 0x01;
                            var traceParent = (0, $6f47dad7a26666b5$export$55f8c39d2c902d0d)((0, $6f47dad7a26666b5$export$2f21fe23413fe96b)(ajaxData[0, $785f2f8595bbd489$export$a5eb52c53bba8560 /* @min:%2etraceID */ ], ajaxData[0, $785f2f8595bbd489$export$c105b94efa183847 /* @min:%2espanID */ ], traceFlags));
                            headers.set((0, $78a4729d55fca66a$export$e499e02a1fe05177)[4 /* eRequestHeaders.traceParentHeader */ ], traceParent);
                            if (_enableRequestHeaderTracking) ajaxData[0, $785f2f8595bbd489$export$b58618e731cdb301 /* @min:%2erequestHeaders */ ][(0, $78a4729d55fca66a$export$e499e02a1fe05177)[4 /* eRequestHeaders.traceParentHeader */ ]] = traceParent;
                        }
                        init[0, $785f2f8595bbd489$export$829ed22a43b4aada /* @min:%2eheaders */ ] = headers;
                    }
                    return init;
                } else if (xhr) {
                    if ((0, $d98b699aeccdabc6$export$a62d10d7f896c08c)(_extensionConfig, ajaxData[0, $785f2f8595bbd489$export$de5be3709039b9b0 /* @min:%2egetAbsoluteUrl */ ](), currentWindowHost)) {
                        if (_isUsingAIHeaders) {
                            var id = "|" + ajaxData[0, $785f2f8595bbd489$export$a5eb52c53bba8560 /* @min:%2etraceID */ ] + "." + ajaxData[0, $785f2f8595bbd489$export$c105b94efa183847 /* @min:%2espanID */ ];
                            xhr[0, $785f2f8595bbd489$export$84ecd29f369f5b1d /* @min:%2esetRequestHeader */ ]((0, $78a4729d55fca66a$export$e499e02a1fe05177)[3 /* eRequestHeaders.requestIdHeader */ ], id);
                            if (_enableRequestHeaderTracking) ajaxData[0, $785f2f8595bbd489$export$b58618e731cdb301 /* @min:%2erequestHeaders */ ][(0, $78a4729d55fca66a$export$e499e02a1fe05177)[3 /* eRequestHeaders.requestIdHeader */ ]] = id;
                        }
                        var appId = _appId || _context && _context.appId();
                        if (appId) {
                            xhr[0, $785f2f8595bbd489$export$84ecd29f369f5b1d /* @min:%2esetRequestHeader */ ]((0, $78a4729d55fca66a$export$e499e02a1fe05177)[0 /* eRequestHeaders.requestContextHeader */ ], (0, $78a4729d55fca66a$export$e499e02a1fe05177)[2 /* eRequestHeaders.requestContextAppIdFormat */ ] + appId);
                            if (_enableRequestHeaderTracking) ajaxData[0, $785f2f8595bbd489$export$b58618e731cdb301 /* @min:%2erequestHeaders */ ][(0, $78a4729d55fca66a$export$e499e02a1fe05177)[0 /* eRequestHeaders.requestContextHeader */ ]] = (0, $78a4729d55fca66a$export$e499e02a1fe05177)[2 /* eRequestHeaders.requestContextAppIdFormat */ ] + appId;
                        }
                        if (_isUsingW3CHeaders) {
                            var traceFlags = ajaxData[0, $785f2f8595bbd489$export$4e92e4b92b41ba2d /* @min:%2etraceFlags */ ];
                            if ((0, $533f826bbc418791$export$bedb7023a7733221)(traceFlags)) traceFlags = 0x01;
                            var traceParent = (0, $6f47dad7a26666b5$export$55f8c39d2c902d0d)((0, $6f47dad7a26666b5$export$2f21fe23413fe96b)(ajaxData[0, $785f2f8595bbd489$export$a5eb52c53bba8560 /* @min:%2etraceID */ ], ajaxData[0, $785f2f8595bbd489$export$c105b94efa183847 /* @min:%2espanID */ ], traceFlags));
                            xhr[0, $785f2f8595bbd489$export$84ecd29f369f5b1d /* @min:%2esetRequestHeader */ ]((0, $78a4729d55fca66a$export$e499e02a1fe05177)[4 /* eRequestHeaders.traceParentHeader */ ], traceParent);
                            if (_enableRequestHeaderTracking) ajaxData[0, $785f2f8595bbd489$export$b58618e731cdb301 /* @min:%2erequestHeaders */ ][(0, $78a4729d55fca66a$export$e499e02a1fe05177)[4 /* eRequestHeaders.traceParentHeader */ ]] = traceParent;
                        }
                    }
                    return xhr;
                }
                return undefined;
            };
            _self[0, $785f2f8595bbd489$export$2aa2820bfe761f5b /* @min:%2etrackDependencyDataInternal */ ] = function(dependency, properties, systemProperties) {
                if (_maxAjaxCallsPerView === -1 || _trackAjaxAttempts < _maxAjaxCallsPerView) {
                    // Hack since expected format in w3c mode is |abc.def.
                    // Non-w3c format is |abc.def
                    // @todo Remove if better solution is available, e.g. handle in portal
                    if ((_distributedTracingMode === 2 /* eDistributedTracingModes.W3C */  || _distributedTracingMode === 1 /* eDistributedTracingModes.AI_AND_W3C */ ) && typeof dependency.id === "string" && dependency.id[dependency.id[0, $785f2f8595bbd489$export$6eae51590aaea43 /* @min:%2elength */ ] - 1] !== ".") dependency.id += ".";
                    if ((0, $533f826bbc418791$export$bedb7023a7733221)(dependency[0, $785f2f8595bbd489$export$69cac26425c8ea23 /* @min:%2estartTime */ ])) dependency[0, $785f2f8595bbd489$export$69cac26425c8ea23 /* @min:%2estartTime */ ] = new Date();
                    var item = (0, $932e93a8e5adf75c$export$2dc41327de8d98f1)(dependency, (0, $0dd1de134f090c69$export$a7b48490930dbffa).dataType, (0, $0dd1de134f090c69$export$a7b48490930dbffa).envelopeType, _self[$2569abef053897bd$var$strDiagLog](), properties, systemProperties);
                    _self[0, $785f2f8595bbd489$export$f9ae8d0acf86503e /* @min:%2ecore */ ].track(item);
                } else if (_trackAjaxAttempts === _maxAjaxCallsPerView) $2569abef053897bd$var$_throwInternalCritical(_self, 55 /* _eInternalMessageId.MaxAjaxPerPVExceeded */ , "Maximum ajax per page view limit reached, ajax monitoring is paused until the next trackPageView(). In order to increase the limit set the maxAjaxCallsPerView configuration parameter.", true);
                ++_trackAjaxAttempts;
            };
            _self.addDependencyListener = function(dependencyListener) {
                return $2569abef053897bd$var$_addHandler(_dependencyListeners, _dependencyHandlerId++, dependencyListener);
            };
            _self.addDependencyInitializer = function(dependencyInitializer) {
                return $2569abef053897bd$var$_addHandler(_dependencyInitializers, _dependencyHandlerId++, dependencyInitializer);
            };
            function _initDefaults() {
                var location = (0, $0c599844349363c4$export$e7fd20fad3cf4b5f)();
                _fetchInitialized = false; // fetch monitoring initialized
                _xhrInitialized = false; // XHR monitoring initialized
                _polyfillInitialized = false; // polyfill monitoring initialized
                _currentWindowHost = location && location.host && location.host[0, $785f2f8595bbd489$export$e4eaee9e01d9baaa /* @min:%2etoLowerCase */ ]();
                _extensionConfig = null;
                _enableRequestHeaderTracking = false;
                _enableAjaxErrorStatusText = false;
                _trackAjaxAttempts = 0;
                _context = null;
                _isUsingW3CHeaders = false;
                _isUsingAIHeaders = false;
                _markPrefix = null;
                _enableAjaxPerfTracking = false;
                _maxAjaxCallsPerView = 0;
                _enableResponseHeaderTracking = false;
                _disabledUrls = {};
                _disableAjaxTracking = false;
                _disableFetchTracking = false;
                _excludeRequestFromAutoTrackingPatterns = null;
                _addRequestContext = null;
                _evtNamespace = null;
                _dependencyHandlerId = 0;
                _dependencyListeners = [];
                _dependencyInitializers = [];
                _ignoreHeaders = null;
                _maxAjaxPerfLookupAttempts = 1;
                _ajaxPerfLookupDelay = 1;
                _distributedTracingMode = 1 /* eDistributedTracingModes.AI_AND_W3C */ ;
                _appId = null;
            }
            function _populateDefaults(config) {
                _self[0, $785f2f8595bbd489$export$3b3afe26ca0e015c /* @min:%2e_addHook */ ]((0, $acb30f9e62dc5705$export$454a433e4deb244f)(config, function(details) {
                    var config = details.cfg;
                    var ctx = (0, $bc7124acb0f73e64$export$ca98f11e981bcfd6)(null, config, _self[0, $785f2f8595bbd489$export$f9ae8d0acf86503e /* @min:%2ecore */ ]);
                    _extensionConfig = ctx.getExtCfg(AjaxMonitor.identifier, $2569abef053897bd$var$_defaultConfig);
                    _distributedTracingMode = _extensionConfig.distributedTracingMode;
                    _enableRequestHeaderTracking = _extensionConfig[0, $785f2f8595bbd489$export$abc5bbd8bd54996a /* @min:%2eenableRequestHeaderTracking */ ];
                    _enableAjaxErrorStatusText = _extensionConfig[0, $785f2f8595bbd489$export$928b837287a09b1f /* @min:%2eenableAjaxErrorStatusText */ ];
                    _enableAjaxPerfTracking = _extensionConfig[0, $785f2f8595bbd489$export$a2e6a87e51acdf74 /* @min:%2eenableAjaxPerfTracking */ ];
                    _maxAjaxCallsPerView = _extensionConfig[0, $785f2f8595bbd489$export$8e8c994d518b7819 /* @min:%2emaxAjaxCallsPerView */ ];
                    _excludeRequestFromAutoTrackingPatterns = [].concat(_extensionConfig[0, $785f2f8595bbd489$export$e4bbd5d3fe5db54b /* @min:%2eexcludeRequestFromAutoTrackingPatterns */ ] || [], _extensionConfig.addIntEndpoints !== false ? $2569abef053897bd$var$_internalExcludeEndpoints : []);
                    _addRequestContext = _extensionConfig[0, $785f2f8595bbd489$export$e9d1b90025f35753 /* @min:%2eaddRequestContext */ ];
                    _isUsingAIHeaders = _distributedTracingMode === 0 /* eDistributedTracingModes.AI */  || _distributedTracingMode === 1 /* eDistributedTracingModes.AI_AND_W3C */ ;
                    _isUsingW3CHeaders = _distributedTracingMode === 1 /* eDistributedTracingModes.AI_AND_W3C */  || _distributedTracingMode === 2 /* eDistributedTracingModes.W3C */ ;
                    if (_enableAjaxPerfTracking) {
                        var iKey = config.instrumentationKey || "unkwn";
                        if (iKey[0, $785f2f8595bbd489$export$6eae51590aaea43 /* @min:%2elength */ ] > 5) _markPrefix = $2569abef053897bd$var$AJAX_MONITOR_PREFIX + (0, $c3f3bf8012a4b2d4$export$9d1aa7361d7a6e87)(iKey, iKey[0, $785f2f8595bbd489$export$6eae51590aaea43 /* @min:%2elength */ ] - 5) + ".";
                        else _markPrefix = $2569abef053897bd$var$AJAX_MONITOR_PREFIX + iKey + ".";
                    }
                    _disableAjaxTracking = !!_extensionConfig[0, $785f2f8595bbd489$export$1b35c99ae5c93631 /* @min:%2edisableAjaxTracking */ ];
                    _maxAjaxPerfLookupAttempts = _extensionConfig.maxAjaxPerfLookupAttempts;
                    _ajaxPerfLookupDelay = _extensionConfig[0, $785f2f8595bbd489$export$990dec05286abf9b /* @min:%2eajaxPerfLookupDelay */ ];
                    _ignoreHeaders = _extensionConfig.ignoreHeaders;
                    _appId = _extensionConfig.appId;
                }));
            }
            function _populateContext() {
                var propExt = _self[0, $785f2f8595bbd489$export$f9ae8d0acf86503e /* @min:%2ecore */ ].getPlugin((0, $ca7353bd9238d340$export$2268e69a6d93b7cc));
                if (propExt) _context = propExt.plugin[0, $785f2f8595bbd489$export$fdcd48959e13aba7 /* @min:%2econtext */ ]; // we could move IPropertiesPlugin to common as well
            }
            // discard the header if it's defined as ignoreHeaders in ICorrelationConfig
            function _canIncludeHeaders(header) {
                var rlt = true;
                if (header || _ignoreHeaders) (0, $f6bb085f8cf12216$export$e2e5bcdbdc49c586)(_ignoreHeaders, function(key) {
                    if (key[0, $785f2f8595bbd489$export$e4eaee9e01d9baaa /* @min:%2etoLowerCase */ ]() === header[0, $785f2f8595bbd489$export$e4eaee9e01d9baaa /* @min:%2etoLowerCase */ ]()) {
                        rlt = false;
                        return -1;
                    }
                });
                return rlt;
            }
            // Fetch Stuff
            function _instrumentFetch() {
                var fetch = $2569abef053897bd$var$_supportsFetch();
                if (!fetch) return;
                var global = (0, $3d5fcb60a9467a45$export$a4e55266d2135a7f)();
                var isPolyfill = fetch.polyfill;
                _self[0, $785f2f8595bbd489$export$3b3afe26ca0e015c /* @min:%2e_addHook */ ]((0, $acb30f9e62dc5705$export$454a433e4deb244f)(_extensionConfig, function() {
                    _disableFetchTracking = !!_extensionConfig[0, $785f2f8595bbd489$export$391aca270631e029 /* @min:%2edisableFetchTracking */ ];
                    _enableResponseHeaderTracking = _extensionConfig[0, $785f2f8595bbd489$export$21cd44ec55cfc0f9 /* @min:%2eenableResponseHeaderTracking */ ];
                    if (!_disableFetchTracking && !_fetchInitialized) {
                        _addHook((0, $963b9811c2275531$export$152e6c4c396a57a)(global, $2569abef053897bd$var$STR_FETCH, {
                            ns: _evtNamespace,
                            // Add request hook
                            req: function(callDetails, input, init) {
                                var fetchData;
                                if (!_disableFetchTracking && _fetchInitialized && !_isDisabledRequest(null, input, init) && // If we have a polyfil and XHR instrumented then let XHR report otherwise we get duplicates
                                !(isPolyfill && _xhrInitialized)) {
                                    var ctx = callDetails.ctx();
                                    fetchData = _createFetchRecord(input, init);
                                    var newInit = _self[0, $785f2f8595bbd489$export$ec2c4b7da1ef8dd0 /* @min:%2eincludeCorrelationHeaders */ ](fetchData, input, init);
                                    if (newInit !== init) callDetails.set(1, newInit);
                                    ctx.data = fetchData;
                                }
                            },
                            rsp: function(callDetails, input) {
                                if (!_disableFetchTracking) {
                                    var fetchData_1 = callDetails.ctx().data;
                                    if (fetchData_1) // Replace the result with the new promise from this code
                                    callDetails.rslt = callDetails.rslt.then(function(response) {
                                        _reportFetchMetrics(callDetails, (response || {})[0, $785f2f8595bbd489$export$f8d169088a01f6f2 /* @min:%2estatus */ ], input, response, fetchData_1, function() {
                                            var _a;
                                            var ajaxResponse = (_a = {
                                                statusText: (response || {})[0, $785f2f8595bbd489$export$e44f43b238a0c7f0 /* @min:%2estatusText */ ]
                                            }, _a[0, $785f2f8595bbd489$export$422ea83a60e3414b /* @min:headerMap */ ] = null, _a[0, $785f2f8595bbd489$export$c4a9b5c39c7409f7 /* @min:correlationContext */ ] = _getFetchCorrelationContext(response), _a);
                                            if (_enableResponseHeaderTracking && response) {
                                                var responseHeaderMap_1 = {};
                                                response.headers.forEach(function(value, name) {
                                                    if (_canIncludeHeaders(name)) responseHeaderMap_1[name] = value;
                                                });
                                                ajaxResponse[0, $785f2f8595bbd489$export$422ea83a60e3414b /* @min:%2eheaderMap */ ] = responseHeaderMap_1;
                                            }
                                            return ajaxResponse;
                                        });
                                        return response;
                                    }).catch(function(reason) {
                                        _reportFetchMetrics(callDetails, 0, input, null, fetchData_1, null, {
                                            error: reason.message || (0, $386f00e3a193a7da$export$21fce7cbd4dc679f)(reason)
                                        });
                                        throw reason;
                                    });
                                }
                            },
                            // Create an error callback to report any hook errors
                            hkErr: $2569abef053897bd$var$_createErrorCallbackFunc(_self, 15 /* _eInternalMessageId.FailedMonitorAjaxOpen */ , "Failed to monitor Window.fetch" + $2569abef053897bd$var$ERROR_POSTFIX)
                        }, true, (0, $3d5fcb60a9467a45$export$97b87b8868ff7a3c)()));
                        _fetchInitialized = true;
                    } else if (isPolyfill && !_polyfillInitialized) {
                        // If fetch is a polyfill we need to capture the request to ensure that we correctly track
                        // disabled request URLS (i.e. internal urls) to ensure we don't end up in a constant loop
                        // of reporting ourselves, for example React Native uses a polyfill for fetch
                        // Note: Polyfill implementations that don't support the "polyfill" tag are not supported
                        // the workaround is to add a polyfill property to your fetch implementation before initializing
                        // App Insights
                        _addHook((0, $963b9811c2275531$export$152e6c4c396a57a)(global, $2569abef053897bd$var$STR_FETCH, {
                            ns: _evtNamespace,
                            req: function(callDetails, input, init) {
                                // Just call so that we record any disabled URL
                                _isDisabledRequest(null, input, init);
                            }
                        }));
                        _polyfillInitialized = true;
                    }
                }));
                if (isPolyfill) // retag the instrumented fetch with the same polyfill settings this is mostly for testing
                // But also supports multiple App Insights usages
                global[$2569abef053897bd$var$STR_FETCH].polyfill = isPolyfill;
            }
            function _hookProto(target, funcName, callbacks) {
                _addHook((0, $963b9811c2275531$export$6b32104a5f4313f6)(target, funcName, callbacks));
            }
            function _instrumentXhr() {
                if (!$2569abef053897bd$var$_supportsAjaxMonitoring(_self)) return;
                _self[0, $785f2f8595bbd489$export$3b3afe26ca0e015c /* @min:%2e_addHook */ ]((0, $acb30f9e62dc5705$export$454a433e4deb244f)(_extensionConfig, function() {
                    _disableAjaxTracking = !!_extensionConfig[0, $785f2f8595bbd489$export$1b35c99ae5c93631 /* @min:%2edisableAjaxTracking */ ];
                    _enableRequestHeaderTracking = _extensionConfig[0, $785f2f8595bbd489$export$abc5bbd8bd54996a /* @min:%2eenableRequestHeaderTracking */ ];
                    if (!_disableAjaxTracking && !_xhrInitialized) {
                        // Instrument open
                        _hookProto(XMLHttpRequest, "open", {
                            ns: _evtNamespace,
                            req: function(args, method, url, async) {
                                if (!_disableAjaxTracking) {
                                    var xhr = args[0, $785f2f8595bbd489$export$25a34734290022f3 /* @min:%2einst */ ];
                                    var ajaxData = xhr[$2569abef053897bd$var$strAjaxData];
                                    if (!_isDisabledRequest(xhr, url) && _isMonitoredXhrInstance(xhr, true)) {
                                        if (!ajaxData || !ajaxData.xhrMonitoringState[0, $785f2f8595bbd489$export$9984940f44bb6769 /* @min:%2eopenDone */ ]) // Only create a single ajaxData (even when multiple AI instances are running)
                                        _openHandler(xhr, method, url, async);
                                        // always attach to the on ready state change (required for handling multiple instances)
                                        _attachToOnReadyStateChange(xhr);
                                    }
                                }
                            },
                            hkErr: $2569abef053897bd$var$_createErrorCallbackFunc(_self, 15 /* _eInternalMessageId.FailedMonitorAjaxOpen */ , $2569abef053897bd$var$ERROR_HEADER + ".open" + $2569abef053897bd$var$ERROR_POSTFIX)
                        });
                        // Instrument send
                        _hookProto(XMLHttpRequest, "send", {
                            ns: _evtNamespace,
                            req: function(args, context) {
                                if (!_disableAjaxTracking) {
                                    var xhr = args[0, $785f2f8595bbd489$export$25a34734290022f3 /* @min:%2einst */ ];
                                    var ajaxData = xhr[$2569abef053897bd$var$strAjaxData];
                                    if (_isMonitoredXhrInstance(xhr) && !ajaxData.xhrMonitoringState[0, $785f2f8595bbd489$export$ebd7b63f645a373e /* @min:%2esendDone */ ]) {
                                        _createMarkId("xhr", ajaxData);
                                        ajaxData[0, $785f2f8595bbd489$export$b3507d39ae3f3e22 /* @min:%2erequestSentTime */ ] = (0, $d98b699aeccdabc6$export$30a447e32c58a836)();
                                        _self[0, $785f2f8595bbd489$export$ec2c4b7da1ef8dd0 /* @min:%2eincludeCorrelationHeaders */ ](ajaxData, undefined, undefined, xhr);
                                        ajaxData.xhrMonitoringState[0, $785f2f8595bbd489$export$ebd7b63f645a373e /* @min:%2esendDone */ ] = true;
                                    }
                                }
                            },
                            hkErr: $2569abef053897bd$var$_createErrorCallbackFunc(_self, 17 /* _eInternalMessageId.FailedMonitorAjaxSend */ , $2569abef053897bd$var$ERROR_HEADER + $2569abef053897bd$var$ERROR_POSTFIX)
                        });
                        // Instrument abort
                        _hookProto(XMLHttpRequest, "abort", {
                            ns: _evtNamespace,
                            req: function(args) {
                                if (!_disableAjaxTracking) {
                                    var xhr = args[0, $785f2f8595bbd489$export$25a34734290022f3 /* @min:%2einst */ ];
                                    var ajaxData = xhr[$2569abef053897bd$var$strAjaxData];
                                    if (_isMonitoredXhrInstance(xhr) && !ajaxData.xhrMonitoringState[0, $785f2f8595bbd489$export$dda6370f5a5c9f36 /* @min:%2eabortDone */ ]) {
                                        ajaxData[0, $785f2f8595bbd489$export$fcf18cee9ee41961 /* @min:%2eaborted */ ] = 1;
                                        ajaxData.xhrMonitoringState[0, $785f2f8595bbd489$export$dda6370f5a5c9f36 /* @min:%2eabortDone */ ] = true;
                                    }
                                }
                            },
                            hkErr: $2569abef053897bd$var$_createErrorCallbackFunc(_self, 13 /* _eInternalMessageId.FailedMonitorAjaxAbort */ , $2569abef053897bd$var$ERROR_HEADER + ".abort" + $2569abef053897bd$var$ERROR_POSTFIX)
                        });
                        // Instrument setRequestHeader
                        _hookProto(XMLHttpRequest, "setRequestHeader", {
                            ns: _evtNamespace,
                            req: function(args, header, value) {
                                if (!_disableAjaxTracking && _enableRequestHeaderTracking) {
                                    var xhr = args[0, $785f2f8595bbd489$export$25a34734290022f3 /* @min:%2einst */ ];
                                    if (_isMonitoredXhrInstance(xhr) && _canIncludeHeaders(header)) xhr[$2569abef053897bd$var$strAjaxData][0, $785f2f8595bbd489$export$b58618e731cdb301 /* @min:%2erequestHeaders */ ][header] = value;
                                }
                            },
                            hkErr: $2569abef053897bd$var$_createErrorCallbackFunc(_self, 71 /* _eInternalMessageId.FailedMonitorAjaxSetRequestHeader */ , $2569abef053897bd$var$ERROR_HEADER + ".setRequestHeader" + $2569abef053897bd$var$ERROR_POSTFIX)
                        });
                        _xhrInitialized = true;
                    }
                }));
            }
            function _isDisabledRequest(xhr, request, init) {
                var isDisabled = false;
                var theUrl = ((!(0, $533f826bbc418791$export$844ec244b1367d54)(request) ? (request || {}).url || "" : request) || "")[0, $785f2f8595bbd489$export$e4eaee9e01d9baaa /* @min:%2etoLowerCase */ ]();
                // check excludeRequestFromAutoTrackingPatterns before stripping off any query string
                (0, $f6bb085f8cf12216$export$e2e5bcdbdc49c586)(_excludeRequestFromAutoTrackingPatterns, function(regex) {
                    var theRegex = regex;
                    if ((0, $533f826bbc418791$export$844ec244b1367d54)(regex)) theRegex = new RegExp(regex);
                    if (!isDisabled) isDisabled = theRegex.test(theUrl);
                });
                // if request url matches with exclude regex pattern, return true and no need to check for headers
                if (isDisabled) return isDisabled;
                var idx = $2569abef053897bd$var$_indexOf(theUrl, "?");
                var idx2 = $2569abef053897bd$var$_indexOf(theUrl, "#");
                if (idx === -1 || idx2 !== -1 && idx2 < idx) idx = idx2;
                if (idx !== -1) // Strip off any Query string
                theUrl = theUrl.substring(0, idx);
                // check that this instance is not not used by ajax call performed inside client side monitoring to send data to collector
                if (!(0, $533f826bbc418791$export$bedb7023a7733221)(xhr)) // Look on the XMLHttpRequest of the URL string value
                isDisabled = xhr[0, $71dfba5ea0640485$export$7c6abff2f2bdd9c0] === true || theUrl[0, $71dfba5ea0640485$export$7c6abff2f2bdd9c0] === true;
                else if (!(0, $533f826bbc418791$export$bedb7023a7733221)(request)) // Look for DisabledPropertyName in either Request or RequestInit
                isDisabled = (typeof request === "object" ? request[0, $71dfba5ea0640485$export$7c6abff2f2bdd9c0] === true : false) || (init ? init[0, $71dfba5ea0640485$export$7c6abff2f2bdd9c0] === true : false);
                // Also add extra check just in case the XHR or fetch objects where not decorated with the DisableProperty due to sealing or freezing
                if (!isDisabled && theUrl && (0, $d98b699aeccdabc6$export$edade5317663baa4)(theUrl)) isDisabled = true;
                if (isDisabled) // Add the disabled url if not present
                {
                    if (!_disabledUrls[theUrl]) _disabledUrls[theUrl] = 1;
                } else // Check to see if the url is listed as disabled
                if (_disabledUrls[theUrl]) isDisabled = true;
                return isDisabled;
            }
            /// <summary>Verifies that particalar instance of XMLHttpRequest needs to be monitored</summary>
            /// <param name="excludeAjaxDataValidation">Optional parameter. True if ajaxData must be excluded from verification</param>
            /// <returns type="bool">True if instance needs to be monitored, otherwise false</returns>
            function _isMonitoredXhrInstance(xhr, excludeAjaxDataValidation) {
                var ajaxValidation = true;
                var initialized = _xhrInitialized;
                if (!(0, $533f826bbc418791$export$bedb7023a7733221)(xhr)) ajaxValidation = excludeAjaxDataValidation === true || !(0, $533f826bbc418791$export$bedb7023a7733221)(xhr[$2569abef053897bd$var$strAjaxData]);
                // checking to see that all interested functions on xhr were instrumented
                return initialized && ajaxValidation;
            }
            function _getDistributedTraceCtx() {
                var distributedTraceCtx = null;
                if (_self[0, $785f2f8595bbd489$export$f9ae8d0acf86503e /* @min:%2ecore */ ] && _self[0, $785f2f8595bbd489$export$f9ae8d0acf86503e /* @min:%2ecore */ ].getTraceCtx) distributedTraceCtx = _self[0, $785f2f8595bbd489$export$f9ae8d0acf86503e /* @min:%2ecore */ ].getTraceCtx(false);
                // Fall back
                if (!distributedTraceCtx && _context && _context.telemetryTrace) distributedTraceCtx = (0, $d98b699aeccdabc6$export$847d5dabba5fabb9)(_context.telemetryTrace);
                return distributedTraceCtx;
            }
            function _openHandler(xhr, method, url, async) {
                var _a;
                var distributedTraceCtx = _getDistributedTraceCtx();
                var traceID = distributedTraceCtx && distributedTraceCtx[0, $785f2f8595bbd489$export$90dab0fe9b2b7158 /* @min:%2egetTraceId */ ]() || (0, $945e40d4195d77bb$export$58d1fad45f39d957)();
                var spanID = (0, $c3f3bf8012a4b2d4$export$25b2a9bb66b0078d)((0, $945e40d4195d77bb$export$58d1fad45f39d957)(), 0, 16);
                var ajaxData = new (0, $9a2f7734ba2f502d$export$3391d178758cbbb1)(traceID, spanID, _self[$2569abef053897bd$var$strDiagLog](), (_a = _self.core) === null || _a === void 0 ? void 0 : _a.getTraceCtx());
                ajaxData[0, $785f2f8595bbd489$export$4e92e4b92b41ba2d /* @min:%2etraceFlags */ ] = distributedTraceCtx && distributedTraceCtx[0, $785f2f8595bbd489$export$1fd22cf8d803736f /* @min:%2egetTraceFlags */ ]();
                ajaxData[0, $785f2f8595bbd489$export$47d30bd816d62bdc /* @min:%2emethod */ ] = method;
                ajaxData[0, $785f2f8595bbd489$export$8ff033ecd75b66c3 /* @min:%2erequestUrl */ ] = url;
                ajaxData.xhrMonitoringState[0, $785f2f8595bbd489$export$9984940f44bb6769 /* @min:%2eopenDone */ ] = true;
                ajaxData[0, $785f2f8595bbd489$export$b58618e731cdb301 /* @min:%2erequestHeaders */ ] = {};
                ajaxData.async = async;
                ajaxData[0, $785f2f8595bbd489$export$cce28811c9041832 /* @min:%2eerrorStatusText */ ] = _enableAjaxErrorStatusText;
                xhr[$2569abef053897bd$var$strAjaxData] = ajaxData;
            }
            function _attachToOnReadyStateChange(xhr) {
                xhr[$2569abef053897bd$var$strAjaxData].xhrMonitoringState[0, $785f2f8595bbd489$export$99588eb1c78d46e0 /* @min:%2estateChangeAttached */ ] = (0, $12cc003c7fb5ccde$export$324ab159353a60a9)(xhr, "readystatechange", function() {
                    var _a;
                    try {
                        if (xhr && xhr.readyState === 4 && _isMonitoredXhrInstance(xhr)) _onAjaxComplete(xhr);
                    } catch (e) {
                        var exceptionText = (0, $386f00e3a193a7da$export$21fce7cbd4dc679f)(e);
                        // ignore messages with c00c023f, as this a known IE9 XHR abort issue
                        if (!exceptionText || $2569abef053897bd$var$_indexOf(exceptionText[0, $785f2f8595bbd489$export$e4eaee9e01d9baaa /* @min:%2etoLowerCase */ ](), "c00c023f") === -1) $2569abef053897bd$var$_throwInternalCritical(_self, 16 /* _eInternalMessageId.FailedMonitorAjaxRSC */ , $2569abef053897bd$var$ERROR_HEADER + " 'readystatechange' event handler" + $2569abef053897bd$var$ERROR_POSTFIX, (_a = {}, _a[0, $785f2f8595bbd489$export$c9bea9d79dd8e37a /* @min:ajaxDiagnosticsMessage */ ] = $2569abef053897bd$var$_getFailedAjaxDiagnosticsMessage(xhr), _a[0, $785f2f8595bbd489$export$4852fd87b68a6e1f /* @min:exception */ ] = exceptionText, _a));
                    }
                }, _evtNamespace);
            }
            function _getResponseText(xhr) {
                try {
                    var responseType = xhr.responseType;
                    if (responseType === "" || responseType === "text") // As per the specification responseText is only valid if the type is an empty string or "text"
                    return xhr[0, $785f2f8595bbd489$export$d9f76b3afffa4e88 /* @min:%2eresponseText */ ];
                } catch (e) {
                // This shouldn't happen because of the above check -- but just in case, so just ignore
                }
                return null;
            }
            function _onAjaxComplete(xhr) {
                var ajaxData = xhr[$2569abef053897bd$var$strAjaxData];
                ajaxData[0, $785f2f8595bbd489$export$e52fa892d403cac3 /* @min:%2eresponseFinishedTime */ ] = (0, $d98b699aeccdabc6$export$30a447e32c58a836)();
                ajaxData[0, $785f2f8595bbd489$export$f8d169088a01f6f2 /* @min:%2estatus */ ] = xhr[0, $785f2f8595bbd489$export$f8d169088a01f6f2 /* @min:%2estatus */ ];
                function _reportXhrError(e, failedProps) {
                    var errorProps = failedProps || {};
                    errorProps["ajaxDiagnosticsMessage"] = $2569abef053897bd$var$_getFailedAjaxDiagnosticsMessage(xhr);
                    if (e) errorProps["exception"] = (0, $386f00e3a193a7da$export$21fce7cbd4dc679f)(e);
                    $2569abef053897bd$var$_throwInternalWarning(_self, 14 /* _eInternalMessageId.FailedMonitorAjaxDur */ , $2569abef053897bd$var$FAILED_TO_CALCULATE_DURATION_ERROR + "ajax call" + $2569abef053897bd$var$ERROR_NOT_SENT, errorProps);
                }
                _findPerfResourceEntry("xmlhttprequest", ajaxData, function() {
                    try {
                        var dependency = ajaxData[0, $785f2f8595bbd489$export$e31aceb60e1b3a1a /* @min:%2eCreateTrackItem */ ]("Ajax", _enableRequestHeaderTracking, function() {
                            var _a;
                            var ajaxResponse = (_a = {
                                statusText: xhr[0, $785f2f8595bbd489$export$e44f43b238a0c7f0 /* @min:%2estatusText */ ]
                            }, _a[0, $785f2f8595bbd489$export$422ea83a60e3414b /* @min:headerMap */ ] = null, _a[0, $785f2f8595bbd489$export$c4a9b5c39c7409f7 /* @min:correlationContext */ ] = _getAjaxCorrelationContext(xhr), _a.type = xhr.responseType, _a[0, $785f2f8595bbd489$export$d9f76b3afffa4e88 /* @min:responseText */ ] = _getResponseText(xhr), _a.response = xhr[0, $785f2f8595bbd489$export$71a9f4a2e496846d /* @min:%2eresponse */ ], _a);
                            if (_enableResponseHeaderTracking) {
                                var headers = xhr[0, $785f2f8595bbd489$export$121ad73699ff0814 /* @min:%2egetAllResponseHeaders */ ]();
                                if (headers) {
                                    // xhr.getAllResponseHeaders() method returns all the response headers, separated by CRLF, as a string or null
                                    // the regex converts the header string into an array of individual headers
                                    var arr = (0, $f67365b40c49b6c1$export$ef0e11c5f5f351f7)(headers).split(/[\r\n]+/);
                                    var responseHeaderMap_2 = {};
                                    (0, $f6bb085f8cf12216$export$e2e5bcdbdc49c586)(arr, function(line) {
                                        var parts = line.split(": ");
                                        var header = parts.shift();
                                        var value = parts.join(": ");
                                        if (_canIncludeHeaders(header)) responseHeaderMap_2[header] = value;
                                    });
                                    ajaxResponse[0, $785f2f8595bbd489$export$422ea83a60e3414b /* @min:%2eheaderMap */ ] = responseHeaderMap_2;
                                }
                            }
                            return ajaxResponse;
                        });
                        var properties = void 0;
                        try {
                            if (!!_addRequestContext) properties = _addRequestContext({
                                status: xhr[0, $785f2f8595bbd489$export$f8d169088a01f6f2 /* @min:%2estatus */ ],
                                xhr: xhr
                            });
                        } catch (e) {
                            $2569abef053897bd$var$_throwInternalWarning(_self, 104 /* _eInternalMessageId.FailedAddingCustomDefinedRequestContext */ , $2569abef053897bd$var$CUSTOM_REQUEST_CONTEXT_ERROR);
                        }
                        if (dependency) {
                            if (properties !== undefined) dependency[0, $072e43366110cd19$export$400e70f2a2ecb5aa /* @min:%2eproperties */ ] = (0, $2a74b38b87b38cda$export$b3cf7a802e578501)((0, $2a74b38b87b38cda$export$b3cf7a802e578501)({}, dependency.properties), properties);
                            var sysProperties = ajaxData[0, $785f2f8595bbd489$export$e2e640c31408a88f /* @min:%2egetPartAProps */ ]();
                            _reportDependencyInternal(_dependencyInitializers, _self[0, $785f2f8595bbd489$export$f9ae8d0acf86503e /* @min:%2ecore */ ], ajaxData, dependency, null, sysProperties);
                        } else _reportXhrError(null, {
                            requestSentTime: ajaxData[0, $785f2f8595bbd489$export$b3507d39ae3f3e22 /* @min:%2erequestSentTime */ ],
                            responseFinishedTime: ajaxData[0, $785f2f8595bbd489$export$e52fa892d403cac3 /* @min:%2eresponseFinishedTime */ ]
                        });
                    } finally{
                        // cleanup telemetry data
                        try {
                            xhr[$2569abef053897bd$var$strAjaxData] = null;
                        } catch (e) {
                        // May throw in environments that prevent extension or freeze xhr
                        }
                    }
                }, function(e) {
                    _reportXhrError(e, null);
                });
            }
            function _getAjaxCorrelationContext(xhr) {
                var _a;
                try {
                    var responseHeadersString = xhr[0, $785f2f8595bbd489$export$121ad73699ff0814 /* @min:%2egetAllResponseHeaders */ ]();
                    if (responseHeadersString !== null) {
                        var index = $2569abef053897bd$var$_indexOf(responseHeadersString[0, $785f2f8595bbd489$export$e4eaee9e01d9baaa /* @min:%2etoLowerCase */ ](), (0, $78a4729d55fca66a$export$e499e02a1fe05177)[8 /* eRequestHeaders.requestContextHeaderLowerCase */ ]);
                        if (index !== -1) {
                            var responseHeader = xhr.getResponseHeader((0, $78a4729d55fca66a$export$e499e02a1fe05177)[0 /* eRequestHeaders.requestContextHeader */ ]);
                            return (0, $d98b699aeccdabc6$export$dbaf37203f788583)(responseHeader);
                        }
                    }
                } catch (e) {
                    $2569abef053897bd$var$_throwInternalWarning(_self, 18 /* _eInternalMessageId.FailedMonitorAjaxGetCorrelationHeader */ , $2569abef053897bd$var$CORRELATION_HEADER_ERROR, (_a = {}, _a[0, $785f2f8595bbd489$export$c9bea9d79dd8e37a /* @min:ajaxDiagnosticsMessage */ ] = $2569abef053897bd$var$_getFailedAjaxDiagnosticsMessage(xhr), _a[0, $785f2f8595bbd489$export$4852fd87b68a6e1f /* @min:exception */ ] = (0, $386f00e3a193a7da$export$21fce7cbd4dc679f)(e), _a));
                }
            }
            function _createMarkId(type, ajaxData) {
                if (ajaxData[0, $785f2f8595bbd489$export$8ff033ecd75b66c3 /* @min:%2erequestUrl */ ] && _markPrefix && _enableAjaxPerfTracking) {
                    var performance_1 = (0, $824d7bc9d9e48f68$export$28a0276e10aa78d7)();
                    if (performance_1 && (0, $533f826bbc418791$export$f6e2535fb5126e54)(performance_1.mark)) {
                        $2569abef053897bd$var$_markCount++;
                        var markId = _markPrefix + type + "#" + $2569abef053897bd$var$_markCount;
                        performance_1.mark(markId);
                        var entries = performance_1.getEntriesByName(markId);
                        if (entries && entries[0, $785f2f8595bbd489$export$6eae51590aaea43 /* @min:%2elength */ ] === 1) ajaxData[0, $785f2f8595bbd489$export$9e85e7b326182790 /* @min:%2eperfMark */ ] = entries[0];
                    }
                }
            }
            function _findPerfResourceEntry(initiatorType, ajaxData, trackCallback, reportError) {
                var perfMark = ajaxData[0, $785f2f8595bbd489$export$9e85e7b326182790 /* @min:%2eperfMark */ ];
                var performance = (0, $824d7bc9d9e48f68$export$28a0276e10aa78d7)();
                var maxAttempts = _maxAjaxPerfLookupAttempts;
                var retryDelay = _ajaxPerfLookupDelay;
                var requestUrl = ajaxData[0, $785f2f8595bbd489$export$8ff033ecd75b66c3 /* @min:%2erequestUrl */ ];
                var attempt = 0;
                (function locateResourceTiming() {
                    try {
                        if (performance && perfMark) {
                            attempt++;
                            var perfTiming = null;
                            var entries = performance.getEntries();
                            for(var lp = entries[0, $785f2f8595bbd489$export$6eae51590aaea43 /* @min:%2elength */ ] - 1; lp >= 0; lp--){
                                var entry = entries[lp];
                                if (entry) {
                                    if (entry.entryType === "resource") {
                                        if (entry.initiatorType === initiatorType && ($2569abef053897bd$var$_indexOf(entry[0, $785f2f8595bbd489$export$9734b0a24bf02e93 /* @min:%2ename */ ], requestUrl) !== -1 || $2569abef053897bd$var$_indexOf(requestUrl, entry[0, $785f2f8595bbd489$export$9734b0a24bf02e93 /* @min:%2ename */ ]) !== -1)) perfTiming = entry;
                                    } else if (entry.entryType === "mark" && entry[0, $785f2f8595bbd489$export$9734b0a24bf02e93 /* @min:%2ename */ ] === perfMark[0, $785f2f8595bbd489$export$9734b0a24bf02e93 /* @min:%2ename */ ]) {
                                        // We hit the start event
                                        ajaxData[0, $785f2f8595bbd489$export$6bec4987b5d3526c /* @min:%2eperfTiming */ ] = perfTiming;
                                        break;
                                    }
                                    if (entry[0, $785f2f8595bbd489$export$69cac26425c8ea23 /* @min:%2estartTime */ ] < perfMark[0, $785f2f8595bbd489$export$69cac26425c8ea23 /* @min:%2estartTime */ ] - 1000) break;
                                }
                            }
                        }
                        if (!perfMark || // - we don't have a perfMark or
                        ajaxData[0, $785f2f8595bbd489$export$6bec4987b5d3526c /* @min:%2eperfTiming */ ] || // - we have not found the perf entry or
                        attempt >= maxAttempts || // - we have tried too many attempts or
                        ajaxData.async === false) {
                            if (perfMark && (0, $533f826bbc418791$export$f6e2535fb5126e54)(performance.clearMarks)) // Remove the mark so we don't fill up the performance resources too much
                            performance.clearMarks(perfMark[0, $785f2f8595bbd489$export$9734b0a24bf02e93 /* @min:%2ename */ ]);
                            ajaxData.perfAttempts = attempt;
                            // just continue and report the track event
                            trackCallback();
                        } else // We need to wait for the browser to populate the window.performance entry
                        // This needs to be at least 1ms as waiting <= 1 (on firefox) is not enough time for fetch or xhr,
                        // this is a scheduling issue for the browser implementation
                        (0, $d03b12effd00bf96$export$5f4d6617421d489b)(locateResourceTiming, retryDelay);
                    } catch (e) {
                        reportError(e);
                    }
                })();
            }
            function _createFetchRecord(input, init) {
                var _a;
                var distributedTraceCtx = _getDistributedTraceCtx();
                var traceID = distributedTraceCtx && distributedTraceCtx[0, $785f2f8595bbd489$export$90dab0fe9b2b7158 /* @min:%2egetTraceId */ ]() || (0, $945e40d4195d77bb$export$58d1fad45f39d957)();
                var spanID = (0, $c3f3bf8012a4b2d4$export$25b2a9bb66b0078d)((0, $945e40d4195d77bb$export$58d1fad45f39d957)(), 0, 16);
                var ajaxData = new (0, $9a2f7734ba2f502d$export$3391d178758cbbb1)(traceID, spanID, _self[$2569abef053897bd$var$strDiagLog](), (_a = _self.core) === null || _a === void 0 ? void 0 : _a.getTraceCtx());
                ajaxData[0, $785f2f8595bbd489$export$4e92e4b92b41ba2d /* @min:%2etraceFlags */ ] = distributedTraceCtx && distributedTraceCtx[0, $785f2f8595bbd489$export$1fd22cf8d803736f /* @min:%2egetTraceFlags */ ]();
                ajaxData[0, $785f2f8595bbd489$export$b3507d39ae3f3e22 /* @min:%2erequestSentTime */ ] = (0, $d98b699aeccdabc6$export$30a447e32c58a836)();
                ajaxData[0, $785f2f8595bbd489$export$cce28811c9041832 /* @min:%2eerrorStatusText */ ] = _enableAjaxErrorStatusText;
                if (input instanceof Request) ajaxData[0, $785f2f8595bbd489$export$8ff033ecd75b66c3 /* @min:%2erequestUrl */ ] = input ? input.url : "";
                else ajaxData[0, $785f2f8595bbd489$export$8ff033ecd75b66c3 /* @min:%2erequestUrl */ ] = input;
                var method = "GET";
                if (init && init[0, $785f2f8595bbd489$export$47d30bd816d62bdc /* @min:%2emethod */ ]) method = init[0, $785f2f8595bbd489$export$47d30bd816d62bdc /* @min:%2emethod */ ];
                else if (input && input instanceof Request) method = input[0, $785f2f8595bbd489$export$47d30bd816d62bdc /* @min:%2emethod */ ];
                ajaxData[0, $785f2f8595bbd489$export$47d30bd816d62bdc /* @min:%2emethod */ ] = method;
                var requestHeaders = {};
                if (_enableRequestHeaderTracking) {
                    var headers = new Headers((init ? init[0, $785f2f8595bbd489$export$829ed22a43b4aada /* @min:%2eheaders */ ] : 0) || (input instanceof Request ? input[0, $785f2f8595bbd489$export$829ed22a43b4aada /* @min:%2eheaders */ ] || {} : {}));
                    headers.forEach(function(value, key) {
                        if (_canIncludeHeaders(key)) requestHeaders[key] = value;
                    });
                }
                ajaxData[0, $785f2f8595bbd489$export$b58618e731cdb301 /* @min:%2erequestHeaders */ ] = requestHeaders;
                _createMarkId($2569abef053897bd$var$STR_FETCH, ajaxData);
                return ajaxData;
            }
            function _getFailedFetchDiagnosticsMessage(input) {
                var result = "";
                try {
                    if (!(0, $533f826bbc418791$export$bedb7023a7733221)(input)) {
                        if (typeof input === "string") result += "(url: '".concat(input, "')");
                        else result += "(url: '".concat(input.url, "')");
                    }
                } catch (e) {
                    $2569abef053897bd$var$_throwInternalCritical(_self, 15 /* _eInternalMessageId.FailedMonitorAjaxOpen */ , "Failed to grab failed fetch diagnostics message", {
                        exception: (0, $386f00e3a193a7da$export$21fce7cbd4dc679f)(e)
                    });
                }
                return result;
            }
            function _reportFetchMetrics(callDetails, status, input, response, ajaxData, getResponse, properties) {
                if (!ajaxData) return;
                function _reportFetchError(msgId, e, failedProps) {
                    var errorProps = failedProps || {};
                    errorProps["fetchDiagnosticsMessage"] = _getFailedFetchDiagnosticsMessage(input);
                    if (e) errorProps["exception"] = (0, $386f00e3a193a7da$export$21fce7cbd4dc679f)(e);
                    $2569abef053897bd$var$_throwInternalWarning(_self, msgId, $2569abef053897bd$var$FAILED_TO_CALCULATE_DURATION_ERROR + "fetch call" + $2569abef053897bd$var$ERROR_NOT_SENT, errorProps);
                }
                ajaxData[0, $785f2f8595bbd489$export$e52fa892d403cac3 /* @min:%2eresponseFinishedTime */ ] = (0, $d98b699aeccdabc6$export$30a447e32c58a836)();
                ajaxData[0, $785f2f8595bbd489$export$f8d169088a01f6f2 /* @min:%2estatus */ ] = status;
                _findPerfResourceEntry($2569abef053897bd$var$STR_FETCH, ajaxData, function() {
                    var dependency = ajaxData[0, $785f2f8595bbd489$export$e31aceb60e1b3a1a /* @min:%2eCreateTrackItem */ ]("Fetch", _enableRequestHeaderTracking, getResponse);
                    var properties;
                    try {
                        if (!!_addRequestContext) properties = _addRequestContext({
                            status: status,
                            request: input,
                            response: response
                        });
                    } catch (e) {
                        $2569abef053897bd$var$_throwInternalWarning(_self, 104 /* _eInternalMessageId.FailedAddingCustomDefinedRequestContext */ , $2569abef053897bd$var$CUSTOM_REQUEST_CONTEXT_ERROR);
                    }
                    if (dependency) {
                        if (properties !== undefined) dependency[0, $072e43366110cd19$export$400e70f2a2ecb5aa /* @min:%2eproperties */ ] = (0, $2a74b38b87b38cda$export$b3cf7a802e578501)((0, $2a74b38b87b38cda$export$b3cf7a802e578501)({}, dependency.properties), properties);
                        var sysProperties = ajaxData[0, $785f2f8595bbd489$export$e2e640c31408a88f /* @min:%2egetPartAProps */ ]();
                        _reportDependencyInternal(_dependencyInitializers, _self[0, $785f2f8595bbd489$export$f9ae8d0acf86503e /* @min:%2ecore */ ], ajaxData, dependency, null, sysProperties);
                    } else _reportFetchError(14 /* _eInternalMessageId.FailedMonitorAjaxDur */ , null, {
                        requestSentTime: ajaxData[0, $785f2f8595bbd489$export$b3507d39ae3f3e22 /* @min:%2erequestSentTime */ ],
                        responseFinishedTime: ajaxData[0, $785f2f8595bbd489$export$e52fa892d403cac3 /* @min:%2eresponseFinishedTime */ ]
                    });
                }, function(e) {
                    _reportFetchError(18 /* _eInternalMessageId.FailedMonitorAjaxGetCorrelationHeader */ , e, null);
                });
            }
            function _getFetchCorrelationContext(response) {
                var _a;
                if (response && response[0, $785f2f8595bbd489$export$829ed22a43b4aada /* @min:%2eheaders */ ]) try {
                    var responseHeader = response[0, $785f2f8595bbd489$export$829ed22a43b4aada /* @min:%2eheaders */ ].get((0, $78a4729d55fca66a$export$e499e02a1fe05177)[0 /* eRequestHeaders.requestContextHeader */ ]);
                    return (0, $d98b699aeccdabc6$export$dbaf37203f788583)(responseHeader);
                } catch (e) {
                    $2569abef053897bd$var$_throwInternalWarning(_self, 18 /* _eInternalMessageId.FailedMonitorAjaxGetCorrelationHeader */ , $2569abef053897bd$var$CORRELATION_HEADER_ERROR, (_a = {
                        fetchDiagnosticsMessage: _getFailedFetchDiagnosticsMessage(response)
                    }, _a[0, $785f2f8595bbd489$export$4852fd87b68a6e1f /* @min:exception */ ] = (0, $386f00e3a193a7da$export$21fce7cbd4dc679f)(e), _a));
                }
            }
            function _reportDependencyInternal(initializers, core, ajaxData, dependency, properties, systemProperties) {
                var _a;
                var result = true;
                var initializersCount = initializers[0, $785f2f8595bbd489$export$6eae51590aaea43 /* @min:%2elength */ ];
                if (initializersCount > 0) {
                    var details = (_a = {
                        item: dependency
                    }, _a[0, $072e43366110cd19$export$400e70f2a2ecb5aa /* @min:properties */ ] = properties, _a.sysProperties = systemProperties, _a.context = ajaxData ? ajaxData[0, $785f2f8595bbd489$export$fdcd48959e13aba7 /* @min:%2econtext */ ] : null, _a.aborted = ajaxData ? !!ajaxData[0, $785f2f8595bbd489$export$fcf18cee9ee41961 /* @min:%2eaborted */ ] : false, _a);
                    result = $2569abef053897bd$var$_processDependencyContainer(core, initializers, details, "initializer");
                }
                if (result) _self[0, $785f2f8595bbd489$export$2aa2820bfe761f5b /* @min:%2etrackDependencyDataInternal */ ](dependency, properties, systemProperties);
            }
        });
        return _this;
    }
    // Removed Stub for AjaxMonitor.prototype.initialize.
    AjaxMonitor.prototype.processTelemetry = function(item, itemCtx) {
        this.processNext(item, itemCtx);
    };
    // Removed Stub for AjaxMonitor.prototype.trackDependencyData.
    // Removed Stub for AjaxMonitor.prototype.includeCorrelationHeaders.
    // Removed Stub for AjaxMonitor.prototype.addDependencyListener.
    /**
     * Add an dependency telemetry initializer callback function to allow populating additional properties or drop the request.
     * It is called after the dependency call has completed and any available performance details are available. A dependency
     * initializer is similar to the TelemetryInitializer function but it allows you to block the reporting of the dependency
     * request so that it doesn't count against the `maxAjaxCallsPerView`.
     * @param dependencyInitializer - The Dependency Telemetry Initializer function
     * @returns - A IDependencyInitializerHandler to enable the initializer to be removed
     */ AjaxMonitor.prototype.addDependencyInitializer = function(dependencyInitializer) {
        return null;
    };
    // Removed Stub for AjaxMonitor.prototype.trackDependencyDataInternal.
    AjaxMonitor.identifier = "AjaxDependencyPlugin";
    return AjaxMonitor;
}((0, $b61d51369f8191a4$export$64a11c2f90e6766c));


/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ /**
* PropertiesPlugin.ts
* @copyright Microsoft 2018
*/ 




/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ /**
* TelemetryContext.ts
* @copyright Microsoft 2018
*/ 


/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ var $8da6cf2fd8f2255d$export$16975c34e60e1e61 = /** @class */ function() {
    function Application() {}
    return Application;
}();


/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ var $4af86dbfa3092e80$export$8215d14a63d9fb10 = /** @class */ function() {
    /**
     * Constructs a new instance of the Device class
     */ function Device() {
        // don't attempt to fingerprint browsers
        this.id = "browser";
        // Device type is a dimension in our data platform
        // Setting it to 'Browser' allows to separate client and server dependencies/exceptions
        this.deviceClass = "Browser";
    }
    return Device;
}();


/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $40e2a879f9bef5dc$var$Version = "3.0.2";
var $40e2a879f9bef5dc$export$81742925a72ee8f2 = /** @class */ function() {
    /**
     * Constructs a new instance of the internal telemetry data class.
     */ function Internal(config, unloadHookContainer) {
        var _this = this;
        var unloadHook = (0, $acb30f9e62dc5705$export$454a433e4deb244f)(config, function() {
            var prefix = config.sdkExtension;
            _this.sdkVersion = (prefix ? prefix + "_" : "") + "javascript:" + $40e2a879f9bef5dc$var$Version;
        });
        unloadHookContainer && unloadHookContainer.add(unloadHook);
    }
    return Internal;
}();


/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ var $767b8cd94041adba$export$18a2be9195644f38 = /** @class */ function() {
    function Location() {}
    return Location;
}();


/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 


/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var $f9279bf813e6e5d7$export$1c39d669bde62767 = "sessionManager"; // Count: 3
var $f9279bf813e6e5d7$export$c9f4bebf02f459de = "update"; // Count: 4
var $f9279bf813e6e5d7$export$52b1fe3e70f4c699 = "isUserCookieSet"; // Count: 4
var $f9279bf813e6e5d7$export$e8019acdc6dfe227 = "isNewUser"; // Count: 4
var $f9279bf813e6e5d7$export$2d15b9b0e9d1daaa = "getTraceCtx"; // Count: 3
var $f9279bf813e6e5d7$export$805965d0d38cc4a5 = "telemetryTrace"; // Count: 3
var $f9279bf813e6e5d7$export$585a4eb45f8043ec = "applySessionContext"; // Count: 2
var $f9279bf813e6e5d7$export$5c833c29ed72a760 = "applyApplicationContext"; // Count: 2
var $f9279bf813e6e5d7$export$f3448cce94ee4935 = "applyDeviceContext"; // Count: 2
var $f9279bf813e6e5d7$export$a6c599a5c1ab6761 = "applyOperationContext"; // Count: 2
var $f9279bf813e6e5d7$export$5090ada1085f4557 = "applyUserContext"; // Count: 2
var $f9279bf813e6e5d7$export$dddc87038d37bcef = "applyOperatingSystemContxt"; // Count: 2
var $f9279bf813e6e5d7$export$4768decfd4f15bcf = "applyLocationContext"; // Count: 2
var $f9279bf813e6e5d7$export$348ac062a116e27c = "applyInternalContext"; // Count: 2
var $f9279bf813e6e5d7$export$f251a1587d4aac90 = "accountId"; // Count: 7
var $f9279bf813e6e5d7$export$3af04f76fec134a = "getSessionId"; // Count: 4
var $f9279bf813e6e5d7$export$6d013a7bc2da53c1 = "namePrefix"; // Count: 3
var $f9279bf813e6e5d7$export$d2109757a25c372a = "sessionCookiePostfix"; // Count: 2
var $f9279bf813e6e5d7$export$f3af58106bbab288 = "userCookiePostfix"; // Count: 2
var $f9279bf813e6e5d7$export$5c90c36f2382a0ff = "idLength"; // Count: 4
var $f9279bf813e6e5d7$export$d4e11a6879dac67b = "getNewId"; // Count: 3
var $f9279bf813e6e5d7$export$6eae51590aaea43 = "length"; // Count: 4
var $f9279bf813e6e5d7$export$4d608086992f55c7 = "automaticSession"; // Count: 5
var $f9279bf813e6e5d7$export$574ff42e0e7ce0c = "authenticatedId"; // Count: 6
var $f9279bf813e6e5d7$export$8c9471ee03377604 = "acquisitionDate"; // Count: 5
var $f9279bf813e6e5d7$export$7254663b30b11264 = "renewalDate"; // Count: 4
var $f9279bf813e6e5d7$export$9876e756459769d6 = "join"; // Count: 5
var $f9279bf813e6e5d7$export$57599fb6aa598bd4 = "cookieSeparator"; // Count: 5
var $f9279bf813e6e5d7$export$7bdc84f949b24ffd = "authUserCookieName"; // Count: 3


var $b3a76197ac0f306d$var$SESSION_COOKIE_NAME = "ai_session";
var $b3a76197ac0f306d$var$ACQUISITION_SPAN = 86400000; // 24 hours in ms
var $b3a76197ac0f306d$var$RENEWAL_SPAN = 1800000; // 30 minutes in ms
var $b3a76197ac0f306d$var$COOKIE_UPDATE_INTERVAL = 60000; // 1 minute in ms
var $b3a76197ac0f306d$export$1fb4852a55678982 = /** @class */ function() {
    function Session() {}
    return Session;
}();
var $b3a76197ac0f306d$export$9a3efd42578d1f11 = /** @class */ function() {
    function _SessionManager(config, core, unloadHookContainer) {
        var self = this;
        var _storageNamePrefix;
        var _cookieUpdatedTimestamp;
        var _logger = (0, $cc2aaaebf96ac6a7$export$5102d32ea1d740a)(core);
        var _cookieManager = (0, $d751d7cd1b1c5598$export$76c0b273586c25c7)(core);
        var _sessionExpirationMs;
        var _sessionRenewalMs;
        (0, $c9b63384299a3252$export$2e2bcd8739ae039)(_SessionManager, self, function(_self) {
            if (!config) config = {};
            var unloadHook = (0, $acb30f9e62dc5705$export$454a433e4deb244f)(config, function(details) {
                _sessionExpirationMs = config.sessionExpirationMs || $b3a76197ac0f306d$var$ACQUISITION_SPAN;
                _sessionRenewalMs = config.sessionRenewalMs || $b3a76197ac0f306d$var$RENEWAL_SPAN;
                // sessionCookiePostfix takes the preference if it is configured, otherwise takes namePrefix if configured.
                var sessionCookiePostfix = config.sessionCookiePostfix || config[0, $f9279bf813e6e5d7$export$6d013a7bc2da53c1 /* @min:%2enamePrefix */ ] || "";
                _storageNamePrefix = $b3a76197ac0f306d$var$SESSION_COOKIE_NAME + sessionCookiePostfix;
            });
            unloadHookContainer && unloadHookContainer.add(unloadHook);
            _self[0, $f9279bf813e6e5d7$export$4d608086992f55c7 /* @min:%2eautomaticSession */ ] = new $b3a76197ac0f306d$export$1fb4852a55678982();
            _self[0, $f9279bf813e6e5d7$export$c9f4bebf02f459de /* @min:%2eupdate */ ] = function() {
                // Always using Date getTime() as there is a bug in older IE instances that causes the performance timings to have the hi-bit set eg 0x800000000 causing
                // the number to be incorrect.
                var nowMs = (0, $628cad25a0769458$export$a56f095995763cca)();
                var isExpired = false;
                var session = _self[0, $f9279bf813e6e5d7$export$4d608086992f55c7 /* @min:%2eautomaticSession */ ];
                if (!session.id) isExpired = !_initializeAutomaticSession(session, nowMs);
                if (!isExpired && _sessionExpirationMs > 0) {
                    var timeSinceAcqMs = nowMs - session[0, $f9279bf813e6e5d7$export$8c9471ee03377604 /* @min:%2eacquisitionDate */ ];
                    var timeSinceRenewalMs = nowMs - session[0, $f9279bf813e6e5d7$export$7254663b30b11264 /* @min:%2erenewalDate */ ];
                    isExpired = timeSinceAcqMs < 0 || timeSinceRenewalMs < 0; // expired if the acquisition or last renewal are in the future
                    isExpired = isExpired || timeSinceAcqMs > _sessionExpirationMs; // expired if the time since acquisition is more than session Expiration
                    isExpired = isExpired || timeSinceRenewalMs > _sessionRenewalMs; // expired if the time since last renewal is more than renewal period
                }
                // renew if acquisitionSpan or renewalSpan has elapsed
                if (isExpired) // update automaticSession so session state has correct id
                _renew(nowMs);
                else // do not update the cookie more often than cookieUpdateInterval
                if (!_cookieUpdatedTimestamp || nowMs - _cookieUpdatedTimestamp > $b3a76197ac0f306d$var$COOKIE_UPDATE_INTERVAL) _setCookie(session, nowMs);
            };
            /**
             *  Record the current state of the automatic session and store it in our cookie string format
             *  into the browser's local storage. This is used to restore the session data when the cookie
             *  expires.
             */ _self.backup = function() {
                var session = _self[0, $f9279bf813e6e5d7$export$4d608086992f55c7 /* @min:%2eautomaticSession */ ];
                _setStorage(session.id, session[0, $f9279bf813e6e5d7$export$8c9471ee03377604 /* @min:%2eacquisitionDate */ ], session[0, $f9279bf813e6e5d7$export$7254663b30b11264 /* @min:%2erenewalDate */ ]);
            };
            /**
             * Use config.namePrefix + ai_session cookie data or local storage data (when the cookie is unavailable) to
             * initialize the automatic session.
             * @returns true if values set otherwise false
             */ function _initializeAutomaticSession(session, now) {
                var isValid = false;
                var cookieValue = _cookieManager.get(_storageNamePrefix);
                if (cookieValue && (0, $533f826bbc418791$export$f6e2535fb5126e54)(cookieValue.split)) isValid = _initializeAutomaticSessionWithData(session, cookieValue);
                else {
                    // There's no cookie, but we might have session data in local storage
                    // This can happen if the session expired or the user actively deleted the cookie
                    // We only want to recover data if the cookie is missing from expiry. We should respect the user's wishes if the cookie was deleted actively.
                    // The User class handles this for us and deletes our local storage object if the persistent user cookie was removed.
                    var storageValue = (0, $8e03bdff803b84be$export$c3876355f131c85c)(_logger, _storageNamePrefix);
                    if (storageValue) isValid = _initializeAutomaticSessionWithData(session, storageValue);
                }
                return isValid || !!session.id;
            }
            /**
             * Extract id, acquisitionDate, and renewalDate from an ai_session payload string and
             * use this data to initialize automaticSession.
             *
             * @param sessionData - The string stored in an ai_session cookie or local storage backup
             * @returns true if values set otherwise false
             */ function _initializeAutomaticSessionWithData(session, sessionData) {
                var isValid = false;
                var sessionReset = ", session will be reset";
                var tokens = sessionData.split("|");
                if (tokens[0, $f9279bf813e6e5d7$export$6eae51590aaea43 /* @min:%2elength */ ] >= 2) try {
                    var acqMs = +tokens[1] || 0;
                    var renewalMs = +tokens[2] || 0;
                    if (isNaN(acqMs) || acqMs <= 0) (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(_logger, 2 /* eLoggingSeverity.WARNING */ , 27 /* _eInternalMessageId.SessionRenewalDateIsZero */ , "AI session acquisition date is 0" + sessionReset);
                    else if (isNaN(renewalMs) || renewalMs <= 0) (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(_logger, 2 /* eLoggingSeverity.WARNING */ , 27 /* _eInternalMessageId.SessionRenewalDateIsZero */ , "AI session renewal date is 0" + sessionReset);
                    else if (tokens[0]) {
                        // Everything looks valid so set the values
                        session.id = tokens[0];
                        session[0, $f9279bf813e6e5d7$export$8c9471ee03377604 /* @min:%2eacquisitionDate */ ] = acqMs;
                        session[0, $f9279bf813e6e5d7$export$7254663b30b11264 /* @min:%2erenewalDate */ ] = renewalMs;
                        isValid = true;
                    }
                } catch (e) {
                    (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(_logger, 1 /* eLoggingSeverity.CRITICAL */ , 9 /* _eInternalMessageId.ErrorParsingAISessionCookie */ , "Error parsing ai_session value [" + (sessionData || "") + "]" + sessionReset + " - " + (0, $0b747974b0bb3563$export$39c4487b36c98fec)(e), {
                        exception: (0, $386f00e3a193a7da$export$21fce7cbd4dc679f)(e)
                    });
                }
                return isValid;
            }
            function _renew(nowMs) {
                var getNewId = config[0, $f9279bf813e6e5d7$export$d4e11a6879dac67b /* @min:%2egetNewId */ ] || (0, $dd28c90c4d15de9c$export$9ffd10a3fbdc175b);
                _self.automaticSession.id = getNewId(config[0, $f9279bf813e6e5d7$export$5c90c36f2382a0ff /* @min:%2eidLength */ ] || 22);
                _self[0, $f9279bf813e6e5d7$export$4d608086992f55c7 /* @min:%2eautomaticSession */ ][0, $f9279bf813e6e5d7$export$8c9471ee03377604 /* @min:%2eacquisitionDate */ ] = nowMs;
                _setCookie(_self[0, $f9279bf813e6e5d7$export$4d608086992f55c7 /* @min:%2eautomaticSession */ ], nowMs);
                // If this browser does not support local storage, fire an internal log to keep track of it at this point
                if (!(0, $8e03bdff803b84be$export$f28746933126d63f)()) (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(_logger, 2 /* eLoggingSeverity.WARNING */ , 0 /* _eInternalMessageId.BrowserDoesNotSupportLocalStorage */ , "Browser does not support local storage. Session durations will be inaccurate.");
            }
            function _setCookie(session, nowMs) {
                var acq = session[0, $f9279bf813e6e5d7$export$8c9471ee03377604 /* @min:%2eacquisitionDate */ ];
                session[0, $f9279bf813e6e5d7$export$7254663b30b11264 /* @min:%2erenewalDate */ ] = nowMs;
                var renewalPeriodMs = _sessionRenewalMs;
                // Set cookie to expire after the session expiry time passes or the session renewal deadline, whichever is sooner
                // Expiring the cookie will cause the session to expire even if the user isn't on the page
                var acqTimeLeftMs = acq + _sessionExpirationMs - nowMs;
                var cookie = [
                    session.id,
                    acq,
                    nowMs
                ];
                var maxAgeSec = 0;
                if (acqTimeLeftMs < renewalPeriodMs) maxAgeSec = acqTimeLeftMs / 1000;
                else maxAgeSec = renewalPeriodMs / 1000;
                var cookieDomain = config.cookieDomain || null;
                // if sessionExpirationMs is set to 0, it means the expiry is set to 0 for this session cookie
                // A cookie with 0 expiry in the session cookie will never expire for that browser session.  If the browser is closed the cookie expires.
                // Depending on the browser, another instance does not inherit this cookie, however, another tab will
                _cookieManager.set(_storageNamePrefix, cookie[0, $f9279bf813e6e5d7$export$9876e756459769d6 /* @min:%2ejoin */ ]("|"), _sessionExpirationMs > 0 ? maxAgeSec : null, cookieDomain);
                _cookieUpdatedTimestamp = nowMs;
            }
            function _setStorage(guid, acq, renewal) {
                // Keep data in local storage to retain the last session id, allowing us to cleanly end the session when it expires
                // Browsers that don't support local storage won't be able to end sessions cleanly from the client
                // The server will notice this and end the sessions itself, with loss of accurate session duration
                (0, $8e03bdff803b84be$export$631bce20500dc098)(_logger, _storageNamePrefix, [
                    guid,
                    acq,
                    renewal
                ][0, $f9279bf813e6e5d7$export$9876e756459769d6 /* @min:%2ejoin */ ]("|"));
            }
        });
    }
    // Removed Stub for _SessionManager.prototype.update.
    // Removed Stub for _SessionManager.prototype.backup.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    _SessionManager.__ieDyn = 1;
    return _SessionManager;
}();


/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 

var $39a36e687e3ece23$export$d65492b1f626b9ec = /** @class */ function() {
    function TelemetryTrace(id, parentId, name, logger) {
        var _self = this;
        _self.traceID = id || (0, $945e40d4195d77bb$export$58d1fad45f39d957)();
        _self.parentID = parentId;
        var location = (0, $0c599844349363c4$export$e7fd20fad3cf4b5f)();
        if (!name && location && location.pathname) name = location.pathname;
        _self.name = (0, $8c3059962bb1d83c$export$4e25b1d4bcd67eb8)(logger, name);
    }
    return TelemetryTrace;
}();


/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 




function $0ad45f65976bc29a$var$_validateUserInput(id) {
    // Validate:
    // 1. Id is a non-empty string.
    // 2. It does not contain special characters for cookies.
    if (typeof id !== "string" || !id || id.match(/,|;|=| |\|/)) return false;
    return true;
}
var $0ad45f65976bc29a$export$1f44aaf2ec115b54 = /** @class */ function() {
    function User(config, core, unloadHookContainer) {
        /**
         * A flag indicating whether this represents a new user
         */ this.isNewUser = false;
        /**
         * A flag indicating whether the user cookie has been set
         */ this.isUserCookieSet = false;
        var _logger = (0, $cc2aaaebf96ac6a7$export$5102d32ea1d740a)(core);
        var _cookieManager = (0, $d751d7cd1b1c5598$export$76c0b273586c25c7)(core);
        var _storageNamePrefix;
        (0, $c9b63384299a3252$export$2e2bcd8739ae039)(User, this, function(_self) {
            // Define _self.config
            (0, $d212d948d25f959a$export$d0d2ebf910ad6e2)(_self, "config", {
                g: function() {
                    return config;
                }
            });
            var unloadHook = (0, $acb30f9e62dc5705$export$454a433e4deb244f)(config, function() {
                var userCookiePostfix = config[0, $f9279bf813e6e5d7$export$f3af58106bbab288 /* @min:%2euserCookiePostfix */ ] || "";
                _storageNamePrefix = User.userCookieName + userCookiePostfix;
                // get userId or create new one if none exists
                var cookie = _cookieManager.get(_storageNamePrefix);
                if (cookie) {
                    _self[0, $f9279bf813e6e5d7$export$e8019acdc6dfe227 /* @min:%2eisNewUser */ ] = false;
                    var params = cookie.split(User[0, $f9279bf813e6e5d7$export$57599fb6aa598bd4 /* @min:%2ecookieSeparator */ ]);
                    if (params[0, $f9279bf813e6e5d7$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) {
                        _self.id = params[0];
                        // we already have a cookie
                        _self[0, $f9279bf813e6e5d7$export$52b1fe3e70f4c699 /* @min:%2eisUserCookieSet */ ] = !!_self.id;
                    }
                }
                if (!_self.id) {
                    _self.id = _generateNewId();
                    var newCookie = _generateNewCookie(_self.id);
                    _setUserCookie(newCookie[0, $f9279bf813e6e5d7$export$9876e756459769d6 /* @min:%2ejoin */ ](User[0, $f9279bf813e6e5d7$export$57599fb6aa598bd4 /* @min:%2ecookieSeparator */ ]));
                    // If we have an config.namePrefix() + ai_session in local storage this means the user actively removed our cookies.
                    // We should respect their wishes and clear ourselves from local storage
                    var name_1 = (config[0, $f9279bf813e6e5d7$export$6d013a7bc2da53c1 /* @min:%2enamePrefix */ ] || "") + "ai_session";
                    (0, $8e03bdff803b84be$export$63137c65c2cc6743)(_logger, name_1);
                }
                // We still take the account id from the ctor param for backward compatibility.
                // But if the the customer set the accountId through the newer setAuthenticatedUserContext API, we will override it.
                _self[0, $f9279bf813e6e5d7$export$f251a1587d4aac90 /* @min:%2eaccountId */ ] = config[0, $f9279bf813e6e5d7$export$f251a1587d4aac90 /* @min:%2eaccountId */ ] || undefined;
                // Get the auth user id and account id from the cookie if exists
                // Cookie is in the pattern: <authenticatedId>|<accountId>
                var authCookie = _cookieManager.get(User[0, $f9279bf813e6e5d7$export$7bdc84f949b24ffd /* @min:%2eauthUserCookieName */ ]);
                if (authCookie) {
                    authCookie = decodeURI(authCookie);
                    var authCookieString = authCookie.split(User[0, $f9279bf813e6e5d7$export$57599fb6aa598bd4 /* @min:%2ecookieSeparator */ ]);
                    if (authCookieString[0]) _self[0, $f9279bf813e6e5d7$export$574ff42e0e7ce0c /* @min:%2eauthenticatedId */ ] = authCookieString[0];
                    if (authCookieString[0, $f9279bf813e6e5d7$export$6eae51590aaea43 /* @min:%2elength */ ] > 1 && authCookieString[1]) _self[0, $f9279bf813e6e5d7$export$f251a1587d4aac90 /* @min:%2eaccountId */ ] = authCookieString[1];
                }
            });
            unloadHookContainer && unloadHookContainer.add(unloadHook);
            function _generateNewId() {
                var theConfig = config || {};
                var getNewId = theConfig[0, $f9279bf813e6e5d7$export$d4e11a6879dac67b /* @min:%2egetNewId */ ] || (0, $dd28c90c4d15de9c$export$9ffd10a3fbdc175b);
                var id = getNewId(theConfig[0, $f9279bf813e6e5d7$export$5c90c36f2382a0ff /* @min:%2eidLength */ ] ? config[0, $f9279bf813e6e5d7$export$5c90c36f2382a0ff /* @min:%2eidLength */ ] : 22);
                return id;
            }
            function _generateNewCookie(userId) {
                var acqStr = (0, $0b747974b0bb3563$export$dfaaa8705752128f)(new Date());
                _self.accountAcquisitionDate = acqStr;
                _self[0, $f9279bf813e6e5d7$export$e8019acdc6dfe227 /* @min:%2eisNewUser */ ] = true;
                var newCookie = [
                    userId,
                    acqStr
                ];
                return newCookie;
            }
            function _setUserCookie(cookie) {
                // without expiration, cookies expire at the end of the session
                // set it to 365 days from now
                // 365 * 24 * 60 * 60 = 31536000
                var oneYear = 31536000;
                _self[0, $f9279bf813e6e5d7$export$52b1fe3e70f4c699 /* @min:%2eisUserCookieSet */ ] = _cookieManager.set(_storageNamePrefix, cookie, oneYear);
            }
            _self.setAuthenticatedUserContext = function(authenticatedUserId, accountId, storeInCookie) {
                if (storeInCookie === void 0) storeInCookie = false;
                // Validate inputs to ensure no cookie control characters.
                var isInvalidInput = !$0ad45f65976bc29a$var$_validateUserInput(authenticatedUserId) || accountId && !$0ad45f65976bc29a$var$_validateUserInput(accountId);
                if (isInvalidInput) {
                    (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(_logger, 2 /* eLoggingSeverity.WARNING */ , 60 /* _eInternalMessageId.SetAuthContextFailedAccountName */ , "Setting auth user context failed. User auth/account id should be of type string, and not contain commas, semi-colons, equal signs, spaces, or vertical-bars.", true);
                    return;
                }
                // Create cookie string.
                _self[0, $f9279bf813e6e5d7$export$574ff42e0e7ce0c /* @min:%2eauthenticatedId */ ] = authenticatedUserId;
                var authCookie = _self[0, $f9279bf813e6e5d7$export$574ff42e0e7ce0c /* @min:%2eauthenticatedId */ ];
                if (accountId) {
                    _self[0, $f9279bf813e6e5d7$export$f251a1587d4aac90 /* @min:%2eaccountId */ ] = accountId;
                    authCookie = [
                        _self[0, $f9279bf813e6e5d7$export$574ff42e0e7ce0c /* @min:%2eauthenticatedId */ ],
                        _self.accountId
                    ][0, $f9279bf813e6e5d7$export$9876e756459769d6 /* @min:%2ejoin */ ](User[0, $f9279bf813e6e5d7$export$57599fb6aa598bd4 /* @min:%2ecookieSeparator */ ]);
                }
                if (storeInCookie) // Set the cookie. No expiration date because this is a session cookie (expires when browser closed).
                // Encoding the cookie to handle unexpected unicode characters.
                _cookieManager.set(User[0, $f9279bf813e6e5d7$export$7bdc84f949b24ffd /* @min:%2eauthUserCookieName */ ], encodeURI(authCookie));
            };
            /**
             * Clears the authenticated user id and the account id from the user context.
             * @returns {}
             */ _self.clearAuthenticatedUserContext = function() {
                _self[0, $f9279bf813e6e5d7$export$574ff42e0e7ce0c /* @min:%2eauthenticatedId */ ] = null;
                _self[0, $f9279bf813e6e5d7$export$f251a1587d4aac90 /* @min:%2eaccountId */ ] = null;
                _cookieManager.del(User[0, $f9279bf813e6e5d7$export$7bdc84f949b24ffd /* @min:%2eauthUserCookieName */ ]);
            };
            _self[0, $f9279bf813e6e5d7$export$c9f4bebf02f459de /* @min:%2eupdate */ ] = function(userId) {
                // Optimizations to avoid setting and processing the cookie when not needed
                if (_self.id !== userId || !_self[0, $f9279bf813e6e5d7$export$52b1fe3e70f4c699 /* @min:%2eisUserCookieSet */ ]) {
                    var user_id = userId ? userId : _generateNewId();
                    var user_cookie = _generateNewCookie(user_id);
                    _setUserCookie(user_cookie[0, $f9279bf813e6e5d7$export$9876e756459769d6 /* @min:%2ejoin */ ](User[0, $f9279bf813e6e5d7$export$57599fb6aa598bd4 /* @min:%2ecookieSeparator */ ]));
                }
            };
        });
    }
    // Removed Stub for User.prototype.setAuthenticatedUserContext.
    // Removed Stub for User.prototype.clearAuthenticatedUserContext.
    // Removed Stub for User.prototype.update.
    User.cookieSeparator = "|";
    User.userCookieName = "ai_user";
    User.authUserCookieName = "ai_authUser";
    return User;
}();



var $c7c00a0692573aa9$var$strExt = "ext";
var $c7c00a0692573aa9$var$strTags = "tags";
function $c7c00a0692573aa9$var$_removeEmpty(target, name) {
    if (target && target[name] && (0, $36a077d9f4439b69$export$f7628dc18f4211e5)(target[name])[0, $f9279bf813e6e5d7$export$6eae51590aaea43 /* @min:%2elength */ ] === 0) delete target[name];
}
function $c7c00a0692573aa9$var$_nullResult() {
    return null;
}
var $c7c00a0692573aa9$export$7b6b7bc4acb29126 = /** @class */ function() {
    function TelemetryContext(core, defaultConfig, previousTraceCtx, unloadHookContainer) {
        var _this = this;
        var logger = core.logger;
        (0, $c9b63384299a3252$export$2e2bcd8739ae039)(TelemetryContext, this, function(_self) {
            _self.appId = $c7c00a0692573aa9$var$_nullResult;
            _self[0, $f9279bf813e6e5d7$export$3af04f76fec134a /* @min:%2egetSessionId */ ] = $c7c00a0692573aa9$var$_nullResult;
            _self.application = new (0, $8da6cf2fd8f2255d$export$16975c34e60e1e61)();
            _self.internal = new (0, $40e2a879f9bef5dc$export$81742925a72ee8f2)(defaultConfig, unloadHookContainer);
            if ((0, $3d5fcb60a9467a45$export$fef62134eea24008)()) {
                _self[0, $f9279bf813e6e5d7$export$1c39d669bde62767 /* @min:%2esessionManager */ ] = new (0, $b3a76197ac0f306d$export$9a3efd42578d1f11)(defaultConfig, core, unloadHookContainer);
                _self.device = new (0, $4af86dbfa3092e80$export$8215d14a63d9fb10)();
                _self.location = new (0, $767b8cd94041adba$export$18a2be9195644f38)();
                _self.user = new (0, $0ad45f65976bc29a$export$1f44aaf2ec115b54)(defaultConfig, core, unloadHookContainer);
                var traceId = void 0;
                var parentId = void 0;
                var name_1;
                if (previousTraceCtx) {
                    traceId = previousTraceCtx.getTraceId();
                    parentId = previousTraceCtx.getSpanId();
                    name_1 = previousTraceCtx.getName();
                }
                _self[0, $f9279bf813e6e5d7$export$805965d0d38cc4a5 /* @min:%2etelemetryTrace */ ] = new (0, $39a36e687e3ece23$export$d65492b1f626b9ec)(traceId, parentId, name_1, logger);
                _self.session = new (0, $b3a76197ac0f306d$export$1fb4852a55678982)();
            }
            _self[0, $f9279bf813e6e5d7$export$3af04f76fec134a /* @min:%2egetSessionId */ ] = function() {
                var session = _self.session;
                var sesId = null;
                // If customer set session info, apply their context; otherwise apply context automatically generated
                if (session && (0, $533f826bbc418791$export$844ec244b1367d54)(session.id)) sesId = session.id;
                else {
                    // Gets the automatic session if it exists or an empty object
                    var autoSession = (_self[0, $f9279bf813e6e5d7$export$1c39d669bde62767 /* @min:%2esessionManager */ ] || {})[0, $f9279bf813e6e5d7$export$4d608086992f55c7 /* @min:%2eautomaticSession */ ];
                    sesId = autoSession && (0, $533f826bbc418791$export$844ec244b1367d54)(autoSession.id) ? autoSession.id : null;
                }
                return sesId;
            };
            _self[0, $f9279bf813e6e5d7$export$585a4eb45f8043ec /* @min:%2eapplySessionContext */ ] = function(evt, itemCtx) {
                (0, $0b747974b0bb3563$export$80746c6bc6142fc8)((0, $0b747974b0bb3563$export$51417ccc212471e)(evt.ext, (0, $1185376df44832bd$export$152f4bb29f8263d0).AppExt), "sesId", _self[0, $f9279bf813e6e5d7$export$3af04f76fec134a /* @min:%2egetSessionId */ ](), (0, $533f826bbc418791$export$844ec244b1367d54));
            };
            _self[0, $f9279bf813e6e5d7$export$dddc87038d37bcef /* @min:%2eapplyOperatingSystemContxt */ ] = function(evt, itemCtx) {
                (0, $0b747974b0bb3563$export$80746c6bc6142fc8)(evt.ext, (0, $1185376df44832bd$export$152f4bb29f8263d0).OSExt, _self.os);
            };
            _self[0, $f9279bf813e6e5d7$export$5c833c29ed72a760 /* @min:%2eapplyApplicationContext */ ] = function(evt, itemCtx) {
                var application = _self.application;
                if (application) {
                    // evt.ext.app
                    var tags = (0, $0b747974b0bb3563$export$51417ccc212471e)(evt, $c7c00a0692573aa9$var$strTags);
                    (0, $0b747974b0bb3563$export$80746c6bc6142fc8)(tags, (0, $1185376df44832bd$export$ebc7727f2a4272f6).applicationVersion, application.ver, (0, $533f826bbc418791$export$844ec244b1367d54));
                    (0, $0b747974b0bb3563$export$80746c6bc6142fc8)(tags, (0, $1185376df44832bd$export$ebc7727f2a4272f6).applicationBuild, application.build, (0, $533f826bbc418791$export$844ec244b1367d54));
                }
            };
            _self[0, $f9279bf813e6e5d7$export$f3448cce94ee4935 /* @min:%2eapplyDeviceContext */ ] = function(evt, itemCtx) {
                var device = _self.device;
                if (device) {
                    // evt.ext.device
                    var extDevice = (0, $0b747974b0bb3563$export$51417ccc212471e)((0, $0b747974b0bb3563$export$51417ccc212471e)(evt, $c7c00a0692573aa9$var$strExt), (0, $1185376df44832bd$export$152f4bb29f8263d0).DeviceExt);
                    (0, $0b747974b0bb3563$export$80746c6bc6142fc8)(extDevice, "localId", device.id, (0, $533f826bbc418791$export$844ec244b1367d54));
                    (0, $0b747974b0bb3563$export$80746c6bc6142fc8)(extDevice, "ip", device.ip, (0, $533f826bbc418791$export$844ec244b1367d54));
                    (0, $0b747974b0bb3563$export$80746c6bc6142fc8)(extDevice, "model", device.model, (0, $533f826bbc418791$export$844ec244b1367d54));
                    (0, $0b747974b0bb3563$export$80746c6bc6142fc8)(extDevice, "deviceClass", device.deviceClass, (0, $533f826bbc418791$export$844ec244b1367d54));
                }
            };
            _self[0, $f9279bf813e6e5d7$export$348ac062a116e27c /* @min:%2eapplyInternalContext */ ] = function(evt, itemCtx) {
                var internal = _self.internal;
                if (internal) {
                    var tags = (0, $0b747974b0bb3563$export$51417ccc212471e)(evt, $c7c00a0692573aa9$var$strTags);
                    (0, $0b747974b0bb3563$export$80746c6bc6142fc8)(tags, (0, $1185376df44832bd$export$ebc7727f2a4272f6).internalAgentVersion, internal.agentVersion, (0, $533f826bbc418791$export$844ec244b1367d54)); // not mapped in CS 4.0
                    (0, $0b747974b0bb3563$export$80746c6bc6142fc8)(tags, (0, $1185376df44832bd$export$ebc7727f2a4272f6).internalSdkVersion, (0, $8c3059962bb1d83c$export$4e25b1d4bcd67eb8)(logger, internal.sdkVersion, 64), (0, $533f826bbc418791$export$844ec244b1367d54));
                    if (evt.baseType === (0, $cc2aaaebf96ac6a7$export$70ef838ed08aad47).dataType || evt.baseType === (0, $5c5f40703ef3d51c$export$12c0fdede1c6bc6c).dataType) {
                        (0, $0b747974b0bb3563$export$80746c6bc6142fc8)(tags, (0, $1185376df44832bd$export$ebc7727f2a4272f6).internalSnippet, internal.snippetVer, (0, $533f826bbc418791$export$844ec244b1367d54));
                        (0, $0b747974b0bb3563$export$80746c6bc6142fc8)(tags, (0, $1185376df44832bd$export$ebc7727f2a4272f6).internalSdkSrc, internal.sdkSrc, (0, $533f826bbc418791$export$844ec244b1367d54));
                    }
                }
            };
            _self[0, $f9279bf813e6e5d7$export$4768decfd4f15bcf /* @min:%2eapplyLocationContext */ ] = function(evt, itemCtx) {
                var location = _this.location;
                if (location) (0, $0b747974b0bb3563$export$80746c6bc6142fc8)((0, $0b747974b0bb3563$export$51417ccc212471e)(evt, $c7c00a0692573aa9$var$strTags, []), (0, $1185376df44832bd$export$ebc7727f2a4272f6).locationIp, location.ip, (0, $533f826bbc418791$export$844ec244b1367d54));
            };
            _self[0, $f9279bf813e6e5d7$export$a6c599a5c1ab6761 /* @min:%2eapplyOperationContext */ ] = function(evt, itemCtx) {
                var telemetryTrace = _self[0, $f9279bf813e6e5d7$export$805965d0d38cc4a5 /* @min:%2etelemetryTrace */ ];
                if (telemetryTrace) {
                    var extTrace = (0, $0b747974b0bb3563$export$51417ccc212471e)((0, $0b747974b0bb3563$export$51417ccc212471e)(evt, $c7c00a0692573aa9$var$strExt), (0, $1185376df44832bd$export$152f4bb29f8263d0).TraceExt, {
                        traceID: undefined,
                        parentID: undefined
                    });
                    (0, $0b747974b0bb3563$export$80746c6bc6142fc8)(extTrace, "traceID", telemetryTrace.traceID, (0, $533f826bbc418791$export$844ec244b1367d54), (0, $533f826bbc418791$export$bedb7023a7733221));
                    (0, $0b747974b0bb3563$export$80746c6bc6142fc8)(extTrace, "name", telemetryTrace.name, (0, $533f826bbc418791$export$844ec244b1367d54), (0, $533f826bbc418791$export$bedb7023a7733221));
                    (0, $0b747974b0bb3563$export$80746c6bc6142fc8)(extTrace, "parentID", telemetryTrace.parentID, (0, $533f826bbc418791$export$844ec244b1367d54), (0, $533f826bbc418791$export$bedb7023a7733221));
                }
            };
            _self.applyWebContext = function(evt, itemCtx) {
                var web = _this.web;
                if (web) (0, $0b747974b0bb3563$export$80746c6bc6142fc8)((0, $0b747974b0bb3563$export$51417ccc212471e)(evt, $c7c00a0692573aa9$var$strExt), (0, $1185376df44832bd$export$152f4bb29f8263d0).WebExt, web);
            };
            _self[0, $f9279bf813e6e5d7$export$5090ada1085f4557 /* @min:%2eapplyUserContext */ ] = function(evt, itemCtx) {
                var user = _self.user;
                if (user) {
                    var tags = (0, $0b747974b0bb3563$export$51417ccc212471e)(evt, $c7c00a0692573aa9$var$strTags, []);
                    // stays in tags
                    (0, $0b747974b0bb3563$export$80746c6bc6142fc8)(tags, (0, $1185376df44832bd$export$ebc7727f2a4272f6).userAccountId, user[0, $f9279bf813e6e5d7$export$f251a1587d4aac90 /* @min:%2eaccountId */ ], (0, $533f826bbc418791$export$844ec244b1367d54));
                    // CS 4.0
                    var extUser = (0, $0b747974b0bb3563$export$51417ccc212471e)((0, $0b747974b0bb3563$export$51417ccc212471e)(evt, $c7c00a0692573aa9$var$strExt), (0, $1185376df44832bd$export$152f4bb29f8263d0).UserExt);
                    (0, $0b747974b0bb3563$export$80746c6bc6142fc8)(extUser, "id", user.id, (0, $533f826bbc418791$export$844ec244b1367d54));
                    (0, $0b747974b0bb3563$export$80746c6bc6142fc8)(extUser, "authId", user[0, $f9279bf813e6e5d7$export$574ff42e0e7ce0c /* @min:%2eauthenticatedId */ ], (0, $533f826bbc418791$export$844ec244b1367d54));
                }
            };
            _self.cleanUp = function(evt, itemCtx) {
                var ext = evt.ext;
                if (ext) {
                    $c7c00a0692573aa9$var$_removeEmpty(ext, (0, $1185376df44832bd$export$152f4bb29f8263d0).DeviceExt);
                    $c7c00a0692573aa9$var$_removeEmpty(ext, (0, $1185376df44832bd$export$152f4bb29f8263d0).UserExt);
                    $c7c00a0692573aa9$var$_removeEmpty(ext, (0, $1185376df44832bd$export$152f4bb29f8263d0).WebExt);
                    $c7c00a0692573aa9$var$_removeEmpty(ext, (0, $1185376df44832bd$export$152f4bb29f8263d0).OSExt);
                    $c7c00a0692573aa9$var$_removeEmpty(ext, (0, $1185376df44832bd$export$152f4bb29f8263d0).AppExt);
                    $c7c00a0692573aa9$var$_removeEmpty(ext, (0, $1185376df44832bd$export$152f4bb29f8263d0).TraceExt);
                }
            };
        });
    }
    // Removed Stub for TelemetryContext.prototype.applySessionContext.
    // Removed Stub for TelemetryContext.prototype.applyOperatingSystemContxt.
    // Removed Stub for TelemetryContext.prototype.applyApplicationContext.
    // Removed Stub for TelemetryContext.prototype.applyDeviceContext.
    // Removed Stub for TelemetryContext.prototype.applyInternalContext.
    // Removed Stub for TelemetryContext.prototype.applyLocationContext.
    // Removed Stub for TelemetryContext.prototype.applyOperationContext.
    // Removed Stub for TelemetryContext.prototype.applyWebContext.
    // Removed Stub for TelemetryContext.prototype.applyUserContext.
    // Removed Stub for TelemetryContext.prototype.cleanUp.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    TelemetryContext.__ieDyn = 1;
    return TelemetryContext;
}();



var $374e174ea903f978$var$_a;
var $374e174ea903f978$var$undefString;
var $374e174ea903f978$var$nullValue = null;
var $374e174ea903f978$var$_defaultConfig = (0, $36a077d9f4439b69$export$a15782d21797da4c)(($374e174ea903f978$var$_a = {}, $374e174ea903f978$var$_a[0, $f9279bf813e6e5d7$export$f251a1587d4aac90 /* @min:accountId */ ] = $374e174ea903f978$var$nullValue, $374e174ea903f978$var$_a.sessionRenewalMs = 1800000, $374e174ea903f978$var$_a.samplingPercentage = 100, $374e174ea903f978$var$_a.sessionExpirationMs = 86400000, $374e174ea903f978$var$_a.cookieDomain = $374e174ea903f978$var$nullValue, $374e174ea903f978$var$_a.sdkExtension = $374e174ea903f978$var$nullValue, $374e174ea903f978$var$_a.isBrowserLinkTrackingEnabled = false, $374e174ea903f978$var$_a.appId = $374e174ea903f978$var$nullValue, $374e174ea903f978$var$_a[0, $f9279bf813e6e5d7$export$3af04f76fec134a /* @min:getSessionId */ ] = $374e174ea903f978$var$nullValue, $374e174ea903f978$var$_a[0, $f9279bf813e6e5d7$export$6d013a7bc2da53c1 /* @min:namePrefix */ ] = $374e174ea903f978$var$undefString, $374e174ea903f978$var$_a[0, $f9279bf813e6e5d7$export$d2109757a25c372a /* @min:sessionCookiePostfix */ ] = $374e174ea903f978$var$undefString, $374e174ea903f978$var$_a[0, $f9279bf813e6e5d7$export$f3af58106bbab288 /* @min:userCookiePostfix */ ] = $374e174ea903f978$var$undefString, $374e174ea903f978$var$_a[0, $f9279bf813e6e5d7$export$5c90c36f2382a0ff /* @min:idLength */ ] = 22, $374e174ea903f978$var$_a[0, $f9279bf813e6e5d7$export$d4e11a6879dac67b /* @min:getNewId */ ] = $374e174ea903f978$var$nullValue, $374e174ea903f978$var$_a));
var $374e174ea903f978$var$PropertiesPlugin = /** @class */ function(_super) {
    (0, $2a74b38b87b38cda$export$1f9c32e3fbfb8e62)(PropertiesPlugin, _super);
    function PropertiesPlugin() {
        var _this = _super.call(this) || this;
        _this.priority = 110;
        _this.identifier = (0, $ca7353bd9238d340$export$2268e69a6d93b7cc);
        var _extensionConfig;
        var _distributedTraceCtx;
        var _previousTraceCtx;
        var _context;
        (0, $c9b63384299a3252$export$2e2bcd8739ae039)(PropertiesPlugin, _this, function(_self, _base) {
            _initDefaults();
            (0, $d212d948d25f959a$export$d0d2ebf910ad6e2)(_self, "context", {
                g: function() {
                    return _context;
                }
            });
            _self.initialize = function(config, core, extensions, pluginChain) {
                _base.initialize(config, core, extensions, pluginChain);
                _populateDefaults(config);
            };
            /**
             * Add Part A fields to the event
             * @param event - The event that needs to be processed
             */ _self.processTelemetry = function(event, itemCtx) {
                if (!(0, $533f826bbc418791$export$bedb7023a7733221)(event)) {
                    itemCtx = _self._getTelCtx(itemCtx);
                    // If the envelope is PageView, reset the internal message count so that we can send internal telemetry for the new page.
                    if (event.name === (0, $5c5f40703ef3d51c$export$12c0fdede1c6bc6c).envelopeType) itemCtx.diagLog().resetInternalMessageCount();
                    var theContext = _context || {};
                    if (theContext.session) // If customer did not provide custom session id update the session manager
                    {
                        if (typeof _context.session.id !== "string" && theContext[0, $f9279bf813e6e5d7$export$1c39d669bde62767 /* @min:%2esessionManager */ ]) theContext[0, $f9279bf813e6e5d7$export$1c39d669bde62767 /* @min:%2esessionManager */ ][0, $f9279bf813e6e5d7$export$c9f4bebf02f459de /* @min:%2eupdate */ ]();
                    }
                    var userCtx = theContext.user;
                    if (userCtx && !userCtx[0, $f9279bf813e6e5d7$export$52b1fe3e70f4c699 /* @min:%2eisUserCookieSet */ ]) userCtx[0, $f9279bf813e6e5d7$export$c9f4bebf02f459de /* @min:%2eupdate */ ](theContext.user.id);
                    _processTelemetryInternal(event, itemCtx);
                    if (userCtx && userCtx[0, $f9279bf813e6e5d7$export$e8019acdc6dfe227 /* @min:%2eisNewUser */ ]) {
                        userCtx[0, $f9279bf813e6e5d7$export$e8019acdc6dfe227 /* @min:%2eisNewUser */ ] = false;
                        var message = new (0, $cc2aaaebf96ac6a7$export$70ef838ed08aad47)(72 /* _eInternalMessageId.SendBrowserInfoOnUserInit */ , ((0, $3d5fcb60a9467a45$export$a56241c767c1d89f)() || {}).userAgent || "");
                        (0, $cc2aaaebf96ac6a7$export$e15fbe42d9bc9d3d)(itemCtx.diagLog(), 1 /* eLoggingSeverity.CRITICAL */ , message);
                    }
                    _self.processNext(event, itemCtx);
                }
            };
            _self._doTeardown = function(unloadCtx, unloadState) {
                var core = (unloadCtx || {}).core();
                if (core && core[0, $f9279bf813e6e5d7$export$2d15b9b0e9d1daaa /* @min:%2egetTraceCtx */ ]) {
                    var traceCtx = core[0, $f9279bf813e6e5d7$export$2d15b9b0e9d1daaa /* @min:%2egetTraceCtx */ ](false);
                    if (traceCtx === _distributedTraceCtx) core.setTraceCtx(_previousTraceCtx);
                }
                _initDefaults();
            };
            function _initDefaults() {
                _extensionConfig = null;
                _distributedTraceCtx = null;
                _previousTraceCtx = null;
                _context = null;
            }
            function _populateDefaults(config) {
                var identifier = _self.identifier;
                var core = _self.core;
                // This function will be re-called whenever any referenced configuration is changed
                _self._addHook((0, $acb30f9e62dc5705$export$454a433e4deb244f)(config, function() {
                    var ctx = (0, $bc7124acb0f73e64$export$ca98f11e981bcfd6)(null, config, core);
                    _extensionConfig = ctx.getExtCfg(identifier, $374e174ea903f978$var$_defaultConfig);
                    // Test hook to allow accessing the internal values -- explicitly not defined as an available property on the class
                    _self["_extConfig"] = _extensionConfig;
                }));
                // This is outside of the onConfigChange as we don't want to update (replace) these values whenever a referenced config item changes
                _previousTraceCtx = core[0, $f9279bf813e6e5d7$export$2d15b9b0e9d1daaa /* @min:%2egetTraceCtx */ ](false);
                _context = new (0, $c7c00a0692573aa9$export$7b6b7bc4acb29126)(core, _extensionConfig, _previousTraceCtx, _self._unloadHooks);
                _distributedTraceCtx = (0, $d98b699aeccdabc6$export$847d5dabba5fabb9)(_self.context[0, $f9279bf813e6e5d7$export$805965d0d38cc4a5 /* @min:%2etelemetryTrace */ ], _previousTraceCtx);
                core.setTraceCtx(_distributedTraceCtx);
                _self.context.appId = function() {
                    var breezeChannel = core.getPlugin((0, $ca7353bd9238d340$export$a714a094d3058c99));
                    return breezeChannel ? breezeChannel.plugin["_appId"] : null;
                };
            }
            function _processTelemetryInternal(evt, itemCtx) {
                // Set Part A fields
                (0, $0b747974b0bb3563$export$51417ccc212471e)(evt, "tags", []);
                (0, $0b747974b0bb3563$export$51417ccc212471e)(evt, "ext", {});
                var ctx = _self.context;
                ctx[0, $f9279bf813e6e5d7$export$585a4eb45f8043ec /* @min:%2eapplySessionContext */ ](evt, itemCtx);
                ctx[0, $f9279bf813e6e5d7$export$5c833c29ed72a760 /* @min:%2eapplyApplicationContext */ ](evt, itemCtx);
                ctx[0, $f9279bf813e6e5d7$export$f3448cce94ee4935 /* @min:%2eapplyDeviceContext */ ](evt, itemCtx);
                ctx[0, $f9279bf813e6e5d7$export$a6c599a5c1ab6761 /* @min:%2eapplyOperationContext */ ](evt, itemCtx);
                ctx[0, $f9279bf813e6e5d7$export$5090ada1085f4557 /* @min:%2eapplyUserContext */ ](evt, itemCtx);
                ctx[0, $f9279bf813e6e5d7$export$dddc87038d37bcef /* @min:%2eapplyOperatingSystemContxt */ ](evt, itemCtx);
                ctx.applyWebContext(evt, itemCtx);
                ctx[0, $f9279bf813e6e5d7$export$4768decfd4f15bcf /* @min:%2eapplyLocationContext */ ](evt, itemCtx); // legacy tags
                ctx[0, $f9279bf813e6e5d7$export$348ac062a116e27c /* @min:%2eapplyInternalContext */ ](evt, itemCtx); // legacy tags
                ctx.cleanUp(evt, itemCtx);
            }
        });
        return _this;
    }
    // Removed Stub for PropertiesPlugin.prototype.initialize.
    // Removed Stub for PropertiesPlugin.prototype.processTelemetry.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    PropertiesPlugin.__ieDyn = 1;
    return PropertiesPlugin;
}((0, $b61d51369f8191a4$export$64a11c2f90e6766c));
var $374e174ea903f978$export$2e2bcd8739ae039 = $374e174ea903f978$var$PropertiesPlugin;




/*
 * Application Insights JavaScript SDK - Web, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // ###################################################################################################################################################
// Note: DON'T Export these const from the package as we are still targeting IE/ES5 this will export a mutable variables that someone could change ###
// ###################################################################################################################################################
// Generally you should only put values that are used more than 2 times and then only if not already exposed as a constant (such as SdkCoreNames)
// as when using "short" named values from here they will be will be minified smaller than the SdkCoreNames[eSdkCoreNames.xxxx] value.
var $07885e4968a136ac$var$_AUTHENTICATED_USER_CONTEXT = "AuthenticatedUserContext";
var $07885e4968a136ac$var$_TRACK = "track";
var $07885e4968a136ac$export$5e8607ab26634759 = "";
var $07885e4968a136ac$export$c40a95bd1f19a04a = "snippet";
var $07885e4968a136ac$export$da4182b670dc48ff = "getCookieMgr";
var $07885e4968a136ac$export$4dff843ac2d49cae = "startTrackPage";
var $07885e4968a136ac$export$83ac403ed0121674 = "stopTrackPage";
var $07885e4968a136ac$export$36b97ab40aae74fe = "flush";
var $07885e4968a136ac$export$5ac4d387b85102 = "startTrackEvent";
var $07885e4968a136ac$export$7895813056375cb = "stopTrackEvent";
var $07885e4968a136ac$export$40f0bd7f5212655f = "addTelemetryInitializer";
var $07885e4968a136ac$export$98706f009830c697 = $07885e4968a136ac$export$40f0bd7f5212655f + "s";
var $07885e4968a136ac$export$6030ed320bde556b = "pollInternalLogs";
var $07885e4968a136ac$export$59cf80c2878d98fc = "getPlugin";
var $07885e4968a136ac$export$657de6e6c53d3d4b = "evtNamespace";
var $07885e4968a136ac$export$2a937c908483aaba = $07885e4968a136ac$var$_TRACK + "Event";
var $07885e4968a136ac$export$6a76308d410f3214 = $07885e4968a136ac$var$_TRACK + "Trace";
var $07885e4968a136ac$export$f73efacb9b6b9a35 = $07885e4968a136ac$var$_TRACK + "Metric";
var $07885e4968a136ac$export$96dcb75b34c1a4 = $07885e4968a136ac$var$_TRACK + "PageView";
var $07885e4968a136ac$export$5a8b50b634878942 = $07885e4968a136ac$var$_TRACK + "Exception";
var $07885e4968a136ac$export$ab9c6dcf6c4e2bbc = $07885e4968a136ac$var$_TRACK + "DependencyData";
var $07885e4968a136ac$export$94666ce386bd4f64 = "set" + $07885e4968a136ac$var$_AUTHENTICATED_USER_CONTEXT;
var $07885e4968a136ac$export$f920535c288b298f = "clear" + $07885e4968a136ac$var$_AUTHENTICATED_USER_CONTEXT;


/*
 * Application Insights JavaScript SDK - Web, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var $5f4895b2bf2489f4$export$568c4302d11f2b22 = "version"; // Count: 6
var $5f4895b2bf2489f4$export$a1c208448cc1b3be = "queue"; // Count: 6
var $5f4895b2bf2489f4$export$1160203e21ea532 = "connectionString"; // Count: 4
var $5f4895b2bf2489f4$export$bfa1c9e5dcf1e78 = "endpointUrl"; // Count: 3
var $5f4895b2bf2489f4$export$81cfd43387c8dbcc = "instrumentationKey"; // Count: 3
var $5f4895b2bf2489f4$export$c0d9014f1d64bf51 = "disableIkeyDeprecationMessage"; // Count: 2
var $5f4895b2bf2489f4$export$f30bfb116278d530 = "onunloadFlush"; // Count: 6
var $5f4895b2bf2489f4$export$fdcd48959e13aba7 = "context"; // Count: 5
var $5f4895b2bf2489f4$export$1005ab001db54adc = "addHousekeepingBeforeUnload"; // Count: 2
var $5f4895b2bf2489f4$export$e8d1780b2404d6a2 = "updateSnippetDefinitions"; // Count: 2


"use strict";
var $a7828c8fd42bf560$var$_a;
var $a7828c8fd42bf560$var$_internalSdkSrc;
// This is an exclude list of properties that should not be updated during initialization
// They include a combination of private and internal property names
var $a7828c8fd42bf560$var$_ignoreUpdateSnippetProperties = [
    (0, $07885e4968a136ac$export$c40a95bd1f19a04a),
    "dependencies",
    "properties",
    "_snippetVersion",
    "appInsightsNew",
    "getSKUDefaults"
];
var $a7828c8fd42bf560$var$UNDEFINED_VALUE = undefined;
// We need to include all properties that we only reference that we want to be dynamically updatable here
// So they are converted even when not specified in the passed configuration
var $a7828c8fd42bf560$var$defaultConfigValues = ($a7828c8fd42bf560$var$_a = {}, $a7828c8fd42bf560$var$_a[0, $5f4895b2bf2489f4$export$1160203e21ea532 /* @min:connectionString */ ] = $a7828c8fd42bf560$var$UNDEFINED_VALUE, $a7828c8fd42bf560$var$_a[0, $5f4895b2bf2489f4$export$bfa1c9e5dcf1e78 /* @min:endpointUrl */ ] = $a7828c8fd42bf560$var$UNDEFINED_VALUE, $a7828c8fd42bf560$var$_a[0, $5f4895b2bf2489f4$export$81cfd43387c8dbcc /* @min:instrumentationKey */ ] = $a7828c8fd42bf560$var$UNDEFINED_VALUE, $a7828c8fd42bf560$var$_a.diagnosticLogInterval = (0, $61c4d9dd4226f64e$export$d0884590a6a82e6c)($a7828c8fd42bf560$var$_chkDiagLevel, 10000), $a7828c8fd42bf560$var$_a);
function $a7828c8fd42bf560$var$_chkDiagLevel(value) {
    // Make sure we have a value > 0
    return value && value > 0;
}
/**
 * Application Insights API
 * @class Initialization
 * @implements {IApplicationInsights}
 */ var $a7828c8fd42bf560$export$e8021799dbedb971 = /** @class */ function() {
    function AppInsightsSku(snippet) {
        var _this = this;
        // NOTE!: DON'T set default values here, instead set them in the _initDefaults() function as it is also called during teardown()
        var dependencies;
        var properties;
        var _sender;
        var _snippetVersion;
        var _evtNamespace;
        var _houseKeepingNamespace;
        var _core;
        var _config;
        var _analyticsPlugin;
        (0, $c9b63384299a3252$export$2e2bcd8739ae039)(AppInsightsSku, this, function(_self) {
            _initDefaults();
            (0, $d212d948d25f959a$export$d0d2ebf910ad6e2)(_self, "config", {
                g: function() {
                    return _config;
                }
            });
            (0, $f6bb085f8cf12216$export$e2e5bcdbdc49c586)([
                "pluginVersionStringArr",
                "pluginVersionString"
            ], function(key) {
                (0, $d212d948d25f959a$export$d0d2ebf910ad6e2)(_self, key, {
                    g: function() {
                        if (_core) return _core[key];
                        return null;
                    }
                });
            });
            // initialize the queue and config in case they are undefined
            _snippetVersion = "" + (snippet.sv || snippet[0, $5f4895b2bf2489f4$export$568c4302d11f2b22 /* @min:%2eversion */ ] || "");
            snippet[0, $5f4895b2bf2489f4$export$a1c208448cc1b3be /* @min:%2equeue */ ] = snippet[0, $5f4895b2bf2489f4$export$a1c208448cc1b3be /* @min:%2equeue */ ] || [];
            snippet[0, $5f4895b2bf2489f4$export$568c4302d11f2b22 /* @min:%2eversion */ ] = snippet[0, $5f4895b2bf2489f4$export$568c4302d11f2b22 /* @min:%2eversion */ ] || 2.0; // Default to new version
            var cfgHandler = (0, $acb30f9e62dc5705$export$3a9e9180c14487fd)(snippet.config || {}, $a7828c8fd42bf560$var$defaultConfigValues);
            _config = cfgHandler.cfg;
            _analyticsPlugin = new (0, $826a9f6c1286ca27$export$ca681bfeb2cf0fca)();
            (0, $d212d948d25f959a$export$d0d2ebf910ad6e2)(_self, "appInsights", {
                g: function() {
                    return _analyticsPlugin;
                }
            });
            properties = new (0, $374e174ea903f978$export$2e2bcd8739ae039)();
            dependencies = new (0, $2569abef053897bd$export$d9a50c4d1eb2475f)();
            _sender = new (0, $de50c0f740c66740$export$c5a96f3e01fb6582)();
            _core = new (0, $e5177bba49076348$export$e7ac25a6828d23bf)();
            (0, $d212d948d25f959a$export$d0d2ebf910ad6e2)(_self, "core", {
                g: function() {
                    return _core;
                }
            });
            // Will get recalled if any referenced values are changed
            _addUnloadHook((0, $acb30f9e62dc5705$export$454a433e4deb244f)(cfgHandler, function() {
                if (_config[0, $5f4895b2bf2489f4$export$1160203e21ea532 /* @min:%2econnectionString */ ]) {
                    var cs = (0, $41f84b9a47a38dfe$export$6369f286b474466d)(_config[0, $5f4895b2bf2489f4$export$1160203e21ea532 /* @min:%2econnectionString */ ]);
                    var ingest = cs.ingestionendpoint;
                    _config[0, $5f4895b2bf2489f4$export$bfa1c9e5dcf1e78 /* @min:%2eendpointUrl */ ] = ingest ? ingest + (0, $71dfba5ea0640485$export$e6c0f3431c6cd728) : _config[0, $5f4895b2bf2489f4$export$bfa1c9e5dcf1e78 /* @min:%2eendpointUrl */ ]; // only add /v2/track when from connectionstring
                    _config[0, $5f4895b2bf2489f4$export$81cfd43387c8dbcc /* @min:%2einstrumentationKey */ ] = cs.instrumentationkey || _config[0, $5f4895b2bf2489f4$export$81cfd43387c8dbcc /* @min:%2einstrumentationKey */ ];
                }
            }));
            // Outside of the onConfigChange as we only want to do this once
            var isErrMessageDisabled = (0, $533f826bbc418791$export$bedb7023a7733221)(_config[0, $5f4895b2bf2489f4$export$c0d9014f1d64bf51 /* @min:%2edisableIkeyDeprecationMessage */ ]) ? true : _config[0, $5f4895b2bf2489f4$export$c0d9014f1d64bf51 /* @min:%2edisableIkeyDeprecationMessage */ ];
            if (!_config[0, $5f4895b2bf2489f4$export$1160203e21ea532 /* @min:%2econnectionString */ ] && !isErrMessageDisabled) (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(_core.logger, 1 /* eLoggingSeverity.CRITICAL */ , 106 /* _eInternalMessageId.InstrumentationKeyDeprecation */ , "Instrumentation key support will end soon, see aka.ms/IkeyMigrate");
            _self[0, $07885e4968a136ac$export$c40a95bd1f19a04a /* @min:%2esnippet */ ] = snippet;
            _self[0, $07885e4968a136ac$export$36b97ab40aae74fe /* @min:%2eflush */ ] = function(async, callBack) {
                if (async === void 0) async = true;
                var result;
                (0, $28deccfc004f252b$export$c6fbeb260600c482)(_core, function() {
                    return "AISKU.flush";
                }, function() {
                    if (async && !callBack) result = (0, $911d39c591a62618$export$5a1eb20c68656e88)(function(resolve) {
                        callBack = resolve;
                    });
                    var waiting = 1;
                    var flushDone = function() {
                        waiting--;
                        if (waiting === 0) callBack();
                    };
                    (0, $f6bb085f8cf12216$export$e2e5bcdbdc49c586)(_core.getChannels(), function(channel) {
                        if (channel) {
                            waiting++;
                            channel[0, $07885e4968a136ac$export$36b97ab40aae74fe /* @min:%2eflush */ ](async, flushDone);
                        }
                    });
                    // decrement the initial "waiting"
                    flushDone();
                }, null, async);
                return result;
            };
            _self[0, $5f4895b2bf2489f4$export$f30bfb116278d530 /* @min:%2eonunloadFlush */ ] = function(async) {
                if (async === void 0) async = true;
                (0, $f6bb085f8cf12216$export$e2e5bcdbdc49c586)(_core.getChannels(), function(channel) {
                    if (channel[0, $5f4895b2bf2489f4$export$f30bfb116278d530 /* @min:%2eonunloadFlush */ ]) channel[0, $5f4895b2bf2489f4$export$f30bfb116278d530 /* @min:%2eonunloadFlush */ ]();
                    else channel[0, $07885e4968a136ac$export$36b97ab40aae74fe /* @min:%2eflush */ ](async);
                });
            };
            _self.loadAppInsights = function(legacyMode, logger, notificationManager) {
                if (legacyMode === void 0) legacyMode = false;
                if (legacyMode) (0, $0cd2c3ce211547d0$export$6523a1bd3b6e3128)("Legacy Mode is no longer supported");
                function _updateSnippetProperties(snippet) {
                    if (snippet) {
                        var snippetVer = "";
                        if (!(0, $533f826bbc418791$export$bedb7023a7733221)(_snippetVersion)) snippetVer += _snippetVersion;
                        if (_self[0, $5f4895b2bf2489f4$export$fdcd48959e13aba7 /* @min:%2econtext */ ] && _self[0, $5f4895b2bf2489f4$export$fdcd48959e13aba7 /* @min:%2econtext */ ].internal) _self[0, $5f4895b2bf2489f4$export$fdcd48959e13aba7 /* @min:%2econtext */ ].internal.snippetVer = snippetVer || "-";
                        // apply updated properties to the global instance (snippet)
                        (0, $45e528077703ac0c$export$aa0705d5774c95d1)(_self, function(field, value) {
                            if ((0, $533f826bbc418791$export$844ec244b1367d54)(field) && !(0, $533f826bbc418791$export$f6e2535fb5126e54)(value) && field && field[0] !== "_" && // Don't copy "internal" values
                            (0, $a96d4958027d6f85$export$9f3b3ffa84393d30)($a7828c8fd42bf560$var$_ignoreUpdateSnippetProperties, field) === -1) {
                                if (snippet[field] !== value) snippet[field] = value;
                            }
                        });
                    }
                }
                (0, $28deccfc004f252b$export$c6fbeb260600c482)(_self.core, function() {
                    return "AISKU.loadAppInsights";
                }, function() {
                    // initialize core
                    _core.initialize(_config, [
                        _sender,
                        properties,
                        dependencies,
                        _analyticsPlugin
                    ], logger, notificationManager);
                    (0, $d212d948d25f959a$export$d0d2ebf910ad6e2)(_self, "context", {
                        g: function() {
                            return properties[0, $5f4895b2bf2489f4$export$fdcd48959e13aba7 /* @min:%2econtext */ ];
                        }
                    });
                    var sdkSrc = $a7828c8fd42bf560$export$62f75e89e888afb6();
                    if (sdkSrc && _self[0, $5f4895b2bf2489f4$export$fdcd48959e13aba7 /* @min:%2econtext */ ]) _self[0, $5f4895b2bf2489f4$export$fdcd48959e13aba7 /* @min:%2econtext */ ].internal.sdkSrc = sdkSrc;
                    _updateSnippetProperties(_self[0, $07885e4968a136ac$export$c40a95bd1f19a04a /* @min:%2esnippet */ ]);
                    // Empty queue of all api calls logged prior to sdk download
                    _self.emptyQueue();
                    _self[0, $07885e4968a136ac$export$6030ed320bde556b /* @min:%2epollInternalLogs */ ]();
                    _self[0, $5f4895b2bf2489f4$export$1005ab001db54adc /* @min:%2eaddHousekeepingBeforeUnload */ ](_self);
                });
                return _self;
            };
            _self[0, $5f4895b2bf2489f4$export$e8d1780b2404d6a2 /* @min:%2eupdateSnippetDefinitions */ ] = function(snippet) {
                // apply full appInsights to the global instance
                // Note: This must be called before loadAppInsights is called
                (0, $0b747974b0bb3563$export$21c1f632458708da)(snippet, _self, function(name) {
                    // Not excluding names prefixed with "_" as we need to proxy some functions like _onError
                    return name && (0, $a96d4958027d6f85$export$9f3b3ffa84393d30)($a7828c8fd42bf560$var$_ignoreUpdateSnippetProperties, name) === -1;
                });
            };
            _self.emptyQueue = function() {
                // call functions that were queued before the main script was loaded
                try {
                    if ((0, $533f826bbc418791$export$43bee75e5e14138e)(_self.snippet[0, $5f4895b2bf2489f4$export$a1c208448cc1b3be /* @min:%2equeue */ ])) {
                        // note: do not check length in the for-loop conditional in case something goes wrong and the stub methods are not overridden.
                        var length_1 = _self.snippet[0, $5f4895b2bf2489f4$export$a1c208448cc1b3be /* @min:%2equeue */ ].length;
                        for(var i = 0; i < length_1; i++){
                            var call = _self.snippet[0, $5f4895b2bf2489f4$export$a1c208448cc1b3be /* @min:%2equeue */ ][i];
                            call();
                        }
                        _self.snippet[0, $5f4895b2bf2489f4$export$a1c208448cc1b3be /* @min:%2equeue */ ] = undefined;
                        delete _self.snippet[0, $5f4895b2bf2489f4$export$a1c208448cc1b3be /* @min:%2equeue */ ];
                    }
                } catch (exception) {
                    var properties_1 = {};
                    if (exception && (0, $533f826bbc418791$export$f6e2535fb5126e54)(exception.toString)) properties_1.exception = exception.toString();
                // need from core
                // Microsoft.ApplicationInsights._InternalLogging.throwInternal(
                //     eLoggingSeverity.WARNING,
                //     _eInternalMessageId.FailedToSendQueuedTelemetry,
                //     "Failed to send queued telemetry",
                //     properties);
                }
            };
            _self[0, $5f4895b2bf2489f4$export$1005ab001db54adc /* @min:%2eaddHousekeepingBeforeUnload */ ] = function(appInsightsInstance) {
                // Add callback to push events when the user navigates away
                if ((0, $3d5fcb60a9467a45$export$fef62134eea24008)() || (0, $3d5fcb60a9467a45$export$c4372eca9c56fe99)()) {
                    var performHousekeeping_1 = function() {
                        // Adds the ability to flush all data before the page unloads.
                        // Note: This approach tries to push a sync request with all the pending events onbeforeunload.
                        // Firefox does not respect this.Other browsers DO push out the call with < 100% hit rate.
                        // Telemetry here will help us analyze how effective this approach is.
                        // Another approach would be to make this call sync with a acceptable timeout to reduce the
                        // impact on user experience.
                        // appInsightsInstance.context._sender.triggerSend();
                        appInsightsInstance[0, $5f4895b2bf2489f4$export$f30bfb116278d530 /* @min:%2eonunloadFlush */ ](false);
                        // Back up the current session to local storage
                        // This lets us close expired sessions after the cookies themselves expire
                        if ((0, $533f826bbc418791$export$f6e2535fb5126e54)(_self.core[0, $07885e4968a136ac$export$59cf80c2878d98fc /* @min:%2egetPlugin */ ])) {
                            var loadedPlugin = _this.core[0, $07885e4968a136ac$export$59cf80c2878d98fc /* @min:%2egetPlugin */ ]((0, $ca7353bd9238d340$export$2268e69a6d93b7cc));
                            if (loadedPlugin) {
                                var propertiesPlugin = loadedPlugin.plugin;
                                if (propertiesPlugin && propertiesPlugin[0, $5f4895b2bf2489f4$export$fdcd48959e13aba7 /* @min:%2econtext */ ] && propertiesPlugin[0, $5f4895b2bf2489f4$export$fdcd48959e13aba7 /* @min:%2econtext */ ]._sessionManager) propertiesPlugin[0, $5f4895b2bf2489f4$export$fdcd48959e13aba7 /* @min:%2econtext */ ]._sessionManager.backup();
                            }
                        }
                    };
                    var added_1 = false;
                    var analyticsPlugin_1 = appInsightsInstance.appInsights;
                    var theConfig_1 = analyticsPlugin_1.config;
                    if (!_houseKeepingNamespace) _houseKeepingNamespace = (0, $12cc003c7fb5ccde$export$3f37a50e0edde3be)(_evtNamespace, _core[0, $07885e4968a136ac$export$657de6e6c53d3d4b /* @min:%2eevtNamespace */ ] && _core[0, $07885e4968a136ac$export$657de6e6c53d3d4b /* @min:%2eevtNamespace */ ]());
                    // Will be recalled if any referenced config properties change
                    _addUnloadHook((0, $acb30f9e62dc5705$export$454a433e4deb244f)(_config, function() {
                        // As we could get recalled, remove any previously registered event handlers first
                        _removePageEventHandlers();
                        var excludePageUnloadEvents = theConfig_1.disablePageUnloadEvents;
                        if (!theConfig_1.disableFlushOnBeforeUnload) {
                            // Hook the unload event for the document, window and body to ensure that the client events are flushed to the server
                            // As just hooking the window does not always fire (on chrome) for page navigation's.
                            if ((0, $12cc003c7fb5ccde$export$f16ce149aca77fdd)(performHousekeeping_1, excludePageUnloadEvents, _houseKeepingNamespace)) added_1 = true;
                            // We also need to hook the pagehide and visibilitychange events as not all versions of Safari support load/unload events.
                            if ((0, $12cc003c7fb5ccde$export$46744aee53e5e558)(performHousekeeping_1, excludePageUnloadEvents, _houseKeepingNamespace)) added_1 = true;
                            // A reactNative app may not have a window and therefore the beforeunload/pagehide events -- so don't
                            // log the failure in this case
                            if (!added_1 && !(0, $0c599844349363c4$export$f7a1e23e542d38e3)()) (0, $cc2aaaebf96ac6a7$export$c7ca1fcbf1d310c4)(analyticsPlugin_1.core.logger, 1 /* eLoggingSeverity.CRITICAL */ , 19 /* _eInternalMessageId.FailedToAddHandlerForOnBeforeUnload */ , "Could not add handler for beforeunload and pagehide");
                        }
                        if (!added_1 && !theConfig_1.disableFlushOnUnload) // If we didn't add the normal set then attempt to add the pagehide and visibilitychange only
                        (0, $12cc003c7fb5ccde$export$46744aee53e5e558)(performHousekeeping_1, excludePageUnloadEvents, _houseKeepingNamespace);
                    }));
                }
            };
            _self.getSender = function() {
                return _sender;
            };
            _self.unload = function(isAsync, unloadComplete, cbTimeout) {
                var unloadDone = false;
                var result;
                if (isAsync && !unloadComplete) result = (0, $911d39c591a62618$export$5a1eb20c68656e88)(function(resolve) {
                    // Set the callback to the promise resolve callback
                    unloadComplete = resolve;
                });
                function _unloadCallback(unloadState) {
                    if (!unloadDone) {
                        unloadDone = true;
                        _initDefaults();
                        unloadComplete && unloadComplete(unloadState);
                    }
                }
                _self[0, $5f4895b2bf2489f4$export$f30bfb116278d530 /* @min:%2eonunloadFlush */ ](isAsync);
                _removePageEventHandlers();
                _core.unload && _core.unload(isAsync, _unloadCallback, cbTimeout);
                return result;
            };
            (0, $0b747974b0bb3563$export$94f4c7fb7e7d8dc7)(_self, _analyticsPlugin, [
                (0, $07885e4968a136ac$export$da4182b670dc48ff),
                (0, $07885e4968a136ac$export$2a937c908483aaba),
                (0, $07885e4968a136ac$export$96dcb75b34c1a4),
                "trackPageViewPerformance",
                (0, $07885e4968a136ac$export$5a8b50b634878942),
                "_onerror",
                (0, $07885e4968a136ac$export$6a76308d410f3214),
                (0, $07885e4968a136ac$export$f73efacb9b6b9a35),
                (0, $07885e4968a136ac$export$4dff843ac2d49cae),
                (0, $07885e4968a136ac$export$83ac403ed0121674),
                (0, $07885e4968a136ac$export$5ac4d387b85102),
                (0, $07885e4968a136ac$export$7895813056375cb)
            ]);
            (0, $0b747974b0bb3563$export$94f4c7fb7e7d8dc7)(_self, _getCurrentDependencies, [
                (0, $07885e4968a136ac$export$ab9c6dcf6c4e2bbc),
                "addDependencyListener",
                "addDependencyInitializer"
            ]);
            (0, $0b747974b0bb3563$export$94f4c7fb7e7d8dc7)(_self, _core, [
                (0, $07885e4968a136ac$export$40f0bd7f5212655f),
                (0, $07885e4968a136ac$export$6030ed320bde556b),
                "stopPollingInternalLogs",
                (0, $07885e4968a136ac$export$59cf80c2878d98fc),
                "addPlugin",
                (0, $07885e4968a136ac$export$657de6e6c53d3d4b),
                "addUnloadCb",
                "getTraceCtx",
                "updateCfg",
                "onCfgChange"
            ]);
            (0, $0b747974b0bb3563$export$94f4c7fb7e7d8dc7)(_self, function() {
                var context = properties[0, $5f4895b2bf2489f4$export$fdcd48959e13aba7 /* @min:%2econtext */ ];
                return context ? context.user : null;
            }, [
                (0, $07885e4968a136ac$export$94666ce386bd4f64),
                (0, $07885e4968a136ac$export$f920535c288b298f)
            ]);
            // Using a function to support the dynamic adding / removal of plugins, so this will always return the current value
            function _getCurrentDependencies() {
                return dependencies;
            }
            function _initDefaults() {
                _evtNamespace = (0, $8a2d104e2647a310$export$eb4a6badb18ead04)("AISKU");
                _houseKeepingNamespace = null;
                dependencies = null;
                properties = null;
                _sender = null;
                _snippetVersion = null;
            }
            function _removePageEventHandlers() {
                // Remove any registered event handlers
                if (_houseKeepingNamespace) {
                    (0, $12cc003c7fb5ccde$export$272dc813b0b2654c)(null, _houseKeepingNamespace);
                    (0, $12cc003c7fb5ccde$export$6aca6ee3a147169f)(null, _houseKeepingNamespace);
                }
            }
            function _addUnloadHook(hooks) {
                _core.addUnloadHook(hooks);
            }
        });
    }
    // Analytics Plugin
    // Removed Stub for AppInsightsSku.prototype.getCookieMgr.
    // Removed Stub for AppInsightsSku.prototype.trackEvent.
    // Removed Stub for AppInsightsSku.prototype.trackPageView.
    // Removed Stub for AppInsightsSku.prototype.trackPageViewPerformance.
    // Removed Stub for AppInsightsSku.prototype.trackException.
    // Removed Stub for AppInsightsSku.prototype._onerror.
    // Removed Stub for AppInsightsSku.prototype.trackTrace.
    // Removed Stub for AppInsightsSku.prototype.trackMetric.
    // Removed Stub for AppInsightsSku.prototype.startTrackPage.
    // Removed Stub for AppInsightsSku.prototype.stopTrackPage.
    // Removed Stub for AppInsightsSku.prototype.startTrackEvent.
    // Removed Stub for AppInsightsSku.prototype.stopTrackEvent.
    // Removed Stub for AppInsightsSku.prototype.addTelemetryInitializer.
    // Properties Plugin
    // Removed Stub for AppInsightsSku.prototype.setAuthenticatedUserContext.
    // Removed Stub for AppInsightsSku.prototype.clearAuthenticatedUserContext.
    // Dependencies Plugin
    // Removed Stub for AppInsightsSku.prototype.trackDependencyData.
    // Misc
    // Removed Stub for AppInsightsSku.prototype.flush.
    // Removed Stub for AppInsightsSku.prototype.onunloadFlush.
    // Removed Stub for AppInsightsSku.prototype.loadAppInsights.
    // Removed Stub for AppInsightsSku.prototype.updateSnippetDefinitions.
    // Removed Stub for AppInsightsSku.prototype.emptyQueue.
    // Removed Stub for AppInsightsSku.prototype.pollInternalLogs.
    // Removed Stub for AppInsightsSku.prototype.stopPollingInternalLogs.
    // Removed Stub for AppInsightsSku.prototype.addHousekeepingBeforeUnload.
    // Removed Stub for AppInsightsSku.prototype.getSender.
    // Removed Stub for AppInsightsSku.prototype.unload.
    // Removed Stub for AppInsightsSku.prototype.getPlugin.
    // Removed Stub for AppInsightsSku.prototype.addPlugin.
    // Removed Stub for AppInsightsSku.prototype.updateCfg.
    // Removed Stub for AppInsightsSku.prototype.evtNamespace.
    // Removed Stub for AppInsightsSku.prototype.addUnloadCb.
    // Removed Stub for AppInsightsSku.prototype.addDependencyListener.
    /**
     * Add an dependency telemetry initializer callback function to allow populating additional properties or drop the request.
     * It is called after the dependency call has completed and any available performance details are available. A dependency
     * initializer is similar to the TelemetryInitializer function but it allows you to block the reporting of the dependency
     * request so that it doesn't count against the `maxAjaxCallsPerView`.
     * @param dependencyInitializer - The Dependency Telemetry Initializer function
     * @returns - A IDependencyInitializerHandler to enable the initializer to be removed
     */ AppInsightsSku.prototype.addDependencyInitializer = function(dependencyInitializer) {
        return null;
    };
    // Removed Stub for AppInsightsSku.prototype.getTraceCtx.
    // Removed Stub for AppInsightsSku.prototype.onCfgChange.
    return AppInsightsSku;
}();
function $a7828c8fd42bf560$export$62f75e89e888afb6() {
    if ($a7828c8fd42bf560$var$_internalSdkSrc) // Use the cached value
    return $a7828c8fd42bf560$var$_internalSdkSrc;
    var sdkSrc = null;
    var isModule = false;
    var cdns = [
        "://js.monitor.azure.com/",
        "://az416426.vo.msecnd.net/"
    ];
    try {
        // Try and determine whether the sdk is being loaded from the CDN
        // currentScript is only valid during initial processing
        var scrpt = (document || {}).currentScript;
        if (scrpt) sdkSrc = scrpt.src;
    } catch (e) {
    // eslint-disable-next-line no-empty
    }
    if (sdkSrc) {
        try {
            var url_1 = sdkSrc.toLowerCase();
            if (url_1) {
                var src_1 = "";
                (0, $f6bb085f8cf12216$export$e2e5bcdbdc49c586)(cdns, function(value, idx) {
                    if ((0, $0194d45a55d79548$export$7c0888b0c4641088)(url_1, value) !== -1) {
                        src_1 = "cdn" + (idx + 1);
                        if ((0, $0194d45a55d79548$export$7c0888b0c4641088)(url_1, "/scripts/") === -1) {
                            if ((0, $0194d45a55d79548$export$7c0888b0c4641088)(url_1, "/next/") !== -1) src_1 += "-next";
                            else if ((0, $0194d45a55d79548$export$7c0888b0c4641088)(url_1, "/beta/") !== -1) src_1 += "-beta";
                        }
                        $a7828c8fd42bf560$var$_internalSdkSrc = src_1 + (isModule ? ".mod" : "");
                        return -1;
                    }
                });
            }
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        // Cache the found value so we don't have to look it up again
        $a7828c8fd42bf560$var$_internalSdkSrc = sdkSrc;
    }
    return $a7828c8fd42bf560$var$_internalSdkSrc;
}


const $a1e7c06e675ca002$var$getCookieValue = (name)=>document.cookie.match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)")?.pop() || "";
const $a1e7c06e675ca002$var$aiConnectionString = decodeURIComponent($a1e7c06e675ca002$var$getCookieValue("ai_connectionString"));
if ($a1e7c06e675ca002$var$aiConnectionString) {
    window.appInsights = new (0, $a7828c8fd42bf560$export$e8021799dbedb971)({
        config: {
            connectionString: $a1e7c06e675ca002$var$aiConnectionString,
            disableInstrumentationKeyValidation: true
        }
    });
    window.appInsights.loadAppInsights();
    window.appInsights.trackPageView(); // Manually call trackPageView to establish the current user/session/pageview 
}

})();
//# sourceMappingURL=ai.js.map
